(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.MappingDemoApplication = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
	"name": "mapping-demo",
	"version": "1.0.0",
	"description": "Meadow-Integration pipeline demo: parse → map → visual map → comprehension → load",
	"main": "server.js",
	"scripts": {
		"start": "node server.js",
		"brand": "node ../../node_modules/pict-section-theme/bin/pict-section-theme-brand.js --palette forest --display-name \"Mapping Demo\" --tagline \"Meadow-Integration mapping editor showcase\" --favicons web/favicons",
		"prebuild": "npm run brand",
		"build": "node generate-build-config.js && ../../node_modules/.bin/quack build",
		"demo": "npm run build && node server.js"
	},
	"author": "steven velozo <steven@velozo.com>",
	"license": "MIT",
	"retold": {
		"brand": {
			"Hash": "mapping-demo",
			"Name": "Mapping Demo",
			"Tagline": "Meadow-Integration mapping editor showcase",
			"Palette": "forest",
			"Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"frame-mapping-demo-filled-light\">\n\t\t\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\" fill=\"#55af3b\"/>\n\t\t<g clip-path=\"url(#frame-mapping-demo-filled-light)\"><circle cx=\"37.5\" cy=\"48\" r=\"30\" fill=\"#ddc536\" opacity=\"0.85\"/>\n\t\t\t\t\t<circle cx=\"58.5\" cy=\"48\" r=\"30\" fill=\"rgba(255,255,255,0.32)\" opacity=\"0.95\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"38\" font-weight=\"600\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">MD</text>\n\t</svg>",
			"IconType": "svg",
			"Favicon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-mapping-demo-light\">\n\t\t\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\" fill=\"#55af3b\"/>\n\t\t<g clip-path=\"url(#fav-mapping-demo-light)\"><circle cx=\"37.5\" cy=\"48\" r=\"34\" fill=\"#ddc536\"/>\n\t\t\t\t\t<circle cx=\"58.5\" cy=\"48\" r=\"34\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">M</text>\n\t</svg>",
			"FaviconDark": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-mapping-demo-dark\">\n\t\t\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 24 2\n\t\tH 72\n\t\tQ 94 2 94 24\n\t\tV 72\n\t\tQ 94 94 72 94\n\t\tH 24\n\t\tQ 2 94 2 72\n\t\tV 24\n\t\tQ 2 2 24 2 Z\" fill=\"#8dcb7b\"/>\n\t\t<g clip-path=\"url(#fav-mapping-demo-dark)\"><circle cx=\"37.5\" cy=\"48\" r=\"34\" fill=\"#e6d989\"/>\n\t\t\t\t\t<circle cx=\"58.5\" cy=\"48\" r=\"34\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#101418\" letter-spacing=\"-1\">M</text>\n\t</svg>",
			"Colors": {
				"Primary": "#55af3b",
				"Secondary": "#ddc536",
				"PrimaryLight": "#55af3b",
				"PrimaryDark": "#8dcb7b",
				"SecondaryLight": "#ddc536",
				"SecondaryDark": "#e6d989"
			}
		}
	},
	"devDependencies": {
		"retold-sharp": "^1.0.0"
	}
}

},{}],2:[function(require,module,exports){
'use strict';

const libPictApplication = require('pict-application');

const libPictSectionModal = require('pict-section-modal');
const libPictSectionTheme = require('pict-section-theme');

const libMappingDemoBrand = require('./MappingDemoBrand.js');
const libMappingDemoEditorView = require('./views/MappingDemoEditorView.js');

/**
 * MappingDemoApplication
 *
 * Pict application that hosts the MappingDemoEditorView and brings up
 * the unified pict-section-theme stack so visitors can flip themes and
 * watch the embedded MeadowMappingEditor library view reskin live.
 *
 * Loaded client-side by Pict.safeLoadPictApplication(MappingDemoApplication, 2).
 *
 * After initialization it exposes window.openMappingEditor() so the
 * static HTML pipeline UI can activate the visual editor from a plain
 * onclick handler.
 */
class MappingDemoApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Modal system (confirm dialogs the editor may pop)
		this.pict.addView('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);

		this.pict.addView(
			'MappingDemoEditor',
			libMappingDemoEditorView.default_configuration,
			libMappingDemoEditorView);

		// Unified theme stack — the demo's whole point is to prove the
		// library view picks up theme tokens, so the picker is exposed
		// inline in the page header (not behind a gear toggle). Just
		// register the runtime here; mount the controls in onAfterInitializeAsync
		// once the destination div exists in the DOM.
		this.pict.addProvider('Theme-Section',
			{
				ApplyDefault: 'pict-default',
				DefaultMode:  'system',
				DefaultScale: 1.0,
				Brand:        libMappingDemoBrand,
				Views: ['Picker', 'ModeToggle', 'ScaleSelect', 'BrandMark']
			}, libPictSectionTheme);
	}

	onAfterInitializeAsync(fCallback)
	{
		// Mount the theme controls directly into the header strip so users
		// can switch themes and watch every surface (the static HTML
		// pipeline UI + the embedded library editor) reskin in lockstep.
		let tmpThemeProvider = this.pict.providers['Theme-Section'];
		if (tmpThemeProvider && typeof tmpThemeProvider.mount === 'function')
		{
			tmpThemeProvider.mount(
			{
				Container: '#MappingDemo-Theme-Controls',
				Views: ['Picker', 'ModeToggle', 'ScaleSelect']
			});
		}

		// Expose a global hook so the outer HTML can open the editor
		window.openMappingEditor = () =>
		{
			let tmpPlaceholder = document.getElementById('mapping-editor-placeholder');
			if (tmpPlaceholder)
			{
				tmpPlaceholder.style.display = 'none';
			}

			window._Pict.views['MappingDemoEditor'].editMappings(1, 'Book');
		};

		return super.onAfterInitializeAsync(fCallback);
	}
}

module.exports = MappingDemoApplication;

module.exports.default_configuration =
{
	Name: 'MappingDemoApp',
	Hash: 'MappingDemo',
	AutoSolveAfterInitialize: true
};

},{"./MappingDemoBrand.js":3,"./views/MappingDemoEditorView.js":4,"pict-application":8,"pict-section-modal":76,"pict-section-theme":77}],3:[function(require,module,exports){
'use strict';

/**
 * Brand wrapper for the mapping-demo Pict app. Reads the retold.brand
 * block populated by `npm run brand` (which invokes
 * pict-section-theme/bin/pict-section-theme-brand.js with the forest
 * palette) and exposes it for the Theme-Section provider's BrandMark.
 */
const tmpPackage = require('../package.json');

if (!tmpPackage.retold || !tmpPackage.retold.brand)
{
	throw new Error('mapping-demo: package.json is missing retold.brand — '
		+ 'run `npm run brand` (chained from prebuild) before building');
}

module.exports = tmpPackage.retold.brand;

},{"../package.json":1}],4:[function(require,module,exports){
'use strict';

// Path: mapping-demo/source/views/ → ../../../../source/views/PictView-MeadowMappingEditor.js
const libMeadowMappingEditorView = require('../../../../source/views/PictView-MeadowMappingEditor.js');

// ── View configuration ────────────────────────────────────────────────────────
// Same template HTML as the generic base editor, but with 'MappingDemoEditor'
// in all onclick handlers so pict resolves this registered view name.
// DOM IDs stay as MeadowMap-* so inherited JS methods work without changes.

const _ViewConfiguration =
{
	ViewIdentifier: 'MappingDemoEditor',

	DefaultRenderable: 'MappingDemoEditor-Content',
	DefaultDestinationAddress: '#MeadowMap-Editor-Container',

	AutoRender: false,

	CSS: libMeadowMappingEditorView.default_configuration.CSS,

	Templates:
	[
		{
			Hash: 'MappingDemoEditor-Template',
			Template: /*html*/`
<div>
	<div id="MeadowMap-Editor" class="meadow-mapping-editor">
		<div class="meadow-mapping-header">
			<button class="meadow-mapping-btn meadow-mapping-btn-secondary meadow-mapping-btn-small" onclick="{~P~}.views['MappingDemoEditor'].closeMappingEditor()">&larr; Back</button>
			<h3 id="MeadowMap-Title">Mapping Editor</h3>
			<div class="meadow-schema-mode-tabs">
				<button class="meadow-schema-mode-tab active" id="MeadowMap-Mode-Flow" onclick="{~P~}.views['MappingDemoEditor'].switchMapMode('flow')">Visual Mapper</button>
				<button class="meadow-schema-mode-tab" id="MeadowMap-Mode-JSON" onclick="{~P~}.views['MappingDemoEditor'].switchMapMode('json')">JSON Config</button>
			</div>
		</div>

		<div id="MeadowMap-List-Wrap">
			<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:0.75em;">
				<div class="meadow-section-title" style="margin:0;">Existing Mappings</div>
				<button class="meadow-mapping-btn meadow-mapping-btn-primary meadow-mapping-btn-small" onclick="{~P~}.views['MappingDemoEditor'].newMapping()">+ New Mapping</button>
			</div>
			<div id="MeadowMap-List"></div>
		</div>

		<div id="MeadowMap-Detail" style="display:none;">
			<div style="display:flex; gap:0.5em; align-items:center; margin-bottom:0.75em;">
				<label style="font-size:0.78em; font-weight:600;">Mapping Name</label>
				<input type="text" id="MeadowMap-Name" placeholder="Mapping name" style="flex:1; padding:0.3em 0.5em; font-size:0.85em; border:1px solid var(--border); border-radius:4px; background:var(--bg-card); color:var(--text);">
			</div>

			<div style="display:flex; gap:0.5em; align-items:center; margin-bottom:0.75em;">
				<label style="font-size:0.78em; font-weight:600;">Source</label>
				<select id="MeadowMap-Source" style="flex:1; padding:0.3em 0.5em; font-size:0.85em; border:1px solid var(--border); border-radius:4px;"></select>
				<button class="meadow-mapping-btn meadow-mapping-btn-secondary meadow-mapping-btn-small" onclick="{~P~}.views['MappingDemoEditor'].discoverSourceFields()">Discover Fields</button>
			</div>

			<div id="MeadowMap-Flow-Wrap">
				<div id="MeadowMap-Flow-Container" class="meadow-flow-container"></div>
			</div>

			<div id="MeadowMap-JSON-Wrap" style="display:none;">
				<textarea class="meadow-mapping-json-editor" id="MeadowMap-JSON" placeholder='{"Entity":"Book","GUIDTemplate":"{~D:Record.id~}","Mappings":{},"Solvers":[],"ManyfestAddresses":false}'></textarea>
			</div>

			<div style="margin-top:0.75em;">
				<div style="font-size:0.72em; font-weight:600; text-transform:uppercase; letter-spacing:0.5px; color:var(--text-dim); margin-bottom:0.35em;">Target Stores</div>
				<div id="MeadowMap-Stores" class="meadow-mapping-store-checklist"></div>
			</div>

			<div style="margin-top:0.75em; display:flex; gap:0.5em; flex-wrap:wrap; align-items:center;">
				<button class="meadow-mapping-btn meadow-mapping-btn-primary" onclick="{~P~}.views['MappingDemoEditor'].saveMapping()">Save Mapping</button>
			</div>
		</div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'MappingDemoEditor-Content',
			TemplateHash: 'MappingDemoEditor-Template',
			ContentDestinationAddress: '#MeadowMap-Editor-Container',
			RenderMethod: 'replace'
		}
	]
};

/**
 * MappingDemoEditorView
 *
 * Extends MeadowMappingEditorView and wires the _do* data methods to the
 * mapping-demo server's REST API endpoints.  All visual/canvas/serialization
 * logic lives in the base class; this subclass only supplies data access.
 */
class MappingDemoEditorView extends libMeadowMappingEditorView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	// ── Data methods ─────────────────────────────────────────────────────────

	_doLoadMappings(pContextID)
	{
		return fetch('/1.0/Demo/VisualMapping').then(function(r) { return r.json(); });
	}

	_doLoadSources()
	{
		return fetch('/1.0/Demo/Sources').then(function(r) { return r.json(); });
	}

	_doLoadStores(pContextID)
	{
		return Promise.resolve({ Stores: [] });
	}

	_doLoadTargetSchema(pContextID)
	{
		return fetch('/1.0/Demo/TargetSchema').then(function(r) { return r.json(); });
	}

	_doLoadMapping(pMappingID)
	{
		return fetch('/1.0/Demo/VisualMapping/' + pMappingID).then(function(r) { return r.json(); });
	}

	_doDeleteMapping(pMappingID)
	{
		return fetch('/1.0/Demo/VisualMapping/' + pMappingID,
			{ method: 'DELETE' }).then(function(r) { return r.json(); });
	}

	_doDiscoverSourceFields(pContextID, pSourceID, pRecordLimit)
	{
		return fetch('/1.0/Demo/SourceSchema').then(function(r) { return r.json(); });
	}

	_doCreateMapping(pContextID, pData)
	{
		return fetch('/1.0/Demo/VisualMapping',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(pData)
			}).then(function(r) { return r.json(); });
	}

	_doUpdateMapping(pMappingID, pData)
	{
		return fetch('/1.0/Demo/VisualMapping/' + pMappingID,
			{
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(pData)
			}).then(function(r) { return r.json(); });
	}

	_onClose()
	{
		// Hide the editor and restore the step placeholder
		let tmpEditor = document.getElementById('MeadowMap-Editor');
		if (tmpEditor)
		{
			tmpEditor.classList.remove('active');
		}

		let tmpPlaceholder = document.getElementById('mapping-editor-placeholder');
		if (tmpPlaceholder)
		{
			tmpPlaceholder.style.display = '';
		}

		// Dispatch an event so the outer UI can mark this step done
		document.dispatchEvent(new CustomEvent('mapping-editor-closed'));
	}
}

module.exports = MappingDemoEditorView;

module.exports.default_configuration = _ViewConfiguration;

},{"../../../../source/views/PictView-MeadowMappingEditor.js":139}],5:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],6:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":5}],7:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],8:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":7,"fable-serviceproviderbase":6}],9:[function(require,module,exports){
/**
 * Pict Provider: Theme
 *
 * Runtime theme manager for Pict applications.  Registers theme bundles
 * (token maps + CSS + SVG + image assets) and applies them by injecting
 * CSS custom properties into a single <style id="pict-theme"> element.
 *
 * Themes can be:
 *   - Single-mode (Modes.Strategy = "single")
 *   - Paired light/dark (Modes.Strategy = "paired")
 *   - System-aware (Modes.Strategy = "system" — paired + auto-pick)
 *
 * Mode is reflected as `theme-light` / `theme-dark` class on <html>.
 *
 * Token resolution path examples:
 *   provider.token('Tokens.Color.Background.Primary') -> raw current value
 *   provider.cssVar('Color.Background.Primary')       -> 'var(--theme-color-background-primary)'
 *   provider.asset('SVG', 'Logo')                     -> SVG string
 *   provider.image('Hero')                            -> image URL / data URL
 *
 * Template expressions registered (when pict has addTemplate):
 *   {~Theme:Tokens.Color.Background.Primary~}    raw value
 *   {~ThemeVar:Color.Background.Primary~}        var(--theme-...) reference
 *   {~ThemeAsset:SVG.Logo~}                      asset content
 *   {~ThemeImage:Hero~}                          image URL
 *
 * Stateless: this provider does not persist anything.  Host applications
 * decide what to apply at boot (from localStorage, server config, etc.).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

const STYLE_ELEMENT_ID = 'pict-theme';
const HTML_CLASS_LIGHT = 'theme-light';
const HTML_CLASS_DARK = 'theme-dark';
const CSS_VAR_PREFIX = '--theme-';

class PictProviderTheme extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictProviderTheme';

		this._themes = {};
		this._themeOrder = [];
		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		this._systemMediaQuery = null;
		this._systemListener = null;
		this._registeredCSSHashes = [];
		this._applyListeners = [];

		// Auto-register the four theme template expressions if the host pict
		// supports addTemplate.  In bare-fable/test contexts this is skipped.
		if (this.pict && typeof this.pict.addTemplate === 'function')
		{
			try
			{
				this.pict.addTemplate(require('./templates/Pict-Template-Theme.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeVar.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeAsset.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeImage.js'));
			}
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: template registration skipped: ' + pError.message);
			}
		}
	}

	// ================================================================
	// Theme registration
	// ================================================================

	/**
	 * Register a theme bundle.  Bundle is the compiled JSON shape (see
	 * the manifest schema documented in the module README and example themes).
	 *
	 * @param {object} pBundle - parsed manifest object
	 * @returns {boolean} true on success
	 */
	registerTheme(pBundle)
	{
		if (!pBundle || typeof pBundle !== 'object')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle is not an object');
			return false;
		}
		if (!pBundle.Hash || typeof pBundle.Hash !== 'string')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle missing required string Hash');
			return false;
		}

		if (!this._themes[pBundle.Hash])
		{
			this._themeOrder.push(pBundle.Hash);
		}
		this._themes[pBundle.Hash] = pBundle;
		return true;
	}

	/**
	 * Get an array of registered theme metadata for building UIs.
	 * @returns {Array<{Hash, Name, Version, Strategy, DefaultMode, Comprehensive}>}
	 */
	listThemes()
	{
		let tmpList = [];
		for (let i = 0; i < this._themeOrder.length; i++)
		{
			let tmpHash = this._themeOrder[i];
			let tmpTheme = this._themes[tmpHash];
			let tmpModes = tmpTheme.Modes || {};
			tmpList.push(
			{
				Hash: tmpTheme.Hash,
				Name: tmpTheme.Name || tmpTheme.Hash,
				Version: tmpTheme.Version || null,
				Strategy: tmpModes.Strategy || 'single',
				DefaultMode: tmpModes.Default || 'light',
				Comprehensive: tmpTheme.Comprehensive !== false
			});
		}
		return tmpList;
	}

	/**
	 * Get the raw stored bundle for a hash.
	 */
	getTheme(pHash)
	{
		return this._themes[pHash] || null;
	}

	// ================================================================
	// Apply / unapply
	// ================================================================

	/**
	 * Apply a theme by hash.  Optionally specify mode ('light', 'dark', 'system').
	 * If pMode is omitted, the theme's Modes.Default is used.
	 *
	 * @param {string} pHash
	 * @param {string} [pMode]
	 * @returns {boolean}
	 */
	applyTheme(pHash, pMode)
	{
		let tmpTheme = this._themes[pHash];
		if (!tmpTheme)
		{
			if (this.log) this.log.warn(`PictProviderTheme.applyTheme: unknown theme hash [${pHash}]`);
			return false;
		}

		// Resolve the effective theme bundle (handle BasedOn inheritance).
		let tmpEffective = this._resolveBundle(tmpTheme);

		let tmpStrategy = (tmpEffective.Modes && tmpEffective.Modes.Strategy) || 'single';
		let tmpDefaultMode = (tmpEffective.Modes && tmpEffective.Modes.Default) || 'light';

		let tmpMode = pMode || tmpDefaultMode;

		// Single-mode themes cannot be put into dark/light/system; clamp.
		if (tmpStrategy === 'single')
		{
			tmpMode = tmpDefaultMode;
		}

		this._activeHash = pHash;
		this._activeMode = tmpMode;

		// Build CSS once, regardless of mode (paired themes emit both blocks
		// and rely on the html class to switch between them).
		let tmpCSS = this._buildThemeCSS(tmpEffective);
		this._injectStyleElement(tmpCSS);

		// Register any auxiliary CSS files declared in the bundle through the
		// Pict CSS cascade so they participate in injectCSS().
		this._registerAuxiliaryCSS(tmpEffective);

		// Set the html class to drive paired-theme variable resolution.
		this._applyMode(tmpMode, tmpStrategy);

		// Notify subscribers (e.g. apps that need to re-color SVG icon palettes
		// from a bundle.IconColors block, swap chart palettes, etc.).
		this._fireApplyListeners(tmpEffective);

		return true;
	}

	/**
	 * Change mode without reapplying the theme.  No-op if no theme is active
	 * or active theme is single-mode.
	 *
	 * @param {string} pMode - 'light' | 'dark' | 'system'
	 */
	setMode(pMode)
	{
		if (!this._activeHash) return false;

		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpStrategy = (tmpTheme.Modes && tmpTheme.Modes.Strategy) || 'single';

		if (tmpStrategy === 'single') return false;

		this._activeMode = pMode;
		this._applyMode(pMode, tmpStrategy);
		this._fireApplyListeners(tmpTheme);
		return true;
	}

	// ================================================================
	// Listener subscription
	// ================================================================

	/**
	 * Subscribe to theme apply / mode-change events.  The callback is
	 * invoked with the effective (BasedOn-resolved) bundle and a context
	 * object: { Hash, Mode, ResolvedMode }.
	 *
	 * Apps use this to re-color SVG icon palettes, swap chart colors,
	 * push tokens into non-CSS consumers (canvas, WebGL), etc.
	 *
	 * Returns a dispose function for symmetry with offApply().
	 */
	onApply(fCallback)
	{
		if (typeof fCallback !== 'function') return function () {};
		this._applyListeners.push(fCallback);
		let tmpSelf = this;
		return function () { tmpSelf.offApply(fCallback); };
	}

	offApply(fCallback)
	{
		let tmpIdx = this._applyListeners.indexOf(fCallback);
		if (tmpIdx >= 0) this._applyListeners.splice(tmpIdx, 1);
	}

	_fireApplyListeners(pBundle)
	{
		if (this._applyListeners.length === 0) return;
		let tmpContext =
		{
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
		for (let i = 0; i < this._applyListeners.length; i++)
		{
			try { this._applyListeners[i](pBundle, tmpContext); }
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: onApply listener threw: ' + pError.message);
			}
		}
	}

	/**
	 * Remove the injected style element, html class, and any auxiliary CSS.
	 */
	unapplyTheme()
	{
		this._detachSystemListener();

		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode)
			{
				tmpStyleEl.parentNode.removeChild(tmpStyleEl);
			}
			if (document.documentElement && document.documentElement.classList)
			{
				document.documentElement.classList.remove(HTML_CLASS_LIGHT);
				document.documentElement.classList.remove(HTML_CLASS_DARK);
			}
		}

		// Unregister any auxiliary CSS we added.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		return true;
	}

	getActiveTheme()
	{
		return {
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
	}

	// ================================================================
	// Token / asset accessors
	// ================================================================

	/**
	 * Resolve a token by dot path against the active theme bundle.  Walks
	 * the entire bundle root, so paths can address Tokens, Brand, etc.
	 *
	 * If the value is paired ({Light, Dark}), returns the value at the
	 * currently resolved mode.
	 *
	 * @param {string} pPath - e.g. 'Tokens.Color.Background.Primary'
	 * @returns {string|number|null}
	 */
	token(pPath)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpValue = this._walkPath(tmpTheme, pPath);
		return this._resolveModedValue(tmpValue);
	}

	/**
	 * Returns a CSS `var(--theme-...)` reference for a token under Tokens.
	 * Path is given without the Tokens prefix:
	 *   cssVar('Color.Background.Primary') -> 'var(--theme-color-background-primary)'
	 *
	 * @param {string} pTokenPath
	 * @returns {string}
	 */
	cssVar(pTokenPath)
	{
		return 'var(' + this._cssVarName(pTokenPath) + ')';
	}

	/**
	 * Look up a named asset under SVG, optionally nested (e.g. 'Icons.Foo').
	 * @param {string} pCategory - 'SVG' | 'Image'
	 * @param {string} pName
	 */
	asset(pCategory, pName)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpRoot = tmpTheme[pCategory];
		if (!tmpRoot) return null;
		return this._walkPath(tmpRoot, pName);
	}

	image(pName)
	{
		return this.asset('Image', pName);
	}

	svg(pName)
	{
		return this.asset('SVG', pName);
	}

	// ================================================================
	// Internals
	// ================================================================

	/**
	 * Resolve a bundle's BasedOn chain into a single effective bundle by
	 * deep-merging this bundle onto its base.  Cycle-safe.
	 */
	_resolveBundle(pBundle)
	{
		let tmpChain = [];
		let tmpCurrent = pBundle;
		let tmpSeen = {};
		while (tmpCurrent)
		{
			if (tmpSeen[tmpCurrent.Hash]) break;
			tmpSeen[tmpCurrent.Hash] = true;
			tmpChain.unshift(tmpCurrent);
			let tmpBaseHash = tmpCurrent.BasedOn;
			tmpCurrent = tmpBaseHash ? this._themes[tmpBaseHash] : null;
		}
		if (tmpChain.length === 1) return tmpChain[0];

		let tmpResult = {};
		for (let i = 0; i < tmpChain.length; i++)
		{
			tmpResult = this._deepMerge(tmpResult, tmpChain[i]);
		}
		return tmpResult;
	}

	_deepMerge(pTarget, pSource)
	{
		let tmpResult = Object.assign({}, pTarget);
		let tmpKeys = Object.keys(pSource);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpVal = pSource[tmpKey];
			if (tmpVal !== null
				&& typeof tmpVal === 'object'
				&& !Array.isArray(tmpVal)
				&& tmpResult[tmpKey] !== null
				&& typeof tmpResult[tmpKey] === 'object'
				&& !Array.isArray(tmpResult[tmpKey]))
			{
				tmpResult[tmpKey] = this._deepMerge(tmpResult[tmpKey], tmpVal);
			}
			else
			{
				tmpResult[tmpKey] = tmpVal;
			}
		}
		return tmpResult;
	}

	/**
	 * Walk a dot-path from a starting object.  Returns null if any segment
	 * is missing.  Path segments are matched case-sensitively as authored.
	 */
	_walkPath(pRoot, pPath)
	{
		if (!pRoot || !pPath) return null;
		let tmpSegments = pPath.split('.');
		let tmpNode = pRoot;
		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpNode === null || typeof tmpNode !== 'object') return null;
			tmpNode = tmpNode[tmpSegments[i]];
			if (typeof tmpNode === 'undefined') return null;
		}
		return tmpNode;
	}

	/**
	 * If pValue is a paired-mode object {Light, Dark}, pick the value matching
	 * the current resolved mode.  Otherwise return as-is.
	 */
	_resolveModedValue(pValue)
	{
		if (this._isPairedValue(pValue))
		{
			let tmpMode = this._resolvedMode || 'light';
			let tmpKey = (tmpMode === 'dark') ? 'Dark' : 'Light';
			return pValue[tmpKey];
		}
		return pValue;
	}

	_isPairedValue(pValue)
	{
		return pValue !== null
			&& typeof pValue === 'object'
			&& !Array.isArray(pValue)
			&& Object.keys(pValue).length > 0
			&& Object.keys(pValue).every((k) => k === 'Light' || k === 'Dark');
	}

	/**
	 * Build the CSS string for a theme.  For single-mode themes, emits a
	 * single :root block.  For paired themes, emits :root for the Light
	 * variant and a .theme-dark { ... } block for the Dark variant.
	 *
	 * Only values under bundle.Tokens become CSS custom properties.
	 */
	_buildThemeCSS(pTheme)
	{
		let tmpTokens = pTheme.Tokens || {};
		let tmpFlat = this._flattenTokens(tmpTokens, '');

		let tmpStrategy = (pTheme.Modes && pTheme.Modes.Strategy) || 'single';
		let tmpHasPaired = tmpFlat.some((tmpEntry) => this._isPairedValue(tmpEntry.Value));

		let tmpAliasLines = this._buildAliasLines(pTheme.Aliases);

		if (tmpStrategy === 'single' || !tmpHasPaired)
		{
			let tmpCSS = ':root {\n';
			for (let i = 0; i < tmpFlat.length; i++)
			{
				let tmpEntry = tmpFlat[i];
				let tmpVal = this._isPairedValue(tmpEntry.Value)
					? tmpEntry.Value.Light
					: tmpEntry.Value;
				tmpCSS += '\t' + this._cssVarName(tmpEntry.Path) + ': ' + this._formatCSSValue(tmpVal) + ';\n';
			}
			tmpCSS += tmpAliasLines;
			tmpCSS += '}\n';
			return tmpCSS;
		}

		let tmpRootCSS = ':root {\n';
		let tmpDarkCSS = '.' + HTML_CLASS_DARK + ' {\n';

		for (let i = 0; i < tmpFlat.length; i++)
		{
			let tmpEntry = tmpFlat[i];
			let tmpVarName = this._cssVarName(tmpEntry.Path);
			if (this._isPairedValue(tmpEntry.Value))
			{
				if (typeof tmpEntry.Value.Light !== 'undefined')
				{
					tmpRootCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Light) + ';\n';
				}
				if (typeof tmpEntry.Value.Dark !== 'undefined')
				{
					tmpDarkCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Dark) + ';\n';
				}
			}
			else
			{
				tmpRootCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value) + ';\n';
			}
		}

		// Aliases live in :root only.  Their var() targets resolve to the
		// active mode's value automatically — no need to duplicate in dark.
		tmpRootCSS += tmpAliasLines;
		tmpRootCSS += '}\n';
		tmpDarkCSS += '}\n';
		return tmpRootCSS + tmpDarkCSS;
	}

	/**
	 * Emit alias lines for legacy CSS variable names that map to token paths
	 * under Tokens.  Each alias becomes:
	 *   --legacy-name: var(--theme-color-...);
	 * Indirection-via-var means paired-mode swap propagates without
	 * needing alias entries duplicated in the .theme-dark block.
	 *
	 * Authored as: { "--legacy-name": "Color.Background.Primary", ... }
	 */
	_buildAliasLines(pAliases)
	{
		if (!pAliases || typeof pAliases !== 'object') return '';
		let tmpKeys = Object.keys(pAliases);
		let tmpOut = '';
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpAlias = tmpKeys[i];
			let tmpTarget = pAliases[tmpAlias];
			if (typeof tmpTarget !== 'string' || tmpTarget.length === 0) continue;
			tmpOut += '\t' + tmpAlias + ': var(' + this._cssVarName(tmpTarget) + ');\n';
		}
		return tmpOut;
	}

	/**
	 * Walk an arbitrary nested token tree and produce a flat list of
	 * { Path: 'color.background.primary', Value: <leaf> } entries.
	 *
	 * Paired-mode objects ({Light, Dark}) and primitive values are leaves.
	 */
	_flattenTokens(pNode, pPathPrefix)
	{
		let tmpResults = [];
		if (pNode === null || typeof pNode !== 'object' || Array.isArray(pNode))
		{
			if (pPathPrefix)
			{
				tmpResults.push({ Path: pPathPrefix, Value: pNode });
			}
			return tmpResults;
		}
		if (this._isPairedValue(pNode))
		{
			tmpResults.push({ Path: pPathPrefix, Value: pNode });
			return tmpResults;
		}
		let tmpKeys = Object.keys(pNode);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pPathPrefix ? (pPathPrefix + '.' + tmpKey) : tmpKey;
			let tmpChild = pNode[tmpKey];
			tmpResults = tmpResults.concat(this._flattenTokens(tmpChild, tmpChildPath));
		}
		return tmpResults;
	}

	/**
	 * 'Color.Background.Primary' -> '--theme-color-background-primary'
	 */
	_cssVarName(pTokenPath)
	{
		return CSS_VAR_PREFIX + pTokenPath.toLowerCase().replace(/\./g, '-');
	}

	_formatCSSValue(pValue)
	{
		if (pValue === null || typeof pValue === 'undefined') return '';
		if (typeof pValue === 'number') return String(pValue);
		return String(pValue);
	}

	_injectStyleElement(pCSS)
	{
		if (typeof document === 'undefined') return;
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = STYLE_ELEMENT_ID;
			document.head.appendChild(tmpStyleEl);
		}
		tmpStyleEl.textContent = pCSS;
	}

	_registerAuxiliaryCSS(pTheme)
	{
		// Clear previously registered auxiliary CSS so stale entries don't pile
		// up when switching themes.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		if (!Array.isArray(pTheme.CSS)) return;
		if (!this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function') return;

		for (let i = 0; i < pTheme.CSS.length; i++)
		{
			let tmpEntry = pTheme.CSS[i];
			if (!tmpEntry || !tmpEntry.Hash || typeof tmpEntry.Content !== 'string') continue;
			let tmpPriority = (typeof tmpEntry.Priority === 'number') ? tmpEntry.Priority : 500;
			this.pict.CSSMap.addCSS(tmpEntry.Hash, tmpEntry.Content, tmpPriority);
			this._registeredCSSHashes.push(tmpEntry.Hash);
		}
	}

	/**
	 * Set or update the `theme-light` / `theme-dark` class on <html>.
	 * For 'system', subscribes to prefers-color-scheme.
	 */
	_applyMode(pMode, pStrategy)
	{
		this._detachSystemListener();

		let tmpResolved = pMode;
		if (pMode === 'system')
		{
			tmpResolved = this._readSystemPreference();
			this._attachSystemListener(pStrategy);
		}

		this._resolvedMode = (tmpResolved === 'dark') ? 'dark' : 'light';
		this._writeHTMLClass(this._resolvedMode);
	}

	_writeHTMLClass(pResolvedMode)
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		if (pResolvedMode === 'dark')
		{
			tmpList.remove(HTML_CLASS_LIGHT);
			tmpList.add(HTML_CLASS_DARK);
		}
		else
		{
			tmpList.remove(HTML_CLASS_DARK);
			tmpList.add(HTML_CLASS_LIGHT);
		}
	}

	_readSystemPreference()
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
		try
		{
			return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
		}
		catch (pError)
		{
			return 'light';
		}
	}

	_attachSystemListener(pStrategy)
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
		try
		{
			let tmpSelf = this;
			let tmpMQ = window.matchMedia('(prefers-color-scheme: dark)');
			let tmpHandler = function ()
			{
				let tmpResolved = tmpMQ.matches ? 'dark' : 'light';
				tmpSelf._resolvedMode = tmpResolved;
				tmpSelf._writeHTMLClass(tmpResolved);
			};
			if (typeof tmpMQ.addEventListener === 'function')
			{
				tmpMQ.addEventListener('change', tmpHandler);
			}
			else if (typeof tmpMQ.addListener === 'function')
			{
				tmpMQ.addListener(tmpHandler);
			}
			this._systemMediaQuery = tmpMQ;
			this._systemListener = tmpHandler;
		}
		catch (pError)
		{
			// Older browser; leave system listener unattached.
		}
	}

	_detachSystemListener()
	{
		if (!this._systemMediaQuery || !this._systemListener) return;
		try
		{
			if (typeof this._systemMediaQuery.removeEventListener === 'function')
			{
				this._systemMediaQuery.removeEventListener('change', this._systemListener);
			}
			else if (typeof this._systemMediaQuery.removeListener === 'function')
			{
				this._systemMediaQuery.removeListener(this._systemListener);
			}
		}
		catch (pError)
		{
			// noop
		}
		this._systemMediaQuery = null;
		this._systemListener = null;
	}
}

PictProviderTheme.default_configuration = _ProviderConfiguration;

module.exports = PictProviderTheme;
module.exports.STYLE_ELEMENT_ID = STYLE_ELEMENT_ID;
module.exports.HTML_CLASS_LIGHT = HTML_CLASS_LIGHT;
module.exports.HTML_CLASS_DARK = HTML_CLASS_DARK;
module.exports.CSS_VAR_PREFIX = CSS_VAR_PREFIX;

},{"./templates/Pict-Template-Theme.js":10,"./templates/Pict-Template-ThemeAsset.js":11,"./templates/Pict-Template-ThemeImage.js":12,"./templates/Pict-Template-ThemeVar.js":13,"pict-provider":15}],10:[function(require,module,exports){
/**
 * Pict template expression: {~Theme:Path~}
 *
 * Resolves a token path against the active theme bundle and returns the
 * raw value at the currently resolved mode.  Walks from the bundle root,
 * so paths like 'Tokens.Color.Background.Primary' or 'Brand.Name' work.
 *
 * Returns an empty string if no theme is active or the path is missing.
 */
const libPictTemplate = require('pict-template');

class PictTemplateTheme extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Theme:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.token(tmpPath);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateTheme;

},{"pict-template":135}],11:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeAsset:Category.Name~}
 *
 * Returns the contents of a named SVG (or other) asset from the active
 * theme bundle.  The first path segment is treated as the category
 * (e.g. SVG), the rest as the asset's path within that category.
 *
 *   {~ThemeAsset:SVG.Logo~}        -> bundle.SVG.Logo
 *   {~ThemeAsset:SVG.Icons.Foo~}   -> bundle.SVG.Icons.Foo
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeAsset extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeAsset:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpDot = tmpPath.indexOf('.');
		if (tmpDot < 0) return '';

		let tmpCategory = tmpPath.substring(0, tmpDot);
		let tmpName = tmpPath.substring(tmpDot + 1);

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.asset(tmpCategory, tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeAsset;

},{"pict-template":135}],12:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeImage:Name~}
 *
 * Returns the URL or data URL stored at bundle.Image[Name] in the active
 * theme bundle.  Convenience over {~ThemeAsset:Image.Name~}.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeImage extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeImage:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpName = (pTemplateHash || '').trim();
		if (!tmpName) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.image(tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeImage;

},{"pict-template":135}],13:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeVar:Path~}
 *
 * Returns a CSS `var(--theme-...)` reference for a token path under
 * Tokens.  E.g. {~ThemeVar:Color.Background.Primary~} ->
 * `var(--theme-color-background-primary)`.
 *
 * Useful inside style attributes and in CSS-in-JS contexts where you want
 * the live custom-property reference rather than the resolved value.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeVar extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeVar:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';
		return tmpProvider.cssVar(tmpPath);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeVar;

},{"pict-template":135}],14:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],15:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":14,"fable-serviceproviderbase":6}],16:[function(require,module,exports){
// The container for all the Pict-Section-Flow related code.

// The main flow diagram view class
module.exports = require('./views/PictView-Flow.js');

// Node rendering view
module.exports.PictViewFlowNode = require('./views/PictView-Flow-Node.js');

// Toolbar views
module.exports.PictViewFlowToolbar = require('./views/PictView-Flow-Toolbar.js');
module.exports.PictViewFlowFloatingToolbar = require('./views/PictView-Flow-FloatingToolbar.js');

// Services
module.exports.PictServiceFlowInteractionManager = require('./services/PictService-Flow-InteractionManager.js');
module.exports.PictServiceFlowConnectionRenderer = require('./services/PictService-Flow-ConnectionRenderer.js');
module.exports.PictServiceFlowTether = require('./services/PictService-Flow-Tether.js');
module.exports.PictServiceFlowLayout = require('./services/PictService-Flow-Layout.js');
module.exports.PictServiceFlowPathGenerator = require('./services/PictService-Flow-PathGenerator.js');
module.exports.PictServiceFlowViewportManager = require('./services/PictService-Flow-ViewportManager.js');
module.exports.PictServiceFlowSelectionManager = require('./services/PictService-Flow-SelectionManager.js');
module.exports.PictServiceFlowPanelManager = require('./services/PictService-Flow-PanelManager.js');
module.exports.PictServiceFlowDataManager = require('./services/PictService-Flow-DataManager.js');
module.exports.PictServiceFlowConnectionHandleManager = require('./services/PictService-Flow-ConnectionHandleManager.js');
module.exports.PictServiceFlowRenderManager = require('./services/PictService-Flow-RenderManager.js');
module.exports.PictServiceFlowPortRenderer = require('./services/PictService-Flow-PortRenderer.js');

// Providers
module.exports.PictProviderFlowNodeTypes = require('./providers/PictProvider-Flow-NodeTypes.js');
module.exports.PictProviderFlowEventHandler = require('./providers/PictProvider-Flow-EventHandler.js');
module.exports.PictProviderFlowLayouts = require('./providers/PictProvider-Flow-Layouts.js');
module.exports.PictProviderFlowSVGHelpers = require('./providers/PictProvider-Flow-SVGHelpers.js');
module.exports.PictProviderFlowGeometry = require('./providers/PictProvider-Flow-Geometry.js');
module.exports.PictProviderFlowPanelChrome = require('./providers/PictProvider-Flow-PanelChrome.js');
module.exports.PictProviderFlowCSS = require('./providers/PictProvider-Flow-CSS.js');
module.exports.PictProviderFlowIcons = require('./providers/PictProvider-Flow-Icons.js');
module.exports.PictProviderFlowConnectorShapes = require('./providers/PictProvider-Flow-ConnectorShapes.js');

// Layout algorithm descriptors (consumers can register custom algorithms via
// _LayoutService.registerAlgorithm({ Name, Apply, DefaultParameters, ParameterSchema }))
module.exports.LayoutAlgorithms =
{
	Custom:           require('./providers/layouts/Layout-Custom.js'),
	Layered:          require('./providers/layouts/Layout-Layered.js'),
	ForcedFromCenter: require('./providers/layouts/Layout-ForcedFromCenter.js'),
	Grid:             require('./providers/layouts/Layout-Grid.js'),
	Circular:         require('./providers/layouts/Layout-Circular.js'),
	Tabular:          require('./providers/layouts/Layout-Tabular.js'),
	Columnar:         require('./providers/layouts/Layout-Columnar.js')
};

// Edge-theme descriptors (consumers can register custom edge themes via
// _LayoutService.registerEdgeTheme({ Name, GeneratePath, AdjustLayout?, ResolveAttachment?, ... }))
module.exports.EdgeThemes =
{
	Bezier:               require('./providers/edges/Edge-Bezier.js'),
	Orthogonal:           require('./providers/edges/Edge-Orthogonal.js'),
	Straight:             require('./providers/edges/Edge-Straight.js'),
	OrthogonalSnap:       require('./providers/edges/Edge-OrthogonalSnap.js'),
	Perimeter:            require('./providers/edges/Edge-Perimeter.js'),
	PerimeterLinear:      require('./providers/edges/Edge-Perimeter-Linear.js'),
	PerimeterOrthogonal:  require('./providers/edges/Edge-Perimeter-Orthogonal.js')
};

// FlowCard base class
module.exports.PictFlowCard = require('./PictFlowCard.js');

// FlowCardPropertiesPanel base class and panel types
module.exports.PictFlowCardPropertiesPanel = require('./PictFlowCardPropertiesPanel.js');
module.exports.FlowCardPropertiesPanelTemplate = require('./panels/FlowCardPropertiesPanel-Template.js');
module.exports.FlowCardPropertiesPanelMarkdown = require('./panels/FlowCardPropertiesPanel-Markdown.js');
module.exports.FlowCardPropertiesPanelForm = require('./panels/FlowCardPropertiesPanel-Form.js');
module.exports.FlowCardPropertiesPanelView = require('./panels/FlowCardPropertiesPanel-View.js');

// Properties panel renderer view
module.exports.PictViewFlowPropertiesPanel = require('./views/PictView-Flow-PropertiesPanel.js');

},{"./PictFlowCard.js":17,"./PictFlowCardPropertiesPanel.js":18,"./panels/FlowCardPropertiesPanel-Form.js":19,"./panels/FlowCardPropertiesPanel-Markdown.js":20,"./panels/FlowCardPropertiesPanel-Template.js":21,"./panels/FlowCardPropertiesPanel-View.js":22,"./providers/PictProvider-Flow-CSS.js":23,"./providers/PictProvider-Flow-ConnectorShapes.js":24,"./providers/PictProvider-Flow-EventHandler.js":25,"./providers/PictProvider-Flow-Geometry.js":26,"./providers/PictProvider-Flow-Icons.js":27,"./providers/PictProvider-Flow-Layouts.js":28,"./providers/PictProvider-Flow-NodeTypes.js":29,"./providers/PictProvider-Flow-PanelChrome.js":31,"./providers/PictProvider-Flow-SVGHelpers.js":32,"./providers/edges/Edge-Bezier.js":34,"./providers/edges/Edge-Orthogonal.js":35,"./providers/edges/Edge-OrthogonalSnap.js":36,"./providers/edges/Edge-Perimeter-Linear.js":37,"./providers/edges/Edge-Perimeter-Orthogonal.js":38,"./providers/edges/Edge-Perimeter.js":39,"./providers/edges/Edge-Straight.js":41,"./providers/layouts/Layout-Circular.js":42,"./providers/layouts/Layout-Columnar.js":44,"./providers/layouts/Layout-Custom.js":45,"./providers/layouts/Layout-ForcedFromCenter.js":46,"./providers/layouts/Layout-Grid.js":47,"./providers/layouts/Layout-Layered.js":48,"./providers/layouts/Layout-Tabular.js":49,"./services/PictService-Flow-ConnectionHandleManager.js":50,"./services/PictService-Flow-ConnectionRenderer.js":51,"./services/PictService-Flow-DataManager.js":52,"./services/PictService-Flow-InteractionManager.js":53,"./services/PictService-Flow-Layout.js":54,"./services/PictService-Flow-PanelManager.js":55,"./services/PictService-Flow-PathGenerator.js":56,"./services/PictService-Flow-PortRenderer.js":57,"./services/PictService-Flow-RenderManager.js":58,"./services/PictService-Flow-SelectionManager.js":59,"./services/PictService-Flow-Tether.js":60,"./services/PictService-Flow-ViewportManager.js":61,"./views/PictView-Flow-FloatingToolbar.js":62,"./views/PictView-Flow-Node.js":63,"./views/PictView-Flow-PropertiesPanel.js":64,"./views/PictView-Flow-Toolbar.js":65,"./views/PictView-Flow.js":66}],17:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCard - Base class for flow diagram cards.
 *
 * Developers create subclasses of PictFlowCard to define reusable node types
 * that appear in the flow palette. Each card describes a discrete operation
 * (e.g. "If-Then-Else", "File Read") with configurable inputs, outputs, and
 * metadata. Pict-Section-Flow uses registered cards to build a palette for
 * the user to drag onto the graph.
 *
 * Configurable properties:
 *   - Title          (string, required) - Display name shown on the node
 *   - Name           (string, optional) - Longer descriptive name
 *   - Code           (string, required) - Short identifier (e.g. "ITE", "SW")
 *   - Description    (string, optional) - Brief explanation of what the card does
 *   - Icon           (string, optional) - Icon identifier or emoji
 *   - PreviewImage   (string, optional) - URL to a preview/thumbnail image
 *   - Documentation  (string, optional) - URL or inline documentation text
 *   - Tooltip        (string, optional) - Hover tooltip text
 *   - Inputs         (array)  - Named input ports, each with:
 *       - Name                 (string)  - Port label
 *       - Side                 (string)  - Port side ('left', 'top', etc.)
 *       - MinimumInputCount    (number)  - Minimum connections accepted (default 0)
 *       - MaximumInputCount    (number)  - Maximum connections accepted (default -1, unlimited)
 *   - Outputs        (array)  - Named output ports
 *   - Enabled        (boolean) - Whether this card is available in the palette
 *   - PropertiesPanel (object, optional) - Configuration for the on-graph properties panel
 *       - PanelType      (string)  - 'Template', 'Markdown', 'Form', or 'View'
 *       - DefaultWidth   (number)  - Panel width (default 300)
 *       - DefaultHeight  (number)  - Panel height (default 200)
 *       - Title          (string)  - Panel title bar text
 *       - Configuration  (object)  - Panel-type-specific configuration
 *   - BodyContent     (object, optional) - Custom content rendered in the node body area
 *       - ContentType    (string)  - 'svg', 'html', or 'canvas'
 *       - Template       (string)  - Pict template string (html/svg only)
 *       - TemplateHash   (string)  - Registered template hash (takes precedence over Template)
 *       - Templates      (array)   - Template definitions to register [{Hash, Template}]
 *       - RenderCallback (function)- Imperative render callback (required for canvas)
 *       - Padding        (number)  - Inner padding in pixels (default 2)
 *   - ShowTypeLabel    (boolean, default true)  - Whether to show the type label/code badge on hover
 *   - PortLabelsOnHover (boolean, default false) - When true, port labels only appear on hover
 *   - PortLabelsVertical (boolean, default false) - When true, port labels render vertically
 *   - PortLabelPadding  (boolean, default false) - When true, port labels have extra padding to avoid overlapping body content
 *   - LabelsInFront     (boolean, default true)  - When true, labels render in front of body content; when false, behind
 *
 * Usage:
 *   class MyCard extends PictFlowCard {
 *     constructor(pFable, pOptions, pServiceHash) {
 *       super(pFable, pOptions, pServiceHash);
 *       this.cardTitle = 'My Card';
 *       this.cardCode = 'MC';
 *       this.cardInputs = [{ Name: 'Data', Side: 'left', MinimumInputCount: 1, MaximumInputCount: 1 }];
 *       this.cardOutputs = [{ Name: 'Result', Side: 'right' }];
 *     }
 *   }
 */
class PictFlowCard extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCard.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCard';

		// --- Card metadata ---
		this.cardTitle = (tmpOptions.Title) ? tmpOptions.Title : 'Card';
		this.cardName = (tmpOptions.Name) ? tmpOptions.Name : false;
		this.cardCode = (tmpOptions.Code) ? tmpOptions.Code : '';
		this.cardDescription = (tmpOptions.Description) ? tmpOptions.Description : false;
		this.cardIcon = (tmpOptions.Icon) ? tmpOptions.Icon : false;
		this.cardPreviewImage = (tmpOptions.PreviewImage) ? tmpOptions.PreviewImage : false;
		this.cardDocumentation = (tmpOptions.Documentation) ? tmpOptions.Documentation : false;
		this.cardTooltip = (tmpOptions.Tooltip) ? tmpOptions.Tooltip : false;
		this.cardHelp = (tmpOptions.Help) ? tmpOptions.Help : false;

		// --- Card enabled state ---
		this.cardEnabled = (typeof tmpOptions.Enabled === 'boolean') ? tmpOptions.Enabled : true;

		// --- Card appearance ---
		this.cardTitleBarColor = (tmpOptions.TitleBarColor) ? tmpOptions.TitleBarColor : '#2c3e50';
		this.cardBodyStyle = (tmpOptions.BodyStyle) ? tmpOptions.BodyStyle : {};
		this.cardWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 180;
		this.cardHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 80;
		this.cardCategory = (tmpOptions.Category) ? tmpOptions.Category : 'General';

		// --- Input and Output port definitions ---
		// Inputs: [{ Name: 'In', Side: 'left', MinimumInputCount: 0, MaximumInputCount: -1 }]
		// Outputs: [{ Name: 'Out', Side: 'right' }]
		this.cardInputs = Array.isArray(tmpOptions.Inputs) ? tmpOptions.Inputs : [];
		this.cardOutputs = Array.isArray(tmpOptions.Outputs) ? tmpOptions.Outputs : [];

		// --- Properties panel configuration ---
		this.cardPropertiesPanel = (tmpOptions.PropertiesPanel && typeof tmpOptions.PropertiesPanel === 'object')
			? tmpOptions.PropertiesPanel
			: null;

		// --- Body content configuration ---
		this.cardBodyContent = (tmpOptions.BodyContent && typeof tmpOptions.BodyContent === 'object')
			? tmpOptions.BodyContent
			: null;

		// --- Label display booleans ---
		this.cardShowTypeLabel = (typeof tmpOptions.ShowTypeLabel === 'boolean') ? tmpOptions.ShowTypeLabel : true;
		this.cardPortLabelsOnHover = (typeof tmpOptions.PortLabelsOnHover === 'boolean') ? tmpOptions.PortLabelsOnHover : false;
		this.cardPortLabelsVertical = (typeof tmpOptions.PortLabelsVertical === 'boolean') ? tmpOptions.PortLabelsVertical : false;
		this.cardPortLabelPadding = (typeof tmpOptions.PortLabelPadding === 'boolean') ? tmpOptions.PortLabelPadding : false;
		this.cardPortLabelsOutside = (typeof tmpOptions.PortLabelsOutside === 'boolean') ? tmpOptions.PortLabelsOutside : false;
		this.cardLabelsInFront = (typeof tmpOptions.LabelsInFront === 'boolean') ? tmpOptions.LabelsInFront : true;
	}

	/**
	 * Generate the node type configuration object for the NodeTypes provider.
	 * This converts the card's properties into the format expected by
	 * PictProviderFlowNodeTypes.registerNodeType().
	 *
	 * @returns {Object} Node type configuration
	 */
	getNodeTypeConfiguration()
	{
		let tmpPorts = [];

		// Build input ports
		for (let i = 0; i < this.cardInputs.length; i++)
		{
			let tmpInput = this.cardInputs[i];
			let tmpPort =
				{
					Hash: null,
					Direction: 'input',
					Side: tmpInput.Side || 'left',
					Label: tmpInput.Name || `In ${i + 1}`,
					MinimumInputCount: (typeof tmpInput.MinimumInputCount === 'number') ? tmpInput.MinimumInputCount : 0,
					MaximumInputCount: (typeof tmpInput.MaximumInputCount === 'number') ? tmpInput.MaximumInputCount : -1
				};
			if (tmpInput.PortType)
			{
				tmpPort.PortType = tmpInput.PortType;
			}
			if (tmpInput.DataType)
			{
				tmpPort.DataType = tmpInput.DataType;
			}
			tmpPorts.push(tmpPort);
		}

		// Build output ports
		for (let i = 0; i < this.cardOutputs.length; i++)
		{
			let tmpOutput = this.cardOutputs[i];
			let tmpOutPort =
				{
					Hash: null,
					Direction: 'output',
					Side: tmpOutput.Side || 'right',
					Label: tmpOutput.Name || `Out ${i + 1}`
				};
			if (tmpOutput.PortType)
			{
				tmpOutPort.PortType = tmpOutput.PortType;
			}
			if (tmpOutput.DataType)
			{
				tmpOutPort.DataType = tmpOutput.DataType;
			}
			tmpPorts.push(tmpOutPort);
		}

		// If no ports were defined, provide sensible defaults
		if (tmpPorts.length === 0)
		{
			tmpPorts.push({ Hash: null, Direction: 'input', Side: 'left', Label: 'In' });
			tmpPorts.push({ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' });
		}

		let tmpResult =
		{
			Hash: this.cardCode,
			Label: this.cardTitle,
			DefaultWidth: this.cardWidth,
			DefaultHeight: this.cardHeight,
			DefaultPorts: tmpPorts,
			TitleBarColor: this.cardTitleBarColor,
			BodyStyle: JSON.parse(JSON.stringify(this.cardBodyStyle)),
			// Extended FlowCard metadata stored alongside the type
			CardMetadata:
			{
				Name: this.cardName,
				Code: this.cardCode,
				Description: this.cardDescription,
				Icon: this.cardIcon,
				PreviewImage: this.cardPreviewImage,
				Documentation: this.cardDocumentation,
				Tooltip: this.cardTooltip,
				Enabled: this.cardEnabled,
				Category: this.cardCategory,
				Help: this.cardHelp
			}
		};

		// Include label display booleans
		tmpResult.ShowTypeLabel = this.cardShowTypeLabel;
		tmpResult.PortLabelsOnHover = this.cardPortLabelsOnHover;
		tmpResult.PortLabelsVertical = this.cardPortLabelsVertical;
		tmpResult.PortLabelPadding = this.cardPortLabelPadding;
		tmpResult.PortLabelsOutside = this.cardPortLabelsOutside;
		tmpResult.LabelsInFront = this.cardLabelsInFront;

		// Include properties panel config if defined
		if (this.cardPropertiesPanel)
		{
			tmpResult.PropertiesPanel = JSON.parse(JSON.stringify(this.cardPropertiesPanel));
		}

		// Include body content config if defined
		if (this.cardBodyContent)
		{
			tmpResult.BodyContent = JSON.parse(JSON.stringify(this.cardBodyContent));
			// RenderCallback cannot be serialized — preserve the original function reference
			if (typeof this.options.BodyContent.RenderCallback === 'function')
			{
				tmpResult.BodyContent.RenderCallback = this.options.BodyContent.RenderCallback;
			}
		}

		return tmpResult;
	}

	/**
	 * Register this card with a FlowView's node type provider.
	 *
	 * @param {Object} pFlowView - The PictViewFlow instance
	 * @returns {boolean} Whether registration succeeded
	 */
	registerWithFlowView(pFlowView)
	{
		if (!pFlowView || !pFlowView._NodeTypeProvider)
		{
			this.log.warn('PictFlowCard registerWithFlowView: no valid FlowView or NodeTypeProvider');
			return false;
		}

		let tmpConfig = this.getNodeTypeConfiguration();
		return pFlowView._NodeTypeProvider.registerNodeType(tmpConfig);
	}
}

module.exports = PictFlowCard;

module.exports.default_configuration =
{
	Title: 'Card',
	Name: false,
	Code: '',
	Description: false,
	Icon: false,
	PreviewImage: false,
	Documentation: false,
	Tooltip: false,
	Inputs: [],
	Outputs: [],
	Enabled: true,
	TitleBarColor: '#2c3e50',
	BodyStyle: {},
	Width: 180,
	Height: 80,
	Category: 'General',
	PropertiesPanel: null,
	BodyContent: null,
	ShowTypeLabel: true,
	PortLabelsOnHover: false,
	PortLabelsVertical: false,
	PortLabelPadding: false,
	PortLabelsOutside: false,
	LabelsInFront: true
};

},{"fable-serviceproviderbase":6}],18:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCardPropertiesPanel - Base class for flow card property panels.
 *
 * Developers create subclasses to define what UI appears when a user opens
 * the properties panel for a node on the flow graph. Four built-in panel
 * types are provided:
 *
 *   - Template  - Renders pict templates
 *   - Markdown  - Renders markdown via pict-section-content
 *   - Form      - Creates an ephemeral pict-section-form section
 *   - View      - Renders an existing registered pict-view
 *
 * Configurable properties:
 *   - PanelType      (string)  - Panel type identifier
 *   - Title          (string)  - Panel title bar text
 *   - Width          (number)  - Default panel width in pixels
 *   - Height         (number)  - Default panel height in pixels
 *   - Configuration  (object)  - Panel-type-specific configuration
 */
class PictFlowCardPropertiesPanel extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCardPropertiesPanel.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel';

		// Panel metadata
		this.panelType = tmpOptions.PanelType || 'Base';
		this.panelTitle = tmpOptions.Title || 'Properties';
		this.panelWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 300;
		this.panelHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 200;

		// Reference to the flow view (set when panel is activated)
		this._FlowView = null;

		// The node data this panel is operating on (set when panel is opened)
		this._NodeData = null;

		// The DOM container element for panel content (set during render)
		this._ContentContainer = null;

		// The panel configuration (panel-type-specific)
		this._Configuration = tmpOptions.Configuration || {};
	}

	/**
	 * Render the panel's content into a DOM container element.
	 * Subclasses MUST override this.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to render into
	 * @param {Object} pNodeData - The node data object (has .Data property)
	 */
	render(pContainer, pNodeData)
	{
		this._ContentContainer = pContainer;
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the node's Data object INTO the panel UI.
	 * Called when the panel opens or when data changes externally.
	 *
	 * @param {Object} pNodeData
	 */
	marshalToPanel(pNodeData)
	{
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the panel UI INTO the node's Data object.
	 * Called before saving or when the panel is about to close.
	 *
	 * @param {Object} pNodeData
	 */
	marshalFromPanel(pNodeData)
	{
		// Subclasses override
	}

	/**
	 * Called when the panel is being destroyed (closed).
	 * Subclasses should clean up resources.
	 */
	destroy()
	{
		this._ContentContainer = null;
		this._NodeData = null;
	}
}

module.exports = PictFlowCardPropertiesPanel;

module.exports.default_configuration =
{
	PanelType: 'Base',
	Title: 'Properties',
	Width: 300,
	Height: 200,
	Configuration: {}
};

},{"fable-serviceproviderbase":6}],19:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Form
 *
 * Creates an ephemeral pict-section-form section to edit the node's Data object.
 * Uses PictViewFormMetacontroller.injectManifest() to dynamically create form
 * sections at runtime.
 *
 * Note: pict-section-form must be available in the consuming application
 * (it is an optional/peer dependency, not bundled with pict-section-flow).
 *
 * Configuration:
 *   {
 *     PanelType: 'Form',
 *     Configuration: {
 *       Manifest: {
 *         Sections: [...],
 *         Descriptors: {...}
 *       }
 *     }
 *   }
 */
class FlowCardPropertiesPanelForm extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Form';

		this._Metacontroller = null;
		this._InjectedSectionHash = null;
	}

	/**
	 * Render the form into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Manifest)
		{
			pContainer.innerHTML = '<em>No form manifest configured</em>';
			return;
		}

		// Create a unique container ID for the form section
		let tmpContainerID = `pict-flow-panel-form-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		// Bind the node data to AppData.Record so the form descriptors
		// (which use addresses like Record.Data.SearchString) resolve against
		// the actual node object.
		this.fable.AppData.Record = pNodeData;

		try
		{
			// Look for an existing metacontroller or create one
			if (!this._Metacontroller)
			{
				// Try to find PictFormMetacontroller service type (check both common names)
				let tmpServiceType = null;
				if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))
				{
					tmpServiceType = 'PictFormMetacontroller';
				}
				else if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller'))
				{
					tmpServiceType = 'PictViewFormMetacontroller';
				}

				if (tmpServiceType)
				{
					this._Metacontroller = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceType,
						{
							ViewIdentifier: `FlowPanelForm-${pNodeData.Hash}`,
							DefaultDestinationAddress: `#${tmpContainerID}`,
							AutoRender: false,
							AutoPopulateAfterRender: true,
							AutoSolveBeforeRender: false
						});
				}
			}

			if (this._Metacontroller && typeof this._Metacontroller.injectManifestAndRender === 'function')
			{
				// Create the FormContainer div that the metacontroller's
				// updateMetatemplateInDOM() expects when adding section wrappers.
				// Normally this is created when the metacontroller renders its own
				// metatemplate, but we skip that step since we only need the
				// injected section views, not the metacontroller's own renderable.
				let tmpFormContainerID = `Pict-${this._Metacontroller.UUID}-FormContainer`;
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl)
				{
					tmpContainerEl.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form"></div>`;
				}

				// Deep clone the manifest so each panel gets its own copy
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Use injectManifestAndRender which properly creates section views,
				// updates the metatemplate in the DOM, and renders each section view
				this._Metacontroller.injectManifestAndRender(tmpManifest);
			}
			else if (this._Metacontroller && typeof this._Metacontroller.injectManifest === 'function')
			{
				// Fallback for older pict-section-form versions: inject the
				// manifest and render each section view individually
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				let tmpViewsToRender = this._Metacontroller.injectManifest(tmpManifest);
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Create container divs for each section view and render them
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl && tmpViewsToRender.length > 0)
				{
					let tmpInnerHTML = '';
					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						let tmpDestID = tmpViewsToRender[i].options.DefaultDestinationAddress;
						if (tmpDestID && tmpDestID.charAt(0) === '#')
						{
							tmpDestID = tmpDestID.substring(1);
						}
						tmpInnerHTML += `<div id="${tmpDestID}" class="pict-form-view"></div>`;
					}
					tmpContainerEl.innerHTML = tmpInnerHTML;

					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						tmpViewsToRender[i].render();
					}
				}
			}
			else
			{
				pContainer.innerHTML = '<em>pict-section-form is not available. Install it in your application to use Form panels.</em>';
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Form render error: ${pError.message}`);
			pContainer.innerHTML = `<em>Form render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._Metacontroller && typeof this._Metacontroller.marshalFromView === 'function')
		{
			this._Metacontroller.marshalFromView();
		}
	}

	destroy()
	{
		this._Metacontroller = null;
		this._InjectedSectionHash = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelForm;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Form',
		Configuration:
		{
			Manifest: null
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":18}],20:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Markdown
 *
 * Renders markdown content into the panel body using pict-section-content's
 * PictContentProvider service.  When pict-section-content is installed and its
 * PictContentProvider service type has been registered with the pict instance,
 * full markdown rendering is available (headings, lists, tables, code blocks
 * with syntax highlighting, KaTeX equations, Mermaid diagrams, etc.).
 *
 * If PictContentProvider is not available, the panel falls back to displaying
 * the raw markdown as pre-formatted text.
 *
 * Configuration:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       Markdown: '# Title\nSome **markdown** content'
 *     }
 *   }
 *
 * Or use an address to pull markdown from the node's data:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       MarkdownAddress: 'Data.MarkdownContent'
 *     }
 *   }
 */
class FlowCardPropertiesPanelMarkdown extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Markdown';

		this._ContentProvider = null;
	}

	/**
	 * Render markdown into the panel.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		this._renderMarkdown();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderMarkdown();
	}

	_renderMarkdown()
	{
		if (!this._ContentContainer || !this._Configuration) return;

		let tmpMarkdown = '';

		if (this._Configuration.MarkdownAddress && this._NodeData)
		{
			// Resolve markdown from node data using manyfest
			tmpMarkdown = this.fable.manifest.getValueByHash(this._NodeData, this._Configuration.MarkdownAddress) || '';
		}
		else if (this._Configuration.Markdown)
		{
			tmpMarkdown = this._Configuration.Markdown;
		}

		if (!tmpMarkdown)
		{
			this._ContentContainer.innerHTML = '<em>No content</em>';
			return;
		}

		// Use pict-section-content's PictContentProvider for markdown rendering.
		// The consuming application must register the PictContentProvider service
		// type (from pict-section-content) for this to work.
		try
		{
			if (!this._ContentProvider)
			{
				if (this.fable.servicesMap.hasOwnProperty('PictContentProvider'))
				{
					this._ContentProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictContentProvider', {});
				}
			}

			if (this._ContentProvider && typeof this._ContentProvider.parseMarkdown === 'function')
			{
				let tmpHTML = this._ContentProvider.parseMarkdown(tmpMarkdown);
				this._ContentContainer.innerHTML = tmpHTML;

				// Post-render hooks for equations and diagrams
				if (typeof this._ContentProvider.renderKaTeXEquations === 'function')
				{
					this._ContentProvider.renderKaTeXEquations(this._ContentContainer);
				}
				if (typeof this._ContentProvider.renderMermaidDiagrams === 'function')
				{
					this._ContentProvider.renderMermaidDiagrams(this._ContentContainer);
				}
			}
			else
			{
				// PictContentProvider not registered — render as pre-formatted text
				this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Markdown render error: ${pError.message}`);
			this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
		}
	}

	_escapeHTML(pText)
	{
		let tmpDiv = document.createElement('div');
		tmpDiv.textContent = pText;
		return tmpDiv.innerHTML;
	}

	destroy()
	{
		this._ContentProvider = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelMarkdown;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Markdown',
		Configuration:
		{
			Markdown: '',
			MarkdownAddress: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":18}],21:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Template
 *
 * Renders pict templates into the panel body.
 *
 * Configuration:
 *   {
 *     PanelType: 'Template',
 *     Configuration: {
 *       Templates: [
 *         { Hash: 'my-template', Template: '<div>{~D:Record.Data.SomeValue~}</div>' }
 *       ],
 *       TemplateHash: 'my-template'
 *     }
 *   }
 */
class FlowCardPropertiesPanelTemplate extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Template';

		this._TemplatesRegistered = false;
	}

	/**
	 * Register templates with the pict template provider and render.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Templates) return;

		// Register templates with pict (only once)
		if (!this._TemplatesRegistered)
		{
			let tmpTemplates = this._Configuration.Templates;
			for (let i = 0; i < tmpTemplates.length; i++)
			{
				if (tmpTemplates[i].Hash && tmpTemplates[i].Template)
				{
					this.fable.TemplateProvider.addTemplate(tmpTemplates[i].Hash, tmpTemplates[i].Template);
				}
			}
			this._TemplatesRegistered = true;
		}

		this._renderTemplate();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderTemplate();
	}

	_renderTemplate()
	{
		if (!this._ContentContainer || !this._NodeData) return;

		let tmpTemplateHash = this._Configuration.TemplateHash;
		if (!tmpTemplateHash) return;

		let tmpRecord = this._NodeData;
		let tmpHTML = this.fable.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, [tmpRecord]);
		this._ContentContainer.innerHTML = tmpHTML;
	}
}

module.exports = FlowCardPropertiesPanelTemplate;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Template',
		Configuration:
		{
			Templates: [],
			TemplateHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":18}],22:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-View
 *
 * Renders an existing registered pict-view into the panel body.
 * The view's destination is temporarily overridden to render inside
 * the panel container.
 *
 * Configuration:
 *   {
 *     PanelType: 'View',
 *     Configuration: {
 *       ViewHash: 'MyCustomViewIdentifier'
 *     }
 *   }
 */
class FlowCardPropertiesPanelView extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-View';

		this._OriginalDestination = null;
		this._ViewInstance = null;
	}

	/**
	 * Render the referenced pict-view into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.ViewHash)
		{
			pContainer.innerHTML = '<em>No ViewHash configured</em>';
			return;
		}

		let tmpViewHash = this._Configuration.ViewHash;

		// Create a unique container ID
		let tmpContainerID = `pict-flow-panel-view-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		try
		{
			// Look up the view in the pict instance
			let tmpPict = this.pict || this.fable;
			if (tmpPict.views && tmpPict.views[tmpViewHash])
			{
				this._ViewInstance = tmpPict.views[tmpViewHash];

				// Save original destination
				this._OriginalDestination = this._ViewInstance.options.DefaultDestinationAddress;

				// Override destination to our panel container
				this._ViewInstance.options.DefaultDestinationAddress = `#${tmpContainerID}`;

				if (typeof this._ViewInstance.render === 'function')
				{
					this._ViewInstance.render();
				}
			}
			else
			{
				pContainer.innerHTML = `<em>View "${tmpViewHash}" not found</em>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-View render error: ${pError.message}`);
			pContainer.innerHTML = `<em>View render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._ViewInstance && typeof this._ViewInstance.marshalFromView === 'function')
		{
			this._ViewInstance.marshalFromView();
		}
	}

	destroy()
	{
		// Restore original destination
		if (this._ViewInstance && this._OriginalDestination)
		{
			this._ViewInstance.options.DefaultDestinationAddress = this._OriginalDestination;
		}

		this._ViewInstance = null;
		this._OriginalDestination = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelView;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'View',
		Configuration:
		{
			ViewHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":18}],23:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-CSS
 *
 * Centralized CSS provider for the flow diagram.
 * All flow-related CSS is organized into domain-specific getter methods,
 * providing a single source of truth and enabling future theming.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowCSS'
};

class PictProviderFlowCSS extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowCSS';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ── Container ──────────────────────────────────────────────────────────
	/**
	 * CSS for the flow container, SVG container, panning/connecting cursors, and grid pattern.
	 * @returns {string}
	 */
	getContainerCSS()
	{
		return /*css*/`
		.pict-flow-container {
			/* ── Design Tokens ─────────────────────────────────────
			   Override these custom properties to theme the flow diagram.
			   Node-type classes (.pict-flow-node-{type}) can scope-override
			   any variable for per-type variation.

			   Defaults reference the host application's pict-provider-theme
			   tokens (--theme-color-*) when available, with hardcoded
			   fallbacks so the editor still looks reasonable in unthemed
			   contexts. Internal flow themes (sketch, blueprint, etc.) keep
			   layering on top via .pict-flow-container scoped overrides. */

			/* Text */
			--pf-text-primary: var(--theme-color-text-primary, #2c3e50);
			--pf-text-heading: var(--theme-color-text-primary, #1a252f);
			--pf-text-secondary: var(--theme-color-text-secondary, #7f8c8d);
			--pf-text-tertiary: var(--theme-color-text-muted, #8e99a4);
			--pf-text-placeholder: var(--theme-color-text-placeholder, #95a5a6);

			/* Node */
			--pf-node-body-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-body-stroke: var(--theme-color-border-default, #d0d4d8);
			--pf-node-body-stroke-hover: var(--theme-color-border-strong, #b0b8c0);
			--pf-node-body-stroke-width: 1;
			--pf-node-body-radius: 8px;
			--pf-node-shadow: drop-shadow(0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)));
			--pf-node-shadow-hover: drop-shadow(0 2px 6px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.15)));
			--pf-node-shadow-selected: drop-shadow(0 2px 8px rgba(52, 152, 219, 0.25));
			--pf-node-shadow-dragging: drop-shadow(0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.20)));
			--pf-node-title-fill: var(--theme-color-background-panel, #ffffff);
			--pf-node-title-size: 11.5px;
			--pf-node-title-weight: 600;
			--pf-node-title-bar-color: var(--theme-color-text-primary, #2c3e50);
			--pf-node-type-label-fill: var(--theme-color-text-muted, #a0a8b0);
			--pf-node-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Node Variants */
			--pf-node-start-fill: #eafaf1;
			--pf-node-start-stroke: var(--theme-color-status-success, #27ae60);
			--pf-node-end-fill: #e8f8f5;
			--pf-node-end-stroke: #1abc9c;
			--pf-node-halt-fill: #fdedec;
			--pf-node-halt-stroke: var(--theme-color-status-error, #e74c3c);
			--pf-node-decision-fill: #fff9e6;
			--pf-node-decision-stroke: var(--theme-color-status-warning, #f39c12);

			/* ── Color roles ───────────────────────────────────────
			   Generic, theme-aware semantic colors that node types and
			   individual cards opt into via a ColorRole field. The
			   "-soft" variant is the tinted background; the bare role is
			   the title-bar / outline / accent stroke.

			   Hosts can override any of these tokens at .pict-flow-container
			   scope (or at their own scope) without touching JS. Built-in
			   node types resolve their visuals through these tokens, so
			   theming a role automatically retints every card that uses it.

			   Soft tints use color-mix() — supported in Chrome 111+,
			   Safari 16.2+, Firefox 113+. The hardcoded fallbacks keep the
			   editor presentable on older engines. */
			--pf-color-success: var(--theme-color-status-success, #27ae60);
			--pf-color-success-soft: color-mix(in srgb, var(--pf-color-success) 12%, transparent);
			--pf-color-warning: var(--theme-color-status-warning, #f39c12);
			--pf-color-warning-soft: color-mix(in srgb, var(--pf-color-warning) 14%, transparent);
			--pf-color-error: var(--theme-color-status-error, #e74c3c);
			--pf-color-error-soft: color-mix(in srgb, var(--pf-color-error) 12%, transparent);
			--pf-color-info: var(--theme-color-status-info, #3498db);
			--pf-color-info-soft: color-mix(in srgb, var(--pf-color-info) 12%, transparent);
			--pf-color-accent: var(--theme-color-brand-accent, #1abc9c);
			--pf-color-accent-soft: color-mix(in srgb, var(--pf-color-accent) 14%, transparent);
			--pf-color-neutral: var(--theme-color-text-primary, #2c3e50);
			--pf-color-neutral-soft: var(--theme-color-background-panel, #ffffff);
			--pf-color-neutral-onfill: var(--theme-color-background-panel, #ffffff);

			/* Ports */
			--pf-port-input-fill: var(--theme-color-status-info, #3498db);
			--pf-port-output-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-stroke: var(--theme-color-background-panel, #ffffff);
			--pf-port-stroke-width: 2;
			--pf-port-label-bg: rgba(255, 253, 240, 0.5);
			--pf-port-label-text: var(--theme-color-text-primary, #2c3e50);

			/* Port Type Colors */
			--pf-port-event-in-fill: var(--theme-color-status-info, #3498db);
			--pf-port-event-out-fill: var(--theme-color-status-success, #2ecc71);
			--pf-port-setting-fill: #e67e22;
			--pf-port-value-fill: #f1c40f;
			--pf-port-error-fill: var(--theme-color-status-error, #e74c3c);

			/* Connection Type Colors (match source port) */
			--pf-connection-event-in-stroke: var(--theme-color-status-info, #3498db);
			--pf-connection-event-out-stroke: var(--theme-color-status-success, #2ecc71);
			--pf-connection-setting-stroke: #e67e22;
			--pf-connection-value-stroke: #f1c40f;
			--pf-connection-error-stroke: var(--theme-color-status-error, #e74c3c);

			/* Connections */
			--pf-connection-stroke: var(--theme-color-border-strong, #95a5a6);
			--pf-connection-stroke-hover: var(--theme-color-text-secondary, #7f8c8d);
			--pf-connection-selected-stroke: var(--theme-color-brand-primary, #3498db);

			/* Panels */
			--pf-panel-bg: var(--theme-color-background-panel, #ffffff);
			--pf-panel-border: var(--theme-color-border-default, #d0d4d8);
			--pf-panel-radius: 8px;
			--pf-panel-shadow: 0 4px 12px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.10)), 0 1px 3px var(--theme-color-shadow-color, rgba(0, 0, 0, 0.06));
			--pf-panel-titlebar-bg: var(--theme-color-background-secondary, #f7f8fa);
			--pf-panel-titlebar-border: var(--theme-color-border-light, #e8eaed);
			--pf-panel-title-color: var(--theme-color-text-primary, #2c3e50);

			/* Tabs */
			--pf-tab-text: var(--theme-color-text-muted, #8e99a4);
			--pf-tab-text-hover: var(--theme-color-text-secondary, #5a6a7a);
			--pf-tab-active-border: var(--pf-node-selected-stroke);
			--pf-resize-handle-hover: var(--theme-color-border-light, #e0e3e6);

			/* Forms & Inputs */
			--pf-input-border: var(--theme-color-border-default, #d5d8dc);
			--pf-input-border-focus: var(--theme-color-focus-outline, #3498db);
			--pf-divider-light: var(--theme-color-border-light, #ecf0f1);
			--pf-divider-medium: var(--theme-color-border-light, #e8eaed);

			/* Buttons */
			--pf-button-border: var(--theme-color-border-default, #bdc3c7);
			--pf-button-hover-border: var(--theme-color-border-strong, #95a5a6);
			--pf-button-hover-bg: var(--theme-color-background-hover, #ecf0f1);
			--pf-button-active-bg: var(--theme-color-background-selected, #d5dbdb);
			--pf-button-danger-text: var(--theme-color-status-error, #e74c3c);
			--pf-button-danger-hover-bg: #fdedec;
			--pf-button-close-color: var(--theme-color-text-muted, #b0b8c0);

			/* Badges */
			--pf-badge-category-bg: var(--theme-color-background-tertiary, #f0f2f4);
			--pf-badge-category-text: var(--theme-color-text-secondary, #6b7b8d);
			--pf-badge-code-bg: #eaf2f8;
			--pf-badge-code-text: #2980b9;

			/* Info Panel */
			--pf-port-item-bg: var(--theme-color-background-secondary, #f8f9fa);

			/* Toolbar */
			--pf-toolbar-bg: var(--theme-color-background-panel, #ffffff);
			--pf-toolbar-border: var(--theme-color-border-default, #e0e0e0);

			/* Palette Cards */
			--pf-card-border: var(--theme-color-border-default, #d5d8dc);
			--pf-card-hover-bg: var(--theme-color-background-hover, #eaf2f8);
			--pf-card-hover-shadow: 0 1px 3px rgba(52, 152, 219, 0.15);

			/* Canvas */
			--pf-canvas-bg: var(--theme-color-background-secondary, #fafafa);
			--pf-grid-stroke: var(--theme-color-border-light, #e8e8e8);

			position: relative;
			width: 100%;
			height: 100%;
			min-height: 400px;
			overflow: hidden;
			background-color: var(--pf-canvas-bg);
			border: 1px solid var(--pf-toolbar-border);
			border-radius: 4px;
			display: flex;
			flex-direction: column;
		}
		.pict-flow-svg-container {
			flex: 1;
			min-height: 0;
			position: relative;
		}
		.pict-flow-svg {
			width: 100%;
			height: 100%;
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-svg.panning {
			cursor: grabbing;
		}
		.pict-flow-svg.connecting {
			cursor: crosshair;
		}
		.pict-flow-grid-pattern line {
			stroke: var(--pf-grid-stroke);
			stroke-width: 0.5;
		}
		`;
	}

	// ── Nodes ──────────────────────────────────────────────────────────────
	/**
	 * CSS for base node styling: body, hover/selected/dragging states, title bar, title text, type label.
	 * @returns {string}
	 */
	getNodeCSS()
	{
		return /*css*/`
		.pict-flow-node {
			cursor: pointer;
			filter: var(--pf-node-shadow);
			transition: filter 0.2s;
		}
		.pict-flow-node:hover {
			filter: var(--pf-node-shadow-hover);
		}
		.pict-flow-node:hover .pict-flow-node-body {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}
		.pict-flow-node.selected {
			filter: var(--pf-node-shadow-selected);
		}
		.pict-flow-node.selected .pict-flow-node-body {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node.dragging {
			opacity: 0.9;
			cursor: grabbing;
			filter: var(--pf-node-shadow-dragging);
		}
		.pict-flow-node-body {
			fill: var(--pf-node-body-fill);
			stroke: var(--pf-node-body-stroke);
			stroke-width: var(--pf-node-body-stroke-width);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
			transition: stroke 0.2s, stroke-width 0.2s;
		}
		.pict-flow-node-title-bar {
			fill: var(--pf-node-title-bar-color);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
		}
		.pict-flow-node-title-bar-bottom {
			fill: var(--pf-node-title-bar-color);
		}
		.pict-flow-node-title {
			fill: var(--pf-node-title-fill);
			font-size: var(--pf-node-title-size);
			font-weight: var(--pf-node-title-weight);
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			letter-spacing: 0.2px;
			pointer-events: none;
		}
		.pict-flow-node-type-label {
			fill: var(--pf-node-type-label-fill);
			font-size: 9.5px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			text-transform: uppercase;
			letter-spacing: 0.3px;
			pointer-events: none;
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-type-label {
			opacity: 1;
		}
		.pict-flow-node-card-code {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-card-code {
			opacity: 1;
		}
		/* Title-bar icon: invert SVG paths to white for dark title bars */
		.pict-flow-node-title-icon {
			filter: brightness(0) invert(1);
		}
		`;
	}

	// ── Body Content ──────────────────────────────────────────────────────
	/**
	 * CSS for custom body content in nodes: SVG group, foreignObject, HTML container, canvas.
	 * @returns {string}
	 */
	getBodyContentCSS()
	{
		return /*css*/`
		.pict-flow-node-body-content {
			pointer-events: none;
		}
		.pict-flow-node-body-content-fo {
			overflow: hidden;
		}
		.pict-flow-node-body-content-html {
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 11px;
			color: var(--pf-text-primary);
			pointer-events: auto;
		}
		.pict-flow-node-body-content-canvas {
			display: block;
			pointer-events: auto;
		}
		`;
	}

	// ── Node Variants ──────────────────────────────────────────────────────
	/**
	 * CSS overrides for specific node types: start, end, halt, decision.
	 * @returns {string}
	 */
	getNodeVariantCSS()
	{
		return /*css*/`
		.pict-flow-node-decision .pict-flow-node-body {
			fill: var(--pf-node-decision-fill);
			stroke: var(--pf-node-decision-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-start .pict-flow-node-body {
			fill: var(--pf-node-start-fill);
			stroke: var(--pf-node-start-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-end .pict-flow-node-body {
			fill: var(--pf-node-end-fill);
			stroke: var(--pf-node-end-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-halt .pict-flow-node-body {
			fill: var(--pf-node-halt-fill);
			stroke: var(--pf-node-halt-stroke);
			stroke-width: 1.5;
		}

		/* ── Color-role variants ────────────────────────────────
		   Cards opt into a role via ColorRole on the node-type config or
		   a per-node override. The renderer adds .pict-flow-node-color-{role}
		   to the node group, which pulls fill/stroke/title-bar colors from
		   the --pf-color-* tokens — those in turn track the host's
		   --theme-color-* tokens so light/dark/palette swaps propagate.

		   Roles deliberately don't override .pict-flow-node-body-content-*
		   styling — the body content's visual identity is the consumer's
		   responsibility. */
		.pict-flow-node-color-success .pict-flow-node-body {
			fill: var(--pf-color-success-soft);
			stroke: var(--pf-color-success);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-success .pict-flow-node-title-bar,
		.pict-flow-node-color-success .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-success);
		}
		.pict-flow-node-color-success .pict-flow-node-bracket {
			stroke: var(--pf-color-success);
		}

		.pict-flow-node-color-warning .pict-flow-node-body {
			fill: var(--pf-color-warning-soft);
			stroke: var(--pf-color-warning);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-warning .pict-flow-node-title-bar,
		.pict-flow-node-color-warning .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-warning);
		}
		.pict-flow-node-color-warning .pict-flow-node-bracket {
			stroke: var(--pf-color-warning);
		}

		.pict-flow-node-color-error .pict-flow-node-body {
			fill: var(--pf-color-error-soft);
			stroke: var(--pf-color-error);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-error .pict-flow-node-title-bar,
		.pict-flow-node-color-error .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-error);
		}
		.pict-flow-node-color-error .pict-flow-node-bracket {
			stroke: var(--pf-color-error);
		}

		.pict-flow-node-color-info .pict-flow-node-body {
			fill: var(--pf-color-info-soft);
			stroke: var(--pf-color-info);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-info .pict-flow-node-title-bar,
		.pict-flow-node-color-info .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-info);
		}
		.pict-flow-node-color-info .pict-flow-node-bracket {
			stroke: var(--pf-color-info);
		}

		.pict-flow-node-color-accent .pict-flow-node-body {
			fill: var(--pf-color-accent-soft);
			stroke: var(--pf-color-accent);
			stroke-width: 1.5;
		}
		.pict-flow-node-color-accent .pict-flow-node-title-bar,
		.pict-flow-node-color-accent .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-accent);
		}
		.pict-flow-node-color-accent .pict-flow-node-bracket {
			stroke: var(--pf-color-accent);
		}

		.pict-flow-node-color-neutral .pict-flow-node-body {
			fill: var(--pf-color-neutral-soft);
			stroke: var(--pf-color-neutral);
			stroke-width: 1;
		}
		.pict-flow-node-color-neutral .pict-flow-node-title-bar,
		.pict-flow-node-color-neutral .pict-flow-node-title-bar-bottom {
			fill: var(--pf-color-neutral);
		}
		.pict-flow-node-color-neutral .pict-flow-node-bracket {
			stroke: var(--pf-color-neutral);
		}
		`;
	}

	// ── Ports ──────────────────────────────────────────────────────────────
	/**
	 * CSS for port circles: input/output coloring, hover states, labels.
	 * @returns {string}
	 */
	getPortCSS()
	{
		return /*css*/`
		.pict-flow-port {
			cursor: crosshair;
			transition: r 0.15s, filter 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.12));
		}
		.pict-flow-port.input {
			fill: var(--pf-port-input-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port.output {
			fill: var(--pf-port-output-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port:hover {
			r: 7;
			filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.20));
		}
		/* Port type color overrides */
		.pict-flow-port.port-type-event-in {
			fill: var(--pf-port-event-in-fill);
		}
		.pict-flow-port.port-type-event-out {
			fill: var(--pf-port-event-out-fill);
		}
		.pict-flow-port.port-type-setting {
			fill: var(--pf-port-setting-fill);
		}
		.pict-flow-port.port-type-value {
			fill: var(--pf-port-value-fill);
		}
		.pict-flow-port.port-type-error {
			fill: var(--pf-port-error-fill);
		}
		.pict-flow-port-label {
			font-size: 8px;
			font-weight: 600;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			pointer-events: none;
		}
		/* Port label badge background */
		.pict-flow-port-label-bg {
			pointer-events: none;
		}
		/* Port labels on hover: hidden by default, revealed on node hover */
		.pict-flow-node-port-labels-hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover .pict-flow-port-label-bg {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label-bg {
			opacity: 1;
		}

		/* Port-hint beziers — drawn from the badge to the actual dot
		   when an edge theme has rerouted the connection. Hidden by
		   default; PortRenderer / NodeView toggle data-active on hover. */
		.pict-flow-port-hint {
			fill: none;
			stroke: var(--pf-connection-stroke-hover, #3498db);
			stroke-width: 1.75;
			stroke-dasharray: 4 3;
			stroke-linecap: round;
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.18s ease;
		}
		.pict-flow-port-hint[data-active="true"] {
			opacity: 0.7;
		}

		/* ── Layout-algorithm popup: tightened layout + form styling ── */
		.pict-flow-popup-layout-algorithm-row {
			display: flex;
			flex-direction: column;
			gap: 4px;
			padding: 6px 10px 4px;
		}
		.pict-flow-popup-layout-algorithm-row > .pict-flow-popup-settings-label {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.7;
			margin: 0;
		}
		.pict-flow-popup-layout-algorithm-controls {
			display: flex;
			align-items: stretch;
			gap: 4px;
		}
		.pict-flow-popup-layout-algorithm-select {
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-flow-popup-collapse-toggle {
			flex: 0 0 auto;
			width: 28px;
			padding: 0;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			background: var(--pf-toolbar-bg, #fff);
			color: var(--pf-text-secondary, #5a6470);
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, color 0.15s, border-color 0.15s;
		}
		.pict-flow-popup-collapse-toggle:hover {
			background-color: var(--pf-button-hover-bg, #eef);
			color: var(--pf-text-primary, #2c3e50);
		}
		/* "Open" state: pressed-in look so the user sees that the form
		   below is being driven by this gear. */
		.pict-flow-popup-collapse-toggle[aria-expanded="true"] {
			background-color: var(--pf-button-active-bg, #d6e4f0);
			color: var(--pf-text-primary, #2c3e50);
			border-color: var(--pf-button-hover-border, #3498db);
		}
		.pict-flow-popup-collapse-toggle svg {
			display: block;
		}
		/* Subordinate description text — sits under a control (algorithm
		   dropdown, edge-theme dropdown, etc.) and explains it. Indented
		   from the section's left edge with a faint left rule so the
		   visual hierarchy is unambiguous: SECTION LABEL > control >
		   description. */
		.pict-flow-popup-control-description {
			font-size: 11px;
			line-height: 1.4;
			color: var(--pf-text-secondary, #5a6470);
			padding: 4px 12px 8px 28px;
			margin-left: 14px;
			border-left: 2px solid var(--pf-divider-light, #e6e6e6);
		}

		/* The form host. Acts as the collapsible container around the
		   pict-section-form metacontroller's emitted markup. */
		.pict-flow-popup-layout-form-host {
			margin: 0 10px 8px;
			padding: 8px 10px;
			background: var(--pf-toolbar-bg, #fafafa);
			border: 1px solid var(--pf-button-border, #e0e0e0);
			border-radius: 6px;
			overflow: hidden;
			max-height: 600px;
			transition: max-height 0.22s ease, padding 0.22s ease,
			            margin 0.22s ease, border-color 0.22s ease, opacity 0.18s ease;
			opacity: 1;
		}
		.pict-flow-popup-layout-form-host[data-collapsed="true"] {
			max-height: 0;
			padding-top: 0;
			padding-bottom: 0;
			margin-top: 0;
			margin-bottom: 0;
			border-color: transparent;
			opacity: 0;
		}
		.pict-flow-popup-layout-form-host > div { width: 100%; }

		/* Form contents — make the auto-rendered sections look professional.
		   The section headings stay visible; the redundant per-section
		   "Group: Defaults" h3 is suppressed. */
		.pict-flow-popup-layout-form .pict-form-view {
			display: block;
		}
		.pict-flow-popup-layout-form .pict-form-section {
			margin: 0;
			padding: 0;
		}
		.pict-flow-popup-layout-form .pict-form-section h2 {
			font-size: 10px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			opacity: 0.6;
			margin: 8px 0 4px;
			padding: 0;
			border-bottom: 1px solid var(--pf-button-border, #e6e6e6);
			padding-bottom: 3px;
		}
		.pict-flow-popup-layout-form .pict-form-section:first-child h2,
		.pict-flow-popup-layout-form .pict-form-section h2:first-child {
			margin-top: 0;
		}
		/* Group headings ("Group: Defaults") are noise — every algorithm
		   has exactly one group right now. Hide them. */
		.pict-flow-popup-layout-form .pict-form-section h3 {
			display: none;
		}
		/* Each row of inputs lives in a flat <div> as alternating
		   <span>label</span><input> pairs. Lay them out in a balanced grid. */
		.pict-flow-popup-layout-form .pict-form-section > div > div {
			display: flex;
			flex-wrap: wrap;
			gap: 4px 14px;
			margin: 4px 0;
			align-items: center;
		}
		.pict-flow-popup-layout-form .pict-form-section span {
			font-size: 12px;
			color: var(--pf-text-primary, #2c3e50);
			line-height: 1.4;
			margin: 0;
		}
		.pict-flow-popup-layout-form input[type="number"],
		.pict-flow-popup-layout-form input[type="text"],
		.pict-flow-popup-layout-form select {
			width: 88px;
			padding: 2px 6px;
			border: 1px solid var(--pf-button-border, #ccc);
			border-radius: 3px;
			font-size: 12px;
			line-height: 1.3;
			background: #fff;
			color: var(--pf-text-primary, #2c3e50);
			margin-left: -8px; /* tighten gap between label and its input */
		}
		.pict-flow-popup-layout-form select {
			width: auto;
			min-width: 110px;
		}
		.pict-flow-popup-layout-form input[type="number"]:focus,
		.pict-flow-popup-layout-form input[type="text"]:focus,
		.pict-flow-popup-layout-form select:focus {
			outline: none;
			border-color: var(--pf-button-hover-border, #3498db);
			box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.15);
		}
		.pict-flow-popup-layout-form input[type="checkbox"] {
			margin: 0 4px 0 0;
		}
		`;
	}

	// ── Connections ────────────────────────────────────────────────────────
	/**
	 * CSS for connection paths: base, hover/selected states, hitarea, drag-connection.
	 * @returns {string}
	 */
	getConnectionCSS()
	{
		return /*css*/`
		/* Arrowhead markers use CSS-driven fills so they follow --pf-* tokens
		   (which in turn map to host --theme-color-* tokens). The polygon's
		   fill attribute is the fallback when CSS does not reach the marker. */
		.pict-flow-svg .pict-flow-arrowhead-default {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-selected {
			fill: var(--pf-connection-selected-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-tether {
			fill: var(--pf-connection-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-in {
			fill: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-event-out {
			fill: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-setting {
			fill: var(--pf-connection-setting-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-value {
			fill: var(--pf-connection-value-stroke);
		}
		.pict-flow-svg .pict-flow-arrowhead-error {
			fill: var(--pf-connection-error-stroke);
		}

		.pict-flow-connection {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 2;
			cursor: pointer;
			transition: stroke 0.15s;
		}
		.pict-flow-connection:hover {
			stroke: var(--pf-connection-stroke-hover);
			stroke-width: 3;
		}
		.pict-flow-connection.selected {
			stroke: var(--pf-connection-selected-stroke);
			stroke-width: 3;
		}
		/* Connection type color overrides (based on source port type) */
		.pict-flow-connection.conn-type-event-in {
			stroke: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-connection.conn-type-event-out {
			stroke: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-connection.conn-type-setting {
			stroke: var(--pf-connection-setting-stroke);
		}
		.pict-flow-connection.conn-type-value {
			stroke: var(--pf-connection-value-stroke);
		}
		.pict-flow-connection.conn-type-error {
			stroke: var(--pf-connection-error-stroke);
		}
		.pict-flow-connection-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 12;
			cursor: pointer;
		}
		.pict-flow-drag-connection {
			fill: none;
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			stroke-dasharray: 6 3;
			pointer-events: none;
		}
		`;
	}

	// ── Connection Handles ─────────────────────────────────────────────────
	/**
	 * CSS for connection waypoint handles and midpoint handles.
	 * @returns {string}
	 */
	getHandleCSS()
	{
		return /*css*/`
		.pict-flow-connection-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-connection-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Tethers ────────────────────────────────────────────────────────────
	/**
	 * CSS for tether lines, hitareas, handles, and midpoint handles.
	 * @returns {string}
	 */
	getTetherCSS()
	{
		return /*css*/`
		.pict-flow-tether-line {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 1.5;
			stroke-dasharray: 6 4;
			pointer-events: visibleStroke;
			cursor: pointer;
		}
		.pict-flow-tether-line.selected {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-tether-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 10;
			cursor: pointer;
		}
		.pict-flow-tether-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-tether-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Panels ─────────────────────────────────────────────────────────────
	/**
	 * CSS for property panels: foreign object, panel container, titlebar, close button, body, indicator.
	 * @returns {string}
	 */
	getPanelCSS()
	{
		return /*css*/`
		.pict-flow-node-panel-indicator {
			fill: var(--pf-node-selected-stroke);
			stroke: none;
			opacity: 0.6;
			cursor: pointer;
			transition: opacity 0.15s;
		}
		.pict-flow-node-panel-indicator:hover {
			opacity: 1.0;
		}
		.pict-flow-panel-foreign-object {
			overflow: visible;
		}
		.pict-flow-panel {
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-panel-border);
			border-radius: var(--pf-panel-radius);
			box-shadow: var(--pf-panel-shadow);
			display: flex;
			flex-direction: column;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}
		.pict-flow-panel-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 8px 12px;
			background: var(--pf-panel-titlebar-bg);
			border-bottom: 1px solid var(--pf-panel-titlebar-border);
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
			flex-shrink: 0;
		}
		.pict-flow-panel-titlebar.dragging {
			cursor: grabbing;
		}
		.pict-flow-panel-title-text {
			font-weight: 600;
			font-size: 12px;
			color: var(--pf-panel-title-color);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			letter-spacing: 0.1px;
		}
		.pict-flow-panel-close-btn {
			cursor: pointer;
			color: var(--pf-button-close-color);
			font-size: 14px;
			line-height: 1;
			padding: 4px;
			border: none;
			background: none;
			border-radius: 4px;
			transition: background-color 0.15s, color 0.15s;
		}
		.pict-flow-panel-close-btn:hover {
			color: var(--pf-button-danger-text);
			background-color: rgba(231, 76, 60, 0.08);
		}
		.pict-flow-panel-content {
			flex: 1;
			overflow-y: auto;
			min-height: 0;
			padding: 0;
		}
		.pict-flow-panel-tab-pane {
			padding: 10px 12px;
			box-sizing: border-box;
		}
		`;
	}

	// ── Info Panels ────────────────────────────────────────────────────────
	/**
	 * CSS for the info/hover panel and all sub-elements: header, description, badges, sections, ports.
	 * @returns {string}
	 */
	getInfoPanelCSS()
	{
		return /*css*/`
		.pict-flow-info-panel {
			padding: 2px 0;
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-info-panel-header {
			font-size: 13px;
			font-weight: 600;
			margin-bottom: 6px;
			color: var(--pf-text-heading);
		}
		.pict-flow-info-panel-header.with-icon {
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.pict-flow-info-panel-description {
			font-size: 11px;
			color: var(--pf-text-secondary);
			margin-bottom: 10px;
			line-height: 1.45;
		}
		.pict-flow-info-panel-badges {
			margin-bottom: 10px;
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
		}
		.pict-flow-info-panel-badge {
			display: inline-block;
			padding: 2px 8px;
			border-radius: 4px;
			font-size: 10px;
		}
		.pict-flow-info-panel-badge.category {
			background: var(--pf-badge-category-bg);
			color: var(--pf-badge-category-text);
		}
		.pict-flow-info-panel-badge.code {
			background: var(--pf-badge-code-bg);
			color: var(--pf-badge-code-text);
			font-family: "SF Mono", "Fira Code", monospace;
		}
		.pict-flow-info-panel-section {
			margin-bottom: 8px;
		}
		.pict-flow-info-panel-section-title {
			font-size: 10px;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--pf-text-tertiary);
			margin-bottom: 4px;
			padding-bottom: 2px;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-info-panel-port {
			padding: 3px 8px;
			background: var(--pf-port-item-bg);
			margin-bottom: 3px;
			font-size: 11px;
			border-radius: 3px;
		}
		.pict-flow-info-panel-port.input {
			border-left: 3px solid var(--pf-port-input-fill);
		}
		.pict-flow-info-panel-port.output {
			border-left: 3px solid var(--pf-port-output-fill);
		}
		/* Info panel port type color overrides */
		.pict-flow-info-panel-port.port-type-event-in {
			border-left-color: var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.port-type-event-out {
			border-left-color: var(--pf-port-event-out-fill);
		}
		.pict-flow-info-panel-port.port-type-setting {
			border-left-color: var(--pf-port-setting-fill);
		}
		.pict-flow-info-panel-port.port-type-value {
			border-left-color: var(--pf-port-value-fill);
		}
		.pict-flow-info-panel-port.port-type-error {
			border-left-color: var(--pf-port-error-fill);
		}
		.pict-flow-info-panel-port-constraint {
			color: var(--pf-text-tertiary);
			font-size: 10px;
		}
		/* Port summary section appended below form panels */
		.pict-flow-port-summary {
			margin-top: 12px;
			padding-top: 8px;
			border-top: 1px solid var(--pf-divider-medium);
		}
		.pict-flow-info-panel-port.event {
			border-left: 3px solid var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.value {
			border-left: 3px solid var(--pf-port-value-fill);
		}
		`;
	}

	// ── Node Properties Editor ────────────────────────────────────────────
	/**
	 * CSS for the node properties editor fields used in the Appearance tab.
	 * @returns {string}
	 */
	getNodePropsEditorCSS()
	{
		return /*css*/`
		.pict-flow-node-props-fields {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
		.pict-flow-node-props-field {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.pict-flow-node-props-label {
			font-size: 11px;
			color: var(--pf-text-secondary);
			min-width: 72px;
			flex-shrink: 0;
		}
		.pict-flow-node-props-input {
			flex: 1;
			padding: 3px 6px;
			border: 1px solid var(--pf-input-border);
			border-radius: 3px;
			font-size: 11px;
			outline: none;
			box-sizing: border-box;
			min-width: 0;
		}
		.pict-flow-node-props-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-node-props-color {
			width: 28px;
			height: 24px;
			padding: 1px;
			cursor: pointer;
			flex: 0 0 28px;
		}

		/* Suppress native number-input spinner buttons on every input
		   inside a properties panel. Panels live inside <foreignObject>;
		   browsers (Chromium / WebKit) render the up/down spinner chrome
		   as native overlays that don't always respect SVG transforms or
		   the parent tab pane's display:none — leaving stale spinner
		   artifacts hanging around when the user switches tabs or pans
		   the diagram. The user can still type numbers; they just don't
		   get clickable spinners. (If we ever want spinners back, build
		   them as real DOM elements next to the input, not native chrome.) */
		.pict-flow-panel input[type="number"] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
		.pict-flow-panel input[type="number"]::-webkit-outer-spin-button,
		.pict-flow-panel input[type="number"]::-webkit-inner-spin-button {
			-webkit-appearance: none;
			appearance: none;
			margin: 0;
		}
		`;
	}

	// ── Panel Tabs & Resize ───────────────────────────────────────────────
	/**
	 * CSS for the tab bar, tab panes, resize handle, and help content.
	 * @returns {string}
	 */
	getPanelTabsCSS()
	{
		return /*css*/`
		.pict-flow-panel-resize-handle {
			height: 6px;
			cursor: ns-resize;
			background: transparent;
			flex-shrink: 0;
			transition: background-color 0.15s;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-panel-resize-handle::after {
			content: '';
			width: 24px;
			height: 2px;
			border-radius: 1px;
			background: var(--pf-resize-handle-hover);
			transition: background-color 0.15s, width 0.15s;
		}
		.pict-flow-panel-resize-handle:hover::after {
			background: var(--pf-button-hover-border);
			width: 32px;
		}
		.pict-flow-panel-tabbar {
			display: flex;
			flex-shrink: 0;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			background: var(--pf-panel-titlebar-bg);
		}
		.pict-flow-panel-tab {
			flex: 1;
			padding: 5px 8px;
			font-size: 11px;
			text-align: center;
			cursor: pointer;
			color: var(--pf-tab-text);
			border-top: 2px solid transparent;
			transition: color 0.15s, border-top-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-panel-tab:hover {
			color: var(--pf-tab-text-hover);
		}
		.pict-flow-panel-tab.active {
			border-top-color: var(--pf-node-selected-stroke);
			color: var(--pf-panel-title-color);
			font-weight: 600;
		}
		.pict-flow-panel-help-content {
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-panel-help-content p {
			margin: 0 0 8px 0;
		}
		`;
	}

	// ── Fullscreen ─────────────────────────────────────────────────────────
	/**
	 * CSS for fullscreen mode.
	 * @returns {string}
	 */
	getFullscreenCSS()
	{
		return /*css*/`
		.pict-flow-fullscreen {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			z-index: 9999;
			border-radius: 0;
			border: none;
			min-height: 100vh;
		}
		.pict-flow-fullscreen .pict-flow-svg {
			min-height: calc(100vh - 50px);
		}
		`;
	}

	// ── Toolbar ────────────────────────────────────────────────────────────
	/**
	 * CSS for the toolbar: buttons, groups, labels, selects.
	 * @returns {string}
	 */
	getToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.5em 0.75em;
			background-color: var(--pf-toolbar-bg);
			border-bottom: 1px solid var(--pf-toolbar-border);
			flex-wrap: wrap;
		}
		.pict-flow-toolbar-group {
			display: flex;
			align-items: center;
			gap: 0.25em;
			padding-right: 0.75em;
			border-right: 1px solid var(--pf-toolbar-border);
		}
		.pict-flow-toolbar-group:last-child {
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: 0.35em;
			padding: 0.35em 0.65em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
			font-size: 0.85em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-toolbar-btn:focus {
			outline: none;
		}
		.pict-flow-toolbar-btn:hover {
			background-color: var(--pf-button-hover-bg);
			border-color: var(--pf-button-hover-border);
		}
		.pict-flow-toolbar-btn:active {
			background-color: var(--pf-button-active-bg);
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
		}
		.pict-flow-toolbar-btn-text {
			white-space: nowrap;
		}
		.pict-flow-toolbar-btn-chevron {
			display: inline-flex;
			align-items: center;
			margin-left: 0.15em;
		}
		/* Split button — visible as one connected unit; the two halves
		   route to different actions. Used for "Auto" so clicking the
		   icon/text applies the current layout while the chevron half
		   opens the algorithm popup with a generous hit area. */
		.pict-flow-toolbar-btn-split {
			display: inline-flex;
			align-items: stretch;
		}
		.pict-flow-toolbar-btn-split-main {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-right: 1px solid var(--pf-button-border);
			margin-right: -1px; /* collapse the seam between the two buttons */
		}
		.pict-flow-toolbar-btn-split-chevron {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			padding-left: 0.55em;
			padding-right: 0.55em;
		}
		.pict-flow-toolbar-btn-split-chevron .pict-flow-toolbar-btn-chevron {
			margin: 0;
		}
		.pict-flow-toolbar-right {
			margin-left: auto;
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-label {
			font-size: 0.8em;
			color: var(--pf-text-secondary);
			margin-right: 0.25em;
		}
		.pict-flow-toolbar-select {
			padding: 0.3em 0.5em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			font-size: 0.85em;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
		}
		`;
	}

	// ── Card Palette ───────────────────────────────────────────────────────
	/**
	 * CSS for the card palette: toggle, body, categories, cards, swatches.
	 * @returns {string}
	 */
	getPaletteCSS()
	{
		return /*css*/`
		.pict-flow-palette-category {
			margin-bottom: 0.5em;
		}
		.pict-flow-palette-category:last-child {
			margin-bottom: 0;
		}
		.pict-flow-palette-category-label {
			font-size: 0.7em;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--pf-text-placeholder);
			margin-bottom: 0.35em;
			padding-bottom: 0.2em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-palette-cards {
			display: flex;
			flex-wrap: wrap;
			gap: 0.35em;
		}
		.pict-flow-palette-card {
			display: inline-flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.6em;
			border: 1px solid var(--pf-card-border);
			border-radius: 4px;
			background-color: var(--pf-panel-bg);
			font-size: 0.8em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
			user-select: none;
			-webkit-user-select: none;
			position: relative;
		}
		.pict-flow-palette-card:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-node-selected-stroke);
			box-shadow: var(--pf-card-hover-shadow);
		}
		.pict-flow-palette-card.disabled {
			opacity: 0.45;
			pointer-events: none;
			cursor: default;
		}
		.pict-flow-palette-card-icon {
			font-size: 1.1em;
			line-height: 1;
		}
		.pict-flow-palette-card-swatch {
			width: 10px;
			height: 10px;
			border-radius: 2px;
			flex-shrink: 0;
		}
		.pict-flow-palette-card-title {
			font-weight: 500;
			color: var(--pf-text-primary);
			white-space: nowrap;
		}
		.pict-flow-palette-card-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
		}
		.pict-flow-toolbar-select.layout-select {
			min-width: 120px;
			max-width: 200px;
		}
		`;
	}

	// ── Popups ────────────────────────────────────────────────────────────
	/**
	 * CSS for toolbar dropdown popups (Add Node, Cards, Layout).
	 * @returns {string}
	 */
	getPopupCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-popup-anchor {
			position: relative;
		}
		.pict-flow-toolbar-popup {
			position: absolute;
			z-index: 1000;
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-card-border);
			border-radius: 6px;
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			min-width: 240px;
			max-height: 80vh;
			overflow-y: auto;
			padding: 0.35em 0;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
		}
		.pict-flow-popup-search-wrapper {
			position: relative;
			padding: 0.4em 0.5em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-popup-search-icon {
			position: absolute;
			left: 0.85em;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			line-height: 1;
			display: flex;
			align-items: center;
		}
		.pict-flow-popup-search {
			width: 100%;
			padding: 0.4em 0.5em 0.4em 2em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-search:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-list-item {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-list-item:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-list-item-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-list-item-label {
			flex: 1;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-list-item-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
			background: var(--pf-badge-category-bg);
			padding: 0.1em 0.4em;
			border-radius: 3px;
		}
		.pict-flow-popup-divider {
			height: 1px;
			background: var(--pf-divider-light);
			margin: 0.25em 0;
		}
		.pict-flow-popup-list-empty {
			text-align: center;
			color: var(--pf-text-placeholder);
			padding: 1.5em 0.75em;
			font-size: 0.9em;
		}
		.pict-flow-popup-layout-save {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-layout-save:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-save-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-input-row {
			display: flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.5em;
		}
		.pict-flow-popup-layout-save-input {
			flex: 1;
			padding: 0.35em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-layout-save-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-save-confirm {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			background: var(--pf-panel-bg);
			cursor: pointer;
			flex-shrink: 0;
			transition: background-color 0.15s, border-color 0.15s;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-confirm:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-row {
			display: flex;
			align-items: center;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-layout-row:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-name {
			flex: 1;
			color: var(--pf-text-primary);
		}
		.pict-flow-popup-layout-delete {
			display: none;
			align-items: center;
			justify-content: center;
			border: none;
			background: none;
			color: var(--pf-button-danger-text);
			cursor: pointer;
			padding: 2px 4px;
			border-radius: 3px;
			line-height: 1;
		}
		.pict-flow-popup-layout-row:hover .pict-flow-popup-layout-delete {
			display: inline-flex;
		}
		.pict-flow-popup-layout-delete:hover {
			background-color: var(--pf-button-danger-hover-bg);
		}
		.pict-flow-popup-settings-section {
			padding: 0.5em 0.75em;
		}
		.pict-flow-popup-settings-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--pf-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.35em;
		}
		.pict-flow-popup-settings-select {
			width: 100%;
			padding: 0.4em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			background: var(--pf-panel-bg);
			color: var(--pf-text-primary);
			cursor: pointer;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-settings-select:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-settings-slider-row {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.pict-flow-popup-settings-slider {
			flex: 1;
			-webkit-appearance: none;
			appearance: none;
			height: 4px;
			background: var(--pf-input-border);
			border-radius: 2px;
			outline: none;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-webkit-slider-thumb {
			-webkit-appearance: none;
			appearance: none;
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-moz-range-thumb {
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
			border: none;
		}
		.pict-flow-popup-settings-slider-value {
			font-size: 0.85em;
			color: var(--pf-text-secondary);
			min-width: 2.5em;
			text-align: right;
		}
		`;
	}

	// ── Collapsed Toolbar ─────────────────────────────────────────────────
	/**
	 * CSS for the collapsed toolbar state (small expand button in corner).
	 * @returns {string}
	 */
	getCollapsedToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-collapsed {
			position: absolute;
			top: 8px;
			right: 8px;
			z-index: 100;
			display: none;
		}
		.pict-flow-toolbar-collapsed.visible {
			display: block;
		}
		.pict-flow-toolbar-expand-btn {
			width: 36px;
			height: 36px;
			border-radius: 6px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 2px 6px rgba(0,0,0,0.1);
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, box-shadow 0.15s;
		}
		.pict-flow-toolbar-expand-btn:hover {
			background-color: var(--pf-button-hover-bg);
			box-shadow: 0 2px 8px rgba(0,0,0,0.15);
		}
		`;
	}

	// ── Floating Toolbar ──────────────────────────────────────────────────
	/**
	 * CSS for the floating draggable toolbar.
	 * @returns {string}
	 */
	getFloatingToolbarCSS()
	{
		return /*css*/`
		.pict-flow-floating-toolbar {
			position: absolute;
			z-index: 100;
			display: flex;
			flex-direction: column;
			gap: 2px;
			padding: 4px;
			border-radius: 8px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			pointer-events: auto;
		}
		.pict-flow-floating-grip {
			cursor: grab;
			padding: 4px;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-grip:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-grip:active {
			cursor: grabbing;
		}
		.pict-flow-floating-btn {
			width: 32px;
			height: 32px;
			border: none;
			border-radius: 4px;
			background-color: transparent;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-btn:focus {
			outline: none;
		}
		.pict-flow-floating-btn:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-separator {
			height: 1px;
			background-color: var(--pf-divider-light);
			margin: 2px 4px;
		}
		/* Collapsed floating toolbar — grip-only draggable square */
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-btn,
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-separator {
			display: none;
		}
		.pict-flow-floating-toolbar.collapsed {
			padding: 0;
			border-radius: 6px;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip {
			width: 32px;
			height: 32px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip span {
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		`;
	}

	// ── Icons ─────────────────────────────────────────────────────────────
	/**
	 * CSS for inline SVG icons in palette cards, toolbar buttons, info panel headers, and panel close buttons.
	 * @returns {string}
	 */
	getIconCSS()
	{
		return /*css*/`
		.pict-flow-icon-svg {
			pointer-events: none;
		}
		.pict-flow-palette-card-icon svg {
			display: inline-block;
			vertical-align: middle;
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
			vertical-align: middle;
		}
		.pict-flow-info-panel-header.with-icon svg {
			display: inline-block;
			vertical-align: middle;
			margin-right: 4px;
		}
		.pict-flow-panel-close-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-panel-close-icon svg {
			display: block;
		}
		.pict-flow-palette-toggle-arrow svg {
			display: block;
		}
		`;
	}

	// ── Bracket Node CSS ──────────────────────────────────────────────────
	/**
	 * CSS for bracket-style node bodies used by sketch/blueprint themes.
	 *
	 * The bracket fill rects share class `.pict-flow-node-body` for fill
	 * inheritance, so these rules must use parent-qualified selectors
	 * (specificity ≥ 0,2,0) to override the base, variant, hover, and
	 * selected rules that set stroke and rx/ry on `.pict-flow-node-body`.
	 *
	 * @returns {string}
	 */
	getBracketNodeCSS()
	{
		return /*css*/`
		/* Bracket outline path */
		.pict-flow-node-bracket {
			fill: none;
			stroke: var(--pf-node-body-stroke);
			stroke-width: 2;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-flow-node.selected .pict-flow-node-bracket {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node:hover .pict-flow-node-bracket {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}

		/* Bracket fill rects: no stroke, no rounded corners.
		   Uses parent-qualified selectors to beat variant rules
		   (e.g. .pict-flow-node-start .pict-flow-node-body). */
		.pict-flow-node .pict-flow-node-bracket-fill,
		.pict-flow-node .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
			rx: 0;
			ry: 0;
		}
		/* Beat hover rule: .pict-flow-node:hover .pict-flow-node-body */
		.pict-flow-node:hover .pict-flow-node-bracket-fill,
		.pict-flow-node:hover .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		/* Beat selected rule: .pict-flow-node.selected .pict-flow-node-body */
		.pict-flow-node.selected .pict-flow-node-bracket-fill,
		.pict-flow-node.selected .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		`;
	}

	// ── Aggregate Methods ──────────────────────────────────────────────────

	/**
	 * Concatenate all domain CSS getters into a single CSS string.
	 * Includes theme overrides if a theme provider is active.
	 * @returns {string}
	 */
	generateCSS()
	{
		let tmpBaseCSS = (
			this.getContainerCSS() +
			this.getNodeCSS() +
			this.getBodyContentCSS() +
			this.getNodeVariantCSS() +
			this.getPortCSS() +
			this.getConnectionCSS() +
			this.getHandleCSS() +
			this.getTetherCSS() +
			this.getPanelCSS() +
			this.getInfoPanelCSS() +
			this.getNodePropsEditorCSS() +
			this.getPanelTabsCSS() +
			this.getBracketNodeCSS() +
			this.getFullscreenCSS() +
			this.getToolbarCSS() +
			this.getPaletteCSS() +
			this.getPopupCSS() +
			this.getCollapsedToolbarCSS() +
			this.getFloatingToolbarCSS() +
			this.getIconCSS()
		);

		// Apply theme overrides if a theme provider exists
		if (this._FlowView && this._FlowView._ThemeProvider)
		{
			let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpTheme && tmpTheme.CSSVariables && Object.keys(tmpTheme.CSSVariables).length > 0)
			{
				let tmpOverrides = '.pict-flow-container {\n';
				for (let tmpKey in tmpTheme.CSSVariables)
				{
					tmpOverrides += '\t' + tmpKey + ': ' + tmpTheme.CSSVariables[tmpKey] + ';\n';
				}
				tmpOverrides += '}\n';
				tmpBaseCSS += tmpOverrides;
			}
			if (tmpTheme && tmpTheme.AdditionalCSS)
			{
				tmpBaseCSS += tmpTheme.AdditionalCSS;
			}
		}

		return tmpBaseCSS;
	}

	/**
	 * Register all flow CSS with pict's CSSMap service.
	 * Uses correct parameter ordering: (hash, content, priority, provider).
	 * Removes existing CSS first to allow theme re-registration,
	 * then re-injects into the DOM.
	 */
	registerCSS()
	{
		if (this.fable && this.fable.CSSMap)
		{
			// Remove existing CSS first so we can re-register with updated theme overrides
			this.fable.CSSMap.removeCSS('PictSectionFlow-CSS');
			this.fable.CSSMap.addCSS('PictSectionFlow-CSS', this.generateCSS(), 500, 'PictProviderFlowCSS');
			// Re-inject into the DOM to apply the updated CSS
			this.fable.CSSMap.injectCSS();
		}
		else
		{
			this.log.warn('PictProviderFlowCSS: CSSMap not available; CSS not registered.');
		}
	}
}

module.exports = PictProviderFlowCSS;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":6}],24:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class PictProviderFlowConnectorShapes extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowConnectorShapes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Default shape configurations — each keyed by a shape identifier
		// _OriginalShapes stores a deep copy for reset when switching themes.
		this._DefaultShapes =
		{
			'port':
			{
				ElementType: 'circle',
				Attributes: { r: '5' },
				ClassName: 'pict-flow-port'
			},
			'panel-indicator':
			{
				ElementType: 'rect',
				Attributes: { rx: '2', ry: '2' },
				ClassName: 'pict-flow-node-panel-indicator'
			},
			'connection-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection'
			},
			'connection-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection-hitarea'
			},
			'connection-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle'
			},
			'connection-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle-midpoint'
			},
			'drag-connection':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-drag-connection'
			},
			'tether-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-line'
			},
			'tether-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-hitarea'
			},
			'tether-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle'
			},
			'tether-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle-midpoint'
			},
			'arrowhead-connection':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: '#95a5a6'
			},
			'arrowhead-connection-selected':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: '#3498db'
			},
			'arrowhead-tether':
			{
				MarkerWidth: '4',
				MarkerHeight: '6',
				RefX: '6',
				RefY: '3',
				Points: '0 0, 4 3, 0 6',
				Fill: '#95a5a6'
			}
		};

		// Store a deep copy for resetting when switching themes
		this._OriginalShapes = JSON.parse(JSON.stringify(this._DefaultShapes));
	}

	// ── Theme Override Methods ─────────────────────────────────────────────

	/**
	 * Apply theme-specific shape overrides.
	 * Merges the overrides into the active shape configs.
	 * @param {Object} pOverrides - Map of shape key to partial config
	 */
	applyThemeOverrides(pOverrides)
	{
		if (!pOverrides || typeof pOverrides !== 'object')
		{
			return;
		}
		for (let tmpKey in pOverrides)
		{
			if (this._DefaultShapes.hasOwnProperty(tmpKey))
			{
				Object.assign(this._DefaultShapes[tmpKey], pOverrides[tmpKey]);
			}
			else
			{
				this._DefaultShapes[tmpKey] = pOverrides[tmpKey];
			}
		}
	}

	/**
	 * Reset all shape configs to their original defaults.
	 * Called before applying new theme overrides to prevent accumulation.
	 */
	resetToDefaults()
	{
		this._DefaultShapes = JSON.parse(JSON.stringify(this._OriginalShapes));
	}

	/**
	 * Get a shape configuration by key.
	 * @param {string} pShapeKey
	 * @returns {Object|null}
	 */
	getShapeConfig(pShapeKey)
	{
		if (this._DefaultShapes.hasOwnProperty(pShapeKey))
		{
			return this._DefaultShapes[pShapeKey];
		}
		return null;
	}

	/**
	 * Override or add a shape configuration.
	 * Consumers can call this to customize connector shapes without subclassing.
	 * @param {string} pShapeKey
	 * @param {Object} pConfig
	 */
	setShapeConfig(pShapeKey, pConfig)
	{
		this._DefaultShapes[pShapeKey] = pConfig;
	}

	/**
	 * Get all registered shape keys.
	 * @returns {string[]}
	 */
	getShapeKeys()
	{
		return Object.keys(this._DefaultShapes);
	}

	// ---- Factory Methods ----

	/**
	 * Create a port SVG element.
	 * @param {Object} pPortData - Port data with Hash, Direction
	 * @param {{x: number, y: number}} pPosition - Local position within the node group
	 * @param {string} pNodeHash - The owning node hash
	 * @returns {SVGCircleElement}
	 */
	createPortElement(pPortData, pPosition, pNodeHash)
	{
		let tmpConfig = this._DefaultShapes['port'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		let tmpClassName = tmpConfig.ClassName + ' ' + pPortData.Direction;
		if (pPortData.PortType)
		{
			tmpClassName += ' port-type-' + pPortData.PortType;
		}
		tmpElement.setAttribute('class', tmpClassName);
		tmpElement.setAttribute('cx', String(pPosition.x));
		tmpElement.setAttribute('cy', String(pPosition.y));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-port-hash', pPortData.Hash);
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-port-direction', pPortData.Direction);
		if (pPortData.PortType)
		{
			tmpElement.setAttribute('data-port-type', pPortData.PortType);
		}
		tmpElement.setAttribute('data-element-type', 'port');
		return tmpElement;
	}

	/**
	 * Create a panel indicator SVG element.
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @returns {SVGRectElement}
	 */
	createPanelIndicatorElement(pNodeHash, pX, pY, pWidth, pHeight)
	{
		let tmpConfig = this._DefaultShapes['panel-indicator'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('x', String(pX));
		tmpElement.setAttribute('y', String(pY));
		tmpElement.setAttribute('width', String(pWidth));
		tmpElement.setAttribute('height', String(pHeight));
		// Apply config attributes (rx, ry, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-element-type', 'panel-indicator');
		return tmpElement;
	}

	/**
	 * Create a visible connection path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createConnectionPathElement(pPath, pConnectionHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['connection-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection');

		// Arrow marker
		let tmpMarkerConfig = pIsSelected
			? this._DefaultShapes['arrowhead-connection-selected']
			: this._DefaultShapes['arrowhead-connection'];
		// The marker id follows the naming convention used in generateMarkerDefs
		let tmpMarkerId = pIsSelected
			? ('flow-arrowhead-selected-' + pViewIdentifier)
			: ('flow-arrowhead-' + pViewIdentifier);
		tmpElement.setAttribute('marker-end', 'url(#' + tmpMarkerId + ')');

		return tmpElement;
	}

	/**
	 * Create a connection hit area SVG element (wider invisible path for click targeting).
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @returns {SVGPathElement}
	 */
	createConnectionHitAreaElement(pPath, pConnectionHash)
	{
		let tmpConfig = this._DefaultShapes['connection-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection-hitarea');
		return tmpElement;
	}

	/**
	 * Create a drag handle circle element.
	 * Works for both connection handles and tether handles.
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - 'connection-handle', 'connection-handle-midpoint', 'tether-handle', 'tether-handle-midpoint'
	 * @returns {SVGCircleElement}
	 */
	createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey)
	{
		let tmpConfig = this._DefaultShapes[pShapeKey] || this._DefaultShapes['connection-handle'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('cx', String(pX));
		tmpElement.setAttribute('cy', String(pY));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-handle-type', pHandleType);
		return tmpElement;
	}

	/**
	 * Create a complete drag handle element with all data attributes set and
	 * append it to the given layer.  Unifies the handle-creation logic that
	 * was previously duplicated in ConnectionRenderer and TetherService.
	 *
	 * @param {SVGGElement} pLayer - The SVG group to append the handle to
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - Shape config key ('connection-handle', 'tether-handle-midpoint', etc.)
	 * @param {string} pElementType - data-element-type value ('connection-handle' or 'tether-handle')
	 * @param {string} pOwnerAttrName - data attribute name for the owner ('data-connection-hash' or 'data-panel-hash')
	 * @returns {SVGElement}
	 */
	createFullHandle(pLayer, pOwnerHash, pHandleType, pX, pY, pShapeKey, pElementType, pOwnerAttrName)
	{
		let tmpHandle = this.createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey);
		tmpHandle.setAttribute('data-element-type', pElementType);
		tmpHandle.setAttribute(pOwnerAttrName, pOwnerHash);
		pLayer.appendChild(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Create a temporary drag connection path element.
	 * @param {string} pPath - The SVG path d-string
	 * @returns {SVGPathElement}
	 */
	createDragConnectionElement(pPath)
	{
		let tmpConfig = this._DefaultShapes['drag-connection'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		return tmpElement;
	}

	/**
	 * Create a visible tether path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createTetherPathElement(pPath, pPanelHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['tether-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('marker-end', 'url(#flow-tether-arrowhead-' + pViewIdentifier + ')');
		tmpElement.setAttribute('data-element-type', 'tether');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Create a tether hit area SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @returns {SVGPathElement}
	 */
	createTetherHitAreaElement(pPath, pPanelHash)
	{
		let tmpConfig = this._DefaultShapes['tether-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-element-type', 'tether-hitarea');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Generate SVG marker definition markup for all arrowhead types.
	 * Returns raw SVG markup to be injected into the <defs> section.
	 * @param {string} pViewIdentifier
	 * @returns {string}
	 */
	generateMarkerDefs(pViewIdentifier)
	{
		let tmpConnectionMarker = this._DefaultShapes['arrowhead-connection'];
		let tmpSelectedMarker = this._DefaultShapes['arrowhead-connection-selected'];
		let tmpTetherMarker = this._DefaultShapes['arrowhead-tether'];

		let tmpMarkup = '';

		// Normal connection arrowhead — class-driven fill so the host theme's
		// --theme-color-* tokens (mapped to --pf-connection-stroke etc. in
		// PictProvider-Flow-CSS) flow through automatically. The polygon's
		// `fill` attribute is kept as a fallback for environments that
		// ignore CSS rules on marker children.
		tmpMarkup += '<marker id="flow-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
			+ ' refX="' + tmpConnectionMarker.RefX + '"'
			+ ' refY="' + tmpConnectionMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-default" points="' + tmpConnectionMarker.Points + '" fill="' + tmpConnectionMarker.Fill + '" />'
			+ '</marker>';

		// Per-port-type connection arrowheads
		let tmpPortTypeColors =
		{
			'event-in': '#3498db',
			'event-out': '#2ecc71',
			'setting': '#e67e22',
			'value': '#f1c40f',
			'error': '#e74c3c'
		};

		for (let tmpType in tmpPortTypeColors)
		{
			tmpMarkup += '<marker id="flow-arrowhead-' + tmpType + '-' + pViewIdentifier + '"'
				+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
				+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
				+ ' refX="' + tmpConnectionMarker.RefX + '"'
				+ ' refY="' + tmpConnectionMarker.RefY + '"'
				+ ' orient="auto" markerUnits="strokeWidth">'
				+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-' + tmpType + '" points="' + tmpConnectionMarker.Points + '" fill="' + tmpPortTypeColors[tmpType] + '" />'
				+ '</marker>';
		}

		// Selected connection arrowhead
		tmpMarkup += '<marker id="flow-arrowhead-selected-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpSelectedMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpSelectedMarker.MarkerHeight + '"'
			+ ' refX="' + tmpSelectedMarker.RefX + '"'
			+ ' refY="' + tmpSelectedMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-selected" points="' + tmpSelectedMarker.Points + '" fill="' + tmpSelectedMarker.Fill + '" />'
			+ '</marker>';

		// Tether arrowhead
		tmpMarkup += '<marker id="flow-tether-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpTetherMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpTetherMarker.MarkerHeight + '"'
			+ ' refX="' + tmpTetherMarker.RefX + '"'
			+ ' refY="' + tmpTetherMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon class="pict-flow-arrowhead pict-flow-arrowhead-tether" points="' + tmpTetherMarker.Points + '" fill="' + tmpTetherMarker.Fill + '" />'
			+ '</marker>';

		return tmpMarkup;
	}
}

module.exports = PictProviderFlowConnectorShapes;

},{"fable-serviceproviderbase":6}],25:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowEventHandler'
};

/**
 * Event handler provider for the flow diagram.
 * Provides hook points for extensibility - consumers can register handlers
 * for flow events like node selection, movement, connection creation, etc.
 *
 * Supported events:
 * - onNodeSelected(node)              - A node was selected (or null for deselection)
 * - onNodeAdded(node)                 - A new node was added
 * - onNodeRemoved(node)               - A node was removed
 * - onNodeMoved(node)                 - A node was moved to a new position
 * - onConnectionSelected(conn)        - A connection was selected
 * - onConnectionCreated(conn)         - A new connection was created
 * - onConnectionRemoved(conn)         - A connection was removed
 * - onConnectionHandleMoved(conn)     - A connection's drag handle was repositioned
 * - onConnectionModeChanged(conn)     - A connection's line mode was toggled (bezier/orthogonal)
 * - onPanelOpened(panelData)          - A properties panel was opened
 * - onPanelClosed(panelData)          - A properties panel was closed
 * - onPanelMoved(panelData)           - A properties panel was moved
 * - onTetherSelected(panelData)       - A tether line was selected (or null for deselection)
 * - onTetherHandleMoved(panelData)    - A tether's drag handle was repositioned
 * - onTetherModeChanged(panelData)    - A tether's line mode was toggled (bezier/orthogonal)
 * - onLayoutSaved(layoutData)         - A layout snapshot was saved
 * - onLayoutRestored(layoutData)      - A saved layout was restored
 * - onLayoutDeleted(layoutData)       - A saved layout was deleted
 * - onFlowChanged(flowData)           - The flow data changed (catch-all)
 */
class PictProviderFlowEventHandler extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowEventHandler';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Event handler registry
		this._Handlers = {};
	}

	/**
	 * Register an event handler
	 * @param {string} pEventName - The event name (e.g., 'onNodeSelected')
	 * @param {Function} pHandler - The handler function
	 * @param {string} [pHandlerHash] - Optional unique identifier for this handler (for later removal)
	 * @returns {string} The handler hash
	 */
	registerHandler(pEventName, pHandler, pHandlerHash)
	{
		if (typeof pHandler !== 'function')
		{
			this.log.warn(`PictProviderFlowEventHandler registerHandler: handler for '${pEventName}' is not a function`);
			return null;
		}

		if (!this._Handlers[pEventName])
		{
			this._Handlers[pEventName] = [];
		}

		let tmpHash = pHandlerHash || `handler-${this.fable.getUUID()}`;

		this._Handlers[pEventName].push({
			Hash: tmpHash,
			Handler: pHandler
		});

		this.log.trace(`PictProviderFlowEventHandler registered handler '${tmpHash}' for event '${pEventName}'`);

		return tmpHash;
	}

	/**
	 * Remove a specific event handler
	 * @param {string} pEventName - The event name
	 * @param {string} pHandlerHash - The handler hash to remove
	 * @returns {boolean}
	 */
	removeHandler(pEventName, pHandlerHash)
	{
		if (!this._Handlers[pEventName]) return false;

		let tmpIndex = this._Handlers[pEventName].findIndex((pH) => pH.Hash === pHandlerHash);
		if (tmpIndex >= 0)
		{
			this._Handlers[pEventName].splice(tmpIndex, 1);
			return true;
		}

		return false;
	}

	/**
	 * Remove all handlers for a specific event
	 * @param {string} pEventName
	 */
	removeAllHandlers(pEventName)
	{
		if (pEventName)
		{
			this._Handlers[pEventName] = [];
		}
		else
		{
			this._Handlers = {};
		}
	}

	/**
	 * Fire an event, calling all registered handlers
	 * @param {string} pEventName - The event name
	 * @param {*} pEventData - The event data to pass to handlers
	 */
	fireEvent(pEventName, pEventData)
	{
		this.log.trace(`PictProviderFlowEventHandler firing event '${pEventName}'`);

		if (!this._Handlers[pEventName] || this._Handlers[pEventName].length === 0)
		{
			return;
		}

		for (let i = 0; i < this._Handlers[pEventName].length; i++)
		{
			let tmpEntry = this._Handlers[pEventName][i];
			try
			{
				tmpEntry.Handler(pEventData, this._FlowView);
			}
			catch (pError)
			{
				this.log.error(`PictProviderFlowEventHandler error in handler '${tmpEntry.Hash}' for event '${pEventName}': ${pError.message}`);
			}
		}
	}

	/**
	 * Check if any handlers are registered for a specific event
	 * @param {string} pEventName
	 * @returns {boolean}
	 */
	hasHandlers(pEventName)
	{
		return !!(this._Handlers[pEventName] && this._Handlers[pEventName].length > 0);
	}

	/**
	 * Get the count of handlers for a specific event
	 * @param {string} pEventName
	 * @returns {number}
	 */
	getHandlerCount(pEventName)
	{
		if (!this._Handlers[pEventName]) return 0;
		return this._Handlers[pEventName].length;
	}
}

module.exports = PictProviderFlowEventHandler;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":15}],26:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Geometry
 *
 * Shared geometry utilities for the flow diagram.
 * Provides direction vectors and edge center calculations used by
 * connections, tethers, and other flow components.
 *
 * Port Side values (12 positions):
 *
 *   Top edge:    'top-left'     'top'     'top-right'
 *   Left edge:   'left-top'     'left'    'left-bottom'
 *   Right edge:  'right-top'    'right'   'right-bottom'
 *   Bottom edge: 'bottom-left'  'bottom'  'bottom-right'
 *
 * The old 4-value sides ('left', 'right', 'top', 'bottom') map to
 * the middle position on each edge for backward compatibility.
 */
class PictProviderFlowGeometry extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowGeometry';
	}

	/**
	 * Extract the edge name from a Side value.
	 *
	 * Maps all 12 positions (and the 4 legacy values) back to
	 * the edge they sit on: 'left', 'right', 'top', or 'bottom'.
	 *
	 * @param {string} pSide - Any valid Side value
	 * @returns {string} The edge: 'left', 'right', 'top', or 'bottom'
	 */
	getEdgeFromSide(pSide)
	{
		switch (pSide)
		{
			case 'left-top':
			case 'left':
			case 'left-bottom':
				return 'left';

			case 'right-top':
			case 'right':
			case 'right-bottom':
				return 'right';

			case 'top-left':
			case 'top':
			case 'top-right':
				return 'top';

			case 'bottom-left':
			case 'bottom':
			case 'bottom-right':
				return 'bottom';

			default:
				return 'right';
		}
	}

	/**
	 * Get the outward unit direction vector for a given side.
	 *
	 * All positions on the same edge share the same direction vector.
	 *
	 * @param {string} pSide - Any valid Side value (12 positions or 4 legacy)
	 * @returns {{dx: number, dy: number}}
	 */
	sideDirection(pSide)
	{
		switch (this.getEdgeFromSide(pSide))
		{
			case 'left':   return { dx: -1, dy: 0 };
			case 'right':  return { dx: 1, dy: 0 };
			case 'top':    return { dx: 0, dy: -1 };
			case 'bottom': return { dx: 0, dy: 1 };
			default:       return { dx: 1, dy: 0 };
		}
	}

	/**
	 * Get the center point of a rectangle's edge.
	 * Works for any object with X, Y, Width, Height properties
	 * (nodes, panels, or any rectangular element).
	 *
	 * @param {Object} pRectData - Object with X, Y, Width, Height
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom'
	 * @returns {{x: number, y: number}}
	 */
	getEdgeCenter(pRectData, pSide)
	{
		switch (pSide)
		{
			case 'left':
				return { x: pRectData.X, y: pRectData.Y + pRectData.Height / 2 };
			case 'right':
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
			case 'top':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y };
			case 'bottom':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y + pRectData.Height };
			default:
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
		}
	}

	/**
	 * Calculate a port's local position relative to node origin.
	 *
	 * Supports 12 positions (3 zones per edge).  For left/right edges,
	 * the body area below the title bar is divided into vertical zones.
	 * For top/bottom edges, the full width is divided into horizontal zones.
	 *
	 * When pPortCountsBySide is provided, zone fractions are computed
	 * proportionally based on actual port counts (adaptive zones).
	 * Otherwise, fixed 1/3 zones are used for backward compatibility.
	 *
	 * Multiple ports sharing the same Side value distribute evenly within
	 * their zone.
	 *
	 * @param {string} pSide - Side value (any of 12 positions or 4 legacy)
	 * @param {number} pIndex - Index of this port within its Side group
	 * @param {number} pTotal - Total ports with this Side value
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pTitleBarHeight - Height of the node title bar
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → port count
	 *        for all ports on the node.  Enables adaptive zone sizing.
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZone = pPortCountsBySide
			? this._computeAdaptiveZone(pSide, pPortCountsBySide)
			: this._getZoneFromSide(pSide);

		// Use the fixed zone to decide alignment intent (start/center/end)
		// because adaptive zones shift boundaries when neighbouring zones
		// are empty, which would break alignment decisions.
		let tmpFixedZone = this._getZoneFromSide(pSide);

		// Minimum spacing between port centers (px)
		let tmpMinSpacing = 16;

		// Reserve space at the bottom of the body so that port badges
		// never overlap the panel-indicator icon (10×10 rect at bottom-right)
		// and always leave a visible gap above the node bottom edge.
		let tmpBottomPad = 16;

		// Determine alignment from the fixed zone position:
		//   start zone  (0.000 – 0.333) → start-align (offset 0)
		//   middle zone (0.333 – 0.667) → center
		//   end zone    (0.667 – 1.000) → end-align
		let tmpAlignment = 'start';
		if (tmpFixedZone.start >= 0.5)
		{
			tmpAlignment = 'end';
		}
		else if (tmpFixedZone.start >= 0.17)
		{
			tmpAlignment = 'center';
		}

		if (tmpEdge === 'left' || tmpEdge === 'right')
		{
			let tmpX = (tmpEdge === 'left') ? 0 : pWidth;
			let tmpBodyHeight = pHeight - pTitleBarHeight - tmpBottomPad;
			let tmpZoneStart = pTitleBarHeight + tmpBodyHeight * tmpZone.start;
			let tmpZoneHeight = tmpBodyHeight * (tmpZone.end - tmpZone.start);

			// Use fixed spacing so port gaps stay consistent across cards
			// even when one edge drives the card height beyond what the
			// other needs.
			let tmpSpacing = tmpMinSpacing;
			let tmpGroupHeight = tmpSpacing * (pTotal + 1);
			let tmpSlack = tmpZoneHeight - tmpGroupHeight;
			if (tmpSlack < 0)
			{
				tmpSlack = 0;
			}

			let tmpAlignOffset = 0;
			if (tmpAlignment === 'end')
			{
				tmpAlignOffset = tmpSlack;
			}
			else if (tmpAlignment === 'center')
			{
				tmpAlignOffset = tmpSlack / 2;
			}

			let tmpY = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
			return { x: tmpX, y: tmpY };
		}

		// top or bottom
		let tmpY = (tmpEdge === 'top') ? 0 : pHeight;
		let tmpZoneStart = pWidth * tmpZone.start;
		let tmpZoneWidth = pWidth * (tmpZone.end - tmpZone.start);

		let tmpSpacing = tmpMinSpacing;
		let tmpGroupWidth = tmpSpacing * (pTotal + 1);
		let tmpSlack = tmpZoneWidth - tmpGroupWidth;
		if (tmpSlack < 0)
		{
			tmpSlack = 0;
		}

		let tmpAlignOffset = 0;
		if (tmpAlignment === 'end')
		{
			tmpAlignOffset = tmpSlack;
		}
		else if (tmpAlignment === 'center')
		{
			tmpAlignOffset = tmpSlack / 2;
		}

		let tmpX = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
		return { x: tmpX, y: tmpY };
	}

	/**
	 * Get the zone fraction (start, end) for a Side value.
	 *
	 * Each edge is divided into three zones of equal size:
	 *   start:  0.0 — 0.333
	 *   middle: 0.333 — 0.667
	 *   end:    0.667 — 1.0
	 *
	 * Used as fallback when adaptive zones are not available.
	 *
	 * @param {string} pSide
	 * @returns {{start: number, end: number}}
	 */
	_getZoneFromSide(pSide)
	{
		switch (pSide)
		{
			// Left edge: top, middle, bottom
			case 'left-top':     return { start: 0.0,   end: 0.333 };
			case 'left':         return { start: 0.333, end: 0.667 };
			case 'left-bottom':  return { start: 0.667, end: 1.0 };

			// Right edge: top, middle, bottom
			case 'right-top':    return { start: 0.0,   end: 0.333 };
			case 'right':        return { start: 0.333, end: 0.667 };
			case 'right-bottom': return { start: 0.667, end: 1.0 };

			// Top edge: left, middle, right
			case 'top-left':     return { start: 0.0,   end: 0.333 };
			case 'top':          return { start: 0.333, end: 0.667 };
			case 'top-right':    return { start: 0.667, end: 1.0 };

			// Bottom edge: left, middle, right
			case 'bottom-left':  return { start: 0.0,   end: 0.333 };
			case 'bottom':       return { start: 0.333, end: 0.667 };
			case 'bottom-right': return { start: 0.667, end: 1.0 };

			// Fallback: full range (legacy behavior)
			default:             return { start: 0.0,   end: 1.0 };
		}
	}

	/**
	 * Get the three zone Side keys for a given edge, in order.
	 *
	 * @param {string} pEdge - 'left', 'right', 'top', or 'bottom'
	 * @returns {Array<string>} Three Side keys in start-to-end order
	 */
	_getZoneKeysForEdge(pEdge)
	{
		switch (pEdge)
		{
			case 'left':   return ['left-top', 'left', 'left-bottom'];
			case 'right':  return ['right-top', 'right', 'right-bottom'];
			case 'top':    return ['top-left', 'top', 'top-right'];
			case 'bottom': return ['bottom-left', 'bottom', 'bottom-right'];
			default:       return ['right-top', 'right', 'right-bottom'];
		}
	}

	/**
	 * Compute an adaptive zone fraction for a Side value based on the
	 * actual port distribution across all zones on the same edge.
	 *
	 * Instead of fixed 1/3 splits, zones are sized proportionally to the
	 * space each zone needs (minSpacing * (portCount + 1)).  Zones with
	 * zero ports collapse to zero, giving occupied zones more room.
	 *
	 * @param {string} pSide - The Side value to compute a zone for
	 * @param {Object} pPortCountsBySide - Map of Side → number of ports
	 * @returns {{start: number, end: number}}
	 */
	_computeAdaptiveZone(pSide, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZoneKeys = this._getZoneKeysForEdge(tmpEdge);

		let tmpMinSpacing = 16;

		// Compute the space each zone needs: minSpacing * (count + 1)
		// The +1 provides padding at both ends of the zone.
		let tmpTotalSpace = 0;
		let tmpSpaceByZone = {};
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpCount = pPortCountsBySide[tmpKey] || 0;
			let tmpSpace = (tmpCount > 0) ? (tmpMinSpacing * (tmpCount + 1)) : 0;
			tmpSpaceByZone[tmpKey] = tmpSpace;
			tmpTotalSpace += tmpSpace;
		}

		// If no ports on this edge at all, fall back to fixed zones
		if (tmpTotalSpace === 0)
		{
			return this._getZoneFromSide(pSide);
		}

		// Compute proportional start/end for the requested zone
		let tmpCumulativeStart = 0;
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpFraction = tmpSpaceByZone[tmpKey] / tmpTotalSpace;
			if (tmpKey === pSide)
			{
				return { start: tmpCumulativeStart, end: tmpCumulativeStart + tmpFraction };
			}
			tmpCumulativeStart += tmpFraction;
		}

		// Should not reach here; fall back to fixed zones
		return this._getZoneFromSide(pSide);
	}

	/**
	 * Build a map of Side → port count from an array of port objects.
	 *
	 * Convenience method for callers that need to pass port counts
	 * to getPortLocalPosition or computeMinimumNodeHeight.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @returns {Object} Map of Side value → count
	 */
	buildPortCountsBySide(pPorts)
	{
		let tmpCounts = {};
		if (!pPorts || !Array.isArray(pPorts))
		{
			return tmpCounts;
		}
		for (let i = 0; i < pPorts.length; i++)
		{
			let tmpSide = pPorts[i].Side || (pPorts[i].Direction === 'input' ? 'left' : 'right');
			if (!tmpCounts[tmpSide])
			{
				tmpCounts[tmpSide] = 0;
			}
			tmpCounts[tmpSide]++;
		}
		return tmpCounts;
	}

	/**
	 * Compute the minimum node height required so that all ports
	 * (with their badges) fit within the node boundary.
	 *
	 * Uses adaptive zone sizing: instead of assuming each zone gets
	 * a fixed 1/3 of the body, sums the space needed by all occupied
	 * zones on each left/right edge.  This produces compact cards
	 * whose height scales linearly with total port count.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @param {number} pTitleBarHeight - Height of the title bar
	 * @returns {number} Minimum node height in pixels (0 if no ports)
	 */
	computeMinimumNodeHeight(pPorts, pTitleBarHeight)
	{
		if (!pPorts || !Array.isArray(pPorts) || pPorts.length === 0)
		{
			return 0;
		}

		let tmpMinSpacing = 16;
		let tmpBottomPad = 16;

		// Count ports per Side value
		let tmpCountBySide = this.buildPortCountsBySide(pPorts);

		// Sum the space needed per edge (left, right) across all zones.
		// Each zone needs minSpacing * (count + 1) pixels.
		let tmpSpacePerEdge = {};
		for (let tmpSide in tmpCountBySide)
		{
			let tmpEdge = this.getEdgeFromSide(tmpSide);

			// Only left/right edge zones affect required height
			if (tmpEdge !== 'left' && tmpEdge !== 'right')
			{
				continue;
			}

			let tmpCount = tmpCountBySide[tmpSide];
			let tmpZoneSpace = tmpMinSpacing * (tmpCount + 1);

			if (!tmpSpacePerEdge[tmpEdge])
			{
				tmpSpacePerEdge[tmpEdge] = 0;
			}
			tmpSpacePerEdge[tmpEdge] += tmpZoneSpace;
		}

		// The minimum height is titleBar + bottomPad + max edge space
		let tmpMinHeight = 0;
		for (let tmpEdge in tmpSpacePerEdge)
		{
			let tmpRequired = pTitleBarHeight + tmpBottomPad + tmpSpacePerEdge[tmpEdge];
			if (tmpRequired > tmpMinHeight)
			{
				tmpMinHeight = tmpRequired;
			}
		}

		return Math.ceil(tmpMinHeight);
	}
}

module.exports = PictProviderFlowGeometry;

},{"fable-serviceproviderbase":6}],27:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Icons
 *
 * Centralized SVG icon provider for the flow diagram.
 * All icons use a duotone style: 2px outline (#2c3e50) with
 * subtle filled accent shapes (#d5e8f7).
 *
 * Each icon is registered as a pict template with hash `Flow-Icon-{key}`,
 * making them individually overridable by consumers.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowIcons'
};

// ── Default Icon SVG Markup ────────────────────────────────────────────────
// All icons: viewBox="0 0 24 24", duotone style
// Accent fill: #d5e8f7, Stroke: #2c3e50, Stroke-width: 2
//
// The {FlowIconSize} placeholder is replaced at render time with the
// requested pixel size. Each template is a self-contained <svg> element.

const _DefaultIcons =
{
	// ── FlowCard Icons ─────────────────────────────────────────────────────

	'ITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="6" cy="18" r="2.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="18" cy="18" r="2.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 9v2M9.5 12.5L6 15.5M14.5 12.5L18 15.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'SW': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M3 12h5M16 12h5M14.8 9.2l3.7-5.2M14.8 14.8l3.7 5.2" stroke="#2c3e50" stroke-width="2"/></svg>',

	'EACH': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="3" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="3" y="14" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="14" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/></svg>',

	'FREAD': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M13 2v7h7" stroke="#2c3e50" stroke-width="2"/><path d="M9 13h6M9 17h4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'FWRITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M13 2v7h7" stroke="#2c3e50" stroke-width="2"/><path d="M12 13v5M9.5 15.5L12 13l2.5 2.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'LOG': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="7.5" cy="8" r="1" fill="#2c3e50"/><circle cx="7.5" cy="12" r="1" fill="#2c3e50"/><circle cx="7.5" cy="16" r="1" fill="#2c3e50"/><path d="M11 8h5.5M11 12h5.5M11 16h3.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'GET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-5.15-5.15" stroke="#2c3e50" stroke-width="2"/></svg>',

	'SET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4.5 1.5L4 16Z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M14 6l3 3" stroke="#2c3e50" stroke-width="2"/></svg>',

	// ── UI Icons ───────────────────────────────────────────────────────────

	'fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>',

	'exit-fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h6v6"/><path d="M20 10h-6V4"/><path d="M14 10l7-7"/><path d="M3 21l7-7"/></svg>',

	'close': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',

	'chevron-down': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',

	// ── Toolbar & Popup Icons ─────────────────────────────────────────────

	'search': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/></svg>',

	'cards': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="12" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M6 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2" stroke="#2c3e50" stroke-width="2"/></svg>',

	'layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="10" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="13" y="3" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="3" y="15" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="13" y="11" width="8" height="10" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/></svg>',

	'collapse': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'expand': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'grip': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="#2c3e50"><circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>',

	'settings': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" fill="#d5e8f7"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',

	'plus': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'trash': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="#2c3e50" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#2c3e50" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'save': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M17 21v-8H7v8" stroke="#2c3e50" stroke-width="2"/><path d="M7 3v5h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'auto-layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="2" y="16" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="16" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v4M6 16v-4h12v4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-in': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/><path d="M11 8v6M8 11h6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-out': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/><path d="M8 11h6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-fit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V3h4"/><path d="M17 3h4v4"/><path d="M21 17v4h-4"/><path d="M7 21H3v-4"/><rect x="7" y="7" width="10" height="10" rx="1.5" fill="#d5e8f7"/></svg>',

	'dock': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="4" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 20V11M8 14l4-4 4 4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'restore': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',

	'delete-node': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="#2c3e50" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#2c3e50" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="#2c3e50" stroke-width="2"/></svg>',

	// ── Fallback ───────────────────────────────────────────────────────────

	'default': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="12" cy="12" r="2.5" fill="#2c3e50"/></svg>'
};

class PictProviderFlowIcons extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowIcons';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Deep copy the default icons
		this._Icons = JSON.parse(JSON.stringify(_DefaultIcons));

		// Merge any additional icons passed via options
		if (pOptions && pOptions.AdditionalIcons && typeof pOptions.AdditionalIcons === 'object')
		{
			let tmpKeys = Object.keys(pOptions.AdditionalIcons);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				this._Icons[tmpKeys[i]] = pOptions.AdditionalIcons[tmpKeys[i]];
			}
		}
	}

	/**
	 * Register all icons as pict templates with hash Flow-Icon-{key}.
	 * Consumers can override any icon by registering a template with
	 * the same hash before the flow view renders.
	 */
	registerIconTemplates()
	{
		if (!this.fable || !this.fable.TemplateProvider)
		{
			this.log.warn('PictProviderFlowIcons: TemplateProvider not available; icon templates not registered.');
			return;
		}

		let tmpKeys = Object.keys(this._Icons);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpHash = 'Flow-Icon-' + tmpKeys[i];

			// Only register if not already present (allow consumer overrides)
			if (!this.fable.TemplateProvider.getTemplate(tmpHash))
			{
				this.fable.TemplateProvider.addTemplate(tmpHash, this._Icons[tmpKeys[i]]);
			}
		}
	}

	/**
	 * Determine if the given icon string is an emoji (legacy) or an icon key.
	 * Returns true if the string contains characters with code points above U+00FF,
	 * indicating emoji or Unicode symbol characters.
	 *
	 * @param {string} pIconValue - The icon value to check
	 * @returns {boolean}
	 */
	isEmojiIcon(pIconValue)
	{
		if (!pIconValue || typeof pIconValue !== 'string')
		{
			return false;
		}

		for (let i = 0; i < pIconValue.length; i++)
		{
			if (pIconValue.charCodeAt(i) > 255)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Resolve the icon key to use for a given CardMetadata object.
	 * Tries Icon field first, then Code field, then falls back to 'default'.
	 *
	 * @param {Object} pCardMetadata - The CardMetadata object
	 * @returns {string} The icon key
	 */
	resolveIconKey(pCardMetadata)
	{
		if (!pCardMetadata)
		{
			return 'default';
		}

		// If Icon is a known key, use it
		if (pCardMetadata.Icon && this._Icons.hasOwnProperty(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// If Icon is a non-emoji string, check if it matches a registered template
		if (pCardMetadata.Icon && !this.isEmojiIcon(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// Fall back to Code field
		if (pCardMetadata.Code && this._Icons.hasOwnProperty(pCardMetadata.Code))
		{
			return pCardMetadata.Code;
		}

		return 'default';
	}

	/**
	 * Get the raw SVG markup string for a given icon key, with size applied.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {string} The SVG markup string
	 */
	getIconSVGMarkup(pIconKey, pSize)
	{
		let tmpSize = pSize || 16;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace the size placeholder
		return tmpMarkup.replace(/\{FlowIconSize\}/g, String(tmpSize));
	}

	/**
	 * Render an icon into an SVG canvas context using createElementNS.
	 * Creates a <g> element containing the icon paths, positioned at (pX, pY)
	 * with the given size via a scale transform.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {SVGElement} pParentGroup - The parent SVG group to append to
	 * @param {number} pX - X position (top-left of icon bounding box)
	 * @param {number} pY - Y position (top-left of icon bounding box)
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {SVGGElement|null} The created group element, or null on failure
	 */
	renderIconIntoSVGGroup(pIconKey, pParentGroup, pX, pY, pSize)
	{
		if (!pParentGroup)
		{
			return null;
		}

		let tmpSize = pSize || 16;
		let tmpScale = tmpSize / 24;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace size placeholder (for consistency, though we scale via transform)
		tmpMarkup = tmpMarkup.replace(/\{FlowIconSize\}/g, '24');

		try
		{
			// Create a temporary SVG element to parse the icon markup
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpMarkup;

			// Find the inner SVG (the icon's root <svg> element)
			let tmpInnerSVG = tmpTempSVG.querySelector('svg');
			if (!tmpInnerSVG)
			{
				return null;
			}

			// Create a group to hold the icon content
			let tmpGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			tmpGroup.setAttribute('transform', 'translate(' + pX + ',' + pY + ') scale(' + tmpScale + ')');
			tmpGroup.setAttribute('pointer-events', 'none');
			tmpGroup.setAttribute('class', 'pict-flow-icon-svg');

			// Move all children from the parsed SVG into the group
			while (tmpInnerSVG.childNodes.length > 0)
			{
				tmpGroup.appendChild(tmpInnerSVG.childNodes[0]);
			}

			pParentGroup.appendChild(tmpGroup);
			return tmpGroup;
		}
		catch (pError)
		{
			this.log.warn('PictProviderFlowIcons renderIconIntoSVGGroup error: ' + pError.message);
			return null;
		}
	}

	/**
	 * Get all registered icon keys.
	 * @returns {Array<string>}
	 */
	getIconKeys()
	{
		return Object.keys(this._Icons);
	}

	/**
	 * Check if a given key has a registered icon.
	 * @param {string} pIconKey
	 * @returns {boolean}
	 */
	hasIcon(pIconKey)
	{
		return this._Icons.hasOwnProperty(pIconKey);
	}

	/**
	 * Register a new icon or override an existing one.
	 * @param {string} pIconKey - The icon key
	 * @param {string} pSVGMarkup - The SVG markup string (must contain {FlowIconSize} placeholders)
	 * @returns {boolean}
	 */
	registerIcon(pIconKey, pSVGMarkup)
	{
		if (!pIconKey || !pSVGMarkup)
		{
			return false;
		}

		this._Icons[pIconKey] = pSVGMarkup;

		// Also update the pict template if TemplateProvider is available
		if (this.fable && this.fable.TemplateProvider)
		{
			this.fable.TemplateProvider.addTemplate('Flow-Icon-' + pIconKey, pSVGMarkup);
		}

		return true;
	}
}

module.exports = PictProviderFlowIcons;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultIcons = _DefaultIcons;

},{"fable-serviceproviderbase":6}],28:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowLayouts'
};

/**
 * Provider for managing saved flow diagram layouts.
 *
 * Layouts capture the spatial arrangement of nodes and panels on the canvas
 * without storing any card content. When a layout is restored, nodes that
 * still exist are placed at their saved positions and any new nodes are
 * auto-laid-out to the right.
 *
 * ## Persistence
 *
 * By default, layouts are persisted to the browser's `localStorage` using a
 * key derived from the flow view identifier. This means layouts survive page
 * refreshes out of the box.
 *
 * Developers can override the storage backend (e.g., to use a REST API or
 * IndexedDB) by replacing the three storage hook methods on the instance or
 * in a subclass:
 *
 *   - `storageWrite(pLayouts, fCallback)` — persist the full layout array
 *   - `storageRead(fCallback)` — load the persisted layout array
 *   - `storageDelete(fCallback)` — remove all persisted layouts
 *
 * Each callback follows the Node convention: `fCallback(pError, pResult)`.
 *
 * Saved layout data structure:
 * {
 *     Hash: "layout-<UUID>",
 *     Name: "My Layout",
 *     CreatedAt: "2026-02-26T12:00:00.000Z",
 *     NodePositions: { "node-hash": { X, Y, Width, Height } },
 *     PanelPositions: { "node-hash": { X, Y, Width, Height } },
 *     ViewState: { PanX, PanY, Zoom }
 * }
 */
class PictProviderFlowLayouts extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowLayouts';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Storage key for localStorage persistence.
		// Defaults to a key derived from the FlowView identifier, or can be
		// set via options.StorageKey.  Pass `false` to disable localStorage.
		if (pOptions && pOptions.StorageKey !== undefined)
		{
			this._StorageKey = pOptions.StorageKey;
		}
		else if (this._FlowView && this._FlowView.options && this._FlowView.options.ViewIdentifier)
		{
			this._StorageKey = `pict-flow-layouts-${this._FlowView.options.ViewIdentifier}`;
		}
		else
		{
			this._StorageKey = 'pict-flow-layouts';
		}
	}

	// ── Storage Hooks ─────────────────────────────────────────────────────
	// These three methods form the persistence contract.  The default
	// implementation uses localStorage.  Override them on the instance or
	// subclass to use a REST API, IndexedDB, or any other backend.
	//
	// All callbacks follow `fCallback(pError, pResult)`.

	/**
	 * Persist the full array of layout objects.
	 *
	 * Default implementation writes JSON to `localStorage`.
	 *
	 * @param {Array} pLayouts - The array of layout objects to persist
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageWrite(pLayouts, fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.setItem(this._StorageKey, JSON.stringify(pLayouts));
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageWrite error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	/**
	 * Load the persisted array of layout objects.
	 *
	 * Default implementation reads JSON from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError, pLayouts)` where
	 *        pLayouts is an Array (or null/empty if nothing stored)
	 */
	storageRead(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null, []);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				let tmpRaw = localStorage.getItem(this._StorageKey);
				if (tmpRaw)
				{
					let tmpParsed = JSON.parse(tmpRaw);
					if (Array.isArray(tmpParsed))
					{
						return fCallback(null, tmpParsed);
					}
				}
			}
			return fCallback(null, []);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageRead error: ${pError.message}`);
			return fCallback(pError, []);
		}
	}

	/**
	 * Remove all persisted layout data.
	 *
	 * Default implementation removes the key from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageDelete(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.removeItem(this._StorageKey);
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageDelete error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	// ── Initialization ────────────────────────────────────────────────────

	/**
	 * Load persisted layouts and merge them into _FlowData.SavedLayouts.
	 * Layouts already present in _FlowData (e.g., from setFlowData) are
	 * kept; persisted layouts with new hashes are appended.
	 *
	 * Call this after _FlowData is populated.
	 */
	loadPersistedLayouts()
	{
		this.storageRead((pError, pLayouts) =>
		{
			if (pError || !Array.isArray(pLayouts) || pLayouts.length === 0)
			{
				return;
			}

			if (!this._FlowView || !this._FlowView._FlowData)
			{
				return;
			}

			let tmpExisting = this._FlowView._FlowData.SavedLayouts;
			let tmpExistingHashes = {};
			for (let i = 0; i < tmpExisting.length; i++)
			{
				tmpExistingHashes[tmpExisting[i].Hash] = true;
			}

			let tmpAdded = 0;
			for (let i = 0; i < pLayouts.length; i++)
			{
				if (!tmpExistingHashes[pLayouts[i].Hash])
				{
					tmpExisting.push(pLayouts[i]);
					tmpAdded++;
				}
			}

			if (tmpAdded > 0)
			{
				this.log.trace(`PictProviderFlowLayouts loaded ${tmpAdded} persisted layout(s)`);
			}
		});
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Save the current node and panel positions as a named layout.
	 * @param {string} pName - The display name for this layout
	 * @returns {Object} The saved layout entry
	 */
	saveLayout(pName)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts saveLayout: no FlowView reference');
			return null;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayoutHash = `layout-${this.fable.getUUID()}`;
		let tmpNodePositions = {};
		let tmpPanelPositions = {};

		// Capture node positions and per-instance overrides (Title, Style)
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			tmpNodePositions[tmpNode.Hash] =
			{
				X: tmpNode.X,
				Y: tmpNode.Y,
				Width: tmpNode.Width,
				Height: tmpNode.Height,
				Title: tmpNode.Title
			};

			// Only include Style if it has been customized
			if (tmpNode.Style && Object.keys(tmpNode.Style).length > 0)
			{
				tmpNodePositions[tmpNode.Hash].Style = JSON.parse(JSON.stringify(tmpNode.Style));
			}
		}

		// Capture panel positions keyed by NodeHash (panels get new hashes on each open)
		for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
		{
			let tmpPanel = tmpFlowData.OpenPanels[i];
			tmpPanelPositions[tmpPanel.NodeHash] =
			{
				X: tmpPanel.X,
				Y: tmpPanel.Y,
				Width: tmpPanel.Width,
				Height: tmpPanel.Height
			};
		}

		let tmpLayout =
		{
			Hash: tmpLayoutHash,
			Name: pName || 'Untitled Layout',
			CreatedAt: new Date().toISOString(),
			NodePositions: tmpNodePositions,
			PanelPositions: tmpPanelPositions,
			ViewState:
			{
				PanX: tmpFlowData.ViewState.PanX,
				PanY: tmpFlowData.ViewState.PanY,
				Zoom: tmpFlowData.ViewState.Zoom
			}
		};

		tmpFlowData.SavedLayouts.push(tmpLayout);
		this._FlowView.marshalFromView();

		// Persist to storage
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after save: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutSaved', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts saved layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return tmpLayout;
	}

	/**
	 * Restore a saved layout by hash.
	 * Nodes present in the saved layout are placed at their saved positions.
	 * Nodes not in the saved layout are auto-laid-out to the right of the
	 * positioned nodes.
	 * @param {string} pLayoutHash - The hash of the layout to restore
	 * @returns {boolean} Whether the layout was restored
	 */
	restoreLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts restoreLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayout = tmpFlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (!tmpLayout)
		{
			this.log.warn(`PictProviderFlowLayouts restoreLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpMatchedNodes = [];
		let tmpUnmatchedNodes = [];

		// Apply saved positions to matched nodes; collect unmatched ones
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			let tmpSaved = tmpLayout.NodePositions[tmpNode.Hash];

			if (tmpSaved)
			{
				tmpNode.X = tmpSaved.X;
				tmpNode.Y = tmpSaved.Y;
				if (typeof tmpSaved.Width === 'number') tmpNode.Width = tmpSaved.Width;
				if (typeof tmpSaved.Height === 'number') tmpNode.Height = tmpSaved.Height;
				if (typeof tmpSaved.Title === 'string') tmpNode.Title = tmpSaved.Title;
				if (tmpSaved.Style && typeof tmpSaved.Style === 'object')
				{
					tmpNode.Style = JSON.parse(JSON.stringify(tmpSaved.Style));
				}
				tmpMatchedNodes.push(tmpNode);
			}
			else
			{
				tmpUnmatchedNodes.push(tmpNode);
			}
		}

		// Apply saved panel positions (keyed by NodeHash)
		if (tmpLayout.PanelPositions)
		{
			for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
			{
				let tmpPanel = tmpFlowData.OpenPanels[i];
				let tmpSavedPanel = tmpLayout.PanelPositions[tmpPanel.NodeHash];

				if (tmpSavedPanel)
				{
					tmpPanel.X = tmpSavedPanel.X;
					tmpPanel.Y = tmpSavedPanel.Y;
					if (typeof tmpSavedPanel.Width === 'number') tmpPanel.Width = tmpSavedPanel.Width;
					if (typeof tmpSavedPanel.Height === 'number') tmpPanel.Height = tmpSavedPanel.Height;
				}
			}
		}

		// Auto-layout unmatched nodes to the right of positioned nodes
		if (tmpUnmatchedNodes.length > 0 && this._FlowView._LayoutService)
		{
			this._FlowView._LayoutService.autoLayoutSubset(
				tmpUnmatchedNodes,
				tmpMatchedNodes,
				tmpFlowData.Connections
			);
		}

		// Restore view state (camera position)
		if (tmpLayout.ViewState)
		{
			if (typeof tmpLayout.ViewState.PanX === 'number')
			{
				tmpFlowData.ViewState.PanX = tmpLayout.ViewState.PanX;
			}
			if (typeof tmpLayout.ViewState.PanY === 'number')
			{
				tmpFlowData.ViewState.PanY = tmpLayout.ViewState.PanY;
			}
			if (typeof tmpLayout.ViewState.Zoom === 'number')
			{
				tmpFlowData.ViewState.Zoom = tmpLayout.ViewState.Zoom;
			}
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutRestored', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts restored layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return true;
	}

	/**
	 * Delete a saved layout by hash.
	 * @param {string} pLayoutHash - The hash of the layout to delete
	 * @returns {boolean} Whether the layout was deleted
	 */
	deleteLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts deleteLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpIndex = tmpFlowData.SavedLayouts.findIndex(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (tmpIndex < 0)
		{
			this.log.warn(`PictProviderFlowLayouts deleteLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpRemovedLayout = tmpFlowData.SavedLayouts.splice(tmpIndex, 1)[0];
		this._FlowView.marshalFromView();

		// Persist to storage (with the layout removed)
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after delete: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutDeleted', tmpRemovedLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts deleted layout '${tmpRemovedLayout.Name}' (${tmpRemovedLayout.Hash})`);

		return true;
	}

	/**
	 * Get the list of saved layouts.
	 * @returns {Array} Array of saved layout objects
	 */
	getLayouts()
	{
		if (!this._FlowView) return [];
		return this._FlowView._FlowData.SavedLayouts;
	}

	/**
	 * Get a specific saved layout by hash.
	 * @param {string} pLayoutHash
	 * @returns {Object|null}
	 */
	getLayout(pLayoutHash)
	{
		if (!this._FlowView) return null;
		return this._FlowView._FlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		) || null;
	}
}

module.exports = PictProviderFlowLayouts;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":15}],29:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// Built-in node types reference theme-aware roles via `ColorRole`. The
// hex `TitleBarColor` / `BodyStyle` values remain as fallbacks for
// rendering paths that bypass CSS (legacy consumers, exports). When a
// role is set, the renderer skips applying those hex attributes — the
// role's CSS class drives the visuals so theme swaps propagate.
const _DefaultNodeTypes =
{
	'default':
	{
		Hash: 'default',
		Label: 'Default',
		DefaultWidth: 180,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		ColorRole: 'neutral',
		TitleBarColor: '#2c3e50',
		BodyStyle: {}
	},
	'start':
	{
		Hash: 'start',
		Label: 'Start',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		ColorRole: 'success',
		TitleBarColor: '#27ae60',
		BodyStyle:
		{
			'fill': '#eafaf1',
			'stroke': '#27ae60'
		}
	},
	'end':
	{
		Hash: 'end',
		Label: 'End',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		ColorRole: 'accent',
		TitleBarColor: '#1abc9c',
		BodyStyle:
		{
			'fill': '#e8f8f5',
			'stroke': '#1abc9c'
		}
	},
	'halt':
	{
		Hash: 'halt',
		Label: 'Halt',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		ColorRole: 'error',
		TitleBarColor: '#e74c3c',
		BodyStyle:
		{
			'fill': '#fdedec',
			'stroke': '#e74c3c'
		}
	},
	'decision':
	{
		Hash: 'decision',
		Label: 'Decision',
		DefaultWidth: 200,
		DefaultHeight: 100,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Yes' },
			{ Hash: null, Direction: 'output', Side: 'bottom', Label: 'No' }
		],
		ColorRole: 'warning',
		TitleBarColor: '#f39c12',
		BodyStyle:
		{
			'fill': '#fff9e6',
			'stroke': '#f39c12'
		}
	}
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNodeTypes'
};

class PictProviderFlowNodeTypes extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNodeTypes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Initialize with default node types unless explicitly disabled
		if (pOptions && pOptions.IncludeDefaultNodeTypes === false)
		{
			this._NodeTypes = {};
		}
		else
		{
			this._NodeTypes = JSON.parse(JSON.stringify(_DefaultNodeTypes));
		}

		// Merge any additional node types passed in via options
		if (pOptions && pOptions.AdditionalNodeTypes && typeof pOptions.AdditionalNodeTypes === 'object')
		{
			let tmpAdditionalKeys = Object.keys(pOptions.AdditionalNodeTypes);
			for (let i = 0; i < tmpAdditionalKeys.length; i++)
			{
				let tmpOriginal = pOptions.AdditionalNodeTypes[tmpAdditionalKeys[i]];
				this._NodeTypes[tmpAdditionalKeys[i]] = Object.assign(
					{},
					this._NodeTypes[tmpAdditionalKeys[i]] || {},
					JSON.parse(JSON.stringify(tmpOriginal))
				);
				// Preserve BodyContent.RenderCallback (functions are stripped by JSON serialization)
				if (tmpOriginal.BodyContent && typeof tmpOriginal.BodyContent.RenderCallback === 'function')
				{
					if (!this._NodeTypes[tmpAdditionalKeys[i]].BodyContent)
					{
						this._NodeTypes[tmpAdditionalKeys[i]].BodyContent = {};
					}
					this._NodeTypes[tmpAdditionalKeys[i]].BodyContent.RenderCallback = tmpOriginal.BodyContent.RenderCallback;
				}
			}
		}
	}

	/**
	 * Get a node type configuration by hash
	 * @param {string} pTypeHash - The node type hash
	 * @returns {Object|null} The node type configuration
	 */
	getNodeType(pTypeHash)
	{
		return this._NodeTypes[pTypeHash] || this._NodeTypes['default'];
	}

	/**
	 * Register a new node type or override an existing one
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 * @returns {boolean}
	 */
	registerNodeType(pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.Hash)
		{
			this.log.warn('PictProviderFlowNodeTypes registerNodeType: invalid config (missing Hash)');
			return false;
		}

		this._NodeTypes[pNodeTypeConfig.Hash] = Object.assign(
			{},
			this._NodeTypes[pNodeTypeConfig.Hash] || {},
			pNodeTypeConfig
		);

		return true;
	}

	/**
	 * Remove a node type
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	removeNodeType(pTypeHash)
	{
		if (pTypeHash === 'default')
		{
			this.log.warn('PictProviderFlowNodeTypes: cannot remove the default node type');
			return false;
		}

		if (this._NodeTypes[pTypeHash])
		{
			delete this._NodeTypes[pTypeHash];
			return true;
		}

		return false;
	}

	/**
	 * Get all registered node types
	 * @returns {Object} Map of type hash to type configuration
	 */
	getNodeTypes()
	{
		return JSON.parse(JSON.stringify(this._NodeTypes));
	}

	/**
	 * Get a list of node type hashes
	 * @returns {Array<string>}
	 */
	getNodeTypeList()
	{
		return Object.keys(this._NodeTypes);
	}

	/**
	 * Get all enabled node types that have FlowCard metadata.
	 * Returns only types that are cards and whose Enabled flag is true.
	 * @returns {Array<Object>} Array of node type configurations
	 */
	getEnabledCards()
	{
		let tmpCards = [];
		let tmpKeys = Object.keys(this._NodeTypes);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpType = this._NodeTypes[tmpKeys[i]];
			if (tmpType.CardMetadata)
			{
				if (tmpType.CardMetadata.Enabled !== false)
				{
					tmpCards.push(JSON.parse(JSON.stringify(tmpType)));
				}
			}
		}
		return tmpCards;
	}

	/**
	 * Get all enabled cards grouped by category.
	 * @returns {Object} Map of category name to array of node type configurations
	 */
	getCardsByCategory()
	{
		let tmpCards = this.getEnabledCards();
		let tmpCategories = {};
		for (let i = 0; i < tmpCards.length; i++)
		{
			let tmpCategory = (tmpCards[i].CardMetadata && tmpCards[i].CardMetadata.Category)
				? tmpCards[i].CardMetadata.Category
				: 'General';
			if (!tmpCategories[tmpCategory])
			{
				tmpCategories[tmpCategory] = [];
			}
			tmpCategories[tmpCategory].push(tmpCards[i]);
		}
		return tmpCategories;
	}

	/**
	 * Check whether a node type hash refers to a FlowCard (has CardMetadata).
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	isFlowCard(pTypeHash)
	{
		let tmpType = this._NodeTypes[pTypeHash];
		return !!(tmpType && tmpType.CardMetadata);
	}
}

module.exports = PictProviderFlowNodeTypes;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultNodeTypes = _DefaultNodeTypes;

},{"pict-provider":15}],30:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNoise'
};

/**
 * PictProvider-Flow-Noise
 *
 * Deterministic noise/jitter generator for hand-drawn visual effects.
 *
 * Uses seeded pseudo-random number generation so that the same node or
 * connection always receives the same jitter values across re-renders,
 * preventing visual "jumping" while still looking organic.
 */
class PictProviderFlowNoise extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNoise';
	}

	// ── Hashing / PRNG ────────────────────────────────────────────────────

	/**
	 * Convert a string to a 32-bit integer hash (djb2 algorithm).
	 * @param {string} pStr
	 * @returns {number}
	 */
	hashString(pStr)
	{
		let tmpHash = 5381;
		for (let i = 0; i < pStr.length; i++)
		{
			tmpHash = ((tmpHash << 5) + tmpHash) + pStr.charCodeAt(i);
			tmpHash = tmpHash & tmpHash; // Convert to 32-bit integer
		}
		return tmpHash >>> 0; // Ensure unsigned
	}

	/**
	 * Create a seeded pseudo-random number generator (Mulberry32).
	 * Returns a function that produces deterministic floats in [0, 1).
	 * @param {number} pSeed - 32-bit integer seed
	 * @returns {Function}
	 */
	seededRandom(pSeed)
	{
		let tmpSeed = pSeed | 0;
		return function()
		{
			tmpSeed = tmpSeed + 0x6D2B79F5 | 0;
			let t = Math.imul(tmpSeed ^ tmpSeed >>> 15, 1 | tmpSeed);
			t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
			return ((t ^ t >>> 14) >>> 0) / 4294967296;
		};
	}

	// ── Point Jitter ──────────────────────────────────────────────────────

	/**
	 * Apply random jitter to a point.
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pAmplitude - Maximum offset in pixels
	 * @param {Function} pRNG - Seeded random function
	 * @returns {{x: number, y: number}}
	 */
	jitterPoint(pX, pY, pAmplitude, pRNG)
	{
		if (pAmplitude <= 0)
		{
			return { x: pX, y: pY };
		}
		return {
			x: pX + pAmplitude * (pRNG() - 0.5) * 2,
			y: pY + pAmplitude * (pRNG() - 0.5) * 2
		};
	}

	// ── Bracket Path Generation ───────────────────────────────────────────

	/**
	 * Generate an SVG path `d` string for a bracket-shaped node border.
	 *
	 * Draws true bracket shapes — `[` on the left and `]` on the right —
	 * with NO top/bottom connecting lines.  The serifs (horizontal turns)
	 * extend inward from each corner, giving a distinctive hand-drawn
	 * technical-diagram look that is immediately distinguishable from a
	 * regular rectangle at any zoom level.
	 *
	 * The bracket consists of:
	 * - Left bracket `[`: top serif → vertical left side → bottom serif
	 * - Right bracket `]`: top serif → vertical right side → bottom serif
	 * - Optional title divider line across the full width
	 *
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pSerifLength - Length of corner serifs in px
	 * @param {number} pTitleBarHeight - Height of title bar (0 to skip divider)
	 * @param {number} pAmplitude - Noise amplitude (0 = precise)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} SVG path d attribute
	 */
	generateBracketPath(pWidth, pHeight, pSerifLength, pTitleBarHeight, pAmplitude, pSeedString)
	{
		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'default'));
		let tmpS = pSerifLength || 18;
		let tmpW = pWidth;
		let tmpH = pHeight;

		let tmpJ = (pX, pY) =>
		{
			return this.jitterPoint(pX, pY, pAmplitude, tmpRNG);
		};

		// Left bracket `[`: top serif → down left side → bottom serif
		let tmpTL_serif = tmpJ(tmpS, 0);
		let tmpTL_corner = tmpJ(0, 0);
		let tmpBL_corner = tmpJ(0, tmpH);
		let tmpBL_serif = tmpJ(tmpS, tmpH);

		// Right bracket `]`: top serif → down right side → bottom serif
		let tmpTR_serif = tmpJ(tmpW - tmpS, 0);
		let tmpTR_corner = tmpJ(tmpW, 0);
		let tmpBR_corner = tmpJ(tmpW, tmpH);
		let tmpBR_serif = tmpJ(tmpW - tmpS, tmpH);

		let tmpPath = '';

		// Left bracket `[`
		tmpPath += `M ${tmpTL_serif.x.toFixed(1)} ${tmpTL_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTL_corner.x.toFixed(1)} ${tmpTL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_corner.x.toFixed(1)} ${tmpBL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_serif.x.toFixed(1)} ${tmpBL_serif.y.toFixed(1)}`;

		// Right bracket `]`
		tmpPath += ` M ${tmpTR_serif.x.toFixed(1)} ${tmpTR_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTR_corner.x.toFixed(1)} ${tmpTR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_corner.x.toFixed(1)} ${tmpBR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_serif.x.toFixed(1)} ${tmpBR_serif.y.toFixed(1)}`;

		// No horizontal lines — the title bar fill rect provides visual
		// separation via its background color.  The bracket outline is
		// purely the `[` and `]` shapes on the sides.

		return tmpPath;
	}

	// ── Path Jitter (for connections) ─────────────────────────────────────

	/**
	 * Apply jitter to an existing SVG path string by offsetting coordinate
	 * pairs.  The first M and last coordinate pair receive reduced jitter
	 * to keep connections aligned with their port anchors.
	 *
	 * @param {string} pPathString - SVG path d attribute
	 * @param {number} pAmplitude - Noise amplitude (0 = no change)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} Modified path string
	 */
	jitterPath(pPathString, pAmplitude, pSeedString)
	{
		if (pAmplitude <= 0 || !pPathString)
		{
			return pPathString;
		}

		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'path'));

		// Parse path into tokens: commands and numbers
		let tmpTokens = pPathString.match(/[MLCQZmlcqz]|[-+]?[0-9]*\.?[0-9]+/g);
		if (!tmpTokens)
		{
			return pPathString;
		}

		// Collect all numeric coordinate indices
		let tmpNumericIndices = [];
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (/^[-+]?[0-9]*\.?[0-9]+$/.test(tmpTokens[i]))
			{
				tmpNumericIndices.push(i);
			}
		}

		// Process pairs of coordinates (x, y)
		for (let i = 0; i < tmpNumericIndices.length - 1; i += 2)
		{
			let tmpXIdx = tmpNumericIndices[i];
			let tmpYIdx = tmpNumericIndices[i + 1];

			// Reduce jitter for first and last coordinate pairs (port anchors)
			let tmpLocalAmplitude = pAmplitude;
			if (i === 0 || i >= tmpNumericIndices.length - 2)
			{
				tmpLocalAmplitude = pAmplitude * 0.15; // Minimal anchor jitter
			}
			else if (i === 2 || i >= tmpNumericIndices.length - 4)
			{
				tmpLocalAmplitude = pAmplitude * 0.5; // Reduced near anchors
			}

			let tmpX = parseFloat(tmpTokens[tmpXIdx]);
			let tmpY = parseFloat(tmpTokens[tmpYIdx]);
			let tmpJittered = this.jitterPoint(tmpX, tmpY, tmpLocalAmplitude, tmpRNG);

			tmpTokens[tmpXIdx] = tmpJittered.x.toFixed(1);
			tmpTokens[tmpYIdx] = tmpJittered.y.toFixed(1);
		}

		// Reassemble path string with spaces
		let tmpResult = '';
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (i > 0 && /^[MLCQZmlcqz]$/.test(tmpTokens[i]))
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else if (i > 0)
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else
			{
				tmpResult += tmpTokens[i];
			}
		}

		return tmpResult;
	}
}

module.exports = PictProviderFlowNoise;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":6}],31:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-PanelChrome
 *
 * Template-based provider for creating the panel chrome (the foreignObject
 * wrapper, title bar, close button, and body container) for properties panels.
 *
 * Replaces the raw DOM API approach with a configuration template
 * (Flow-PanelChrome-Template) registered in the FlowView's template set.
 */
class PictProviderFlowPanelChrome extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowPanelChrome';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Create a foreignObject containing the panel chrome and empty body container.
	 *
	 * Uses the Flow-PanelChrome-Template registered in the FlowView configuration
	 * to render the inner HTML (title bar, close button, body container), then
	 * attaches event isolation listeners so pointer and wheel events inside the
	 * panel body do not propagate to the SVG interaction layer.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels (Hash, NodeHash, X, Y, Width, Height, Title)
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @returns {HTMLDivElement} The panel body container element for content rendering
	 */
	createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpSVGHelper = this._FlowView._SVGHelperProvider;

		// Create the SVG foreignObject wrapper
		let tmpFO = tmpSVGHelper.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-panel-foreign-object');
		tmpFO.setAttribute('data-panel-hash', pPanelData.Hash);
		tmpFO.setAttribute('data-node-hash', pPanelData.NodeHash);
		tmpFO.setAttribute('x', String(pPanelData.X));
		tmpFO.setAttribute('y', String(pPanelData.Y));
		tmpFO.setAttribute('width', String(pPanelData.Width));
		tmpFO.setAttribute('height', String(pPanelData.Height));

		// Render the panel chrome from the configuration template
		let tmpPict = this._FlowView.pict || this._FlowView.fable;
		let tmpTitle = pPanelData.Title || 'Properties';
		let tmpChromeHTML = tmpPict.parseTemplateByHash('Flow-PanelChrome-Template',
			{
				Hash: pPanelData.Hash,
				Title: tmpTitle,
				FlowViewIdentifier: this._FlowView.options.ViewIdentifier
			});

		tmpFO.innerHTML = tmpChromeHTML;

		// Populate the close button icon
		let tmpCloseIcon = tmpFO.querySelector('.pict-flow-panel-close-icon');
		if (tmpCloseIcon && this._FlowView && this._FlowView._IconProvider)
		{
			tmpCloseIcon.innerHTML = this._FlowView._IconProvider.getIconSVGMarkup('close', 12);
		}
		else if (tmpCloseIcon)
		{
			tmpCloseIcon.textContent = '\u2715';
		}

		// Pointer/wheel isolation lives on the inline onpointerdown/onwheel
		// attributes in Flow-PanelChrome-Template — see PictView-Flow.js.

		pPanelsLayer.appendChild(tmpFO);

		// Return the properties tab pane as the body container for content rendering
		let tmpPropertiesPane = tmpFO.querySelector('.pict-flow-panel-tab-pane[data-tab="properties"]');
		return tmpPropertiesPane;
	}
}

module.exports = PictProviderFlowPanelChrome;

},{"fable-serviceproviderbase":6}],32:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-SVGHelpers
 *
 * Shared SVG element creation utility used by all flow components
 * that need to create SVG namespace elements (nodes, connections, tethers).
 */
class PictProviderFlowSVGHelpers extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowSVGHelpers';
	}

	/**
	 * Create an SVG namespace element.
	 *
	 * @param {string} pTagName - The SVG element tag name (e.g., 'path', 'circle', 'g', 'rect', 'text')
	 * @returns {SVGElement}
	 */
	createSVGElement(pTagName)
	{
		return document.createElementNS('http://www.w3.org/2000/svg', pTagName);
	}
}

module.exports = PictProviderFlowSVGHelpers;

},{"fable-serviceproviderbase":6}],33:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowTheme'
};

/**
 * PictProvider-Flow-Theme
 *
 * Central orchestrator for the flow diagram theming system.
 *
 * Holds a registry of theme definitions, manages the active theme,
 * and provides hooks for node body rendering and path noise processing.
 *
 * ## Usage
 *
 * ```javascript
 * flowView.setTheme('sketch');       // Switch to hand-drawn style
 * flowView.setNoiseLevel(0.6);       // Increase bracket/connection wobble
 * flowView.setTheme('default');      // Restore modern style
 * ```
 *
 * ## Custom Themes
 *
 * ```javascript
 * flowView._ThemeProvider.registerTheme('custom', {
 *     Key: 'custom',
 *     Label: 'My Custom Theme',
 *     CSSVariables: { '--pf-canvas-bg': '#222' },
 *     NodeBodyMode: 'rect',
 *     NoiseConfig: { Enabled: false }
 * });
 * flowView.setTheme('custom');
 * ```
 */
class PictProviderFlowTheme extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowTheme';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._ActiveThemeKey = 'default';
		this._NoiseLevel = 0;
		this._Themes = {};

		this._registerBuiltInThemes();
	}

	// ── Theme Registry ────────────────────────────────────────────────────

	_registerBuiltInThemes()
	{
		// ── 1. Default (Modern) ──────────────────────────────────────
		this._Themes['default'] =
		{
			Key: 'default',
			Label: 'Modern',
			CSSVariables: {},
			AdditionalCSS: '',
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides: {}
		};

		// ── 2. Sketch (Hand-drawn) ───────────────────────────────────
		this._Themes['sketch'] =
		{
			Key: 'sketch',
			Label: 'Sketch',
			CSSVariables:
			{
				'--pf-node-body-fill': '#fffef5',
				'--pf-node-body-stroke': '#444444',
				'--pf-node-body-stroke-width': '1.5',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#333333',
				'--pf-node-title-size': '12px',
				'--pf-node-title-weight': '400',
				'--pf-node-title-bar-color': '#f0ece0',
				'--pf-node-type-label-fill': '#888888',
				'--pf-node-selected-stroke': '#2255aa',
				'--pf-port-input-fill': '#5577bb',
				'--pf-port-output-fill': '#55aa77',
				'--pf-port-stroke': '#fffef5',
				'--pf-connection-stroke': '#555555',
				'--pf-connection-selected-stroke': '#2255aa',
				'--pf-canvas-bg': '#fffef5',
				'--pf-grid-stroke': '#e8e4d8',
				'--pf-panel-bg': '#fffef5',
				'--pf-panel-border': '#ccccaa',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px rgba(0,0,0,0.08)',
				'--pf-panel-titlebar-bg': '#f0ece0',
				'--pf-panel-titlebar-border': '#ccccaa',
				'--pf-panel-title-color': '#333333'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-panel-title-text,
				.pict-flow-panel-node-props-title,
				.pict-flow-info-panel {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) !important;
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 20,
				TitleSeparator: true
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: true,
				DefaultLevel: 0.4,
				MaxJitterPx: 4,
				AffectsNodes: true,
				AffectsConnections: true
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#555555' },
				'arrowhead-connection-selected': { Fill: '#2255aa' }
			}
		};

		// ── 3. Blueprint (Technical) ─────────────────────────────────
		this._Themes['blueprint'] =
		{
			Key: 'blueprint',
			Label: 'Blueprint',
			CSSVariables:
			{
				'--pf-node-body-fill': 'rgba(255,255,255,0.05)',
				'--pf-node-body-stroke': '#ffffff',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '400',
				'--pf-node-title-bar-color': 'rgba(255,255,255,0.1)',
				'--pf-node-type-label-fill': 'rgba(255,255,255,0.5)',
				'--pf-node-selected-stroke': '#ffdd44',
				'--pf-port-input-fill': '#88bbff',
				'--pf-port-output-fill': '#88ffbb',
				'--pf-port-stroke': '#1a3a6a',
				'--pf-connection-stroke': 'rgba(255,255,255,0.6)',
				'--pf-connection-selected-stroke': '#ffdd44',
				'--pf-canvas-bg': '#1a3a6a',
				'--pf-grid-stroke': 'rgba(255,255,255,0.08)',
				'--pf-panel-bg': '#1a3a6a',
				'--pf-panel-border': 'rgba(255,255,255,0.3)',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': 'none',
				'--pf-panel-titlebar-bg': 'rgba(255,255,255,0.05)',
				'--pf-panel-titlebar-border': 'rgba(255,255,255,0.15)',
				'--pf-panel-title-color': '#ffffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", monospace !important;
					text-transform: uppercase;
					letter-spacing: 1px;
				}
				.pict-flow-container {
					border-color: #0d2244;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
				.pict-flow-toolbar {
					background-color: #142e54;
					border-bottom-color: rgba(255,255,255,0.15);
				}
				.pict-flow-toolbar-btn {
					background-color: rgba(255,255,255,0.05);
					border-color: rgba(255,255,255,0.2);
					color: var(--theme-color-background-panel, #ffffff);
				}
				.pict-flow-toolbar-btn:hover {
					background-color: rgba(255,255,255,0.1);
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 18,
				TitleSeparator: true
			},
			ConnectionConfig:
			{
				StrokeDashArray: '8 4',
				StrokeWidth: 1,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: 'rgba(255,255,255,0.6)' },
				'arrowhead-connection-selected': { Fill: '#ffdd44' }
			}
		};

		// ── 4. Mono (Black & White) ──────────────────────────────────
		this._Themes['mono'] =
		{
			Key: 'mono',
			Label: 'Monochrome',
			CSSVariables:
			{
				'--pf-node-body-fill': '#ffffff',
				'--pf-node-body-stroke': '#000000',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '600',
				'--pf-node-title-bar-color': '#000000',
				'--pf-node-type-label-fill': '#888888',
				'--pf-node-selected-stroke': '#444444',
				'--pf-port-input-fill': '#000000',
				'--pf-port-output-fill': '#666666',
				'--pf-port-stroke': '#ffffff',
				'--pf-connection-stroke': '#000000',
				'--pf-connection-selected-stroke': '#444444',
				'--pf-canvas-bg': '#ffffff',
				'--pf-grid-stroke': '#eeeeee',
				'--pf-panel-bg': '#ffffff',
				'--pf-panel-border': '#000000',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': 'none',
				'--pf-panel-titlebar-bg': '#f0f0f0',
				'--pf-panel-titlebar-border': '#000000',
				'--pf-panel-title-color': '#000000'
			},
			AdditionalCSS: `
				.pict-flow-node-title {
					font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#000000' },
				'arrowhead-connection-selected': { Fill: '#444444' }
			}
		};

		// ── 5. Retro 80s (Neon) ──────────────────────────────────────
		this._Themes['retro-80s'] =
		{
			Key: 'retro-80s',
			Label: '80s Retro',
			CSSVariables:
			{
				'--pf-node-body-fill': '#1a0a2e',
				'--pf-node-body-stroke': '#ff00ff',
				'--pf-node-body-stroke-width': '2',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'drop-shadow(0 0 8px rgba(255,0,255,0.4))',
				'--pf-node-shadow-hover': 'drop-shadow(0 0 12px rgba(255,0,255,0.6))',
				'--pf-node-shadow-selected': 'drop-shadow(0 0 16px rgba(0,255,255,0.5))',
				'--pf-node-shadow-dragging': 'drop-shadow(0 0 20px rgba(255,0,255,0.7))',
				'--pf-node-title-fill': '#00ffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '700',
				'--pf-node-title-bar-color': '#2a0a4e',
				'--pf-node-type-label-fill': '#ff66ff',
				'--pf-node-selected-stroke': '#00ffff',
				'--pf-port-input-fill': '#ff00ff',
				'--pf-port-output-fill': '#00ff66',
				'--pf-port-stroke': '#1a0a2e',
				'--pf-connection-stroke': '#ff00ff',
				'--pf-connection-selected-stroke': '#00ffff',
				'--pf-canvas-bg': '#0a0015',
				'--pf-grid-stroke': '#1a0a2e',
				'--pf-panel-bg': '#1a0a2e',
				'--pf-panel-border': '#ff00ff',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '0 0 20px rgba(255,0,255,0.3)',
				'--pf-panel-titlebar-bg': '#2a0a4e',
				'--pf-panel-titlebar-border': '#ff00ff',
				'--pf-panel-title-color': '#00ffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", monospace !important;
					text-transform: uppercase;
					letter-spacing: 0.5px;
				}
				.pict-flow-connection {
					filter: drop-shadow(0 0 3px rgba(255,0,255,0.4));
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) hue-rotate(180deg) !important;
				}
				.pict-flow-toolbar {
					background-color: #1a0a2e;
					border-bottom-color: #ff00ff;
				}
				.pict-flow-toolbar-btn {
					background-color: #1a0a2e;
					border-color: #ff00ff;
					color: #00ffff;
				}
				.pict-flow-toolbar-btn:hover {
					background-color: #2a0a4e;
				}
				.pict-flow-container {
					border-color: #ff00ff;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#ff00ff' },
				'arrowhead-connection-selected': { Fill: '#00ffff' }
			}
		};

		// ── 6. Retro 90s (Windows) ───────────────────────────────────
		this._Themes['retro-90s'] =
		{
			Key: 'retro-90s',
			Label: '90s Retro',
			CSSVariables:
			{
				'--pf-node-body-fill': '#c0c0c0',
				'--pf-node-body-stroke': '#808080',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'drop-shadow(2px 2px 0px #404040)',
				'--pf-node-shadow-hover': 'drop-shadow(3px 3px 0px #404040)',
				'--pf-node-shadow-selected': 'drop-shadow(2px 2px 0px #008080)',
				'--pf-node-shadow-dragging': 'drop-shadow(4px 4px 0px #404040)',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '700',
				'--pf-node-title-bar-color': '#000080',
				'--pf-node-type-label-fill': '#606060',
				'--pf-node-selected-stroke': '#008080',
				'--pf-port-input-fill': '#000080',
				'--pf-port-output-fill': '#008000',
				'--pf-port-stroke': '#c0c0c0',
				'--pf-connection-stroke': '#808080',
				'--pf-connection-selected-stroke': '#008080',
				'--pf-canvas-bg': '#008080',
				'--pf-grid-stroke': 'rgba(0,0,0,0.06)',
				'--pf-panel-bg': '#c0c0c0',
				'--pf-panel-border': '#808080',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px #404040',
				'--pf-panel-titlebar-bg': '#000080',
				'--pf-panel-titlebar-border': '#c0c0c0',
				'--pf-panel-title-color': '#ffffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "MS Sans Serif", "Arial", sans-serif !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
				.pict-flow-toolbar {
					background-color: #c0c0c0;
					border-bottom: 2px solid #808080;
					border-top: 1px solid var(--theme-color-background-panel, #ffffff);
				}
				.pict-flow-toolbar-btn {
					background-color: #c0c0c0;
					border: 2px outset #c0c0c0;
					border-radius: 0;
					color: var(--theme-color-text-primary, #000000);
				}
				.pict-flow-toolbar-btn:hover {
					background-color: var(--theme-color-border-default, #d0d0d0);
				}
				.pict-flow-toolbar-btn:active {
					border-style: inset;
				}
				.pict-flow-container {
					border: 2px outset #c0c0c0;
					border-radius: 0;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#808080' },
				'arrowhead-connection-selected': { Fill: '#008080' }
			}
		};

		// ── 7. Whiteboard (Minimal brackets, no fills) ──────────────
		this._Themes['whiteboard'] =
		{
			Key: 'whiteboard',
			Label: 'Whiteboard',
			CSSVariables:
			{
				'--pf-node-body-fill': 'transparent',
				'--pf-node-body-stroke': '#555555',
				'--pf-node-body-stroke-width': '2',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#333333',
				'--pf-node-title-size': '12px',
				'--pf-node-title-weight': '600',
				'--pf-node-title-bar-color': 'transparent',
				'--pf-node-type-label-fill': '#999999',
				'--pf-node-selected-stroke': '#2255aa',
				'--pf-port-input-fill': '#5577bb',
				'--pf-port-output-fill': '#55aa77',
				'--pf-port-stroke': '#ffffff',
				'--pf-connection-stroke': '#888888',
				'--pf-connection-selected-stroke': '#2255aa',
				'--pf-canvas-bg': '#ffffff',
				'--pf-grid-stroke': '#f0f0f0',
				'--pf-panel-bg': '#ffffff',
				'--pf-panel-border': '#cccccc',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px rgba(0,0,0,0.06)',
				'--pf-panel-titlebar-bg': '#f8f8f8',
				'--pf-panel-titlebar-border': '#e0e0e0',
				'--pf-panel-title-color': '#333333'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
				}
				/* Node-type bracket colors — each type gets its own bracket color */
				.pict-flow-node-start .pict-flow-node-bracket { stroke: var(--theme-color-status-success, #27ae60); }
				.pict-flow-node-end .pict-flow-node-bracket { stroke: #1abc9c; }
				.pict-flow-node-halt .pict-flow-node-bracket { stroke: var(--theme-color-status-error, #e74c3c); }
				.pict-flow-node-decision .pict-flow-node-bracket { stroke: var(--theme-color-status-warning, #f39c12); }
				.pict-flow-node-default .pict-flow-node-bracket { stroke: #3498db; }
				.pict-flow-node-action .pict-flow-node-bracket { stroke: #2c3e50; }
				/* Override variant rules: no fills/strokes on body rects in whiteboard */
				.pict-flow-node-decision .pict-flow-node-body,
				.pict-flow-node-start .pict-flow-node-body,
				.pict-flow-node-end .pict-flow-node-body,
				.pict-flow-node-halt .pict-flow-node-body {
					fill: transparent;
					stroke: transparent;
					stroke-width: 0;
				}
				/* Title bar fills transparent too */
				.pict-flow-node .pict-flow-node-bracket-title-fill {
					fill: transparent !important;
				}
				.pict-flow-node-title-icon {
					filter: none !important;
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 22,
				TitleSeparator: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: true,
				DefaultLevel: 0.3,
				MaxJitterPx: 3,
				AffectsNodes: true,
				AffectsConnections: true
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#888888' },
				'arrowhead-connection-selected': { Fill: '#2255aa' }
			}
		};
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Get the active theme definition.
	 * @returns {Object}
	 */
	getActiveTheme()
	{
		return this._Themes[this._ActiveThemeKey] || this._Themes['default'];
	}

	/**
	 * Get the active theme key.
	 * @returns {string}
	 */
	getActiveThemeKey()
	{
		return this._ActiveThemeKey;
	}

	/**
	 * Switch the active theme.
	 * This updates the internal key and applies shape overrides.
	 * The caller (FlowView.setTheme) is responsible for re-registering
	 * CSS and triggering a full re-render.
	 *
	 * @param {string} pThemeKey
	 * @returns {boolean} Whether the theme was found and applied
	 */
	setTheme(pThemeKey)
	{
		if (!this._Themes[pThemeKey])
		{
			this.log.warn(`PictProviderFlowTheme: theme '${pThemeKey}' not found`);
			return false;
		}

		this._ActiveThemeKey = pThemeKey;
		let tmpTheme = this._Themes[pThemeKey];

		// Apply noise defaults from theme
		if (tmpTheme.NoiseConfig && typeof tmpTheme.NoiseConfig.DefaultLevel === 'number')
		{
			this._NoiseLevel = tmpTheme.NoiseConfig.DefaultLevel;
		}
		else
		{
			this._NoiseLevel = 0;
		}

		// Apply shape overrides
		if (this._FlowView && this._FlowView._ConnectorShapesProvider)
		{
			this._FlowView._ConnectorShapesProvider.resetToDefaults();
			if (tmpTheme.ShapeOverrides && Object.keys(tmpTheme.ShapeOverrides).length > 0)
			{
				this._FlowView._ConnectorShapesProvider.applyThemeOverrides(tmpTheme.ShapeOverrides);
			}
		}

		this.log.trace(`PictProviderFlowTheme: switched to '${pThemeKey}'`);
		return true;
	}

	/**
	 * Get the current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		return this._NoiseLevel;
	}

	/**
	 * Set the noise level (0 to 1).
	 * @param {number} pLevel
	 */
	setNoiseLevel(pLevel)
	{
		this._NoiseLevel = Math.max(0, Math.min(1, pLevel || 0));
	}

	/**
	 * Register a custom theme.
	 * @param {string} pKey
	 * @param {Object} pThemeDefinition
	 */
	registerTheme(pKey, pThemeDefinition)
	{
		if (!pKey || !pThemeDefinition)
		{
			this.log.warn('PictProviderFlowTheme: registerTheme requires key and definition');
			return;
		}
		pThemeDefinition.Key = pKey;
		this._Themes[pKey] = pThemeDefinition;
	}

	/**
	 * Get all registered theme keys.
	 * @returns {Array<string>}
	 */
	getThemeKeys()
	{
		return Object.keys(this._Themes);
	}

	// ── Rendering Hooks ───────────────────────────────────────────────────

	/**
	 * Post-process an SVG path string to apply noise/jitter if the
	 * active theme has noise enabled for connections.
	 *
	 * @param {string} pPathString - SVG path d attribute
	 * @param {string} pSeedString - Hash for deterministic noise
	 * @returns {string} Possibly-modified path string
	 */
	processPathString(pPathString, pSeedString)
	{
		let tmpTheme = this.getActiveTheme();
		if (!tmpTheme || !tmpTheme.NoiseConfig || !tmpTheme.NoiseConfig.Enabled || !tmpTheme.NoiseConfig.AffectsConnections)
		{
			return pPathString;
		}

		let tmpAmplitude = this._NoiseLevel * (tmpTheme.NoiseConfig.MaxJitterPx || 3);
		if (tmpAmplitude <= 0)
		{
			return pPathString;
		}

		if (this._FlowView && this._FlowView._NoiseProvider)
		{
			return this._FlowView._NoiseProvider.jitterPath(pPathString, tmpAmplitude, pSeedString);
		}

		return pPathString;
	}

	/**
	 * Get the noise amplitude for node bracket rendering.
	 * Returns 0 if noise is not enabled for nodes in the active theme.
	 * @returns {number}
	 */
	getNodeNoiseAmplitude()
	{
		let tmpTheme = this.getActiveTheme();
		if (!tmpTheme || !tmpTheme.NoiseConfig || !tmpTheme.NoiseConfig.Enabled || !tmpTheme.NoiseConfig.AffectsNodes)
		{
			return 0;
		}
		return this._NoiseLevel * (tmpTheme.NoiseConfig.MaxJitterPx || 3);
	}
}

module.exports = PictProviderFlowTheme;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":6}],34:[function(require,module,exports){
/**
 * Edge-Bezier
 *
 * Default edge theme: smooth cubic bezier between source and target ports,
 * with departure/approach geometry derived from each port's `Side`. This
 * is a thin wrapper around the renderer's pre-existing bezier path
 * generator — selecting it is equivalent to the historical default.
 *
 * Honors per-connection multi-handle waypoints (BezierHandles) when
 * present so user-edited curves still survive.
 */
module.exports =
{
	Name: 'Bezier',
	Label: 'Bezier (smooth)',
	Description: 'Smooth cubic curves with side-aware departures.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		// Preserve user-customized multi-handle bezier waypoints.
		if (tmpData.HandleCustomized)
		{
			let tmpHandles = tmpHelpers.getBezierHandles(tmpData);
			if (tmpHandles.length > 0)
			{
				return tmpHelpers.generateMultiBezier(tmpSrc, tmpTgt, tmpHandles);
			}
		}

		return tmpHelpers.generateBezier(tmpSrc, tmpTgt);
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],35:[function(require,module,exports){
/**
 * Edge-Orthogonal
 *
 * Right-angle (Manhattan) routing between source and target. Reads
 * cleanly for layered DAGs and grid-shaped layouts. Per-connection
 * `OrthoMidOffset` and customized corner overrides are preserved.
 */
module.exports =
{
	Name: 'Orthogonal',
	Label: 'Orthogonal (right-angle)',
	Description: 'Right-angle routing — reads well for DAGs and grids.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}

		return tmpHelpers.generateOrthogonal(tmpSrc, tmpTgt, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],36:[function(require,module,exports){
const libCoerce = require('../layouts/Layout-Coerce.js');

/**
 * Edge-OrthogonalSnap
 *
 * Demonstrates the "edge theme can affect node placement" axis. Same
 * right-angle routing as Edge-Orthogonal, but with an `AdjustLayout`
 * pass that snaps every node's X/Y to a grid so corner segments line
 * up cleanly across the diagram.
 *
 * Trade-off: nodes shift slightly from the layout's natural positions
 * to gain visual alignment. The user opts into this by picking the
 * theme — the layout algorithm itself is unaware.
 */
module.exports =
{
	Name: 'OrthogonalSnap',
	Label: 'Orthogonal (snap to grid)',
	Description: 'Right-angle routing; snaps node positions to a grid for cleaner corner alignment. Demonstrates an edge theme that adjusts node placement.',

	GeneratePath: function (pContext)
	{
		let tmpHelpers = pContext.Helpers;
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};

		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}

		return tmpHelpers.generateOrthogonal(tmpSrc, tmpTgt, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	/**
	 * Snap each node's (X, Y) to the configured grid after the layout
	 * has run. Mutates pNodes in place.
	 *
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {Object} pParameters
	 */
	AdjustLayout: function (pNodes, pConnections, pParameters)
	{
		let tmpGridSize = libCoerce.toFloat((pParameters || {}).GridSize, 20);
		if (tmpGridSize <= 0) return;

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			if (typeof tmpNode.X !== 'number' || typeof tmpNode.Y !== 'number') continue;
			tmpNode.X = Math.round(tmpNode.X / tmpGridSize) * tmpGridSize;
			tmpNode.Y = Math.round(tmpNode.Y / tmpGridSize) * tmpGridSize;
		}
	},

	DefaultParameters:
	{
		GridSize: 20
	},

	ParameterSchema:
	{
		GridSize: { Type: 'PreciseNumber', Label: 'Grid size', Default: 20, Min: 1, Max: 200 }
	}
};

},{"../layouts/Layout-Coerce.js":43}],37:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter-Linear
 *
 * Perimeter attachment + literal straight line between the two
 * resolved exit points. Reads cleanly for force-directed and circular
 * layouts where the topology already determines edge angles, and the
 * curves of bezier add visual noise.
 */
module.exports =
{
	Name: 'Perimeter-Linear',
	Label: 'Perimeter (linear)',
	Description: 'Each connection exits the node at the perimeter, then runs as a straight line to the other end.',

	GeneratePath: function (pContext)
	{
		let tmpS = pContext.Source;
		let tmpT = pContext.Target;
		return `M ${tmpS.x} ${tmpS.y} L ${tmpT.x} ${tmpT.y}`;
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":40}],38:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter-Orthogonal
 *
 * Perimeter attachment + right-angle (Manhattan) routing between
 * the two resolved exit points. Best when the layout already has
 * grid-like structure (Grid, Mesh) and you want connections to
 * leave from whichever side faces the partner.
 */
module.exports =
{
	Name: 'Perimeter-Orthogonal',
	Label: 'Perimeter (orthogonal)',
	Description: 'Each connection exits the node at the perimeter, then routes via right-angle segments to the other end.',

	GeneratePath: function (pContext)
	{
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};
		let tmpCorners = null;
		if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
		{
			tmpCorners =
			{
				corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
				corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
			};
		}
		return pContext.Helpers.generateOrthogonal(pContext.Source, pContext.Target, tmpCorners, tmpData.OrthoMidOffset || 0);
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":40}],39:[function(require,module,exports){
const libPerimeterMath = require('./Edge-PerimeterMath.js');

/**
 * Edge-Perimeter (Bezier)
 *
 * "Smart exit" routing with smooth bezier curves. Each connection
 * exits the node at the perimeter point closest to its target —
 * solves star/hub topologies where many connections share one port.
 *
 * Renders the path as a side-aware bezier (uses the side returned by
 * `ResolveAttachment` so the curve departs in the right direction).
 *
 * See `Edge-Perimeter-Linear` and `Edge-Perimeter-Orthogonal` for the
 * straight-line and right-angle variants.
 */
module.exports =
{
	Name: 'Perimeter',
	Label: 'Perimeter (bezier)',
	Description: 'Each connection exits the node at the perimeter point closest to its target, with smooth bezier curves. Fixes star/hub topologies where many lines share one port.',

	GeneratePath: function (pContext)
	{
		// Honor user-edited bezier handles when the connection is selected
		// and dragged. Without this, the drag handles render but moving
		// them does nothing because Perimeter would always re-emit a
		// fresh side-aware bezier.
		let tmpHelpers = pContext.Helpers;
		let tmpData = (pContext.Connection && pContext.Connection.Data) || {};
		if (tmpData.HandleCustomized)
		{
			let tmpHandles = tmpHelpers.getBezierHandles(tmpData);
			if (tmpHandles.length > 0)
			{
				return tmpHelpers.generateMultiBezier(pContext.Source, pContext.Target, tmpHandles);
			}
		}
		return tmpHelpers.generateBezier(pContext.Source, pContext.Target);
	},

	ResolveAttachment: function (pContext)
	{
		return libPerimeterMath.resolvePerimeterAttachment(pContext);
	},

	DefaultParameters: {},
	ParameterSchema: {}
};

},{"./Edge-PerimeterMath.js":40}],40:[function(require,module,exports){
/**
 * Edge-PerimeterMath
 *
 * Shared geometry helper for the Perimeter family of edge themes
 * (Perimeter, Perimeter-Linear, Perimeter-Orthogonal). Solves the
 * "where on this node's bounding box should the line attach so it
 * points at the other end" question.
 *
 * The themes themselves only differ in how they render the path
 * between the two attachment points; the attachment math is identical.
 */

/**
 * Resolve a perimeter attachment point for one end of a connection.
 * Traces a line from the node's center toward the other end and returns
 * the first crossing of the node's bounding-box perimeter, plus the
 * `side` of that crossing (so the bezier helper departs in the right
 * direction).
 *
 * @param {Object} pContext - the same shape the renderer passes into
 *        ResolveAttachment (Node, OtherNode, OtherDefaultPosition,
 *        DefaultPosition, …).
 * @returns {{x: number, y: number, side: string}|Object|null}
 *        Returns null when node geometry is missing; returns
 *        DefaultPosition (verbatim) for degenerate same-center cases.
 */
function _resolvePerimeterAttachment(pContext)
{
	let tmpNode = pContext.Node;
	if (!tmpNode || typeof tmpNode.X !== 'number' || typeof tmpNode.Y !== 'number') return null;

	let tmpW = tmpNode.Width || 180;
	let tmpH = tmpNode.Height || 80;
	let tmpCx = tmpNode.X + tmpW / 2;
	let tmpCy = tmpNode.Y + tmpH / 2;

	let tmpAimX, tmpAimY;
	if (pContext.OtherNode && typeof pContext.OtherNode.X === 'number')
	{
		let tmpOW = pContext.OtherNode.Width || 180;
		let tmpOH = pContext.OtherNode.Height || 80;
		tmpAimX = pContext.OtherNode.X + tmpOW / 2;
		tmpAimY = pContext.OtherNode.Y + tmpOH / 2;
	}
	else if (pContext.OtherDefaultPosition)
	{
		tmpAimX = pContext.OtherDefaultPosition.x;
		tmpAimY = pContext.OtherDefaultPosition.y;
	}
	else
	{
		return null;
	}

	let tmpDX = tmpAimX - tmpCx;
	let tmpDY = tmpAimY - tmpCy;

	if (tmpDX === 0 && tmpDY === 0) return pContext.DefaultPosition || null;

	let tmpHalfW = tmpW / 2;
	let tmpHalfH = tmpH / 2;

	let tmpTX = (tmpDX > 0) ? tmpHalfW / tmpDX
		: (tmpDX < 0) ? -tmpHalfW / tmpDX
		: Infinity;
	let tmpTY = (tmpDY > 0) ? tmpHalfH / tmpDY
		: (tmpDY < 0) ? -tmpHalfH / tmpDY
		: Infinity;

	let tmpT, tmpSide;
	if (tmpTX < tmpTY)
	{
		tmpT = tmpTX;
		tmpSide = (tmpDX > 0) ? 'right' : 'left';
	}
	else
	{
		tmpT = tmpTY;
		tmpSide = (tmpDY > 0) ? 'bottom' : 'top';
	}

	return {
		x: tmpCx + tmpT * tmpDX,
		y: tmpCy + tmpT * tmpDY,
		side: tmpSide
	};
}

module.exports =
{
	resolvePerimeterAttachment: _resolvePerimeterAttachment
};

},{}],41:[function(require,module,exports){
/**
 * Edge-Straight
 *
 * Literal straight line from source port to target port. Useful for
 * dense clusters where curves add visual noise, and for force-directed
 * layouts where the topology already determines edge angles.
 */
module.exports =
{
	Name: 'Straight',
	Label: 'Straight line',
	Description: 'Plain straight line between ports.',

	GeneratePath: function (pContext)
	{
		let tmpSrc = pContext.Source;
		let tmpTgt = pContext.Target;
		return `M ${tmpSrc.x} ${tmpSrc.y} L ${tmpTgt.x} ${tmpTgt.y}`;
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],42:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Circular
 *
 * Concentric-ring layout.
 *
 * Two modes, decided by the presence of connections:
 *
 *   With connections: BFS from the root nodes (in-degree 0; or all
 *   nodes if every node has incoming edges). Each BFS depth becomes
 *   one ring. Roots cluster near the center, leaves on the outer rings.
 *
 *   Without connections: all nodes share a single ring with equal
 *   angular spacing.
 *
 * Within each ring, nodes are placed at equal angles starting from
 * `StartAngle` (in degrees, 0 = +X axis), going clockwise or
 * counter-clockwise per `Direction`.
 */
module.exports =
{
	Name: 'Circular',
	Label: 'Circular',
	Description: 'Concentric rings; uses connections for ring assignment when available.',
	DefaultEdgeTheme: 'Perimeter',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing     = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpCenterX     = libCoerce.toFloat(tmpParams.CenterX, 1000);
		let tmpCenterY     = libCoerce.toFloat(tmpParams.CenterY, 750);
		let tmpRingSpacing = libCoerce.toFloat(tmpParams.RingSpacing, 220) * tmpSpacing;
		let tmpInnerRadius = libCoerce.toFloat(tmpParams.InnerRadius, 0) * tmpSpacing;
		let tmpStartAngle  = libCoerce.toFloat(tmpParams.StartAngle, -90);
		let tmpDirection   = (tmpParams.Direction === 'ccw') ? 'ccw' : 'cw';

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		// Build in-degree map and adjacency
		let tmpInDegree = {};
		let tmpAdjacency = {};
		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
			tmpInDegree[pNodes[i].Hash] = 0;
			tmpAdjacency[pNodes[i].Hash] = [];
		}
		for (let i = 0; i < tmpConnections.length; i++)
		{
			let tmpConn = tmpConnections[i];
			if (tmpInDegree.hasOwnProperty(tmpConn.TargetNodeHash))
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
			}
			if (tmpAdjacency.hasOwnProperty(tmpConn.SourceNodeHash))
			{
				tmpAdjacency[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Identify roots
		let tmpRoots = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			if (tmpInDegree[pNodes[i].Hash] === 0)
			{
				tmpRoots.push(pNodes[i].Hash);
			}
		}

		let tmpRings = [];

		if (tmpConnections.length === 0 || tmpRoots.length === 0)
		{
			tmpRings.push(pNodes.map((pNode) => pNode.Hash));
		}
		else
		{
			// BFS by depth
			let tmpVisited = {};
			let tmpCurrent = tmpRoots.slice();
			while (tmpCurrent.length > 0)
			{
				let tmpRing = [];
				let tmpNext = [];
				for (let i = 0; i < tmpCurrent.length; i++)
				{
					let tmpHash = tmpCurrent[i];
					if (tmpVisited[tmpHash]) continue;
					tmpVisited[tmpHash] = true;
					tmpRing.push(tmpHash);

					let tmpChildren = tmpAdjacency[tmpHash] || [];
					for (let j = 0; j < tmpChildren.length; j++)
					{
						if (!tmpVisited[tmpChildren[j]])
						{
							tmpNext.push(tmpChildren[j]);
						}
					}
				}
				if (tmpRing.length > 0) tmpRings.push(tmpRing);
				tmpCurrent = tmpNext;
			}

			let tmpRemaining = [];
			for (let i = 0; i < pNodes.length; i++)
			{
				if (!tmpVisited[pNodes[i].Hash]) tmpRemaining.push(pNodes[i].Hash);
			}
			if (tmpRemaining.length > 0) tmpRings.push(tmpRemaining);
		}

		// Place nodes
		let tmpAngleSign = (tmpDirection === 'cw') ? 1 : -1;
		let tmpStartRad = tmpStartAngle * Math.PI / 180;

		for (let tmpRingIdx = 0; tmpRingIdx < tmpRings.length; tmpRingIdx++)
		{
			let tmpRing = tmpRings[tmpRingIdx];
			let tmpRadius = tmpInnerRadius + tmpRingIdx * tmpRingSpacing;

			if (tmpRing.length === 1 && tmpRingIdx === 0 && tmpInnerRadius === 0)
			{
				let tmpNode = tmpNodeMap[tmpRing[0]];
				if (tmpNode)
				{
					tmpNode.X = tmpCenterX - (tmpNode.Width || 180) / 2;
					tmpNode.Y = tmpCenterY - (tmpNode.Height || 80) / 2;
				}
				continue;
			}

			let tmpAngleStep = (2 * Math.PI) / tmpRing.length;
			for (let i = 0; i < tmpRing.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpRing[i]];
				if (!tmpNode) continue;
				let tmpAngle = tmpStartRad + tmpAngleSign * i * tmpAngleStep;
				let tmpW = tmpNode.Width || 180;
				let tmpH = tmpNode.Height || 80;
				tmpNode.X = tmpCenterX + Math.cos(tmpAngle) * tmpRadius - tmpW / 2;
				tmpNode.Y = tmpCenterY + Math.sin(tmpAngle) * tmpRadius - tmpH / 2;
			}
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		CenterX: 1000,
		CenterY: 750,
		RingSpacing: 220,
		InnerRadius: 0,
		StartAngle: -90,
		Direction: 'cw'
	},

	ParameterSchema:
	{
		Spacing:     { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		CenterX:     { Type: 'PreciseNumber', Label: 'Center X',     Default: 1000, Min: -10000, Max: 10000 },
		CenterY:     { Type: 'PreciseNumber', Label: 'Center Y',     Default: 750,  Min: -10000, Max: 10000 },
		RingSpacing: { Type: 'PreciseNumber', Label: 'Ring spacing', Default: 220,  Min: 1, Max: 5000 },
		InnerRadius: { Type: 'PreciseNumber', Label: 'Inner radius', Default: 0,    Min: 0, Max: 5000 },
		StartAngle:  { Type: 'PreciseNumber', Label: 'Start angle (deg)', Default: -90, Min: -360, Max: 360 },
		Direction:   { Type: 'enum',          Label: 'Direction',    Default: 'cw', Options: ['cw', 'ccw'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Circular',
		Sections:
		[
			{ Name: 'Circular Parameters', Hash: 'PFLCircularSection', Groups: [{ Name: 'Defaults', Hash: 'PFLCircularGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.CenterX':
			{ Name: 'Center X', Hash: 'CenterX', DataType: 'PreciseNumber', Default: 1000, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterY':
			{ Name: 'Center Y', Hash: 'CenterY', DataType: 'PreciseNumber', Default: 750, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.RingSpacing':
			{ Name: 'Ring spacing', Hash: 'RingSpacing', DataType: 'PreciseNumber', Default: 220, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.InnerRadius':
			{ Name: 'Inner radius', Hash: 'InnerRadius', DataType: 'PreciseNumber', Default: 0, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 2, Width: 6, Min: 0, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.StartAngle':
			{ Name: 'Start angle (deg)', Hash: 'StartAngle', DataType: 'PreciseNumber', Default: -90, PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 3, Width: 6, Min: -360, Max: 360 } },
			'PictFlowLayoutEditor.Parameters.Direction':
			{
				Name: 'Direction', Hash: 'Direction', DataType: 'String', Default: 'cw',
				PictForm: { Section: 'PFLCircularSection', Group: 'PFLCircularGroup', Row: 3, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'cw', Name: 'Clockwise' }, { Value: 'ccw', Name: 'Counter-clockwise' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":43}],43:[function(require,module,exports){
/**
 * Layout-Coerce
 *
 * Tiny coercion helpers for layout-algorithm parameters. Manyfest's
 * `PreciseNumber` DataType stores values as strings (so big.js /
 * fable.ExpressionParser can do arbitrary-precision math on them
 * without float drift). The simulation code in each layout algorithm
 * uses native JS Math, so we coerce at the entry point.
 *
 * Apply functions accept either format (number or string) and use
 * these helpers to normalize.
 */

function _toFloat(pValue, pDefault)
{
	if (typeof pValue === 'number' && !isNaN(pValue)) return pValue;
	if (typeof pValue === 'string' && pValue !== '')
	{
		let tmpNum = parseFloat(pValue);
		if (!isNaN(tmpNum)) return tmpNum;
	}
	return pDefault;
}

function _toInt(pValue, pDefault)
{
	if (typeof pValue === 'number' && !isNaN(pValue)) return Math.floor(pValue);
	if (typeof pValue === 'string' && pValue !== '')
	{
		let tmpNum = parseInt(pValue, 10);
		if (!isNaN(tmpNum)) return tmpNum;
	}
	return pDefault;
}

module.exports =
{
	toFloat: _toFloat,
	toInt: _toInt
};

},{}],44:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Columnar
 *
 * N-column layout with deterministic fill order. Distinct from Grid in
 * two ways:
 *   - Columns is always explicit (no 'auto')
 *   - FillOrder controls whether nodes flow row-first or column-first
 *
 * The column count is `Number` (integer index); spacing/origin values
 * are `PreciseNumber` so they survive solver chains.
 */
module.exports =
{
	Name: 'Columnar',
	Label: 'Columnar (N Columns)',
	Description: 'Explicit N columns; flow row-first or column-first.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing         = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpColumns         = Math.max(1, libCoerce.toInt(tmpParams.Columns, 3));
		let tmpColumnSpacing   = libCoerce.toFloat(tmpParams.ColumnSpacing, 40) * tmpSpacing;
		let tmpRowSpacing      = libCoerce.toFloat(tmpParams.RowSpacing, 40) * tmpSpacing;
		let tmpStartX          = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY          = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpFillOrder       = (tmpParams.FillOrder === 'column') ? 'column' : 'row';
		let tmpOrderBy         = tmpParams.OrderBy || 'index';

		// Compute cell dimensions from largest node
		let tmpMaxWidth = 0;
		let tmpMaxHeight = 0;
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMaxWidth = Math.max(tmpMaxWidth, pNodes[i].Width || 180);
			tmpMaxHeight = Math.max(tmpMaxHeight, pNodes[i].Height || 80);
		}
		let tmpCellWidth  = tmpMaxWidth + tmpColumnSpacing;
		let tmpCellHeight = tmpMaxHeight + tmpRowSpacing;

		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		let tmpRows = Math.ceil(tmpOrdered.length / tmpColumns);

		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpRow;
			let tmpCol;
			if (tmpFillOrder === 'column')
			{
				tmpCol = Math.floor(i / tmpRows);
				tmpRow = i % tmpRows;
			}
			else
			{
				tmpRow = Math.floor(i / tmpColumns);
				tmpCol = i % tmpColumns;
			}
			tmpOrdered[i].X = tmpStartX + tmpCol * tmpCellWidth;
			tmpOrdered[i].Y = tmpStartY + tmpRow * tmpCellHeight;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Columns: 3,
		ColumnSpacing: 40,
		RowSpacing: 40,
		StartX: 100,
		StartY: 100,
		FillOrder: 'row',
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:       { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Columns:       { Type: 'Number',        Label: 'Columns',        Default: 3,   Min: 1, Max: 50 },
		ColumnSpacing: { Type: 'PreciseNumber', Label: 'Column spacing', Default: 40,  Min: 0, Max: 1000 },
		RowSpacing:    { Type: 'PreciseNumber', Label: 'Row spacing',    Default: 40,  Min: 0, Max: 1000 },
		StartX:        { Type: 'PreciseNumber', Label: 'Start X',        Default: 100, Min: -10000, Max: 10000 },
		StartY:        { Type: 'PreciseNumber', Label: 'Start Y',        Default: 100, Min: -10000, Max: 10000 },
		FillOrder:     { Type: 'enum',          Label: 'Fill order',     Default: 'row', Options: ['row', 'column'] },
		OrderBy:       { Type: 'enum',          Label: 'Order by',       Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Columnar',
		Sections:
		[
			{ Name: 'Columnar Parameters', Hash: 'PFLColumnarSection', Groups: [{ Name: 'Defaults', Hash: 'PFLColumnarGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.Columns':
			{ Name: 'Columns', Hash: 'Columns', DataType: 'Number', Default: 3, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 1, Width: 6, Min: 1, Max: 50 } },
			'PictFlowLayoutEditor.Parameters.FillOrder':
			{
				Name: 'Fill order', Hash: 'FillOrder', DataType: 'String', Default: 'row',
				PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 1, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'row', Name: 'Row-first' }, { Value: 'column', Name: 'Column-first' }] }
			},
			'PictFlowLayoutEditor.Parameters.ColumnSpacing':
			{ Name: 'Column spacing', Hash: 'ColumnSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.RowSpacing':
			{ Name: 'Row spacing', Hash: 'RowSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 3, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 3, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLColumnarSection', Group: 'PFLColumnarGroup', Row: 4, Width: 12, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":43}],45:[function(require,module,exports){
/**
 * Layout-Custom
 *
 * No-op layout algorithm. Preserves the X/Y values currently on each
 * node so users can hand-place nodes without an algorithm clobbering
 * positions on the next render.
 *
 * Selecting "Custom" with auto-apply enabled is effectively a no-op
 * on every structural change — useful as a way to disable the
 * configured algorithm without unsetting it.
 */
module.exports =
{
	Name: 'Custom',
	Label: 'Custom (Hand-placed)',
	Description: 'Preserve hand-placed positions. No automatic arrangement.',
	DefaultEdgeTheme: 'Bezier',

	Apply: function (pNodes, pConnections, pParameters)
	{
		// Intentionally empty — Custom is a no-op.
	},

	DefaultParameters: {},

	ParameterSchema: {}
};

},{}],46:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-ForcedFromCenter
 *
 * Force-directed simulation in the Fruchterman-Reingold style:
 *   - Spring (attractive) forces along each connection
 *   - Coulomb-style repulsion between every pair of nodes
 *   - Center-attraction force pulling all nodes toward (CenterX, CenterY)
 *   - Cooling schedule: max displacement per iteration shrinks over time
 *
 * Deterministic by default — initial positions for unplaced nodes are
 * generated from a seedable Mulberry32 PRNG (inline implementation, no
 * new dependencies). Tests pin `Seed` to assert byte-identical output.
 *
 * Performance: O(n^2) per iteration. With Iterations=200 this is fine
 * for ~100 nodes; keep ForcedFromCenter for moderate-sized graphs.
 *
 * Numeric parameters (other than Iterations and Seed) are typed
 * `PreciseNumber` so they round-trip cleanly through the
 * ExpressionParser; the simulation coerces back to JS floats via
 * Layout-Coerce. Iterations and Seed stay `Number` because they're
 * loop counters / bitwise-PRNG state.
 */
module.exports =
{
	Name: 'ForcedFromCenter',
	Label: 'Forced from Center',
	Description: 'Spring + repulsion simulation pulling toward a center point.',
	DefaultEdgeTheme: 'Bezier',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing            = libCoerce.toFloat(tmpParams.Spacing,            1.0);
		let tmpIterations         = libCoerce.toInt(tmpParams.Iterations,         200);
		let tmpCenterX            = libCoerce.toFloat(tmpParams.CenterX,            1000);
		let tmpCenterY            = libCoerce.toFloat(tmpParams.CenterY,            750);
		let tmpSpringLength       = libCoerce.toFloat(tmpParams.SpringLength,       200) * tmpSpacing;
		let tmpSpringStiffness    = libCoerce.toFloat(tmpParams.SpringStiffness,    0.05);
		let tmpRepulsion          = libCoerce.toFloat(tmpParams.Repulsion,          8000);
		let tmpCenterAttraction   = libCoerce.toFloat(tmpParams.CenterAttraction,   0.01);
		let tmpCoolingFactor      = libCoerce.toFloat(tmpParams.CoolingFactor,      0.95);
		let tmpInitialTemperature = libCoerce.toFloat(tmpParams.InitialTemperature, 100);
		let tmpSeed               = libCoerce.toInt(tmpParams.Seed,               42);
		let tmpPreservePositions  = !!tmpParams.PreservePositions;
		let tmpInitialSpread      = libCoerce.toFloat(tmpParams.InitialSpread,      400);

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		// Mulberry32 seeded PRNG — deterministic initial-position generator.
		let tmpRand = _makeMulberry32(tmpSeed >>> 0);

		// Initial positions
		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			let tmpHasPosition = (typeof tmpNode.X === 'number' && typeof tmpNode.Y === 'number');
			if (tmpPreservePositions && tmpHasPosition) continue;
			tmpNode.X = tmpCenterX + (tmpRand() - 0.5) * tmpInitialSpread;
			tmpNode.Y = tmpCenterY + (tmpRand() - 0.5) * tmpInitialSpread;
		}

		// Index nodes by hash for connection lookup
		let tmpNodeMap = {};
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpNodeMap[pNodes[i].Hash] = pNodes[i];
		}

		let tmpTemperature = tmpInitialTemperature;

		for (let tmpIter = 0; tmpIter < tmpIterations; tmpIter++)
		{
			// Force accumulators
			let tmpForceX = new Array(pNodes.length).fill(0);
			let tmpForceY = new Array(pNodes.length).fill(0);

			// Repulsion between every pair of nodes
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpA = pNodes[i];
				for (let j = i + 1; j < pNodes.length; j++)
				{
					let tmpB = pNodes[j];
					let tmpDX = tmpA.X - tmpB.X;
					let tmpDY = tmpA.Y - tmpB.Y;
					let tmpDistSq = tmpDX * tmpDX + tmpDY * tmpDY;
					if (tmpDistSq < 1) tmpDistSq = 1; // avoid singularities
					let tmpDist = Math.sqrt(tmpDistSq);
					let tmpForce = tmpRepulsion / tmpDistSq;
					let tmpFX = (tmpDX / tmpDist) * tmpForce;
					let tmpFY = (tmpDY / tmpDist) * tmpForce;
					tmpForceX[i] += tmpFX;
					tmpForceY[i] += tmpFY;
					tmpForceX[j] -= tmpFX;
					tmpForceY[j] -= tmpFY;
				}
			}

			// Spring forces along connections
			for (let i = 0; i < tmpConnections.length; i++)
			{
				let tmpConn = tmpConnections[i];
				let tmpSource = tmpNodeMap[tmpConn.SourceNodeHash];
				let tmpTarget = tmpNodeMap[tmpConn.TargetNodeHash];
				if (!tmpSource || !tmpTarget) continue;

				let tmpSourceIdx = pNodes.indexOf(tmpSource);
				let tmpTargetIdx = pNodes.indexOf(tmpTarget);
				if (tmpSourceIdx < 0 || tmpTargetIdx < 0) continue;

				let tmpDX = tmpTarget.X - tmpSource.X;
				let tmpDY = tmpTarget.Y - tmpSource.Y;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				if (tmpDist < 0.0001) tmpDist = 0.0001;

				let tmpDelta = tmpDist - tmpSpringLength;
				let tmpForce = tmpSpringStiffness * tmpDelta;
				let tmpFX = (tmpDX / tmpDist) * tmpForce;
				let tmpFY = (tmpDY / tmpDist) * tmpForce;

				tmpForceX[tmpSourceIdx] += tmpFX;
				tmpForceY[tmpSourceIdx] += tmpFY;
				tmpForceX[tmpTargetIdx] -= tmpFX;
				tmpForceY[tmpTargetIdx] -= tmpFY;
			}

			// Center attraction
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpNode = pNodes[i];
				tmpForceX[i] += (tmpCenterX - tmpNode.X) * tmpCenterAttraction;
				tmpForceY[i] += (tmpCenterY - tmpNode.Y) * tmpCenterAttraction;
			}

			// Apply forces with temperature clamp
			for (let i = 0; i < pNodes.length; i++)
			{
				let tmpNode = pNodes[i];
				let tmpFX = tmpForceX[i];
				let tmpFY = tmpForceY[i];
				let tmpMag = Math.sqrt(tmpFX * tmpFX + tmpFY * tmpFY);
				if (tmpMag > tmpTemperature)
				{
					tmpFX = (tmpFX / tmpMag) * tmpTemperature;
					tmpFY = (tmpFY / tmpMag) * tmpTemperature;
				}
				tmpNode.X += tmpFX;
				tmpNode.Y += tmpFY;
			}

			tmpTemperature *= tmpCoolingFactor;
		}

		// Round to whole pixels for stable rendering and predictable tests
		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X = Math.round(pNodes[i].X);
			pNodes[i].Y = Math.round(pNodes[i].Y);
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Iterations: 200,
		CenterX: 1000,
		CenterY: 750,
		SpringLength: 200,
		SpringStiffness: 0.05,
		Repulsion: 8000,
		CenterAttraction: 0.01,
		CoolingFactor: 0.95,
		InitialTemperature: 100,
		Seed: 42,
		PreservePositions: false,
		InitialSpread: 400
	},

	ParameterSchema:
	{
		Spacing:            { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Iterations:         { Type: 'Number',        Label: 'Iterations',         Default: 200,   Min: 1,    Max: 2000  },
		CenterX:            { Type: 'PreciseNumber', Label: 'Center X',           Default: 1000,  Min: -10000, Max: 10000 },
		CenterY:            { Type: 'PreciseNumber', Label: 'Center Y',           Default: 750,   Min: -10000, Max: 10000 },
		SpringLength:       { Type: 'PreciseNumber', Label: 'Spring length',      Default: 200,   Min: 1,    Max: 2000  },
		SpringStiffness:    { Type: 'PreciseNumber', Label: 'Spring stiffness',   Default: 0.05,  Min: 0,    Max: 1     },
		Repulsion:          { Type: 'PreciseNumber', Label: 'Repulsion',          Default: 8000,  Min: 0,    Max: 100000 },
		CenterAttraction:   { Type: 'PreciseNumber', Label: 'Center attraction',  Default: 0.01,  Min: 0,    Max: 1     },
		CoolingFactor:      { Type: 'PreciseNumber', Label: 'Cooling factor',     Default: 0.95,  Min: 0.5,  Max: 1     },
		InitialTemperature: { Type: 'PreciseNumber', Label: 'Initial temperature', Default: 100,  Min: 1,    Max: 1000  },
		Seed:               { Type: 'Number',        Label: 'Random seed',        Default: 42,    Min: 0,    Max: 2147483647 },
		PreservePositions:  { Type: 'boolean',       Label: 'Preserve positions', Default: false },
		InitialSpread:      { Type: 'PreciseNumber', Label: 'Initial spread',     Default: 400,   Min: 0,    Max: 5000  }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-ForcedFromCenter',
		Sections:
		[
			{ Name: 'Center', Hash: 'PFLCenterSection', Groups: [{ Name: 'Defaults', Hash: 'PFLCenterGroup' }] },
			{ Name: 'Forces', Hash: 'PFLForcesSection', Groups: [{ Name: 'Defaults', Hash: 'PFLForcesGroup' }] },
			{ Name: 'Simulation', Hash: 'PFLSimSection', Groups: [{ Name: 'Defaults', Hash: 'PFLSimGroup' }] },
			{ Name: 'Initialization', Hash: 'PFLInitSection', Groups: [{ Name: 'Defaults', Hash: 'PFLInitGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.CenterX':
			{ Name: 'Center X', Hash: 'CenterX', DataType: 'PreciseNumber', Default: 1000, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterY':
			{ Name: 'Center Y', Hash: 'CenterY', DataType: 'PreciseNumber', Default: 750, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.CenterAttraction':
			{ Name: 'Center attraction', Hash: 'CenterAttraction', DataType: 'PreciseNumber', Default: 0.01, PictForm: { Section: 'PFLCenterSection', Group: 'PFLCenterGroup', Row: 2, Width: 12, Min: 0, Max: 1 } },

			'PictFlowLayoutEditor.Parameters.SpringLength':
			{ Name: 'Spring length', Hash: 'SpringLength', DataType: 'PreciseNumber', Default: 200, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 1, Width: 6, Min: 1, Max: 2000 } },
			'PictFlowLayoutEditor.Parameters.SpringStiffness':
			{ Name: 'Spring stiffness', Hash: 'SpringStiffness', DataType: 'PreciseNumber', Default: 0.05, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 1, Width: 6, Min: 0, Max: 1 } },
			'PictFlowLayoutEditor.Parameters.Repulsion':
			{ Name: 'Repulsion', Hash: 'Repulsion', DataType: 'PreciseNumber', Default: 8000, PictForm: { Section: 'PFLForcesSection', Group: 'PFLForcesGroup', Row: 2, Width: 12, Min: 0, Max: 100000 } },

			'PictFlowLayoutEditor.Parameters.Iterations':
			{ Name: 'Iterations', Hash: 'Iterations', DataType: 'Number', Default: 200, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 1, Width: 6, Min: 1, Max: 2000 } },
			'PictFlowLayoutEditor.Parameters.CoolingFactor':
			{ Name: 'Cooling factor', Hash: 'CoolingFactor', DataType: 'PreciseNumber', Default: 0.95, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 1, Width: 6, Min: 0.5, Max: 1 } },
			'PictFlowLayoutEditor.Parameters.InitialTemperature':
			{ Name: 'Initial temperature', Hash: 'InitialTemperature', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLSimSection', Group: 'PFLSimGroup', Row: 2, Width: 12, Min: 1, Max: 1000 } },

			'PictFlowLayoutEditor.Parameters.Seed':
			{ Name: 'Random seed', Hash: 'Seed', DataType: 'Number', Default: 42, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 1, Width: 6, Min: 0, Max: 2147483647 } },
			'PictFlowLayoutEditor.Parameters.InitialSpread':
			{ Name: 'Initial spread', Hash: 'InitialSpread', DataType: 'PreciseNumber', Default: 400, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 1, Width: 6, Min: 0, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.PreservePositions':
			{ Name: 'Preserve existing positions', Hash: 'PreservePositions', DataType: 'Boolean', Default: false, PictForm: { Section: 'PFLInitSection', Group: 'PFLInitGroup', Row: 2, Width: 12, InputType: 'Boolean' } }
		}
	}
};

function _makeMulberry32(pSeed)
{
	let tmpState = pSeed >>> 0;
	return function ()
	{
		tmpState = (tmpState + 0x6D2B79F5) >>> 0;
		let tmpT = tmpState;
		tmpT = Math.imul(tmpT ^ (tmpT >>> 15), tmpT | 1);
		tmpT ^= tmpT + Math.imul(tmpT ^ (tmpT >>> 7), tmpT | 61);
		return ((tmpT ^ (tmpT >>> 14)) >>> 0) / 4294967296;
	};
}

},{"./Layout-Coerce.js":43}],47:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Grid
 *
 * Auto-arrange nodes in a roughly-square grid. Cell width and height
 * default to the largest node dimensions plus margins. Column count
 * defaults to ceil(sqrt(n)) when `Columns` is 'auto'.
 *
 * Continuous params (margins, cell sizes, origin) are typed
 * `PreciseNumber` so they survive solver chains; the integer column
 * count and the categorical OrderBy stay `Number` / enum.
 */
module.exports =
{
	Name: 'Grid',
	Label: 'Grid',
	Description: 'Auto-arrange in a roughly-square grid.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing          = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpColumnsParam     = tmpParams.Columns;
		let tmpCellWidthParam   = tmpParams.CellWidth;
		let tmpCellHeightParam  = tmpParams.CellHeight;
		let tmpHorizontalMargin = libCoerce.toFloat(tmpParams.HorizontalMargin, 40) * tmpSpacing;
		let tmpVerticalMargin   = libCoerce.toFloat(tmpParams.VerticalMargin, 40) * tmpSpacing;
		let tmpStartX           = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY           = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpOrderBy          = tmpParams.OrderBy || 'index';

		let tmpColumns;
		if (tmpColumnsParam === 'auto' || tmpColumnsParam == null || tmpColumnsParam === '')
		{
			tmpColumns = Math.max(1, Math.ceil(Math.sqrt(pNodes.length)));
		}
		else
		{
			tmpColumns = Math.max(1, libCoerce.toInt(tmpColumnsParam, Math.max(1, Math.ceil(Math.sqrt(pNodes.length)))));
		}

		// Compute cell dimensions from largest node if not specified
		let tmpMaxWidth = 0;
		let tmpMaxHeight = 0;
		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMaxWidth = Math.max(tmpMaxWidth, pNodes[i].Width || 180);
			tmpMaxHeight = Math.max(tmpMaxHeight, pNodes[i].Height || 80);
		}

		let tmpCellWidth  = (tmpCellWidthParam == null)  ? tmpMaxWidth + tmpHorizontalMargin  : libCoerce.toFloat(tmpCellWidthParam,  tmpMaxWidth + tmpHorizontalMargin);
		let tmpCellHeight = (tmpCellHeightParam == null) ? tmpMaxHeight + tmpVerticalMargin : libCoerce.toFloat(tmpCellHeightParam, tmpMaxHeight + tmpVerticalMargin);

		// Ordered iteration
		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpRow = Math.floor(i / tmpColumns);
			let tmpCol = i % tmpColumns;
			tmpOrdered[i].X = tmpStartX + tmpCol * tmpCellWidth;
			tmpOrdered[i].Y = tmpStartY + tmpRow * tmpCellHeight;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		Columns: 'auto',
		HorizontalMargin: 40,
		VerticalMargin: 40,
		StartX: 100,
		StartY: 100,
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:          { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		Columns:          { Type: 'string',        Label: 'Columns',          Default: 'auto', Description: '"auto" or an integer' },
		CellWidth:        { Type: 'PreciseNumber', Label: 'Cell width',       Description: 'Defaults to largest node width + horizontal margin', Min: 1, Max: 5000 },
		CellHeight:       { Type: 'PreciseNumber', Label: 'Cell height',      Description: 'Defaults to largest node height + vertical margin', Min: 1, Max: 5000 },
		HorizontalMargin: { Type: 'PreciseNumber', Label: 'Horizontal margin', Default: 40, Min: 0, Max: 1000 },
		VerticalMargin:   { Type: 'PreciseNumber', Label: 'Vertical margin',   Default: 40, Min: 0, Max: 1000 },
		StartX:           { Type: 'PreciseNumber', Label: 'Start X',          Default: 100, Min: -10000, Max: 10000 },
		StartY:           { Type: 'PreciseNumber', Label: 'Start Y',          Default: 100, Min: -10000, Max: 10000 },
		OrderBy:          { Type: 'enum',          Label: 'Order by',         Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Grid',
		Sections:
		[
			{ Name: 'Grid Parameters', Hash: 'PFLGridSection', Groups: [{ Name: 'Defaults', Hash: 'PFLGridGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.Columns':
			{ Name: 'Columns ("auto" or integer)', Hash: 'Columns', DataType: 'String', Default: 'auto', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 1, Width: 6 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 1, Width: 6, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			},
			'PictFlowLayoutEditor.Parameters.CellWidth':
			{ Name: 'Cell width (auto = blank)', Hash: 'CellWidth', DataType: 'PreciseNumber', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.CellHeight':
			{ Name: 'Cell height (auto = blank)', Hash: 'CellHeight', DataType: 'PreciseNumber', PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.HorizontalMargin':
			{ Name: 'Horizontal margin', Hash: 'HorizontalMargin', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 3, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.VerticalMargin':
			{ Name: 'Vertical margin', Hash: 'VerticalMargin', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 3, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 4, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLGridSection', Group: 'PFLGridGroup', Row: 4, Width: 6, Min: -10000, Max: 10000 } }
		}
	}
};

},{"./Layout-Coerce.js":43}],48:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Layered
 *
 * Topological-sort (Kahn's algorithm) left-to-right layered layout.
 *
 * This is the original `autoLayout` behavior of pict-section-flow,
 * extracted into a layout-algorithm descriptor. Calling
 * `_LayoutService.autoLayout(nodes, connections)` with no algorithm
 * argument dispatches here, preserving backwards compatibility.
 *
 * Numeric parameters are typed `PreciseNumber` (big.js-backed strings)
 * so they survive ExpressionParser solver chains without float drift;
 * the simulation coerces back to JS floats at entry via Layout-Coerce.
 */
module.exports =
{
	Name: 'Layered',
	Label: 'Layered (Topological)',
	Description: 'Left-to-right layers based on connection topology.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing           = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpHorizontalSpacing = libCoerce.toFloat(tmpParams.HorizontalSpacing, 250) * tmpSpacing;
		let tmpVerticalSpacing   = libCoerce.toFloat(tmpParams.VerticalSpacing, 120) * tmpSpacing;
		let tmpStartX            = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY            = libCoerce.toFloat(tmpParams.StartY, 100);

		let tmpConnections = Array.isArray(pConnections) ? pConnections : [];

		// Build adjacency information
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		for (let i = 0; i < tmpConnections.length; i++)
		{
			let tmpConn = tmpConnections[i];
			if (tmpInDegree.hasOwnProperty(tmpConn.TargetNodeHash))
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
			}
			if (tmpOutEdges.hasOwnProperty(tmpConn.SourceNodeHash))
			{
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];
			let tmpNextQueue = [];

			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle cycles or disconnected nodes
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			if (!tmpAssigned[pNodes[i].Hash])
			{
				tmpRemainingNodes.push(pNodes[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + tmpVerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + tmpHorizontalSpacing;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		HorizontalSpacing: 250,
		VerticalSpacing: 120,
		StartX: 100,
		StartY: 100
	},

	ParameterSchema:
	{
		Spacing:           { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		HorizontalSpacing: { Type: 'PreciseNumber', Label: 'Horizontal spacing', Default: 250, Min: 0, Max: 1000 },
		VerticalSpacing:   { Type: 'PreciseNumber', Label: 'Vertical spacing',   Default: 120, Min: 0, Max: 1000 },
		StartX:            { Type: 'PreciseNumber', Label: 'Start X',            Default: 100, Min: -10000, Max: 10000 },
		StartY:            { Type: 'PreciseNumber', Label: 'Start Y',            Default: 100, Min: -10000, Max: 10000 }
	},

	// Manyfest descriptor catalog consumed by pict-section-form's metacontroller.
	// Descriptor keys are full data paths relative to the marshal destination
	// (default `AppData`); the toolbar binds `AppData.PictFlowLayoutEditor.Parameters`
	// to the active flow's `_FlowData.LayoutParameters` before injecting.
	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Layered',
		Sections:
		[
			{ Name: 'Layered Parameters', Hash: 'PictFlowLayoutSection', Groups: [{ Name: 'Defaults', Hash: 'PictFlowLayoutGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{
				Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 }
			},
			'PictFlowLayoutEditor.Parameters.HorizontalSpacing':
			{
				Name: 'Horizontal spacing', Hash: 'HorizontalSpacing', DataType: 'PreciseNumber', Default: 250,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 1, Width: 6, Min: 0, Max: 1000 }
			},
			'PictFlowLayoutEditor.Parameters.VerticalSpacing':
			{
				Name: 'Vertical spacing', Hash: 'VerticalSpacing', DataType: 'PreciseNumber', Default: 120,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 1, Width: 6, Min: 0, Max: 1000 }
			},
			'PictFlowLayoutEditor.Parameters.StartX':
			{
				Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 }
			},
			'PictFlowLayoutEditor.Parameters.StartY':
			{
				Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100,
				PictForm: { Section: 'PictFlowLayoutSection', Group: 'PictFlowLayoutGroup', Row: 2, Width: 6, Min: -10000, Max: 10000 }
			}
		}
	}
};

},{"./Layout-Coerce.js":43}],49:[function(require,module,exports){
const libCoerce = require('./Layout-Coerce.js');

/**
 * Layout-Tabular
 *
 * Vertical single-column flow. Nodes are stacked top-to-bottom with
 * VerticalSpacing between successive rows.
 */
module.exports =
{
	Name: 'Tabular',
	Label: 'Tabular (Top-to-Bottom)',
	Description: 'Single column, top-to-bottom.',
	DefaultEdgeTheme: 'Orthogonal',

	Apply: function (pNodes, pConnections, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpParams = pParameters || {};
		let tmpSpacing         = libCoerce.toFloat(tmpParams.Spacing, 1.0);
		let tmpStartX          = libCoerce.toFloat(tmpParams.StartX, 100);
		let tmpStartY          = libCoerce.toFloat(tmpParams.StartY, 100);
		let tmpVerticalSpacing = libCoerce.toFloat(tmpParams.VerticalSpacing, 40) * tmpSpacing;
		let tmpRowHeightParam  = tmpParams.RowHeight;
		let tmpOrderBy         = tmpParams.OrderBy || 'index';

		let tmpOrdered = pNodes.slice();
		if (tmpOrderBy === 'hash')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
		}
		else if (tmpOrderBy === 'title')
		{
			tmpOrdered.sort((pA, pB) => String(pA.Title || pA.Hash).localeCompare(String(pB.Title || pB.Hash)));
		}

		let tmpY = tmpStartY;
		for (let i = 0; i < tmpOrdered.length; i++)
		{
			let tmpNode = tmpOrdered[i];
			tmpNode.X = tmpStartX;
			tmpNode.Y = tmpY;
			let tmpRowHeight = (tmpRowHeightParam == null) ? (tmpNode.Height || 80) : libCoerce.toFloat(tmpRowHeightParam, tmpNode.Height || 80);
			tmpY += tmpRowHeight + tmpVerticalSpacing;
		}
	},

	DefaultParameters:
	{
		Spacing: 1.0,
		StartX: 100,
		StartY: 100,
		VerticalSpacing: 40,
		OrderBy: 'index'
	},

	ParameterSchema:
	{
		Spacing:         { Type: 'PreciseNumber', Label: 'Spacing (multiplier)', Default: 1.0, Min: 0.1, Max: 5 },
		StartX:          { Type: 'PreciseNumber', Label: 'Start X',          Default: 100, Min: -10000, Max: 10000 },
		StartY:          { Type: 'PreciseNumber', Label: 'Start Y',          Default: 100, Min: -10000, Max: 10000 },
		VerticalSpacing: { Type: 'PreciseNumber', Label: 'Vertical spacing', Default: 40,  Min: 0, Max: 1000 },
		RowHeight:       { Type: 'PreciseNumber', Label: 'Row height',       Description: 'Defaults to each node\'s own height', Min: 1, Max: 5000 },
		OrderBy:         { Type: 'enum',          Label: 'Order by',         Default: 'index', Options: ['index', 'hash', 'title'] }
	},

	ParameterManifest:
	{
		Scope: 'PictFlowLayout-Tabular',
		Sections:
		[
			{ Name: 'Tabular Parameters', Hash: 'PFLTabularSection', Groups: [{ Name: 'Defaults', Hash: 'PFLTabularGroup' }] }
		],
		Descriptors:
		{
			'PictFlowLayoutEditor.Parameters.Spacing':
			{ Name: 'Spacing (multiplier)', Hash: 'Spacing', DataType: 'PreciseNumber', Default: 1.0, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 0, Width: 12, Min: 0.1, Max: 5 } },
			'PictFlowLayoutEditor.Parameters.StartX':
			{ Name: 'Start X', Hash: 'StartX', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.StartY':
			{ Name: 'Start Y', Hash: 'StartY', DataType: 'PreciseNumber', Default: 100, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 1, Width: 6, Min: -10000, Max: 10000 } },
			'PictFlowLayoutEditor.Parameters.VerticalSpacing':
			{ Name: 'Vertical spacing', Hash: 'VerticalSpacing', DataType: 'PreciseNumber', Default: 40, PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 2, Width: 6, Min: 0, Max: 1000 } },
			'PictFlowLayoutEditor.Parameters.RowHeight':
			{ Name: 'Row height (auto = blank)', Hash: 'RowHeight', DataType: 'PreciseNumber', PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 2, Width: 6, Min: 1, Max: 5000 } },
			'PictFlowLayoutEditor.Parameters.OrderBy':
			{
				Name: 'Order by', Hash: 'OrderBy', DataType: 'String', Default: 'index',
				PictForm: { Section: 'PFLTabularSection', Group: 'PFLTabularGroup', Row: 3, Width: 12, InputType: 'Option', SelectOptions: [{ Value: 'index', Name: 'Index' }, { Value: 'hash', Name: 'Hash' }, { Value: 'title', Name: 'Title' }] }
			}
		}
	}
};

},{"./Layout-Coerce.js":43}],50:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ConnectionHandleManager
 *
 * Manages connection handle lifecycle: dragging, adding, removing,
 * and resetting bezier/orthogonal handles on connections and tethers.
 *
 * Extracted from PictView-Flow.js to isolate handle CRUD operations
 * from the main view.
 */
class PictServiceFlowConnectionHandleManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionHandleManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Update a connection handle position during drag (for real-time feedback).
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType - 'bezier-midpoint', 'bezier-handle-N', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};
		tmpConnection.Data.HandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(tmpConnection.Data.BezierHandles)
				&& tmpIndex < tmpConnection.Data.BezierHandles.length)
			{
				tmpConnection.Data.BezierHandles[tmpIndex].x = pX;
				tmpConnection.Data.BezierHandles[tmpIndex].y = pY;
			}
			this._FlowView._renderSingleConnection(pConnectionHash);
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Legacy single-handle: migrate to BezierHandles array
				if (!Array.isArray(tmpConnection.Data.BezierHandles)
					|| tmpConnection.Data.BezierHandles.length === 0)
				{
					tmpConnection.Data.BezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					tmpConnection.Data.BezierHandles[0].x = pX;
					tmpConnection.Data.BezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync for backward compat
				tmpConnection.Data.BezierHandleX = pX;
				tmpConnection.Data.BezierHandleY = pY;
				break;

			case 'ortho-corner1':
				tmpConnection.Data.OrthoCorner1X = pX;
				tmpConnection.Data.OrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				tmpConnection.Data.OrthoCorner2X = pX;
				tmpConnection.Data.OrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
			{
				// Midpoint drag shifts the corridor offset
				let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
				let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);
				if (tmpSourcePos && tmpTargetPos)
				{
					let tmpGeom = this._FlowView._ConnectionRenderer._computeDirectionalGeometry(tmpSourcePos, tmpTargetPos);
					let tmpStartDir = tmpGeom.startDir;

					// Compute offset along the corridor axis
					if (Math.abs(tmpStartDir.dx) > Math.abs(tmpStartDir.dy))
					{
						// Horizontal departure — corridor is vertical, shift is along X
						let tmpAutoMidX = (tmpGeom.departX + tmpGeom.approachX) / 2;
						tmpConnection.Data.OrthoMidOffset = pX - tmpAutoMidX;
					}
					else
					{
						// Vertical departure — corridor is horizontal, shift is along Y
						let tmpAutoMidY = (tmpGeom.departY + tmpGeom.approachY) / 2;
						tmpConnection.Data.OrthoMidOffset = pY - tmpAutoMidY;
					}
				}
				break;
			}
		}

		this._FlowView._renderSingleConnection(pConnectionHash);
	}

	/**
	 * Add a bezier handle to a connection at the specified position.
	 * The handle is inserted at the correct index based on which
	 * segment of the curve the click point is closest to.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addConnectionHandle(pConnectionHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		// Ensure BezierHandles array exists (migrate from legacy if needed)
		if (!Array.isArray(tmpConnection.Data.BezierHandles))
		{
			tmpConnection.Data.BezierHandles = [];
			if (tmpConnection.Data.BezierHandleX != null && tmpConnection.Data.BezierHandleY != null)
			{
				tmpConnection.Data.BezierHandles.push({
					x: tmpConnection.Data.BezierHandleX,
					y: tmpConnection.Data.BezierHandleY
				});
			}
		}

		// Ensure bezier mode
		tmpConnection.Data.LineMode = 'bezier';

		let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);

		let tmpInsertIndex = 0;
		if (tmpSourcePos && tmpTargetPos && this._FlowView._ConnectionRenderer)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				tmpConnection.Data.BezierHandles,
				{ x: pX, y: pY },
				tmpSourcePos,
				tmpTargetPos
			);
		}

		tmpConnection.Data.BezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		tmpConnection.Data.HandleCustomized = true;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a connection by index.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pIndex - Index in the BezierHandles array
	 */
	removeConnectionHandle(pConnectionHash, pIndex)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection || !tmpConnection.Data) return;

		if (!Array.isArray(tmpConnection.Data.BezierHandles)) return;
		if (pIndex < 0 || pIndex >= tmpConnection.Data.BezierHandles.length) return;

		tmpConnection.Data.BezierHandles.splice(pIndex, 1);

		if (tmpConnection.Data.BezierHandles.length === 0)
		{
			tmpConnection.Data.HandleCustomized = false;
			tmpConnection.Data.BezierHandleX = null;
			tmpConnection.Data.BezierHandleY = null;
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Reset handle positions for all connections/tethers involving a node.
	 * Called when a node moves. Preserves LineMode but resets handle coordinates to auto.
	 * @param {string} pNodeHash
	 */
	resetHandlesForNode(pNodeHash)
	{
		if (!this._FlowView) return;

		// Reset connection handles
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConn = this._FlowView._FlowData.Connections[i];
			if (tmpConn.SourceNodeHash === pNodeHash || tmpConn.TargetNodeHash === pNodeHash)
			{
				if (tmpConn.Data && tmpConn.Data.HandleCustomized)
				{
					tmpConn.Data.HandleCustomized = false;
					// Clear multi-handle array (current format)
					tmpConn.Data.BezierHandles = [];
					// Clear legacy single-handle fields
					tmpConn.Data.BezierHandleX = null;
					tmpConn.Data.BezierHandleY = null;
					tmpConn.Data.OrthoCorner1X = null;
					tmpConn.Data.OrthoCorner1Y = null;
					tmpConn.Data.OrthoCorner2X = null;
					tmpConn.Data.OrthoCorner2Y = null;
					tmpConn.Data.OrthoMidOffset = 0;
				}
			}
		}

		// Reset tether handles for panels attached to this node
		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlesForNode(this._FlowView._FlowData.OpenPanels, pNodeHash);
		}
	}

	/**
	 * Reset tether handle positions for a specific panel.
	 * Called when a panel is dragged.
	 * @param {string} pPanelHash
	 */
	resetHandlesForPanel(pPanelHash)
	{
		if (!this._FlowView) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlePositions(tmpPanel);
		}
	}
}

module.exports = PictServiceFlowConnectionHandleManager;

},{"fable-serviceproviderbase":6}],51:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libPerimeterMath = require('../providers/edges/Edge-PerimeterMath.js');

// Chip (port-label badge) geometry — must mirror PortRenderer's badge
// dimensions exactly so hint paths land on the chip's actual outer
// edge instead of where we *guess* it might be.
const _CHIP_HEIGHT       = 12;
const _CHIP_PAD_H        = 5;
const _CHIP_EDGE_PAD     = 1;
const _CHIP_PORT_RADIUS  = 5;
const _CHIP_BORDER_WIDTH = 2;
const _CHIP_PER_CHAR_PX  = 5;

// Port-type → stroke color map. Mirrors the table PortRenderer uses for
// badge borders so the hint bezier matches its port's affinity color.
const PORT_TYPE_COLORS =
{
	'event-in':  '#3498db',
	'event-out': '#2ecc71',
	'setting':   '#e67e22',
	'value':     '#f1c40f',
	'error':     '#e74c3c'
};
const PORT_TYPE_DEFAULT_COLOR = '#95a5a6';

class PictServiceFlowConnectionRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render a connection as an SVG path with hit area and optional handles.
	 * @param {Object} pConnection - The connection data
	 * @param {SVGGElement} pConnectionsLayer - The SVG group to append to
	 * @param {boolean} pIsSelected - Whether this connection is selected
	 */
	renderConnection(pConnection, pConnectionsLayer, pIsSelected)
	{
		if (!this._FlowView) return;

		let tmpSourcePos = this._FlowView.getPortPosition(pConnection.SourceNodeHash, pConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(pConnection.TargetNodeHash, pConnection.TargetPortHash);

		// Let the active edge theme reshape the attachment points (e.g. a
		// "perimeter" theme that exits whichever side of the node faces the
		// other end). The static port positions are still computed above so
		// themes that don't override fall through unchanged.
		let tmpStaticSourcePos = tmpSourcePos;
		let tmpStaticTargetPos = tmpTargetPos;
		let tmpAttachOverride = this._resolveAttachmentsViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos);
		if (tmpAttachOverride.source) tmpSourcePos = tmpAttachOverride.source;
		if (tmpAttachOverride.target) tmpTargetPos = tmpAttachOverride.target;

		// Look up the source port's PortType for connection coloring
		let tmpSourcePortType = null;
		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		if (tmpSourceNode && tmpSourceNode.Ports)
		{
			for (let i = 0; i < tmpSourceNode.Ports.length; i++)
			{
				if (tmpSourceNode.Ports[i].Hash === pConnection.SourcePortHash)
				{
					tmpSourcePortType = tmpSourceNode.Ports[i].PortType || null;
					break;
				}
			}
		}

		if (!tmpSourcePos || !tmpTargetPos) return;

		let tmpData = pConnection.Data || {};
		let tmpPath = this._generatePathViaEdgeTheme(pConnection, tmpSourcePos, tmpTargetPos, tmpData);

		// Apply theme noise post-processing to the path
		if (this._FlowView._ThemeProvider)
		{
			tmpPath = this._FlowView._ThemeProvider.processPathString(tmpPath, pConnection.Hash);
		}

		// Apply stroke-dasharray from theme's ConnectionConfig
		let tmpStrokeDashArray = null;
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.ConnectionConfig && tmpActiveTheme.ConnectionConfig.StrokeDashArray)
			{
				tmpStrokeDashArray = tmpActiveTheme.ConnectionConfig.StrokeDashArray;
			}
		}

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;

		// Build the port-type CSS class suffix for connection coloring
		let tmpConnTypeClass = tmpSourcePortType ? (' conn-type-' + tmpSourcePortType) : '';

		// Determine the arrowhead marker based on port type
		let tmpArrowMarkerId;
		if (pIsSelected)
		{
			tmpArrowMarkerId = 'flow-arrowhead-selected-' + tmpViewIdentifier;
		}
		else if (tmpSourcePortType)
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpSourcePortType + '-' + tmpViewIdentifier;
		}
		else
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpViewIdentifier;
		}

		// Hit area (wider invisible path for easier selection)
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createConnectionHitAreaElement(tmpPath, pConnection.Hash);
			pConnectionsLayer.appendChild(tmpHitArea);

			let tmpPathElement = tmpShapeProvider.createConnectionPathElement(
				tmpPath, pConnection.Hash, pIsSelected, tmpViewIdentifier);
			if (tmpConnTypeClass)
			{
				tmpPathElement.setAttribute('class',
					(tmpPathElement.getAttribute('class') || '') + tmpConnTypeClass);
			}
			// Override the default arrowhead with the typed one
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');
			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}
			pConnectionsLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-connection-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-connection-hash', pConnection.Hash);
			tmpHitArea.setAttribute('data-element-type', 'connection-hitarea');
			pConnectionsLayer.appendChild(tmpHitArea);

			let tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-connection${tmpConnTypeClass} ${pIsSelected ? 'selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('data-connection-hash', pConnection.Hash);
			tmpPathElement.setAttribute('data-element-type', 'connection');
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');

			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}

			pConnectionsLayer.appendChild(tmpPathElement);
		}

		// Render the colored endpoint dot at each end of the connection
		// into the dedicated endpoints layer (sits *above* the nodes
		// layer so the dot doesn't get hidden under the card chrome
		// when an edge theme places it on the node's perimeter).
		// PortRenderer suppresses its own circle for any port that
		// participates in a connection — we own the dot here.
		let tmpEndpointsLayer = this._FlowView._EndpointsLayer || pConnectionsLayer;
		this._renderEndpointDots(pConnection, tmpEndpointsLayer, tmpSourcePos, tmpTargetPos);

		// When the resolved attachment differs from the card-defined port
		// position (e.g. a Perimeter theme moved the dot to the edge of the
		// card), paint a hidden hint bezier connecting the badge to the
		// dot. CSS reveals it on hover so users can see "this 'In' chip
		// corresponds to that dot up at the top".
		if (this._FlowView._PortHintsLayer)
		{
			this._renderPortHints(pConnection, this._FlowView._PortHintsLayer,
				tmpStaticSourcePos, tmpSourcePos, tmpStaticTargetPos, tmpTargetPos);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pConnection, pConnectionsLayer, tmpSourcePos, tmpTargetPos);
		}
	}

	/**
	 * Append the colored endpoint dots for both ends of a connection
	 * onto the destination layer (absolute coords). Reuses
	 * `ConnectorShapesProvider.createPortElement` so the styling
	 * matches the static port circle exactly.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer - the endpoints layer (or fallback)
	 * @param {{x: number, y: number}} pSourcePos
	 * @param {{x: number, y: number}} pTargetPos
	 */
	_renderEndpointDots(pConnection, pLayer, pSourcePos, pTargetPos)
	{
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (!tmpShapeProvider) return;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		if (tmpSourcePort && pSourcePos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpSourcePort, pSourcePos, pConnection.SourceNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'source');
			pLayer.appendChild(tmpDot);
		}
		if (tmpTargetPort && pTargetPos)
		{
			let tmpDot = tmpShapeProvider.createPortElement(tmpTargetPort, pTargetPos, pConnection.TargetNodeHash);
			tmpDot.setAttribute('data-connection-hash', pConnection.Hash);
			tmpDot.setAttribute('data-connection-end', 'target');
			pLayer.appendChild(tmpDot);
		}
	}

	/**
	 * Render the per-end "where did the dot go" hint paths. Drawn into
	 * the port-hints layer (above nodes) but kept opacity:0 by CSS;
	 * PortRenderer/NodeView toggle a `data-active` attribute on hover.
	 *
	 * Skipped when the resolved attachment matches the static port
	 * position (no theme rerouting → no need for a hint).
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x: number, y: number, side?: string}} pStaticSrc - card-defined port position
	 * @param {{x: number, y: number, side?: string}} pSrc - resolved attachment
	 * @param {{x: number, y: number, side?: string}} pStaticTgt
	 * @param {{x: number, y: number, side?: string}} pTgt
	 */
	_renderPortHints(pConnection, pLayer, pStaticSrc, pSrc, pStaticTgt, pTgt)
	{
		let tmpPositionsDiffer = function (pA, pB)
		{
			if (!pA || !pB) return false;
			return (Math.abs(pA.x - pB.x) > 0.5) || (Math.abs(pA.y - pB.y) > 0.5);
		};

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		// Hints are colored by the *other* end's node identity — looking
		// at a hub with 8 hints fanning out, each hint is the color of
		// the spoke that connection terminates at, so you can tell at a
		// glance which line goes where without tracing it. (Mirrors the
		// Ultravisor card-category color model: gray=flow-control,
		// purple=core, orange=data, teal=llm, etc.)
		// Anchor each hint at the chip's outer edge facing the dot
		// (not the port's static position, which sits on the node's
		// edge — visually inside the chip's stripe). The hint ends at
		// the dot but its tail "points at" the chip's center.
		if (pStaticSrc && tmpPositionsDiffer(pStaticSrc, pSrc))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpSourcePort, pStaticSrc, pSrc);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pSrc,
				pConnection.SourceNodeHash, pConnection.SourcePortHash, pConnection.Hash, 'source',
				this._hintColor(tmpSourcePort, tmpTargetNode)));
		}
		if (pStaticTgt && tmpPositionsDiffer(pStaticTgt, pTgt))
		{
			let tmpChipExit = this._chipEdgeAimingAt(tmpTargetPort, pStaticTgt, pTgt);
			pLayer.appendChild(this._buildPortHintPath(
				tmpChipExit, pTgt,
				pConnection.TargetNodeHash, pConnection.TargetPortHash, pConnection.Hash, 'target',
				this._hintColor(tmpTargetPort, tmpSourceNode)));
		}
	}

	/**
	 * Compute the chip (port-label badge) bounding box for a given
	 * port. The chip is a small rectangle that lives just inside the
	 * node's outer edge, anchored to the port's static position. We
	 * mirror PortRenderer's badge geometry exactly so the hint path
	 * lands on real chip-edge pixels.
	 *
	 * Returns null when we don't have enough info (no label or
	 * unknown side) — caller should fall back to the static position.
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos - the
	 *        port's nominal position (returned by getPortPosition); the
	 *        chip extends *inward* from here.
	 * @returns {{X: number, Y: number, Width: number, Height: number}|null}
	 */
	_chipBoundsFor(pPort, pStaticPos)
	{
		if (!pPort || !pStaticPos) return null;
		let tmpSide = pStaticPos.side || pPort.Side || (pPort.Direction === 'input' ? 'left' : 'right');
		let tmpLabel = pPort.Label || '';
		// PortRenderer skips badge rendering entirely when there is no
		// label, so there's nothing for the hint to anchor against.
		if (tmpLabel === '') return null;

		let tmpTextPx = tmpLabel.length * _CHIP_PER_CHAR_PX;
		let tmpWidth = _CHIP_PORT_RADIUS + _CHIP_PAD_H + tmpTextPx + _CHIP_PAD_H + _CHIP_BORDER_WIDTH;
		let tmpHeight = _CHIP_HEIGHT;

		// Chip center sits halfway along the line from the port's static
		// position toward the inside of the node, offset by half the
		// chip's extent in that direction (plus the 1px edge padding
		// PortRenderer leaves between the chip and the node edge).
		let tmpCx, tmpCy;
		if (tmpSide.indexOf('left') === 0)
		{
			tmpCx = pStaticPos.x + tmpWidth / 2 + _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('right') === 0)
		{
			tmpCx = pStaticPos.x - tmpWidth / 2 - _CHIP_EDGE_PAD;
			tmpCy = pStaticPos.y;
		}
		else if (tmpSide.indexOf('top') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y + tmpHeight / 2 + _CHIP_EDGE_PAD;
		}
		else if (tmpSide.indexOf('bottom') === 0)
		{
			tmpCx = pStaticPos.x;
			tmpCy = pStaticPos.y - tmpHeight / 2 - _CHIP_EDGE_PAD;
		}
		else
		{
			return null;
		}

		return { X: tmpCx - tmpWidth / 2, Y: tmpCy - tmpHeight / 2, Width: tmpWidth, Height: tmpHeight };
	}

	/**
	 * Resolve the point on the chip's outer perimeter where a line
	 * from the chip's center toward the dot would exit the chip. Used
	 * as the hint's start point so the line visually emerges from the
	 * chip's edge facing the dot, aimed at the chip's center.
	 *
	 * Falls back to the static port position when chip geometry can't
	 * be computed (no label, unknown side).
	 *
	 * @param {Object|null} pPort
	 * @param {{x: number, y: number, side?: string}} pStaticPos
	 * @param {{x: number, y: number}} pDotPos
	 * @returns {{x: number, y: number}}
	 */
	_chipEdgeAimingAt(pPort, pStaticPos, pDotPos)
	{
		let tmpBounds = this._chipBoundsFor(pPort, pStaticPos);
		if (!tmpBounds) return pStaticPos;
		let tmpExit = libPerimeterMath.resolvePerimeterAttachment({
			Node: tmpBounds,
			OtherDefaultPosition: pDotPos
		});
		if (!tmpExit) return pStaticPos;
		return tmpExit;
	}

	/**
	 * Resolve a node's identity color. Looks at the inline node fields
	 * first (per-node overrides win), then the registered node-type
	 * config from the NodeTypeProvider. Returns null when the node has
	 * no opinion — caller should fall back to port-type color.
	 *
	 * @param {Object|null} pNode
	 * @returns {string|null}
	 */
	_resolveNodeIdentityColor(pNode)
	{
		if (!pNode) return null;
		if (pNode.TitleBarColor) return pNode.TitleBarColor;
		if (pNode.BodyStyle && pNode.BodyStyle.stroke) return pNode.BodyStyle.stroke;
		let tmpProvider = this._FlowView ? this._FlowView._NodeTypeProvider : null;
		if (tmpProvider && typeof tmpProvider.getNodeType === 'function' && pNode.Type)
		{
			let tmpType = tmpProvider.getNodeType(pNode.Type);
			if (tmpType)
			{
				if (tmpType.TitleBarColor) return tmpType.TitleBarColor;
				if (tmpType.BodyStyle && tmpType.BodyStyle.stroke) return tmpType.BodyStyle.stroke;
			}
		}
		return null;
	}

	/**
	 * Resolve the hint stroke color. Priority chain:
	 *   1. The OTHER end's node identity color (TitleBarColor /
	 *      BodyStyle.stroke / NodeTypeConfig color) — the strongest
	 *      signal: "this hint terminates at *that* card".
	 *   2. This end's PortType color — semantic-role fallback.
	 *   3. Direction-based default that matches the visible dot color.
	 *   4. Neutral gray.
	 *
	 * @param {Object|null} pPort - this end's port
	 * @param {Object|null} pOtherNode - the node at the other end
	 * @returns {string}
	 */
	_hintColor(pPort, pOtherNode)
	{
		let tmpOtherColor = this._resolveNodeIdentityColor(pOtherNode);
		if (tmpOtherColor) return tmpOtherColor;
		if (pPort && pPort.PortType && PORT_TYPE_COLORS[pPort.PortType])
		{
			return PORT_TYPE_COLORS[pPort.PortType];
		}
		if (pPort && pPort.Direction === 'input')  return PORT_TYPE_COLORS['event-in'];
		if (pPort && pPort.Direction === 'output') return PORT_TYPE_COLORS['event-out'];
		return PORT_TYPE_DEFAULT_COLOR;
	}

	/**
	 * Build a single hint-path SVG element: a soft S-curve from the
	 * card-defined port position to the resolved attachment position.
	 * Tagged with port + node + connection hashes so hover handlers can
	 * find the right hint by attribute.
	 *
	 * @param {{x: number, y: number}} pStart - badge / chip position
	 * @param {{x: number, y: number}} pEnd - actual dot position
	 * @returns {SVGPathElement}
	 */
	_buildPortHintPath(pStart, pEnd, pNodeHash, pPortHash, pConnectionHash, pEndLabel, pStrokeColor)
	{
		let tmpEl = this._FlowView._SVGHelperProvider.createSVGElement('path');

		// Soft S-curve: control points pulled along the perpendicular bisector
		let tmpDX = pEnd.x - pStart.x;
		let tmpDY = pEnd.y - pStart.y;
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
		let tmpBend = Math.min(60, tmpDist * 0.35);
		// Perpendicular unit vector
		let tmpPX = (tmpDist > 0) ? -tmpDY / tmpDist : 0;
		let tmpPY = (tmpDist > 0) ?  tmpDX / tmpDist : 0;
		let tmpCp1X = pStart.x + tmpDX * 0.35 + tmpPX * tmpBend * 0.3;
		let tmpCp1Y = pStart.y + tmpDY * 0.35 + tmpPY * tmpBend * 0.3;
		let tmpCp2X = pStart.x + tmpDX * 0.65 + tmpPX * tmpBend * 0.3;
		let tmpCp2Y = pStart.y + tmpDY * 0.65 + tmpPY * tmpBend * 0.3;
		let tmpD = `M ${pStart.x} ${pStart.y} C ${tmpCp1X} ${tmpCp1Y} ${tmpCp2X} ${tmpCp2Y} ${pEnd.x} ${pEnd.y}`;

		tmpEl.setAttribute('class', 'pict-flow-port-hint');
		tmpEl.setAttribute('d', tmpD);
		tmpEl.setAttribute('data-node-hash', pNodeHash);
		tmpEl.setAttribute('data-port-hash', pPortHash);
		tmpEl.setAttribute('data-connection-hash', pConnectionHash);
		tmpEl.setAttribute('data-connection-end', pEndLabel);
		// Affinity color from port type (matches the badge border color).
		// Inline so PortRenderer's color map stays the single source of
		// truth without dragging CSS variables around per port type.
		if (pStrokeColor)
		{
			tmpEl.setAttribute('stroke', pStrokeColor);
		}
		return tmpEl;
	}

	/**
	 * Compute the departure and approach points plus control points
	 * for a direction-aware bezier between two ports.
	 *
	 * This extracts the intermediate geometry from _generateDirectionalPath
	 * so it can be reused by _getAutoMidpoint and _generateBezierPathWithHandle.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX, departY, approachX, approachY, cp1X, cp1Y, cp2X, cp2Y, startDir, endDir}}
	 */
	_computeDirectionalGeometry(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.computeDirectionalGeometry(pStart, pEnd);
	}

	/**
	 * Generate a direction-aware path between two ports.
	 *
	 * The path is composed of three segments:
	 *   1. A short straight "departure" segment leaving the source port
	 *      in its outward direction.
	 *   2. A cubic bezier curve connecting the departure point to an
	 *      "approach" point near the target port.
	 *   3. A short straight "approach" segment arriving at the target
	 *      port aligned with its inward direction.
	 *
	 * @param {{x: number, y: number, side: string}} pStart - Start port position + side
	 * @param {{x: number, y: number, side: string}} pEnd   - End port position + side
	 * @returns {string} SVG path d attribute
	 */
	_generateDirectionalPath(pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Dispatch to an edge theme to generate the path string. Falls back
	 * to the renderer's built-in bezier / orthogonal helpers when no
	 * edge-theme registry is available (older host integrations) or
	 * the resolved theme errors out.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData - connection data (LineMode, custom handles, etc.)
	 * @returns {string} SVG path 'd' attribute
	 */
	_generatePathViaEdgeTheme(pConnection, pSourcePos, pTargetPos, pData)
	{
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;

		if (!tmpTheme || typeof tmpTheme.GeneratePath !== 'function')
		{
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}

		let tmpContext =
		{
			Source: pSourcePos,
			Target: pTargetPos,
			Connection: pConnection,
			AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
			AllConnections: this._FlowView._FlowData ? this._FlowView._FlowData.Connections : [],
			FlowView: this._FlowView,
			Helpers: this._buildEdgeThemeHelpers(),
			Parameters: tmpLayoutService.getMergedEdgeThemeParameters(
				tmpTheme.Name,
				(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
			)
		};

		try
		{
			let tmpPath = tmpTheme.GeneratePath(tmpContext);
			if (typeof tmpPath !== 'string' || tmpPath === '')
			{
				return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
			}
			return tmpPath;
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' threw: ${pError.message}`);
			return this._builtInPathFallback(pSourcePos, pTargetPos, pData);
		}
	}

	/**
	 * Resolve per-end attachment overrides via the active edge theme's
	 * optional `ResolveAttachment(context)` hook. The theme can return
	 * `{ x, y, side }` for either end (or null to fall through). Used by
	 * themes like Perimeter that route through the node's bounding box
	 * rather than the static port position.
	 *
	 * @param {Object} pConnection
	 * @param {{x: number, y: number, side?: string}} pSourcePos - default port position
	 * @param {{x: number, y: number, side?: string}} pTargetPos - default port position
	 * @returns {{source: ?Object, target: ?Object}}
	 */
	_resolveAttachmentsViaEdgeTheme(pConnection, pSourcePos, pTargetPos)
	{
		let tmpEmpty = { source: null, target: null };
		let tmpLayoutService = this._FlowView ? this._FlowView._LayoutService : null;
		let tmpTheme = (tmpLayoutService && typeof tmpLayoutService.resolveActiveEdgeTheme === 'function')
			? tmpLayoutService.resolveActiveEdgeTheme(pConnection)
			: null;
		if (!tmpTheme || typeof tmpTheme.ResolveAttachment !== 'function') return tmpEmpty;

		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		let tmpTargetNode = this._FlowView.getNode(pConnection.TargetNodeHash);
		let tmpSourcePort = this._findPort(tmpSourceNode, pConnection.SourcePortHash);
		let tmpTargetPort = this._findPort(tmpTargetNode, pConnection.TargetPortHash);

		let tmpParams = tmpLayoutService.getMergedEdgeThemeParameters(
			tmpTheme.Name,
			(this._FlowView._FlowData && this._FlowView._FlowData.EdgeThemeParameters) || {}
		);

		let tmpSrc = null, tmpTgt = null;
		try
		{
			tmpSrc = tmpTheme.ResolveAttachment({
				Node: tmpSourceNode, Port: tmpSourcePort,
				DefaultPosition: pSourcePos,
				Connection: pConnection, IsSource: true,
				OtherNode: tmpTargetNode, OtherPort: tmpTargetPort,
				OtherDefaultPosition: pTargetPos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
			tmpTgt = tmpTheme.ResolveAttachment({
				Node: tmpTargetNode, Port: tmpTargetPort,
				DefaultPosition: pTargetPos,
				Connection: pConnection, IsSource: false,
				OtherNode: tmpSourceNode, OtherPort: tmpSourcePort,
				OtherDefaultPosition: pSourcePos,
				AllNodes: this._FlowView._FlowData ? this._FlowView._FlowData.Nodes : [],
				FlowView: this._FlowView,
				Parameters: tmpParams
			});
		}
		catch (pError)
		{
			this._FlowView.log.warn(`PictServiceFlowConnectionRenderer edge theme '${tmpTheme.Name}' ResolveAttachment threw: ${pError.message}`);
			return tmpEmpty;
		}

		return { source: tmpSrc || null, target: tmpTgt || null };
	}

	/**
	 * Find a port by hash on a node. Returns null if missing.
	 * @param {Object} pNode
	 * @param {string} pPortHash
	 * @returns {Object|null}
	 */
	_findPort(pNode, pPortHash)
	{
		if (!pNode || !Array.isArray(pNode.Ports)) return null;
		for (let i = 0; i < pNode.Ports.length; i++)
		{
			if (pNode.Ports[i].Hash === pPortHash) return pNode.Ports[i];
		}
		return null;
	}

	/**
	 * Path-generation helpers exposed to edge themes via the GeneratePath
	 * context object. Themes can compose these to derive their own routing.
	 *
	 * @returns {Object}
	 */
	_buildEdgeThemeHelpers()
	{
		let tmpRenderer = this;
		return {
			generateBezier: function (pStart, pEnd)
			{
				return tmpRenderer._generateDirectionalPath(pStart, pEnd);
			},
			generateMultiBezier: function (pStart, pEnd, pHandles)
			{
				return tmpRenderer._generateMultiHandleBezierPath(pStart, pEnd, pHandles);
			},
			generateOrthogonal: function (pStart, pEnd, pCorners, pMidOffset)
			{
				return tmpRenderer._generateOrthogonalPath(pStart, pEnd, pCorners || null, pMidOffset || 0);
			},
			getBezierHandles: function (pData)
			{
				return tmpRenderer._getBezierHandles(pData);
			}
		};
	}

	/**
	 * Built-in fallback when no edge theme is registered. Mirrors the
	 * pre-edge-theme dispatch (LineMode → bezier or orthogonal).
	 *
	 * @param {{x: number, y: number, side?: string}} pSourcePos
	 * @param {{x: number, y: number, side?: string}} pTargetPos
	 * @param {Object} pData
	 * @returns {string}
	 */
	_builtInPathFallback(pSourcePos, pTargetPos, pData)
	{
		let tmpData = pData || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
					corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
				};
			}
			return this._generateOrthogonalPath(pSourcePos, pTargetPos, tmpCorners, tmpData.OrthoMidOffset || 0);
		}

		let tmpHandles = this._getBezierHandles(tmpData);
		if (tmpHandles.length > 0)
		{
			return this._generateMultiHandleBezierPath(pSourcePos, pTargetPos, tmpHandles);
		}
		return this._generateDirectionalPath(pSourcePos, pTargetPos);
	}

	/**
	 * Get the bezier handles array from connection data, with backward
	 * compatibility for the legacy BezierHandleX/Y single-handle format.
	 *
	 * @param {Object} pData - Connection.Data
	 * @returns {Array<{x: number, y: number}>} Ordered handle waypoints (may be empty)
	 */
	_getBezierHandles(pData)
	{
		if (!pData || !pData.HandleCustomized)
		{
			return [];
		}

		// New multi-handle format
		if (Array.isArray(pData.BezierHandles) && pData.BezierHandles.length > 0)
		{
			return pData.BezierHandles;
		}

		// Legacy single-handle format
		if (pData.BezierHandleX != null && pData.BezierHandleY != null)
		{
			return [{ x: pData.BezierHandleX, y: pData.BezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path between two ports.
	 * Delegates to PathGenerator.buildMultiBezierPathString for the
	 * actual SVG path assembly with Catmull-Rom tangent continuity.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered waypoints
	 * @returns {string} SVG path d attribute
	 */
	_generateMultiHandleBezierPath(pStart, pEnd, pHandles)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			pHandles,
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y },
			tmpGeo.startDir,
			tmpGeo.endDir
		);
	}

	/**
	 * Find which segment of the multi-handle bezier the given click point
	 * is closest to, returning the index at which a new handle should be
	 * inserted into the BezierHandles array.
	 *
	 * Segments are: depart→handle[0], handle[0]→handle[1], ..., handle[N-1]→approach.
	 * Returns 0 for before handle[0], 1 for between handle[0] and handle[1], etc.
	 *
	 * @param {Array<{x: number, y: number}>} pHandles - Current handles
	 * @param {{x: number, y: number}} pClickPoint - Where the user right-clicked
	 * @param {{x: number, y: number, side: string}} pStart - Source port position
	 * @param {{x: number, y: number, side: string}} pEnd - Target port position
	 * @returns {number} Insertion index
	 */
	computeInsertionIndex(pHandles, pClickPoint, pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		// Build the waypoint chain: depart, handle[0..N-1], approach
		let tmpWaypoints = [{ x: tmpGeo.departX, y: tmpGeo.departY }];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push({ x: tmpGeo.approachX, y: tmpGeo.approachY });

		let tmpBestDist = Infinity;
		let tmpBestIndex = 0;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpDist = this._distanceToSegment(
				pClickPoint.x, pClickPoint.y,
				tmpWaypoints[i].x, tmpWaypoints[i].y,
				tmpWaypoints[i + 1].x, tmpWaypoints[i + 1].y
			);

			if (tmpDist < tmpBestDist)
			{
				tmpBestDist = tmpDist;
				tmpBestIndex = i;
			}
		}

		return tmpBestIndex;
	}

	/**
	 * Distance from point (px,py) to line segment (ax,ay)-(bx,by).
	 */
	_distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		return this._FlowView._PathGenerator.distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY);
	}

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between two ports.
	 * Evaluates the cubic bezier at t=0.5.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.getAutoMidpoint(pStart, pEnd);
	}

	/**
	 * Generate an orthogonal (90-degree angles only) path between two ports.
	 *
	 * Path format: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object|null} pCorners - { corner1: {x,y}, corner2: {x,y} } or null for auto
	 * @param {number} pMidOffset - Offset for the auto-calculated corridor position
	 * @returns {string} SVG path d attribute
	 */
	_generateOrthogonalPath(pStart, pEnd, pCorners, pMidOffset)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
				tmpDA.departX, tmpDA.departY,
				tmpDA.approachX, tmpDA.approachY,
				tmpDA.fromDir, tmpDA.toDir,
				pMidOffset || 0
			);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpDA.departX, y: tmpDA.departY },
			tmpCorner1,
			tmpCorner2,
			{ x: tmpDA.approachX, y: tmpDA.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Get the full orthogonal geometry for a connection (for handle positioning).
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object} pData - Connection.Data
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthogonalGeometry(pStart, pEnd, pData)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		if (pData && pData.HandleCustomized && pData.OrthoCorner1X != null)
		{
			let tmpCorner1 = { x: pData.OrthoCorner1X, y: pData.OrthoCorner1Y };
			let tmpCorner2 = { x: pData.OrthoCorner2X, y: pData.OrthoCorner2Y };
			let tmpMidpoint =
			{
				x: (tmpCorner1.x + tmpCorner2.x) / 2,
				y: (tmpCorner1.y + tmpCorner2.y) / 2
			};
			return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
		}

		return this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
			tmpDA.departX, tmpDA.departY,
			tmpDA.approachX, tmpDA.approachY,
			tmpDA.fromDir, tmpDA.toDir,
			(pData && pData.OrthoMidOffset) || 0
		);
	}

	/**
	 * Render drag handles for the selected connection.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x, y, side}} pStart - Source port position
	 * @param {{x, y, side}} pEnd   - Target port position
	 */
	_renderHandles(pConnection, pLayer, pStart, pEnd)
	{
		let tmpData = pConnection.Data || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeometry = this.getOrthogonalGeometry(pStart, pEnd, tmpData);

			// Corner 1 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner1',
				tmpGeometry.corner1.x, tmpGeometry.corner1.y, 'pict-flow-connection-handle');

			// Midpoint handle (between corners)
			this._createHandle(pLayer, pConnection.Hash, 'ortho-midpoint',
				tmpGeometry.midpoint.x, tmpGeometry.midpoint.y, 'pict-flow-connection-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner2',
				tmpGeometry.corner2.x, tmpGeometry.corner2.y, 'pict-flow-connection-handle');
		}
		else
		{
			// Bezier handles — show one handle per waypoint, or a
			// single auto-midpoint when no custom handles exist.
			let tmpHandles = this._getBezierHandles(tmpData);

			if (tmpHandles.length > 0)
			{
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pLayer, pConnection.Hash,
						'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y,
						'pict-flow-connection-handle');
				}
			}
			else
			{
				let tmpMidpoint = this.getAutoMidpoint(pStart, pEnd);
				this._createHandle(pLayer, pConnection.Hash, 'bezier-midpoint',
					tmpMidpoint.x, tmpMidpoint.y, 'pict-flow-connection-handle');
			}
		}
	}

	/**
	 * Create a single SVG circle handle element.
	 *
	 * @param {SVGGElement} pLayer
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pConnectionHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-connection-handle-midpoint')
			? 'connection-handle-midpoint' : 'connection-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pConnectionHash, pHandleType, pX, pY,
			tmpShapeKey, 'connection-handle', 'data-connection-hash');
	}

	/**
	 * Legacy bezier path for drag connections where we don't have side info.
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string}
	 */
	_generateBezierPath(pStart, pEnd)
	{
		// During drag operations we may not have side info; default to right->left
		let tmpStart = { x: pStart.x, y: pStart.y, side: pStart.side || 'right' };
		let tmpEnd   = { x: pEnd.x,   y: pEnd.y,   side: pEnd.side   || 'left' };
		return this._generateDirectionalPath(tmpStart, tmpEnd);
	}

	/**
	 * Render a temporary drag connection line (used during connection creation)
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {SVGGElement} pLayer - The layer to render into
	 * @param {string} [pStartSide] - The side the source port is on
	 * @returns {SVGPathElement} The created path element
	 */
	renderDragConnection(pStartX, pStartY, pEndX, pEndY, pLayer, pStartSide)
	{
		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement;

		if (tmpShapeProvider)
		{
			tmpPathElement = tmpShapeProvider.createDragConnectionElement(tmpPath);
		}
		else
		{
			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', 'pict-flow-drag-connection');
			tmpPathElement.setAttribute('d', tmpPath);
		}

		pLayer.appendChild(tmpPathElement);

		return tmpPathElement;
	}

	/**
	 * Update a drag connection path
	 * @param {SVGPathElement} pPathElement
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {string} [pStartSide] - The side the source port is on
	 */
	updateDragConnection(pPathElement, pStartX, pStartY, pEndX, pEndY, pStartSide)
	{
		if (!pPathElement) return;

		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		pPathElement.setAttribute('d', tmpPath);
	}
}

module.exports = PictServiceFlowConnectionRenderer;

},{"../providers/edges/Edge-PerimeterMath.js":40,"fable-serviceproviderbase":6}],52:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-DataManager
 *
 * Manages flow data lifecycle: serialization, deserialization, and CRUD
 * operations for nodes and connections.
 *
 * Extracted from PictView-Flow.js to keep the view focused on
 * coordination and lifecycle rather than data manipulation.
 */
class PictServiceFlowDataManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowDataManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Marshaling ----

	/**
	 * Marshal data from AppData into the flow view
	 */
	marshalToView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			let tmpData = this._FlowView.fable.manifest.getValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress);
			if (typeof tmpData === 'object' && tmpData !== null)
			{
				this.setFlowData(tmpData);
			}
		}
	}

	/**
	 * Marshal data from the flow view back to AppData
	 */
	marshalFromView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			this._FlowView.fable.manifest.setValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress, JSON.parse(JSON.stringify(this._FlowView._FlowData)));
		}
	}

	// ---- Flow Data Get/Set ----

	/**
	 * Get the complete flow data object
	 * @returns {Object} The flow data including nodes, connections, and view state
	 */
	getFlowData()
	{
		if (!this._FlowView) return {};
		return JSON.parse(JSON.stringify(this._FlowView._FlowData));
	}

	/**
	 * Set the complete flow data object and re-render
	 * @param {Object} pFlowData - The flow data to set
	 */
	setFlowData(pFlowData)
	{
		if (!this._FlowView) return;

		if (typeof pFlowData !== 'object' || pFlowData === null)
		{
			this._FlowView.log.warn('PictSectionFlow setFlowData received invalid data');
			return;
		}

		let tmpDefaultAlgorithm = (this._FlowView.options && this._FlowView.options.DefaultLayoutAlgorithm) || 'Custom';
		let tmpDefaultParameters = (this._FlowView.options && this._FlowView.options.DefaultLayoutParameters) || {};
		let tmpDefaultAutoApply = !!(this._FlowView.options && this._FlowView.options.DefaultLayoutAutoApply);
		let tmpDefaultEdgeTheme = (this._FlowView.options && this._FlowView.options.DefaultEdgeTheme) || null;
		let tmpDefaultEdgeThemeParameters = (this._FlowView.options && this._FlowView.options.DefaultEdgeThemeParameters) || {};

		this._FlowView._FlowData = {
			Nodes: Array.isArray(pFlowData.Nodes) ? pFlowData.Nodes : [],
			Connections: Array.isArray(pFlowData.Connections) ? pFlowData.Connections : [],
			OpenPanels: Array.isArray(pFlowData.OpenPanels) ? pFlowData.OpenPanels : [],
			SavedLayouts: Array.isArray(pFlowData.SavedLayouts) ? pFlowData.SavedLayouts : [],
			ViewState: Object.assign(
				{ PanX: 0, PanY: 0, Zoom: 1, SelectedNodeHash: null, SelectedConnectionHash: null, SelectedTetherHash: null },
				pFlowData.ViewState || {}
			),
			LayoutAlgorithm: (typeof pFlowData.LayoutAlgorithm === 'string' && pFlowData.LayoutAlgorithm !== '') ? pFlowData.LayoutAlgorithm : tmpDefaultAlgorithm,
			LayoutParameters: (pFlowData.LayoutParameters && typeof pFlowData.LayoutParameters === 'object') ? JSON.parse(JSON.stringify(pFlowData.LayoutParameters)) : JSON.parse(JSON.stringify(tmpDefaultParameters)),
			LayoutAutoApply: (typeof pFlowData.LayoutAutoApply === 'boolean') ? pFlowData.LayoutAutoApply : tmpDefaultAutoApply,
			EdgeTheme: (typeof pFlowData.EdgeTheme === 'string' && pFlowData.EdgeTheme !== '') ? pFlowData.EdgeTheme : tmpDefaultEdgeTheme,
			EdgeThemeParameters: (pFlowData.EdgeThemeParameters && typeof pFlowData.EdgeThemeParameters === 'object') ? JSON.parse(JSON.stringify(pFlowData.EdgeThemeParameters)) : JSON.parse(JSON.stringify(tmpDefaultEdgeThemeParameters))
		};

		// Merge any browser-persisted layouts into the newly loaded data
		if (this._FlowView._LayoutProvider)
		{
			this._FlowView._LayoutProvider.loadPersistedLayouts();
		}

		if (this._FlowView.initialRenderComplete)
		{
			this._FlowView.renderFlow();
		}
	}

	// ---- Node CRUD ----

	/**
	 * Add a new node to the flow
	 * @param {string} pType - The node type hash
	 * @param {number} pX - X position
	 * @param {number} pY - Y position
	 * @param {string} [pTitle] - Optional title
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object} The created node
	 */
	addNode(pType, pX, pY, pTitle, pData)
	{
		if (!this._FlowView) return null;

		let tmpType = pType || this._FlowView.options.DefaultNodeType;
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpType);

		let tmpNodeHash = `node-${this._FlowView.fable.getUUID()}`;
		let tmpNode =
		{
			Hash: tmpNodeHash,
			Type: tmpType,
			X: pX || 100,
			Y: pY || 100,
			Width: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultWidth) || this._FlowView.options.DefaultNodeWidth,
			Height: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultHeight) || this._FlowView.options.DefaultNodeHeight,
			Title: pTitle || (tmpNodeTypeConfig && tmpNodeTypeConfig.Label) || 'New Node',
			Ports: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts)
				? JSON.parse(JSON.stringify(tmpNodeTypeConfig.DefaultPorts))
				: [
					{ Hash: `port-in-${this._FlowView.fable.getUUID()}`, Direction: 'input', Side: 'left', Label: 'In' },
					{ Hash: `port-out-${this._FlowView.fable.getUUID()}`, Direction: 'output', Side: 'right', Label: 'Out' }
				],
			Data: pData || {}
		};

		// Ensure each port has a unique hash
		for (let i = 0; i < tmpNode.Ports.length; i++)
		{
			if (!tmpNode.Ports[i].Hash)
			{
				tmpNode.Ports[i].Hash = `port-${tmpNode.Ports[i].Direction}-${this._FlowView.fable.getUUID()}`;
			}
		}

		this._FlowView._FlowData.Nodes.push(tmpNode);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeAdded', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpNode;
	}

	/**
	 * Remove a node and all its connections
	 * @param {string} pNodeHash - The hash of the node to remove
	 * @returns {boolean} Whether the node was removed
	 */
	removeNode(pNodeHash)
	{
		if (!this._FlowView) return false;

		let tmpNodeIndex = this._FlowView._FlowData.Nodes.findIndex((pNode) => pNode.Hash === pNodeHash);
		if (tmpNodeIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeNode: node ${pNodeHash} not found`);
			return false;
		}

		let tmpRemovedNode = this._FlowView._FlowData.Nodes.splice(tmpNodeIndex, 1)[0];

		// Remove all connections involving this node
		this._FlowView._FlowData.Connections = this._FlowView._FlowData.Connections.filter((pConnection) =>
		{
			return pConnection.SourceNodeHash !== pNodeHash && pConnection.TargetNodeHash !== pNodeHash;
		});

		// Close any open panels for this node
		this._FlowView.closePanelForNode(pNodeHash);

		// Clear selection if this node was selected
		if (this._FlowView._FlowData.ViewState.SelectedNodeHash === pNodeHash)
		{
			this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeRemoved', tmpRemovedNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	// ---- Connection CRUD ----

	/**
	 * Add a connection between two ports
	 * @param {string} pSourceNodeHash
	 * @param {string} pSourcePortHash
	 * @param {string} pTargetNodeHash
	 * @param {string} pTargetPortHash
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object|false} The created connection, or false if invalid
	 */
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData)
	{
		if (!this._FlowView) return false;

		// Validate that both nodes and ports exist
		let tmpSourceNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pSourceNodeHash);
		let tmpTargetNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pTargetNodeHash);

		if (!tmpSourceNode || !tmpTargetNode)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target node not found');
			return false;
		}

		let tmpSourcePort = tmpSourceNode.Ports.find((pPort) => pPort.Hash === pSourcePortHash);
		let tmpTargetPort = tmpTargetNode.Ports.find((pPort) => pPort.Hash === pTargetPortHash);

		if (!tmpSourcePort || !tmpTargetPort)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target port not found');
			return false;
		}

		// Prevent self-connections
		if (pSourceNodeHash === pTargetNodeHash)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: cannot connect a node to itself');
			return false;
		}

		// Check for duplicate connections
		let tmpDuplicate = this._FlowView._FlowData.Connections.find((pConn) =>
		{
			return pConn.SourceNodeHash === pSourceNodeHash
				&& pConn.SourcePortHash === pSourcePortHash
				&& pConn.TargetNodeHash === pTargetNodeHash
				&& pConn.TargetPortHash === pTargetPortHash;
		});
		if (tmpDuplicate)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: duplicate connection');
			return false;
		}

		let tmpConnection =
		{
			Hash: `conn-${this._FlowView.fable.getUUID()}`,
			SourceNodeHash: pSourceNodeHash,
			SourcePortHash: pSourcePortHash,
			TargetNodeHash: pTargetNodeHash,
			TargetPortHash: pTargetPortHash,
			Data: pData || {}
		};

		this._FlowView._FlowData.Connections.push(tmpConnection);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionCreated', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpConnection;
	}

	/**
	 * Remove a connection
	 * @param {string} pConnectionHash - The hash of the connection to remove
	 * @returns {boolean} Whether the connection was removed
	 */
	removeConnection(pConnectionHash)
	{
		if (!this._FlowView) return false;

		let tmpConnectionIndex = this._FlowView._FlowData.Connections.findIndex((pConn) => pConn.Hash === pConnectionHash);
		if (tmpConnectionIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeConnection: connection ${pConnectionHash} not found`);
			return false;
		}

		let tmpRemovedConnection = this._FlowView._FlowData.Connections.splice(tmpConnectionIndex, 1)[0];

		if (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash)
		{
			this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionRemoved', tmpRemovedConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}
}

module.exports = PictServiceFlowDataManager;

},{"fable-serviceproviderbase":6}],53:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Interaction states for the flow diagram
 */
const INTERACTION_STATES =
{
	IDLE: 'idle',
	DRAGGING_NODE: 'dragging-node',
	DRAGGING_PANEL: 'dragging-panel',
	DRAGGING_HANDLE: 'dragging-handle',
	CONNECTING: 'connecting',
	PANNING: 'panning',
	RESIZING_PANEL: 'resizing-panel'
};

class PictServiceFlowInteractionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowInteractionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._SVGElement = null;
		this._ViewportElement = null;

		// Interaction state
		this._State = INTERACTION_STATES.IDLE;

		// Drag state
		this._DragNodeHash = null;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragNodeStartX = 0;
		this._DragNodeStartY = 0;

		// Panel drag state
		this._DragPanelHash = null;
		this._DragPanelStartX = 0;
		this._DragPanelStartY = 0;
		this._DragPanelDataStartX = 0;
		this._DragPanelDataStartY = 0;

		// Handle drag state
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;

		// Pan state
		this._PanStartX = 0;
		this._PanStartY = 0;
		this._PanStartPanX = 0;
		this._PanStartPanY = 0;

		// Connection drag state
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
		this._ConnectDragLine = null;

		// Double-click detection
		this._LastClickTime = 0;
		this._LastClickNodeHash = null;
		this._DoubleClickThreshold = 400;

		// Panel resize state
		this._ResizePanelHash = null;
		this._ResizeStartY = 0;
		this._ResizePanelStartHeight = 0;

		// Double-click detection for connections
		this._LastConnectionClickTime = 0;
		this._LastConnectionClickHash = null;

		// Double-click detection for tethers
		this._LastTetherClickTime = 0;
		this._LastTetherClickHash = null;

		// Double-click detection for handles
		this._LastHandleClickTime = 0;
		this._LastHandleClickHash = null;
		this._LastHandleClickType = null;

		// Bound event handlers (for removeEventListener)
		this._boundOnPointerDown = this._onPointerDown.bind(this);
		this._boundOnPointerMove = this._onPointerMove.bind(this);
		this._boundOnPointerUp = this._onPointerUp.bind(this);
		this._boundOnWheel = this._onWheel.bind(this);
		this._boundOnKeyDown = this._onKeyDown.bind(this);
	}

	/**
	 * Initialize event listeners on the SVG element
	 * @param {SVGSVGElement} pSVGElement
	 * @param {SVGGElement} pViewportElement
	 */
	initialize(pSVGElement, pViewportElement)
	{
		this._SVGElement = pSVGElement;
		this._ViewportElement = pViewportElement;

		if (!this._SVGElement) return;

		// Pointer/wheel/contextmenu live as inline attributes on the SVG
		// template (see Flow-Container-Template in PictView-Flow.js); they
		// route to InteractionManager via the FlowView's bridges. The
		// keydown listener stays document-level because keyboard input
		// has no element-level inline equivalent for the canvas-as-a-whole.
		document.addEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Inline-handler bridge — invoked from the SVG template's
	 * `oncontextmenu` attribute. Prevents the browser context menu and
	 * dispatches to the right bezier-handle action based on what was
	 * right-clicked.
	 *
	 * @param {Event} pEvent
	 */
	handleContextMenu(pEvent)
	{
		pEvent.preventDefault();

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		switch (tmpElementType)
		{
			case 'connection':
			case 'connection-hitarea':
				this._addBezierHandle(tmpTarget, pEvent);
				break;

			case 'connection-handle':
				this._removeBezierHandle(tmpTarget);
				break;

			case 'tether':
			case 'tether-hitarea':
				this._addTetherBezierHandle(tmpTarget, pEvent);
				break;

			case 'tether-handle':
				this._removeTetherBezierHandle(tmpTarget);
				break;
		}
	}

	/**
	 * Remove all event listeners. Pointer/wheel/contextmenu listeners live
	 * as inline template attributes and don't need explicit teardown — they
	 * disappear with the SVG element when the FlowView is destroyed.
	 */
	destroy()
	{
		document.removeEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Handle pointer down event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerDown(pEvent)
	{
		if (!this._FlowView) return;

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		// Check if click is inside a panel content area — let HTML handle its own events
		if (tmpTarget.closest && tmpTarget.closest('.pict-flow-panel-content'))
		{
			return;
		}

		// Capture pointer for smooth dragging (left-click only — right-click
		// needs the real target for contextmenu handle add/remove)
		if (pEvent.button === 0)
		{
			this._SVGElement.setPointerCapture(pEvent.pointerId);
		}

		switch (tmpElementType)
		{
			case 'port':
				this._startConnection(pEvent, tmpTarget);
				break;

			case 'node':
			case 'node-body':
			case 'panel-indicator':
			{
				let tmpNodeHash = this._getNodeHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same node
				if (tmpNodeHash && tmpNodeHash === this._LastClickNodeHash
					&& (tmpNow - this._LastClickTime) < this._DoubleClickThreshold)
				{
					// Double-click: toggle panel
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.togglePanel(tmpNodeHash);
				}
				else
				{
					// Single click: start node drag
					this._LastClickTime = tmpNow;
					this._LastClickNodeHash = tmpNodeHash;
					this._startNodeDrag(pEvent, tmpTarget);
				}
				break;
			}

			case 'panel-titlebar':
				this._startPanelDrag(pEvent, tmpTarget);
				break;

			case 'panel-resize':
				this._startPanelResize(pEvent, tmpTarget);
				break;

			case 'panel-close':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				if (tmpPanelHash)
				{
					this._FlowView.closePanel(tmpPanelHash);
				}
				break;
			}

			case 'connection-handle':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on handle to toggle mode
				if (tmpConnectionHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleConnectionLineMode(tmpConnectionHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpConnectionHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, tmpConnectionHash, null, tmpHandleType, false);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'tether':
			case 'tether-hitarea':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same tether to add a handle
				if (tmpPanelHash && tmpPanelHash === this._LastTetherClickHash
					&& (tmpNow - this._LastTetherClickTime) < this._DoubleClickThreshold)
				{
					this._LastTetherClickTime = 0;
					this._LastTetherClickHash = null;
					this._addTetherBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastTetherClickTime = tmpNow;
					this._LastTetherClickHash = tmpPanelHash;
					this._selectTether(tmpTarget);
				}
				break;
			}

			case 'tether-handle':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on tether handle to toggle mode
				if (tmpPanelHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleTetherLineMode(tmpPanelHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpPanelHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, null, tmpPanelHash, tmpHandleType, true);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'connection':
			case 'connection-hitarea':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same connection to add a handle
				if (tmpConnectionHash && tmpConnectionHash === this._LastConnectionClickHash
					&& (tmpNow - this._LastConnectionClickTime) < this._DoubleClickThreshold)
				{
					this._LastConnectionClickTime = 0;
					this._LastConnectionClickHash = null;
					this._addBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastConnectionClickTime = tmpNow;
					this._LastConnectionClickHash = tmpConnectionHash;
					this._selectConnection(tmpTarget);
				}
				break;
			}

			default:
				// Click on background - start panning or deselect
				if (pEvent.button === 0 && this._FlowView.options.EnablePanning)
				{
					this._startPanning(pEvent);
				}
				break;
		}
	}

	/**
	 * Handle pointer move event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerMove(pEvent)
	{
		if (!this._FlowView) return;

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._onNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._onPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._onHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._onConnectionDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._onPanelResize(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._onPan(pEvent);
				break;
		}
	}

	/**
	 * Handle pointer up event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerUp(pEvent)
	{
		if (!this._FlowView) return;

		// Release pointer capture
		if (this._SVGElement.hasPointerCapture && this._SVGElement.hasPointerCapture(pEvent.pointerId))
		{
			this._SVGElement.releasePointerCapture(pEvent.pointerId);
		}

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._endNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._endPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._endHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._endPanelResize(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._endConnection(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._endPanning(pEvent);
				break;
		}
	}

	/**
	 * Handle mouse wheel for zoom
	 * @param {WheelEvent} pEvent
	 */
	_onWheel(pEvent)
	{
		if (!this._FlowView || !this._FlowView.options.EnableZooming) return;

		pEvent.preventDefault();

		let tmpDelta = pEvent.deltaY > 0 ? -this._FlowView.options.ZoomStep : this._FlowView.options.ZoomStep;
		let tmpNewZoom = this._FlowView.viewState.Zoom + tmpDelta;

		// Zoom toward mouse position
		let tmpRect = this._SVGElement.getBoundingClientRect();
		let tmpMouseX = pEvent.clientX - tmpRect.left;
		let tmpMouseY = pEvent.clientY - tmpRect.top;

		this._FlowView.setZoom(tmpNewZoom, tmpMouseX, tmpMouseY);
	}

	/**
	 * Handle keyboard events
	 * @param {KeyboardEvent} pEvent
	 */
	_onKeyDown(pEvent)
	{
		if (!this._FlowView) return;

		// Only handle events when the flow is focused/visible
		if (pEvent.key === 'Delete' || pEvent.key === 'Backspace')
		{
			// Don't delete if user is typing in an input or inside a panel
			if (pEvent.target && (pEvent.target.tagName === 'INPUT' || pEvent.target.tagName === 'TEXTAREA' || pEvent.target.tagName === 'SELECT'))
			{
				return;
			}
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.pict-flow-panel'))
			{
				return;
			}

			this._FlowView.deleteSelected();
			pEvent.preventDefault();
		}
		else if (pEvent.key === 'Escape')
		{
			if (this._State === INTERACTION_STATES.CONNECTING)
			{
				this._cancelConnection();
			}

			// Exit fullscreen if currently in fullscreen mode
			if (this._FlowView._IsFullscreen)
			{
				this._FlowView.exitFullscreen();
				// Update the toolbar button text
				if (this._FlowView._ToolbarView)
				{
					let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
					let tmpBtnElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpBtnElements.length > 0)
					{
						tmpBtnElements[0].innerHTML = '&#x26F6; Fullscreen';
					}
				}
				pEvent.preventDefault();
				return;
			}

			this._FlowView.deselectAll();
		}
	}

	// ---- Node Dragging ----

	_startNodeDrag(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeDragging) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		this._FlowView.selectNode(tmpNodeHash);

		let tmpNode = this._FlowView.getNode(tmpNodeHash);
		if (!tmpNode) return;

		this._State = INTERACTION_STATES.DRAGGING_NODE;
		this._DragNodeHash = tmpNodeHash;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragNodeStartX = tmpNode.X;
		this._DragNodeStartY = tmpNode.Y;

		this._SVGElement.classList.add('panning');

		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${tmpNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.classList.add('dragging');
		}
	}

	_onNodeDrag(pEvent)
	{
		if (!this._DragNodeHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragNodeStartX + tmpDX;
		let tmpNewY = this._DragNodeStartY + tmpDY;

		this._FlowView.updateNodePosition(this._DragNodeHash, tmpNewX, tmpNewY);
	}

	_endNodeDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${this._DragNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.classList.remove('dragging');
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		let tmpNode = this._FlowView.getNode(this._DragNodeHash);
		if (tmpNode && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeMoved', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragNodeHash = null;
	}

	// ---- Panel Dragging ----

	_startPanelDrag(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.DRAGGING_PANEL;
		this._DragPanelHash = tmpPanelHash;
		this._DragPanelStartX = pEvent.clientX;
		this._DragPanelStartY = pEvent.clientY;
		this._DragPanelDataStartX = tmpPanel.X;
		this._DragPanelDataStartY = tmpPanel.Y;

		this._SVGElement.classList.add('panning');
	}

	_onPanelDrag(pEvent)
	{
		if (!this._DragPanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragPanelStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragPanelStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragPanelDataStartX + tmpDX;
		let tmpNewY = this._DragPanelDataStartY + tmpDY;

		this._FlowView.updatePanelPosition(this._DragPanelHash, tmpNewX, tmpNewY);
	}

	_endPanelDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.marshalFromView();

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragPanelHash);
		if (tmpPanel && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelMoved', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragPanelHash = null;
	}

	// ---- Panel Resizing ----

	_startPanelResize(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.RESIZING_PANEL;
		this._ResizePanelHash = tmpPanelHash;
		this._ResizeStartY = pEvent.clientY;
		this._ResizePanelStartHeight = tmpPanel.Height;

		this._SVGElement.classList.add('panning');
	}

	_onPanelResize(pEvent)
	{
		if (!this._ResizePanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDY = (pEvent.clientY - this._ResizeStartY) / tmpVS.Zoom;
		let tmpNewHeight = Math.max(120, this._ResizePanelStartHeight + tmpDY);

		// Update the panel data
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._ResizePanelHash);
		if (tmpPanel)
		{
			tmpPanel.Height = tmpNewHeight;
		}

		// Update the foreignObject height directly for smooth resizing
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector('[data-panel-hash="' + this._ResizePanelHash + '"]');
			if (tmpFO)
			{
				tmpFO.setAttribute('height', String(tmpNewHeight));
			}
		}
	}

	_endPanelResize(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		// Re-render to sync tethers
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ResizePanelHash = null;
	}

	// ---- Handle Dragging ----

	_startHandleDrag(pEvent, pConnectionHash, pPanelHash, pHandleType, pIsTether)
	{
		this._State = INTERACTION_STATES.DRAGGING_HANDLE;
		this._DragHandleConnectionHash = pConnectionHash;
		this._DragHandlePanelHash = pPanelHash;
		this._DragHandleType = pHandleType;
		this._DragHandleIsTether = pIsTether;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._SVGElement.classList.add('panning');
	}

	_onHandleDrag(pEvent)
	{
		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		if (this._DragHandleIsTether)
		{
			this._FlowView.updateTetherHandle(
				this._DragHandlePanelHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
		else
		{
			this._FlowView.updateConnectionHandle(
				this._DragHandleConnectionHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
	}

	_endHandleDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);

			if (this._DragHandleIsTether)
			{
				let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragHandlePanelHash);
				if (tmpPanel)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onTetherHandleMoved', tmpPanel);
				}
			}
			else
			{
				let tmpConnection = this._FlowView.getConnection(this._DragHandleConnectionHash);
				if (tmpConnection)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onConnectionHandleMoved', tmpConnection);
				}
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;
	}

	// ---- Right-Click Handle Add/Remove ----

	/**
	 * Add a bezier handle to a connection at the right-click position.
	 * @param {Element} pTarget - The SVG element that was right-clicked
	 * @param {MouseEvent} pEvent - The contextmenu event
	 */
	_addBezierHandle(pTarget, pEvent)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		// Select the connection so handle circles are rendered after the re-render
		this._FlowView.selectConnection(tmpConnectionHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addConnectionHandle(tmpConnectionHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a connection.
	 * @param {Element} pTarget - The handle SVG element that was right-clicked
	 */
	_removeBezierHandle(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeConnectionHandle(tmpConnectionHash, tmpIndex);
	}

	/**
	 * Add a bezier handle to a tether.
	 * @param {Element} pTarget - The tether SVG element that was right-clicked or double-clicked
	 * @param {Event} pEvent - The mouse event (for coordinate extraction)
	 */
	_addTetherBezierHandle(pTarget, pEvent)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		// Select the tether so handles render after re-render
		this._FlowView.selectTether(tmpPanelHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addTetherHandle(tmpPanelHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a tether.
	 * @param {Element} pTarget - The tether handle SVG element that was right-clicked
	 */
	_removeTetherBezierHandle(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeTetherHandle(tmpPanelHash, tmpIndex);
	}

	// ---- Line Mode Toggling ----

	_toggleConnectionLineMode(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		let tmpCurrentMode = tmpConnection.Data.LineMode || 'bezier';
		tmpConnection.Data.LineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		// Reset handle positions when switching modes
		tmpConnection.Data.HandleCustomized = false;
		tmpConnection.Data.BezierHandles = [];
		tmpConnection.Data.BezierHandleX = null;
		tmpConnection.Data.BezierHandleY = null;
		tmpConnection.Data.OrthoCorner1X = null;
		tmpConnection.Data.OrthoCorner1Y = null;
		tmpConnection.Data.OrthoCorner2X = null;
		tmpConnection.Data.OrthoCorner2Y = null;
		tmpConnection.Data.OrthoMidOffset = 0;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionModeChanged', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	_toggleTetherLineMode(pPanelHash)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.toggleLineMode(tmpPanel);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onTetherModeChanged', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	// ---- Tether Selection ----

	_selectTether(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (tmpPanelHash)
		{
			this._FlowView.selectTether(tmpPanelHash);
		}
	}

	// ---- Connection Creation ----

	_startConnection(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableConnectionCreation) return;

		let tmpNodeHash = pTarget.getAttribute('data-node-hash');
		let tmpPortHash = pTarget.getAttribute('data-port-hash');
		let tmpPortDirection = pTarget.getAttribute('data-port-direction');

		if (!tmpNodeHash || !tmpPortHash) return;

		if (tmpPortDirection !== 'output')
		{
			return;
		}

		this._State = INTERACTION_STATES.CONNECTING;
		this._ConnectSourceNodeHash = tmpNodeHash;
		this._ConnectSourcePortHash = tmpPortHash;

		this._SVGElement.classList.add('connecting');

		let tmpPortPos = this._FlowView.getPortPosition(tmpNodeHash, tmpPortHash);
		if (tmpPortPos)
		{
			this._ConnectDragLine = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			this._ConnectDragLine.setAttribute('class', 'pict-flow-drag-connection');
			this._ConnectDragLine.setAttribute('d', `M ${tmpPortPos.x} ${tmpPortPos.y} L ${tmpPortPos.x} ${tmpPortPos.y}`);
			this._FlowView._ViewportElement.appendChild(this._ConnectDragLine);
		}

		pEvent.stopPropagation();
	}

	_onConnectionDrag(pEvent)
	{
		if (!this._ConnectDragLine) return;

		let tmpSourcePos = this._FlowView.getPortPosition(this._ConnectSourceNodeHash, this._ConnectSourcePortHash);
		if (!tmpSourcePos) return;

		let tmpEndCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		let tmpDX = Math.abs(tmpEndCoords.x - tmpSourcePos.x) * 0.5;
		let tmpPath = `M ${tmpSourcePos.x} ${tmpSourcePos.y} C ${tmpSourcePos.x + tmpDX} ${tmpSourcePos.y}, ${tmpEndCoords.x - tmpDX} ${tmpEndCoords.y}, ${tmpEndCoords.x} ${tmpEndCoords.y}`;
		this._ConnectDragLine.setAttribute('d', tmpPath);
	}

	_endConnection(pEvent)
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		let tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		if (tmpTarget)
		{
			let tmpTargetPortHash = tmpTarget.getAttribute('data-port-hash');
			let tmpTargetNodeHash = tmpTarget.getAttribute('data-node-hash');
			let tmpTargetPortDirection = tmpTarget.getAttribute('data-port-direction');

			if (tmpTargetPortHash && tmpTargetNodeHash && tmpTargetPortDirection === 'input')
			{
				this._FlowView.addConnection(
					this._ConnectSourceNodeHash,
					this._ConnectSourcePortHash,
					tmpTargetNodeHash,
					tmpTargetPortHash
				);
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	_cancelConnection()
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	// ---- Panning ----

	_startPanning(pEvent)
	{
		this._FlowView.deselectAll();

		this._State = INTERACTION_STATES.PANNING;
		this._PanStartX = pEvent.clientX;
		this._PanStartY = pEvent.clientY;
		this._PanStartPanX = this._FlowView.viewState.PanX;
		this._PanStartPanY = this._FlowView.viewState.PanY;

		this._SVGElement.classList.add('panning');
	}

	_onPan(pEvent)
	{
		let tmpDX = pEvent.clientX - this._PanStartX;
		let tmpDY = pEvent.clientY - this._PanStartY;

		this._FlowView.viewState.PanX = this._PanStartPanX + tmpDX;
		this._FlowView.viewState.PanY = this._PanStartPanY + tmpDY;

		this._FlowView.updateViewportTransform();
	}

	_endPanning(pEvent)
	{
		this._SVGElement.classList.remove('panning');
		this._State = INTERACTION_STATES.IDLE;
	}

	// ---- Connection Selection ----

	_selectConnection(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (tmpConnectionHash)
		{
			this._FlowView.selectConnection(tmpConnectionHash);
		}
	}

	// ---- Utilities ----

	_getElementType(pTarget)
	{
		if (!pTarget) return 'background';

		let tmpType = pTarget.getAttribute ? pTarget.getAttribute('data-element-type') : null;
		if (tmpType) return tmpType;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpType = tmpParent.getAttribute ? tmpParent.getAttribute('data-element-type') : null;
			if (tmpType) return tmpType;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return 'background';
	}

	_getNodeHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-node-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-node-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getPanelHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-panel-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-panel-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getConnectionHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-connection-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-connection-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}
}

module.exports = PictServiceFlowInteractionManager;
module.exports.INTERACTION_STATES = INTERACTION_STATES;

},{"fable-serviceproviderbase":6}],54:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libLayoutCustom           = require('../providers/layouts/Layout-Custom.js');
const libLayoutLayered          = require('../providers/layouts/Layout-Layered.js');
const libLayoutForcedFromCenter = require('../providers/layouts/Layout-ForcedFromCenter.js');
const libLayoutGrid             = require('../providers/layouts/Layout-Grid.js');
const libLayoutCircular         = require('../providers/layouts/Layout-Circular.js');
const libLayoutTabular          = require('../providers/layouts/Layout-Tabular.js');
const libLayoutColumnar         = require('../providers/layouts/Layout-Columnar.js');

const libEdgeBezier              = require('../providers/edges/Edge-Bezier.js');
const libEdgeOrthogonal          = require('../providers/edges/Edge-Orthogonal.js');
const libEdgeStraight            = require('../providers/edges/Edge-Straight.js');
const libEdgeOrthogonalSnap      = require('../providers/edges/Edge-OrthogonalSnap.js');
const libEdgePerimeter           = require('../providers/edges/Edge-Perimeter.js');
const libEdgePerimeterLinear     = require('../providers/edges/Edge-Perimeter-Linear.js');
const libEdgePerimeterOrthogonal = require('../providers/edges/Edge-Perimeter-Orthogonal.js');

const _BUILTIN_ALGORITHMS =
[
	libLayoutCustom,
	libLayoutLayered,
	libLayoutForcedFromCenter,
	libLayoutGrid,
	libLayoutCircular,
	libLayoutTabular,
	libLayoutColumnar
];

const _BUILTIN_EDGE_THEMES =
[
	libEdgeBezier,
	libEdgeOrthogonal,
	libEdgeStraight,
	libEdgeOrthogonalSnap,
	libEdgePerimeter,
	libEdgePerimeterLinear,
	libEdgePerimeterOrthogonal
];

const _LEGACY_ALGORITHM  = 'Layered';
const _DEFAULT_EDGE_THEME = 'Bezier';

/**
 * PictServiceFlowLayout
 *
 * Layout-algorithm registry and dispatcher. Holds plain descriptor
 * objects (`{ Name, Label, Apply, DefaultParameters, ParameterSchema }`)
 * for every registered layout algorithm, plus the small helpers
 * `snapToGrid` and `centerNodes` and the special-case `autoLayoutSubset`.
 *
 * Algorithms are pure functions over `(nodes, connections, parameters)`
 * that mutate node X/Y in place. Third parties extend the registry via
 * `registerAlgorithm(pDescriptor)`.
 *
 * Note: `_LayoutProvider` (PictProvider-Flow-Layouts.js) is a different
 * concept — it manages **saved layout snapshots** (named position
 * captures the user can restore later). Don't confuse "layouts" (saved
 * snapshots) with "layout algorithms" (procedural arrangement).
 */
class PictServiceFlowLayout extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowLayout';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Legacy spacing fields kept for `autoLayoutSubset` and any
		// external consumer that read them. The Layered algorithm itself
		// pulls spacing from its DefaultParameters.
		this._HorizontalSpacing = 250;
		this._VerticalSpacing = 120;
		this._StartX = 100;
		this._StartY = 100;

		// Algorithm registry: Name → descriptor
		this._Algorithms = {};

		// Edge-theme registry: Name → descriptor
		this._EdgeThemes = {};

		for (let i = 0; i < _BUILTIN_ALGORITHMS.length; i++)
		{
			this.registerAlgorithm(_BUILTIN_ALGORITHMS[i]);
		}
		for (let i = 0; i < _BUILTIN_EDGE_THEMES.length; i++)
		{
			this.registerEdgeTheme(_BUILTIN_EDGE_THEMES[i]);
		}
	}

	// ── Algorithm Registry ────────────────────────────────────────────────

	/**
	 * Register a layout algorithm.
	 * @param {Object} pDescriptor - { Name, Label, Apply, DefaultParameters, ParameterSchema }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerAlgorithm(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerAlgorithm: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.Apply !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerAlgorithm: descriptor.Apply for '${pDescriptor.Name}' must be a function`);
			return false;
		}

		this._Algorithms[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered algorithm by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getAlgorithm(pName)
	{
		return this._Algorithms[pName] || null;
	}

	/**
	 * List all registered algorithm names in registration order.
	 * @returns {string[]}
	 */
	getAlgorithmNames()
	{
		return Object.keys(this._Algorithms);
	}

	/**
	 * List all registered algorithm descriptors.
	 * @returns {Object[]}
	 */
	listAlgorithms()
	{
		let tmpKeys = Object.keys(this._Algorithms);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._Algorithms[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Build the merged parameter set for an algorithm: default values
	 * with caller-supplied overrides on top.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedParameters(pName, pOverrides)
	{
		let tmpAlgo = this.getAlgorithm(pName);
		if (!tmpAlgo) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpAlgo.DefaultParameters || {}, pOverrides || {});
	}

	// ── Edge-Theme Registry ──────────────────────────────────────────────

	/**
	 * Register an edge theme.
	 * @param {Object} pDescriptor - { Name, Label, Description, GeneratePath, AdjustLayout?, DefaultParameters?, ParameterSchema? }
	 * @returns {boolean} true if registered, false if invalid
	 */
	registerEdgeTheme(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor must be an object');
			return false;
		}
		if (typeof pDescriptor.Name !== 'string' || pDescriptor.Name === '')
		{
			this.log.warn('PictServiceFlowLayout registerEdgeTheme: descriptor.Name is required');
			return false;
		}
		if (typeof pDescriptor.GeneratePath !== 'function')
		{
			this.log.warn(`PictServiceFlowLayout registerEdgeTheme: descriptor.GeneratePath for '${pDescriptor.Name}' must be a function`);
			return false;
		}
		this._EdgeThemes[pDescriptor.Name] = pDescriptor;
		return true;
	}

	/**
	 * Look up a registered edge theme by name.
	 * @param {string} pName
	 * @returns {Object|null}
	 */
	getEdgeTheme(pName)
	{
		return this._EdgeThemes[pName] || null;
	}

	/**
	 * List all registered edge-theme names in registration order.
	 * @returns {string[]}
	 */
	getEdgeThemeNames()
	{
		return Object.keys(this._EdgeThemes);
	}

	/**
	 * List all registered edge-theme descriptors.
	 * @returns {Object[]}
	 */
	listEdgeThemes()
	{
		let tmpKeys = Object.keys(this._EdgeThemes);
		let tmpResult = [];
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpResult.push(this._EdgeThemes[tmpKeys[i]]);
		}
		return tmpResult;
	}

	/**
	 * Resolve which edge theme should render a given connection. Order:
	 *   1. `Connection.Data.EdgeTheme` (per-connection override)
	 *   2. Per-connection `Connection.Data.LineMode === 'orthogonal'`
	 *      → 'Orthogonal' (back-compat for the existing line-mode flag)
	 *   3. `_FlowData.EdgeTheme` (flow-level)
	 *   4. Active layout's `DefaultEdgeTheme`
	 *   5. The hard fallback ('Bezier')
	 *
	 * Returns null only if even the fallback isn't registered, in which
	 * case the renderer should use its built-in path generators.
	 *
	 * @param {Object} pConnection
	 * @returns {Object|null}
	 */
	resolveActiveEdgeTheme(pConnection)
	{
		let tmpData = (pConnection && pConnection.Data) || {};
		let tmpFlowView = this._FlowView;
		let tmpFlowData = tmpFlowView ? tmpFlowView._FlowData : null;

		if (tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpData.LineMode === 'orthogonal' && !tmpData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme('Orthogonal');
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.EdgeTheme)
		{
			let tmpTheme = this.getEdgeTheme(tmpFlowData.EdgeTheme);
			if (tmpTheme) return tmpTheme;
		}
		if (tmpFlowData && tmpFlowData.LayoutAlgorithm)
		{
			let tmpAlgo = this.getAlgorithm(tmpFlowData.LayoutAlgorithm);
			if (tmpAlgo && tmpAlgo.DefaultEdgeTheme)
			{
				let tmpTheme = this.getEdgeTheme(tmpAlgo.DefaultEdgeTheme);
				if (tmpTheme) return tmpTheme;
			}
		}
		return this.getEdgeTheme(_DEFAULT_EDGE_THEME);
	}

	/**
	 * Build the merged parameter set for an edge theme.
	 * @param {string} pName
	 * @param {Object} [pOverrides]
	 * @returns {Object}
	 */
	getMergedEdgeThemeParameters(pName, pOverrides)
	{
		let tmpTheme = this.getEdgeTheme(pName);
		if (!tmpTheme) return Object.assign({}, pOverrides || {});
		return Object.assign({}, tmpTheme.DefaultParameters || {}, pOverrides || {});
	}

	// ── Dispatch ──────────────────────────────────────────────────────────

	/**
	 * Apply a registered layout algorithm. Mutates node X/Y in place.
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters]
	 */
	applyLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		let tmpAlgo = this.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictServiceFlowLayout applyLayout: unknown algorithm '${pAlgorithmName}', falling back to '${_LEGACY_ALGORITHM}'`);
			tmpAlgo = this.getAlgorithm(_LEGACY_ALGORITHM);
			if (!tmpAlgo) return;
		}
		let tmpMerged = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		tmpAlgo.Apply(pNodes, pConnections, tmpMerged);
	}

	/**
	 * Auto-layout entry point.
	 *
	 * - Legacy 2-arg form `autoLayout(nodes, connections)` dispatches to
	 *   the Layered algorithm and is byte-for-byte identical to the
	 *   pre-subsystem behavior.
	 * - 3- or 4-arg form `autoLayout(nodes, connections, name, params)`
	 *   dispatches to the named algorithm.
	 *
	 * @param {Array} pNodes
	 * @param {Array} pConnections
	 * @param {string} [pAlgorithmName] - defaults to the Layered algorithm
	 * @param {Object} [pParameters]
	 */
	autoLayout(pNodes, pConnections, pAlgorithmName, pParameters)
	{
		if (!pNodes || pNodes.length === 0) return;
		let tmpName = (typeof pAlgorithmName === 'string' && pAlgorithmName !== '') ? pAlgorithmName : _LEGACY_ALGORITHM;
		this.applyLayout(pNodes, pConnections, tmpName, pParameters);
	}

	// ── Helpers ──────────────────────────────────────────────────────────

	/**
	 * Snap a coordinate to the nearest grid point.
	 * @param {number} pValue
	 * @param {number} pGridSize
	 * @returns {number}
	 */
	snapToGrid(pValue, pGridSize)
	{
		if (!pGridSize || pGridSize <= 0) return pValue;
		return Math.round(pValue / pGridSize) * pGridSize;
	}

	/**
	 * Auto-layout a subset of nodes, positioning them to the right of
	 * any fixed (already-positioned) nodes.
	 *
	 * Used by the saved-layout restore flow (`PictProvider-Flow-Layouts`)
	 * to position nodes that exist in the current flow but were absent
	 * from the saved snapshot.
	 *
	 * **Always runs the Layered algorithm**, regardless of the flow's
	 * configured `LayoutAlgorithm`. Running ForcedFromCenter or another
	 * algorithm on a partial node set would jitter the matched nodes
	 * (which are intentionally fixed). The contract here is "place the
	 * orphans in a sensible default arrangement," not "obey the user's
	 * full-graph algorithm."
	 *
	 * @param {Array} pNodesToLayout - Nodes that need new positions
	 * @param {Array} pFixedNodes - Nodes that already have positions (read-only)
	 * @param {Array} pConnections - All connections in the flow
	 */
	autoLayoutSubset(pNodesToLayout, pFixedNodes, pConnections)
	{
		if (!pNodesToLayout || pNodesToLayout.length === 0) return;

		// Compute the starting X position to the right of all fixed nodes
		let tmpStartX = this._StartX;
		let tmpStartY = this._StartY;

		if (pFixedNodes && pFixedNodes.length > 0)
		{
			let tmpMaxX = -Infinity;

			for (let i = 0; i < pFixedNodes.length; i++)
			{
				let tmpRight = pFixedNodes[i].X + (pFixedNodes[i].Width || 180);
				if (tmpRight > tmpMaxX)
				{
					tmpMaxX = tmpRight;
				}
			}

			tmpStartX = tmpMaxX + this._HorizontalSpacing;
		}

		// Build a set of nodes we are laying out for quick lookup
		let tmpNodeSet = {};
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			tmpNodeSet[pNodesToLayout[i].Hash] = true;
		}

		// Build adjacency information only for nodes in the subset
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			let tmpNode = pNodesToLayout[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		for (let i = 0; i < pConnections.length; i++)
		{
			let tmpConn = pConnections[i];
			let tmpSourceInSubset = tmpNodeSet[tmpConn.SourceNodeHash];
			let tmpTargetInSubset = tmpNodeSet[tmpConn.TargetNodeHash];

			if (tmpSourceInSubset && tmpTargetInSubset)
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];
			let tmpNextQueue = [];

			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle remaining unassigned nodes (cycles or disconnected)
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			if (!tmpAssigned[pNodesToLayout[i].Hash])
			{
				tmpRemainingNodes.push(pNodesToLayout[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers, starting from tmpStartX
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + this._VerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + this._HorizontalSpacing;
		}
	}

	/**
	 * Center all nodes around a given point.
	 * @param {Array} pNodes
	 * @param {number} pCenterX
	 * @param {number} pCenterY
	 */
	centerNodes(pNodes, pCenterX, pCenterY)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMinX = Math.min(tmpMinX, pNodes[i].X);
			tmpMinY = Math.min(tmpMinY, pNodes[i].Y);
			tmpMaxX = Math.max(tmpMaxX, pNodes[i].X + (pNodes[i].Width || 180));
			tmpMaxY = Math.max(tmpMaxY, pNodes[i].Y + (pNodes[i].Height || 80));
		}

		let tmpCurrentCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCurrentCenterY = (tmpMinY + tmpMaxY) / 2;
		let tmpOffsetX = pCenterX - tmpCurrentCenterX;
		let tmpOffsetY = pCenterY - tmpCurrentCenterY;

		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X += tmpOffsetX;
			pNodes[i].Y += tmpOffsetY;
		}
	}
}

module.exports = PictServiceFlowLayout;

},{"../providers/edges/Edge-Bezier.js":34,"../providers/edges/Edge-Orthogonal.js":35,"../providers/edges/Edge-OrthogonalSnap.js":36,"../providers/edges/Edge-Perimeter-Linear.js":37,"../providers/edges/Edge-Perimeter-Orthogonal.js":38,"../providers/edges/Edge-Perimeter.js":39,"../providers/edges/Edge-Straight.js":41,"../providers/layouts/Layout-Circular.js":42,"../providers/layouts/Layout-Columnar.js":44,"../providers/layouts/Layout-Custom.js":45,"../providers/layouts/Layout-ForcedFromCenter.js":46,"../providers/layouts/Layout-Grid.js":47,"../providers/layouts/Layout-Layered.js":48,"../providers/layouts/Layout-Tabular.js":49,"fable-serviceproviderbase":6}],55:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PanelManager
 *
 * Manages the lifecycle of properties panels in the flow diagram:
 * opening, closing, toggling, and position updates for panels
 * associated with flow nodes.
 */
class PictServiceFlowPanelManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPanelManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node was not found
	 */
	openPanel(pNodeHash)
	{
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return false;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);
		if (!tmpNodeTypeConfig) return false;

		// Check if a panel is already open for this node
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting) return tmpExisting;

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelHash = `panel-${this.fable.getUUID()}`;
		let tmpWidth, tmpHeight, tmpPanelType, tmpTitle;

		if (tmpPanelConfig)
		{
			tmpWidth = tmpPanelConfig.DefaultWidth || 300;
			tmpHeight = tmpPanelConfig.DefaultHeight || 200;
			tmpPanelType = tmpPanelConfig.PanelType || 'Base';
			tmpTitle = tmpPanelConfig.Title || tmpNodeTypeConfig.Label || 'Properties';
		}
		else
		{
			// No PropertiesPanel configured — open an auto-generated info panel
			tmpWidth = 240;
			tmpHeight = 180;
			tmpPanelType = 'Info';
			tmpTitle = tmpNodeTypeConfig.Label || tmpNode.Title || 'Node Info';
		}

		let tmpPanelData =
		{
			Hash: tmpPanelHash,
			NodeHash: pNodeHash,
			PanelType: tmpPanelType,
			Title: tmpTitle,
			X: tmpNode.X + tmpNode.Width + 30,
			Y: tmpNode.Y,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		let tmpIndex = this._FlowView._FlowData.OpenPanels.findIndex((pPanel) => pPanel.Hash === pPanelHash);
		if (tmpIndex < 0) return false;

		let tmpRemovedPanel = this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1)[0];

		// Clean up the panel instance
		if (this._FlowView._PropertiesPanelView)
		{
			this._FlowView._PropertiesPanelView.destroyPanel(pPanelHash);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelClosed', tmpRemovedPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openPanel(pNodeHash);
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		tmpPanel.X = pX;
		tmpPanel.Y = pY;

		// Reset tether handle positions when panel moves
		this._FlowView._resetHandlesForPanel(pPanelHash);

		// Update the foreignObject position directly for smooth dragging
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector(`[data-panel-hash="${pPanelHash}"]`);
			if (tmpFO)
			{
				tmpFO.setAttribute('x', String(pX));
				tmpFO.setAttribute('y', String(pY));
			}
		}

		// Update the tether for this panel
		this._FlowView._renderTethersForNode(tmpPanel.NodeHash);
	}
}

module.exports = PictServiceFlowPanelManager;

},{"fable-serviceproviderbase":6}],56:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PathGenerator
 *
 * Centralizes SVG path generation for the flow diagram.
 * Provides shared building blocks used by both the ConnectionRenderer
 * (port-to-port connections) and the TetherService (panel-to-node tethers).
 *
 * Responsibilities:
 *   - Departure/approach point calculation from anchors
 *   - Auto orthogonal corner computation for right-angle paths
 *   - Cubic bezier evaluation at arbitrary parameter t
 *   - SVG path string assembly (bezier, split-bezier, orthogonal)
 */
class PictServiceFlowPathGenerator extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPathGenerator';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Departure / Approach Calculation ----

	/**
	 * Compute departure and approach points from start/end anchors.
	 * The departure point extends outward from the start in its side direction,
	 * and the approach point extends outward from the end in its side direction.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom - Start anchor with side
	 * @param {{x: number, y: number, side: string}} pTo - End anchor with side
	 * @param {number} pDepartDist - Distance for departure/approach straight segments
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, fromDir: {dx: number, dy: number}, toDir: {dx: number, dy: number}}}
	 */
	computeDepartApproach(pFrom, pTo, pDepartDist)
	{
		let tmpGeometry = this._FlowView._GeometryProvider;

		let tmpFromDir = tmpGeometry.sideDirection(pFrom.side || 'right');
		let tmpToDir = tmpGeometry.sideDirection(pTo.side || 'left');

		return {
			departX: pFrom.x + tmpFromDir.dx * pDepartDist,
			departY: pFrom.y + tmpFromDir.dy * pDepartDist,
			approachX: pTo.x + tmpToDir.dx * pDepartDist,
			approachY: pTo.y + tmpToDir.dy * pDepartDist,
			fromDir: tmpFromDir,
			toDir: tmpToDir
		};
	}

	// ---- Orthogonal Corner Calculation ----

	/**
	 * Compute auto orthogonal corners for an L-shaped or Z-shaped path.
	 * Determines corner placement based on departure/approach directions.
	 *
	 * Used by both connection and tether renderers for right-angle paths.
	 *
	 * @param {number} pDepartX
	 * @param {number} pDepartY
	 * @param {number} pApproachX
	 * @param {number} pApproachY
	 * @param {{dx: number, dy: number}} pFromDir - Departure direction vector
	 * @param {{dx: number, dy: number}} pToDir - Approach direction vector
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {{corner1: {x: number, y: number}, corner2: {x: number, y: number}, midpoint: {x: number, y: number}}}
	 */
	computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset)
	{
		let tmpOffset = pMidOffset || 0;
		let tmpFromHoriz = Math.abs(pFromDir.dx) > 0;
		let tmpToHoriz = Math.abs(pToDir.dx) > 0;

		let tmpCorner1, tmpCorner2, tmpMidpoint;

		if (tmpFromHoriz && tmpToHoriz)
		{
			// Both horizontal departure/approach: corridor is vertical
			let tmpMidX = (pDepartX + pApproachX) / 2 + tmpOffset;
			tmpCorner1 = { x: tmpMidX, y: pDepartY };
			tmpCorner2 = { x: tmpMidX, y: pApproachY };
			tmpMidpoint = { x: tmpMidX, y: (pDepartY + pApproachY) / 2 };
		}
		else if (!tmpFromHoriz && !tmpToHoriz)
		{
			// Both vertical: corridor is horizontal
			let tmpMidY = (pDepartY + pApproachY) / 2 + tmpOffset;
			tmpCorner1 = { x: pDepartX, y: tmpMidY };
			tmpCorner2 = { x: pApproachX, y: tmpMidY };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: tmpMidY };
		}
		else if (tmpFromHoriz && !tmpToHoriz)
		{
			// Horizontal→Vertical: single L-bend
			tmpCorner1 = { x: pApproachX + tmpOffset, y: pDepartY };
			tmpCorner2 = { x: pApproachX + tmpOffset, y: pApproachY };
			tmpMidpoint = { x: pApproachX + tmpOffset, y: (pDepartY + pApproachY) / 2 };
		}
		else
		{
			// Vertical→Horizontal: single L-bend
			tmpCorner1 = { x: pDepartX, y: pApproachY + tmpOffset };
			tmpCorner2 = { x: pApproachX, y: pApproachY + tmpOffset };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: pApproachY + tmpOffset };
		}

		return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
	}

	// ---- Bezier Evaluation ----

	/**
	 * Evaluate a cubic bezier curve at parameter t.
	 * B(t) = (1-t)³P0 + 3(1-t)²tP1 + 3(1-t)t²P2 + t³P3
	 *
	 * @param {{x: number, y: number}} pP0 - Start point
	 * @param {{x: number, y: number}} pP1 - First control point
	 * @param {{x: number, y: number}} pP2 - Second control point
	 * @param {{x: number, y: number}} pP3 - End point
	 * @param {number} pT - Parameter in range [0, 1]
	 * @returns {{x: number, y: number}}
	 */
	evaluateCubicBezier(pP0, pP1, pP2, pP3, pT)
	{
		let tmpOMT = 1 - pT;
		let tmpOMT2 = tmpOMT * tmpOMT;
		let tmpOMT3 = tmpOMT2 * tmpOMT;
		let tmpT2 = pT * pT;
		let tmpT3 = tmpT2 * pT;

		return {
			x: tmpOMT3 * pP0.x + 3 * tmpOMT2 * pT * pP1.x + 3 * tmpOMT * tmpT2 * pP2.x + tmpT3 * pP3.x,
			y: tmpOMT3 * pP0.y + 3 * tmpOMT2 * pT * pP1.y + 3 * tmpOMT * tmpT2 * pP2.y + tmpT3 * pP3.y
		};
	}

	// ---- SVG Path String Assembly ----

	/**
	 * Build an SVG bezier path string.
	 * Pattern: M start L depart C cp1, cp2, approach L end
	 *
	 * @param {{x: number, y: number}} pStart - Start point
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {{x: number, y: number}} pCP1 - First control point
	 * @param {{x: number, y: number}} pCP2 - Second control point
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - End point
	 * @returns {string} SVG path d attribute
	 */
	buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1.x} ${pCP1.y}, ${pCP2.x} ${pCP2.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG split bezier path string (two cubic segments through a handle point).
	 * Pattern: M start L depart C cp1a, cp1b, handle C cp2a, cp2b, approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCP1a - First segment's first control point
	 * @param {{x: number, y: number}} pCP1b - First segment's second control point
	 * @param {{x: number, y: number}} pHandle - Handle point where the two segments meet
	 * @param {{x: number, y: number}} pCP2a - Second segment's first control point
	 * @param {{x: number, y: number}} pCP2b - Second segment's second control point
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1a.x} ${pCP1a.y}, ${pCP1b.x} ${pCP1b.y}, ${pHandle.x} ${pHandle.y} C ${pCP2a.x} ${pCP2a.y}, ${pCP2b.x} ${pCP2b.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG multi-segment bezier path string.
	 * Generates N+1 cubic bezier segments through N handle points.
	 *
	 * Pattern: M start L depart C cp,cp,handle[0] C cp,cp,handle[1] ... C cp,cp,approach L end
	 *
	 * Control points are computed using Catmull-Rom-to-Bezier conversion
	 * for C1 (smooth tangent) continuity at every handle.
	 *
	 * @param {{x: number, y: number}} pStart - Port anchor start
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered handle waypoints
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - Port anchor end
	 * @param {{dx: number, dy: number}} pStartDir - Departure direction unit vector
	 * @param {{dx: number, dy: number}} pEndDir - Approach direction unit vector
	 * @returns {string} SVG path d attribute
	 */
	buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir)
	{
		// Build the full list of waypoints: depart, handle[0..N-1], approach
		let tmpWaypoints = [pDepart];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push(pApproach);

		let tmpPath = `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y}`;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpFrom = tmpWaypoints[i];
			let tmpTo = tmpWaypoints[i + 1];

			let tmpSegDX = tmpTo.x - tmpFrom.x;
			let tmpSegDY = tmpTo.y - tmpFrom.y;
			let tmpSegLen = Math.sqrt(tmpSegDX * tmpSegDX + tmpSegDY * tmpSegDY);
			if (tmpSegLen < 1)
			{
				tmpSegLen = 1;
			}
			let tmpScale = tmpSegLen * 0.35;

			// Tangent at tmpFrom
			let tmpTanFromX, tmpTanFromY;
			if (i === 0)
			{
				// First segment: use the port departure direction
				tmpTanFromX = pStartDir.dx;
				tmpTanFromY = pStartDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i - 1];
				let tmpNext = tmpWaypoints[i + 1];
				tmpTanFromX = tmpNext.x - tmpPrev.x;
				tmpTanFromY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanFromX * tmpTanFromX + tmpTanFromY * tmpTanFromY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanFromX /= tmpTanLen;
				tmpTanFromY /= tmpTanLen;
			}

			// Tangent at tmpTo
			let tmpTanToX, tmpTanToY;
			if (i === tmpWaypoints.length - 2)
			{
				// Last segment: use the port approach direction (reversed for incoming)
				tmpTanToX = -pEndDir.dx;
				tmpTanToY = -pEndDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i];
				let tmpNext = tmpWaypoints[i + 2];
				tmpTanToX = tmpNext.x - tmpPrev.x;
				tmpTanToY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanToX * tmpTanToX + tmpTanToY * tmpTanToY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanToX /= tmpTanLen;
				tmpTanToY /= tmpTanLen;
			}

			let tmpCP1X = tmpFrom.x + tmpTanFromX * tmpScale;
			let tmpCP1Y = tmpFrom.y + tmpTanFromY * tmpScale;
			let tmpCP2X = tmpTo.x - tmpTanToX * tmpScale;
			let tmpCP2Y = tmpTo.y - tmpTanToY * tmpScale;

			tmpPath += ` C ${tmpCP1X} ${tmpCP1Y}, ${tmpCP2X} ${tmpCP2Y}, ${tmpTo.x} ${tmpTo.y}`;
		}

		tmpPath += ` L ${pEnd.x} ${pEnd.y}`;

		return tmpPath;
	}

	/**
	 * Build an SVG orthogonal (right-angle) path string.
	 * Pattern: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCorner1
	 * @param {{x: number, y: number}} pCorner2
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} L ${pCorner1.x} ${pCorner1.y} L ${pCorner2.x} ${pCorner2.y} L ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	// ---- Directional Geometry ----

	/**
	 * Compute full directional geometry between two port anchors, including
	 * departure/approach points and bezier control points.
	 *
	 * Uses sophisticated facing detection: when ports face each other the
	 * curve offset scales with inline distance; when ports are on the same
	 * axis but not facing, a wider offset prevents the path from collapsing;
	 * perpendicular exits use a moderate offset.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, cp1X: number, cp1Y: number, cp2X: number, cp2Y: number, startDir: {dx: number, dy: number}, endDir: {dx: number, dy: number}}}
	 */
	computeDirectionalGeometry(pStart, pEnd)
	{
		let tmpStartDir = this._FlowView._GeometryProvider.sideDirection(pStart.side || 'right');
		let tmpEndDir   = this._FlowView._GeometryProvider.sideDirection(pEnd.side   || 'left');

		let tmpStraightLen = 20;

		let tmpDepartX = pStart.x + tmpStartDir.dx * tmpStraightLen;
		let tmpDepartY = pStart.y + tmpStartDir.dy * tmpStraightLen;

		let tmpApproachX = pEnd.x + tmpEndDir.dx * tmpStraightLen;
		let tmpApproachY = pEnd.y + tmpEndDir.dy * tmpStraightLen;

		let tmpDX = Math.abs(tmpApproachX - tmpDepartX);
		let tmpDY = Math.abs(tmpApproachY - tmpDepartY);
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);

		let tmpBaseOffset = Math.max(Math.min(tmpDist * 0.4, 180), 30);

		let tmpSameAxis = (tmpStartDir.dx !== 0 && tmpEndDir.dx !== 0) ||
		                  (tmpStartDir.dy !== 0 && tmpEndDir.dy !== 0);

		let tmpFacingEachOther = false;
		if (tmpSameAxis)
		{
			if (tmpStartDir.dx === 1 && tmpEndDir.dx === -1 && pEnd.x >= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dx === -1 && tmpEndDir.dx === 1 && pEnd.x <= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === 1 && tmpEndDir.dy === -1 && pEnd.y >= pStart.y)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === -1 && tmpEndDir.dy === 1 && pEnd.y <= pStart.y)
			{
				tmpFacingEachOther = true;
			}
		}

		let tmpCurveOffset;

		if (tmpFacingEachOther)
		{
			let tmpInlineDist = (tmpStartDir.dx !== 0) ? tmpDX : tmpDY;
			tmpCurveOffset = Math.max(tmpInlineDist * 0.35, 30);
		}
		else if (tmpSameAxis)
		{
			tmpCurveOffset = Math.max(tmpBaseOffset, 60);
		}
		else
		{
			tmpCurveOffset = Math.max(tmpBaseOffset * 0.8, 40);
		}

		let tmpCP1X = tmpDepartX + tmpStartDir.dx * tmpCurveOffset;
		let tmpCP1Y = tmpDepartY + tmpStartDir.dy * tmpCurveOffset;
		let tmpCP2X = tmpApproachX + tmpEndDir.dx * tmpCurveOffset;
		let tmpCP2Y = tmpApproachY + tmpEndDir.dy * tmpCurveOffset;

		return {
			departX: tmpDepartX, departY: tmpDepartY,
			approachX: tmpApproachX, approachY: tmpApproachY,
			cp1X: tmpCP1X, cp1Y: tmpCP1Y,
			cp2X: tmpCP2X, cp2Y: tmpCP2Y,
			startDir: tmpStartDir, endDir: tmpEndDir
		};
	}

	// ---- Distance Utilities ----

	/**
	 * Distance from point (pPX, pPY) to line segment (pAX, pAY)-(pBX, pBY).
	 * Pure math utility, no state.
	 *
	 * @param {number} pPX
	 * @param {number} pPY
	 * @param {number} pAX
	 * @param {number} pAY
	 * @param {number} pBX
	 * @param {number} pBY
	 * @returns {number}
	 */
	distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		let tmpDX = pBX - pAX;
		let tmpDY = pBY - pAY;
		let tmpLenSq = tmpDX * tmpDX + tmpDY * tmpDY;

		if (tmpLenSq < 0.001)
		{
			// Degenerate segment
			let tmpDPX = pPX - pAX;
			let tmpDPY = pPY - pAY;
			return Math.sqrt(tmpDPX * tmpDPX + tmpDPY * tmpDPY);
		}

		// Project point onto segment, clamped to [0, 1]
		let tmpT = ((pPX - pAX) * tmpDX + (pPY - pAY) * tmpDY) / tmpLenSq;
		if (tmpT < 0) tmpT = 0;
		if (tmpT > 1) tmpT = 1;

		let tmpClosestX = pAX + tmpT * tmpDX;
		let tmpClosestY = pAY + tmpT * tmpDY;
		let tmpDistX = pPX - tmpClosestX;
		let tmpDistY = pPY - tmpClosestY;
		return Math.sqrt(tmpDistX * tmpDistX + tmpDistY * tmpDistY);
	}

	// ---- Auto Midpoint Calculation ----

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between
	 * two port anchors, using the full directional geometry (facing detection,
	 * adaptive curve offsets). Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by ConnectionRenderer for connection midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		let tmpGeo = this.computeDirectionalGeometry(pStart, pEnd);

		return this.evaluateCubicBezier(
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			0.5
		);
	}

	/**
	 * Get the auto-calculated midpoint using simple span-based control points.
	 * Uses computeDepartApproach for basic geometry, then span * 0.4 for
	 * control point distance. Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by TetherService for tether midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom
	 * @param {{x: number, y: number, side: string}} pTo
	 * @param {number} pDepartDist - Departure/approach distance
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpointSimple(pFrom, pTo, pDepartDist)
	{
		let tmpDA = this.computeDepartApproach(pFrom, pTo, pDepartDist);

		let tmpSpanX = Math.abs(tmpDA.approachX - tmpDA.departX);
		let tmpSpanY = Math.abs(tmpDA.approachY - tmpDA.departY);
		let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
		let tmpCPDist = tmpSpan * 0.4;

		let tmpP0 = { x: tmpDA.departX, y: tmpDA.departY };
		let tmpP1 = { x: tmpDA.departX + tmpDA.fromDir.dx * tmpCPDist, y: tmpDA.departY + tmpDA.fromDir.dy * tmpCPDist };
		let tmpP2 = { x: tmpDA.approachX + tmpDA.toDir.dx * tmpCPDist, y: tmpDA.approachY + tmpDA.toDir.dy * tmpCPDist };
		let tmpP3 = { x: tmpDA.approachX, y: tmpDA.approachY };

		return this.evaluateCubicBezier(tmpP0, tmpP1, tmpP2, tmpP3, 0.5);
	}
}

module.exports = PictServiceFlowPathGenerator;

},{"fable-serviceproviderbase":6}],57:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PortRenderer
 *
 * Renders port circles, labels, and badges for flow diagram nodes.
 *
 * Extracted from PictView-Flow-Node.js to isolate port rendering logic
 * from node body rendering and layout.
 *
 * Dependencies (all accessed via this._FlowView):
 *   - _GeometryProvider — for getEdgeFromSide, getPortLocalPosition
 *   - _ConnectorShapesProvider — for createPortElement
 *   - _SVGHelperProvider — for createSVGElement
 */
class PictServiceFlowPortRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPortRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render ports for a node.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 * @param {number} pNodeTitleBarHeight - Title bar height (for port position offset)
	 */
	renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, pNodeTitleBarHeight)
	{
		if (!this._FlowView) return;
		if (!pNodeData.Ports || !Array.isArray(pNodeData.Ports)) return;

		let tmpPortLabelsVertical = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsVertical);
		let tmpPortLabelPadding = (pNodeTypeConfig && pNodeTypeConfig.PortLabelPadding);
		let tmpPortLabelsOutside = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsOutside);
		let tmpGeometryProvider = this._FlowView._GeometryProvider;

		// Connected ports get their colored dot drawn by the connection
		// renderer at the actual line attachment (which may have been
		// reshaped by an edge theme like Perimeter). Unconnected ports
		// still draw their dot at the static card-defined position.
		let tmpConnectedPortHashes = this._collectConnectedPortHashes(pNodeData.Hash);

		// Group ports by their Side value (supports all 12 positions)
		let tmpPortsBySide = {};
		for (let i = 0; i < pNodeData.Ports.length; i++)
		{
			let tmpPort = pNodeData.Ports[i];
			let tmpSide = tmpPort.Side || (tmpPort.Direction === 'input' ? 'left' : 'right');
			if (!tmpPortsBySide[tmpSide])
			{
				tmpPortsBySide[tmpSide] = [];
			}
			tmpPortsBySide[tmpSide].push(tmpPort);
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = {};
		for (let tmpKey in tmpPortsBySide)
		{
			tmpPortCountsBySide[tmpKey] = tmpPortsBySide[tmpKey].length;
		}

		for (let tmpSide in tmpPortsBySide)
		{
			let tmpPorts = tmpPortsBySide[tmpSide];
			// Determine the edge for label positioning
			let tmpEdge = tmpGeometryProvider ? tmpGeometryProvider.getEdgeFromSide(tmpSide) : tmpSide;

			for (let i = 0; i < tmpPorts.length; i++)
			{
				let tmpPort = tmpPorts[i];
				let tmpPosition = this.getPortLocalPosition(tmpSide, i, tmpPorts.length, pWidth, pHeight, pNodeTitleBarHeight, tmpPortCountsBySide);

				// Port label badge — flush against the node edge with no
				// border on the edge side; rendered before the port circle
				// so the circle visually sits on top of the badge
				let tmpLabelElement = null;
				if (tmpPort.Label)
				{
					let tmpPortTypeColorMap =
					{
						'event-in': '#3498db',
						'event-out': '#2ecc71',
						'setting': '#e67e22',
						'value': '#f1c40f',
						'error': '#e74c3c'
					};
					let tmpBorderColor = tmpPort.PortType ? (tmpPortTypeColorMap[tmpPort.PortType] || '#95a5a6') : '#95a5a6';

					let tmpBadgeHeight = 12;
					let tmpBadgePadH = 5;
					let tmpBadgeBorderW = 2;
					let tmpEdgePad = 1;
					let tmpPortRadius = 5;

					let tmpTextLen = tmpPort.Label.length * 5;
					let tmpBadgeX, tmpBadgeY, tmpBadgeWidth;
					let tmpTextX, tmpTextAnchor;
					let tmpStripeX, tmpStripeY, tmpStripeW, tmpStripeH;
					let tmpBorderPath;

					if (tmpEdge === 'left')
					{
						tmpBadgeWidth = tmpPortRadius + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpBadgeBorderW;
						tmpBadgeX = tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpPortRadius + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX + tmpBadgeWidth - tmpBadgeBorderW;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'right')
					{
						tmpBadgeWidth = tmpBadgeBorderW + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpPortRadius;
						tmpBadgeX = pWidth - tmpBadgeWidth - tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpBadgeBorderW + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'top')
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY + tmpBadgeHeight - tmpBadgeBorderW;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY;
					}
					else
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = pHeight - tmpBadgeHeight - tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}

					// Wrap the badge elements in a hoverable group so we can
					// listen for mouseenter/mouseleave on the badge as a
					// whole. Tagged with data-port-hash + data-node-hash so
					// the hover handler can surface this port's hint paths.
					let tmpBadgeGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
					tmpBadgeGroup.setAttribute('class', 'pict-flow-port-badge');
					tmpBadgeGroup.setAttribute('data-port-hash', tmpPort.Hash);
					tmpBadgeGroup.setAttribute('data-node-hash', pNodeData.Hash);
					this._wirePortHintHover(tmpBadgeGroup, tmpPort.Hash, null);

					// Background rect (cream, no stroke — border drawn separately)
					let tmpBgRect = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpBgRect.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBgRect.setAttribute('x', String(tmpBadgeX));
					tmpBgRect.setAttribute('y', String(tmpBadgeY));
					tmpBgRect.setAttribute('width', String(tmpBadgeWidth));
					tmpBgRect.setAttribute('height', String(tmpBadgeHeight));
					tmpBgRect.setAttribute('fill', 'var(--pf-port-label-bg, rgba(255, 253, 240, 0.5))');
					tmpBadgeGroup.appendChild(tmpBgRect);

					// 3-sided border path (open on the edge-facing side)
					let tmpBorderPathEl = this._FlowView._SVGHelperProvider.createSVGElement('path');
					tmpBorderPathEl.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBorderPathEl.setAttribute('d', tmpBorderPath);
					tmpBorderPathEl.setAttribute('fill', 'none');
					tmpBorderPathEl.setAttribute('stroke', tmpBorderColor);
					tmpBorderPathEl.setAttribute('stroke-width', '0.75');
					tmpBadgeGroup.appendChild(tmpBorderPathEl);

					// Colored stripe on the inner side
					let tmpStripe = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpStripe.setAttribute('class', 'pict-flow-port-label-bg');
					tmpStripe.setAttribute('x', String(tmpStripeX));
					tmpStripe.setAttribute('y', String(tmpStripeY));
					tmpStripe.setAttribute('width', String(tmpStripeW));
					tmpStripe.setAttribute('height', String(tmpStripeH));
					tmpStripe.setAttribute('fill', tmpBorderColor);
					tmpBadgeGroup.appendChild(tmpStripe);

					pGroup.appendChild(tmpBadgeGroup);

					// Text label — appended after circle for z-order
					tmpLabelElement = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpLabelElement.setAttribute('class', 'pict-flow-port-label');
					tmpLabelElement.setAttribute('fill', 'var(--pf-port-label-text, #2c3e50)');
					tmpLabelElement.textContent = tmpPort.Label;
					tmpLabelElement.setAttribute('x', String(tmpTextX));
					tmpLabelElement.setAttribute('y', String(tmpBadgeY + tmpBadgeHeight / 2));
					tmpLabelElement.setAttribute('text-anchor', tmpTextAnchor);
					tmpLabelElement.setAttribute('dominant-baseline', 'central');
				}

				// Port circle (rendered on top of badge background) —
				// only for unconnected ports. Connected ports get their
				// dot painted by the connection renderer at the actual
				// attachment point (so it follows edge-theme overrides).
				if (!tmpConnectedPortHashes[tmpPort.Hash])
				{
					let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
					let tmpCircle;
					if (tmpShapeProvider)
					{
						tmpCircle = tmpShapeProvider.createPortElement(tmpPort, tmpPosition, pNodeData.Hash);
					}
					else
					{
						tmpCircle = this._FlowView._SVGHelperProvider.createSVGElement('circle');
						let tmpPortClass = `pict-flow-port ${tmpPort.Direction}`;
						if (tmpPort.PortType)
						{
							tmpPortClass += ` port-type-${tmpPort.PortType}`;
						}
						tmpCircle.setAttribute('class', tmpPortClass);
						tmpCircle.setAttribute('cx', String(tmpPosition.x));
						tmpCircle.setAttribute('cy', String(tmpPosition.y));
						tmpCircle.setAttribute('r', '5');
						tmpCircle.setAttribute('data-port-hash', tmpPort.Hash);
						tmpCircle.setAttribute('data-node-hash', pNodeData.Hash);
						tmpCircle.setAttribute('data-port-direction', tmpPort.Direction);
						if (tmpPort.PortType)
						{
							tmpCircle.setAttribute('data-port-type', tmpPort.PortType);
						}
						tmpCircle.setAttribute('data-element-type', 'port');
					}
					pGroup.appendChild(tmpCircle);
				}

				// Port label text (on top of everything)
				if (tmpLabelElement)
				{
					pGroup.appendChild(tmpLabelElement);
				}
			}
		}
	}

	/**
	 * Wire mouseenter/mouseleave on a hoverable element so it activates
	 * port-hint paths in the port-hints layer. When `pPortHash` is set,
	 * only hints for that port light up; when `pNodeHash` is set (and
	 * port hash is null), every hint on that node lights up. Static —
	 * no closure-state dependency on the node/port objects themselves.
	 *
	 * @param {SVGElement} pHoverEl
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_wirePortHintHover(pHoverEl, pPortHash, pNodeHash)
	{
		if (!pHoverEl || typeof pHoverEl.setAttribute !== 'function') return;
		if (!this._FlowView || !this._FlowView.options) return;

		// Inline attribute handlers — survive the connection-layer rebuild
		// without leaving stale listeners on detached DOM nodes.
		let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpHashArg = pPortHash ? ('"' + pPortHash + '", null') : ('null, "' + pNodeHash + '"');
		pHoverEl.setAttribute('onmouseenter',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._activatePortHints(" + tmpHashArg + ")");
		pHoverEl.setAttribute('onmouseleave',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._deactivatePortHints(" + tmpHashArg + ")");
	}

	/**
	 * Build a hash-set of port hashes on the given node that participate
	 * in any connection (either as source or target). Used to suppress
	 * the static port circle so the connection renderer can paint the
	 * dot at the resolved attachment point instead.
	 *
	 * @param {string} pNodeHash
	 * @returns {Object} keyed by port hash → true
	 */
	_collectConnectedPortHashes(pNodeHash)
	{
		let tmpResult = {};
		if (!this._FlowView || !this._FlowView._FlowData || !Array.isArray(this._FlowView._FlowData.Connections))
		{
			return tmpResult;
		}
		let tmpConns = this._FlowView._FlowData.Connections;
		for (let i = 0; i < tmpConns.length; i++)
		{
			let tmpConn = tmpConns[i];
			if (tmpConn.SourceNodeHash === pNodeHash && tmpConn.SourcePortHash)
			{
				tmpResult[tmpConn.SourcePortHash] = true;
			}
			if (tmpConn.TargetNodeHash === pNodeHash && tmpConn.TargetPortHash)
			{
				tmpResult[tmpConn.TargetPortHash] = true;
			}
		}
		return tmpResult;
	}

	/**
	 * Calculate port position relative to node origin.
	 *
	 * Delegates to the geometry provider's getPortLocalPosition method.
	 *
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom' (or compound sides)
	 * @param {number} pIndex - Index of this port on its side
	 * @param {number} pTotal - Total ports on this side
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pNodeTitleBarHeight - Title bar height
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → count for adaptive zones
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide)
	{
		return this._FlowView._GeometryProvider.getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide);
	}
}

module.exports = PictServiceFlowPortRenderer;

},{"fable-serviceproviderbase":6}],58:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-RenderManager
 *
 * Orchestrates rendering of the flow diagram: nodes, connections,
 * tethers, panels, SVG marker definitions, and node position updates.
 *
 * Extracted from PictView-Flow.js to isolate rendering orchestration
 * from data management and interaction handling.
 */
class PictServiceFlowRenderManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowRenderManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render the complete flow diagram
	 */
	renderFlow()
	{
		if (!this._FlowView) return;
		if (!this._FlowView._NodesLayer || !this._FlowView._ConnectionsLayer) return;

		// Clear existing SVG content
		while (this._FlowView._NodesLayer.firstChild)
		{
			this._FlowView._NodesLayer.removeChild(this._FlowView._NodesLayer.firstChild);
		}
		while (this._FlowView._ConnectionsLayer.firstChild)
		{
			this._FlowView._ConnectionsLayer.removeChild(this._FlowView._ConnectionsLayer.firstChild);
		}
		if (this._FlowView._EndpointsLayer)
		{
			while (this._FlowView._EndpointsLayer.firstChild) this._FlowView._EndpointsLayer.removeChild(this._FlowView._EndpointsLayer.firstChild);
		}
		if (this._FlowView._PortHintsLayer)
		{
			while (this._FlowView._PortHintsLayer.firstChild) this._FlowView._PortHintsLayer.removeChild(this._FlowView._PortHintsLayer.firstChild);
		}

		// Render connections first (behind nodes)
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConnection = this._FlowView._FlowData.Connections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConnection.Hash);

			this._FlowView._ConnectionRenderer.renderConnection(
				tmpConnection,
				this._FlowView._ConnectionsLayer,
				tmpIsSelected
			);
		}

		// Render nodes
		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedNodeHash === tmpNode.Hash);
			let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);

			// Enrich saved port data with metadata from the node type's DefaultPorts.
			// Saved flow data may not include PortType or may have stale Side values,
			// so we match each port to its DefaultPort counterpart by Label and Direction,
			// then copy over PortType and Side from the authoritative node type definition.
			if (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts && tmpNode.Ports)
			{
				for (let p = 0; p < tmpNode.Ports.length; p++)
				{
					let tmpPort = tmpNode.Ports[p];
					for (let d = 0; d < tmpNodeTypeConfig.DefaultPorts.length; d++)
					{
						let tmpDefault = tmpNodeTypeConfig.DefaultPorts[d];
						if (tmpDefault.Label === tmpPort.Label && tmpDefault.Direction === tmpPort.Direction)
						{
							if (tmpDefault.PortType)
							{
								tmpPort.PortType = tmpDefault.PortType;
							}
							if (tmpDefault.Side)
							{
								tmpPort.Side = tmpDefault.Side;
							}
							break;
						}
					}
				}
			}

			this._FlowView._NodeView.renderNode(tmpNode, this._FlowView._NodesLayer, tmpIsSelected, tmpNodeTypeConfig);
		}

		// Render properties panels and tethers
		if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
		{
			this._FlowView._PropertiesPanelView.renderPanels(
				this._FlowView._FlowData.OpenPanels,
				this._FlowView._PanelsLayer,
				this._FlowView._TethersLayer,
				this._FlowView._FlowData.ViewState.SelectedTetherHash
			);
		}

		// Update viewport transform
		this._FlowView.updateViewportTransform();
	}

	/**
	 * Re-render a single connection (remove and re-add) for smooth drag performance.
	 * @param {string} pConnectionHash
	 */
	renderSingleConnection(pConnectionHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		// Remove existing elements for this connection across all layers
		// where it might live (path / hit-area in connections, dots in
		// endpoints, hint paths in port-hints).
		this._removeConnectionElements(pConnectionHash);

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash);
		this._FlowView._ConnectionRenderer.renderConnection(tmpConnection, this._FlowView._ConnectionsLayer, tmpIsSelected);
	}

	/**
	 * Re-render a single tether (remove and re-add) for smooth drag performance.
	 * @param {string} pPanelHash
	 */
	renderSingleTether(pPanelHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		// Remove existing tether elements for this panel
		let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${pPanelHash}"]`);
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExisting[i].remove();
		}

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		let tmpNodeData = this._FlowView.getNode(tmpPanel.NodeHash);
		if (!tmpNodeData) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === pPanelHash);
		this._FlowView._TetherService.renderTether(tmpPanel, tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
	}

	/**
	 * Update a single node's position in the SVG without full re-render (for drag performance)
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateNodePosition(pNodeHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;

		if (this._FlowView.options.EnableGridSnap)
		{
			pX = this._FlowView._LayoutService.snapToGrid(pX, this._FlowView.options.GridSnapSize);
			pY = this._FlowView._LayoutService.snapToGrid(pY, this._FlowView.options.GridSnapSize);
		}

		tmpNode.X = pX;
		tmpNode.Y = pY;

		// Reset customized handle positions for connections/tethers involving this node
		this._FlowView._resetHandlesForNode(pNodeHash);

		// Update the node's SVG group transform for smooth dragging
		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${pNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.setAttribute('transform', `translate(${pX}, ${pY})`);
		}

		// Re-render connections that involve this node
		this.renderConnectionsForNode(pNodeHash);

		// Update tethers for any panels attached to this node
		this.renderTethersForNode(pNodeHash);
	}

	/**
	 * Re-render only connections that involve a specific node (for drag performance)
	 * @param {string} pNodeHash
	 */
	renderConnectionsForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		let tmpAffectedConnections = this._FlowView._FlowData.Connections.filter((pConn) =>
		{
			return pConn.SourceNodeHash === pNodeHash || pConn.TargetNodeHash === pNodeHash;
		});

		for (let i = 0; i < tmpAffectedConnections.length; i++)
		{
			let tmpConn = tmpAffectedConnections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConn.Hash);

			// Remove existing connection SVG elements across all layers
			this._removeConnectionElements(tmpConn.Hash);

			// Re-render this connection
			this._FlowView._ConnectionRenderer.renderConnection(tmpConn, this._FlowView._ConnectionsLayer, tmpIsSelected);
		}
	}

	/**
	 * Remove every SVG element tagged with `data-connection-hash="<hash>"`
	 * from any of the layers a connection might write into (connections,
	 * endpoints, port-hints). Centralised so per-connection re-render
	 * paths stay in sync with whatever layers ConnectionRenderer touches.
	 *
	 * @param {string} pConnectionHash
	 */
	_removeConnectionElements(pConnectionHash)
	{
		let tmpLayers =
		[
			this._FlowView._ConnectionsLayer,
			this._FlowView._EndpointsLayer,
			this._FlowView._PortHintsLayer
		];
		for (let i = 0; i < tmpLayers.length; i++)
		{
			let tmpLayer = tmpLayers[i];
			if (!tmpLayer) continue;
			let tmpExisting = tmpLayer.querySelectorAll(`[data-connection-hash="${pConnectionHash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}
		}
	}

	/**
	 * Re-render tethers for panels attached to a specific node (for drag performance).
	 * @param {string} pNodeHash
	 */
	renderTethersForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		let tmpAffectedPanels = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpAffectedPanels.length === 0) return;

		// Remove existing tethers for these panels and re-render via TetherService
		for (let i = 0; i < tmpAffectedPanels.length; i++)
		{
			let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${tmpAffectedPanels[i].Hash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}

			let tmpNodeData = this._FlowView.getNode(tmpAffectedPanels[i].NodeHash);
			if (!tmpNodeData) continue;

			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === tmpAffectedPanels[i].Hash);
			this._FlowView._TetherService.renderTether(tmpAffectedPanels[i], tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
		}
	}

	/**
	 * Re-inject SVG marker definitions (arrowheads).
	 * Called after a theme switch to update arrowhead colors.
	 */
	reinjectMarkerDefs()
	{
		if (!this._FlowView || !this._FlowView._ConnectorShapesProvider || !this._FlowView._SVGElement) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpDefs = this._FlowView._SVGElement.querySelector('defs');
		if (!tmpDefs) return;

		// Remove existing marker elements
		let tmpExistingMarkers = tmpDefs.querySelectorAll('marker');
		for (let i = 0; i < tmpExistingMarkers.length; i++)
		{
			tmpExistingMarkers[i].remove();
		}

		// Re-generate and inject
		let tmpMarkerMarkup = this._FlowView._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
		let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		tmpTempSVG.innerHTML = tmpMarkerMarkup;
		while (tmpTempSVG.firstChild)
		{
			tmpDefs.appendChild(tmpTempSVG.firstChild);
		}
	}
}

module.exports = PictServiceFlowRenderManager;

},{"fable-serviceproviderbase":6}],59:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-SelectionManager
 *
 * Manages selection state for nodes, connections, and tethers in the flow diagram.
 * Handles selecting, deselecting, and deleting selected elements.
 */
class PictServiceFlowSelectionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowSelectionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedNodeHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = pNodeHash;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pNodeHash !== tmpPreviousSelection)
		{
			let tmpNode = pNodeHash ? this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onNodeSelected', tmpNode);
		}
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = pConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pConnectionHash !== tmpPreviousSelection)
		{
			let tmpConnection = pConnectionHash ? this._FlowView._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionSelected', tmpConnection);
		}
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedTetherHash;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = pPanelHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pPanelHash !== tmpPreviousSelection)
		{
			let tmpPanel = pPanelHash ? this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onTetherSelected', tmpPanel);
		}
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;
		this._FlowView.renderFlow();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		if (this._FlowView._FlowData.ViewState.SelectedNodeHash)
		{
			return this._FlowView.removeNode(this._FlowView._FlowData.ViewState.SelectedNodeHash);
		}
		if (this._FlowView._FlowData.ViewState.SelectedConnectionHash)
		{
			return this._FlowView.removeConnection(this._FlowView._FlowData.ViewState.SelectedConnectionHash);
		}
		return false;
	}
}

module.exports = PictServiceFlowSelectionManager;

},{"fable-serviceproviderbase":6}],60:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-Tether
 *
 * Centralizes all tether geometry, path generation, handle state management,
 * and SVG rendering for the lines that connect properties panels to their nodes.
 *
 * Delegates to shared providers for:
 *   - SVG element creation (_FlowView._SVGHelperProvider)
 *   - Geometry calculations (_FlowView._GeometryProvider)
 *   - Path string building (_FlowView._PathGenerator)
 *
 * Responsibilities:
 *   - Smart 4-quadrant anchor detection (which edge of the node/panel to connect)
 *   - Bezier and orthogonal path generation
 *   - Auto-midpoint and auto-corner calculations
 *   - Handle position updates during drag
 *   - Handle reset when nodes or panels move
 *   - Line mode toggling (bezier <-> orthogonal)
 *   - SVG element creation for tether lines, hit areas, and drag handles
 */
class PictServiceFlowTether extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowTether';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Anchor Calculation ----

	/**
	 * Determine which node edge and panel edge to connect based on 4-quadrant detection.
	 * Uses the relative position of the panel center to the node center.
	 *
	 * @param {Object} pPanelData - Panel data with X, Y, Width, Height
	 * @param {Object} pNodeData - Node data with X, Y, Width, Height
	 * @returns {{nodeAnchor: {x,y,side}, panelAnchor: {x,y,side}}}
	 */
	getSmartAnchors(pPanelData, pNodeData)
	{
		let tmpNodeCX = pNodeData.X + pNodeData.Width / 2;
		let tmpNodeCY = pNodeData.Y + pNodeData.Height / 2;
		let tmpPanelCX = pPanelData.X + pPanelData.Width / 2;
		let tmpPanelCY = pPanelData.Y + pPanelData.Height / 2;

		let tmpDX = tmpPanelCX - tmpNodeCX;
		let tmpDY = tmpPanelCY - tmpNodeCY;

		let tmpNodeSide, tmpPanelSide;

		if (Math.abs(tmpDX) >= Math.abs(tmpDY))
		{
			// Panel is primarily to the left or right
			if (tmpDX >= 0)
			{
				tmpNodeSide = 'right';
				tmpPanelSide = 'left';
			}
			else
			{
				tmpNodeSide = 'left';
				tmpPanelSide = 'right';
			}
		}
		else
		{
			// Panel is primarily above or below
			if (tmpDY >= 0)
			{
				tmpNodeSide = 'bottom';
				tmpPanelSide = 'top';
			}
			else
			{
				tmpNodeSide = 'top';
				tmpPanelSide = 'bottom';
			}
		}

		let tmpNodeAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pNodeData, tmpNodeSide);
		let tmpPanelAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pPanelData, tmpPanelSide);

		return {
			nodeAnchor: Object.assign(tmpNodeAnchor, { side: tmpNodeSide }),
			panelAnchor: Object.assign(tmpPanelAnchor, { side: tmpPanelSide })
		};
	}

	// ---- Path Generation ----

	/**
	 * Generate a bezier path between two anchor points with directional departure/approach.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {number|null} pHandleX - User-set handle X or null for auto
	 * @param {number|null} pHandleY - User-set handle Y or null for auto
	 * @returns {string} SVG path d attribute
	 */
	generateBezierPath(pFrom, pTo, pHandleX, pHandleY)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		if (pHandleX == null || pHandleY == null)
		{
			// Auto bezier: simple cubic from depart to approach
			let tmpSpanX = Math.abs(tmpApproachX - tmpDepartX);
			let tmpSpanY = Math.abs(tmpApproachY - tmpDepartY);
			let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
			let tmpCPDist = tmpSpan * 0.4;

			let tmpCP1X = tmpDepartX + tmpFromDir.dx * tmpCPDist;
			let tmpCP1Y = tmpDepartY + tmpFromDir.dy * tmpCPDist;
			let tmpCP2X = tmpApproachX + tmpToDir.dx * tmpCPDist;
			let tmpCP2Y = tmpApproachY + tmpToDir.dy * tmpCPDist;

			return this._FlowView._PathGenerator.buildBezierPathString(
				{ x: pFrom.x, y: pFrom.y },
				{ x: tmpDepartX, y: tmpDepartY },
				{ x: tmpCP1X, y: tmpCP1Y },
				{ x: tmpCP2X, y: tmpCP2Y },
				{ x: tmpApproachX, y: tmpApproachY },
				{ x: pTo.x, y: pTo.y }
			);
		}

		// User-set handle: split bezier into two segments through handle
		let tmpCP1aDist = 30;
		let tmpCP1aX = tmpDepartX + tmpFromDir.dx * tmpCP1aDist;
		let tmpCP1aY = tmpDepartY + tmpFromDir.dy * tmpCP1aDist;

		let tmpCP2aDist = 30;
		let tmpCP2aX = tmpApproachX + tmpToDir.dx * tmpCP2aDist;
		let tmpCP2aY = tmpApproachY + tmpToDir.dy * tmpCP2aDist;

		// Tangent at the handle — direction from first segment end to second segment start
		let tmpTangentX = tmpApproachX - tmpDepartX;
		let tmpTangentY = tmpApproachY - tmpDepartY;
		let tmpTangentLen = Math.sqrt(tmpTangentX * tmpTangentX + tmpTangentY * tmpTangentY) || 1;
		tmpTangentX /= tmpTangentLen;
		tmpTangentY /= tmpTangentLen;
		let tmpTangentDist = 25;

		let tmpCP1bX = pHandleX - tmpTangentX * tmpTangentDist;
		let tmpCP1bY = pHandleY - tmpTangentY * tmpTangentDist;
		let tmpCP2bX = pHandleX + tmpTangentX * tmpTangentDist;
		let tmpCP2bY = pHandleY + tmpTangentY * tmpTangentDist;

		return this._FlowView._PathGenerator.buildSplitBezierPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCP1aX, y: tmpCP1aY },
			{ x: tmpCP1bX, y: tmpCP1bY },
			{ x: pHandleX, y: pHandleY },
			{ x: tmpCP2bX, y: tmpCP2bY },
			{ x: tmpCP2aX, y: tmpCP2aY },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	/**
	 * Generate an orthogonal (90-degree) path between two anchor points.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object|null} pCorners - {corner1: {x,y}, corner2: {x,y}} or null for auto
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {string} SVG path d attribute
	 */
	generateOrthogonalPath(pFrom, pTo, pCorners, pMidOffset)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			// Auto-calculate corners based on direction
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pMidOffset);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCorner1.x, y: tmpCorner1.y },
			{ x: tmpCorner2.x, y: tmpCorner2.y },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	// ---- Handle Position Computation ----

	/**
	 * Get auto-calculated bezier midpoint for a tether at t=0.5 on the curve.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pFrom, pTo)
	{
		return this._FlowView._PathGenerator.getAutoMidpointSimple(pFrom, pTo, 20);
	}

	/**
	 * Get full orthogonal geometry including corners and midpoint for handle rendering.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthoGeometry(pFrom, pTo, pPanelData)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorners;
		if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
			tmpCorners.corner1 = { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y };
			tmpCorners.corner2 = { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y };
		}
		else
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
		}

		let tmpMidpoint =
		{
			x: (tmpCorners.corner1.x + tmpCorners.corner2.x) / 2,
			y: (tmpCorners.corner1.y + tmpCorners.corner2.y) / 2
		};

		return {
			corner1: tmpCorners.corner1,
			corner2: tmpCorners.corner2,
			midpoint: tmpMidpoint
		};
	}

	// ---- Path Generation (high-level) ----

	/**
	 * Generate the SVG path string for a tether based on its panel data and anchors.
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @param {Object} pFrom - {x, y, side} panel anchor
	 * @param {Object} pTo - {x, y, side} node anchor
	 * @returns {string} SVG path d attribute
	 */
	generatePath(pPanelData, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y },
					corner2: { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y }
				};
			}
			return this.generateOrthogonalPath(pFrom, pTo, tmpCorners, pPanelData.TetherOrthoMidOffset || 0);
		}
		else
		{
			// Check for multi-handle array first
			let tmpHandles = this._getTetherBezierHandles(pPanelData);
			if (tmpHandles.length > 0)
			{
				return this.generateMultiBezierPath(pFrom, pTo, tmpHandles);
			}

			// Single-handle legacy path
			let tmpHandleX = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleX != null) ? pPanelData.TetherBezierHandleX : null;
			let tmpHandleY = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleY != null) ? pPanelData.TetherBezierHandleY : null;
			return this.generateBezierPath(pFrom, pTo, tmpHandleX, tmpHandleY);
		}
	}

	/**
	 * Get the bezier handles array for a tether, respecting the customized flag.
	 * @param {Object} pPanelData
	 * @returns {Array<{x: number, y: number}>}
	 */
	_getTetherBezierHandles(pPanelData)
	{
		if (!pPanelData || !pPanelData.TetherHandleCustomized)
		{
			return [];
		}

		// Multi-handle format
		if (Array.isArray(pPanelData.TetherBezierHandles) && pPanelData.TetherBezierHandles.length > 0)
		{
			return pPanelData.TetherBezierHandles;
		}

		// Legacy single-handle format
		if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
		{
			return [{ x: pPanelData.TetherBezierHandleX, y: pPanelData.TetherBezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path for a tether.
	 * Delegates to PathGenerator.buildMultiBezierPathString.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Array<{x: number, y: number}>} pHandles
	 * @returns {string} SVG path d attribute
	 */
	generateMultiBezierPath(pFrom, pTo, pHandles)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepart = {
			x: pFrom.x + tmpFromDir.dx * tmpDepartDist,
			y: pFrom.y + tmpFromDir.dy * tmpDepartDist
		};
		let tmpApproach = {
			x: pTo.x + tmpToDir.dx * tmpDepartDist,
			y: pTo.y + tmpToDir.dy * tmpDepartDist
		};

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			pFrom, tmpDepart, pFrom.side, tmpApproach, pTo.side, pTo, pHandles);
	}

	// ---- Handle State Management ----

	/**
	 * Update a tether handle position during drag.
	 * @param {Object} pPanelData - Panel data to update
	 * @param {string} pHandleType - 'bezier-midpoint', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateHandlePosition(pPanelData, pHandleType, pX, pY)
	{
		pPanelData.TetherHandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(pPanelData.TetherBezierHandles)
				&& tmpIndex < pPanelData.TetherBezierHandles.length)
			{
				pPanelData.TetherBezierHandles[tmpIndex].x = pX;
				pPanelData.TetherBezierHandles[tmpIndex].y = pY;
			}
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Migrate to multi-handle array
				if (!Array.isArray(pPanelData.TetherBezierHandles)
					|| pPanelData.TetherBezierHandles.length === 0)
				{
					pPanelData.TetherBezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					pPanelData.TetherBezierHandles[0].x = pX;
					pPanelData.TetherBezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync
				pPanelData.TetherBezierHandleX = pX;
				pPanelData.TetherBezierHandleY = pY;
				break;

			case 'ortho-corner1':
				pPanelData.TetherOrthoCorner1X = pX;
				pPanelData.TetherOrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				pPanelData.TetherOrthoCorner2X = pX;
				pPanelData.TetherOrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
				// Store the desired position for offset computation
				pPanelData.TetherOrthoMidOffset = (pPanelData.TetherOrthoMidOffset || 0);
				pPanelData._TetherMidDragX = pX;
				pPanelData._TetherMidDragY = pY;
				break;
		}
	}

	/**
	 * Reset tether handle positions to auto for a single panel.
	 * Preserves TetherLineMode but clears all handle coordinates.
	 * @param {Object} pPanelData - Panel data to reset
	 */
	resetHandlePositions(pPanelData)
	{
		if (pPanelData.TetherHandleCustomized)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandles = [];
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
			pPanelData.TetherOrthoCorner1X = null;
			pPanelData.TetherOrthoCorner1Y = null;
			pPanelData.TetherOrthoCorner2X = null;
			pPanelData.TetherOrthoCorner2Y = null;
			pPanelData.TetherOrthoMidOffset = 0;
		}
	}

	/**
	 * Reset tether handle positions for all panels attached to a node.
	 * Called when a node moves.
	 * @param {Array} pOpenPanels - Array of all open panel data objects
	 * @param {string} pNodeHash - The node hash whose panels should be reset
	 */
	resetHandlesForNode(pOpenPanels, pNodeHash)
	{
		for (let i = 0; i < pOpenPanels.length; i++)
		{
			let tmpPanel = pOpenPanels[i];
			if (tmpPanel.NodeHash === pNodeHash)
			{
				this.resetHandlePositions(tmpPanel);
			}
		}
	}

	/**
	 * Add a bezier handle to a tether at the specified position.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pX
	 * @param {number} pY
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	addHandle(pPanelData, pX, pY, pFrom, pTo)
	{
		// Ensure bezier mode and multi-handle array
		pPanelData.TetherLineMode = 'bezier';

		if (!Array.isArray(pPanelData.TetherBezierHandles))
		{
			pPanelData.TetherBezierHandles = [];
			// Migrate legacy single-handle if present
			if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
			{
				pPanelData.TetherBezierHandles.push({
					x: pPanelData.TetherBezierHandleX,
					y: pPanelData.TetherBezierHandleY
				});
			}
		}

		// Compute insertion index
		let tmpInsertIndex = 0;
		if (this._FlowView._ConnectionRenderer && pFrom && pTo)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				pPanelData.TetherBezierHandles,
				{ x: pX, y: pY },
				pFrom,
				pTo
			);
		}

		pPanelData.TetherBezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		pPanelData.TetherHandleCustomized = true;
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pIndex - Index in TetherBezierHandles array
	 */
	removeHandle(pPanelData, pIndex)
	{
		if (!Array.isArray(pPanelData.TetherBezierHandles)) return;
		if (pIndex < 0 || pIndex >= pPanelData.TetherBezierHandles.length) return;

		pPanelData.TetherBezierHandles.splice(pIndex, 1);

		if (pPanelData.TetherBezierHandles.length === 0)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
		}
	}

	/**
	 * Toggle tether line mode between bezier and orthogonal.
	 * Resets handle positions on toggle.
	 * @param {Object} pPanelData - Panel data to toggle
	 * @returns {string} The new line mode ('bezier' or 'orthogonal')
	 */
	toggleLineMode(pPanelData)
	{
		let tmpCurrentMode = pPanelData.TetherLineMode || 'bezier';
		pPanelData.TetherLineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		pPanelData.TetherHandleCustomized = false;
		pPanelData.TetherBezierHandles = [];
		pPanelData.TetherBezierHandleX = null;
		pPanelData.TetherBezierHandleY = null;
		pPanelData.TetherOrthoCorner1X = null;
		pPanelData.TetherOrthoCorner1Y = null;
		pPanelData.TetherOrthoCorner2X = null;
		pPanelData.TetherOrthoCorner2Y = null;
		pPanelData.TetherOrthoMidOffset = 0;

		return pPanelData.TetherLineMode;
	}

	// ---- SVG Rendering ----

	/**
	 * Render a tether from a panel to its node.
	 * Creates SVG path elements for the line and hit area, plus drag handles when selected.
	 *
	 * @param {Object} pPanelData - Panel data with position and tether properties
	 * @param {Object} pNodeData - Node data with position
	 * @param {SVGGElement} pTethersLayer - SVG group to append elements to
	 * @param {boolean} pIsSelected - Whether this tether is currently selected
	 * @param {string} pViewIdentifier - The flow view identifier (for marker URL)
	 */
	renderTether(pPanelData, pNodeData, pTethersLayer, pIsSelected, pViewIdentifier)
	{
		if (!pNodeData) return;

		let tmpAnchors = this.getSmartAnchors(pPanelData, pNodeData);
		let tmpFrom = tmpAnchors.panelAnchor;
		let tmpTo = tmpAnchors.nodeAnchor;

		let tmpPath = this.generatePath(pPanelData, tmpFrom, tmpTo);

		// Hit area and visible tether path
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createTetherHitAreaElement(tmpPath, pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = tmpShapeProvider.createTetherPathElement(
				tmpPath, pPanelData.Hash, pIsSelected, pViewIdentifier);
			pTethersLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-tether-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-element-type', 'tether-hitarea');
			tmpHitArea.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-tether-line${pIsSelected ? ' selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('marker-end', `url(#flow-tether-arrowhead-${pViewIdentifier})`);
			tmpPathElement.setAttribute('data-element-type', 'tether');
			tmpPathElement.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpPathElement);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pPanelData, pTethersLayer, tmpFrom, tmpTo);
		}
	}

	/**
	 * Render drag handles for a selected tether.
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	_renderHandles(pPanelData, pTethersLayer, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeom = this.getOrthoGeometry(pFrom, pTo, pPanelData);

			// Corner 1 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner1',
				tmpGeom.corner1.x, tmpGeom.corner1.y, 'pict-flow-tether-handle');

			// Midpoint handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-midpoint',
				tmpGeom.midpoint.x, tmpGeom.midpoint.y, 'pict-flow-tether-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner2',
				tmpGeom.corner2.x, tmpGeom.corner2.y, 'pict-flow-tether-handle');
		}
		else
		{
			// Bezier handles
			let tmpHandles = this._getTetherBezierHandles(pPanelData);

			if (tmpHandles.length > 0)
			{
				// Multi-handle: render each handle as a draggable circle
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y, 'pict-flow-tether-handle');
				}
			}
			else
			{
				// No custom handles: show auto-computed midpoint
				let tmpMid = this.getAutoMidpoint(pFrom, pTo);
				this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-midpoint',
					tmpMid.x, tmpMid.y, 'pict-flow-tether-handle-midpoint');
			}
		}
	}

	/**
	 * Create a single tether drag handle circle.
	 * @param {SVGGElement} pLayer
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pPanelHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-tether-handle-midpoint')
			? 'tether-handle-midpoint' : 'tether-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pPanelHash, pHandleType, pX, pY,
			tmpShapeKey, 'tether-handle', 'data-panel-hash');
	}
}

module.exports = PictServiceFlowTether;

},{"fable-serviceproviderbase":6}],61:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ViewportManager
 *
 * Manages viewport transforms (pan/zoom), coordinate conversion between
 * screen and SVG space, zoom-to-fit calculations, and fullscreen toggling
 * for the flow diagram.
 */
class PictServiceFlowViewportManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowViewportManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._IsFullscreen = false;
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		if (!this._FlowView._ViewportElement) return;
		let tmpVS = this._FlowView._FlowData.ViewState;
		this._FlowView._ViewportElement.setAttribute('transform',
			`translate(${tmpVS.PanX}, ${tmpVS.PanY}) scale(${tmpVS.Zoom})`
		);
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		let tmpNewZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, pZoom));
		let tmpOldZoom = this._FlowView._FlowData.ViewState.Zoom;

		if (typeof pFocusX === 'number' && typeof pFocusY === 'number')
		{
			// Zoom toward focus point
			let tmpVS = this._FlowView._FlowData.ViewState;
			tmpVS.PanX = pFocusX - (pFocusX - tmpVS.PanX) * (tmpNewZoom / tmpOldZoom);
			tmpVS.PanY = pFocusY - (pFocusY - tmpVS.PanY) * (tmpNewZoom / tmpOldZoom);
		}

		this._FlowView._FlowData.ViewState.Zoom = tmpNewZoom;
		this.updateViewportTransform();
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		if (this._FlowView._FlowData.Nodes.length === 0) return;
		if (!this._FlowView._SVGElement) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			tmpMinX = Math.min(tmpMinX, tmpNode.X);
			tmpMinY = Math.min(tmpMinY, tmpNode.Y);
			tmpMaxX = Math.max(tmpMaxX, tmpNode.X + tmpNode.Width);
			tmpMaxY = Math.max(tmpMaxY, tmpNode.Y + tmpNode.Height);
		}

		let tmpPadding = 50;
		let tmpFlowWidth = tmpMaxX - tmpMinX + tmpPadding * 2;
		let tmpFlowHeight = tmpMaxY - tmpMinY + tmpPadding * 2;

		let tmpSVGRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpScaleX = tmpSVGRect.width / tmpFlowWidth;
		let tmpScaleY = tmpSVGRect.height / tmpFlowHeight;
		let tmpZoom = Math.min(tmpScaleX, tmpScaleY, 1.0); // Don't zoom in past 1.0
		tmpZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, tmpZoom));

		let tmpCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCenterY = (tmpMinY + tmpMaxY) / 2;

		this._FlowView._FlowData.ViewState.Zoom = tmpZoom;
		this._FlowView._FlowData.ViewState.PanX = (tmpSVGRect.width / 2) - (tmpCenterX * tmpZoom);
		this._FlowView._FlowData.ViewState.PanY = (tmpSVGRect.height / 2) - (tmpCenterY * tmpZoom);

		this.updateViewportTransform();
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		if (!this._FlowView._SVGElement)
		{
			return { x: pScreenX, y: pScreenY };
		}

		let tmpPoint = this._FlowView._SVGElement.createSVGPoint();
		tmpPoint.x = pScreenX;
		tmpPoint.y = pScreenY;

		let tmpCTM = this._FlowView._SVGElement.getScreenCTM();
		if (tmpCTM)
		{
			let tmpInverse = tmpCTM.inverse();
			let tmpTransformed = tmpPoint.matrixTransform(tmpInverse);
			// Account for viewport pan/zoom
			let tmpVS = this._FlowView._FlowData.ViewState;
			return {
				x: (tmpTransformed.x - tmpVS.PanX) / tmpVS.Zoom,
				y: (tmpTransformed.y - tmpVS.PanY) / tmpVS.Zoom
			};
		}

		return { x: pScreenX, y: pScreenY };
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length < 1) return this._IsFullscreen;

		let tmpContainer = tmpContainerElements[0];

		this._IsFullscreen = !this._IsFullscreen;

		if (this._IsFullscreen)
		{
			tmpContainer.classList.add('pict-flow-fullscreen');
		}
		else
		{
			tmpContainer.classList.remove('pict-flow-fullscreen');
		}

		return this._IsFullscreen;
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		if (!this._IsFullscreen) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length > 0)
		{
			tmpContainerElements[0].classList.remove('pict-flow-fullscreen');
		}

		this._IsFullscreen = false;
	}
}

module.exports = PictServiceFlowViewportManager;

},{"fable-serviceproviderbase":6}],62:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-FloatingToolbar',

	DefaultRenderable: 'Flow-FloatingToolbar-Content',
	DefaultDestinationAddress: '#Flow-FloatingToolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-FloatingToolbar-Template',
			// Inline handlers route to the floating toolbar view via _Pict.views
			// (see _handleButtonClick / _startDrag / _toggleCollapse).
			Template: /*html*/`
<div class="pict-flow-floating-toolbar" id="Flow-FloatingToolbar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-floating-grip" id="Flow-FloatingGrip-{~D:Record.FlowViewIdentifier~}" title="Drag to move · Double-click to collapse"
		onmousedown="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._startDrag(event)"
		ondblclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleGripDoubleClick(event)">
		<span id="Flow-FloatingIcon-grip-{~D:Record.FlowViewIdentifier~}"></span>
	</div>
	<button class="pict-flow-floating-btn" data-flow-action="add-node" title="Add Node"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('add-node')">
		<span id="Flow-FloatingIcon-plus-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="cards-popup" title="Cards"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('cards-popup')">
		<span id="Flow-FloatingIcon-cards-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="delete-selected" title="Delete Selected"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('delete-selected')">
		<span id="Flow-FloatingIcon-trash-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-in" title="Zoom In"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-in')">
		<span id="Flow-FloatingIcon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-out" title="Zoom Out"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-out')">
		<span id="Flow-FloatingIcon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-fit" title="Fit to View"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('zoom-fit')">
		<span id="Flow-FloatingIcon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="auto-layout" title="Auto Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('auto-layout')">
		<span id="Flow-FloatingIcon-auto-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="layout-popup" title="Layout"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('layout-popup')">
		<span id="Flow-FloatingIcon-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="fullscreen" title="Toggle Fullscreen"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('fullscreen')">
		<span id="Flow-FloatingIcon-fullscreen-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="dock-toolbar" title="Dock Toolbar"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._FloatingToolbarView._handleButtonClick('dock-toolbar')">
		<span id="Flow-FloatingIcon-dock-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-FloatingToolbar-Content',
			TemplateHash: 'Flow-FloatingToolbar-Template',
			DestinationAddress: '#Flow-FloatingToolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowFloatingToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowFloatingToolbar';

		this._ToolbarView = null;
		this._FlowView = null;

		this._IsCollapsed = false;

		this._IsDragging = false;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragStartLeft = 0;
		this._DragStartTop = 0;

		this._BoundMouseMove = null;
		this._BoundMouseUp = null;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Button clicks and grip drag/dblclick are wired inline in
		// Flow-FloatingToolbar-Template — see _handleButtonClick / _startDrag /
		// _handleGripDoubleClick. Only icon population and option-based
		// pruning happen here.
		this._populateIcons();

		let tmpFloatingToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpFloatingToolbar.length > 0)
		{
			if (this.options.EnableAddNode === false)
			{
				let tmpAddNodeBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="add-node"]');
				if (tmpAddNodeBtn)
				{
					tmpAddNodeBtn.remove();
				}
			}
			if (this.options.EnableCardPalette === false)
			{
				let tmpCardsBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="cards-popup"]');
				if (tmpCardsBtn)
				{
					tmpCardsBtn.remove();
				}
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Handle a click on a floating toolbar action button. Called from the
	 * inline `onclick` handler on each button.
	 *
	 * @param {string} pAction - Value of the button's data-flow-action attr
	 */
	_handleButtonClick(pAction)
	{
		if (pAction === 'dock-toolbar')
		{
			if (this._ToolbarView)
			{
				this._ToolbarView._setToolbarMode('docked');
			}
			return;
		}
		if (this._ToolbarView)
		{
			this._ToolbarView._handleToolbarAction(pAction);
		}
	}

	/**
	 * Handle a double-click on the grip. Toggles collapsed state and
	 * prevents the event from reaching the surrounding canvas. Called
	 * from the inline `ondblclick` handler.
	 *
	 * @param {Event} pEvent
	 */
	_handleGripDoubleClick(pEvent)
	{
		if (pEvent && typeof pEvent.preventDefault === 'function')
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		this._toggleCollapse();
	}

	/**
	 * Populate SVG icons into all floating toolbar button spans.
	 */
	_populateIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		let tmpIconMap =
		{
			'grip': 'grip',
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto-layout': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'fullscreen': 'fullscreen',
			'dock': 'dock'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-FloatingIcon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 16);
			}
		}
	}

	/**
	 * Toggle the floating toolbar between expanded and collapsed (grip-only square) states.
	 */
	_toggleCollapse()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		this._IsCollapsed = !this._IsCollapsed;

		if (this._IsCollapsed)
		{
			tmpToolbar[0].classList.add('collapsed');
		}
		else
		{
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Start dragging the floating toolbar.
	 * @param {MouseEvent} pEvent
	 */
	_startDrag(pEvent)
	{
		pEvent.preventDefault();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		this._IsDragging = true;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragStartLeft = tmpEl.offsetLeft;
		this._DragStartTop = tmpEl.offsetTop;

		this._BoundMouseMove = (pMoveEvent) => { this._onDragMove(pMoveEvent); };
		this._BoundMouseUp = () => { this._onDragEnd(); };

		document.addEventListener('mousemove', this._BoundMouseMove);
		document.addEventListener('mouseup', this._BoundMouseUp);
	}

	/**
	 * Handle drag movement.
	 * @param {MouseEvent} pEvent
	 */
	_onDragMove(pEvent)
	{
		if (!this._IsDragging) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		let tmpDeltaX = pEvent.clientX - this._DragStartX;
		let tmpDeltaY = pEvent.clientY - this._DragStartY;

		let tmpNewLeft = this._DragStartLeft + tmpDeltaX;
		let tmpNewTop = this._DragStartTop + tmpDeltaY;

		// Clamp to parent bounds
		let tmpParent = tmpEl.parentElement;
		if (tmpParent)
		{
			let tmpMaxLeft = tmpParent.clientWidth - tmpEl.offsetWidth;
			let tmpMaxTop = tmpParent.clientHeight - tmpEl.offsetHeight;
			tmpNewLeft = Math.max(0, Math.min(tmpNewLeft, tmpMaxLeft));
			tmpNewTop = Math.max(0, Math.min(tmpNewTop, tmpMaxTop));
		}

		tmpEl.style.left = tmpNewLeft + 'px';
		tmpEl.style.top = tmpNewTop + 'px';
	}

	/**
	 * End dragging.
	 */
	_onDragEnd()
	{
		this._IsDragging = false;

		if (this._BoundMouseMove)
		{
			document.removeEventListener('mousemove', this._BoundMouseMove);
			this._BoundMouseMove = null;
		}
		if (this._BoundMouseUp)
		{
			document.removeEventListener('mouseup', this._BoundMouseUp);
			this._BoundMouseUp = null;
		}

		// Save position
		if (this._ToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
			if (tmpToolbar.length > 0)
			{
				this._ToolbarView._FloatingPosition.X = tmpToolbar[0].offsetLeft;
				this._ToolbarView._FloatingPosition.Y = tmpToolbar[0].offsetTop;
			}
		}
	}

	/**
	 * Show the floating toolbar at the saved position.
	 */
	show()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'block';
		}

		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length > 0 && this._ToolbarView)
		{
			tmpToolbar[0].style.left = this._ToolbarView._FloatingPosition.X + 'px';
			tmpToolbar[0].style.top = this._ToolbarView._FloatingPosition.Y + 'px';
		}

		// Restore expanded state when showing
		if (this._IsCollapsed && tmpToolbar.length > 0)
		{
			this._IsCollapsed = false;
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Hide the floating toolbar.
	 */
	hide()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'none';
		}
	}
}

module.exports = PictViewFlowFloatingToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":137}],63:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-NodeRenderer',

	AutoRender: false,

	// Title bar height for nodes
	NodeTitleBarHeight: 22
};

class PictViewFlowNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowNode';

		this._FlowView = null;
	}

	/**
	 * Render a node into the nodes SVG layer
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pNodesLayer - The SVG <g> element to append to
	 * @param {boolean} pIsSelected - Whether this node is selected
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	renderNode(pNodeData, pNodesLayer, pIsSelected, pNodeTypeConfig)
	{
		let tmpGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');

		// Build CSS class list with optional per-type modifier classes
		let tmpClassList = `pict-flow-node ${pIsSelected ? 'selected' : ''} pict-flow-node-${pNodeData.Type || 'default'}`;
		if (pNodeTypeConfig)
		{
			if (pNodeTypeConfig.PortLabelsOnHover) tmpClassList += ' pict-flow-node-port-labels-hover';
			if (pNodeTypeConfig.PortLabelsVertical) tmpClassList += ' pict-flow-node-port-labels-vertical';
		}

		// Resolve theme-aware ColorRole. Per-node override wins; falls back
		// to the node type's role. A role of 'none' (or empty string)
		// explicitly opts out — useful when a card wants to keep its
		// hex BodyStyle/TitleBarColor regardless of the host theme.
		let tmpColorRole = (typeof pNodeData.ColorRole !== 'undefined')
			? pNodeData.ColorRole
			: (pNodeTypeConfig && pNodeTypeConfig.ColorRole);
		if (tmpColorRole && tmpColorRole !== 'none')
		{
			tmpClassList += ' pict-flow-node-color-' + tmpColorRole;
		}
		tmpGroup.setAttribute('class', tmpClassList);
		tmpGroup.setAttribute('transform', `translate(${pNodeData.X}, ${pNodeData.Y})`);
		tmpGroup.setAttribute('data-node-hash', pNodeData.Hash);
		tmpGroup.setAttribute('data-element-type', 'node');

		// Hover the whole node → activate every port-hint that points
		// at any of this node's ports. Lets the user see *all* of the
		// node's reroute lines at once, not just one badge at a time.
		if (this._FlowView._PortRenderer && typeof this._FlowView._PortRenderer._wirePortHintHover === 'function')
		{
			this._FlowView._PortRenderer._wirePortHintHover(tmpGroup, null, pNodeData.Hash);
		}

		let tmpWidth = pNodeData.Width || 180;
		let tmpHeight = pNodeData.Height || 80;
		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;

		// Ensure node is tall enough for all ports in their zones
		let tmpGeomProvider = this._FlowView._GeometryProvider;
		if (tmpGeomProvider && pNodeData.Ports && pNodeData.Ports.length > 0)
		{
			let tmpMinHeight = tmpGeomProvider.computeMinimumNodeHeight(pNodeData.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Write the adjusted dimensions back to the node data so that
		// connection rendering (which reads pNodeData.Width/Height to
		// compute port positions) uses the same values we render with.
		pNodeData.Width = tmpWidth;
		pNodeData.Height = tmpHeight;

		// Determine node body mode from theme (bracket vs rect)
		let tmpNodeBodyMode = 'rect';
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.NodeBodyMode)
			{
				tmpNodeBodyMode = tmpActiveTheme.NodeBodyMode;
			}
		}

		if (tmpNodeBodyMode === 'bracket')
		{
			this._renderBracketNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}
		else
		{
			this._renderRectNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}

		// Determine if this node has a title-bar icon (FlowCard with CardMetadata)
		let tmpHasTitleIcon = false;
		let tmpTitleIconSize = 12;
		let tmpTitleIconMarginLeft = 8;
		let tmpTitleIconGap = 4;

		if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
		{
			let tmpMeta = pNodeTypeConfig.CardMetadata;
			let tmpIconProvider = this._FlowView._IconProvider;
			if (tmpMeta.Icon || tmpIconProvider)
			{
				tmpHasTitleIcon = true;
			}
		}

		// Title text (position adjusts when a title-bar icon is present)
		let tmpTitle = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpTitle.setAttribute('class', 'pict-flow-node-title');
		if (tmpHasTitleIcon)
		{
			tmpTitle.setAttribute('x', String(tmpTitleIconMarginLeft + tmpTitleIconSize + tmpTitleIconGap));
			tmpTitle.setAttribute('text-anchor', 'start');
		}
		else
		{
			tmpTitle.setAttribute('x', String(tmpWidth / 2));
			tmpTitle.setAttribute('text-anchor', 'middle');
		}
		tmpTitle.setAttribute('y', String(tmpTitleBarHeight / 2 + 1));
		tmpTitle.setAttribute('dominant-baseline', 'central');
		tmpTitle.textContent = pNodeData.Title || 'Untitled';
		tmpGroup.appendChild(tmpTitle);

		// Determine whether labels should be rendered
		let tmpShowTypeLabel = (!pNodeTypeConfig || pNodeTypeConfig.ShowTypeLabel !== false);
		let tmpLabelsInFront = (!pNodeTypeConfig || pNodeTypeConfig.LabelsInFront !== false);

		// Helper: render type label + code badge + tooltip (the "middle labels")
		let tmpRenderTypeLabels = () =>
		{
			// Type label (below title bar — hover-only for FlowCard nodes via CSS)
			if (tmpShowTypeLabel && pNodeTypeConfig && pNodeTypeConfig.Label && pNodeTypeConfig.Label !== pNodeData.Title)
			{
				let tmpTypeLabel = this._FlowView._SVGHelperProvider.createSVGElement('text');
				tmpTypeLabel.setAttribute('class', 'pict-flow-node-type-label');
				tmpTypeLabel.setAttribute('x', String(tmpWidth / 2));
				tmpTypeLabel.setAttribute('y', String(tmpTitleBarHeight + 16));
				tmpTypeLabel.setAttribute('text-anchor', 'middle');
				tmpTypeLabel.setAttribute('dominant-baseline', 'central');
				tmpTypeLabel.textContent = pNodeTypeConfig.Label;
				tmpGroup.appendChild(tmpTypeLabel);
			}

			// FlowCard metadata: icon in title bar, code badge in body (hover-only via CSS)
			if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
			{
				let tmpMeta = pNodeTypeConfig.CardMetadata;
				let tmpIconProvider = this._FlowView._IconProvider;
				let tmpTitleIconRendered = false;

				// Icon position in title bar (vertically centered)
				let tmpIconX = tmpTitleIconMarginLeft;
				let tmpIconY = (tmpTitleBarHeight - tmpTitleIconSize) / 2;

				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// SVG icon via the icon provider — rendered into title bar
					let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						tmpResolvedKey, tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon && tmpIconProvider && tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// Emoji icon in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon)
				{
					// No icon provider — text fallback in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}

				// Default fallback icon in title bar
				if (!tmpTitleIconRendered && tmpIconProvider)
				{
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						'default', tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
				}

				// Code badge in body (hover-only via CSS, skipped when ShowTypeLabel is false)
				let tmpBodyCenterY = tmpTitleBarHeight + (tmpHeight - tmpTitleBarHeight) / 2;
				if (tmpShowTypeLabel && tmpMeta.Code)
				{
					let tmpCodeText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpCodeText.setAttribute('class', 'pict-flow-node-card-code');
					tmpCodeText.setAttribute('font-size', '10');
					tmpCodeText.setAttribute('font-family', 'monospace');
					tmpCodeText.setAttribute('fill', '#7f8c8d');
					tmpCodeText.setAttribute('text-anchor', 'middle');
					tmpCodeText.setAttribute('dominant-baseline', 'central');
					tmpCodeText.setAttribute('pointer-events', 'none');
					tmpCodeText.setAttribute('x', String(tmpWidth / 2));
					tmpCodeText.setAttribute('y', String(tmpBodyCenterY));
					tmpCodeText.textContent = tmpMeta.Code;
					tmpGroup.appendChild(tmpCodeText);
				}

				// Tooltip via SVG <title> element
				if (tmpMeta.Tooltip || tmpMeta.Description)
				{
					let tmpSVGTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
					tmpSVGTitle.textContent = tmpMeta.Tooltip || tmpMeta.Description;
					tmpGroup.appendChild(tmpSVGTitle);
				}
			}
		};

		// Render order depends on LabelsInFront:
		//   true  (default): body content first, then labels + ports (labels on top)
		//   false:           labels + ports first, then body content (content on top)
		if (tmpLabelsInFront)
		{
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}
		else
		{
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}

		// Panel indicator icon (small rect in bottom-right corner)
		if (pNodeTypeConfig && pNodeTypeConfig.PropertiesPanel)
		{
			let tmpIndicatorSize = 10;
			let tmpIndicatorMargin = 4;
			let tmpIndicatorX = tmpWidth - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpIndicatorY = tmpHeight - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
			let tmpIndicator;

			if (tmpShapeProvider)
			{
				tmpIndicator = tmpShapeProvider.createPanelIndicatorElement(
					pNodeData.Hash, tmpIndicatorX, tmpIndicatorY,
					tmpIndicatorSize, tmpIndicatorSize);
			}
			else
			{
				tmpIndicator = this._FlowView._SVGHelperProvider.createSVGElement('rect');
				tmpIndicator.setAttribute('class', 'pict-flow-node-panel-indicator');
				tmpIndicator.setAttribute('x', String(tmpIndicatorX));
				tmpIndicator.setAttribute('y', String(tmpIndicatorY));
				tmpIndicator.setAttribute('width', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('height', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('rx', '2');
				tmpIndicator.setAttribute('ry', '2');
				tmpIndicator.setAttribute('data-node-hash', pNodeData.Hash);
				tmpIndicator.setAttribute('data-element-type', 'panel-indicator');
			}

			let tmpIndicatorTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
			tmpIndicatorTitle.textContent = 'Double-click to open properties';
			tmpIndicator.appendChild(tmpIndicatorTitle);

			tmpGroup.appendChild(tmpIndicator);
		}

		pNodesLayer.appendChild(tmpGroup);
	}

	/**
	 * Render ports for a node — delegates to the PortRenderer service.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 */
	_renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		this._FlowView._PortRenderer.renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, this.options.NodeTitleBarHeight);
	}

	/**
	 * Render custom body content for a node (svg, html, or canvas).
	 *
	 * Checks for a BodyContent configuration on the node type and renders
	 * the appropriate content type into the node's SVG group.
	 *
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	_renderBodyContent(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.BodyContent) return;

		let tmpBodyContent = pNodeTypeConfig.BodyContent;
		let tmpContentType = tmpBodyContent.ContentType;
		if (!tmpContentType) return;

		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;
		let tmpPadding = (typeof tmpBodyContent.Padding === 'number') ? tmpBodyContent.Padding : 2;
		let tmpBodyBounds =
		{
			x: tmpPadding,
			y: tmpTitleBarHeight + tmpPadding,
			width: pWidth - (tmpPadding * 2),
			height: pHeight - tmpTitleBarHeight - (tmpPadding * 2)
		};

		let tmpPict = this._FlowView.pict || this.pict;

		// Register any templates defined in the BodyContent config (once)
		if (tmpBodyContent.Templates && Array.isArray(tmpBodyContent.Templates))
		{
			if (!this._registeredBodyTemplates)
			{
				this._registeredBodyTemplates = new Set();
			}
			for (let i = 0; i < tmpBodyContent.Templates.length; i++)
			{
				let tmpTpl = tmpBodyContent.Templates[i];
				if (tmpTpl.Hash && tmpTpl.Template && !this._registeredBodyTemplates.has(tmpTpl.Hash))
				{
					tmpPict.TemplateProvider.addTemplate(tmpTpl.Hash, tmpTpl.Template, 'PictViewFlowNode-BodyContent');
					this._registeredBodyTemplates.add(tmpTpl.Hash);
				}
			}
		}

		switch (tmpContentType)
		{
			case 'svg':
				this._renderBodyContentSVG(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'html':
				this._renderBodyContentHTML(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'canvas':
				this._renderBodyContentCanvas(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig);
				break;
			default:
				this.log.warn('PictViewFlowNode _renderBodyContent: unknown ContentType [' + tmpContentType + ']');
				break;
		}
	}

	/**
	 * Render SVG body content into a <g> group.
	 */
	_renderBodyContentSVG(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpContentGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
		tmpContentGroup.setAttribute('class', 'pict-flow-node-body-content');
		tmpContentGroup.setAttribute('transform', `translate(${pBounds.x}, ${pBounds.y})`);

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			// Parse SVG markup into the group via a temporary SVG element
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpRenderedContent;
			while (tmpTempSVG.firstChild)
			{
				tmpContentGroup.appendChild(tmpTempSVG.firstChild);
			}
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpContentGroup, pNodeData, pNodeTypeConfig, pBounds);
		}

		pGroup.appendChild(tmpContentGroup);
	}

	/**
	 * Render HTML body content into a foreignObject.
	 */
	_renderBodyContentHTML(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpDiv = document.createElement('div');
		tmpDiv.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpDiv.setAttribute('class', 'pict-flow-node-body-content-html');

		// Pointer event isolation — prevent node drag/canvas pan.
		// Inline attribute handlers (visible in DOM, no closure leak).
		tmpDiv.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpDiv.setAttribute('onwheel', 'event.stopPropagation()');

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			tmpDiv.innerHTML = tmpRenderedContent;
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpDiv, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpDiv);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Render canvas body content into a foreignObject.
	 */
	_renderBodyContentCanvas(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpCanvas = document.createElement('canvas');
		tmpCanvas.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpCanvas.setAttribute('class', 'pict-flow-node-body-content-canvas');
		tmpCanvas.width = Math.floor(pBounds.width);
		tmpCanvas.height = Math.floor(pBounds.height);
		tmpCanvas.style.width = '100%';
		tmpCanvas.style.height = '100%';

		// Pointer event isolation — inline attribute handlers.
		tmpCanvas.setAttribute('onpointerdown', 'event.stopPropagation()');
		tmpCanvas.setAttribute('onwheel', 'event.stopPropagation()');

		// Invoke render callback (the primary rendering path for canvas)
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpCanvas, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpCanvas);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Resolve and render a body content template string.
	 * @param {Object} pBodyContent - The BodyContent config
	 * @param {Object} pNodeData - The node data (template record)
	 * @param {Object} pPict - The Pict instance
	 * @returns {string|null} Rendered template content, or null
	 */
	_resolveBodyTemplate(pBodyContent, pNodeData, pPict)
	{
		if (pBodyContent.TemplateHash)
		{
			return pPict.parseTemplateByHash(pBodyContent.TemplateHash, pNodeData);
		}
		if (pBodyContent.Template)
		{
			return pPict.parseTemplate(pBodyContent.Template, pNodeData, null, [pNodeData]);
		}
		return null;
	}

	// ── Node Body Renderers ──────────────────────────────────────────────

	/**
	 * Render the standard rect-based node body (default mode).
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderRectNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// Node body (main rectangle)
		let tmpBody = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBody.setAttribute('class', 'pict-flow-node-body');
		tmpBody.setAttribute('x', '0');
		tmpBody.setAttribute('y', '0');
		tmpBody.setAttribute('width', String(pWidth));
		tmpBody.setAttribute('height', String(pHeight));
		tmpBody.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBody.setAttribute('data-element-type', 'node-body');

		// Apply custom styles from node type
		if (pNodeTypeConfig && pNodeTypeConfig.BodyStyle)
		{
			for (let tmpStyleKey in pNodeTypeConfig.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeTypeConfig.BodyStyle[tmpStyleKey]);
			}
		}

		// Per-node BodyStyle override (wins over the node-type default).
		// Lets a flow author paint individual cards distinctly without
		// registering a new node type per category.
		if (pNodeData.BodyStyle)
		{
			for (let tmpStyleKey in pNodeData.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeData.BodyStyle[tmpStyleKey]);
			}
		}

		// Apply per-instance style overrides (for node-specific editing)
		// These must be applied as inline styles so they override CSS rules
		// (CSS declarations take precedence over SVG presentation attributes).
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBody.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBody);

		// Title bar background (top portion)
		let tmpTitleBar = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBar.setAttribute('class', 'pict-flow-node-title-bar');
		tmpTitleBar.setAttribute('x', '0');
		tmpTitleBar.setAttribute('y', '0');
		tmpTitleBar.setAttribute('width', String(pWidth));
		tmpTitleBar.setAttribute('height', String(pTitleBarHeight));
		tmpTitleBar.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBar.setAttribute('data-element-type', 'node-body');

		// Apply custom title bar color
		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		// Per-node TitleBarColor (wins over node-type default).
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeData.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBar);

		// Title bar bottom fill (to square off the rounded corners at the bottom of the title bar)
		let tmpTitleBarBottom = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBarBottom.setAttribute('class', 'pict-flow-node-title-bar-bottom');
		tmpTitleBarBottom.setAttribute('x', '0');
		tmpTitleBarBottom.setAttribute('y', String(pTitleBarHeight - 8));
		tmpTitleBarBottom.setAttribute('width', String(pWidth));
		tmpTitleBarBottom.setAttribute('height', '8');
		tmpTitleBarBottom.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBarBottom.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeData.TitleBarColor);
		}

		// Per-instance title bar color override
		// Applied as inline style to override CSS rules.
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleBar.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
			tmpTitleBarBottom.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBarBottom);
	}

	/**
	 * Render a bracket-style node body (used by sketch/blueprint themes).
	 *
	 * The bracket body consists of:
	 * 1. A fill rect for the body background (no stroke)
	 * 2. A fill rect for the title bar background (no stroke)
	 * 3. A bracket path drawn via the noise provider (outline + title divider)
	 *
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderBracketNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// 1. Body fill rect (background only, no stroke)
		let tmpBodyFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBodyFill.setAttribute('class', 'pict-flow-node-body pict-flow-node-bracket-fill');
		tmpBodyFill.setAttribute('x', '0');
		tmpBodyFill.setAttribute('y', '0');
		tmpBodyFill.setAttribute('width', String(pWidth));
		tmpBodyFill.setAttribute('height', String(pHeight));
		tmpBodyFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBodyFill.setAttribute('data-element-type', 'node-body');

		// Per-instance style overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (tmpInlineStyles.length > 0)
			{
				tmpBodyFill.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBodyFill);

		// 2. Title bar fill rect (background only, no stroke)
		let tmpTitleFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleFill.setAttribute('class', 'pict-flow-node-title-bar pict-flow-node-bracket-title-fill');
		tmpTitleFill.setAttribute('x', '0');
		tmpTitleFill.setAttribute('y', '0');
		tmpTitleFill.setAttribute('width', String(pWidth));
		tmpTitleFill.setAttribute('height', String(pTitleBarHeight));
		tmpTitleFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleFill.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleFill);

		// 3. Bracket path (outline + title divider with optional noise)
		let tmpBracketConfig = { SerifLength: 6, TitleSeparator: true };
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.BracketConfig)
			{
				tmpBracketConfig = Object.assign(tmpBracketConfig, tmpActiveTheme.BracketConfig);
			}
		}

		let tmpAmplitude = 0;
		if (this._FlowView._ThemeProvider)
		{
			tmpAmplitude = this._FlowView._ThemeProvider.getNodeNoiseAmplitude();
		}

		let tmpBracketD = '';
		if (this._FlowView._NoiseProvider)
		{
			tmpBracketD = this._FlowView._NoiseProvider.generateBracketPath(
				pWidth, pHeight,
				tmpBracketConfig.SerifLength,
				tmpBracketConfig.TitleSeparator ? pTitleBarHeight : 0,
				tmpAmplitude,
				pNodeData.Hash
			);
		}

		let tmpBracketPath = this._FlowView._SVGHelperProvider.createSVGElement('path');
		tmpBracketPath.setAttribute('class', 'pict-flow-node-bracket');
		tmpBracketPath.setAttribute('d', tmpBracketD);
		tmpBracketPath.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBracketPath.setAttribute('data-element-type', 'node-body');

		// Per-instance stroke overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBracketPath.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBracketPath);
	}
}

module.exports = PictViewFlowNode;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":137}],64:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-PropertiesPanel',

	AutoRender: false,

	Templates:
	[
		{
			Hash: 'Flow-InfoPanel-Wrapper',
			Template: '<div class="pict-flow-info-panel">{~D:Record.PanelContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header-Icon',
			Template: '<div class="pict-flow-info-panel-header with-icon">{~D:Record.Icon~} {~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header',
			Template: '<div class="pict-flow-info-panel-header">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Description',
			Template: '<div class="pict-flow-info-panel-description">{~D:Record.Description~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badges',
			Template: '<div class="pict-flow-info-panel-badges">{~D:Record.BadgesContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Category',
			Template: '<span class="pict-flow-info-panel-badge category">{~D:Record.Category~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Code',
			Template: '<span class="pict-flow-info-panel-badge code">{~D:Record.Code~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Inputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Inputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Outputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Outputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Input',
			Template: '<div class="pict-flow-info-panel-port input">{~D:Record.Label~}{~D:Record.Constraint~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Output',
			Template: '<div class="pict-flow-info-panel-port output">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Constraint',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.ConstraintText~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Generic',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">{~D:Record.SectionTitle~}</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Event',
			Template: '<div class="pict-flow-info-panel-port event">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Value',
			Template: '<div class="pict-flow-info-panel-port value">{~D:Record.Label~}{~D:Record.DataType~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-DataType',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.DataTypeText~}</span>'
		},
		{
			Hash: 'Flow-NodeProps-Editor',
			// Inline oninput/onpointerdown wired to the FlowView's helper —
			// see PictViewFlow._applyNodePropChange / _stopEvent.
			Template: '<div class="pict-flow-node-props-fields" data-flow-view="{~D:Record.FlowViewIdentifier~}" data-node-hash="{~D:Record.NodeHash~}">'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title</label><input type="text" class="pict-flow-node-props-input" data-prop="Title" value="{~D:Record.Title~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Width" value="{~D:Record.Width~}" min="60" step="10" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Height</label><input type="number" class="pict-flow-node-props-input" data-prop="Height" value="{~D:Record.Height~}" min="40" step="10" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Fill</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyFill" value="{~D:Record.BodyFillValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Stroke</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyStroke" value="{~D:Record.BodyStrokeValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Stroke Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Style.BodyStrokeWidth" value="{~D:Record.BodyStrokeWidthValue~}" min="0" max="10" step="0.5" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '<div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title Bar</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.TitleBarColor" value="{~D:Record.TitleBarColorValue~}" oninput="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._applyNodePropChange(\'{~D:Record.NodeHash~}\', this.getAttribute(\'data-prop\'), this.value, this.type, event)" onpointerdown="event.stopPropagation()" /></div>'
				+ '</div>'
		}
	]
};

/**
 * PictView-Flow-PropertiesPanel
 *
 * Renders and manages all open properties panels on the flow graph.
 * Panels are SVG foreignObject elements containing HTML, placed inside
 * the viewport group so they zoom/pan with the graph.
 *
 * Responsibilities:
 *   - Reconcile DOM (add new panels, remove closed ones, update positions)
 *   - Render tether lines from each panel to its node
 *   - Manage panel instance cache (PictFlowCardPropertiesPanel subclasses)
 *   - Isolate HTML events from SVG interactions
 */
class PictViewFlowPropertiesPanel extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowPropertiesPanel';

		this._FlowView = null;

		// Cache of active panel instances: Map<panelHash, PictFlowCardPropertiesPanel>
		this._PanelInstances = {};
	}

	/**
	 * Render all open panels and their tethers.
	 *
	 * Uses DOM reconciliation for panels (to preserve live HTML state)
	 * and clear-and-rebuild for tethers (trivial SVG lines).
	 *
	 * @param {Array} pOpenPanels - Array of panel data objects from _FlowData.OpenPanels
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @param {SVGGElement} pTethersLayer - The SVG <g> for tether lines
	 * @param {string|null} pSelectedTetherHash - Hash of the selected tether's panel, or null
	 */
	renderPanels(pOpenPanels, pPanelsLayer, pTethersLayer, pSelectedTetherHash)
	{
		if (!pPanelsLayer || !pTethersLayer) return;
		if (!this._FlowView) return;

		let tmpOpenPanels = Array.isArray(pOpenPanels) ? pOpenPanels : [];

		// --- Reconcile panels layer (add new, remove closed, update positions) ---
		let tmpExistingPanelHashes = new Set();
		let tmpExistingForeignObjects = pPanelsLayer.querySelectorAll('.pict-flow-panel-foreign-object');
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			tmpExistingPanelHashes.add(tmpExistingForeignObjects[i].getAttribute('data-panel-hash'));
		}

		let tmpDesiredPanelHashes = new Set();
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			tmpDesiredPanelHashes.add(tmpOpenPanels[i].Hash);
		}

		// Remove panels that are no longer open
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			let tmpHash = tmpExistingForeignObjects[i].getAttribute('data-panel-hash');
			if (!tmpDesiredPanelHashes.has(tmpHash))
			{
				tmpExistingForeignObjects[i].remove();
				// Destroy cached instance
				if (this._PanelInstances[tmpHash])
				{
					this._PanelInstances[tmpHash].destroy();
					delete this._PanelInstances[tmpHash];
				}
			}
		}

		// Add or update panels
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpPanelData = tmpOpenPanels[i];

			if (tmpExistingPanelHashes.has(tmpPanelData.Hash))
			{
				// Update position of existing panel
				let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${tmpPanelData.Hash}"]`);
				if (tmpFO)
				{
					tmpFO.setAttribute('x', String(tmpPanelData.X));
					tmpFO.setAttribute('y', String(tmpPanelData.Y));
					tmpFO.setAttribute('width', String(tmpPanelData.Width));
					tmpFO.setAttribute('height', String(tmpPanelData.Height));
				}
			}
			else
			{
				// Create new panel
				this._createPanelForeignObject(tmpPanelData, pPanelsLayer);
			}
		}

		// --- Clear and rebuild tethers ---
		while (pTethersLayer.firstChild)
		{
			pTethersLayer.removeChild(pTethersLayer.firstChild);
		}

		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpIsSelected = (pSelectedTetherHash === tmpOpenPanels[i].Hash);
			this._renderTether(tmpOpenPanels[i], pTethersLayer, tmpIsSelected);
		}
	}

	/**
	 * Create a foreignObject containing the panel chrome and content.
	 * Delegates to the PanelChrome provider for template-based chrome creation,
	 * then renders panel content into the body container.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {SVGGElement} pPanelsLayer
	 */
	_createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpPanelChromeProvider = this._FlowView._PanelChromeProvider;
		if (!tmpPanelChromeProvider) return;

		let tmpBody = tmpPanelChromeProvider.createPanelForeignObject(pPanelData, pPanelsLayer);

		// Render the panel content into the Properties tab pane
		if (tmpBody)
		{
			this._renderPanelContent(pPanelData, tmpBody);
		}

		let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${pPanelData.Hash}"]`);
		if (tmpFO)
		{
			// Render appearance and help tabs. Tab-switching click handlers
			// are inline `onclick=` attributes in Flow-PanelChrome-Template
			// that call FlowView._handlePanelTabClick → switchPanelTab.
			this._renderAppearanceTab(pPanelData, tmpFO);
			this._renderHelpTab(pPanelData, tmpFO);
		}
	}

	/**
	 * Instantiate (or reuse) the panel type implementation and render into the body container.
	 *
	 * @param {Object} pPanelData
	 * @param {HTMLDivElement} pBodyContainer
	 */
	_renderPanelContent(pPanelData, pBodyContainer)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		// If no PropertiesPanel is configured, render the auto-generated info panel
		if (!tmpNodeTypeConfig.PropertiesPanel)
		{
			this._renderInfoPanelContent(pBodyContainer, tmpNodeData, tmpNodeTypeConfig);
			return;
		}

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelType = tmpPanelConfig.PanelType || 'Base';

		// Try to get a registered panel type service
		let tmpServiceName = `PictFlowCardPropertiesPanel-${tmpPanelType}`;
		let tmpInstance = null;

		if (this._PanelInstances[pPanelData.Hash])
		{
			// Reuse existing instance
			tmpInstance = this._PanelInstances[pPanelData.Hash];
		}
		else
		{
			// Create a new instance
			if (this.fable.servicesMap.hasOwnProperty(tmpServiceName))
			{
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceName, tmpPanelConfig);
			}
			else if (this.fable.servicesMap.hasOwnProperty('PictFlowCardPropertiesPanel'))
			{
				// Fall back to base class
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration('PictFlowCardPropertiesPanel', tmpPanelConfig);
			}

			if (tmpInstance)
			{
				tmpInstance._FlowView = this._FlowView;
				this._PanelInstances[pPanelData.Hash] = tmpInstance;
			}
		}

		if (tmpInstance)
		{
			tmpInstance.render(pBodyContainer, tmpNodeData);
		}

		// After the form renders, append port summary sections showing
		// event inputs, event outputs, and state outputs.
		// SettingsInputs are already visible as form fields above.
		this._renderPortSummary(pBodyContainer, tmpNodeTypeConfig);
	}

	/**
	 * Render an auto-generated info panel for nodes without a configured PropertiesPanel.
	 * Shows the node type, description, and a summary of input/output ports with
	 * their connection constraints.
	 *
	 * Uses configuration-based templates from _DefaultConfiguration.Templates
	 * rendered via pict.parseTemplateByHash().
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeData
	 * @param {Object} pNodeTypeConfig
	 */
	_renderInfoPanelContent(pContainer, pNodeData, pNodeTypeConfig)
	{
		let tmpMeta = pNodeTypeConfig.CardMetadata || {};
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];

		let tmpInputs = tmpPorts.filter((pPort) => pPort.Direction === 'input');
		let tmpOutputs = tmpPorts.filter((pPort) => pPort.Direction === 'output');

		let tmpLabel = pNodeTypeConfig.Label || pNodeData.Type;

		// Build content by rendering configuration-based templates
		let tmpContentParts = [];

		// Header
		let tmpIconProvider = this._FlowView._IconProvider;
		if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
		{
			// SVG icon markup for the header
			let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
			let tmpIconMarkup = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpIconMarkup, Label: tmpLabel }));
		}
		else if (tmpMeta.Icon)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpMeta.Icon, Label: tmpLabel }));
		}
		else if (tmpIconProvider)
		{
			// No icon specified — render default fallback
			let tmpDefaultMarkup = tmpIconProvider.getIconSVGMarkup('default', 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpDefaultMarkup, Label: tmpLabel }));
		}
		else
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header', { Label: tmpLabel }));
		}

		// Description
		if (tmpMeta.Description)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Description', { Description: tmpMeta.Description }));
		}

		// Category + Code badges
		if (tmpMeta.Category || tmpMeta.Code)
		{
			let tmpBadgesContent = '';
			if (tmpMeta.Category)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Category', { Category: tmpMeta.Category });
			}
			if (tmpMeta.Code)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Code', { Code: tmpMeta.Code });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Badges', { BadgesContent: tmpBadgesContent }));
		}

		// Inputs
		if (tmpInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpInputs.length; i++)
			{
				let tmpPort = tmpInputs[i];
				let tmpConstraint = this._getPortConstraintHTML(tmpPort);
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Input', { Label: tmpPort.Label || 'In', Constraint: tmpConstraint });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Inputs', { PortsContent: tmpPortsContent }));
		}

		// Outputs
		if (tmpOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpOutputs.length; i++)
			{
				let tmpPort = tmpOutputs[i];
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Output', { Label: tmpPort.Label || 'Out' });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Outputs', { PortsContent: tmpPortsContent }));
		}

		pContainer.innerHTML = this.pict.parseTemplateByHash('Flow-InfoPanel-Wrapper', { PanelContent: tmpContentParts.join('') });
	}

	/**
	 * Render port summary sections below the form panel content.
	 * Shows event inputs, event outputs, and state outputs — the ports
	 * that the form does not cover (since the form only shows SettingsInputs).
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeTypeConfig
	 */
	_renderPortSummary(pContainer, pNodeTypeConfig)
	{
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];
		if (tmpPorts.length === 0) return;

		// Categorize ports by type (settings are already shown as form fields)
		let tmpEventInputs = [];
		let tmpEventOutputs = [];
		let tmpStateOutputs = [];

		for (let i = 0; i < tmpPorts.length; i++)
		{
			let tmpPort = tmpPorts[i];
			let tmpPortType = tmpPort.PortType || '';

			if (tmpPortType === 'event-in')
			{
				tmpEventInputs.push(tmpPort);
			}
			else if (tmpPortType === 'event-out' || tmpPortType === 'error')
			{
				tmpEventOutputs.push(tmpPort);
			}
			else if (tmpPortType === 'value')
			{
				tmpStateOutputs.push(tmpPort);
			}
		}

		// Only render if there are non-settings ports to show
		if (tmpEventInputs.length === 0 && tmpEventOutputs.length === 0 && tmpStateOutputs.length === 0)
		{
			return;
		}

		let tmpSummaryParts = [];

		// Event Inputs
		if (tmpEventInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventInputs.length; i++)
			{
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpEventInputs[i].Label || tmpEventInputs[i].Name || 'Event In' });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Inputs', PortsContent: tmpPortsContent }));
		}

		// Event Outputs
		if (tmpEventOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventOutputs.length; i++)
			{
				let tmpPort = tmpEventOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Event Out';
				if (tmpPort.PortType === 'error')
				{
					tmpLabel += ' ⚠';
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpLabel });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Outputs', PortsContent: tmpPortsContent }));
		}

		// State Outputs
		if (tmpStateOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpStateOutputs.length; i++)
			{
				let tmpPort = tmpStateOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Output';
				let tmpDataType = '';
				if (tmpPort.DataType)
				{
					tmpDataType = this.pict.parseTemplateByHash('Flow-InfoPanel-Port-DataType', { DataTypeText: tmpPort.DataType });
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Value', { Label: tmpLabel, DataType: tmpDataType });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'State Outputs', PortsContent: tmpPortsContent }));
		}

		if (tmpSummaryParts.length > 0)
		{
			// Create a wrapper div for the port summary and append it to the container
			let tmpSummaryDiv = document.createElement('div');
			tmpSummaryDiv.className = 'pict-flow-info-panel pict-flow-port-summary';
			tmpSummaryDiv.innerHTML = tmpSummaryParts.join('');
			pContainer.appendChild(tmpSummaryDiv);
		}
	}

	/**
	 * Build the constraint markup for a port using configuration templates.
	 *
	 * @param {Object} pPort
	 * @returns {string} Rendered constraint HTML or empty string
	 */
	_getPortConstraintHTML(pPort)
	{
		let tmpMin = (typeof pPort.MinimumInputCount === 'number') ? pPort.MinimumInputCount : 0;
		let tmpMax = (typeof pPort.MaximumInputCount === 'number') ? pPort.MaximumInputCount : -1;

		if (tmpMin > 0 || tmpMax > 0)
		{
			let tmpConstraintText = '';
			if (tmpMax < 0)
			{
				tmpConstraintText = `(min ${tmpMin})`;
			}
			else if (tmpMin === tmpMax)
			{
				tmpConstraintText = `(exactly ${tmpMin})`;
			}
			else
			{
				tmpConstraintText = `(${tmpMin}\u2013${tmpMax})`;
			}
			return this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Constraint', { ConstraintText: tmpConstraintText });
		}
		return '';
	}

	/**
	 * Render the Appearance tab content with node property editor fields.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderAppearanceTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpAppearancePane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="appearance"]');
		if (!tmpAppearancePane) return;

		// Build the template record with safe defaults for Style values
		let tmpStyle = tmpNodeData.Style || {};

		// Resolve default colors from the node type config or CSS token defaults
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		let tmpDefaultTitleBarColor = '#2c3e50';
		let tmpDefaultBodyFill = '#ffffff';
		let tmpDefaultBodyStroke = '#d0d4d8';
		if (tmpNodeTypeConfig)
		{
			if (tmpNodeTypeConfig.TitleBarColor) tmpDefaultTitleBarColor = tmpNodeTypeConfig.TitleBarColor;
			if (tmpNodeTypeConfig.BodyStyle)
			{
				if (tmpNodeTypeConfig.BodyStyle.fill) tmpDefaultBodyFill = tmpNodeTypeConfig.BodyStyle.fill;
				if (tmpNodeTypeConfig.BodyStyle.stroke) tmpDefaultBodyStroke = tmpNodeTypeConfig.BodyStyle.stroke;
			}
		}

		let tmpRecord =
		{
			Title: tmpNodeData.Title || '',
			Width: tmpNodeData.Width || 180,
			Height: tmpNodeData.Height || 80,
			BodyFillValue: tmpStyle.BodyFill || tmpDefaultBodyFill,
			BodyStrokeValue: tmpStyle.BodyStroke || tmpDefaultBodyStroke,
			BodyStrokeWidthValue: tmpStyle.BodyStrokeWidth || 1,
			TitleBarColorValue: tmpStyle.TitleBarColor || tmpDefaultTitleBarColor,
			NodeHash: pPanelData.NodeHash,
			FlowViewIdentifier: this._FlowView.options.ViewIdentifier
		};

		// Inputs in the rendered template carry inline oninput/onpointerdown
		// handlers that call the FlowView's _applyNodePropChange — no
		// addEventListener wiring needed here.
		this.pict.ContentAssignment.assignContent(tmpAppearancePane,
			this.pict.parseTemplateByHash('Flow-NodeProps-Editor', tmpRecord));
	}

	/**
	 * Render the Help tab content if help text is defined on the node type.
	 * Shows the Help tab button only when help content is available.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderHelpTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		let tmpHelpText = (tmpNodeTypeConfig.CardMetadata && tmpNodeTypeConfig.CardMetadata.Help)
			? tmpNodeTypeConfig.CardMetadata.Help
			: null;

		if (!tmpHelpText) return;

		// Show the Help tab button
		let tmpHelpTabButton = pForeignObject.querySelector('.pict-flow-panel-tab[data-tab-target="help"]');
		if (tmpHelpTabButton)
		{
			tmpHelpTabButton.style.display = '';
		}

		// Render help content into the help pane
		let tmpHelpPane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="help"]');
		if (tmpHelpPane)
		{
			tmpHelpPane.innerHTML = '<div class="pict-flow-panel-help-content">' + tmpHelpText + '</div>';
		}
	}

	/**
	 * Switch the visible tab pane within a panel foreignObject. Invoked
	 * from the inline `onclick` handler on tab buttons in
	 * Flow-PanelChrome-Template via FlowView._handlePanelTabClick.
	 *
	 * @param {Element} pTabElement - The clicked tab button
	 */
	switchPanelTab(pTabElement)
	{
		let tmpForeignObject = pTabElement.closest('foreignObject');
		if (!tmpForeignObject) return;

		let tmpTarget = pTabElement.getAttribute('data-tab-target');
		let tmpTabs = tmpForeignObject.querySelectorAll('.pict-flow-panel-tab');
		let tmpPanes = tmpForeignObject.querySelectorAll('.pict-flow-panel-tab-pane');

		for (let i = 0; i < tmpTabs.length; i++)
		{
			tmpTabs[i].classList.remove('active');
		}
		for (let i = 0; i < tmpPanes.length; i++)
		{
			tmpPanes[i].classList.remove('active');
			tmpPanes[i].style.display = 'none';
		}

		pTabElement.classList.add('active');
		let tmpTargetPane = tmpForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="' + tmpTarget + '"]');
		if (tmpTargetPane)
		{
			tmpTargetPane.classList.add('active');
			tmpTargetPane.style.display = 'block';
		}
	}

	/**
	 * Apply a node property change from the properties editor and re-render.
	 *
	 * @param {string} pNodeHash - Hash of the node to update
	 * @param {string} pPropPath - Property path (e.g. 'Title', 'Width', 'Style.BodyFill')
	 * @param {string} pValue - The new value from the input
	 * @param {string} pInputType - The input element type ('text', 'number', 'color')
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType)
	{
		let tmpNodeData = this._FlowView.getNode(pNodeHash);
		if (!tmpNodeData) return;

		// Parse numeric values
		let tmpValue = pValue;
		if (pInputType === 'number')
		{
			tmpValue = parseFloat(pValue);
			if (isNaN(tmpValue)) return;
		}

		// Apply the value based on the property path
		if (pPropPath === 'Title')
		{
			tmpNodeData.Title = tmpValue;
		}
		else if (pPropPath === 'Width')
		{
			tmpNodeData.Width = tmpValue;
		}
		else if (pPropPath === 'Height')
		{
			tmpNodeData.Height = tmpValue;
		}
		else if (pPropPath.startsWith('Style.'))
		{
			if (!tmpNodeData.Style) tmpNodeData.Style = {};
			let tmpStyleKey = pPropPath.substring(6); // Remove 'Style.' prefix
			tmpNodeData.Style[tmpStyleKey] = tmpValue;
		}

		// Re-render the flow to reflect changes
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		// Fire change event
		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Render a tether from a panel to its node.
	 * Delegates to the TetherService for geometry, path generation, and SVG element creation.
	 *
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {boolean} pIsSelected
	 */
	_renderTether(pPanelData, pTethersLayer, pIsSelected)
	{
		let tmpTetherService = this._FlowView._TetherService;
		if (!tmpTetherService) return;

		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		tmpTetherService.renderTether(pPanelData, tmpNodeData, pTethersLayer, pIsSelected, tmpViewIdentifier);
	}

	/**
	 * Marshal data from all open panels back into their node Data objects.
	 */
	marshalAllFromPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			let tmpInstance = this._PanelInstances[tmpPanelHash];
			if (tmpInstance && tmpInstance._NodeData)
			{
				tmpInstance.marshalFromPanel(tmpInstance._NodeData);
			}
		}
	}

	/**
	 * Destroy a specific panel instance and clean up.
	 *
	 * @param {string} pPanelHash
	 */
	destroyPanel(pPanelHash)
	{
		if (this._PanelInstances[pPanelHash])
		{
			this._PanelInstances[pPanelHash].destroy();
			delete this._PanelInstances[pPanelHash];
		}
	}

	/**
	 * Destroy all panel instances.
	 */
	destroyAllPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			this._PanelInstances[tmpPanelHash].destroy();
		}
		this._PanelInstances = {};
	}
}

module.exports = PictViewFlowPropertiesPanel;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":137}],65:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-Toolbar',

	DefaultRenderable: 'Flow-Toolbar-Content',
	DefaultDestinationAddress: '#Flow-Toolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	EnablePalette: true,
	EnableAddNode: true,
	EnableCardPalette: true,

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-Toolbar-Template',
			// Inline onclick handlers route to the toolbar via the FlowView
			// (the flow toolbar is reachable as ._ToolbarView from the
			// registered FlowView). Each button is responsible for its own
			// action — no event delegation.
			Template: /*html*/`
<div class="pict-flow-toolbar" id="Flow-Toolbar-Bar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="add-node" id="Flow-Toolbar-AddNode-{~D:Record.FlowViewIdentifier~}" title="Add Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('add-node')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-plus-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Node</span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="cards-popup" id="Flow-Toolbar-Cards-{~D:Record.FlowViewIdentifier~}" title="Card Palette"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('cards-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-cards-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Cards</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-CardsChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="delete-selected" title="Delete Node"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('delete-selected')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-trash-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="layout-popup" id="Flow-Toolbar-Layout-{~D:Record.FlowViewIdentifier~}" title="Manage saved layouts"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-layout-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Layouts</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-LayoutChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<div class="pict-flow-toolbar-btn-split" id="Flow-Toolbar-Auto-{~D:Record.FlowViewIdentifier~}">
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-main" data-flow-action="apply-current-layout" title="Apply current layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('apply-current-layout')">
				<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-auto-{~D:Record.FlowViewIdentifier~}"></span>
				<span class="pict-flow-toolbar-btn-text">Auto</span>
			</button>
			<button class="pict-flow-toolbar-btn pict-flow-toolbar-btn-split-chevron" data-flow-action="layout-algorithm-popup" title="Choose layout algorithm"
				onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('layout-algorithm-popup')">
				<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-AutoChevron-{~D:Record.FlowViewIdentifier~}"></span>
			</button>
		</div>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-in" title="Zoom In"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-in')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-out" title="Zoom Out"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-out')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-fit" title="Fit to View"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('zoom-fit')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-right">
		<button class="pict-flow-toolbar-btn" data-flow-action="settings-popup" id="Flow-Toolbar-Settings-{~D:Record.FlowViewIdentifier~}" title="Theme Settings"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('settings-popup')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-settings-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="fullscreen" id="Flow-Toolbar-Fullscreen-{~D:Record.FlowViewIdentifier~}" title="Toggle Fullscreen"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('fullscreen')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Fullscreen-Icon-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="toggle-floating" title="Float"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('toggle-floating')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-grip-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="collapse-toolbar" title="Collapse Toolbar"
			onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('collapse-toolbar')">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-collapse-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
</div>
<div class="pict-flow-toolbar-collapsed" id="Flow-Toolbar-Collapsed-{~D:Record.FlowViewIdentifier~}">
	<button class="pict-flow-toolbar-expand-btn" data-flow-action="expand-toolbar" title="Expand Toolbar" id="Flow-Toolbar-ExpandBtn-{~D:Record.FlowViewIdentifier~}"
		onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._ToolbarView._handleToolbarAction('expand-toolbar')">
		<span id="Flow-Toolbar-Icon-expand-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
<div class="pict-flow-toolbar-popup-anchor" id="Flow-Toolbar-PopupAnchor-{~D:Record.FlowViewIdentifier~}">
</div>
`
		},
		{
			Hash: 'Flow-AddNode-List',
			// Iteration source is `Record.Rows` — the outer call sets the
			// FlowViewIdentifier on each row so inline handlers resolve their
			// owning view independently. Nested {~D:~} inside {~TS:~}
			// addresses isn't supported by the template engine, so we keep
			// addresses static.
			Template: '{~TS:Flow-AddNode-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-AddNode-Row',
			Template: '<div class="pict-flow-popup-list-item" data-node-type="{~D:Record.NodeType~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addNodeFromPopup(this.getAttribute(\'data-node-type\'))">'
				+ '<span class="pict-flow-popup-list-item-icon">{~D:Record.IconHTML~}</span>'
				+ '<span class="pict-flow-popup-list-item-label">{~D:Record.Label~}</span>'
				+ '{~NE:Record.Code^<span class="pict-flow-popup-list-item-code">{~D:Record.Code~}</span>~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-List',
			Template: '{~TS:Flow-Cards-Category:Record.Categories~}'
		},
		{
			Hash: 'Flow-Cards-Category',
			Template: '<div class="pict-flow-palette-category" style="padding:0.35em 0.5em;">'
				+ '<div class="pict-flow-palette-category-label">{~D:Record.Name~}</div>'
				+ '<div class="pict-flow-palette-cards">{~TS:Flow-Cards-Card:Record.Cards~}</div>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Cards-Card',
			Template: '<div class="pict-flow-palette-card{~D:Record.DisabledClass~}" data-card-type="{~D:Record.CardType~}" title="{~D:Record.Tooltip~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._addCardFromPopup(this.getAttribute(\'data-card-type\'))">'
				+ '{~NE:Record.IconHTML^<span class="pict-flow-palette-card-icon">{~D:Record.IconHTML~}</span>~}'
				+ '{~NE:Record.IconEmoji^<span class="pict-flow-palette-card-icon">{~D:Record.IconEmoji~}</span>~}'
				+ '{~NE:Record.SwatchColor^<span class="pict-flow-palette-card-swatch" style="background-color: {~D:Record.SwatchColor~};"></span>~}'
				+ '<span class="pict-flow-palette-card-title">{~D:Record.Label~}</span>'
				+ '{~NE:Record.Code^<span class="pict-flow-palette-card-code">{~D:Record.Code~}</span>~}'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-List',
			Template: '{~TS:Flow-Layout-Row:Record.Rows~}'
		},
		{
			Hash: 'Flow-Layout-Row',
			Template: '<div class="pict-flow-popup-layout-row" data-layout-hash="{~D:Record.LayoutHash~}"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._restoreLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '<span class="pict-flow-popup-layout-name">{~D:Record.Name~}</span>'
				+ '<button class="pict-flow-popup-layout-delete" title="Delete layout"'
				+ ' onclick="_Pict.views[\'{~D:Record.FlowViewIdentifier~}\']._ToolbarView._deleteLayoutFromPopup(\'{~D:Record.LayoutHash~}\', event)">'
				+ '{~D:Record.DeleteIconHTML~}</button>'
				+ '</div>'
		},
		{
			Hash: 'Flow-Layout-OptionList',
			Template: '{~TS:Flow-Layout-Option:Record.Options~}'
		},
		{
			Hash: 'Flow-Layout-Option',
			Template: '<option value="{~D:Record.Value~}"{~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Toolbar-Content',
			TemplateHash: 'Flow-Toolbar-Template',
			DestinationAddress: '#Flow-Toolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowToolbar';

		this._FlowView = null;

		// Toolbar mode state
		this._ToolbarMode = 'docked'; // 'docked' | 'floating' | 'collapsed'
		this._ActivePopup = null;     // 'add-node' | 'cards' | 'layout' | null
		this._FloatingPosition = { X: 80, Y: 80 };
		this._DocumentClickHandler = null;
		this._FloatingToolbarView = null;

		// Layout-algorithm parameter form (pict-section-form metacontroller).
		// Lazily created on first popup open; null until then. Falls back to
		// hand-rolled inputs when PictFormMetacontroller is not registered.
		this._LayoutFormMetacontroller = null;
		this._LayoutFormHostID = null;
		// Whether the parameter form is expanded inside the popup. Persists
		// across popup opens so a user who collapsed it doesn't have to
		// re-collapse on every reopen. Defaults to expanded.
		this._LayoutFormExpanded = true;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Pass this.options as the template record so {~D:Record.FlowViewIdentifier~}
		// resolves correctly in the toolbar template.
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Click handlers live on each button as inline `onclick` attributes
		// in Flow-Toolbar-Template — they call _handleToolbarAction directly.

		// Populate SVG icons for toolbar buttons
		this._populateToolbarIcons();

		// Remove buttons from DOM based on options
		if (this.options.EnableAddNode === false)
		{
			let tmpAddNodeBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`);
			if (tmpAddNodeBtn.length > 0)
			{
				tmpAddNodeBtn[0].remove();
			}
		}
		if (this.options.EnableCardPalette === false)
		{
			let tmpCardsBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`);
			if (tmpCardsBtn.length > 0)
			{
				tmpCardsBtn[0].remove();
			}
		}
		if (this.options.EnableLayoutMenu === false)
		{
			let tmpAutoBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`);
			if (tmpAutoBtn.length > 0)
			{
				tmpAutoBtn[0].remove();
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// ── Icon Population ───────────────────────────────────────────────────

	/**
	 * Populate SVG icons for all toolbar buttons.
	 */
	_populateToolbarIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Map of element ID suffix → icon key
		let tmpIconMap =
		{
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'settings': 'settings',
			'grip': 'grip',
			'collapse': 'collapse',
			'expand': 'expand'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-Toolbar-Icon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 14);
			}
		}

		// Fullscreen icon
		let tmpFullscreenIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
		if (tmpFullscreenIcon.length > 0)
		{
			tmpFullscreenIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup('fullscreen', 14);
		}

		// Chevrons (smaller)
		let tmpCardsChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-CardsChevron-${tmpFlowViewIdentifier}`);
		if (tmpCardsChevron.length > 0)
		{
			tmpCardsChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpLayoutChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-LayoutChevron-${tmpFlowViewIdentifier}`);
		if (tmpLayoutChevron.length > 0)
		{
			tmpLayoutChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpAutoChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AutoChevron-${tmpFlowViewIdentifier}`);
		if (tmpAutoChevron.length > 0)
		{
			tmpAutoChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}
	}

	// ── Popup Management ──────────────────────────────────────────────────

	/**
	 * Open a popup below a trigger button.
	 * @param {string} pType - 'add-node' | 'cards' | 'layout'
	 */
	_openPopup(pType)
	{
		// Toggle off if already open
		if (this._ActivePopup === pType)
		{
			this._closePopup();
			return;
		}

		// Close any existing popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		// Create popup div
		let tmpPopup = document.createElement('div');
		tmpPopup.className = 'pict-flow-toolbar-popup';
		tmpPopup.setAttribute('id', `Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);

		// Build popup content
		switch (pType)
		{
			case 'add-node':
				this._buildAddNodePopup(tmpPopup);
				break;
			case 'cards':
				this._buildCardsPopup(tmpPopup);
				break;
			case 'layout':
				this._buildLayoutPopup(tmpPopup);
				break;
			case 'layout-algorithm':
				this._buildLayoutAlgorithmPopup(tmpPopup);
				break;
			case 'settings':
				this._buildSettingsPopup(tmpPopup);
				break;
		}

		tmpAnchor[0].appendChild(tmpPopup);
		this._ActivePopup = pType;

		// Position the popup below the trigger button
		this._positionPopup(tmpPopup, pType);

		// Click-outside-to-close handler (delayed to avoid catching the opening click)
		setTimeout(() =>
		{
			this._DocumentClickHandler = (pEvent) =>
			{
				if (!tmpPopup.contains(pEvent.target))
				{
					// Check if click was on the trigger button itself (toggle behavior)
					let tmpButton = pEvent.target.closest('[data-flow-action]');
					if (tmpButton)
					{
						let tmpAction = tmpButton.getAttribute('data-flow-action');
						if (tmpAction === pType || tmpAction === pType.replace('-popup', '') + '-popup')
						{
							return; // Let the toggle handle it
						}
					}
					this._closePopup();
				}
			};
			document.addEventListener('click', this._DocumentClickHandler, true);
		}, 0);

		// Focus search input if Add Node popup
		if (pType === 'add-node')
		{
			let tmpSearch = tmpPopup.querySelector('.pict-flow-popup-search');
			if (tmpSearch)
			{
				setTimeout(() => { tmpSearch.focus(); }, 50);
			}
		}
	}

	/**
	 * Close the active popup and clean up.
	 */
	_closePopup()
	{
		if (this._DocumentClickHandler)
		{
			document.removeEventListener('click', this._DocumentClickHandler, true);
			this._DocumentClickHandler = null;
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopup = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopup.length > 0)
		{
			tmpPopup[0].parentNode.removeChild(tmpPopup[0]);
		}

		this._ActivePopup = null;
	}

	/**
	 * Position a popup below its trigger button.
	 * @param {HTMLElement} pPopupDiv
	 * @param {string} pType
	 */
	_positionPopup(pPopupDiv, pType)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Determine which button triggered the popup
		let tmpTriggerSelector;
		switch (pType)
		{
			case 'add-node':
				tmpTriggerSelector = `#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`;
				break;
			case 'cards':
				tmpTriggerSelector = `#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`;
				break;
			case 'layout':
				tmpTriggerSelector = `#Flow-Toolbar-Layout-${tmpFlowViewIdentifier}`;
				break;
			case 'layout-algorithm':
				tmpTriggerSelector = `#Flow-Toolbar-Auto-${tmpFlowViewIdentifier}`;
				break;
			case 'settings':
				tmpTriggerSelector = `#Flow-Toolbar-Settings-${tmpFlowViewIdentifier}`;
				break;
			default:
				return;
		}

		let tmpTriggerElements = this.pict.ContentAssignment.getElement(tmpTriggerSelector);
		if (tmpTriggerElements.length < 1) return;

		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		let tmpTriggerRect = tmpTriggerElements[0].getBoundingClientRect();
		let tmpAnchorRect = tmpAnchor[0].getBoundingClientRect();

		let tmpLeft = tmpTriggerRect.left - tmpAnchorRect.left;
		pPopupDiv.style.left = tmpLeft + 'px';
		pPopupDiv.style.top = '0px';
	}

	// ── Add Node Popup ────────────────────────────────────────────────────

	/**
	 * Build the searchable Add Node popup content via templates with inline
	 * handlers. Search input fires `_filterNodeList` which re-renders the
	 * list section in place.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildAddNodePopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-AddNodeList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-AddNodeSearch-${tmpFlowViewIdentifier}`;

		// Stage AppData and render the initial list HTML inline — the popup
		// element isn't in the DOM yet, so we can't look it up via
		// getElementById here. _filterNodeList handles updates after open.
		let tmpInitialListHTML = this._renderNodeListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search node types..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterNodeList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');
	}

	/**
	 * Build the HTML string for the Add Node list filtered by the given
	 * text. Stages AppData and renders the {~TS:~} template into a string;
	 * returns "no matches" markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderNodeListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpTypes = this._FlowView._NodeTypeProvider.getNodeTypes();
		let tmpTypeKeys = Object.keys(tmpTypes);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;

		let tmpRows = [];
		for (let i = 0; i < tmpTypeKeys.length; i++)
		{
			let tmpTypeConfig = tmpTypes[tmpTypeKeys[i]];
			let tmpMeta = tmpTypeConfig.CardMetadata || {};
			if (tmpMeta.Enabled === false) continue;

			if (tmpFilter)
			{
				let tmpLabel = (tmpTypeConfig.Label || '').toLowerCase();
				let tmpCode = (tmpMeta.Code || '').toLowerCase();
				let tmpCategory = (tmpMeta.Category || '').toLowerCase();
				if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
			}

			let tmpIconHTML = '';
			if (tmpIconProvider)
			{
				let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
				tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 16);
			}
			tmpRows.push(
			{
				NodeType: tmpTypeKeys[i],
				Label: tmpTypeConfig.Label || '',
				IconHTML: tmpIconHTML,
				Code: tmpMeta.Code || '',
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpRows.length === 0)
		{
			return '<div class="pict-flow-popup-list-empty">No matching node types</div>';
		}
		return this.pict.parseTemplateByHash('Flow-AddNode-List', { Rows: tmpRows });
	}

	/**
	 * Update the Add Node list contents in response to a search input
	 * change. Called from the inline `oninput` handler. The list element
	 * is already in the DOM by the time this fires.
	 *
	 * @param {string} pListID
	 * @param {string} pFilter
	 */
	_filterNodeList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderNodeListHTML(pFilter));
	}

	/**
	 * Inline handler for an Add Node row click. Adds the node at viewport
	 * center and closes the popup.
	 *
	 * @param {string} pNodeType
	 */
	_addNodeFromPopup(pNodeType)
	{
		this._addNodeAtCenter(pNodeType);
		this._closePopup();
	}

	// ── Cards Popup ───────────────────────────────────────────────────────

	/**
	 * Build the Cards popup using templates with inline handlers. Search
	 * input fires `_filterCardsList` which re-renders the categorized list.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildCardsPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSearchIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('search', 12) : '';

		let tmpListID = `Flow-Toolbar-CardsList-${tmpFlowViewIdentifier}`;
		let tmpSearchID = `Flow-Toolbar-CardsSearch-${tmpFlowViewIdentifier}`;

		// Initial render inline — popup not yet in DOM.
		let tmpInitialListHTML = this._renderCardsListHTML('');

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-search-wrapper">'
			+ '<span class="pict-flow-popup-search-icon">' + tmpSearchIconHTML + '</span>'
			+ '<input id="' + tmpSearchID + '" class="pict-flow-popup-search" type="text" placeholder="Search cards..." '
			+ 'oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._filterCardsList(\'' + tmpListID + '\', this.value)" />'
			+ '</div>'
			+ '<div id="' + tmpListID + '" class="pict-flow-popup-node-list">' + tmpInitialListHTML + '</div>');

		// Focus search input — defer past the popup append.
		setTimeout(() =>
		{
			let tmpSearch = document.getElementById(tmpSearchID);
			if (tmpSearch) tmpSearch.focus();
		}, 50);
	}

	/**
	 * Build the cards-list HTML string for the given filter. Stages
	 * AppData and renders via the {~TS:~} templates; returns "no matches"
	 * markup when nothing matches.
	 *
	 * @param {string} pFilter
	 * @returns {string}
	 */
	_renderCardsListHTML(pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return '';

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpCategories = this._FlowView._NodeTypeProvider.getCardsByCategory();
		let tmpCategoryKeys = Object.keys(tmpCategories);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;
		let tmpTotalMatchCount = 0;

		let tmpCategoryRecords = [];
		for (let i = 0; i < tmpCategoryKeys.length; i++)
		{
			let tmpCategoryName = tmpCategoryKeys[i];
			let tmpCards = tmpCategories[tmpCategoryName];
			let tmpMatching = [];

			for (let j = 0; j < tmpCards.length; j++)
			{
				let tmpCardConfig = tmpCards[j];
				let tmpMeta = tmpCardConfig.CardMetadata || {};

				if (tmpFilter)
				{
					let tmpLabel = (tmpCardConfig.Label || '').toLowerCase();
					let tmpCode = (tmpMeta.Code || '').toLowerCase();
					let tmpCategory = tmpCategoryName.toLowerCase();
					if (tmpLabel.indexOf(tmpFilter) < 0 && tmpCode.indexOf(tmpFilter) < 0 && tmpCategory.indexOf(tmpFilter) < 0) continue;
				}

				let tmpIconHTML = '';
				let tmpIsEmoji = false;
				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup(tmpIconProvider.resolveIconKey(tmpMeta), 14);
				}
				else if (tmpMeta.Icon)
				{
					tmpIsEmoji = true;
				}
				else if (tmpIconProvider)
				{
					tmpIconHTML = tmpIconProvider.getIconSVGMarkup('default', 14);
				}

				tmpMatching.push(
				{
					CardType: tmpCardConfig.Hash,
					Label: tmpCardConfig.Label || '',
					Code: tmpMeta.Code || '',
					IconHTML: tmpIconHTML,
					IconEmoji: tmpIsEmoji ? tmpMeta.Icon : '',
					DisabledClass: (tmpMeta.Enabled === false) ? ' disabled' : '',
					Tooltip: tmpMeta.Tooltip || tmpMeta.Description || '',
					SwatchColor: (!tmpIconHTML && !tmpIsEmoji && tmpCardConfig.TitleBarColor) ? tmpCardConfig.TitleBarColor : '',
					FlowViewIdentifier: tmpFlowViewIdentifier
				});
			}

			if (tmpMatching.length === 0) continue;
			tmpTotalMatchCount += tmpMatching.length;
			tmpCategoryRecords.push(
			{
				Name: tmpCategoryName,
				Cards: tmpMatching,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		if (tmpTotalMatchCount === 0)
		{
			return '<div class="pict-flow-popup-list-empty">' + (tmpFilter ? 'No matching cards' : 'No card types available') + '</div>';
		}
		return this.pict.parseTemplateByHash('Flow-Cards-List', { Categories: tmpCategoryRecords });
	}

	/**
	 * Inline `oninput` handler — refresh card list with the new filter.
	 */
	_filterCardsList(pListID, pFilter)
	{
		let tmpListEl = document.getElementById(pListID);
		if (!tmpListEl) return;
		this.pict.ContentAssignment.assignContent(tmpListEl, this._renderCardsListHTML(pFilter));
	}

	/**
	 * Inline handler for a card click. Adds the node and closes the popup.
	 *
	 * @param {string} pCardType
	 */
	_addCardFromPopup(pCardType)
	{
		this._addCardFromPalette(pCardType);
		this._closePopup();
	}

	// ── Layout Popup ──────────────────────────────────────────────────────

	/**
	 * Build the Layout popup using templates with inline handlers.
	 *
	 * Layout records (name + hash) are pushed into AppData and iterated via
	 * a {~TS:~} template. The save section is a static fragment with inline
	 * handlers that call the toolbar's helper methods.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutPopup(pContainer)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSaveIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('save', 14) : '✓';
		let tmpDeleteIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('trash', 12) : '×';

		let tmpSaveRowID = `Flow-Toolbar-LayoutSaveRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputRowID = `Flow-Toolbar-LayoutSaveInputRow-${tmpFlowViewIdentifier}`;
		let tmpSaveInputID = `Flow-Toolbar-LayoutSaveInput-${tmpFlowViewIdentifier}`;
		let tmpListID = `Flow-Toolbar-LayoutList-${tmpFlowViewIdentifier}`;

		// Build layout records for the {~TS:~} iteration
		let tmpLayouts = (this._FlowView && this._FlowView._LayoutProvider)
			? this._FlowView._LayoutProvider.getLayouts() : [];
		let tmpLayoutRecords = [];
		for (let i = 0; i < tmpLayouts.length; i++)
		{
			tmpLayoutRecords.push(
			{
				LayoutHash: tmpLayouts[i].Hash,
				Name: tmpLayouts[i].Name || '',
				DeleteIconHTML: tmpDeleteIconHTML,
				FlowViewIdentifier: tmpFlowViewIdentifier
			});
		}

		let tmpListHTML = (tmpLayoutRecords.length === 0)
			? '<div class="pict-flow-popup-list-empty">No saved layouts</div>'
			: this.pict.parseTemplateByHash('Flow-Layout-List', { Rows: tmpLayoutRecords });

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-layout-save-section">'
			+ '<div id="' + tmpSaveRowID + '" class="pict-flow-popup-layout-save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._showLayoutSaveInput(\'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\', \'' + tmpSaveInputID + '\')">'
			+ '<span class="pict-flow-popup-layout-save-icon">' + tmpSaveIconHTML + '</span>'
			+ '<span>Save Current Layout</span>'
			+ '</div>'
			+ '<div id="' + tmpSaveInputRowID + '" class="pict-flow-popup-layout-save-input-row" style="display:none;">'
			+ '<input id="' + tmpSaveInputID + '" class="pict-flow-popup-layout-save-input" type="text" placeholder="Layout name..."'
			+ ' onclick="event.stopPropagation()"'
			+ ' onkeydown="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutSaveKey(event, \'' + tmpSaveInputID + '\', \'' + tmpSaveRowID + '\', \'' + tmpSaveInputRowID + '\')" />'
			+ '<button class="pict-flow-popup-layout-save-confirm" title="Save"'
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._confirmLayoutSave(\'' + tmpSaveInputID + '\')">'
			+ tmpSaveIconHTML + '</button>'
			+ '</div>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div id="' + tmpListID + '">' + tmpListHTML + '</div>');
	}

	/**
	 * Inline handler — reveal the layout-name input and focus it.
	 */
	_showLayoutSaveInput(pSaveRowID, pInputRowID, pInputID)
	{
		let tmpRow = document.getElementById(pSaveRowID);
		let tmpInputRow = document.getElementById(pInputRowID);
		let tmpInput = document.getElementById(pInputID);
		if (tmpRow) tmpRow.style.display = 'none';
		if (tmpInputRow) tmpInputRow.style.display = '';
		if (tmpInput)
		{
			tmpInput.value = '';
			setTimeout(() => { tmpInput.focus(); }, 50);
		}
	}

	/**
	 * Inline handler — Enter saves, Escape cancels.
	 */
	_handleLayoutSaveKey(pEvent, pInputID, pSaveRowID, pInputRowID)
	{
		if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			this._confirmLayoutSave(pInputID);
		}
		else if (pEvent.key === 'Escape')
		{
			let tmpRow = document.getElementById(pSaveRowID);
			let tmpInputRow = document.getElementById(pInputRowID);
			if (tmpInputRow) tmpInputRow.style.display = 'none';
			if (tmpRow) tmpRow.style.display = '';
		}
	}

	/**
	 * Inline handler — save the layout under the entered name and rebuild
	 * the popup so the new entry appears.
	 */
	_confirmLayoutSave(pInputID)
	{
		let tmpInput = document.getElementById(pInputID);
		if (!tmpInput) return;
		let tmpName = (tmpInput.value || '').trim();
		if (tmpName === '') return;
		this._FlowView._LayoutProvider.saveLayout(tmpName);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — restore layout when the row (not its delete button)
	 * is clicked.
	 */
	_restoreLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && pEvent.target && pEvent.target.closest('.pict-flow-popup-layout-delete')) return;
		this._FlowView._LayoutProvider.restoreLayout(pLayoutHash);
		this._closePopup();
	}

	/**
	 * Inline handler — delete a saved layout and refresh the popup.
	 */
	_deleteLayoutFromPopup(pLayoutHash, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function') pEvent.stopPropagation();
		this._FlowView._LayoutProvider.deleteLayout(pLayoutHash);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutPopup(tmpPopupEl);
	}

	// ── Layout Algorithm Popup ────────────────────────────────────────────

	/**
	 * Build the Layout Algorithm popup using templates with inline handlers.
	 * The popup has three logical sections (algorithm chooser, edge-theme
	 * chooser, auto-apply toggle + apply button). Each control's behavior
	 * lives on the toolbar as a helper method called from inline handlers.
	 *
	 * Iterations (algorithm options, edge themes) are template-driven via
	 * AppData arrays.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutAlgorithmPopup(pContainer)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpLayoutService = this._FlowView._LayoutService;
		let tmpCurrentSettings = this._FlowView.getLayoutAlgorithm();
		let tmpAlgoDescriptor = tmpLayoutService.getAlgorithm(tmpCurrentSettings.Algorithm);
		let tmpEdgeSettings = this._FlowView.getEdgeTheme();
		let tmpResolvedEdge = tmpEdgeSettings.Theme;
		let tmpExplicitEdgeOverride = tmpEdgeSettings.Override;
		let tmpDefaultThemeName = (tmpAlgoDescriptor && tmpAlgoDescriptor.DefaultEdgeTheme) || 'Bezier';
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		let tmpSettingsIconHTML = tmpIconProvider ? tmpIconProvider.getIconSVGMarkup('settings', 13) : '⚙';

		// Build option records for the dropdowns
		let tmpAlgoOptions = tmpLayoutService.listAlgorithms().map((pAlgo) => (
		{
			Value: pAlgo.Name,
			Label: pAlgo.Label || pAlgo.Name,
			SelectedAttr: (pAlgo.Name === tmpCurrentSettings.Algorithm) ? ' selected="selected"' : ''
		}));

		let tmpEdgeOptionRecords = [];
		tmpEdgeOptionRecords.push(
		{
			Value: '__inherit__',
			Label: `Inherit from layout (${tmpDefaultThemeName})`,
			SelectedAttr: !tmpExplicitEdgeOverride ? ' selected="selected"' : ''
		});
		let tmpEdgeThemes = tmpLayoutService.listEdgeThemes();
		for (let i = 0; i < tmpEdgeThemes.length; i++)
		{
			tmpEdgeOptionRecords.push(
			{
				Value: tmpEdgeThemes[i].Name,
				Label: tmpEdgeThemes[i].Label || tmpEdgeThemes[i].Name,
				SelectedAttr: (tmpEdgeThemes[i].Name === tmpExplicitEdgeOverride) ? ' selected="selected"' : ''
			});
		}

		let tmpAlgoOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpAlgoOptions });
		let tmpEdgeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpEdgeOptionRecords });

		let tmpHasParameters = !!(tmpAlgoDescriptor && (
			(tmpAlgoDescriptor.ParameterManifest && tmpAlgoDescriptor.ParameterManifest.Descriptors) ||
			(tmpAlgoDescriptor.ParameterSchema && Object.keys(tmpAlgoDescriptor.ParameterSchema).length > 0)
		));

		let tmpAlgoDescription = (tmpAlgoDescriptor && tmpAlgoDescriptor.Description)
			? '<div class="pict-flow-popup-control-description">' + tmpAlgoDescriptor.Description + '</div>'
			: '';

		let tmpFormToggleHTML = '';
		if (tmpHasParameters)
		{
			tmpFormToggleHTML = '<button type="button" class="pict-flow-popup-collapse-toggle"'
				+ ' aria-expanded="' + (this._LayoutFormExpanded ? 'true' : 'false') + '"'
				+ ' title="' + (this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters') + '"'
				+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._toggleLayoutFormCollapsed(this)">'
				+ tmpSettingsIconHTML
				+ '</button>';
		}

		let tmpAutoApplyID = `Flow-Toolbar-AutoApply-${tmpFlowViewIdentifier}`;
		let tmpApplyDisabled = (tmpCurrentSettings.Algorithm === 'Custom') ? ' disabled' : '';
		let tmpApplyTitle = (tmpCurrentSettings.Algorithm === 'Custom') ? ' title="Custom does not auto-position nodes"' : '';

		let tmpEdgeDescriptionHTML = '';
		if (tmpResolvedEdge)
		{
			let tmpResolvedDescriptor = tmpLayoutService.getEdgeTheme(tmpResolvedEdge);
			if (tmpResolvedDescriptor && tmpResolvedDescriptor.Description)
			{
				tmpEdgeDescriptionHTML = '<div class="pict-flow-popup-control-description">' + tmpResolvedDescriptor.Description + '</div>';
			}
		}

		// Place a host div for the parameter form; mount the form into it
		// after the popup is in the DOM (the metacontroller resolves
		// destinations via document.querySelector).
		let tmpParamFormHostID = `Flow-Toolbar-LayoutParamFormHost-${tmpFlowViewIdentifier}`;

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-settings-section pict-flow-popup-layout-algorithm-row">'
			+ '<label class="pict-flow-popup-settings-label">Algorithm</label>'
			+ '<div class="pict-flow-popup-layout-algorithm-controls">'
			+ '<select class="pict-flow-popup-settings-select pict-flow-popup-layout-algorithm-select" data-layout-control="algorithm"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleLayoutAlgoChange(this.value)">'
			+ tmpAlgoOptionsHTML
			+ '</select>'
			+ tmpFormToggleHTML
			+ '</div>'
			+ '</div>'
			+ tmpAlgoDescription
			+ '<div id="' + tmpParamFormHostID + '"></div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Edge theme</label>'
			+ '<select class="pict-flow-popup-settings-select" data-layout-control="edge-theme"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleEdgeThemeChange(this.value)">'
			+ tmpEdgeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ tmpEdgeDescriptionHTML
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="display:flex;align-items:center;gap:8px;">'
			+ '<input type="checkbox" id="' + tmpAutoApplyID + '"' + (tmpCurrentSettings.AutoApply ? ' checked="checked"' : '') + ''
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleAutoApplyChange(this.checked)" />'
			+ '<label class="pict-flow-popup-settings-label" for="' + tmpAutoApplyID + '" style="cursor:pointer;">Auto-apply on changes</label>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section" style="padding:4px 8px;">'
			+ '<button class="pict-flow-popup-layout-save-confirm" style="width:100%;padding:6px;"' + tmpApplyDisabled + tmpApplyTitle
			+ ' onclick="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleApplyLayoutNow()">Apply Now</button>'
			+ '</div>');

		// Mount the parameter form (handles its own DOM building /
		// metacontroller). Use pContainer.querySelector — the popup may
		// not be in the document yet, so document.getElementById would miss.
		let tmpFormHostEl = pContainer.querySelector('#' + tmpParamFormHostID);
		if (tmpFormHostEl)
		{
			this._buildLayoutParameterFormSection(tmpFormHostEl, tmpAlgoDescriptor, tmpCurrentSettings);
		}
	}

	/**
	 * Inline handler — switch layout algorithm, refresh popup.
	 */
	_handleLayoutAlgoChange(pName)
	{
		if (!this._FlowView || !this._FlowView._LayoutService) return;
		let tmpAlgo = this._FlowView._LayoutService.getAlgorithm(pName);
		let tmpDefaults = (tmpAlgo && tmpAlgo.DefaultParameters)
			? JSON.parse(JSON.stringify(tmpAlgo.DefaultParameters)) : {};
		this._FlowView.setLayoutAlgorithm(pName, tmpDefaults);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — switch edge theme, refresh popup so descriptions
	 * track the new theme.
	 */
	_handleEdgeThemeChange(pValue)
	{
		if (!this._FlowView) return;
		if (pValue === '__inherit__')
		{
			this._FlowView.setEdgeTheme(null);
		}
		else
		{
			this._FlowView.setEdgeTheme(pValue);
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._buildLayoutAlgorithmPopup(tmpPopupEl);
	}

	/**
	 * Inline handler — toggle auto-apply.
	 */
	_handleAutoApplyChange(pChecked)
	{
		if (!this._FlowView) return;
		this._FlowView.setLayoutAutoApply(pChecked);
	}

	/**
	 * Inline handler — fire the layout (when not Custom).
	 */
	_handleApplyLayoutNow()
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		if (tmpSettings.Algorithm === 'Custom') return;
		this._FlowView.applyCurrentLayout();
	}

	/**
	 * Inline handler — toggle the parameter-form collapse state.
	 */
	_toggleLayoutFormCollapsed(pToggleButton)
	{
		this._LayoutFormExpanded = !this._LayoutFormExpanded;
		pToggleButton.setAttribute('aria-expanded', this._LayoutFormExpanded ? 'true' : 'false');
		pToggleButton.title = this._LayoutFormExpanded ? 'Hide parameters' : 'Show parameters';
		let tmpHost = this._LayoutFormHostID ? document.getElementById(this._LayoutFormHostID) : null;
		if (tmpHost)
		{
			tmpHost.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		}
	}

	/**
	 * Render the parameter form section. When the host app has registered
	 * `PictFormMetacontroller` and the algorithm provides a
	 * `ParameterManifest`, we inject that manifest into a section-form so
	 * the user gets the same Manyfest-driven UX as the rest of the Pict
	 * ecosystem. Otherwise we fall back to schema-driven hand-rolled inputs.
	 *
	 * Data binding: `pict.AppData.PictFlowLayoutEditor.Parameters` is a
	 * mirror of `_FlowData.LayoutParameters`. The form's Informary writes
	 * directly into AppData; a `change`/`input` listener on the popup
	 * pushes those edits back into `_FlowData.LayoutParameters` and (when
	 * the active algorithm is non-Custom) re-applies the layout.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor - the descriptor for the active algorithm
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 */
	_buildLayoutParameterFormSection(pContainer, pAlgoDescriptor, pCurrentSettings)
	{
		if (!pAlgoDescriptor) return;

		let tmpHasManifest = !!(pAlgoDescriptor.ParameterManifest && pAlgoDescriptor.ParameterManifest.Descriptors);
		let tmpMetacontrollerType = this._resolveMetacontrollerServiceType();

		if (tmpHasManifest && tmpMetacontrollerType)
		{
			this._mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, tmpMetacontrollerType);
			return;
		}

		// Fallback path — schema-driven hand-rolled inputs.
		let tmpSchema = (pAlgoDescriptor.ParameterSchema) ? pAlgoDescriptor.ParameterSchema : {};
		let tmpParamKeys = Object.keys(tmpSchema);
		if (tmpParamKeys.length === 0) return;

		let tmpParamDivider = document.createElement('div');
		tmpParamDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpParamDivider);

		let tmpParamHeader = document.createElement('div');
		tmpParamHeader.className = 'pict-flow-popup-settings-label';
		tmpParamHeader.style.fontWeight = 'bold';
		tmpParamHeader.style.padding = '4px 8px';
		tmpParamHeader.textContent = 'Parameters';
		pContainer.appendChild(tmpParamHeader);

		for (let i = 0; i < tmpParamKeys.length; i++)
		{
			let tmpKey = tmpParamKeys[i];
			let tmpFieldSchema = tmpSchema[tmpKey];
			let tmpCurrentValue = (pCurrentSettings.Parameters && pCurrentSettings.Parameters.hasOwnProperty(tmpKey))
				? pCurrentSettings.Parameters[tmpKey]
				: tmpFieldSchema.Default;

			let tmpRow = document.createElement('div');
			tmpRow.className = 'pict-flow-popup-settings-section';
			tmpRow.style.display = 'flex';
			tmpRow.style.alignItems = 'center';
			tmpRow.style.gap = '8px';

			let tmpRowLabel = document.createElement('label');
			tmpRowLabel.className = 'pict-flow-popup-settings-label';
			tmpRowLabel.textContent = tmpFieldSchema.Label || tmpKey;
			tmpRowLabel.style.flex = '1';
			tmpRow.appendChild(tmpRowLabel);

			let tmpInput = this._buildLayoutParamInput(tmpKey, tmpFieldSchema, tmpCurrentValue);
			tmpRow.appendChild(tmpInput);
			pContainer.appendChild(tmpRow);
		}
	}

	/**
	 * Remove `PictSectionForm-*` views the layout-algorithm popup has
	 * previously registered on the host Pict. Without this, switching
	 * algorithms accumulates dead section views — the metatemplate
	 * generated by the next inject would still reference the old ones.
	 * Idempotent.
	 */
	_evictLayoutFormViews()
	{
		if (!this.pict || !this.pict.views) return;
		let tmpKeys = Object.keys(this.pict.views);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			if (tmpKey.indexOf('PictSectionForm-') === 0 && tmpKey.indexOf('PictFlowLayout') > 0)
			{
				delete this.pict.views[tmpKey];
				continue;
			}
			// Match any previously-injected layout-algorithm section by hash
			// suffix (manifests use unique algorithm-suffixed section names).
			if (tmpKey.indexOf('PictSectionForm-PFL') === 0)
			{
				delete this.pict.views[tmpKey];
			}
		}
		this._LayoutFormMetacontroller = null;
	}

	/**
	 * Look up which form-metacontroller service is registered on the host
	 * Pict instance. pict-section-form has been published under both
	 * 'PictFormMetacontroller' and (older) 'PictViewFormMetacontroller'
	 * names; check both, in that order.
	 * @returns {string|null}
	 */
	_resolveMetacontrollerServiceType()
	{
		if (!this.fable || !this.fable.servicesMap) return null;
		if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))     return 'PictFormMetacontroller';
		if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller')) return 'PictViewFormMetacontroller';
		return null;
	}

	/**
	 * Build the parameter form section using a pict-section-form
	 * metacontroller. Creates a host div, binds the active layout
	 * parameters to `pict.AppData.PictFlowLayoutEditor.Parameters`, and
	 * injects the algorithm's `ParameterManifest`. Form-input changes
	 * propagate back to `_FlowData.LayoutParameters` via a single
	 * `change`/`input` listener on the popup container.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {Object} pAlgoDescriptor
	 * @param {{ Algorithm: string, Parameters: Object }} pCurrentSettings
	 * @param {string} pMetacontrollerType - 'PictFormMetacontroller' or 'PictViewFormMetacontroller'
	 */
	_mountLayoutParameterMetacontroller(pContainer, pAlgoDescriptor, pCurrentSettings, pMetacontrollerType)
	{
		let tmpManifest = JSON.parse(JSON.stringify(pAlgoDescriptor.ParameterManifest));
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Section header + divider
		let tmpDivider = document.createElement('div');
		tmpDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpDivider);

		// Form host div — the metacontroller renders into here. Inline
		// onclick stops popup-close propagation; onchange/oninput drive the
		// _FlowData.LayoutParameters writeback (see _pushFormBack).
		let tmpHostID = `Flow-Toolbar-LayoutForm-${tmpFlowViewIdentifier}`;
		this._LayoutFormHostID = tmpHostID;

		let tmpHostDiv = document.createElement('div');
		tmpHostDiv.id = tmpHostID;
		tmpHostDiv.className = 'pict-flow-popup-layout-form-host';
		tmpHostDiv.setAttribute('data-collapsed', this._LayoutFormExpanded ? 'false' : 'true');
		tmpHostDiv.setAttribute('onclick', 'event.stopPropagation()');
		tmpHostDiv.setAttribute('onchange',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		tmpHostDiv.setAttribute('oninput',
			"_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView._pushLayoutFormBack('" + pCurrentSettings.Algorithm + "')");
		pContainer.appendChild(tmpHostDiv);

		// Bind the layout parameters as the data source for the form.
		// `injectManifestAndRender(manifest, _, UUID)` calls
		// `createDistinctManifest` which prepends the UUID to every descriptor
		// address (so re-injecting the same manifest doesn't collide). We use
		// the algorithm name as the UUID, so the form's expected address is
		// `AppData.<Algorithm>.PictFlowLayoutEditor.Parameters.<Key>` —
		// bind there, not at the unprefixed root.
		let tmpScope = pCurrentSettings.Algorithm;
		this.pict.AppData[tmpScope] = this.pict.AppData[tmpScope] || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor = this.pict.AppData[tmpScope].PictFlowLayoutEditor || {};
		this.pict.AppData[tmpScope].PictFlowLayoutEditor.Parameters = JSON.parse(JSON.stringify(pCurrentSettings.Parameters || {}));

		// Always recreate the metacontroller per mount. Reusing the same
		// metacontroller across algorithm switches accumulates section views
		// (each switch's manifest gets injected onto the existing roster) and
		// the metatemplate ends up wedging multiple sections into a single
		// shared destination — only the last one survives. Fresh instance per
		// mount keeps the DOM consistent; we also evict the prior
		// `PictSectionForm-*` views from `pict.views` so they GC cleanly.
		this._evictLayoutFormViews();
		try
		{
			this._LayoutFormMetacontroller = this.fable.instantiateServiceProviderWithoutRegistration(
				pMetacontrollerType,
				{
					ViewIdentifier: `Flow-Toolbar-LayoutForm-MC-${tmpFlowViewIdentifier}-${this.fable.getUUID()}`,
					DefaultDestinationAddress: `#${tmpHostID}`,
					AutoRender: false,
					AutoPopulateAfterRender: true,
					AutoSolveBeforeRender: false
				});
		}
		catch (pError)
		{
			this.log.warn(`Failed to instantiate ${pMetacontrollerType}: ${pError.message}`);
			this._LayoutFormMetacontroller = null;
		}

		if (!this._LayoutFormMetacontroller)
		{
			tmpHostDiv.innerHTML = '<em style="padding:8px;display:block;opacity:0.7;">pict-section-form not available; parameter form skipped.</em>';
			return;
		}

		// Establish the form-container div the metacontroller expects.
		let tmpFormContainerID = `Pict-${this._LayoutFormMetacontroller.UUID}-FormContainer`;
		tmpHostDiv.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form pict-flow-popup-layout-form"></div>`;

		try
		{
			// Use `injectManifest` + explicit per-section destination divs +
			// per-section render. Don't use `injectManifestAndRender` —
			// its metatemplate flow ends up wedging multi-section manifests
			// into a single shared destination (each section's render call
			// uses RenderMethod=replace, blowing the others away). The
			// explicit path gives each section its own destination div and
			// renders them independently.
			let tmpInjectFn = (typeof this._LayoutFormMetacontroller.injectManifest === 'function')
				? this._LayoutFormMetacontroller.injectManifest.bind(this._LayoutFormMetacontroller)
				: null;
			if (!tmpInjectFn) throw new Error('Metacontroller exposes neither injectManifest nor injectManifestAndRender');

			// Pass the algorithm name as the section-hash discriminator so
			// re-injecting the same algorithm gets unique view registrations.
			// (createDistinctManifest does the address-prefixing too — see
			// the per-algorithm AppData binding above.)
			let tmpDistinct = (typeof this._LayoutFormMetacontroller.createDistinctManifest === 'function')
				? this._LayoutFormMetacontroller.createDistinctManifest(tmpManifest, pCurrentSettings.Algorithm)
				: tmpManifest;

			let tmpViews = tmpInjectFn(tmpDistinct);

			// Build a destination div per section view, in order, and render each.
			let tmpFormContainerEl = tmpHostDiv.querySelector(`#${tmpFormContainerID}`);
			if (tmpFormContainerEl)
			{
				let tmpInner = '';
				for (let i = 0; i < tmpViews.length; i++)
				{
					let tmpDest = tmpViews[i].options.DefaultDestinationAddress;
					if (tmpDest && tmpDest.charAt(0) === '#') tmpDest = tmpDest.substring(1);
					tmpInner += `<div id="${tmpDest}" class="pict-form-view"></div>`;
				}
				tmpFormContainerEl.innerHTML = tmpInner;
			}
			// Defer render() to the next microtask so the popup has been
			// appended to the DOM by `_openPopup` — pict-section-form
			// resolves destinations via `document.querySelector`, which
			// can't see detached subtrees. (Same workaround the
			// metacontroller's own `injectManifestAndRender` uses.)
			setTimeout(() =>
			{
				for (let i = 0; i < tmpViews.length; i++)
				{
					tmpViews[i].render();
					if (typeof tmpViews[i].marshalToView === 'function')
					{
						tmpViews[i].marshalToView();
					}
				}
			}, 0);
		}
		catch (pError)
		{
			this.log.warn(`PictViewFlowToolbar: layout-form injection failed: ${pError.message}`);
			tmpHostDiv.innerHTML = `<em style="padding:8px;display:block;opacity:0.7;">Form render error: ${pError.message}</em>`;
			return;
		}

		// Form-change writeback runs through the host div's inline
		// onchange/oninput attributes (set above), which call
		// `_pushLayoutFormBack(algorithm)`.
	}

	/**
	 * Inline handler for layout-parameter form changes. Pushes Informary's
	 * write into AppData back into `_FlowData.LayoutParameters` and
	 * re-applies the layout (when non-Custom). De-bounces via microtask so
	 * multi-key edits collapse to a single layout pass.
	 *
	 * @param {string} pAlgorithm
	 */
	_pushLayoutFormBack(pAlgorithm)
	{
		if (this._LayoutFormPushScheduled) return;
		this._LayoutFormPushScheduled = true;
		Promise.resolve().then(() =>
		{
			this._LayoutFormPushScheduled = false;
			if (!this._FlowView) return;
			let tmpScopedRoot = this.pict.AppData[pAlgorithm] || {};
			let tmpEditorParams = (tmpScopedRoot.PictFlowLayoutEditor || {}).Parameters || {};
			let tmpMerged = Object.assign({}, this._FlowView.getLayoutAlgorithm().Parameters || {}, tmpEditorParams);
			this._FlowView.setLayoutAlgorithm(pAlgorithm, tmpMerged);
		});
	}

	/**
	 * Build a single parameter input row for the layout-algorithm popup.
	 * Wires the input's change handler to update the flow's
	 * `LayoutParameters` and re-apply the layout if non-Custom.
	 *
	 * @param {string} pKey
	 * @param {Object} pSchema - { Type: 'number' | 'string' | 'boolean' | 'enum', Default, Options? }
	 * @param {*} pCurrentValue
	 * @returns {HTMLElement}
	 */
	_buildLayoutParamInput(pKey, pSchema, pCurrentValue)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpViewPath = "_Pict.views['" + tmpFlowViewIdentifier + "']._ToolbarView";
		let tmpKeyEsc = pKey.replace(/'/g, "\\'");
		let tmpInput;

		if (pSchema.Type === 'boolean')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'checkbox';
			tmpInput.checked = !!pCurrentValue;
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.checked)");
		}
		else if (pSchema.Type === 'enum' && Array.isArray(pSchema.Options))
		{
			tmpInput = document.createElement('select');
			tmpInput.className = 'pict-flow-popup-settings-select';
			for (let i = 0; i < pSchema.Options.length; i++)
			{
				let tmpOpt = document.createElement('option');
				tmpOpt.value = pSchema.Options[i];
				tmpOpt.textContent = pSchema.Options[i];
				if (pSchema.Options[i] === pCurrentValue) tmpOpt.selected = true;
				tmpInput.appendChild(tmpOpt);
			}
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}
		else if (pSchema.Type === 'number' || pSchema.Type === 'Number' || pSchema.Type === 'PreciseNumber')
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'number';
			tmpInput.className = 'pict-flow-popup-settings-input';
			let tmpIsPrecise = (pSchema.Type === 'PreciseNumber');
			if (typeof pSchema.Min === 'number') tmpInput.min = String(pSchema.Min);
			if (typeof pSchema.Max === 'number') tmpInput.max = String(pSchema.Max);
			tmpInput.step = tmpIsPrecise ? 'any' : '1';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			let tmpPreciseFlag = tmpIsPrecise ? 'true' : 'false';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutNumberParameter('" + tmpKeyEsc + "', this.value, " + tmpPreciseFlag + ")");
		}
		else
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'text';
			tmpInput.className = 'pict-flow-popup-settings-input';
			tmpInput.value = (pCurrentValue == null) ? '' : String(pCurrentValue);
			tmpInput.style.width = '90px';
			tmpInput.setAttribute('onchange',
				tmpViewPath + "._updateLayoutParameter('" + tmpKeyEsc + "', this.value)");
		}

		tmpInput.setAttribute('onclick', 'event.stopPropagation()');
		return tmpInput;
	}

	/**
	 * Update a single layout parameter on the flow and re-apply the layout
	 * if the configured algorithm is not 'Custom'.
	 * @param {string} pKey
	 * @param {*} pValue
	 */
	_updateLayoutParameter(pKey, pValue)
	{
		if (!this._FlowView) return;
		let tmpSettings = this._FlowView.getLayoutAlgorithm();
		let tmpParams = Object.assign({}, tmpSettings.Parameters || {});
		tmpParams[pKey] = pValue;
		this._FlowView.setLayoutAlgorithm(tmpSettings.Algorithm, tmpParams);
	}

	/**
	 * Inline-handler helper for numeric parameter inputs. Preserves the
	 * raw string when PreciseNumber so big.js / ExpressionParser can use
	 * it without float round-trip drift.
	 *
	 * @param {string} pKey
	 * @param {string} pRawValue
	 * @param {boolean} pIsPrecise
	 */
	_updateLayoutNumberParameter(pKey, pRawValue, pIsPrecise)
	{
		if (pRawValue === '') return;
		if (pIsPrecise)
		{
			this._updateLayoutParameter(pKey, pRawValue);
			return;
		}
		let tmpNum = parseFloat(pRawValue);
		if (isNaN(tmpNum)) return;
		this._updateLayoutParameter(pKey, tmpNum);
	}

	// ── Settings Popup ───────────────────────────────────────────────────

	/**
	 * Build the Settings popup using a template with inline handlers.
	 *
	 * Theme options are iterated via `{~TS:~}` from AppData. Sliders and
	 * selects fire inline handlers that update the FlowView's theme state.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_buildSettingsPopup(pContainer)
	{
		if (!this._FlowView || !this._FlowView._ThemeProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpThemeProvider = this._FlowView._ThemeProvider;
		let tmpThemeKeys = tmpThemeProvider.getThemeKeys();
		let tmpActiveKey = tmpThemeProvider.getActiveThemeKey();

		let tmpThemeOptions = [];
		for (let i = 0; i < tmpThemeKeys.length; i++)
		{
			let tmpTheme = tmpThemeProvider._Themes[tmpThemeKeys[i]];
			tmpThemeOptions.push(
			{
				Value: tmpThemeKeys[i],
				Label: tmpTheme.Label || tmpThemeKeys[i],
				SelectedAttr: (tmpThemeKeys[i] === tmpActiveKey) ? ' selected="selected"' : ''
			});
		}

		let tmpThemeOptionsHTML = this.pict.parseTemplateByHash('Flow-Layout-OptionList', { Options: tmpThemeOptions });

		let tmpNoiseLevel = Math.round(tmpThemeProvider.getNoiseLevel() * 100);
		let tmpActiveTheme = tmpThemeProvider.getActiveTheme();
		let tmpNoiseEnabled = !!(tmpActiveTheme && tmpActiveTheme.NoiseConfig && tmpActiveTheme.NoiseConfig.Enabled);
		let tmpNoiseDisplay = tmpNoiseEnabled ? '' : 'display:none;';

		this.pict.ContentAssignment.assignContent(pContainer,
			'<div class="pict-flow-popup-settings-section">'
			+ '<label class="pict-flow-popup-settings-label">Theme</label>'
			+ '<select class="pict-flow-popup-settings-select"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onchange="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleThemeSelectChange(this.value)">'
			+ tmpThemeOptionsHTML
			+ '</select>'
			+ '</div>'
			+ '<div class="pict-flow-popup-divider"></div>'
			+ '<div class="pict-flow-popup-settings-section pict-flow-popup-settings-noise" data-settings-type="noise" style="' + tmpNoiseDisplay + '">'
			+ '<label class="pict-flow-popup-settings-label">Noise</label>'
			+ '<div class="pict-flow-popup-settings-slider-row">'
			+ '<input type="range" class="pict-flow-popup-settings-slider" min="0" max="100" value="' + tmpNoiseLevel + '"'
			+ ' onclick="event.stopPropagation()"'
			+ ' onpointerdown="event.stopPropagation()"'
			+ ' oninput="_Pict.views[\'' + tmpFlowViewIdentifier + '\']._ToolbarView._handleNoiseSliderInput(this)" />'
			+ '<span class="pict-flow-popup-settings-slider-value">' + tmpNoiseLevel + '%</span>'
			+ '</div>'
			+ '</div>');
	}

	/**
	 * Inline handler — apply selected flow theme and refresh the noise
	 * slider visibility (some themes don't expose noise).
	 */
	_handleThemeSelectChange(pThemeKey)
	{
		if (!this._FlowView) return;
		this._FlowView.setTheme(pThemeKey);

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopupEl = document.getElementById(`Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopupEl) this._refreshNoiseSlider(tmpPopupEl);
	}

	/**
	 * Inline handler — push slider position into the noise level and
	 * update the percentage label adjacent to it.
	 */
	_handleNoiseSliderInput(pSlider)
	{
		let tmpRaw = parseInt(pSlider.value, 10);
		if (isNaN(tmpRaw)) return;
		let tmpLevel = tmpRaw / 100;
		let tmpValueLabel = pSlider.parentNode ? pSlider.parentNode.querySelector('.pict-flow-popup-settings-slider-value') : null;
		if (tmpValueLabel) tmpValueLabel.textContent = tmpRaw + '%';
		if (this._FlowView) this._FlowView.setNoiseLevel(tmpLevel);
	}

	/**
	 * Show or hide the noise slider based on whether the active theme supports noise.
	 * @param {HTMLElement} pContainer - The settings popup container
	 */
	_refreshNoiseSlider(pContainer)
	{
		let tmpNoiseSection = pContainer.querySelector('[data-settings-type="noise"]');
		if (!tmpNoiseSection) return;

		let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
		if (tmpTheme && tmpTheme.NoiseConfig && tmpTheme.NoiseConfig.Enabled)
		{
			tmpNoiseSection.style.display = '';
			// Update slider value to reflect theme default
			let tmpSlider = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider');
			let tmpValueLabel = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider-value');
			if (tmpSlider)
			{
				let tmpLevel = Math.round(this._FlowView._ThemeProvider.getNoiseLevel() * 100);
				tmpSlider.value = String(tmpLevel);
				if (tmpValueLabel) tmpValueLabel.textContent = tmpLevel + '%';
			}
		}
		else
		{
			tmpNoiseSection.style.display = 'none';
		}
	}

	// ── Toolbar Mode Switching ────────────────────────────────────────────

	/**
	 * Switch between docked, floating, and collapsed modes.
	 * @param {string} pMode - 'docked' | 'floating' | 'collapsed'
	 */
	_setToolbarMode(pMode)
	{
		// Close any active popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpBar = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Bar-${tmpFlowViewIdentifier}`);
		let tmpCollapsed = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Collapsed-${tmpFlowViewIdentifier}`);

		switch (pMode)
		{
			case 'docked':
				// Show toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = '';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;

			case 'floating':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Show floating toolbar
				this._showFloatingToolbar();
				break;

			case 'collapsed':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Show collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.add('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;
		}

		this._ToolbarMode = pMode;
	}

	/**
	 * Lazily create and show the floating toolbar.
	 */
	_showFloatingToolbar()
	{
		if (!this._FlowView) return;

		if (!this._FloatingToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			this._FloatingToolbarView = this.fable.instantiateServiceProviderWithoutRegistration(
				'PictViewFlowFloatingToolbar',
				{
					FlowViewIdentifier: tmpFlowViewIdentifier,
					DefaultDestinationAddress: `#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`,
					EnableAddNode: this.options.EnableAddNode,
					EnableCardPalette: this.options.EnableCardPalette
				}
			);
			this._FloatingToolbarView._ToolbarView = this;
			this._FloatingToolbarView._FlowView = this._FlowView;
			this._FloatingToolbarView.render();
		}

		this._FloatingToolbarView.show();
	}

	// ── Node Placement Helpers ────────────────────────────────────────────

	/**
	 * Add a node at the center of the visible viewport.
	 * @param {string} pNodeType - The node type hash
	 */
	_addNodeAtCenter(pNodeType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;

		// Calculate the center of the visible SVG area
		let tmpSVGContainer = this._FlowView._SVGElement;
		let tmpWidth = tmpSVGContainer ? tmpSVGContainer.clientWidth : 600;
		let tmpHeight = tmpSVGContainer ? tmpSVGContainer.clientHeight : 400;

		let tmpCenterX = (-tmpVS.PanX + tmpWidth / 2) / tmpVS.Zoom;
		let tmpCenterY = (-tmpVS.PanY + tmpHeight / 2) / tmpVS.Zoom;

		// Slight offset to avoid stacking
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpCenterX += (tmpNodeCount % 5) * 30;
		tmpCenterY += (tmpNodeCount % 5) * 30;

		this._FlowView.addNode(pNodeType, tmpCenterX, tmpCenterY);
	}

	/**
	 * Add a node from a palette card click.
	 * @param {string} pCardType - The card type hash
	 */
	_addCardFromPalette(pCardType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;
		let tmpX = (-tmpVS.PanX + 200) / tmpVS.Zoom;
		let tmpY = (-tmpVS.PanY + 200) / tmpVS.Zoom;

		// Offset to avoid overlap
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpX += (tmpNodeCount % 5) * 40;
		tmpY += (tmpNodeCount % 5) * 40;

		this._FlowView.addNode(pCardType, tmpX, tmpY);
	}

	// ── Action Handler ────────────────────────────────────────────────────

	/**
	 * Handle a toolbar action
	 * @param {string} pAction
	 */
	_handleToolbarAction(pAction)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		switch (pAction)
		{
			case 'add-node':
				this._openPopup('add-node');
				break;

			case 'delete-selected':
				this._FlowView.deleteSelected();
				break;

			case 'zoom-in':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom + this._FlowView.options.ZoomStep);
				break;

			case 'zoom-out':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom - this._FlowView.options.ZoomStep);
				break;

			case 'zoom-fit':
				this._FlowView.zoomToFit();
				break;

			case 'auto-layout':
				// Legacy alias kept for backward compatibility with any
				// caller still firing 'auto-layout'. The toolbar's "Auto"
				// button now uses 'apply-current-layout' (below).
				this._FlowView.autoLayout();
				break;

			case 'apply-current-layout':
				// Respects whichever algorithm is configured in the
				// Algorithm popup. Falls back to Layered when the
				// configured value is 'Custom' or unset (autoLayout's
				// existing behavior — "do something useful").
				this._FlowView.autoLayout();
				break;

			case 'cards-popup':
				this._openPopup('cards');
				break;

			case 'layout-popup':
				this._openPopup('layout');
				break;

			case 'layout-algorithm-popup':
				this._openPopup('layout-algorithm');
				break;

			case 'apply-layout':
				this._FlowView.applyCurrentLayout();
				break;

			case 'settings-popup':
				this._openPopup('settings');
				break;

			case 'toggle-floating':
				if (this._ToolbarMode === 'floating')
				{
					this._setToolbarMode('docked');
				}
				else
				{
					this._setToolbarMode('floating');
				}
				break;

			case 'collapse-toolbar':
				this._setToolbarMode('collapsed');
				break;

			case 'expand-toolbar':
				this._setToolbarMode('docked');
				break;

			case 'fullscreen':
				{
					let tmpIsFullscreen = this._FlowView.toggleFullscreen();
					let tmpIconProvider = this._FlowView._IconProvider;
					let tmpIconElements = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
					if (tmpIconElements.length > 0 && tmpIconProvider)
					{
						tmpIconElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(
							tmpIsFullscreen ? 'exit-fullscreen' : 'fullscreen', 14);
					}
					let tmpFullscreenBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpFullscreenBtn.length > 0)
					{
						tmpFullscreenBtn[0].setAttribute('title', tmpIsFullscreen ? 'Exit Fullscreen' : 'Toggle Fullscreen');
					}
				}
				break;

			default:
				this.log.warn(`PictViewFlowToolbar: unknown action '${pAction}'`);
				break;
		}
	}
}

module.exports = PictViewFlowToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":137}],66:[function(require,module,exports){
const libPictView = require('pict-view');

const libPictServiceFlowInteractionManager = require('../services/PictService-Flow-InteractionManager.js');
const libPictServiceFlowConnectionRenderer = require('../services/PictService-Flow-ConnectionRenderer.js');
const libPictServiceFlowTether = require('../services/PictService-Flow-Tether.js');
const libPictServiceFlowLayout = require('../services/PictService-Flow-Layout.js');
const libPictServiceFlowPathGenerator = require('../services/PictService-Flow-PathGenerator.js');
const libPictServiceFlowViewportManager = require('../services/PictService-Flow-ViewportManager.js');
const libPictServiceFlowSelectionManager = require('../services/PictService-Flow-SelectionManager.js');
const libPictServiceFlowPanelManager = require('../services/PictService-Flow-PanelManager.js');
const libPictServiceFlowDataManager = require('../services/PictService-Flow-DataManager.js');
const libPictServiceFlowConnectionHandleManager = require('../services/PictService-Flow-ConnectionHandleManager.js');
const libPictServiceFlowRenderManager = require('../services/PictService-Flow-RenderManager.js');
const libPictServiceFlowPortRenderer = require('../services/PictService-Flow-PortRenderer.js');

const libPictProviderFlowNodeTypes = require('../providers/PictProvider-Flow-NodeTypes.js');
const libPictProviderFlowEventHandler = require('../providers/PictProvider-Flow-EventHandler.js');
const libPictProviderFlowLayouts = require('../providers/PictProvider-Flow-Layouts.js');
const libPictProviderFlowSVGHelpers = require('../providers/PictProvider-Flow-SVGHelpers.js');
const libPictProviderFlowGeometry = require('../providers/PictProvider-Flow-Geometry.js');
const libPictProviderFlowPanelChrome = require('../providers/PictProvider-Flow-PanelChrome.js');
const libPictProviderFlowCSS = require('../providers/PictProvider-Flow-CSS.js');
const libPictProviderFlowIcons = require('../providers/PictProvider-Flow-Icons.js');
const libPictProviderFlowConnectorShapes = require('../providers/PictProvider-Flow-ConnectorShapes.js');
const libPictProviderFlowTheme = require('../providers/PictProvider-Flow-Theme.js');
const libPictProviderFlowNoise = require('../providers/PictProvider-Flow-Noise.js');

const libPictViewFlowNode = require('./PictView-Flow-Node.js');
const libPictViewFlowToolbar = require('./PictView-Flow-Toolbar.js');
const libPictViewFlowFloatingToolbar = require('./PictView-Flow-FloatingToolbar.js');
const libPictViewFlowPropertiesPanel = require('./PictView-Flow-PropertiesPanel.js');

const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');
const libPanelTemplate = require('../panels/FlowCardPropertiesPanel-Template.js');
const libPanelMarkdown = require('../panels/FlowCardPropertiesPanel-Markdown.js');
const libPanelForm = require('../panels/FlowCardPropertiesPanel-Form.js');
const libPanelView = require('../panels/FlowCardPropertiesPanel-View.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Pict-Flow',

	DefaultRenderable: 'Flow-Container',
	DefaultDestinationAddress: '#Flow-Container',

	AutoRender: false,

	FlowDataAddress: false,

	TargetElementAddress: '#Flow-SVG-Container',

	EnableToolbar: true,
	EnableAddNode: true,
	EnableCardPalette: true,
	IncludeDefaultNodeTypes: true,
	EnablePanning: true,
	EnableZooming: true,
	EnableNodeDragging: true,
	EnableConnectionCreation: true,
	EnableGridSnap: false,
	GridSnapSize: 20,
	EnableLayoutMenu: true,

	MinZoom: 0.1,
	MaxZoom: 5.0,
	ZoomStep: 0.1,

	DefaultNodeType: 'default',
	DefaultNodeWidth: 180,
	DefaultNodeHeight: 80,

	// Layout-algorithm subsystem defaults
	DefaultLayoutAlgorithm: 'Custom',
	DefaultLayoutParameters: {},
	DefaultLayoutAutoApply: false,

	// Edge-theme subsystem defaults — null = inherit from active layout's
	// `DefaultEdgeTheme` field, with hard fallback to 'Bezier'.
	DefaultEdgeTheme: null,
	DefaultEdgeThemeParameters: {},

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-PanelChrome-Template',
			Template: /*html*/`<div class="pict-flow-panel" xmlns="http://www.w3.org/1999/xhtml"><div class="pict-flow-panel-titlebar" data-element-type="panel-titlebar" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-title-text">{~D:Record.Title~}</span><span class="pict-flow-panel-close-btn" data-element-type="panel-close" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-close-icon"></span></span></div><div class="pict-flow-panel-content" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab-pane active" data-tab="properties" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tab-pane" data-tab="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div><div class="pict-flow-panel-tab-pane" data-tab="appearance" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div></div><div class="pict-flow-panel-resize-handle" data-element-type="panel-resize" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tabbar" data-panel-hash="{~D:Record.Hash~}" onpointerdown="event.stopPropagation()" onwheel="event.stopPropagation()"><div class="pict-flow-panel-tab active" data-tab-target="properties" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Properties</div><div class="pict-flow-panel-tab" data-tab-target="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Help</div><div class="pict-flow-panel-tab" data-tab-target="appearance" data-panel-hash="{~D:Record.Hash~}" onclick="_Pict.views['{~D:Record.FlowViewIdentifier~}']._handlePanelTabClick(this, event)">Appearance</div></div></div>`
		},
		{
			Hash: 'Flow-Container-Template',
			// Inline pointer/wheel/contextmenu handlers route to the
			// InteractionManager via the FlowView. Keyboard events stay
			// document-level (no element-level inline equivalent).
			Template: /*html*/`
<div class="pict-flow-container" id="Flow-Wrapper-{~D:Record.ViewIdentifier~}">
	<div id="Flow-Toolbar-{~D:Record.ViewIdentifier~}"></div>
	<div id="Flow-FloatingToolbar-Container-{~D:Record.ViewIdentifier~}" style="display:none;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:100;"></div>
	<div class="pict-flow-svg-container" id="Flow-SVG-Container-{~D:Record.ViewIdentifier~}">
		<svg class="pict-flow-svg"
			id="Flow-SVG-{~D:Record.ViewIdentifier~}"
			xmlns="http://www.w3.org/2000/svg"
			onpointerdown="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerDown(event)"
			onpointermove="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerMove(event)"
			onpointerup="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onpointerleave="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGPointerUp(event)"
			onwheel="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGWheel(event)"
			oncontextmenu="_Pict.views['{~D:Record.ViewIdentifier~}']._handleSVGContextMenu(event)">
			<defs>
				<pattern id="flow-grid-{~D:Record.ViewIdentifier~}"
					width="20" height="20" patternUnits="userSpaceOnUse">
					<line x1="20" y1="0" x2="20" y2="20" class="pict-flow-grid-pattern" />
					<line x1="0" y1="20" x2="20" y2="20" class="pict-flow-grid-pattern" />
				</pattern>
			</defs>
			<rect width="10000" height="10000" x="-5000" y="-5000"
				fill="url(#flow-grid-{~D:Record.ViewIdentifier~})"
				class="pict-flow-grid-background" />
			<g class="pict-flow-viewport" id="Flow-Viewport-{~D:Record.ViewIdentifier~}">
				<g class="pict-flow-connections-layer" id="Flow-Connections-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-nodes-layer" id="Flow-Nodes-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-endpoints-layer" id="Flow-Endpoints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-port-hints-layer" id="Flow-PortHints-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-tethers-layer" id="Flow-Tethers-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-panels-layer" id="Flow-Panels-{~D:Record.ViewIdentifier~}"></g>
			</g>
		</svg>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Container',
			TemplateHash: 'Flow-Container-Template',
			DestinationAddress: '#Flow-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlow extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictSectionFlow';

		// ---- Declarative service registry ----
		// Each entry defines a service to register, instantiate, and guard.
		// Optional flags:
		//   NoFlowView  — instantiate without { FlowView: this }
		//   PostInit    — method name to call on the instance after creation
		//   RegisterOnly — only register the type; do not bulk-instantiate
		this._ServiceRegistry =
		[
			// Providers (stateless or config-only — no FlowView needed)
			{ ServiceType: 'PictProviderFlowSVGHelpers',   Library: libPictProviderFlowSVGHelpers,   Property: '_SVGHelperProvider',    NoFlowView: true },
			{ ServiceType: 'PictProviderFlowGeometry',      Library: libPictProviderFlowGeometry,      Property: '_GeometryProvider',     NoFlowView: true },
			{ ServiceType: 'PictProviderFlowNoise',         Library: libPictProviderFlowNoise,         Property: '_NoiseProvider',        NoFlowView: true },

			// Providers (need FlowView)
			{ ServiceType: 'PictProviderFlowTheme',         Library: libPictProviderFlowTheme,         Property: '_ThemeProvider' },
			{ ServiceType: 'PictProviderFlowCSS',           Library: libPictProviderFlowCSS,           Property: '_CSSProvider',          PostInit: 'registerCSS' },
			{ ServiceType: 'PictProviderFlowIcons',         Library: libPictProviderFlowIcons,         Property: '_IconProvider',         PostInit: 'registerIconTemplates' },
			{ ServiceType: 'PictProviderFlowConnectorShapes', Library: libPictProviderFlowConnectorShapes, Property: '_ConnectorShapesProvider' },
			{ ServiceType: 'PictProviderFlowPanelChrome',   Library: libPictProviderFlowPanelChrome,   Property: '_PanelChromeProvider' },
			{ ServiceType: 'PictProviderFlowNodeTypes',     Library: libPictProviderFlowNodeTypes,     Property: '_NodeTypeProvider',   ExtraOptions: () => ({ AdditionalNodeTypes: this.options.NodeTypes, IncludeDefaultNodeTypes: this.options.IncludeDefaultNodeTypes }) },
			{ ServiceType: 'PictProviderFlowEventHandler',  Library: libPictProviderFlowEventHandler,  Property: '_EventHandlerProvider' },
			{ ServiceType: 'PictProviderFlowLayouts',       Library: libPictProviderFlowLayouts,       Property: '_LayoutProvider',       PostInit: 'loadPersistedLayouts' },

			// Services
			{ ServiceType: 'PictServiceFlowPathGenerator',           Library: libPictServiceFlowPathGenerator,           Property: '_PathGenerator' },
			{ ServiceType: 'PictServiceFlowDataManager',             Library: libPictServiceFlowDataManager,             Property: '_DataManager' },
			{ ServiceType: 'PictServiceFlowConnectionHandleManager', Library: libPictServiceFlowConnectionHandleManager, Property: '_ConnectionHandleManager' },
			{ ServiceType: 'PictServiceFlowRenderManager',           Library: libPictServiceFlowRenderManager,           Property: '_RenderManager' },
			{ ServiceType: 'PictServiceFlowPortRenderer',            Library: libPictServiceFlowPortRenderer,            Property: '_PortRenderer' },
			{ ServiceType: 'PictServiceFlowInteractionManager',      Library: libPictServiceFlowInteractionManager,      Property: '_InteractionManager' },
			{ ServiceType: 'PictServiceFlowConnectionRenderer',      Library: libPictServiceFlowConnectionRenderer,      Property: '_ConnectionRenderer' },
			{ ServiceType: 'PictServiceFlowTether',                  Library: libPictServiceFlowTether,                  Property: '_TetherService' },
			{ ServiceType: 'PictServiceFlowLayout',                  Library: libPictServiceFlowLayout,                  Property: '_LayoutService' },
			{ ServiceType: 'PictServiceFlowViewportManager',         Library: libPictServiceFlowViewportManager,         Property: '_ViewportManager' },
			{ ServiceType: 'PictServiceFlowSelectionManager',        Library: libPictServiceFlowSelectionManager,        Property: '_SelectionManager' },
			{ ServiceType: 'PictServiceFlowPanelManager',            Library: libPictServiceFlowPanelManager,            Property: '_PanelManager' },

			// View types (register only — instantiated with custom config in onAfterInitialRender)
			{ ServiceType: 'PictViewFlowNode',             Library: libPictViewFlowNode,             RegisterOnly: true },
			{ ServiceType: 'PictViewFlowToolbar',          Library: libPictViewFlowToolbar,          RegisterOnly: true },
			{ ServiceType: 'PictViewFlowFloatingToolbar',  Library: libPictViewFlowFloatingToolbar,  RegisterOnly: true },
			{ ServiceType: 'PictViewFlowPropertiesPanel',  Library: libPictViewFlowPropertiesPanel,  RegisterOnly: true },

			// Panel types (register only)
			{ ServiceType: 'PictFlowCardPropertiesPanel',           Library: libPictFlowCardPropertiesPanel,  RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Template',  Library: libPanelTemplate,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Markdown',  Library: libPanelMarkdown,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Form',      Library: libPanelForm,                   RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-View',      Library: libPanelView,                   RegisterOnly: true }
		];

		this._registerServiceTypes();

		// Internal state
		this._FlowData = {
			Nodes: [],
			Connections: [],
			OpenPanels: [],
			SavedLayouts: [],
			ViewState: {
				PanX: 0,
				PanY: 0,
				Zoom: 1,
				SelectedNodeHash: null,
				SelectedConnectionHash: null,
				SelectedTetherHash: null
			},
			LayoutAlgorithm: this.options.DefaultLayoutAlgorithm || 'Custom',
			LayoutParameters: JSON.parse(JSON.stringify(this.options.DefaultLayoutParameters || {})),
			LayoutAutoApply: !!this.options.DefaultLayoutAutoApply,
			EdgeTheme: this.options.DefaultEdgeTheme || null,
			EdgeThemeParameters: JSON.parse(JSON.stringify(this.options.DefaultEdgeThemeParameters || {}))
		};

		// Re-entrancy guard for the auto-apply event handler
		this._AutoApplyInProgress = false;
		this._AutoApplyHandlerHashes = [];

		this._SVGElement = null;
		this._ViewportElement = null;
		this._NodesLayer = null;
		this._ConnectionsLayer = null;
		this._EndpointsLayer = null;
		this._PortHintsLayer = null;
		this._TethersLayer = null;
		this._PanelsLayer = null;

		this._DataManager = null;
		this._ConnectionHandleManager = null;
		this._RenderManager = null;
		this._PortRenderer = null;

		this._InteractionManager = null;
		this._ConnectionRenderer = null;
		this._TetherService = null;
		this._LayoutService = null;
		this._PathGenerator = null;
		this._ViewportManager = null;
		this._SelectionManager = null;
		this._PanelManager = null;
		this._CSSProvider = null;
		this._IconProvider = null;
		this._ConnectorShapesProvider = null;
		this._ThemeProvider = null;
		this._NoiseProvider = null;
		this._SVGHelperProvider = null;
		this._GeometryProvider = null;
		this._PanelChromeProvider = null;
		this._NodeTypeProvider = null;
		this._LayoutProvider = null;
		this._EventHandlerProvider = null;
		this._NodeView = null;
		this._ToolbarView = null;
		this._PropertiesPanelView = null;

		this.initialRenderComplete = false;
	}

	_registerServiceTypes()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpEntry.ServiceType))
			{
				this.fable.addServiceType(tmpEntry.ServiceType, tmpEntry.Library);
			}
		}
	}

	_instantiateServices()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (tmpEntry.RegisterOnly) continue;
			if (this[tmpEntry.Property]) continue;

			let tmpOptions = tmpEntry.NoFlowView ? {} : { FlowView: this };
			if (typeof tmpEntry.ExtraOptions === 'function')
			{
				Object.assign(tmpOptions, tmpEntry.ExtraOptions());
			}

			this[tmpEntry.Property] = this.fable.instantiateServiceProviderWithoutRegistration(tmpEntry.ServiceType, tmpOptions);

			if (tmpEntry.PostInit && typeof this[tmpEntry.Property][tmpEntry.PostInit] === 'function')
			{
				this[tmpEntry.Property][tmpEntry.PostInit]();
			}
		}
	}

	get flowData()
	{
		return this._FlowData;
	}

	get viewState()
	{
		return this._FlowData.ViewState;
	}

	// Backward-compatible getter for InteractionManager direct access
	get _IsFullscreen()
	{
		return this._ViewportManager ? this._ViewportManager._IsFullscreen : false;
	}

	/**
	 * Override render to pass view options as the template record,
	 * so template expressions like {~D:Record.ViewIdentifier~} resolve correctly.
	 */
	render(pRenderableHash, pRenderDestinationAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		// If no record address is explicitly provided, use this.options as the record
		if (typeof pTemplateRecordAddress === 'function' || typeof pTemplateRecordAddress === 'undefined')
		{
			return super.renderAsync(pRenderableHash, pRenderDestinationAddress, this.options, pRootRenderable, pTemplateRecordAddress || fCallback);
		}
		return super.renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Theme + Noise must be created first (CSS PostInit depends on theme state)
		this._ThemeProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowTheme', { FlowView: this });
		this._NoiseProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowNoise');

		// Apply initial theme from options
		if (this.options.Theme)
		{
			this._ThemeProvider.setTheme(this.options.Theme);
		}
		if (typeof this.options.NoiseLevel === 'number')
		{
			this._ThemeProvider.setNoiseLevel(this.options.NoiseLevel);
		}

		// Instantiate all remaining services (skips Theme + Noise since already set)
		this._instantiateServices();

		// Subscribe to the host application's pict-provider-theme so the flow
		// editor's marker arrowhead colors and shape overrides update when the
		// host swaps light/dark or palette themes. CSS variables (--theme-*)
		// re-resolve automatically — only the SVG <marker> defs (which inline
		// fill colors at build time) and ConnectorShapesProvider state need a
		// manual refresh.
		this._subscribeToHostTheme();

		return super.onBeforeInitialize();
	}

	/**
	 * If the host application has registered pict-provider-theme, subscribe
	 * to its onApply hook so we can refresh anything that doesn't pick up
	 * the new --theme-* CSS variables automatically (SVG marker fills,
	 * connector shape overrides). No-op when no host theme provider is
	 * available — the flow editor still functions with its built-in themes.
	 */
	_subscribeToHostTheme()
	{
		let tmpHostTheme = this._resolveHostThemeProvider();
		if (!tmpHostTheme || typeof tmpHostTheme.onApply !== 'function') return;

		this._HostThemeUnsubscribe = tmpHostTheme.onApply(() =>
		{
			if (this._CSSProvider) this._CSSProvider.registerCSS();
			this._reinjectMarkerDefs();
			if (this.initialRenderComplete) this.renderFlow();
		});
	}

	/**
	 * Locate the host's pict-provider-theme instance. It is normally
	 * registered under a stable service hash by the host app; we check
	 * common locations so consumers don't have to wire it manually.
	 * @returns {Object|null}
	 */
	_resolveHostThemeProvider()
	{
		let tmpPict = this.pict;
		if (!tmpPict) return null;
		if (tmpPict.providers)
		{
			let tmpKeys = Object.keys(tmpPict.providers);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpProvider = tmpPict.providers[tmpKeys[i]];
				if (tmpProvider
					&& typeof tmpProvider.onApply === 'function'
					&& typeof tmpProvider.applyTheme === 'function'
					&& typeof tmpProvider.listThemes === 'function')
				{
					return tmpProvider;
				}
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpViewIdentifier = this.options.ViewIdentifier;

		// Grab SVG DOM elements
		let tmpSVGElements = this.pict.ContentAssignment.getElement(`#Flow-SVG-${tmpViewIdentifier}`);
		if (tmpSVGElements.length < 1)
		{
			this.log.error(`PictSectionFlow could not find SVG element #Flow-SVG-${tmpViewIdentifier}`);
			return false;
		}
		this._SVGElement = tmpSVGElements[0];

		let tmpViewportElements = this.pict.ContentAssignment.getElement(`#Flow-Viewport-${tmpViewIdentifier}`);
		if (tmpViewportElements.length > 0)
		{
			this._ViewportElement = tmpViewportElements[0];
		}

		let tmpNodesElements = this.pict.ContentAssignment.getElement(`#Flow-Nodes-${tmpViewIdentifier}`);
		if (tmpNodesElements.length > 0)
		{
			this._NodesLayer = tmpNodesElements[0];
		}

		let tmpConnectionsElements = this.pict.ContentAssignment.getElement(`#Flow-Connections-${tmpViewIdentifier}`);
		if (tmpConnectionsElements.length > 0)
		{
			this._ConnectionsLayer = tmpConnectionsElements[0];
		}

		let tmpEndpointsElements = this.pict.ContentAssignment.getElement(`#Flow-Endpoints-${tmpViewIdentifier}`);
		if (tmpEndpointsElements.length > 0)
		{
			this._EndpointsLayer = tmpEndpointsElements[0];
		}

		let tmpPortHintsElements = this.pict.ContentAssignment.getElement(`#Flow-PortHints-${tmpViewIdentifier}`);
		if (tmpPortHintsElements.length > 0)
		{
			this._PortHintsLayer = tmpPortHintsElements[0];
		}

		let tmpTethersElements = this.pict.ContentAssignment.getElement(`#Flow-Tethers-${tmpViewIdentifier}`);
		if (tmpTethersElements.length > 0)
		{
			this._TethersLayer = tmpTethersElements[0];
		}

		let tmpPanelsElements = this.pict.ContentAssignment.getElement(`#Flow-Panels-${tmpViewIdentifier}`);
		if (tmpPanelsElements.length > 0)
		{
			this._PanelsLayer = tmpPanelsElements[0];
		}

		// Ensure all services are initialized (fallback if onBeforeInitialize was skipped)
		this._instantiateServices();

		// Inject marker defs via the connector shapes provider
		// Note: insertAdjacentHTML does not work on SVG elements (wrong namespace),
		// so we parse via a temporary <svg> element to ensure SVG namespace.
		if (this._ConnectorShapesProvider && this._SVGElement)
		{
			let tmpDefs = this._SVGElement.querySelector('defs');
			if (tmpDefs)
			{
				let tmpMarkerMarkup = this._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
				let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				tmpTempSVG.innerHTML = tmpMarkerMarkup;
				while (tmpTempSVG.firstChild)
				{
					tmpDefs.appendChild(tmpTempSVG.firstChild);
				}
			}
		}

		// Setup the toolbar if enabled
		if (this.options.EnableToolbar)
		{
			this._ToolbarView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowToolbar',
				Object.assign({},
					libPictViewFlowToolbar.default_configuration,
					{
						ViewIdentifier: `Flow-Toolbar-${tmpViewIdentifier}`,
						DefaultDestinationAddress: `#Flow-Toolbar-${tmpViewIdentifier}`,
						FlowViewIdentifier: tmpViewIdentifier,
						EnableAddNode: this.options.EnableAddNode,
						EnableCardPalette: this.options.EnableCardPalette
					}
				));
			// Use the toolbar's render method after it's set up
			if (this._ToolbarView && typeof this._ToolbarView.render === 'function')
			{
				this._ToolbarView._FlowView = this;
				this._ToolbarView.render();
			}
		}

		// Setup the node renderer
		this._NodeView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowNode',
			Object.assign({},
				libPictViewFlowNode.default_configuration,
				{
					ViewIdentifier: `Flow-NodeRenderer-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._NodeView._FlowView = this;

		// Setup the properties panel renderer
		this._PropertiesPanelView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowPropertiesPanel',
			Object.assign({},
				libPictViewFlowPropertiesPanel.default_configuration,
				{
					ViewIdentifier: `Flow-PropertiesPanel-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._PropertiesPanelView._FlowView = this;

		// Bind interaction events
		this._InteractionManager.initialize(this._SVGElement, this._ViewportElement);

		// Wire the auto-apply handler to structural-change events
		this._subscribeAutoApplyHandlers();

		// Load initial flow data if an address is configured
		if (this.options.FlowDataAddress)
		{
			this.marshalToView();
		}

		// Render the initial flow
		this.renderFlow();
	}

	// ---- Data Manager Delegations ----

	marshalToView() { return this._DataManager.marshalToView(); }
	marshalFromView() { return this._DataManager.marshalFromView(); }
	getFlowData() { return this._DataManager.getFlowData(); }
	setFlowData(pFlowData) { return this._DataManager.setFlowData(pFlowData); }
	addNode(pType, pX, pY, pTitle, pData) { return this._DataManager.addNode(pType, pX, pY, pTitle, pData); }
	removeNode(pNodeHash) { return this._DataManager.removeNode(pNodeHash); }
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData) { return this._DataManager.addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData); }
	removeConnection(pConnectionHash) { return this._DataManager.removeConnection(pConnectionHash); }

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		return this._SelectionManager.selectNode(pNodeHash);
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		return this._SelectionManager.selectConnection(pConnectionHash);
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		return this._SelectionManager.deselectAll();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		return this._SelectionManager.deleteSelected();
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		return this._ViewportManager.updateViewportTransform();
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		return this._ViewportManager.setZoom(pZoom, pFocusX, pFocusY);
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		return this._ViewportManager.zoomToFit();
	}

	/**
	 * Apply auto-layout to all nodes.
	 *
	 * Backwards-compatible signature: when called with no arguments,
	 * dispatches to the Layered algorithm with its default parameters
	 * (matching the pre-subsystem behavior).
	 *
	 * If `pAlgorithmName` is provided it is used directly; otherwise the
	 * configured `_FlowData.LayoutAlgorithm` is used (unless that value
	 * is 'Custom' or unset, in which case it falls back to 'Layered').
	 *
	 * @param {string} [pAlgorithmName]
	 * @param {Object} [pParameters]
	 */
	autoLayout(pAlgorithmName, pParameters)
	{
		if (!this._LayoutService) return;

		let tmpName;
		let tmpParams;
		if (typeof pAlgorithmName === 'string' && pAlgorithmName !== '')
		{
			tmpName = pAlgorithmName;
			tmpParams = pParameters || {};
		}
		else
		{
			let tmpConfigured = this._FlowData.LayoutAlgorithm;
			tmpName = (typeof tmpConfigured === 'string' && tmpConfigured !== '' && tmpConfigured !== 'Custom') ? tmpConfigured : 'Layered';
			tmpParams = (tmpName === this._FlowData.LayoutAlgorithm) ? (this._FlowData.LayoutParameters || {}) : {};
		}

		this._LayoutService.autoLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpName, tmpParams);
		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Apply the currently configured layout algorithm to the flow, then
	 * call the active edge theme's `AdjustLayout` callback (if any) to
	 * let the theme adjust node positions for cleaner edge rendering
	 * (e.g. snap to grid, optimize for crossing minimization).
	 *
	 * Reads `_FlowData.LayoutAlgorithm` / `LayoutParameters` /
	 * `EdgeTheme` / `EdgeThemeParameters`. No-op when algorithm is
	 * 'Custom' — but the edge theme's adjustment still runs (so themes
	 * like OrthogonalSnap can snap hand-placed nodes too).
	 */
	applyCurrentLayout()
	{
		if (!this._LayoutService) return;
		let tmpAlgorithm = this._FlowData.LayoutAlgorithm || 'Custom';

		this._AutoApplyInProgress = true;
		try
		{
			if (tmpAlgorithm !== 'Custom')
			{
				this._LayoutService.applyLayout(
					this._FlowData.Nodes,
					this._FlowData.Connections,
					tmpAlgorithm,
					this._FlowData.LayoutParameters || {}
				);
			}

			// Edge-theme post-processing (placement adjustment).
			let tmpEdgeTheme = this._LayoutService.resolveActiveEdgeTheme({});
			if (tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function')
			{
				try
				{
					let tmpEdgeParams = this._LayoutService.getMergedEdgeThemeParameters(
						tmpEdgeTheme.Name,
						this._FlowData.EdgeThemeParameters || {}
					);
					tmpEdgeTheme.AdjustLayout(this._FlowData.Nodes, this._FlowData.Connections, tmpEdgeParams);
				}
				catch (pError)
				{
					this.log.warn(`PictSectionFlow edge theme '${tmpEdgeTheme.Name}' AdjustLayout threw: ${pError.message}`);
				}
			}

			let tmpHadAdjust = !!(tmpEdgeTheme && typeof tmpEdgeTheme.AdjustLayout === 'function');
			let tmpDidLayout = (tmpAlgorithm !== 'Custom');

			if (!tmpDidLayout && !tmpHadAdjust)
			{
				// Custom + theme-without-AdjustLayout → no positions changed.
				// Don't render or fire onFlowChanged.
				return;
			}

			this.renderFlow();
			this.marshalFromView();

			if (this._EventHandlerProvider)
			{
				this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
			}
		}
		finally
		{
			this._AutoApplyInProgress = false;
		}
	}

	/**
	 * Set the active edge theme (and optionally its parameters). Re-runs
	 * the current layout so any `AdjustLayout` callback takes effect.
	 *
	 * @param {string|null} pThemeName - null clears the override (theme
	 *   then resolves via the active layout's `DefaultEdgeTheme`).
	 * @param {Object} [pParameters]
	 */
	setEdgeTheme(pThemeName, pParameters)
	{
		if (!this._LayoutService) return;
		if (pThemeName != null && typeof pThemeName !== 'string') return;

		if (pThemeName)
		{
			let tmpTheme = this._LayoutService.getEdgeTheme(pThemeName);
			if (!tmpTheme)
			{
				this.log.warn(`PictSectionFlow setEdgeTheme: unknown theme '${pThemeName}'`);
				return;
			}
			this._FlowData.EdgeTheme = pThemeName;
			this._FlowData.EdgeThemeParameters = Object.assign({}, tmpTheme.DefaultParameters || {}, pParameters || {});
		}
		else
		{
			this._FlowData.EdgeTheme = null;
			this._FlowData.EdgeThemeParameters = pParameters ? Object.assign({}, pParameters) : {};
		}

		this.applyCurrentLayout();
	}

	/**
	 * Read the currently configured edge theme settings.
	 * Returns the *resolved* active theme (factoring in fallback to the
	 * active layout's `DefaultEdgeTheme`) plus the explicit override
	 * (if any) for round-tripping into UI.
	 *
	 * @returns {{ Theme: string, Override: string|null, Parameters: Object }}
	 */
	getEdgeTheme()
	{
		let tmpResolved = this._LayoutService ? this._LayoutService.resolveActiveEdgeTheme({}) : null;
		return {
			Theme: tmpResolved ? tmpResolved.Name : null,
			Override: this._FlowData.EdgeTheme || null,
			Parameters: JSON.parse(JSON.stringify(this._FlowData.EdgeThemeParameters || {}))
		};
	}

	/**
	 * Set the configured layout algorithm and (optionally) its parameters
	 * and auto-apply flag. Persists to `_FlowData` and applies the layout
	 * immediately when the algorithm is non-Custom.
	 *
	 * @param {string} pAlgorithmName
	 * @param {Object} [pParameters] - merged over the algorithm's defaults
	 * @param {boolean} [pAutoApply] - if provided, also sets `LayoutAutoApply`
	 */
	setLayoutAlgorithm(pAlgorithmName, pParameters, pAutoApply)
	{
		if (!this._LayoutService) return;
		if (typeof pAlgorithmName !== 'string' || pAlgorithmName === '') return;

		let tmpAlgo = this._LayoutService.getAlgorithm(pAlgorithmName);
		if (!tmpAlgo)
		{
			this.log.warn(`PictSectionFlow setLayoutAlgorithm: unknown algorithm '${pAlgorithmName}'`);
			return;
		}

		this._FlowData.LayoutAlgorithm = pAlgorithmName;
		this._FlowData.LayoutParameters = Object.assign({}, tmpAlgo.DefaultParameters || {}, pParameters || {});
		if (typeof pAutoApply === 'boolean')
		{
			this._FlowData.LayoutAutoApply = pAutoApply;
		}

		// Always run applyCurrentLayout so the new layout's `DefaultEdgeTheme`
		// takes effect on connection rendering — even when switching to
		// 'Custom' (which doesn't reposition nodes but does re-render edges).
		this.applyCurrentLayout();
		this.renderFlow();
	}

	/**
	 * Toggle whether the configured layout re-applies on structural changes.
	 * @param {boolean} pAutoApply
	 */
	setLayoutAutoApply(pAutoApply)
	{
		this._FlowData.LayoutAutoApply = !!pAutoApply;
		this.marshalFromView();
	}

	/**
	 * Read the currently configured layout algorithm settings.
	 * @returns {{ Algorithm: string, Parameters: Object, AutoApply: boolean }}
	 */
	getLayoutAlgorithm()
	{
		return {
			Algorithm: this._FlowData.LayoutAlgorithm || 'Custom',
			Parameters: JSON.parse(JSON.stringify(this._FlowData.LayoutParameters || {})),
			AutoApply: !!this._FlowData.LayoutAutoApply
		};
	}

	/**
	 * Subscribe the auto-apply handler to structural-change events. Idempotent.
	 * Only structural events trigger re-layout — `onNodeMoved` is intentionally
	 * NOT subscribed so user drags are never clobbered until the next add/remove.
	 */
	_subscribeAutoApplyHandlers()
	{
		if (!this._EventHandlerProvider) return;
		if (this._AutoApplyHandlerHashes.length > 0) return;

		let tmpEvents = ['onNodeAdded', 'onNodeRemoved', 'onConnectionCreated', 'onConnectionRemoved'];
		for (let i = 0; i < tmpEvents.length; i++)
		{
			let tmpHash = this._EventHandlerProvider.registerHandler(tmpEvents[i], () =>
			{
				if (this._AutoApplyInProgress) return;
				if (!this._FlowData.LayoutAutoApply) return;
				if (!this._FlowData.LayoutAlgorithm || this._FlowData.LayoutAlgorithm === 'Custom') return;
				this.applyCurrentLayout();
			});
			if (tmpHash) this._AutoApplyHandlerHashes.push({ Event: tmpEvents[i], Hash: tmpHash });
		}
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		return this._ViewportManager.toggleFullscreen();
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		return this._ViewportManager.exitFullscreen();
	}

	// ── Theme API ────────────────────────────────────────────────────────

	/**
	 * Switch the active theme and re-render.
	 * @param {string} pThemeKey - Theme key (e.g. 'default', 'sketch', 'blueprint', 'mono', 'retro-80s', 'retro-90s')
	 */
	setTheme(pThemeKey)
	{
		if (!this._ThemeProvider)
		{
			this.log.warn('PictSectionFlow setTheme: ThemeProvider not available');
			return;
		}

		let tmpApplied = this._ThemeProvider.setTheme(pThemeKey);
		if (!tmpApplied) return;

		// Re-register CSS with the new theme overrides
		if (this._CSSProvider)
		{
			this._CSSProvider.registerCSS();
		}

		// Re-inject marker defs (arrowhead colors may have changed)
		this._reinjectMarkerDefs();

		// Full re-render
		if (this.initialRenderComplete)
		{
			this.renderFlow();
		}

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onThemeChanged', pThemeKey);
		}
	}

	/**
	 * Set the noise level (0 to 1) and re-render.
	 * @param {number} pLevel - 0 = precise, 1 = maximum wobble
	 */
	setNoiseLevel(pLevel)
	{
		if (!this._ThemeProvider)
		{
			this.log.warn('PictSectionFlow setNoiseLevel: ThemeProvider not available');
			return;
		}

		this._ThemeProvider.setNoiseLevel(pLevel);

		// Full re-render to apply new noise
		if (this.initialRenderComplete)
		{
			this.renderFlow();
		}
	}

	/**
	 * Get the current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		if (this._ThemeProvider)
		{
			return this._ThemeProvider.getNoiseLevel();
		}
		return 0;
	}

	/**
	 * Get the active theme key.
	 * @returns {string}
	 */
	getThemeKey()
	{
		if (this._ThemeProvider)
		{
			return this._ThemeProvider.getActiveThemeKey();
		}
		return 'default';
	}

	_reinjectMarkerDefs() { return this._RenderManager.reinjectMarkerDefs(); }

	/**
	 * Get a node by hash
	 * @param {string} pNodeHash
	 * @returns {Object|null}
	 */
	getNode(pNodeHash)
	{
		return this._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) || null;
	}

	/**
	 * Get a connection by hash
	 * @param {string} pConnectionHash
	 * @returns {Object|null}
	 */
	getConnection(pConnectionHash)
	{
		return this._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) || null;
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		return this._SelectionManager.selectTether(pPanelHash);
	}

	// ---- Connection Handle Manager Delegations ----

	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY) { return this._ConnectionHandleManager.updateConnectionHandle(pConnectionHash, pHandleType, pX, pY); }
	addConnectionHandle(pConnectionHash, pX, pY) { return this._ConnectionHandleManager.addConnectionHandle(pConnectionHash, pX, pY); }
	removeConnectionHandle(pConnectionHash, pIndex) { return this._ConnectionHandleManager.removeConnectionHandle(pConnectionHash, pIndex); }
	_resetHandlesForNode(pNodeHash) { return this._ConnectionHandleManager.resetHandlesForNode(pNodeHash); }
	_resetHandlesForPanel(pPanelHash) { return this._ConnectionHandleManager.resetHandlesForPanel(pPanelHash); }

	/**
	 * Add a bezier handle to a tether at the specified SVG position.
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addTetherHandle(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		let tmpNode = this.getNode(tmpPanel.NodeHash);
		if (!tmpNode) return;

		let tmpAnchors = this._TetherService.getSmartAnchors(tmpPanel, tmpNode);

		this._TetherService.addHandle(tmpPanel, pX, pY, tmpAnchors.panelAnchor, tmpAnchors.nodeAnchor);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {string} pPanelHash
	 * @param {number} pIndex
	 */
	removeTetherHandle(pPanelHash, pIndex)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		this._TetherService.removeHandle(tmpPanel, pIndex);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Update a tether handle position during drag (for real-time feedback).
	 * Delegates state update to the TetherService.
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateTetherHandle(pPanelHash, pHandleType, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._TetherService)
		{
			this._TetherService.updateHandlePosition(tmpPanel, pHandleType, pX, pY);
		}

		this._renderSingleTether(pPanelHash);
	}

	/**
	 * Get a port's absolute position in SVG coordinates.
	 *
	 * For left and right side ports, positioning is offset below the title bar
	 * so that connection endpoints match the rendered port circles.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPortHash
	 * @returns {{x: number, y: number, side: string}|null}
	 */
	getPortPosition(pNodeHash, pPortHash)
	{
		let tmpNode = this.getNode(pNodeHash);
		if (!tmpNode) return null;

		let tmpPort = tmpNode.Ports.find((p) => p.Hash === pPortHash);
		if (!tmpPort) return null;

		// Count ports on the same side (matching both direction and side)
		let tmpSameSidePorts = tmpNode.Ports.filter((p) => p.Side === tmpPort.Side);
		let tmpPortIndex = tmpSameSidePorts.indexOf(tmpPort);
		let tmpPortCount = tmpSameSidePorts.length;

		let tmpTitleBarHeight = (this._NodeView && this._NodeView.options.NodeTitleBarHeight) || 28;

		// Use the adjusted node height that accounts for minimum port
		// spacing.  Connections render before nodes, so the node renderer
		// may not have written back its adjusted height yet.
		let tmpHeight = tmpNode.Height || 80;
		if (this._GeometryProvider && tmpNode.Ports && tmpNode.Ports.length > 0)
		{
			let tmpMinHeight = this._GeometryProvider.computeMinimumNodeHeight(tmpNode.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = this._GeometryProvider.buildPortCountsBySide(tmpNode.Ports);

		let tmpLocal = this._GeometryProvider.getPortLocalPosition(tmpPort.Side, tmpPortIndex, tmpPortCount, tmpNode.Width, tmpHeight, tmpTitleBarHeight, tmpPortCountsBySide);

		return { x: tmpNode.X + tmpLocal.x, y: tmpNode.Y + tmpLocal.y, side: tmpPort.Side || 'right' };
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		return this._ViewportManager.screenToSVGCoords(pScreenX, pScreenY);
	}

	// ---- Render Manager Delegations ----

	renderFlow() { return this._RenderManager.renderFlow(); }
	_renderSingleConnection(pConnectionHash) { return this._RenderManager.renderSingleConnection(pConnectionHash); }
	_renderSingleTether(pPanelHash) { return this._RenderManager.renderSingleTether(pPanelHash); }
	updateNodePosition(pNodeHash, pX, pY) { return this._RenderManager.updateNodePosition(pNodeHash, pX, pY); }
	_renderConnectionsForNode(pNodeHash) { return this._RenderManager.renderConnectionsForNode(pNodeHash); }
	_renderTethersForNode(pNodeHash) { return this._RenderManager.renderTethersForNode(pNodeHash); }

	// ---- Properties Panel Management ----

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node has no PropertiesPanel config
	 */
	openPanel(pNodeHash)
	{
		return this._PanelManager.openPanel(pNodeHash);
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		return this._PanelManager.closePanel(pPanelHash);
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		return this._PanelManager.closePanelForNode(pNodeHash);
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		return this._PanelManager.togglePanel(pNodeHash);
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		return this._PanelManager.updatePanelPosition(pPanelHash, pX, pY);
	}

	// ── Inline-handler bridges (called from template onclick/oninput attrs)

	/**
	 * Handle a click on a panel tab button. Stops propagation so the
	 * underlying SVG doesn't see it, then delegates to the properties
	 * panel view for the actual visibility toggle.
	 *
	 * @param {Element} pTabElement
	 * @param {Event} pEvent
	 */
	_handlePanelTabClick(pTabElement, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView.switchPanelTab(pTabElement);
		}
	}

	/**
	 * Apply a node property change driven from the appearance editor's
	 * inline `oninput` handler. Stops propagation, then delegates to the
	 * properties panel view.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPropPath
	 * @param {string} pValue
	 * @param {string} pInputType - 'text' | 'number' | 'color'
	 * @param {Event} [pEvent]
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType, pEvent)
	{
		if (pEvent && typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		if (this._PropertiesPanelView)
		{
			this._PropertiesPanelView._applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType);
		}
	}

	/**
	 * Inline-handler bridge — light up port-hint paths matching the given
	 * port (and optionally node) hash. Called from inline `onmouseenter`
	 * on port badges; see PictService-Flow-PortRenderer._wirePortHintHover.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_activatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, true);
	}

	/**
	 * Inline-handler bridge — clear port-hint highlights.
	 *
	 * @param {string|null} pPortHash
	 * @param {string|null} pNodeHash
	 */
	_deactivatePortHints(pPortHash, pNodeHash)
	{
		this._togglePortHints(pPortHash, pNodeHash, false);
	}

	_togglePortHints(pPortHash, pNodeHash, pActive)
	{
		let tmpScope = this._SVGElement || document;
		let tmpSelector = pPortHash
			? '.pict-flow-port-hint[data-port-hash="' + pPortHash + '"]'
			: '.pict-flow-port-hint[data-node-hash="' + pNodeHash + '"]';
		let tmpHints = tmpScope.querySelectorAll(tmpSelector);
		for (let i = 0; i < tmpHints.length; i++)
		{
			if (pActive)
			{
				tmpHints[i].setAttribute('data-active', 'true');
			}
			else
			{
				tmpHints[i].removeAttribute('data-active');
			}
		}
	}

	// ── SVG inline pointer/wheel bridges ─────────────────────────────────

	_handleSVGPointerDown(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerDown(pEvent);
	}

	_handleSVGPointerMove(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerMove(pEvent);
	}

	_handleSVGPointerUp(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onPointerUp(pEvent);
	}

	_handleSVGWheel(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager._onWheel(pEvent);
	}

	_handleSVGContextMenu(pEvent)
	{
		if (this._InteractionManager) this._InteractionManager.handleContextMenu(pEvent);
	}
}

module.exports = PictViewFlow;

module.exports.default_configuration = _DefaultConfiguration;

},{"../PictFlowCardPropertiesPanel.js":18,"../panels/FlowCardPropertiesPanel-Form.js":19,"../panels/FlowCardPropertiesPanel-Markdown.js":20,"../panels/FlowCardPropertiesPanel-Template.js":21,"../panels/FlowCardPropertiesPanel-View.js":22,"../providers/PictProvider-Flow-CSS.js":23,"../providers/PictProvider-Flow-ConnectorShapes.js":24,"../providers/PictProvider-Flow-EventHandler.js":25,"../providers/PictProvider-Flow-Geometry.js":26,"../providers/PictProvider-Flow-Icons.js":27,"../providers/PictProvider-Flow-Layouts.js":28,"../providers/PictProvider-Flow-NodeTypes.js":29,"../providers/PictProvider-Flow-Noise.js":30,"../providers/PictProvider-Flow-PanelChrome.js":31,"../providers/PictProvider-Flow-SVGHelpers.js":32,"../providers/PictProvider-Flow-Theme.js":33,"../services/PictService-Flow-ConnectionHandleManager.js":50,"../services/PictService-Flow-ConnectionRenderer.js":51,"../services/PictService-Flow-DataManager.js":52,"../services/PictService-Flow-InteractionManager.js":53,"../services/PictService-Flow-Layout.js":54,"../services/PictService-Flow-PanelManager.js":55,"../services/PictService-Flow-PathGenerator.js":56,"../services/PictService-Flow-PortRenderer.js":57,"../services/PictService-Flow-RenderManager.js":58,"../services/PictService-Flow-SelectionManager.js":59,"../services/PictService-Flow-Tether.js":60,"../services/PictService-Flow-ViewportManager.js":61,"./PictView-Flow-FloatingToolbar.js":62,"./PictView-Flow-Node.js":63,"./PictView-Flow-PropertiesPanel.js":64,"./PictView-Flow-Toolbar.js":65,"pict-view":137}],67:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],68:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.align]   - 'left'|'right' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.setAttribute('role', 'menu');
		tmpMenu.style.maxHeight = pOptions.maxHeight;

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],69:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],70:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron lookup via pict.providers.Icon ──────────
		// Both directions come from the core registry (`{~I:ChevronLeft~}`
		// / `{~I:ChevronRight~}`).  Resolved per-render so a theme that
		// re-registers the chevron variant picks up automatically.  Empty
		// fallback in the unlikely case pict is missing the Icon provider
		// (very old pict versions; current minimum is 1.0.368).
		let tmpPictHandle = (typeof (window) !== 'undefined' && window.pict) ? window.pict : null;
		let tmpIcon = (pName) => (tmpPictHandle && typeof (tmpPictHandle.icon) === 'function')
			? tmpPictHandle.icon(pName)
			: '';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			let tmpChevronRight = tmpIcon('ChevronRight');
			let tmpChevronLeft  = tmpIcon('ChevronLeft');
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],71:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Scope:                'shell' (default) | 'center'.
 *                         When 'shell', the panel mounts in one of the
 *                         outer rows / side stacks (Side decides which).
 *                         When 'center', the panel mounts INSIDE the
 *                         center column instead — useful for bars that
 *                         should align with the content area only, not
 *                         span across the sidebars.  Only Side='top' and
 *                         Side='bottom' are supported with Scope='center'.
 *                         The center auto-switches to a flex-column
 *                         layout so the content destination + inner
 *                         panels stack vertically.
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			// Remove any previously-created destination so center() is
			// idempotent across reconfigurations.  We don't blow away
			// the whole center via innerHTML='' anymore: Scope:'center'
			// panels mounted by earlier addPanel() calls need to stay
			// in place.  Find the right insertion point so the
			// destination sits between any top-scoped panels and any
			// bottom-scoped panels.
			if (this._centerDestinationEl && this._centerDestinationEl.parentNode === this._centerEl)
			{
				this._centerEl.removeChild(this._centerDestinationEl);
			}
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			let tmpFirstBottomScoped = null;
			let tmpChildren = this._centerEl.children;
			for (let i = 0; i < tmpChildren.length; i++)
			{
				let tmpCandidate = tmpChildren[i];
				if (tmpCandidate.classList && tmpCandidate.classList.contains('pict-modal-shell-panel-bottom'))
				{
					tmpFirstBottomScoped = tmpCandidate;
					break;
				}
			}
			if (tmpFirstBottomScoped)
			{
				this._centerEl.insertBefore(tmpInner, tmpFirstBottomScoped);
			}
			else
			{
				this._centerEl.appendChild(tmpInner);
			}
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		if (pPanel.Position === 'overlay')
		{
			this._overlayLayer.appendChild(pPanel.El);
			return;
		}
		if (pPanel.Scope === 'center')
		{
			// Center-scoped panels mount inside the center column.
			// The column switches to flex-column so the content
			// destination + the panel(s) stack vertically.
			this._centerEl.classList.add('pict-modal-shell-center-with-inner-panel');
			if (pPanel.Side === 'top')
			{
				// Top-scoped panels go above the content destination.
				// If center() hasn't run yet, this still works — we
				// insert before whatever's first (or just append to an
				// empty center, which leaves us above any subsequent
				// content destination).
				this._centerEl.insertBefore(pPanel.El, this._centerEl.firstChild);
			}
			else
			{
				// Side === 'bottom' (the Scope guard already filtered
				// left/right).  Append to the bottom of the center.
				this._centerEl.appendChild(pPanel.El);
			}
			return;
		}
		let tmpHost;
		if      (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		// Scope: 'center' opts the panel into the center column instead
		// of the shell's outer rows.  Only valid for Side='top'/'bottom'
		// (left/right inside center would need a separate axis we don't
		// support).  Invalid combinations silently fall back to 'shell'.
		this.Scope = (pConfig.Scope === 'center'
				&& (this.Side === 'top' || this.Side === 'bottom'))
			? 'center'
			: 'shell';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],72:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible)
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		let tmpContent = '<span class="pict-modal-toast-message">' + this._escapeHTML(pMessage) + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],73:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in
			void tmpTooltipElement.offsetHeight;
			tmpTooltipElement.classList.add('pict-modal-visible');

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					tmpHide();
				});
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			tmpHide();
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
		};

		return { destroy: tmpDestroy };
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],74:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],75:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}
/* Center column gains this class when at least one Scope:'center'
   panel is added.  The center stops scrolling internally — that job
   moves to the content destination — and switches to a vertical flex
   so the destination and any inner panels stack cleanly. */
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel
{
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-center-content
{
	flex: 1 1 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-panel
{
	flex: 0 0 auto;
	width: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	/* How far the collapse-tab's panel-bg "merge bar" extends INTO
	   the panel past the tab's geometric edge. Painted via box-shadow
	   on the tab (no DOM impact), it masks any 1px theme border on an
	   inner element, content padding offset, or resize-handle hover
	   bleed in the strip between the tab's panel-facing edge and the
	   first real pixel of panel content. Consumers can bump this for
	   themes with thicker (2+px) inner borders. */
	--pict-modal-collapse-tab-merge: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	/* Geometry (width/height/right/left) is intentionally NOT animated.
	   Sliding the tab's outer edge inward on hover-out makes it look like
	   the tab is "sliding into" the panel content — weird visual.
	   Snapping the size change instead, and animating only the appearance
	   (opacity/color/shadow), gives a clean fade-in/out with no boundary
	   weirdness. */
	transition: opacity 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary.
   The first shadow value is the merge-bar (panel-bg colored, offset
   INTO the panel) which has to be repeated here so the hover override
   doesn't drop it. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow:
		calc(-1 * var(--pict-modal-collapse-tab-merge)) 0 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff)),
		3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow:
		var(--pict-modal-collapse-tab-merge) 0 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff)),
		-3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow:
		0 calc(-1 * var(--pict-modal-collapse-tab-merge)) 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff)),
		0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow:
		0 var(--pict-modal-collapse-tab-merge) 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff)),
		0 -3px 6px -2px rgba(0, 0, 0, 0.18);
}

/* Side panels: slim VERTICAL sliver pulled OUT of the panel's outer
   boundary like a drawer tab. The geometric inner edge sits 1px
   INSIDE the panel boundary, and the merge-bar box-shadow paints
   another --pict-modal-collapse-tab-merge px of panel-bg color past
   it INTO the panel — together they mask any 1px theme border on an
   inner element, content padding offset, or resize-handle hover bleed
   that would otherwise leak between the tab and the panel content.
   The tab grows OUTWARD only on hover; the inner edge stays put so
   the tab always looks like an extension of the panel rather than a
   floating button. Border-left is removed for left panels (and
   border-right for right panels) so the panel-facing edge is open. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	right: -5px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
	box-shadow: calc(-1 * var(--pict-modal-collapse-tab-merge)) 0 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -5px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
	box-shadow: var(--pict-modal-collapse-tab-merge) 0 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
}
/* Hover: same inner anchor (panelRight - 1), tab grows outward to
   width 18 → right: -17px. Top + height grow downward only (top
   stays, height extends so the tab visually 'drops' the chevron
   into view). */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -17px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -17px;
}

/* Top / bottom panels: slim HORIZONTAL sliver pulled OUT of the
   horizontal boundary, anchored 14 px in from the right. Same
   inner-edge-anchored + merge-bar pattern as the side panels — the
   merge-bar offsets vertically instead of horizontally. */
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -5px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
	box-shadow: 0 calc(-1 * var(--pict-modal-collapse-tab-merge)) 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -5px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
	box-shadow: 0 var(--pict-modal-collapse-tab-merge) 0 0 var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -17px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -17px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],76:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items, align, position, minWidth, maxHeight,
	 *   className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss.
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":67,"./Pict-Modal-Dropdown.js":68,"./Pict-Modal-Overlay.js":69,"./Pict-Modal-Panel.js":70,"./Pict-Modal-Shell.js":71,"./Pict-Modal-Toast.js":72,"./Pict-Modal-Tooltip.js":73,"./Pict-Modal-Window.js":74,"./Pict-Section-Modal-DefaultConfiguration.js":75,"pict-view":137}],77:[function(require,module,exports){
/**
 * pict-section-theme — entry point.
 *
 * Bundles every Retold-ecosystem theme and exposes five reusable views:
 *
 *   - Theme-Picker      : a custom dropdown listing every registered theme,
 *                         grouped by category, with inline SVG mode-glyphs.
 *                         Switches the active theme on change.
 *   - Theme-ModeToggle  : a 3-button toggle for Light / Dark / System mode.
 *                         Disables itself when the active theme is single-mode.
 *   - Theme-ScaleSelect : a dropdown of viewport scale presets (75% – 200%).
 *                         Independent of theme bundles — applied via CSS
 *                         `zoom` on <html> + a `--theme-scale` custom prop.
 *   - Theme-Button      : an embeddable SVG topbar button that, when clicked,
 *                         opens a pict-section-modal containing the picker,
 *                         the mode toggle, and the scale select. Designed to
 *                         drop into any application chrome.
 *   - Theme-BrandStrip  : the per-app brand signature (icon + name + two
 *                         color stripes). Driven by libThemeBrand which the
 *                         host configures via the `Brand` option.
 *
 * # Recommended consumption (Pict provider)
 *
 * Add the section as a Pict provider — it self-bootstraps on construction:
 *
 *     const libPictSectionTheme = require('pict-section-theme');
 *
 *     pict.addProvider('Theme-Section',
 *     {
 *         ApplyDefault: 'pict-default',
 *         DefaultMode:  'system',
 *         DefaultScale: 1.0,
 *         Brand:        libRetoldManagerBrand
 *     }, libPictSectionTheme);
 *
 * That single addProvider call:
 *   - Ensures `pict.providers.Theme` (the underlying pict-provider-theme
 *     runtime) exists.
 *   - Registers every theme in the runtime registry — bundled starter set
 *     plus anything the host registered via `Catalog.register()`.
 *   - Adds Theme-Picker / Theme-ModeToggle / Theme-ScaleSelect /
 *     Theme-Button / Theme-BrandStrip to `pict.views[...]`.
 *   - Hydrates persisted choices from localStorage; otherwise applies the
 *     supplied `ApplyDefault` / `DefaultMode` / `DefaultScale`.
 *   - Wires the `onApply` save handler so subsequent user picks persist.
 *   - Applies the supplied Brand block if one was provided.
 *
 * # Runtime theme registration
 *
 * The bundled starter set lives in `themes/_catalog.js`. To add custom
 * themes (e.g. a host app's own brand palette, or a remote bundle from
 * a "theme garden") use the registry:
 *
 *     const libCatalog = require('pict-section-theme').Catalog;
 *     libCatalog.register({ Hash: 'my-theme', Bundle: require('./mine.json'), Category: 'App' });
 *     // Or, async, from a URL:
 *     await libCatalog.registerFromURL('https://garden.example.com/themes/foo.json');
 *
 * Themes registered before `addProvider()` runs are picked up
 * automatically. Themes registered after must be manually pushed via
 * `pict.providers.Theme.registerTheme(bundle)`.
 *
 * # Persistence
 *
 * Persisting active theme + mode + scale to localStorage is on by
 * default. Storage key is scoped to `window.location.hostname` so apps
 * on different hosts keep independent state. Override with
 * `PersistenceKey: 'my-app'`. Pass `Persistence: false` to disable.
 *
 * A saved entry takes precedence over `ApplyDefault` — once a user has
 * picked a theme, reloads honour that pick instead of the host's
 * default. If the saved theme hash is no longer in the registry (theme
 * removed, app downgraded), the bootstrap falls back to `ApplyDefault`
 * cleanly.
 *
 * # Legacy API
 *
 * `install(pict, options)` and `registerCatalog(pict)` are still
 * exported as thin shims that delegate to the provider — existing apps
 * keep working without changes.
 */

'use strict';

const libPictProvider = require('pict-provider');
const libPictProviderTheme = require('pict-provider-theme');

const libPickerView = require('./views/PictView-Theme-Picker.js');
const libModeToggleView = require('./views/PictView-Theme-ModeToggle.js');
const libScaleSelectView = require('./views/PictView-Theme-ScaleSelect.js');
const libButtonView = require('./views/PictView-Theme-Button.js');
const libBrandStripView = require('./views/PictView-Theme-BrandStrip.js');
const libBrandMarkView = require('./views/PictView-Theme-Brand-Mark.js');
const libTopBarView = require('./views/PictView-Theme-TopBar.js');
const libBottomBarView = require('./views/PictView-Theme-BottomBar.js');

const libThemePersistence = require('./Theme-Persistence.js');
const libThemeScale = require('./Theme-Scale.js');
const libThemeBrand = require('./Theme-Brand.js');
// Theme-Logo (the deterministic name → SVG generator) is intentionally
// NOT required here. It's a build-time tool used by
// `pict-section-theme-brand` to precompute brand blocks into a host's
// package.json — there's no reason for it to ride along in the runtime
// bundle every host ships. Hosts that want runtime generation can
// `require('pict-section-theme/source/Theme-Logo.js')` directly; that
// keeps the import explicit and the cost opt-in.

const libCatalog = require('./themes/_catalog.js');

// View registry: short-name → { lib, hash } where hash is the
// ViewIdentifier the view registers under in pict.views[...].
const _Views =
{
	Picker:      { lib: libPickerView,      hash: 'Theme-Picker' },
	ModeToggle:  { lib: libModeToggleView,  hash: 'Theme-ModeToggle' },
	ScaleSelect: { lib: libScaleSelectView, hash: 'Theme-ScaleSelect' },
	Button:      { lib: libButtonView,      hash: 'Theme-Button' },
	BrandStrip:  { lib: libBrandStripView,  hash: 'Theme-BrandStrip' },
	BrandMark:   { lib: libBrandMarkView,   hash: 'Theme-Brand-Mark' },
	TopBar:      { lib: libTopBarView,      hash: 'Theme-TopBar' },
	BottomBar:   { lib: libBottomBarView,   hash: 'Theme-BottomBar' }
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme-Section',

	// Don't auto-fire the standard pict-provider initialize chain — we do
	// our setup work synchronously in the constructor so consumers can
	// use the views immediately after addProvider() returns.
	AutoInitialize: false,

	// Bootstrap config — same shape as the legacy install() options.
	ApplyDefault:    null,    // theme hash to apply at boot
	DefaultMode:     null,    // 'light' | 'dark' | 'system' | null (theme's default)
	DefaultScale:    null,    // 0.75 .. 2.0 — viewport scale
	Persistence:     true,
	PersistenceKey:  null,    // null → window.location.hostname
	RegisterCatalog: true,
	Views:           null,    // null → all views; or array of short-names
	ViewOptions:     null,    // { Picker: { ... }, ... } per-view overrides
	Brand:           null,    // { Name, Icon, Colors: { Primary, ... } }
	ProviderOptions: null     // pict-provider-theme overrides if a host wants them
};

// ── Helpers ──────────────────────────────────────────────────────────────

/**
 * Iterate the runtime registry and call provider.registerTheme() for each
 * entry. Safe to call before or after addProvider — the runtime's
 * registerTheme is idempotent on repeat hashes.
 *
 * @param {object} pPict - a Pict instance with the Theme runtime attached
 * @returns {number} count of themes registered
 */
function registerCatalog(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers.Theme)
	{
		if (pPict && pPict.log && pPict.log.warn)
		{
			pPict.log.warn('pict-section-theme.registerCatalog: pict.providers.Theme not found — register the runtime first');
		}
		return 0;
	}
	let tmpProvider = pPict.providers.Theme;
	let tmpEntries = libCatalog.list();
	let tmpCount = 0;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpProvider.registerTheme(tmpEntries[i].Bundle))
		{
			tmpCount++;
		}
	}
	return tmpCount;
}

/**
 * Return the registry as picker-friendly metadata (no Bundle payload).
 *
 * @returns {Array<{Hash, Name, Category, Strategy, DefaultMode, IsDefault}>}
 */
function listCatalog()
{
	let tmpEntries = libCatalog.list();
	let tmpList = [];
	for (let i = 0; i < tmpEntries.length; i++)
	{
		let tmpEntry = tmpEntries[i];
		let tmpBundle = tmpEntry.Bundle || {};
		let tmpModes = tmpBundle.Modes || {};
		tmpList.push(
		{
			Hash: tmpEntry.Hash,
			Name: tmpBundle.Name || tmpEntry.Hash,
			Category: tmpEntry.Category || 'Other',
			Strategy: tmpModes.Strategy || 'single',
			DefaultMode: tmpModes.Default || 'light',
			IsDefault: !!tmpEntry.IsDefault
		});
	}
	return tmpList;
}

// ── Bootstrap routine ────────────────────────────────────────────────────
// Shared between the provider class (new path) and the install() function
// (legacy path). Performs the actual wiring against a Pict instance.
function _bootstrap(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme: requires a Pict instance');
	}
	let tmpOptions = pOptions || {};

	// 1. Theme runtime — only add if not already attached (hosts with
	//    a custom runtime, e.g. retold-remote's V2 bridge, pre-register).
	if (!pPict.providers || !pPict.providers.Theme)
	{
		let tmpRuntimeOpts = Object.assign({},
			libPictProviderTheme.default_configuration, tmpOptions.ProviderOptions || {});
		pPict.addProvider('Theme', tmpRuntimeOpts, libPictProviderTheme);
	}

	// 2. Catalog — every entry from the runtime registry, unless the host
	//    asked to skip (RegisterCatalog: false).
	if (tmpOptions.RegisterCatalog !== false)
	{
		registerCatalog(pPict);
	}

	// 3. Views — default all five; pass an array to subset.
	let tmpViewNames = Array.isArray(tmpOptions.Views) ? tmpOptions.Views : Object.keys(_Views);
	for (let i = 0; i < tmpViewNames.length; i++)
	{
		let tmpEntry = _Views[tmpViewNames[i]];
		if (!tmpEntry)
		{
			if (pPict.log && pPict.log.warn)
			{
				pPict.log.warn('pict-section-theme: unknown view name "' + tmpViewNames[i] + '" — skipped');
			}
			continue;
		}
		if (pPict.views && pPict.views[tmpEntry.hash])
		{
			// Already registered — skip silently.
			continue;
		}
		let tmpViewOpts = Object.assign({},
			tmpEntry.lib.default_configuration,
			(tmpOptions.ViewOptions && tmpOptions.ViewOptions[tmpViewNames[i]]) || {});
		pPict.addView(tmpEntry.hash, tmpViewOpts, tmpEntry.lib);
	}

	// 4. Persistence + initial apply.
	let tmpProvider = pPict.providers.Theme;
	let tmpPersistenceEnabled = (tmpOptions.Persistence !== false);
	let tmpPersistenceKey = null;

	let tmpBootHash  = tmpOptions.ApplyDefault || null;
	let tmpBootMode  = tmpOptions.DefaultMode  || null;
	let tmpBootScale = (typeof tmpOptions.DefaultScale === 'number') ? tmpOptions.DefaultScale : null;

	if (tmpPersistenceEnabled && tmpProvider)
	{
		tmpPersistenceKey = libThemePersistence.resolveKey(tmpOptions.PersistenceKey);

		let tmpSaved = libThemePersistence.load(tmpPersistenceKey);
		if (tmpSaved
			&& tmpSaved.ThemeHash
			&& typeof tmpProvider.getTheme === 'function'
			&& tmpProvider.getTheme(tmpSaved.ThemeHash))
		{
			tmpBootHash = tmpSaved.ThemeHash;
			if (tmpSaved.Mode)  { tmpBootMode  = tmpSaved.Mode; }
			if (tmpSaved.Scale) { tmpBootScale = tmpSaved.Scale; }
		}
		else if (tmpSaved && tmpSaved.Scale)
		{
			tmpBootScale = tmpSaved.Scale;
		}

		// Single save snapshot — both the provider listener and the scale
		// listener call this so any change persists the full set.
		let tmpSaveCurrent = function ()
		{
			let tmpActive = (typeof tmpProvider.getActiveTheme === 'function')
				? tmpProvider.getActiveTheme() : { Hash: null, Mode: null };
			libThemePersistence.save(tmpPersistenceKey,
			{
				ThemeHash: tmpActive.Hash,
				Mode:      tmpActive.Mode,
				Scale:     libThemeScale.getActive()
			});
		};

		tmpProvider.onApply(tmpSaveCurrent);
		libThemeScale.onChange(tmpSaveCurrent);
	}

	if (tmpBootHash && tmpProvider)
	{
		tmpProvider.applyTheme(tmpBootHash, tmpBootMode);
	}
	if (tmpBootScale !== null)
	{
		libThemeScale.applyScale(tmpBootScale);
	}

	// 5. Brand — host-supplied app identity. Apply LAST so the BrandStrip
	//    view's first paint sees the CSS custom properties.
	if (tmpOptions.Brand)
	{
		libThemeBrand.applyBrand(tmpOptions.Brand);
	}

	// Stash the resolved key on the provider for debugging + so the host
	// can clear it via clearPersistence() for a "reset to defaults"
	// affordance.
	if (tmpProvider && tmpPersistenceKey)
	{
		tmpProvider._persistenceKey = tmpPersistenceKey;
	}

	return tmpProvider;
}

// ── PictProvider class ───────────────────────────────────────────────────
// The recommended entry point. `pict.addProvider('Theme-Section',
// options, PictSectionThemeProvider)` self-bootstraps the whole module
// (runtime + catalog + views + persistence + apply + brand) inside the
// constructor — no follow-up install() call required.
class PictSectionThemeProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictSectionTheme';

		// pict-provider sets `this.pict` for us via super() above. Run the
		// bootstrap synchronously so the views, theme runtime, and applied
		// theme are all in place before addProvider() returns.
		_bootstrap(this.pict, this.options);
	}

	/**
	 * Embed theme controls into a host-supplied container.
	 *
	 * The Theme-Button view ships a popover that hosts the picker + mode
	 * toggle + scale select — convenient for "drop a theme menu in the
	 * topbar" but not for apps that already have a settings surface and
	 * want the controls inline there. `mount()` writes the destination
	 * divs each theme view expects into the supplied container, then
	 * calls render() on each requested view.
	 *
	 * Important: each theme view has a SINGLE default destination id
	 * (e.g. `#Theme-Picker`). Mounting overrides where the view paints —
	 * once mount() is called, the picker / toggle / scale destinations
	 * live inside the supplied container. Combining a mount() with a
	 * Theme-Button popover that ALSO hosts these views causes duplicate
	 * destination ids and undefined behaviour; pick one host per view.
	 *
	 * @param {object} pOptions
	 * @param {string|HTMLElement} pOptions.Container - CSS selector or element
	 * @param {Array<string>} [pOptions.Views] - short names; default ['Picker','ModeToggle','ScaleSelect']
	 * @param {string} [pOptions.WrapperClass] - class added to the outer wrapper div
	 * @returns {object|null} { container, viewsRendered } on success, null if the container can't be resolved
	 */
	mount(pOptions)
	{
		let tmpOpts = pOptions || {};
		let tmpContainer = tmpOpts.Container;
		if (!tmpContainer) { return null; }
		let tmpEl = (typeof tmpContainer === 'string')
			? (this.pict && this.pict.ContentAssignment
				? this.pict.ContentAssignment.getElement(tmpContainer)
				: document.querySelector(tmpContainer))
			: tmpContainer;
		// ContentAssignment.getElement returns an array-like; normalise to one node.
		if (tmpEl && tmpEl.length && !tmpEl.tagName) { tmpEl = tmpEl[0]; }
		if (!tmpEl)
		{
			if (this.pict && this.pict.log && this.pict.log.warn)
			{
				this.pict.log.warn('pict-section-theme.mount: container not found for ' + tmpContainer);
			}
			return null;
		}

		let tmpRequested = Array.isArray(tmpOpts.Views) && tmpOpts.Views.length
			? tmpOpts.Views
			: ['Picker', 'ModeToggle', 'ScaleSelect'];

		// Build a wrapper that carries one row per requested view; each row
		// contains the destination div the view's render() will write into.
		let tmpRows = [];
		let tmpRendered = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			let tmpEntry = _Views[tmpRequested[i]];
			if (!tmpEntry) { continue; }
			let tmpDestSel = tmpEntry.lib.default_configuration.DefaultDestinationAddress || '';
			let tmpDestId = tmpDestSel.replace(/^#/, '');
			if (!tmpDestId) { continue; }
			tmpRows.push(
				'<div class="pict-theme-mount-row pict-theme-mount-row-' + tmpEntry.hash.toLowerCase() + '">'
					+ '<div id="' + tmpDestId + '"></div>'
				+ '</div>');
			tmpRendered.push(tmpEntry.hash);
		}

		let tmpWrapperClass = 'pict-theme-mount' + (tmpOpts.WrapperClass ? ' ' + tmpOpts.WrapperClass : '');
		tmpEl.innerHTML = '<div class="' + tmpWrapperClass + '">' + tmpRows.join('') + '</div>';

		// Render each requested view. Each render() targets the destination
		// id we just stamped into the wrapper.
		for (let i = 0; i < tmpRendered.length; i++)
		{
			let tmpView = this.pict.views[tmpRendered[i]];
			if (tmpView && typeof tmpView.render === 'function')
			{
				try { tmpView.render(); }
				catch (pErr) { /* a view render failure shouldn't break the host */ }
			}
		}

		return { container: tmpEl, viewsRendered: tmpRendered };
	}
}

// ── Legacy install() ─────────────────────────────────────────────────────
// Thin shim for apps that already call install(); delegates to the same
// bootstrap routine the provider runs.
function install(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme.install: first arg must be a Pict instance');
	}
	return _bootstrap(pPict, pOptions || {});
}

/**
 * Drop the saved theme state for this app's storage key. The next
 * install() (or page reload / addProvider) falls back to ApplyDefault.
 *
 * @param {object} pPict - the pict instance
 * @returns {boolean} true if anything was cleared
 */
function clearPersistence(pPict)
{
	let tmpKey = (pPict && pPict.providers && pPict.providers.Theme && pPict.providers.Theme._persistenceKey)
		|| libThemePersistence.resolveKey(null);
	return libThemePersistence.clear(tmpKey);
}

// ── Exports ──────────────────────────────────────────────────────────────
// Default export = the provider class so apps can do:
//   pict.addProvider('Theme-Section', { ... }, libPictSectionTheme);
//
// Named exports preserved so legacy callers keep working unchanged.
module.exports = PictSectionThemeProvider;
module.exports.default_configuration = _ProviderConfiguration;

module.exports.Provider = libPictProviderTheme;             // the runtime class
module.exports.PictSectionThemeProvider = PictSectionThemeProvider;
module.exports.PickerView = libPickerView;
module.exports.ModeToggleView = libModeToggleView;
module.exports.ButtonView = libButtonView;
module.exports.ScaleSelectView = libScaleSelectView;
module.exports.BrandStripView = libBrandStripView;
module.exports.BrandMarkView = libBrandMarkView;
module.exports.TopBarView = libTopBarView;
module.exports.BottomBarView = libBottomBarView;
module.exports.Catalog = libCatalog;                        // the registry singleton
module.exports.Brand = libThemeBrand;                       // the brand helper module
module.exports.Scale = libThemeScale;                       // the scale helper module
module.exports.Persistence = libThemePersistence;           // the persistence helper module
// Theme-Logo is exposed as a sub-module path, not a top-level field —
// see the comment near the imports above.
module.exports.registerCatalog = registerCatalog;
module.exports.listCatalog = listCatalog;
module.exports.install = install;
module.exports.clearPersistence = clearPersistence;

},{"./Theme-Brand.js":78,"./Theme-Persistence.js":80,"./Theme-Scale.js":81,"./themes/_catalog.js":85,"./views/PictView-Theme-BottomBar.js":126,"./views/PictView-Theme-Brand-Mark.js":127,"./views/PictView-Theme-BrandStrip.js":128,"./views/PictView-Theme-Button.js":129,"./views/PictView-Theme-ModeToggle.js":130,"./views/PictView-Theme-Picker.js":131,"./views/PictView-Theme-ScaleSelect.js":132,"./views/PictView-Theme-TopBar.js":133,"pict-provider":15,"pict-provider-theme":9}],78:[function(require,module,exports){
/**
 * Theme-Brand — app-level brand identity (icon + colors) that overlays
 * the active theme.
 *
 * # What this is for
 *
 * The active *theme* describes how UI surfaces look (panel colors,
 * borders, text, status). The active *brand* describes which APP the
 * user is in. retold-facto, retold-manager, and ultravisor can share
 * the same theme but each carries its own visual signature: a small
 * icon and two brand colors that show up in a stripe under the nav
 * (and optionally tinge link underlines, header accents, etc. when
 * the active theme opts to reference them).
 *
 * Brand is host-supplied (passed to pict-section-theme.install() as
 * `Brand: {...}` or applied later via this module's `applyBrand()`)
 * and NOT user-pickable — it's the app's wordmark. It's also not
 * persisted; the host config drives it on every boot.
 *
 * # Brand shape
 *
 * Two equivalent forms — pick whichever reads better in your app.
 *
 * ## Recommended: nested form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:   { Light: '#0044cc', Dark: '#6b8eff' },   // both required
 *       Secondary: { Light: '#c75033', Dark: '#ff8a6b' }    // both required
 *     },
 *     Tagline: 'Optional short tagline'
 *   }
 *
 * This mirrors how theme JSONs already structure their Tokens.Color.*
 * trees, makes the "explicit light + dark variants" contract obvious,
 * and means your brand and your theme look consistent in source.
 *
 * ## Legacy: flat form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:        '#0066ff',                // required
 *       Secondary:      '#ff6600',                // required
 *       PrimaryLight:   '#3388ff',                // optional, light-mode tint
 *       PrimaryDark:    '#0044cc',                // optional, dark-mode tint
 *       SecondaryLight: '#ff8833',
 *       SecondaryDark:  '#cc4400'
 *     }
 *   }
 *
 * The flat form's `Primary` / `Secondary` are mode-agnostic constants
 * (used for the `--brand-color-primary` / `-secondary` CSS variables);
 * the *Light / *Dark fields drive the mode-aware variants. When the
 * Light / Dark fields are omitted, the base Primary / Secondary
 * doubles for both modes. Both forms land on the same six output CSS
 * variables — see "CSS variables emitted" below.
 *
 * Icon shape: inline SVG markup, OR a data URL, OR a remote / app-served
 * URL. IconType is optional and auto-detected from the value.
 *
 * # CSS variables emitted
 *
 *   :root {
 *     --brand-color-primary:           <Primary>
 *     --brand-color-secondary:         <Secondary>
 *     --brand-color-primary-light:     <PrimaryLight or Primary>
 *     --brand-color-primary-dark:      <PrimaryDark or Primary>
 *     --brand-color-secondary-light:   <SecondaryLight or Secondary>
 *     --brand-color-secondary-dark:    <SecondaryDark or Secondary>
 *     --brand-color-primary-mode:      <Primary OR PrimaryLight in :root>
 *     --brand-color-secondary-mode:    <Secondary OR SecondaryLight in :root>
 *     --brand-name:                    "<Name>"
 *   }
 *   .theme-dark {
 *     --brand-color-primary-mode:      <PrimaryDark or Primary>
 *     --brand-color-secondary-mode:    <SecondaryDark or Secondary>
 *   }
 *
 * The `*-mode` variables are the ones theme/host CSS should reach for
 * when they want a brand color that automatically swaps for dark mode
 * (parallel to how --theme-color-* works). The plain Primary/Secondary
 * are constants that ignore the mode toggle — useful for the brand
 * stripe itself, where the brand should look the same in both modes.
 *
 * # Listener pattern
 *
 * Mirrors Theme-Scale: subscribe via `onBrandChange(cb)`, dispose by
 * calling the returned function. The BrandStrip view uses this to
 * re-render when the host changes brand at runtime (rare, but used by
 * test harnesses + multi-tenant hosts).
 */

const STYLE_ELEMENT_ID = 'pict-brand';
const FAVICON_LINK_ID = 'pict-brand-favicon';
const FAVICON_DARK_LINK_ID = 'pict-brand-favicon-dark';

let _activeBrand = null;
let _listeners = [];

function _isInlineSVG(pIcon)
{
	return (typeof pIcon === 'string') && /^\s*<svg[\s>]/i.test(pIcon);
}

function _isImageURL(pIcon)
{
	if (typeof pIcon !== 'string') return false;
	return /^(data:|https?:|\/|\.\.?\/)/.test(pIcon);
}

function _detectIconType(pBrand)
{
	if (pBrand && typeof pBrand.IconType === 'string') return pBrand.IconType;
	if (!pBrand || !pBrand.Icon) return null;
	if (_isInlineSVG(pBrand.Icon)) return 'svg';
	if (_isImageURL(pBrand.Icon)) return 'image';
	return null;
}

// Resolve a "color slot" to { Light, Dark, Base } regardless of input
// shape. Supported inputs:
//   - "string"                        → all three equal that string
//   - { Light, Dark }                 → Base = Light, others as given
//   - { Light, Dark, Base }           → Base explicit
//   - missing                         → null (caller decides how to fail)
function _resolveColorSlot(pSlot)
{
	if (typeof pSlot === 'string' && pSlot.length > 0)
	{
		return { Light: pSlot, Dark: pSlot, Base: pSlot };
	}
	if (pSlot && typeof pSlot === 'object')
	{
		let tmpLight = (typeof pSlot.Light === 'string' && pSlot.Light.length > 0) ? pSlot.Light : null;
		let tmpDark  = (typeof pSlot.Dark  === 'string' && pSlot.Dark.length  > 0) ? pSlot.Dark  : null;
		// Need at least one variant present.
		if (!tmpLight && !tmpDark) return null;
		// Fill missing variant from the other side. Base defaults to
		// the light variant (matches the legacy flat-form semantics).
		tmpLight = tmpLight || tmpDark;
		tmpDark  = tmpDark  || tmpLight;
		let tmpBase = (typeof pSlot.Base === 'string' && pSlot.Base.length > 0) ? pSlot.Base : tmpLight;
		return { Light: tmpLight, Dark: tmpDark, Base: tmpBase };
	}
	return null;
}

function _normalize(pBrand)
{
	if (!pBrand || typeof pBrand !== 'object') return null;
	let tmpColors = pBrand.Colors || {};

	// Brand colors accept TWO forms — flat or nested:
	//
	//   FLAT (legacy):
	//     Colors: {
	//       Primary:        '#e54b1e',     // required (the mode-agnostic value)
	//       Secondary:      '#1e9aa0',     // required
	//       PrimaryLight:   '#e54b1e',     // optional fallback to Primary
	//       PrimaryDark:    '#ff7a4a',     // optional fallback to Primary
	//       SecondaryLight: '#1e9aa0',     // optional fallback to Secondary
	//       SecondaryDark:  '#5fc5cb'      // optional fallback to Secondary
	//     }
	//
	//   NESTED (recommended):
	//     Colors: {
	//       Primary:   { Light: '#e54b1e', Dark: '#ff7a4a' },  // both required
	//       Secondary: { Light: '#1e9aa0', Dark: '#5fc5cb' }   // both required
	//     }
	//
	// The nested form mirrors how themes already structure their
	// Tokens.Color.* trees and makes the "this brand needs explicit
	// light + dark variants" contract obvious. Either form lands on
	// the same six --brand-color-* CSS variables.
	let tmpPriSlot = _resolveColorSlot(tmpColors.Primary);
	let tmpSecSlot = _resolveColorSlot(tmpColors.Secondary);
	if (!tmpPriSlot || !tmpSecSlot) return null;

	// Legacy flat-form fields override the resolved slot's Light/Dark
	// (so a host passing both forms gets the most explicit one).
	let tmpPriLight = tmpColors.PrimaryLight   || tmpPriSlot.Light;
	let tmpPriDark  = tmpColors.PrimaryDark    || tmpPriSlot.Dark;
	let tmpSecLight = tmpColors.SecondaryLight || tmpSecSlot.Light;
	let tmpSecDark  = tmpColors.SecondaryDark  || tmpSecSlot.Dark;

	return {
		Hash:    pBrand.Hash || 'brand',
		Name:    pBrand.Name || pBrand.Hash || 'Brand',
		Icon:    pBrand.Icon || null,
		IconType: _detectIconType(pBrand),
		Tagline: (typeof pBrand.Tagline === 'string') ? pBrand.Tagline : null,
		// Optional favicon assets. Each can be: inline `<svg>` markup, a
		// data URL, or a regular URL. When both Favicon and FaviconDark
		// are supplied, paired light/dark <link rel="icon"> tags are
		// emitted with prefers-color-scheme media queries; otherwise a
		// single <link> covers both modes.
		Favicon:     pBrand.Favicon     || null,
		FaviconDark: pBrand.FaviconDark || null,
		Colors:
		{
			Primary:        tmpPriSlot.Base,
			Secondary:      tmpSecSlot.Base,
			PrimaryLight:   tmpPriLight,
			PrimaryDark:    tmpPriDark,
			SecondaryLight: tmpSecLight,
			SecondaryDark:  tmpSecDark
		}
	};
}

// Encode an inline `<svg>` blob into a data URL safe for an <img src> /
// <link href> attribute. Falls through if the input already looks like
// a URL (data:, http:, /, ./, ../).
function _faviconHref(pIcon)
{
	if (!pIcon || typeof pIcon !== 'string') return null;
	if (_isInlineSVG(pIcon))
	{
		// percent-encode SVG markup. Don't encode '#' or '&' minimally;
		// the safe path is to encode aggressively then unescape spaces.
		let tmpEncoded = encodeURIComponent(pIcon).replace(/'/g, '%27').replace(/"/g, '%22');
		return 'data:image/svg+xml;charset=utf-8,' + tmpEncoded;
	}
	if (_isImageURL(pIcon)) return pIcon;
	return null;
}

function _removeFaviconLinks()
{
	if (typeof document === 'undefined') return;
	[FAVICON_LINK_ID, FAVICON_DARK_LINK_ID].forEach((pID) =>
	{
		let tmpEl = document.getElementById(pID);
		if (tmpEl && tmpEl.parentNode) tmpEl.parentNode.removeChild(tmpEl);
	});
}

function _injectFaviconLinks(pBrand)
{
	if (typeof document === 'undefined') return;
	_removeFaviconLinks();

	let tmpLight = _faviconHref(pBrand.Favicon);
	let tmpDark  = _faviconHref(pBrand.FaviconDark);
	if (!tmpLight && !tmpDark) return;

	let tmpHasPair = !!(tmpLight && tmpDark);

	if (tmpLight)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpLight;
		if (/^data:image\/svg\+xml/.test(tmpLight)) tmpLink.type = 'image/svg+xml';
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: light)';
		document.head.appendChild(tmpLink);
	}

	if (tmpDark)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_DARK_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpDark;
		if (/^data:image\/svg\+xml/.test(tmpDark)) tmpLink.type = 'image/svg+xml';
		// If we have a light variant, the dark link's media query handles
		// the swap; otherwise it serves both modes.
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: dark)';
		document.head.appendChild(tmpLink);
	}
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

// Escape so the brand name can ride along inside the CSS `content`-style
// `--brand-name` value as a quoted string.
function _cssQuote(pStr)
{
	return '"' + String(pStr || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
}

function _buildCSS(pBrand)
{
	let tmpC = pBrand.Colors;
	let tmpRoot = ':root {\n'
		+ '\t--brand-color-primary:         ' + tmpC.Primary + ';\n'
		+ '\t--brand-color-secondary:       ' + tmpC.Secondary + ';\n'
		+ '\t--brand-color-primary-light:   ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-primary-dark:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-light: ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-color-secondary-dark:  ' + tmpC.SecondaryDark + ';\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-name:                  ' + _cssQuote(pBrand.Name) + ';\n'
		+ '}\n';
	// Dark-mode overrides for the *-mode variables only.
	let tmpDark = '.theme-dark {\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryDark + ';\n'
		+ '}\n';
	return tmpRoot + tmpDark;
}

/**
 * Apply (or replace) the active brand. Pass `null` to clear.
 *
 * @param {object|null} pBrand
 * @returns {object|null} the normalized active brand (or null on clear)
 */
function applyBrand(pBrand)
{
	let tmpPrev = _activeBrand;

	if (pBrand === null)
	{
		_activeBrand = null;
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
		}
		_removeFaviconLinks();
		_fireChange(null, tmpPrev);
		return null;
	}

	let tmpNorm = _normalize(pBrand);
	if (!tmpNorm)
	{
		// Bad input — keep current brand, no-op.
		if (typeof console !== 'undefined' && console.warn)
		{
			console.warn('Theme-Brand.applyBrand: bad brand object — needs Colors.Primary + Colors.Secondary as strings.');
		}
		return _activeBrand;
	}

	_activeBrand = tmpNorm;
	_injectStyleElement(_buildCSS(tmpNorm));
	_injectFaviconLinks(tmpNorm);
	_fireChange(tmpNorm, tmpPrev);
	return tmpNorm;
}

function getActive()
{
	return _activeBrand;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNew, pOld)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNew, pOld); }
		catch (pErr) { /* swallow — listener failure must not break callers */ }
	}
}

/**
 * Reset to no-brand state and detach the injected style. Tests use this;
 * runtime hosts rarely need it.
 */
function reset()
{
	applyBrand(null);
	_listeners = [];
}

module.exports =
{
	applyBrand:      applyBrand,
	getActive:       getActive,
	onChange:        onChange,
	offChange:       offChange,
	reset:           reset,
	STYLE_ELEMENT_ID:      STYLE_ELEMENT_ID,
	FAVICON_LINK_ID:       FAVICON_LINK_ID,
	FAVICON_DARK_LINK_ID:  FAVICON_DARK_LINK_ID
};

},{}],79:[function(require,module,exports){
/**
 * Theme-Icons — single source of truth for the inline SVG glyphs the
 * theme section uses (sun, moon, system / monitor, plus a chevron for
 * dropdown triggers).
 *
 * Every icon:
 *   - Is a self-contained SVG string suitable for direct DOM insertion
 *     (innerHTML, template substitution, or pict-section-modal's
 *     `Icon: <html>` field on dropdown items).
 *   - Uses `currentColor` for stroke so it picks up the surrounding
 *     text colour from the active theme (light + dark both look right
 *     without per-mode swaps).
 *   - Has `aria-hidden="true"` so screen readers ignore the decorative
 *     glyph and rely on the surrounding label / aria-label instead.
 *
 * The shapes are intentionally line-art (stroke-based, fill="none") so
 * they read at very small sizes (12–16 px) without going muddy. The
 * "system" icon is a stylised display (rectangle + stand) rather than
 * the unicode 🖥 to keep visual weight consistent with sun + moon.
 *
 * Need a different size? Pass `pSizePx` to any of the iconXxx() helpers
 * and the wrapper SVG's width/height are emitted with that value. The
 * default is 14 px which matches the mode toggle's existing visual.
 */

const _DEFAULT_SIZE_PX = 14;

function _wrap(pSizePx, pInner)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	return '<svg class="pict-theme-icon"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 24 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ pInner
		+ '</svg>';
}

/**
 * Sun glyph — central disc + 8 radial rays. Communicates "light mode"
 * universally. Slightly chunkier disc than the typical Feather sun so
 * it still reads at 12 px.
 */
function iconSun(pSizePx)
{
	return _wrap(pSizePx,
		'<circle cx="12" cy="12" r="4"/>'
		+ '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>');
}

/**
 * Moon glyph — clean crescent (one continuous filled-look path drawn
 * as a stroke). Avoids the brittle thin-crescent unicode characters
 * that fall back to weird outline glyphs in some system fonts.
 */
function iconMoon(pSizePx)
{
	return _wrap(pSizePx,
		'<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>');
}

/**
 * System / display glyph — a small monitor with a stand. Communicates
 * "follow the OS preference" without ambiguity (a monitor is universal
 * UI for system settings, more than the gear icon would be).
 */
function iconSystem(pSizePx)
{
	return _wrap(pSizePx,
		'<rect x="2" y="4" width="20" height="14" rx="2"/>'
		+ '<path d="M8 21h8M12 18v3"/>');
}

/**
 * Composite: a sun + moon side-by-side, sized so the two icons fit in
 * the same horizontal footprint as a single icon. Used in the picker
 * to indicate a paired (Light + Dark) theme without needing two
 * separate visual columns.
 */
function iconPaired(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	// Each half uses currentColor; the sun is rendered slightly smaller
	// in the left half and the moon in the right half by abusing the
	// viewBox width.
	return '<svg class="pict-theme-icon pict-theme-icon-paired"'
		+ ' width="' + (tmpSize * 1.6) + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 38 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		// Sun on the left (centred at 8,12, radius 3)
		+ '<circle cx="8" cy="12" r="3"/>'
		+ '<path d="M8 4v1.5M8 18.5V20M2.5 12H4M12 12h1.5M4.1 7.1l1 1M11.1 7.1l-1 1M4.1 16.9l1-1M11.1 16.9l-1-1"/>'
		// Moon on the right (mirrored crescent, centred near x=28)
		+ '<path d="M33 13.5A6.5 6.5 0 1 1 26 6a5 5 0 0 0 7 7.5z"/>'
		+ '</svg>';
}

/**
 * Down-chevron used by dropdown triggers. Sized to sit alongside body
 * text (10 px default).
 */
function iconChevronDown(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : 10;
	return '<svg class="pict-theme-icon pict-theme-icon-chevron"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 12 12" fill="none"'
		+ ' stroke="currentColor" stroke-width="1.6"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ '<path d="M3 4.5l3 3 3-3"/>'
		+ '</svg>';
}

/**
 * Pick the right capability icon for a theme based on its mode strategy.
 * Returns the composite paired glyph for paired themes, sun for light-only,
 * moon for dark-only.
 *
 * @param {string} pStrategy - 'single' or 'system'/'paired'
 * @param {string} pDefaultMode - 'light' or 'dark' (only consulted for single)
 * @param {number} [pSizePx]
 */
function iconForTheme(pStrategy, pDefaultMode, pSizePx)
{
	if (pStrategy === 'single')
	{
		return (pDefaultMode === 'dark') ? iconMoon(pSizePx) : iconSun(pSizePx);
	}
	return iconPaired(pSizePx);
}

module.exports =
{
	iconSun:         iconSun,
	iconMoon:        iconMoon,
	iconSystem:      iconSystem,
	iconPaired:      iconPaired,
	iconChevronDown: iconChevronDown,
	iconForTheme:    iconForTheme,
	DEFAULT_SIZE_PX: _DEFAULT_SIZE_PX
};

},{}],80:[function(require,module,exports){
/**
 * Theme-Persistence — reads and writes the user's selected theme + mode
 * to the browser's localStorage so a reload restores the same look.
 *
 * pict-provider-theme is intentionally stateless — host applications
 * decide what to apply at boot. This module is the small, opt-out-able
 * layer that pict-section-theme.install() uses to make "remember my
 * theme" the default behaviour without forcing every consumer to wire
 * it themselves.
 *
 * # Storage shape
 *
 * Every entry is a single JSON object under one key:
 *
 *   localStorage["pict-section-theme:<scope>"] =
 *     {
 *       Version:   1,
 *       ThemeHash: "retold-manager",
 *       Mode:      "dark",
 *       Scale:     1.25,
 *       SavedAt:   "2026-05-09T21:00:00.000Z"
 *     }
 *
 * Version-tagged so future schema changes can be migrated cleanly;
 * mismatched versions are treated as "no saved entry" and the host
 * application's defaults take over. Older entries that pre-date the
 * Scale field are still valid — Scale is optional and load() returns
 * null for it when absent (caller defaults to 1.0).
 *
 * # Scope (the <scope> portion of the key)
 *
 * Determined in this priority order:
 *   1. The string the host passed in (`PersistenceKey: 'my-app'`) —
 *      use this when one host serves multiple logical apps from the
 *      same origin and they shouldn't share theme state.
 *   2. window.location.hostname when running in a browser.
 *   3. The literal 'default' as a last-ditch fallback (Node, sandbox,
 *      mid-SSR, etc.).
 *
 * # Failure modes
 *
 * - localStorage missing (SSR, Safari private mode, blocked) →
 *   load() returns null, save() returns false, no exception.
 * - Quota exceeded → save() returns false silently; the in-memory
 *   active theme is unaffected.
 * - JSON parse error or version mismatch → load() returns null so the
 *   caller falls back to ApplyDefault.
 *
 * Nothing here throws — persistence failures must NEVER crash the host
 * application's boot path.
 */

const STORAGE_PREFIX = 'pict-section-theme:';
const SCHEMA_VERSION = 1;

function _getStorage()
{
	try
	{
		if (typeof window !== 'undefined' && window.localStorage)
		{
			return window.localStorage;
		}
	}
	catch (pErr) { /* SecurityError in some contexts */ }
	return null;
}

function _autoScope()
{
	try
	{
		if (typeof window !== 'undefined' && window.location && window.location.hostname)
		{
			return window.location.hostname;
		}
	}
	catch (pErr) { /* fall through */ }
	return 'default';
}

/**
 * Resolve the full localStorage key for this app's theme state.
 *
 * @param {string|null} pUserKey - Host-supplied scope override; falsy
 *   values trigger the auto-scope fallback (hostname → 'default').
 * @returns {string} the fully-qualified localStorage key.
 */
function resolveKey(pUserKey)
{
	let tmpScope = (typeof pUserKey === 'string' && pUserKey.length > 0)
		? pUserKey
		: _autoScope();
	return STORAGE_PREFIX + tmpScope;
}

/**
 * Read the saved theme state for a key.  Returns null if nothing is
 * stored, the storage is unavailable, or the entry's schema version
 * doesn't match.
 *
 * @param {string} pKey - the resolved storage key
 * @returns {{ThemeHash: string, Mode: string|null, Scale: number|null}|null}
 */
function load(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return null;

	let tmpRaw;
	try { tmpRaw = tmpStore.getItem(pKey); }
	catch (pErr) { return null; }
	if (!tmpRaw) return null;

	let tmpParsed;
	try { tmpParsed = JSON.parse(tmpRaw); }
	catch (pErr) { return null; }

	if (!tmpParsed || typeof tmpParsed !== 'object') return null;
	if (tmpParsed.Version !== SCHEMA_VERSION) return null;
	if (typeof tmpParsed.ThemeHash !== 'string' || tmpParsed.ThemeHash.length === 0) return null;

	let tmpScale = null;
	if (typeof tmpParsed.Scale === 'number' && isFinite(tmpParsed.Scale) && tmpParsed.Scale > 0)
	{
		tmpScale = tmpParsed.Scale;
	}

	return {
		ThemeHash: tmpParsed.ThemeHash,
		Mode:      (typeof tmpParsed.Mode === 'string' && tmpParsed.Mode.length > 0)
			? tmpParsed.Mode
			: null,
		Scale:     tmpScale
	};
}

/**
 * Persist the active theme + mode for this key.  No-ops gracefully
 * when storage is unavailable or quota is exceeded.
 *
 * @param {string} pKey
 * @param {{ThemeHash: string, Mode?: string, Scale?: number}} pState
 * @returns {boolean} true on success, false otherwise
 */
function save(pKey, pState)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	if (!pState || typeof pState.ThemeHash !== 'string' || pState.ThemeHash.length === 0) return false;

	let tmpEntry =
	{
		Version:   SCHEMA_VERSION,
		ThemeHash: pState.ThemeHash,
		Mode:      (typeof pState.Mode === 'string' && pState.Mode.length > 0) ? pState.Mode : null,
		Scale:     (typeof pState.Scale === 'number' && isFinite(pState.Scale) && pState.Scale > 0)
			? pState.Scale
			: null,
		SavedAt:   new Date().toISOString()
	};

	try { tmpStore.setItem(pKey, JSON.stringify(tmpEntry)); return true; }
	catch (pErr) { return false; }
}

/**
 * Remove the saved theme state for a key.  Useful for "reset to
 * defaults" actions.
 */
function clear(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	try { tmpStore.removeItem(pKey); return true; }
	catch (pErr) { return false; }
}

module.exports =
{
	resolveKey: resolveKey,
	load:       load,
	save:       save,
	clear:      clear,
	STORAGE_PREFIX: STORAGE_PREFIX,
	SCHEMA_VERSION: SCHEMA_VERSION
};

},{}],81:[function(require,module,exports){
/**
 * Theme-Scale — viewport scale (zoom) selector independent of theme bundles.
 *
 * Scale is a *user preference*, not a property of any particular theme:
 * the user might want Cyberpunk-at-1.25x or Retold-Manager-at-0.85x.
 * Pict-provider-theme is intentionally bundle-shaped (Tokens / SVG /
 * Image), so scale lives here at the section layer alongside Mode.
 *
 * # Apply mechanism
 *
 * Two outputs feed cooperating CSS:
 *
 *   1. `html { zoom: <scale>; }` — works for legacy stylesheets that
 *      use `px` everywhere (most Retold apps including retold-manager).
 *      Browsers (Chromium-based + Firefox 126+ + Safari) all honour
 *      `zoom` on root.
 *
 *   2. `:root { --theme-scale: <scale>; }` — exposed for stylesheets
 *      that want to opt into explicit `calc(... * var(--theme-scale))`
 *      sizing. Keeps the value addressable from JS too via
 *      `getComputedStyle(document.documentElement).getPropertyValue(...)`.
 *
 * Both are written into a single `<style id="pict-theme-scale">` element
 * appended to `<head>` after the theme provider's own style element so
 * scale wins last. Re-applying just rewrites this one element's text.
 *
 * # Listener pattern
 *
 * Mirrors pict-provider-theme.onApply(): subscribers receive the new
 * scale value plus the previous value and a return-able `dispose`
 * function. The persistence wiring in pict-section-theme.install()
 * uses this to autosave whenever the scale changes.
 *
 * # Stateless across instances
 *
 * No singleton state — each browser window has one DOM, so the module
 * tracks active scale via a module-level variable, but exposes
 * `getActive()` for callers that want to query it. `applyScale()` is
 * idempotent: applying the same value re-injects the same CSS (cheap
 * no-op).
 */

const STYLE_ELEMENT_ID = 'pict-theme-scale';
const CSS_VAR_NAME = '--theme-scale';
const DEFAULT_SCALE = 1.0;
const MIN_SCALE = 0.5;
const MAX_SCALE = 3.0;

// Curated list of presets. Hosts that want a different range can pass
// a custom `Presets` array to the ScaleSelect view; this default covers
// the readability common cases without overwhelming the dropdown.
const PRESETS =
[
	{ Value: 0.75, Label: 'Tiny (75%)' },
	{ Value: 0.85, Label: 'Small (85%)' },
	{ Value: 1.00, Label: 'Default (100%)' },
	{ Value: 1.15, Label: 'Comfortable (115%)' },
	{ Value: 1.25, Label: 'Large (125%)' },
	{ Value: 1.50, Label: 'Huge (150%)' },
	{ Value: 1.75, Label: 'Extra Huge (175%)' },
	{ Value: 2.00, Label: 'Massive (200%)' }
];

let _activeScale = DEFAULT_SCALE;
let _listeners = [];

function _clamp(pValue)
{
	let tmpNum = Number(pValue);
	if (!isFinite(tmpNum) || tmpNum <= 0) return DEFAULT_SCALE;
	if (tmpNum < MIN_SCALE) return MIN_SCALE;
	if (tmpNum > MAX_SCALE) return MAX_SCALE;
	return tmpNum;
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

function _buildCSS(pScale)
{
	// `zoom` on <html> scales everything (px + rem + layout). The
	// `--theme-scale` custom property exposes the same value to any CSS
	// that wants to react explicitly via calc().
	return ':root {\n'
		+ '\t' + CSS_VAR_NAME + ': ' + pScale + ';\n'
		+ '}\n'
		+ 'html {\n'
		+ '\tzoom: ' + pScale + ';\n'
		+ '}\n';
}

/**
 * Apply a viewport scale.
 *
 * @param {number} pScale - desired multiplier (e.g. 1.0, 1.25). Values
 *   outside [MIN_SCALE, MAX_SCALE] are clamped; non-finite values
 *   reset to DEFAULT_SCALE.
 * @returns {number} the actually-applied scale (after clamping).
 */
function applyScale(pScale)
{
	let tmpPrev = _activeScale;
	let tmpNext = _clamp(pScale);
	_activeScale = tmpNext;
	_injectStyleElement(_buildCSS(tmpNext));
	if (tmpPrev !== tmpNext) { _fireChange(tmpNext, tmpPrev); }
	return tmpNext;
}

function getActive()
{
	return _activeScale;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNewScale, pOldScale)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNewScale, pOldScale); }
		catch (pErr) { /* listener failures must not break callers */ }
	}
}

/**
 * Reset to default scale and remove the injected style element. Useful
 * for tests + "reset to defaults" affordances.
 */
function reset()
{
	_activeScale = DEFAULT_SCALE;
	if (typeof document !== 'undefined')
	{
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
	}
	_listeners = [];
}

module.exports =
{
	applyScale: applyScale,
	getActive:  getActive,
	onChange:   onChange,
	offChange:  offChange,
	reset:      reset,

	PRESETS:        PRESETS,
	DEFAULT_SCALE:  DEFAULT_SCALE,
	MIN_SCALE:      MIN_SCALE,
	MAX_SCALE:      MAX_SCALE,
	STYLE_ELEMENT_ID: STYLE_ELEMENT_ID,
	CSS_VAR_NAME:     CSS_VAR_NAME
};

},{}],82:[function(require,module,exports){
module.exports={
	"Hash": "1970s-console",
	"Name": "1970s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Amber phosphor on brown-black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A1000",
				"Secondary": "#140C00",
				"Tertiary": "#1E1400",
				"Panel": "#1C1200",
				"Viewer": "#100A00",
				"Hover": "#2A1C00",
				"Selected": "#3A2800",
				"Thumb": "#140C00"
			},
			"Text": {
				"Primary": "#FFAA00",
				"Secondary": "#DD8800",
				"Muted": "#AA6600",
				"Dim": "#884400",
				"Placeholder": "#663300"
			},
			"Brand": {
				"Accent": "#FFCC00",
				"AccentHover": "#FFDD44"
			},
			"Border": {
				"Default": "#2A1800",
				"Light": "#3A2200"
			},
			"Status": {
				"Danger": "#FF4400",
				"DangerMuted": "#AA3300"
			},
			"Scrollbar": {
				"Track": "#2A1800",
				"Hover": "#3A2800"
			},
			"Selection": {
				"Background": "rgba(255, 204, 0, 0.2)"
			},
			"Focus": {
				"Outline": "#FFCC00"
			},
			"Syntax": {
				"Keyword":     "#FFB000",
				"String":      "#FFD080",
				"Number":      "#FFB000",
				"Comment":     "#806020",
				"Operator":    "#FFB000",
				"Punctuation": "#FFD080",
				"Function":    "#FFB000",
				"Variable":    "#FFE090",
				"Type":        "#FFB000",
				"Builtin":     "#FFB000",
				"Property":    "#FF6E40",
				"Tag":         "#FF6E40",
				"AttrName":    "#FFB000",
				"AttrValue":   "#FFD080"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', 'Lucida Console', monospace",
				"Mono": "'Courier New', 'Lucida Console', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#DD8800",
		"Accent": "#FFCC00",
		"Muted": "#884400",
		"Light": "#1E1400",
		"WarmBeige": "#201800",
		"TealTint": "#1A1000",
		"Lavender": "#1C1200",
		"AmberTint": "#221800",
		"PdfFill": "#201000",
		"PdfText": "#FF4400"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.405Z",
	"CompilerVersion": 1
}
},{}],83:[function(require,module,exports){
module.exports={
	"Hash": "1980s-console",
	"Name": "1980s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Green phosphor on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#001200",
				"Secondary": "#000E00",
				"Tertiary": "#001600",
				"Panel": "#001400",
				"Viewer": "#000A00",
				"Hover": "#002200",
				"Selected": "#003800",
				"Thumb": "#000E00"
			},
			"Text": {
				"Primary": "#00FF00",
				"Secondary": "#00CC00",
				"Muted": "#009900",
				"Dim": "#006600",
				"Placeholder": "#004400"
			},
			"Brand": {
				"Accent": "#00FF66",
				"AccentHover": "#44FF88"
			},
			"Border": {
				"Default": "#002A00",
				"Light": "#003A00"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#AA0000"
			},
			"Scrollbar": {
				"Track": "#002A00",
				"Hover": "#004400"
			},
			"Selection": {
				"Background": "rgba(0, 255, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF66"
			},
			"Syntax": {
				"Keyword":     "#00FF00",
				"String":      "#90FF90",
				"Number":      "#FFFF00",
				"Comment":     "#208020",
				"Operator":    "#00FF00",
				"Punctuation": "#90FF90",
				"Function":    "#00FF00",
				"Variable":    "#C0FFC0",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF4040",
				"Tag":         "#FF4040",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#90FF90"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#00CC00",
		"Accent": "#00FF66",
		"Muted": "#006600",
		"Light": "#001600",
		"WarmBeige": "#001A00",
		"TealTint": "#001200",
		"Lavender": "#001400",
		"AmberTint": "#001800",
		"PdfFill": "#140000",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],84:[function(require,module,exports){
module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Web Site",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Blue links on grey, beveled Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#C0C0C0",
				"Secondary": "#B0B0B0",
				"Tertiary": "#A8A8A8",
				"Panel": "#B8B8B8",
				"Viewer": "#D0D0D0",
				"Hover": "#B8B8D0",
				"Selected": "#000080",
				"Thumb": "#B0B0B0"
			},
			"Text": {
				"Primary": "#000000",
				"Secondary": "#000080",
				"Muted": "#404040",
				"Dim": "#606060",
				"Placeholder": "#808080"
			},
			"Brand": {
				"Accent": "#0000FF",
				"AccentHover": "#0000CC"
			},
			"Border": {
				"Default": "#808080",
				"Light": "#A0A0A0"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#990000"
			},
			"Scrollbar": {
				"Track": "#808080",
				"Hover": "#606060"
			},
			"Selection": {
				"Background": "rgba(0, 0, 128, 0.3)"
			},
			"Focus": {
				"Outline": "#0000FF"
			},
			"Syntax": {
				"Keyword":     "#0000FF",
				"String":      "#008000",
				"Number":      "#A52A2A",
				"Comment":     "#808080",
				"Operator":    "#000080",
				"Punctuation": "#000000",
				"Function":    "#0000A0",
				"Variable":    "#000000",
				"Type":        "#A52A2A",
				"Builtin":     "#A52A2A",
				"Property":    "#800080",
				"Tag":         "#800080",
				"AttrName":    "#A52A2A",
				"AttrValue":   "#008000"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Times New Roman', Times, serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#000080",
		"Accent": "#0000FF",
		"Muted": "#606060",
		"Light": "#A8A8A8",
		"WarmBeige": "#B0B0B0",
		"TealTint": "#A0A0A0",
		"Lavender": "#ABABD0",
		"AmberTint": "#B8B0A0",
		"PdfFill": "#C0A0A0",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],85:[function(require,module,exports){
/**
 * Theme Registry — runtime registry of every theme available to
 * pict-section-theme.
 *
 * Bundled "starter set" themes are pre-registered at module load time
 * via static `require()` so browserify can resolve and inline each JSON
 * at bundle time. Beyond the starter set, consumers can register
 * additional theme bundles at runtime — useful for:
 *
 *   - Loading themes the host app authored (e.g. an app's own brand
 *     palette that isn't shipped with this module).
 *   - Pulling themes from a remote "theme garden" via
 *     `registerFromURL()` (CDN-hosted curated bundles).
 *   - Tooling / playgrounds that mutate the registry as the user
 *     iterates.
 *
 * Module exports a singleton instance, so all consumers operate on the
 * same set. Use `register({Hash, Bundle, Category, IsDefault})` to add
 * themes, `list()` to enumerate them, `get(hash)` for direct lookup,
 * `unregister(hash)` to remove.
 *
 * Each entry shape:
 *
 *   {
 *     Hash:       <string>      // matches bundle.Hash; used by the picker
 *     Bundle:     <object>      // theme JSON, ready for provider.registerTheme()
 *     Category:   <string>      // grouping label for the picker UI
 *     IsDefault:  <bool?>       // true for the canonical ecosystem default
 *     Source:     <string?>     // 'starter' | URL | host-supplied tag
 *   }
 *
 * Backwards-compat:
 *   - The instance is iterable (Symbol.iterator), exposes `.length`,
 *     and supports numeric indexing `[i]` so legacy code that treated
 *     the catalog as an array continues to work without changes.
 */
'use strict';

class ThemeRegistry
{
	constructor()
	{
		this._themes = new Map();      // Hash → entry, insertion-ordered
		this._loadStarterSet();
	}

	// ── Bundled starter set ──────────────────────────────────────────────
	// Each `require()` is a literal string so browserify inlines the JSON
	// at build time. Adding a new bundled theme: drop the JSON in this
	// folder and append a row here. Runtime additions go via register()
	// from anywhere else in the codebase.
	_loadStarterSet()
	{
		const STARTER =
		[
			// Framework defaults
			{ Hash: 'pict-default',       Category: 'Default',  IsDefault: true,  Bundle: require('./pict-default.json') },
			{ Hash: 'retold-mono',        Category: 'Default',  Bundle: require('./retold-mono.json') },

			// App-extracted themes (named after their host app)
			{ Hash: 'retold-manager',                Category: 'App',  Bundle: require('./retold-manager.json') },
			{ Hash: 'retold-content-system',         Category: 'App',  Bundle: require('./retold-content-system.json') },
			{ Hash: 'retold-labs',                   Category: 'App',  Bundle: require('./retold-labs.json') },
			{ Hash: 'retold-labs-cyberpunk',         Category: 'App',  Bundle: require('./retold-labs-cyberpunk.json') },
			{ Hash: 'retold-labs-retro',             Category: 'App',  Bundle: require('./retold-labs-retro.json') },
			{ Hash: 'ultravisor-desert-dusk',        Category: 'App',  Bundle: require('./ultravisor-desert-dusk.json') },
			{ Hash: 'ultravisor-desert-day',         Category: 'App',  Bundle: require('./ultravisor-desert-day.json') },
			{ Hash: 'ultravisor-desert-sunset',      Category: 'App',  Bundle: require('./ultravisor-desert-sunset.json') },
			{ Hash: 'ultravisor-professional-light', Category: 'App',  Bundle: require('./ultravisor-professional-light.json') },
			{ Hash: 'ultravisor-professional-dark',  Category: 'App',  Bundle: require('./ultravisor-professional-dark.json') },
			{ Hash: 'ultravisor-desert-canyon',      Category: 'App',  Bundle: require('./ultravisor-desert-canyon.json') },

			// Paired light/dark themes
			{ Hash: 'ocean',              Category: 'Paired',   Bundle: require('./ocean.json') },
			{ Hash: 'playground-corp',    Category: 'Paired',   Bundle: require('./playground-corp.json') },

			// Flow themes (originally pict-section-flow's internal presets; now first-class
			// pict-section-theme entries so other apps can adopt the same color identity)
			{ Hash: 'flow-modern',        Category: 'Flow',     Bundle: require('./flow-modern.json') },
			{ Hash: 'flow-sketch',        Category: 'Flow',     Bundle: require('./flow-sketch.json') },
			{ Hash: 'flow-blueprint',     Category: 'Flow',     Bundle: require('./flow-blueprint.json') },
			{ Hash: 'flow-mono',          Category: 'Flow',     Bundle: require('./flow-mono.json') },
			{ Hash: 'flow-retro-80s',     Category: 'Flow',     Bundle: require('./flow-retro-80s.json') },
			{ Hash: 'flow-retro-90s',     Category: 'Flow',     Bundle: require('./flow-retro-90s.json') },
			{ Hash: 'flow-whiteboard',    Category: 'Flow',     Bundle: require('./flow-whiteboard.json') },

			// Greys (low-light single-mode themes)
			{ Hash: 'twilight',           Category: 'Grey',     Bundle: require('./twilight.json') },
			{ Hash: 'night',              Category: 'Grey',     Bundle: require('./night.json') },
			{ Hash: 'evening',            Category: 'Grey',     Bundle: require('./evening.json') },
			{ Hash: 'afternoon',          Category: 'Grey',     Bundle: require('./afternoon.json') },
			{ Hash: 'daylight',           Category: 'Grey',     Bundle: require('./daylight.json') },

			// Fun / period palettes
			{ Hash: 'cyberpunk',          Category: 'Fun',      Bundle: require('./cyberpunk.json') },
			{ Hash: 'synthwave',          Category: 'Fun',      Bundle: require('./synthwave.json') },
			{ Hash: 'neo-tokyo',          Category: 'Fun',      Bundle: require('./neo-tokyo.json') },
			{ Hash: 'solarized-dark',     Category: 'Fun',      Bundle: require('./solarized-dark.json') },
			{ Hash: 'forest',             Category: 'Fun',      Bundle: require('./forest.json') },
			{ Hash: 'hotdog',             Category: 'Fun',      Bundle: require('./hotdog.json') },
			{ Hash: '1970s-console',      Category: 'Fun',      Bundle: require('./1970s-console.json') },
			{ Hash: '1980s-console',      Category: 'Fun',      Bundle: require('./1980s-console.json') },
			{ Hash: '1990s-website',      Category: 'Fun',      Bundle: require('./1990s-website.json') },
			{ Hash: 'early-2000s',        Category: 'Fun',      Bundle: require('./early-2000s.json') },

			// Retro workstation palettes — extracted from retold-databeacon's
			// original built-in theme set; period-platform-themed pairs.
			{ Hash: 'databeacon-nineteen-97', Category: 'Retro', Bundle: require('./databeacon-nineteen-97.json') },
			{ Hash: 'databeacon-mac-classic', Category: 'Retro', Bundle: require('./databeacon-mac-classic.json') },
			{ Hash: 'databeacon-next',        Category: 'Retro', Bundle: require('./databeacon-next.json') },
			{ Hash: 'databeacon-beos',        Category: 'Retro', Bundle: require('./databeacon-beos.json') },
			{ Hash: 'databeacon-sgi',         Category: 'Retro', Bundle: require('./databeacon-sgi.json') },

			// Diagnostics / utility
			{ Hash: 'mobile-debug',       Category: 'Debug',    Bundle: require('./mobile-debug.json') }
		];

		for (let i = 0; i < STARTER.length; i++)
		{
			let tmpEntry = Object.assign({}, STARTER[i], { Source: STARTER[i].Source || 'starter' });
			this._themes.set(tmpEntry.Hash, tmpEntry);
		}
	}

	// ── Public API ───────────────────────────────────────────────────────

	/**
	 * Register a theme. Re-registering an existing hash overwrites cleanly.
	 *
	 * @param {{Hash, Bundle, Category?, IsDefault?, Source?}} pEntry
	 * @returns {object} the stored entry
	 */
	register(pEntry)
	{
		if (!pEntry || typeof pEntry !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry must be an object');
		}
		if (typeof pEntry.Hash !== 'string' || pEntry.Hash.length === 0)
		{
			throw new Error('ThemeRegistry.register: entry.Hash is required');
		}
		if (!pEntry.Bundle || typeof pEntry.Bundle !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry.Bundle is required');
		}
		let tmpStored = Object.assign({ Source: 'host' }, pEntry);
		this._themes.set(pEntry.Hash, tmpStored);
		return tmpStored;
	}

	/**
	 * Remove a theme by hash. Returns true if anything was removed.
	 * @param {string} pHash
	 * @returns {boolean}
	 */
	unregister(pHash)
	{
		return this._themes.delete(pHash);
	}

	/**
	 * Look up a single theme entry by hash.
	 * @param {string} pHash
	 * @returns {object|undefined}
	 */
	get(pHash)
	{
		return this._themes.get(pHash);
	}

	has(pHash)
	{
		return this._themes.has(pHash);
	}

	/**
	 * Snapshot of every registered entry, in registration order.
	 * @returns {Array<object>}
	 */
	list()
	{
		return Array.from(this._themes.values());
	}

	/**
	 * Drop every registered entry. Mostly useful in tests; production
	 * consumers should prefer `unregister()` per hash.
	 */
	clear()
	{
		this._themes.clear();
	}

	/**
	 * Re-load the bundled starter set. No-op if the starter set is
	 * already registered (re-registering replaces, so this is safe to
	 * call any time).
	 */
	loadStarterSet()
	{
		this._loadStarterSet();
	}

	/**
	 * Number of registered themes.
	 * @returns {number}
	 */
	get count()
	{
		return this._themes.size;
	}

	/**
	 * Async fetch + register from a URL. Used by the future "online theme
	 * garden" — the URL must serve a JSON bundle compatible with
	 * pict-provider-theme's `registerTheme()` shape.
	 *
	 * @param {string} pURL
	 * @param {{Category?, IsDefault?, Hash?}} [pMetadata] - override metadata
	 * @returns {Promise<object>} the registered entry
	 */
	async registerFromURL(pURL, pMetadata)
	{
		if (typeof fetch !== 'function')
		{
			throw new Error('ThemeRegistry.registerFromURL: fetch is not available in this environment');
		}
		let tmpResponse = await fetch(pURL);
		if (!tmpResponse.ok)
		{
			throw new Error('ThemeRegistry.registerFromURL: HTTP ' + tmpResponse.status + ' for ' + pURL);
		}
		let tmpBundle = await tmpResponse.json();
		if (!tmpBundle || typeof tmpBundle !== 'object' || typeof tmpBundle.Hash !== 'string')
		{
			throw new Error('ThemeRegistry.registerFromURL: payload missing Hash');
		}
		let tmpMeta = pMetadata || {};
		return this.register(
		{
			Hash: tmpMeta.Hash || tmpBundle.Hash,
			Bundle: tmpBundle,
			Category: tmpMeta.Category || 'Garden',
			IsDefault: !!tmpMeta.IsDefault,
			Source: pURL
		});
	}

	// ── Array-like compatibility ─────────────────────────────────────────
	// Older code iterated the catalog as an array (`for (let i = 0; i <
	// CATALOG.length; i++) ... CATALOG[i]`). Preserve those usages without
	// requiring a refactor: the iterator + length + numeric proxy give
	// `Array.isArray(registry)` returns false, but everything that reads
	// keeps working. New code should prefer `list()` / `get()`.

	get length()
	{
		return this._themes.size;
	}

	[Symbol.iterator]()
	{
		return this._themes.values();
	}
}

// Singleton — every consumer gets the same registry.
const _Registry = new ThemeRegistry();

// Numeric-index proxy: `registry[0]` returns the first entry, matching
// the legacy "catalog as array" shape. Wraps the singleton so existing
// `tmpEntry = _CATALOG[i]` loops keep working.
const _IndexedRegistry = new Proxy(_Registry,
{
	get(pTarget, pProp, pReceiver)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			let tmpIdx = parseInt(pProp, 10);
			let tmpList = pTarget.list();
			return tmpList[tmpIdx];
		}
		return Reflect.get(pTarget, pProp, pReceiver);
	},
	has(pTarget, pProp)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			return parseInt(pProp, 10) < pTarget.length;
		}
		return Reflect.has(pTarget, pProp);
	}
});

module.exports = _IndexedRegistry;
module.exports.ThemeRegistry = ThemeRegistry;

},{"./1970s-console.json":82,"./1980s-console.json":83,"./1990s-website.json":84,"./afternoon.json":86,"./cyberpunk.json":87,"./databeacon-beos.json":88,"./databeacon-mac-classic.json":89,"./databeacon-next.json":90,"./databeacon-nineteen-97.json":91,"./databeacon-sgi.json":92,"./daylight.json":93,"./early-2000s.json":94,"./evening.json":95,"./flow-blueprint.json":96,"./flow-modern.json":97,"./flow-mono.json":98,"./flow-retro-80s.json":99,"./flow-retro-90s.json":100,"./flow-sketch.json":101,"./flow-whiteboard.json":102,"./forest.json":103,"./hotdog.json":104,"./mobile-debug.json":105,"./neo-tokyo.json":106,"./night.json":107,"./ocean.json":108,"./pict-default.json":109,"./playground-corp.json":110,"./retold-content-system.json":111,"./retold-labs-cyberpunk.json":112,"./retold-labs-retro.json":113,"./retold-labs.json":114,"./retold-manager.json":115,"./retold-mono.json":116,"./solarized-dark.json":117,"./synthwave.json":118,"./twilight.json":119,"./ultravisor-desert-canyon.json":120,"./ultravisor-desert-day.json":121,"./ultravisor-desert-dusk.json":122,"./ultravisor-desert-sunset.json":123,"./ultravisor-professional-dark.json":124,"./ultravisor-professional-light.json":125}],86:[function(require,module,exports){
module.exports={
	"Hash": "afternoon",
	"Name": "Afternoon",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Warm light grey, softer contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8E4E0",
				"Secondary": "#DAD6D2",
				"Tertiary": "#D0CCC8",
				"Panel": "#DDD9D5",
				"Viewer": "#F0ECE8",
				"Hover": "#CCC8C4",
				"Selected": "#B8B4B0",
				"Thumb": "#DAD6D2"
			},
			"Text": {
				"Primary": "#2A2A2A",
				"Secondary": "#404040",
				"Muted": "#707070",
				"Dim": "#909090",
				"Placeholder": "#B0B0B0"
			},
			"Brand": {
				"Accent": "#555555",
				"AccentHover": "#333333"
			},
			"Border": {
				"Default": "#C0BCB8",
				"Light": "#D0CCC8"
			},
			"Status": {
				"Danger": "#AA3333",
				"DangerMuted": "#886655"
			},
			"Scrollbar": {
				"Track": "#B8B4B0",
				"Hover": "#A0A09C"
			},
			"Selection": {
				"Background": "rgba(85, 85, 85, 0.2)"
			},
			"Focus": {
				"Outline": "#555555"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#666666",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Georgia, 'Times New Roman', serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#404040",
		"Accent": "#555555",
		"Muted": "#909090",
		"Light": "#D0CCC8",
		"WarmBeige": "#DAD6D2",
		"TealTint": "#CCC8C4",
		"Lavender": "#D2D0CE",
		"AmberTint": "#D8D2C8",
		"PdfFill": "#D8C8C0",
		"PdfText": "#AA3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],87:[function(require,module,exports){
module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Electric green on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0E0A",
				"Secondary": "#060806",
				"Tertiary": "#0E120E",
				"Panel": "#0C100C",
				"Viewer": "#040604",
				"Hover": "#142014",
				"Selected": "#1A3A1A",
				"Thumb": "#060806"
			},
			"Text": {
				"Primary": "#C8FFC8",
				"Secondary": "#A0D8A0",
				"Muted": "#608860",
				"Dim": "#406040",
				"Placeholder": "#305030"
			},
			"Brand": {
				"Accent": "#00FF41",
				"AccentHover": "#44FF77"
			},
			"Border": {
				"Default": "#1A2A1A",
				"Light": "#224022"
			},
			"Status": {
				"Danger": "#FF3333",
				"DangerMuted": "#AA2222"
			},
			"Scrollbar": {
				"Track": "#1A2A1A",
				"Hover": "#2A4A2A"
			},
			"Selection": {
				"Background": "rgba(0, 255, 65, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF41"
			},
			"Syntax": {
				"Keyword":     "#FF00FF",
				"String":      "#00FF41",
				"Number":      "#FFFF00",
				"Comment":     "#406040",
				"Operator":    "#00FFFF",
				"Punctuation": "#A0D8A0",
				"Function":    "#FF00FF",
				"Variable":    "#C8FFC8",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF3333",
				"Tag":         "#FF3333",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#00FF41"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Lucida Console', 'Courier New', monospace",
				"Mono": "'Lucida Console', 'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#A0D8A0",
		"Accent": "#00FF41",
		"Muted": "#406040",
		"Light": "#0E120E",
		"WarmBeige": "#101610",
		"TealTint": "#0C140C",
		"Lavender": "#0E120E",
		"AmberTint": "#141810",
		"PdfFill": "#181010",
		"PdfText": "#FF3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],88:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-beos",
	"Name": "DataBeacon \u2014 BeOS",
	"Version": "0.0.1",
	"Description": "BeOS palette \u2014 cool teals with orange accents. Light: sky-blue desktop. Dark: deep ocean panels with cyan highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e0e8ec",
					"Dark": "#0a1a22"
				},
				"Secondary": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Tertiary": {
					"Light": "#d4dfe5",
					"Dark": "#0d1f29"
				},
				"Panel": {
					"Light": "#f0f4f6",
					"Dark": "#142430"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#1b313f"
				},
				"Hover": {
					"Light": "#d7dee2",
					"Dark": "#091820"
				},
				"Selected": {
					"Light": "#c2d4da",
					"Dark": "#19353e"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Secondary": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Muted": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Placeholder": {
					"Light": "#95a5ae",
					"Dark": "#3a4e59"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a1a22"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"PrimaryHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				},
				"Accent": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"AccentHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				}
			},
			"Border": {
				"Default": {
					"Light": "#8ba3b0",
					"Dark": "#466070"
				},
				"Light": {
					"Light": "#b5c5ce",
					"Dark": "#283d49"
				},
				"Strong": {
					"Light": "#6f828c",
					"Dark": "#384c59"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Warning": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Error": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Info": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Thumb": {
					"Light": "#7c929f",
					"Dark": "#4d6574"
				},
				"Hover": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aac4cc",
					"Dark": "#254a54"
				},
				"Text": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"String": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Number": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Comment": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Operator": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Punctuation": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Function": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Variable": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Type": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Builtin": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Property": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Tag": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"AttrName": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"AttrValue": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "BeOS",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],89:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-mac-classic",
	"Name": "DataBeacon \u2014 Mac Classic",
	"Version": "0.0.1",
	"Description": "Mac OS 8/9 Platinum palette \u2014 soft greys with sky blue accents. Light: classic Mac platinum. Dark: charcoal panels with the same blue accent family.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#dddddd",
					"Dark": "#202020"
				},
				"Secondary": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Tertiary": {
					"Light": "#d4d4d4",
					"Dark": "#252525"
				},
				"Panel": {
					"Light": "#f0f0f0",
					"Dark": "#2e2e2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#3a3a3a"
				},
				"Hover": {
					"Light": "#d4d4d4",
					"Dark": "#1e1e1e"
				},
				"Selected": {
					"Light": "#c0cce3",
					"Dark": "#2b3748"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Secondary": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Muted": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Placeholder": {
					"Light": "#9a9a9a",
					"Dark": "#585858"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"PrimaryHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				},
				"Accent": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"AccentHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#999999",
					"Dark": "#555555"
				},
				"Light": {
					"Light": "#bbbbbb",
					"Dark": "#3a3a3a"
				},
				"Strong": {
					"Light": "#7a7a7a",
					"Dark": "#444444"
				}
			},
			"Status": {
				"Success": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Warning": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Error": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Info": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Thumb": {
					"Light": "#888888",
					"Dark": "#666666"
				},
				"Hover": {
					"Light": "#777777",
					"Dark": "#777777"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aabfe7",
					"Dark": "#344867"
				},
				"Text": {
					"Light": "#000000",
					"Dark": "#dddddd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"String": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Number": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Comment": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Operator": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Punctuation": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Function": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Variable": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Type": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Builtin": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Property": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Tag": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"AttrName": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"AttrValue": {
					"Light": "#339933",
					"Dark": "#60cc60"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Mac Classic",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],90:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-next",
	"Name": "DataBeacon \u2014 NeXT",
	"Version": "0.0.1",
	"Description": "NeXTSTEP palette \u2014 stone backgrounds with rich purple accents. Light: warm stone. Dark: deep aubergine with lavender highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e8e6dd",
					"Dark": "#1a1420"
				},
				"Secondary": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Tertiary": {
					"Light": "#dfdcd2",
					"Dark": "#1e1726"
				},
				"Panel": {
					"Light": "#f5f3ed",
					"Dark": "#251c2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2f253a"
				},
				"Hover": {
					"Light": "#dedcd4",
					"Dark": "#18131e"
				},
				"Selected": {
					"Light": "#d1c7d2",
					"Dark": "#352a42"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Secondary": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Muted": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Placeholder": {
					"Light": "#a09ba5",
					"Dark": "#585263"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1420"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"PrimaryHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				},
				"Accent": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"AccentHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				}
			},
			"Border": {
				"Default": {
					"Light": "#9a96a6",
					"Dark": "#5e5468"
				},
				"Light": {
					"Light": "#c1bec1",
					"Dark": "#3c3444"
				},
				"Strong": {
					"Light": "#7b7884",
					"Dark": "#4b4353"
				}
			},
			"Status": {
				"Success": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Warning": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Error": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Info": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Thumb": {
					"Light": "#8a8597",
					"Dark": "#6c6478"
				},
				"Hover": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#bfb0c9",
					"Dark": "#4a3b5d"
				},
				"Text": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"String": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Number": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Comment": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Operator": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Punctuation": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Function": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Variable": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Type": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Builtin": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Property": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Tag": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"AttrName": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"AttrValue": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "NeXT",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],91:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-nineteen-97",
	"Name": "DataBeacon \u2014 1997 (Win95/98)",
	"Version": "0.0.1",
	"Description": "Windows 95/98 retro palette \u2014 beige + navy + maroon. Light: classic Win95 desktop. Dark: indigo-grey background with sky/coral accents.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ece9d8",
					"Dark": "#1e1e2e"
				},
				"Secondary": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Tertiary": {
					"Light": "#e2dec8",
					"Dark": "#222234"
				},
				"Panel": {
					"Light": "#fffbf0",
					"Dark": "#2a2a3a"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#343450"
				},
				"Hover": {
					"Light": "#e2dfcf",
					"Dark": "#1c1c2c"
				},
				"Selected": {
					"Light": "#c1bfc8",
					"Dark": "#2f3553"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Muted": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Placeholder": {
					"Light": "#a1a09a",
					"Dark": "#5c5b58"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1a1a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"PrimaryHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				},
				"Accent": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"AccentHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#4e4e68"
				},
				"Light": {
					"Light": "#b6b4ac",
					"Dark": "#36364b"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#3e3e53"
				}
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Warning": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Error": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Thumb": {
					"Light": "#7d7d7d",
					"Dark": "#66656c"
				},
				"Hover": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#a09ebb",
					"Dark": "#3d4770"
				},
				"Text": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"String": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Number": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Comment": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Operator": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Function": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				},
				"Variable": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Type": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Builtin": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Property": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Tag": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"AttrName": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"AttrValue": {
					"Light": "#008000",
					"Dark": "#80ff80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "1997 (Win95/98)",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],92:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-sgi",
	"Name": "DataBeacon \u2014 SGI",
	"Version": "0.0.1",
	"Description": "SGI Indy / IRIX palette \u2014 magenta with cyan highlights. Light: signature SGI grey. Dark: deep workstation black with the same hot magenta.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c8c8c8",
					"Dark": "#1a1a1a"
				},
				"Secondary": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Tertiary": {
					"Light": "#c0c0c0",
					"Dark": "#1e1e1e"
				},
				"Panel": {
					"Light": "#dcdcdc",
					"Dark": "#252525"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2e2e2e"
				},
				"Hover": {
					"Light": "#c0c0c0",
					"Dark": "#181818"
				},
				"Selected": {
					"Light": "#c8a9bb",
					"Dark": "#432635"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Muted": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Placeholder": {
					"Light": "#8d8d8d",
					"Dark": "#515151"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"PrimaryHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				},
				"Accent": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"AccentHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#505050"
				},
				"Light": {
					"Light": "#a4a4a4",
					"Dark": "#353535"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#404040"
				}
			},
			"Status": {
				"Success": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Warning": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Error": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Info": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Thumb": {
					"Light": "#777777",
					"Dark": "#606060"
				},
				"Hover": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#c892b0",
					"Dark": "#63304a"
				},
				"Text": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"String": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Number": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Comment": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Operator": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Function": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				},
				"Variable": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Type": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Builtin": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Property": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Tag": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"AttrName": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"AttrValue": {
					"Light": "#208040",
					"Dark": "#50d080"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "SGI",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],93:[function(require,module,exports){
module.exports={
	"Hash": "daylight",
	"Name": "Daylight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Bright white, dark text Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FFFFFF",
				"Secondary": "#F0F0F0",
				"Tertiary": "#E8E8E8",
				"Panel": "#F5F5F5",
				"Viewer": "#FAFAFA",
				"Hover": "#E0E0E0",
				"Selected": "#C8C8C8",
				"Thumb": "#F0F0F0"
			},
			"Text": {
				"Primary": "#1A1A1A",
				"Secondary": "#333333",
				"Muted": "#666666",
				"Dim": "#888888",
				"Placeholder": "#AAAAAA"
			},
			"Brand": {
				"Accent": "#444444",
				"AccentHover": "#222222"
			},
			"Border": {
				"Default": "#D0D0D0",
				"Light": "#E0E0E0"
			},
			"Status": {
				"Danger": "#CC0000",
				"DangerMuted": "#884444"
			},
			"Scrollbar": {
				"Track": "#C0C0C0",
				"Hover": "#A0A0A0"
			},
			"Selection": {
				"Background": "rgba(68, 68, 68, 0.2)"
			},
			"Focus": {
				"Outline": "#444444"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#444444",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Segoe UI', system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#333333",
		"Accent": "#444444",
		"Muted": "#888888",
		"Light": "#E8E8E8",
		"WarmBeige": "#F0F0F0",
		"TealTint": "#E0E0E0",
		"Lavender": "#EBEBEB",
		"AmberTint": "#F0EDE8",
		"PdfFill": "#F0E0E0",
		"PdfText": "#CC0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],94:[function(require,module,exports){
module.exports={
	"Hash": "early-2000s",
	"Name": "Early 2000s Web",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Teal and silver, Web 2.0 Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8F4F8",
				"Secondary": "#D0E8EE",
				"Tertiary": "#C0DDE6",
				"Panel": "#D8EEF2",
				"Viewer": "#F0F8FA",
				"Hover": "#B0D4E0",
				"Selected": "#88C4D8",
				"Thumb": "#D0E8EE"
			},
			"Text": {
				"Primary": "#1A3A4A",
				"Secondary": "#2A4A5A",
				"Muted": "#5A7A8A",
				"Dim": "#7A9AAA",
				"Placeholder": "#9ABACA"
			},
			"Brand": {
				"Accent": "#0099CC",
				"AccentHover": "#00AADD"
			},
			"Border": {
				"Default": "#A0C8D8",
				"Light": "#B8D8E4"
			},
			"Status": {
				"Danger": "#CC3300",
				"DangerMuted": "#994422"
			},
			"Scrollbar": {
				"Track": "#A0C8D8",
				"Hover": "#88B8CC"
			},
			"Selection": {
				"Background": "rgba(0, 153, 204, 0.2)"
			},
			"Focus": {
				"Outline": "#0099CC"
			},
			"Syntax": {
				"Keyword":     "#1A4080",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#333333",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Verdana, Geneva, Tahoma, sans-serif",
				"Mono": "'Lucida Console', Monaco, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#2A4A5A",
		"Accent": "#0099CC",
		"Muted": "#7A9AAA",
		"Light": "#C0DDE6",
		"WarmBeige": "#D0E8EE",
		"TealTint": "#B0D8E4",
		"Lavender": "#C8DCE6",
		"AmberTint": "#D8E0D0",
		"PdfFill": "#E0C8C0",
		"PdfText": "#CC3300"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],95:[function(require,module,exports){
module.exports={
	"Hash": "evening",
	"Name": "Evening",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Medium grey, transitional Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#484848",
				"Secondary": "#3C3C3C",
				"Tertiary": "#424242",
				"Panel": "#454545",
				"Viewer": "#363636",
				"Hover": "#525252",
				"Selected": "#606060",
				"Thumb": "#3C3C3C"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#D0D0D0",
				"Muted": "#A0A0A0",
				"Dim": "#888888",
				"Placeholder": "#707070"
			},
			"Brand": {
				"Accent": "#C0C0C0",
				"AccentHover": "#E0E0E0"
			},
			"Border": {
				"Default": "#585858",
				"Light": "#606060"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#585858",
				"Hover": "#686868"
			},
			"Selection": {
				"Background": "rgba(192, 192, 192, 0.25)"
			},
			"Focus": {
				"Outline": "#C0C0C0"
			},
			"Syntax": {
				"Keyword":     "#B894FF",
				"String":      "#A8D8B0",
				"Number":      "#FFB880",
				"Comment":     "#8A8A8A",
				"Operator":    "#7EC0FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFCC80",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB880",
				"Builtin":     "#FFB880",
				"Property":    "#FF9494",
				"Tag":         "#FF9494",
				"AttrName":    "#FFB880",
				"AttrValue":   "#A8D8B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0D0D0",
		"Accent": "#C0C0C0",
		"Muted": "#888888",
		"Light": "#424242",
		"WarmBeige": "#484848",
		"TealTint": "#3E3E3E",
		"Lavender": "#444444",
		"AmberTint": "#4A4640",
		"PdfFill": "#4A3C3C",
		"PdfText": "#FF6666"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],96:[function(require,module,exports){
module.exports={
	"Hash": "flow-blueprint",
	"Name": "Flow Blueprint",
	"Version": "0.0.1",
	"Description": "Technical-drawing aesthetic — white-on-navy with yellow selection. Single-mode (always dark blueprint).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a3a6a",
				"Secondary": "#142e54",
				"Tertiary":  "rgba(255,255,255,0.1)",
				"Panel":     "#1a3a6a",
				"Hover":     "rgba(255,255,255,0.06)",
				"Selected":  "rgba(255,221,68,0.18)"
			},
			"Text": {
				"Primary":   "#ffffff",
				"Secondary": "rgba(255,255,255,0.7)",
				"Muted":     "rgba(255,255,255,0.5)",
				"OnBrand":   "#0d2244"
			},
			"Brand": {
				"Primary":      "#ffdd44",
				"PrimaryHover": "#ffe978",
				"Accent":       "#88ffbb"
			},
			"Border": {
				"Default": "rgba(255,255,255,0.6)",
				"Light":   "rgba(255,255,255,0.15)",
				"Strong":  "#ffffff"
			},
			"Status": {
				"Success": "#88ffbb",
				"Warning": "#ffdd44",
				"Error":   "#ff8888",
				"Info":    "#88bbff"
			},
			"Scrollbar": {
				"Track": "rgba(255,255,255,0.05)",
				"Thumb": "rgba(255,255,255,0.3)",
				"Hover": "rgba(255,255,255,0.5)"
			},
			"Focus": {
				"Outline": "#ffdd44"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Blueprint",
		"Tagline": "Technical drawing on navy"
	}
}

},{}],97:[function(require,module,exports){
module.exports={
	"Hash": "flow-modern",
	"Name": "Flow Modern",
	"Version": "0.0.1",
	"Description": "The default modern look for pict-section-flow — clean, theme-neutral. Paired light/dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ecf0f1", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#eef3f7", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#dde7f3", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":   { "Light": "#2c3e50", "Dark": "#ededed" },
				"Secondary": { "Light": "#7f8c8d", "Dark": "#bdbdbd" },
				"Muted":     { "Light": "#95a5a6", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#1a1a1a" }
			},
			"Brand": {
				"Primary":      { "Light": "#2255aa", "Dark": "#5b8aff" },
				"PrimaryHover": { "Light": "#1a4488", "Dark": "#7ba4ff" },
				"Accent":       { "Light": "#1abc9c", "Dark": "#4fd1b5" }
			},
			"Border": {
				"Default": { "Light": "#bdc3c7", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#ecf0f1", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#27ae60", "Dark": "#5fc377" },
				"Warning": { "Light": "#f39c12", "Dark": "#f0b84a" },
				"Error":   { "Light": "#e74c3c", "Dark": "#ff7373" },
				"Info":    { "Light": "#3498db", "Dark": "#5fb4ff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ecf0f1", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#bdc3c7", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Focus": {
				"Outline": { "Light": "#2255aa", "Dark": "#5b8aff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Modern",
		"Tagline": "Clean modern flow editor look"
	}
}

},{}],98:[function(require,module,exports){
module.exports={
	"Hash": "flow-mono",
	"Name": "Flow Mono",
	"Version": "0.0.1",
	"Description": "High-contrast monochrome flow editor look. Paired light/dark — pure black on white or white on black.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Tertiary":  { "Light": "#e0e0e0", "Dark": "#262626" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#eeeeee", "Dark": "#1f1f1f" },
				"Selected":  { "Light": "#dddddd", "Dark": "#333333" }
			},
			"Text": {
				"Primary":   { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary": { "Light": "#444444", "Dark": "#cccccc" },
				"Muted":     { "Light": "#888888", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Brand": {
				"Primary":      { "Light": "#444444", "Dark": "#bbbbbb" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#666666", "Dark": "#999999" }
			},
			"Border": {
				"Default": { "Light": "#000000", "Dark": "#ffffff" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Thumb": { "Light": "#888888", "Dark": "#888888" },
				"Hover": { "Light": "#444444", "Dark": "#cccccc" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.25)", "Dark": "rgba(255, 255, 255, 0.25)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Mono",
		"Tagline": "Monochrome ink-on-paper"
	}
}

},{}],99:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-80s",
	"Name": "Flow Retro 80s",
	"Version": "0.0.1",
	"Description": "Neon-on-purple synthwave aesthetic for the flow editor. Single-mode (always dark) — '80s arcade glow.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#0a0015",
				"Secondary": "#1a0a2e",
				"Tertiary":  "#2a0a4e",
				"Panel":     "#1a0a2e",
				"Hover":     "#2a0a4e",
				"Selected":  "#3a1466"
			},
			"Text": {
				"Primary":   "#00ffff",
				"Secondary": "#ff66ff",
				"Muted":     "#9966cc",
				"OnBrand":   "#0a0015"
			},
			"Brand": {
				"Primary":      "#ff00ff",
				"PrimaryHover": "#ff66ff",
				"Accent":       "#00ffff"
			},
			"Border": {
				"Default": "#ff00ff",
				"Light":   "#2a0a4e",
				"Strong":  "#ff00ff"
			},
			"Status": {
				"Success": "#00ff66",
				"Warning": "#ffdd44",
				"Error":   "#ff4477",
				"Info":    "#00ffff"
			},
			"Scrollbar": {
				"Track": "#1a0a2e",
				"Thumb": "#ff00ff",
				"Hover": "#ff66ff"
			},
			"Focus": {
				"Outline": "#00ffff"
			},
			"Shadow": {
				"Color": "rgba(255, 0, 255, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 80s",
		"Tagline": "Neon synthwave glow"
	}
}

},{}],100:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-90s",
	"Name": "Flow Retro 90s",
	"Version": "0.0.1",
	"Description": "Windows-95 aesthetic — gray panels, navy title bars, teal desktop. Single-mode (always its specific palette).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#008080",
				"Secondary": "#c0c0c0",
				"Tertiary":  "#d0d0d0",
				"Panel":     "#c0c0c0",
				"Hover":     "#d0d0d0",
				"Selected":  "#a8c8e0"
			},
			"Text": {
				"Primary":   "#000000",
				"Secondary": "#404040",
				"Muted":     "#606060",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#000080",
				"PrimaryHover": "#0000a0",
				"Accent":       "#008000"
			},
			"Border": {
				"Default": "#808080",
				"Light":   "#a0a0a0",
				"Strong":  "#404040"
			},
			"Status": {
				"Success": "#008000",
				"Warning": "#808000",
				"Error":   "#800000",
				"Info":    "#000080"
			},
			"Scrollbar": {
				"Track": "#c0c0c0",
				"Thumb": "#808080",
				"Hover": "#404040"
			},
			"Focus": {
				"Outline": "#008080"
			},
			"Shadow": {
				"Color": "#404040"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 90s",
		"Tagline": "Workstation chrome from the 90s"
	}
}

},{}],101:[function(require,module,exports){
module.exports={
	"Hash": "flow-sketch",
	"Name": "Flow Sketch",
	"Version": "0.0.1",
	"Description": "Warm-paper sketch aesthetic for the flow editor. Single-mode (always light) — sketches live on paper.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#fffef5",
				"Secondary": "#faf8ed",
				"Tertiary":  "#f0ece0",
				"Panel":     "#fffef5",
				"Hover":     "#f4f0e2",
				"Selected":  "#e8dfc8"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#888888",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#c47b5a"
			},
			"Border": {
				"Default": "#444444",
				"Light":   "#ccccaa",
				"Strong":  "#222222"
			},
			"Status": {
				"Success": "#55aa77",
				"Warning": "#d4a040",
				"Error":   "#c44836",
				"Info":    "#5577bb"
			},
			"Scrollbar": {
				"Track": "#f0ece0",
				"Thumb": "#c5c0a8",
				"Hover": "#9e9a82"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.08)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Sketch",
		"Tagline": "Hand-drawn paper aesthetic"
	}
}

},{}],102:[function(require,module,exports){
module.exports={
	"Hash": "flow-whiteboard",
	"Name": "Flow Whiteboard",
	"Version": "0.0.1",
	"Description": "Minimal whiteboard aesthetic — transparent fills with colored brackets per node type. Single-mode (light).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#ffffff",
				"Secondary": "#fafafa",
				"Tertiary":  "#f5f5f5",
				"Panel":     "#ffffff",
				"Hover":     "#f0f0f0",
				"Selected":  "#e0eaff"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#999999",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#1abc9c"
			},
			"Border": {
				"Default": "#888888",
				"Light":   "#cccccc",
				"Strong":  "#555555"
			},
			"Status": {
				"Success": "#27ae60",
				"Warning": "#f39c12",
				"Error":   "#e74c3c",
				"Info":    "#3498db"
			},
			"Scrollbar": {
				"Track": "#f5f5f5",
				"Thumb": "#cccccc",
				"Hover": "#888888"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Whiteboard",
		"Tagline": "Minimal whiteboard sketching"
	}
}

},{}],103:[function(require,module,exports){
module.exports={
	"Hash": "forest",
	"Name": "Forest",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Deep greens and earth browns Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A2018",
				"Secondary": "#141A12",
				"Tertiary": "#1E2620",
				"Panel": "#1C221A",
				"Viewer": "#101410",
				"Hover": "#283828",
				"Selected": "#344834",
				"Thumb": "#141A12"
			},
			"Text": {
				"Primary": "#D0DCC8",
				"Secondary": "#B0C4A8",
				"Muted": "#809878",
				"Dim": "#607858",
				"Placeholder": "#486040"
			},
			"Brand": {
				"Accent": "#6AAF5C",
				"AccentHover": "#88CC78"
			},
			"Border": {
				"Default": "#2A3A28",
				"Light": "#3A4A38"
			},
			"Status": {
				"Danger": "#CC4422",
				"DangerMuted": "#884422"
			},
			"Scrollbar": {
				"Track": "#2A3A28",
				"Hover": "#3A4A38"
			},
			"Selection": {
				"Background": "rgba(106, 175, 92, 0.25)"
			},
			"Focus": {
				"Outline": "#6AAF5C"
			},
			"Syntax": {
				"Keyword":     "#D4E157",
				"String":      "#A5D6A7",
				"Number":      "#FFB74D",
				"Comment":     "#5D6F58",
				"Operator":    "#80CBC4",
				"Punctuation": "#A8C8A0",
				"Function":    "#FFCC80",
				"Variable":    "#C8E6C9",
				"Type":        "#FFB74D",
				"Builtin":     "#FFB74D",
				"Property":    "#FF8A65",
				"Tag":         "#FF8A65",
				"AttrName":    "#FFB74D",
				"AttrValue":   "#A5D6A7"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#B0C4A8",
		"Accent": "#6AAF5C",
		"Muted": "#607858",
		"Light": "#1E2620",
		"WarmBeige": "#22281E",
		"TealTint": "#1A221A",
		"Lavender": "#1E2420",
		"AmberTint": "#262218",
		"PdfFill": "#261A18",
		"PdfText": "#CC4422"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],104:[function(require,module,exports){
module.exports={
	"Hash": "hotdog",
	"Name": "Hotdog",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Red and mustard yellow, garish Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#8B0000",
				"Secondary": "#6B0000",
				"Tertiary": "#7B0000",
				"Panel": "#750000",
				"Viewer": "#550000",
				"Hover": "#AA1111",
				"Selected": "#BB3300",
				"Thumb": "#6B0000"
			},
			"Text": {
				"Primary": "#FFD700",
				"Secondary": "#FFC000",
				"Muted": "#CC9900",
				"Dim": "#AA7700",
				"Placeholder": "#886600"
			},
			"Brand": {
				"Accent": "#FFD700",
				"AccentHover": "#FFEE44"
			},
			"Border": {
				"Default": "#AA2222",
				"Light": "#BB3333"
			},
			"Status": {
				"Danger": "#FFFF00",
				"DangerMuted": "#CCCC00"
			},
			"Scrollbar": {
				"Track": "#AA2222",
				"Hover": "#CC3333"
			},
			"Selection": {
				"Background": "rgba(255, 215, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFD700"
			},
			"Syntax": {
				"Keyword":     "#FFD800",
				"String":      "#FFFFFF",
				"Number":      "#FFD800",
				"Comment":     "#9C2828",
				"Operator":    "#FFD800",
				"Punctuation": "#FFFFFF",
				"Function":    "#FFD800",
				"Variable":    "#FFFFFF",
				"Type":        "#FFD800",
				"Builtin":     "#FFD800",
				"Property":    "#FFD800",
				"Tag":         "#FFD800",
				"AttrName":    "#FFD800",
				"AttrValue":   "#FFFFFF"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Impact, 'Arial Black', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFC000",
		"Accent": "#FFD700",
		"Muted": "#AA7700",
		"Light": "#7B0000",
		"WarmBeige": "#800000",
		"TealTint": "#6B0000",
		"Lavender": "#780000",
		"AmberTint": "#7A1000",
		"PdfFill": "#6B0000",
		"PdfText": "#FFFF00"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],105:[function(require,module,exports){
module.exports={
	"Hash": "mobile-debug",
	"Name": "Mobile Container Debug",
	"Category": "Debug",
	"Version": "0.0.1",
	"Description": "Unique color per container for layout debugging Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FF0000",
				"Secondary": "#00CCCC",
				"Tertiary": "#00AA00",
				"Panel": "#FFAA00",
				"Viewer": "#333333",
				"Hover": "rgba(255, 255, 255, 0.2)",
				"Selected": "rgba(255, 255, 255, 0.3)",
				"Thumb": "#AA00AA"
			},
			"Text": {
				"Primary": "#FFFFFF",
				"Secondary": "#EEEEEE",
				"Muted": "#CCCCCC",
				"Dim": "#AAAAAA",
				"Placeholder": "#888888"
			},
			"Brand": {
				"Accent": "#FFFF00",
				"AccentHover": "#FFFF88"
			},
			"Border": {
				"Default": "#FFFFFF",
				"Light": "#CCCCCC"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#CC4444"
			},
			"Scrollbar": {
				"Track": "#888888",
				"Hover": "#AAAAAA"
			},
			"Selection": {
				"Background": "rgba(255, 255, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFFF00"
			},
			"Syntax": {
				"Keyword":     "#A626A4",
				"String":      "#50A14F",
				"Number":      "#986801",
				"Comment":     "#A0A1A7",
				"Operator":    "#0184BC",
				"Punctuation": "#383A42",
				"Function":    "#4078F2",
				"Variable":    "#383A42",
				"Type":        "#C18401",
				"Builtin":     "#986801",
				"Property":    "#E45649",
				"Tag":         "#E45649",
				"AttrName":    "#986801",
				"AttrValue":   "#50A14F"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFFFFF",
		"Accent": "#FFFF00",
		"Muted": "#CCCCCC",
		"Light": "#333333",
		"WarmBeige": "#FFAA00",
		"TealTint": "#00CCCC",
		"Lavender": "#AA00AA",
		"AmberTint": "#FFAA00",
		"PdfFill": "#FF4444",
		"PdfText": "#FFFFFF"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],106:[function(require,module,exports){
module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Neon pink on dark navy Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0D0D2B",
				"Secondary": "#080820",
				"Tertiary": "#121235",
				"Panel": "#0F0F28",
				"Viewer": "#060615",
				"Hover": "#1A1A42",
				"Selected": "#2A1845",
				"Thumb": "#080820"
			},
			"Text": {
				"Primary": "#E8E0F0",
				"Secondary": "#D0C8E0",
				"Muted": "#9088A8",
				"Dim": "#6860A0",
				"Placeholder": "#504888"
			},
			"Brand": {
				"Accent": "#FF2D8A",
				"AccentHover": "#FF5AA0"
			},
			"Border": {
				"Default": "#2A2050",
				"Light": "#382868"
			},
			"Status": {
				"Danger": "#FF4466",
				"DangerMuted": "#AA3355"
			},
			"Scrollbar": {
				"Track": "#2A2050",
				"Hover": "#3A3068"
			},
			"Selection": {
				"Background": "rgba(255, 45, 138, 0.25)"
			},
			"Focus": {
				"Outline": "#FF2D8A"
			},
			"Syntax": {
				"Keyword":     "#FF4E9F",
				"String":      "#A1FFCE",
				"Number":      "#FFD93D",
				"Comment":     "#807A9E",
				"Operator":    "#7DF9FF",
				"Punctuation": "#C0BCEB",
				"Function":    "#FFCC80",
				"Variable":    "#E0D8FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF6E6E",
				"Tag":         "#FF6E6E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#A1FFCE"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0C8E0",
		"Accent": "#FF2D8A",
		"Muted": "#6860A0",
		"Light": "#121235",
		"WarmBeige": "#141438",
		"TealTint": "#100E30",
		"Lavender": "#141232",
		"AmberTint": "#1A1228",
		"PdfFill": "#1A1028",
		"PdfText": "#FF4466"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],107:[function(require,module,exports){
module.exports={
	"Hash": "night",
	"Name": "Night",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Near-black, minimal contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0A0A",
				"Secondary": "#060606",
				"Tertiary": "#0E0E0E",
				"Panel": "#0C0C0C",
				"Viewer": "#040404",
				"Hover": "#161616",
				"Selected": "#252525",
				"Thumb": "#060606"
			},
			"Text": {
				"Primary": "#888888",
				"Secondary": "#707070",
				"Muted": "#555555",
				"Dim": "#444444",
				"Placeholder": "#333333"
			},
			"Brand": {
				"Accent": "#666666",
				"AccentHover": "#808080"
			},
			"Border": {
				"Default": "#1A1A1A",
				"Light": "#222222"
			},
			"Status": {
				"Danger": "#AA4444",
				"DangerMuted": "#663333"
			},
			"Scrollbar": {
				"Track": "#1A1A1A",
				"Hover": "#2A2A2A"
			},
			"Selection": {
				"Background": "rgba(102, 102, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#666666"
			},
			"Syntax": {
				"Keyword":     "#C28FFF",
				"String":      "#B0E0B0",
				"Number":      "#FFA070",
				"Comment":     "#888888",
				"Operator":    "#80C8FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFD080",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF9090",
				"Tag":         "#FF9090",
				"AttrName":    "#FFB870",
				"AttrValue":   "#B0E0B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#707070",
		"Accent": "#666666",
		"Muted": "#444444",
		"Light": "#0E0E0E",
		"WarmBeige": "#121212",
		"TealTint": "#0C0C0C",
		"Lavender": "#101010",
		"AmberTint": "#141210",
		"PdfFill": "#141010",
		"PdfText": "#AA4444"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],108:[function(require,module,exports){
module.exports={
	"Hash": "ocean",
	"Name": "Ocean",
	"Version": "0.0.1",
	"Description": "Cool blue-greens (180-235°) with warm coral / amber punctuation (5-30°). Paired light/dark; feels like sea + sun on the horizon.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f4f9fb", "Dark": "#0e1820" },
				"Secondary": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"Tertiary":  { "Light": "#dde9ee", "Dark": "#1f2c38" },
				"Panel":     { "Light": "#ffffff", "Dark": "#1a2632" },
				"Hover":     { "Light": "#e0eef3", "Dark": "#26323f" },
				"Selected":  { "Light": "#c8e1ea", "Dark": "#1e3a48" }
			},
			"Text": {
				"Primary":     { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Secondary":   { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#6c828b", "Dark": "#7a8e96" },
				"Placeholder": { "Light": "#90a4ad", "Dark": "#5a6e76" }
			},
			"Brand": {
				"Primary":      { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"PrimaryHover": { "Light": "#0a6371", "Dark": "#6dd4e2" },
				"Accent":       { "Light": "#e8a050", "Dark": "#f0b878" }
			},
			"Border": {
				"Default": { "Light": "#c0d5dc", "Dark": "#2c3d49" },
				"Light":   { "Light": "#d8e6ec", "Dark": "#1f2c38" },
				"Strong":  { "Light": "#90b0bc", "Dark": "#4a6470" }
			},
			"Status": {
				"Success": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Warning": { "Light": "#d68910", "Dark": "#f0b020" },
				"Error":   { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Info":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Data": {
				"1": { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"2": { "Light": "#e8a050", "Dark": "#f0b878" },
				"3": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"4": { "Light": "#c93a3a", "Dark": "#ff6464" },
				"5": { "Light": "#b07bac", "Dark": "#cda6cf" },
				"6": { "Light": "#d68910", "Dark": "#f0b020" },
				"7": { "Light": "#5a7f9e", "Dark": "#82a0c4" },
				"8": { "Light": "#6c828b", "Dark": "#a8c0c8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#dde9ee", "Dark": "#15212b" },
				"Thumb": { "Light": "#a8c2cc", "Dark": "#324658" },
				"Hover": { "Light": "#7a99a4", "Dark": "#506876" }
			},
			"Selection": {
				"Background": { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"Text":       { "Light": "#0e2832", "Dark": "#e1ecf0" }
			},
			"Focus": {
				"Outline": { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(14, 40, 50, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"String":      { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Number":      { "Light": "#d68910", "Dark": "#f0b020" },
				"Comment":     { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"Operator":    { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Punctuation": { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Function":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"Variable":    { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Type":        { "Light": "#e8a050", "Dark": "#f0b878" },
				"Builtin":     { "Light": "#d68910", "Dark": "#f0b020" },
				"Property":    { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Tag":         { "Light": "#c93a3a", "Dark": "#ff6464" },
				"AttrName":    { "Light": "#d68910", "Dark": "#f0b020" },
				"AttrValue":   { "Light": "#1f8a52", "Dark": "#4dc97a" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"LineNumberText":       { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"CurrentLineHighlight": { "Light": "#e0eef3", "Dark": "#26323f" },
				"SelectionBackground":  { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"GutterBorder":         { "Light": "#d8e6ec", "Dark": "#1f2c38" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Ocean",
		"Tagline": "Cool waters, warm sun"
	}
}

},{}],109:[function(require,module,exports){
module.exports={
	"Hash": "pict-default",
	"Name": "Pict Default",
	"Version": "0.0.1",
	"Description": "The reference paired light/dark theme for pict-based applications. Neutral palette suitable for any app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ebebeb", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#e0eaff", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":     { "Light": "#1a1a1a", "Dark": "#ededed" },
				"Secondary":   { "Light": "#454545", "Dark": "#bdbdbd" },
				"Muted":       { "Light": "#6b6b6b", "Dark": "#888888" },
				"Placeholder": { "Light": "#9a9a9a", "Dark": "#6a6a6a" }
			},
			"Brand": {
				"Primary":      { "Light": "#3357c7", "Dark": "#6b8eff" },
				"PrimaryHover": { "Light": "#2848b3", "Dark": "#88a4ff" },
				"Accent":       { "Light": "#c75033", "Dark": "#ff8a6b" }
			},
			"Border": {
				"Default": { "Light": "#d6d6d6", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#e9e9e9", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"Warning": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"Error":   { "Light": "#b62828", "Dark": "#ff7373" },
				"Info":    { "Light": "#1f6fb5", "Dark": "#5fb4ff" }
			},
			"Data": {
				"1": { "Light": "#3357c7", "Dark": "#6b8eff" },
				"2": { "Light": "#c75033", "Dark": "#ff8a6b" },
				"3": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"4": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"5": { "Light": "#6b3aac", "Dark": "#b08eff" },
				"6": { "Light": "#1f6fb5", "Dark": "#5fb4ff" },
				"7": { "Light": "#c63a8e", "Dark": "#ff7fb6" },
				"8": { "Light": "#6b6b6b", "Dark": "#bdbdbd" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ebebeb", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#c2c2c2", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Selection": {
				"Background": { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"Text":       { "Light": "#1a1a1a", "Dark": "#ededed" }
			},
			"Focus": {
				"Outline": { "Light": "#3357c7", "Dark": "#6b8eff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#f5f5f5", "Dark": "#1f1f1f" },
				"LineNumberText":       { "Light": "#9a9a9a", "Dark": "#6a6a6a" },
				"CurrentLineHighlight": { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"SelectionBackground":  { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"GutterBorder":         { "Light": "#e9e9e9", "Dark": "#2c2c2c" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Pict",
		"Tagline": "A JavaScript MVC framework for building web applications."
	},
	"CSS": [
		{
			"Hash": "pict-default-brand-accents",
			"Priority": 600,
			"Content": "/* pict-default — subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}

},{}],110:[function(require,module,exports){
module.exports={
	"Hash": "playground-corp",
	"Name": "Playground Corp",
	"Version": "0.0.1",
	"Description": "A different paired starter — corporate teal palette, rounder corners.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#fbfbfd", "Dark": "#0e1416" },
				"Secondary": { "Light": "#eef3f6", "Dark": "#152024" },
				"Tertiary":  { "Light": "#dde7ec", "Dark": "#1e2c30" },
				"Panel":     { "Light": "#ffffff", "Dark": "#162126" },
				"Hover":     { "Light": "#e5edf1", "Dark": "#1d292e" }
			},
			"Text": {
				"Primary":     { "Light": "#0a1d22", "Dark": "#e3edf0" },
				"Secondary":   { "Light": "#3a5b65", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#647e87", "Dark": "#7a929a" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Brand": {
				"Primary":      { "Light": "#117a8b", "Dark": "#3ec0d4" },
				"PrimaryHover": { "Light": "#0e6271", "Dark": "#5fd0e0" },
				"Accent":       { "Light": "#d97706", "Dark": "#fb923c" }
			},
			"Border": {
				"Default": { "Light": "#cfdce1", "Dark": "#2c3a3f" },
				"Strong":  { "Light": "#86a3ac", "Dark": "#4d5e64" }
			},
			"Status": {
				"Success": { "Light": "#0f7a52", "Dark": "#34d399" },
				"Warning": { "Light": "#b45309", "Dark": "#fbbf24" },
				"Error":   { "Light": "#9f1239", "Dark": "#fb7185" },
				"Info":    { "Light": "#1e6fbe", "Dark": "#60a5fa" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Inter, system-ui, sans-serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.25rem"
			},
			"Weight": {
				"Regular": "400",
				"Bold": "700"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "14px",
			"LG": "20px",
			"XL": "28px"
		},
		"Radius": {
			"SM": "4px",
			"MD": "10px",
			"LG": "16px"
		}
	},
	"Brand": {
		"Name": "Corp"
	},
	"Aliases": {
		"--pict-modal-overlay-bg":          "Color.Background.Tertiary",
		"--pict-modal-bg":                  "Color.Background.Panel",
		"--pict-modal-fg":                  "Color.Text.Primary",
		"--pict-modal-border":              "Color.Border.Default",
		"--pict-modal-shadow":              "Color.Border.Strong",
		"--pict-modal-header-bg":           "Color.Background.Secondary",
		"--pict-modal-header-fg":           "Color.Text.Primary",
		"--pict-modal-header-border":       "Color.Border.Default",
		"--pict-modal-btn-bg":              "Color.Background.Secondary",
		"--pict-modal-btn-fg":              "Color.Text.Primary",
		"--pict-modal-btn-hover-bg":        "Color.Background.Hover",
		"--pict-modal-btn-primary-bg":      "Color.Brand.Primary",
		"--pict-modal-btn-primary-fg":      "Color.Text.OnBrand",
		"--pict-modal-btn-primary-hover-bg":"Color.Brand.PrimaryHover",
		"--pict-modal-btn-danger-bg":       "Color.Status.Error",
		"--pict-modal-btn-danger-fg":       "Color.Text.OnBrand",
		"--pict-modal-btn-danger-hover-bg": "Color.Status.Error",
		"--pict-modal-toast-bg":            "Color.Background.Panel",
		"--pict-modal-toast-fg":            "Color.Text.Primary",
		"--pict-modal-toast-shadow":        "Color.Border.Strong",
		"--pict-modal-toast-success-bg":    "Color.Status.Success",
		"--pict-modal-toast-error-bg":      "Color.Status.Error",
		"--pict-modal-toast-warning-bg":    "Color.Status.Warning",
		"--pict-modal-toast-info-bg":       "Color.Status.Info",
		"--pict-modal-tooltip-bg":          "Color.Background.Tertiary",
		"--pict-modal-tooltip-fg":          "Color.Text.Primary",
		"--pict-modal-font-family":         "Typography.Family.Sans",

		"--pict-um-bg":          "Color.Background.Panel",
		"--pict-um-fg":          "Color.Text.Primary",
		"--pict-um-muted":       "Color.Text.Muted",
		"--pict-um-accent":      "Color.Brand.Primary",
		"--pict-um-border":      "Color.Border.Default",
		"--pict-um-border-soft": "Color.Border.Light",
		"--pict-um-input-bg":    "Color.Background.Primary",
		"--pict-um-pill-bg":     "Color.Background.Tertiary",
		"--pict-um-font":        "Typography.Family.Sans"
	}
}

},{}],111:[function(require,module,exports){
module.exports={
	"Hash": "retold-content-system",
	"Name": "Retold Content System",
	"Version": "0.0.1",
	"Description": "Default palette for the Retold Content System editor — warm beige with teal accents. Light side preserves the original retold-content-system.css palette verbatim; dark side keeps the teal accent and warms the backgrounds into a deep walnut/charcoal range so dark mode reads as the same family of values rather than a generic dark theme.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F3EE", "Dark": "#1F1B17" },
				"Secondary": { "Light": "#FAF8F4", "Dark": "#2A251F" },
				"Tertiary":  { "Light": "#F0EDE8", "Dark": "#332D26" },
				"Panel":     { "Light": "#FFFFFF", "Dark": "#26221C" },
				"Hover":     { "Light": "#EDE9E3", "Dark": "#383028" },
				"Selected":  { "Light": "#DCE9E7", "Dark": "#1E3833" }
			},
			"Text": {
				"Primary":     { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Secondary":   { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Muted":       { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Placeholder": { "Light": "#A89E91", "Dark": "#6E6457" },
				"OnBrand":     { "Light": "#FFFFFF", "Dark": "#1F1B17" }
			},
			"Brand": {
				"Primary":      { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"PrimaryHover": { "Light": "#3A9E92", "Dark": "#65CBBE" },
				"Accent":       { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"AccentHover":  { "Light": "#3A9E92", "Dark": "#65CBBE" }
			},
			"Border": {
				"Default": { "Light": "#DDD6CA", "Dark": "#3F362C" },
				"Light":   { "Light": "#E8E2D7", "Dark": "#33291F" },
				"Strong":  { "Light": "#C4BDB0", "Dark": "#5A4F40" }
			},
			"Status": {
				"Success": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"Warning": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"Error":   { "Light": "#D9534F", "Dark": "#E87B78" },
				"Info":    { "Light": "#5DA6C7", "Dark": "#7FBDD8" }
			},
			"Data": {
				"1": { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"2": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"3": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"4": { "Light": "#D9534F", "Dark": "#E87B78" },
				"5": { "Light": "#A07ACC", "Dark": "#BCA0DC" },
				"6": { "Light": "#5DA6C7", "Dark": "#7FBDD8" },
				"7": { "Light": "#C46B8A", "Dark": "#D8919E" },
				"8": { "Light": "#8A7F72", "Dark": "#B8AFA4" }
			},
			"Scrollbar": {
				"Track": { "Light": "#F5F0E8", "Dark": "#26221C" },
				"Thumb": { "Light": "#C4BDB0", "Dark": "#4A4036" },
				"Hover": { "Light": "#8A7F72", "Dark": "#6A5F50" }
			},
			"Selection": {
				"Background": { "Light": "#CDE3E0", "Dark": "#2E5B55" },
				"Text":       { "Light": "#3D3229", "Dark": "#E8DCC8" }
			},
			"Focus": {
				"Outline": { "Light": "#2E7D74", "Dark": "#4FB3A6" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(61, 50, 41, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#A0532E", "Dark": "#E89A6E" },
				"String":      { "Light": "#3F8A52", "Dark": "#8FD493" },
				"Number":      { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Comment":     { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Operator":    { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"Punctuation": { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Function":    { "Light": "#2E5E96", "Dark": "#7FBDD8" },
				"Variable":    { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Type":        { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Builtin":     { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Property":    { "Light": "#A0532E", "Dark": "#E89A6E" },
				"Tag":         { "Light": "#A0532E", "Dark": "#E89A6E" },
				"AttrName":    { "Light": "#A86B00", "Dark": "#E8A94D" },
				"AttrValue":   { "Light": "#3F8A52", "Dark": "#8FD493" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth":    "250px",
			"TopbarHeight":    "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Content",
		"Tagline": "Author content for the Retold ecosystem."
	}
}

},{}],112:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-cyberpunk",
	"Name": "Retold Labs Cyberpunk",
	"Version": "0.0.1",
	"Description": "retold-labs’ neon \"cyberpunk\" identity — cyan/magenta on near-black (dark) or violet on light. Preserves the original cyberpunk-light / cyberpunk-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#eae8f0",
					"Dark": "#0a0a12"
				},
				"Secondary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Tertiary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Panel": {
					"Light": "#f4f2fa",
					"Dark": "#1a1628"
				},
				"Sidebar": {
					"Light": "#1e1430",
					"Dark": "#06060e"
				},
				"Hover": {
					"Light": "rgba(130, 0, 200, 0.06)",
					"Dark": "rgba(0, 255, 255, 0.08)"
				},
				"Selected": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Secondary": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Muted": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Placeholder": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"OnBrand": {
					"Light": "#d0c8e0",
					"Dark": "#d0c8e0"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"PrimaryHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				},
				"Accent": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AccentHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Light": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Strong": {
					"Light": "#2a2040",
					"Dark": "#1a1430"
				}
			},
			"Status": {
				"Success": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Warning": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Error": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Info": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Thumb": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Hover": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				},
				"Text": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(26, 16, 40, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"String": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Number": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Comment": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Operator": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Punctuation": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Function": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Variable": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Type": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Builtin": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Property": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Tag": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AttrName": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"AttrValue": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],113:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-retro",
	"Name": "Retold Labs Retro",
	"Version": "0.0.1",
	"Description": "retold-labs’ \"retro\" identity — amber/green phosphor on dark or sepia/olive on light. Preserves the original retro-light / retro-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#f5f0e0",
					"Dark": "#0c0c08"
				},
				"Secondary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Tertiary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Panel": {
					"Light": "#faf6e8",
					"Dark": "#1e1e14"
				},
				"Sidebar": {
					"Light": "#3a3020",
					"Dark": "#080804"
				},
				"Hover": {
					"Light": "rgba(140, 80, 20, 0.06)",
					"Dark": "rgba(255, 176, 0, 0.08)"
				},
				"Selected": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Secondary": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Muted": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Placeholder": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"OnBrand": {
					"Light": "#d8c8a0",
					"Dark": "#c8b870"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"PrimaryHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				},
				"Accent": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AccentHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				}
			},
			"Border": {
				"Default": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Light": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Strong": {
					"Light": "#4a4030",
					"Dark": "#1a1a10"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Warning": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Error": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Info": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Thumb": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Hover": {
					"Light": "#8a7450",
					"Dark": "#706848"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				},
				"Text": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(46, 36, 24, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"String": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Number": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Comment": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Operator": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Punctuation": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Function": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Variable": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Type": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Builtin": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Property": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Tag": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AttrName": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"AttrValue": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],114:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs",
	"Name": "Retold Labs",
	"Version": "0.0.1",
	"Description": "retold-labs’ original \"professional\" identity — warm beige with teal accents and a deep teal sidebar. Light side preserves professional-light verbatim; dark side preserves professional-dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#faf6f0",
					"Dark": "#14201e"
				},
				"Secondary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Tertiary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#1e3532"
				},
				"Sidebar": {
					"Light": "#1a3a3a",
					"Dark": "#0e1a18"
				},
				"Hover": {
					"Light": "rgba(13, 138, 138, 0.06)",
					"Dark": "rgba(45, 212, 191, 0.08)"
				},
				"Selected": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Secondary": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Muted": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Placeholder": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"OnBrand": {
					"Light": "#c8dcd8",
					"Dark": "#c8dcd8"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"PrimaryHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				},
				"Accent": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AccentHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				}
			},
			"Border": {
				"Default": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Light": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Strong": {
					"Light": "#2a5454",
					"Dark": "#1e3a36"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Warning": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Error": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Info": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Thumb": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Hover": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				},
				"Text": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(44, 36, 22, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.45)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"String": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Number": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Comment": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Operator": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Punctuation": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Function": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Variable": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Type": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Builtin": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Property": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Tag": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AttrName": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"AttrValue": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],115:[function(require,module,exports){
module.exports={
	"Hash": "retold-manager",
	"Name": "Retold Manager",
	"Description": "Default palette for the Retold Manager application — GitHub-style dark on slate with a parallel light variant. Dark side mirrors retold-manager.css's original colors verbatim; light side is a sympathetic translation tuned for daytime use. The retold-manager.css :root block proxies its --color-* names through these --theme-color-* tokens (with the original hexes as fallbacks), so this theme drives the whole app cleanly and other catalog themes still skin most of it.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f6f8fa", "Dark": "#0e1116" },
				"Secondary": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Tertiary":  { "Light": "#e4e8ec", "Dark": "#1c2128" },
				"Panel":     { "Light": "#ffffff", "Dark": "#161b22" },
				"PanelAlt":  { "Light": "#f0f3f6", "Dark": "#1c2128" },
				"Hover":     { "Light": "#eaeef2", "Dark": "#1c2128" },
				"Selected":  { "Light": "#dbe7ff", "Dark": "#243454" }
			},
			"Border": {
				"Default":   { "Light": "#d0d7de", "Dark": "#30363d" },
				"Light":     { "Light": "#e1e4e8", "Dark": "#21262d" },
				"Strong":    { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Brand": {
				"Primary":      { "Light": "#0969da", "Dark": "#2f81f7" },
				"PrimaryHover": { "Light": "#0550ae", "Dark": "#1f6feb" },
				"Accent":       { "Light": "#0969da", "Dark": "#2f81f7" },
				"AccentHover":  { "Light": "#0550ae", "Dark": "#1f6feb" }
			},
			"Text": {
				"Primary":     { "Light": "#1f2328", "Dark": "#e6edf3" },
				"Secondary":   { "Light": "#3b424a", "Dark": "#c9d1d9" },
				"Muted":       { "Light": "#656d76", "Dark": "#8b949e" },
				"Placeholder": { "Light": "#8c959f", "Dark": "#6e7681" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"Danger":  { "Light": "#cf222e", "Dark": "#f85149" },
				"Warning": { "Light": "#9a6700", "Dark": "#d29922" },
				"Error":   { "Light": "#cf222e", "Dark": "#f85149" },
				"Info":    { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Data": {
				"1": { "Light": "#0969da", "Dark": "#2f81f7" },
				"2": { "Light": "#cf222e", "Dark": "#f85149" },
				"3": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"4": { "Light": "#9a6700", "Dark": "#d29922" },
				"5": { "Light": "#8250df", "Dark": "#a371f7" },
				"6": { "Light": "#bf3989", "Dark": "#db61a2" },
				"7": { "Light": "#1b7c83", "Dark": "#39c5cf" },
				"8": { "Light": "#656d76", "Dark": "#8b949e" }
			},
			"Scrollbar": {
				"Track": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Thumb": { "Light": "#c1c8cf", "Dark": "#30363d" },
				"Hover": { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Selection": {
				"Background": { "Light": "#cfe6ff", "Dark": "#243454" },
				"Text":       { "Light": "#1f2328", "Dark": "#e6edf3" }
			},
			"Focus": {
				"Outline": { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#cf222e", "Dark": "#ff7b72" },
				"String":      { "Light": "#0a3069", "Dark": "#a5d6ff" },
				"Number":      { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Comment":     { "Light": "#6e7781", "Dark": "#8b949e" },
				"Operator":    { "Light": "#cf222e", "Dark": "#ff7b72" },
				"Punctuation": { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Function":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"Variable":    { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Type":        { "Light": "#953800", "Dark": "#ffa657" },
				"Builtin":     { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Property":    { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Tag":         { "Light": "#116329", "Dark": "#7ee787" },
				"AttrName":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"AttrValue":   { "Light": "#0a3069", "Dark": "#a5d6ff" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, \"SF Pro\", \"Segoe UI\", sans-serif",
				"Mono": "ui-monospace, \"SF Mono\", Menlo, Monaco, \"Courier New\", monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "280px",
			"TopbarHeight":    "44px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],116:[function(require,module,exports){
module.exports={
	"Hash": "retold-mono",
	"Name": "Retold Mono",
	"Version": "0.0.2",
	"Description": "High-contrast monochrome theme — black on white in light mode, white on black in dark mode. Useful for print, simple admin tooling, and as a paired-mode reference theme that proves the toggle works on something visually unmistakable.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#101010" },
				"Tertiary":  { "Light": "#e2e2e2", "Dark": "#1c1c1c" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#ebebeb", "Dark": "#1a1a1a" },
				"Selected":  { "Light": "#d6d6d6", "Dark": "#2a2a2a" }
			},
			"Text": {
				"Primary":     { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary":   { "Light": "#222222", "Dark": "#dddddd" },
				"Muted":       { "Light": "#555555", "Dark": "#aaaaaa" },
				"Placeholder": { "Light": "#888888", "Dark": "#777777" }
			},
			"Brand": {
				"Primary":      { "Light": "#000000", "Dark": "#ffffff" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Border": {
				"Default": { "Light": "#888888", "Dark": "#666666" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Data": {
				"1": { "Light": "#000000", "Dark": "#ffffff" },
				"2": { "Light": "#262626", "Dark": "#e0e0e0" },
				"3": { "Light": "#404040", "Dark": "#c0c0c0" },
				"4": { "Light": "#595959", "Dark": "#a0a0a0" },
				"5": { "Light": "#737373", "Dark": "#808080" },
				"6": { "Light": "#8c8c8c", "Dark": "#737373" },
				"7": { "Light": "#a6a6a6", "Dark": "#595959" },
				"8": { "Light": "#bfbfbf", "Dark": "#404040" }
			},
			"Scrollbar": {
				"Track": { "Light": "#e0e0e0", "Dark": "#101010" },
				"Thumb": { "Light": "#888888", "Dark": "#666666" },
				"Hover": { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Selection": {
				"Background": { "Light": "#000000", "Dark": "#ffffff" },
				"Text":       { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.18)", "Dark": "rgba(255, 255, 255, 0.18)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#000000", "Dark": "#ffffff" },
				"String":      { "Light": "#555555", "Dark": "#cccccc" },
				"Number":      { "Light": "#000000", "Dark": "#ffffff" },
				"Comment":     { "Light": "#888888", "Dark": "#888888" },
				"Operator":    { "Light": "#000000", "Dark": "#ffffff" },
				"Punctuation": { "Light": "#444444", "Dark": "#bbbbbb" },
				"Function":    { "Light": "#000000", "Dark": "#ffffff" },
				"Variable":    { "Light": "#000000", "Dark": "#ffffff" },
				"Type":        { "Light": "#222222", "Dark": "#dddddd" },
				"Builtin":     { "Light": "#222222", "Dark": "#dddddd" },
				"Property":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"Tag":         { "Light": "#000000", "Dark": "#ffffff" },
				"AttrName":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"AttrValue":   { "Light": "#555555", "Dark": "#cccccc" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Times New Roman, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "600",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.15",
				"Normal": "1.4",
				"Loose": "1.65"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "0",
			"MD": "0",
			"LG": "0",
			"XL": "0",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 0 var(--theme-color-shadow-color)",
			"MD": "0 2px 0 var(--theme-color-shadow-color)",
			"LG": "0 4px 0 var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "0ms",
			"Normal": "0ms",
			"Slow": "0ms"
		}
	},
	"Brand": {
		"Name": "Retold Mono",
		"Tagline": "Black on white. White on black. Nothing else."
	},
	"CSS": [
		{
			"Hash": "retold-mono-brand-accents",
			"Priority": 600,
			"Content": "/* retold-mono — keeps the all-monochrome aesthetic but lets brand colors\n   in for narrow accent moments. The thick rule under H1 is brand primary;\n   the hair rule under H2 is brand secondary. Without a brand registered\n   they fall back to mono black/grey. */\na { text-decoration-color: var(--brand-color-primary-mode, currentColor); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 3px solid var(--brand-color-primary-mode, var(--theme-color-text-primary, #000)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-default, #888)); padding-bottom: 4px; }"
		}
	]
}

},{}],117:[function(require,module,exports){
module.exports={
	"Hash": "solarized-dark",
	"Name": "Solarized Dark",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Schoonover's classic palette Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#002B36",
				"Secondary": "#073642",
				"Tertiary": "#003B4A",
				"Panel": "#00303C",
				"Viewer": "#001E28",
				"Hover": "#0A4858",
				"Selected": "#155868",
				"Thumb": "#073642"
			},
			"Text": {
				"Primary": "#FDF6E3",
				"Secondary": "#EEE8D5",
				"Muted": "#93A1A1",
				"Dim": "#839496",
				"Placeholder": "#657B83"
			},
			"Brand": {
				"Accent": "#268BD2",
				"AccentHover": "#45A0E0"
			},
			"Border": {
				"Default": "#0A4050",
				"Light": "#125868"
			},
			"Status": {
				"Danger": "#DC322F",
				"DangerMuted": "#AA2A28"
			},
			"Scrollbar": {
				"Track": "#0A4050",
				"Hover": "#125868"
			},
			"Selection": {
				"Background": "rgba(38, 139, 210, 0.25)"
			},
			"Focus": {
				"Outline": "#268BD2"
			},
			"Syntax": {
				"Keyword":     "#859900",
				"String":      "#2AA198",
				"Number":      "#D33682",
				"Comment":     "#586E75",
				"Operator":    "#268BD2",
				"Punctuation": "#93A1A1",
				"Function":    "#B58900",
				"Variable":    "#FDF6E3",
				"Type":        "#B58900",
				"Builtin":     "#CB4B16",
				"Property":    "#268BD2",
				"Tag":         "#268BD2",
				"AttrName":    "#B58900",
				"AttrValue":   "#2AA198"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Source Code Pro', 'Fira Code', monospace",
				"Mono": "'Source Code Pro', 'Fira Code', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#EEE8D5",
		"Accent": "#268BD2",
		"Muted": "#839496",
		"Light": "#003B4A",
		"WarmBeige": "#073642",
		"TealTint": "#004050",
		"Lavender": "#003848",
		"AmberTint": "#0A3A30",
		"PdfFill": "#0A3028",
		"PdfText": "#DC322F"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],118:[function(require,module,exports){
module.exports={
	"Hash": "synthwave",
	"Name": "Synthwave",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Purple and pink neon Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A0A2E",
				"Secondary": "#140824",
				"Tertiary": "#200E38",
				"Panel": "#1C0C32",
				"Viewer": "#100620",
				"Hover": "#2A1848",
				"Selected": "#3A2060",
				"Thumb": "#140824"
			},
			"Text": {
				"Primary": "#E8C0F8",
				"Secondary": "#D0A8E8",
				"Muted": "#9878B8",
				"Dim": "#7858A8",
				"Placeholder": "#584088"
			},
			"Brand": {
				"Accent": "#FF71CE",
				"AccentHover": "#FF99DD"
			},
			"Border": {
				"Default": "#302050",
				"Light": "#402868"
			},
			"Status": {
				"Danger": "#FF4488",
				"DangerMuted": "#AA3366"
			},
			"Scrollbar": {
				"Track": "#302050",
				"Hover": "#402868"
			},
			"Selection": {
				"Background": "rgba(255, 113, 206, 0.25)"
			},
			"Focus": {
				"Outline": "#FF71CE"
			},
			"Syntax": {
				"Keyword":     "#FF6AD5",
				"String":      "#FFE066",
				"Number":      "#FF6AD5",
				"Comment":     "#9C8AC1",
				"Operator":    "#26F0F1",
				"Punctuation": "#C8B6E2",
				"Function":    "#26F0F1",
				"Variable":    "#FFE0FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF477E",
				"Tag":         "#FF477E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#FFE066"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Trebuchet MS', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0A8E8",
		"Accent": "#FF71CE",
		"Muted": "#7858A8",
		"Light": "#200E38",
		"WarmBeige": "#221040",
		"TealTint": "#1A0C30",
		"Lavender": "#1E0E36",
		"AmberTint": "#241028",
		"PdfFill": "#241020",
		"PdfText": "#FF4488"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],119:[function(require,module,exports){
module.exports={
	"Hash": "twilight",
	"Name": "Twilight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Dark grey, low light. Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format. Single-mode (no light/dark bifurcation). Aliases preserve the legacy `--retold-*` variable names so existing CSS keeps working through the migration.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1E1E1E",
				"Secondary": "#181818",
				"Tertiary": "#252525",
				"Panel": "#202020",
				"Viewer": "#141414",
				"Hover": "#2E2E2E",
				"Selected": "#404040",
				"Thumb": "#181818"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#C8C8C8",
				"Muted": "#909090",
				"Dim": "#707070",
				"Placeholder": "#585858"
			},
			"Brand": {
				"Accent": "#A0A0A0",
				"AccentHover": "#C0C0C0"
			},
			"Border": {
				"Default": "#333333",
				"Light": "#404040"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#404040",
				"Hover": "#505050"
			},
			"Selection": {
				"Background": "rgba(160, 160, 160, 0.25)"
			},
			"Focus": {
				"Outline": "#A0A0A0"
			},
			"Syntax": {
				"Keyword":     "#B58FFF",
				"String":      "#9CDFB0",
				"Number":      "#FFB870",
				"Comment":     "#6E6E6E",
				"Operator":    "#7CC5FF",
				"Punctuation": "#C0C0C0",
				"Function":    "#FFD080",
				"Variable":    "#E0E0E0",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF8B8B",
				"Tag":         "#FF8B8B",
				"AttrName":    "#FFB870",
				"AttrValue":   "#9CDFB0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#C8C8C8",
		"Accent": "#A0A0A0",
		"Muted": "#707070",
		"Light": "#252525",
		"WarmBeige": "#2A2A2A",
		"TealTint": "#222222",
		"Lavender": "#282828",
		"AmberTint": "#2E2A24",
		"PdfFill": "#2E2224",
		"PdfText": "#E06060"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],120:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-canyon",
	"Name": "Ultravisor — Desert Canyon",
	"Version": "0.0.1",
	"Description": "Vibrant desert palette — orange brand and teal accents on deep canyon-brown backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#18120e",
				"Secondary": "#221a14",
				"Tertiary":  "#2e2018",
				"Panel":     "#221a14",
				"Hover":     "#3a2a1e",
				"Selected":  "#3a2a1e"
			},
			"Text": {
				"Primary":     "#d8c8b0",
				"Secondary":   "#e8d8c0",
				"Muted":       "#a09080",
				"Placeholder": "#685040",
				"OnBrand":     "#18120e"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#18a0a0",
				"AccentHover":  "#30b0b0"
			},
			"Border": {
				"Default": "#3a2a1e",
				"Light":   "#2e2018",
				"Strong":  "#4a3a2e"
			},
			"Status": {
				"Success": "#18a0a0",
				"Warning": "#e0c870",
				"Error":   "#e05830",
				"Info":    "#18a0a0"
			},
			"Scrollbar": {
				"Track": "#221a14",
				"Thumb": "#3a2a1e",
				"Hover": "#4a3a2e"
			},
			"Selection": {
				"Background": "#3a2a1e",
				"Text":       "#e8d8c0"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#221a14",
				"LineNumberText":       "#685040",
				"CurrentLineHighlight": "#2e2018",
				"SelectionBackground":  "#3a2a1e",
				"GutterBorder":         "#2e2018"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],121:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-day",
	"Name": "Ultravisor — Desert Day",
	"Version": "0.0.1",
	"Description": "Ultravisor's warm light palette — cream backgrounds, deep walnut text, teal accents. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#faf6f0",
				"Secondary": "#f0e6d6",
				"Tertiary":  "#e8ddd0",
				"Panel":     "#ffffff",
				"Hover":     "#f0e6d6",
				"Selected":  "#e8ddd0"
			},
			"Text": {
				"Primary":     "#3d2b1f",
				"Secondary":   "#2e1e14",
				"Muted":       "#8a7560",
				"Placeholder": "#a09080",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#5c3d2e",
				"PrimaryHover": "#7a5040",
				"Accent":       "#3a8a8c",
				"AccentHover":  "#2a7070"
			},
			"Border": {
				"Default": "#e0d0b8",
				"Light":   "#e8ddd0",
				"Strong":  "#c8b8a0"
			},
			"Status": {
				"Success": "#5a7a30",
				"Warning": "#b08020",
				"Error":   "#a03040",
				"Info":    "#3a8a8c"
			},
			"Scrollbar": {
				"Track": "#f0e6d6",
				"Thumb": "#d0c0a8",
				"Hover": "#c0b098"
			},
			"Selection": {
				"Background": "#e8ddd0",
				"Text":       "#2e1e14"
			},
			"Focus": {
				"Outline": "#c2703e"
			},
			"Shadow": {
				"Color": "rgba(92, 61, 46, 0.10)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f0e6d6",
				"LineNumberText":       "#a09080",
				"CurrentLineHighlight": "#f5ede0",
				"SelectionBackground":  "#e8ddd0",
				"GutterBorder":         "#e0d0b8"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],122:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-dusk",
	"Name": "Ultravisor — Desert Dusk",
	"Version": "0.0.1",
	"Description": "Ultravisor's original default — warm tan brand on muted dark desert backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a1714",
				"Secondary": "#252018",
				"Tertiary":  "#302818",
				"Panel":     "#252018",
				"Hover":     "#3a3028",
				"Selected":  "#3a3028"
			},
			"Text": {
				"Primary":     "#c8b8a0",
				"Secondary":   "#d8c8a8",
				"Muted":       "#907860",
				"Placeholder": "#706050",
				"OnBrand":     "#FFFFFF"
			},
			"Brand": {
				"Primary":      "#c4956a",
				"PrimaryHover": "#d4a57a",
				"Accent":       "#4a9090",
				"AccentHover":  "#5aacac"
			},
			"Border": {
				"Default": "#3a3028",
				"Light":   "#302818",
				"Strong":  "#4a4038"
			},
			"Status": {
				"Success": "#8a9a5a",
				"Warning": "#c0a050",
				"Error":   "#b04050",
				"Info":    "#4a9090"
			},
			"Scrollbar": {
				"Track": "#252018",
				"Thumb": "#3a3028",
				"Hover": "#4a4038"
			},
			"Selection": {
				"Background": "#3a3028",
				"Text":       "#d8c8a8"
			},
			"Focus": {
				"Outline": "#c4956a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#252018",
				"LineNumberText":       "#706050",
				"CurrentLineHighlight": "#302818",
				"SelectionBackground":  "#3a3028",
				"GutterBorder":         "#302818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],123:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-sunset",
	"Name": "Ultravisor — Desert Sunset",
	"Version": "0.0.1",
	"Description": "Ultravisor's golden-hour palette — orange brand on rust-warmed dark backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1e1610",
				"Secondary": "#2a2018",
				"Tertiary":  "#342818",
				"Panel":     "#2a2018",
				"Hover":     "#3a2e22",
				"Selected":  "#3a2e22"
			},
			"Text": {
				"Primary":     "#d4c4aa",
				"Secondary":   "#e0d0b8",
				"Muted":       "#8a7560",
				"Placeholder": "#6a5840",
				"OnBrand":     "#1e1610"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#2a8a8a",
				"AccentHover":  "#3a9a9a"
			},
			"Border": {
				"Default": "#3a2e22",
				"Light":   "#342818",
				"Strong":  "#4a3e32"
			},
			"Status": {
				"Success": "#6a9a3a",
				"Warning": "#d4a46a",
				"Error":   "#c44e2a",
				"Info":    "#2a8a8a"
			},
			"Scrollbar": {
				"Track": "#2a2018",
				"Thumb": "#3a2e22",
				"Hover": "#4a3e32"
			},
			"Selection": {
				"Background": "#3a2e22",
				"Text":       "#e0d0b8"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#2a2018",
				"LineNumberText":       "#6a5840",
				"CurrentLineHighlight": "#342818",
				"SelectionBackground":  "#3a2e22",
				"GutterBorder":         "#342818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],124:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-dark",
	"Name": "Ultravisor — Professional Dark",
	"Version": "0.0.1",
	"Description": "Dark modern palette — slate-blue text on inky surfaces, sky-blue brand. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#111318",
				"Secondary": "#1a1d24",
				"Tertiary":  "#22252e",
				"Panel":     "#1a1d24",
				"Hover":     "#282c34",
				"Selected":  "#282c34"
			},
			"Text": {
				"Primary":     "#c8cdd5",
				"Secondary":   "#e0e4ea",
				"Muted":       "#8b92a0",
				"Placeholder": "#5a6070",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#60a5fa",
				"PrimaryHover": "#93c5fd",
				"Accent":       "#60a5fa",
				"AccentHover":  "#93c5fd"
			},
			"Border": {
				"Default": "#282c34",
				"Light":   "#22252e",
				"Strong":  "#3a3f4a"
			},
			"Status": {
				"Success": "#34d399",
				"Warning": "#fbbf24",
				"Error":   "#f87171",
				"Info":    "#60a5fa"
			},
			"Scrollbar": {
				"Track": "#1a1d24",
				"Thumb": "#282c34",
				"Hover": "#3a3f4a"
			},
			"Selection": {
				"Background": "#1e2230",
				"Text":       "#e0e4ea"
			},
			"Focus": {
				"Outline": "#60a5fa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#1a1d24",
				"LineNumberText":       "#5a6070",
				"CurrentLineHighlight": "#22252e",
				"SelectionBackground":  "#1e2230",
				"GutterBorder":         "#22252e"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],125:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-light",
	"Name": "Ultravisor — Professional Light",
	"Version": "0.0.1",
	"Description": "Bright modern palette — slate text on near-white backgrounds, royal-blue brand. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#f5f6f8",
				"Secondary": "#ffffff",
				"Tertiary":  "#e4e7ec",
				"Panel":     "#ffffff",
				"Hover":     "#f0f1f4",
				"Selected":  "#e4e7ec"
			},
			"Text": {
				"Primary":     "#2d3748",
				"Secondary":   "#1a202c",
				"Muted":       "#6b7280",
				"Placeholder": "#9ca3af",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#3b82f6",
				"PrimaryHover": "#2563eb",
				"Accent":       "#3b82f6",
				"AccentHover":  "#2563eb"
			},
			"Border": {
				"Default": "#e2e5ea",
				"Light":   "#eceef2",
				"Strong":  "#c8cdd5"
			},
			"Status": {
				"Success": "#10b981",
				"Warning": "#f59e0b",
				"Error":   "#ef4444",
				"Info":    "#3b82f6"
			},
			"Scrollbar": {
				"Track": "#f0f1f4",
				"Thumb": "#d1d5db",
				"Hover": "#b0b5bd"
			},
			"Selection": {
				"Background": "#dbeafe",
				"Text":       "#1a202c"
			},
			"Focus": {
				"Outline": "#3b82f6"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f5f6f8",
				"LineNumberText":       "#9ca3af",
				"CurrentLineHighlight": "#f0f1f4",
				"SelectionBackground":  "#dbeafe",
				"GutterBorder":         "#e2e5ea"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],126:[function(require,module,exports){
/**
 * Theme-BottomBar — standard application footer row.
 *
 * The bottom-row counterpart to Theme-TopBar: a thin status / chrome bar
 * that sits at the absolute bottom of the application shell. Three
 * zones — status text on the left, info indicators in the middle, and
 * action buttons / toggles on the right.
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ Status text          [── Info slot (flex) ──]      [actions]   │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Renders into `#Theme-BottomBar` by default.
 *
 * Three slots host views drop content into:
 *   - `#Theme-BottomBar-Status`  — short status / state line (left)
 *   - `#Theme-BottomBar-Info`    — center info: connection, version,
 *                                  ambient indicators
 *   - `#Theme-BottomBar-Actions` — log toggle, debug controls, etc.
 *
 * Top border uses `--brand-color-secondary-mode` so the bottombar gets
 * a brand-tinted edge that's visually distinct from the topbar's
 * primary-color stripe.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BottomBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BottomBar',
	DefaultRenderable: 'Theme-BottomBar-Renderable',

	// ViewIdentifier of a host view that fills #Theme-BottomBar-Status.
	StatusView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Info.
	InfoView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Actions.
	ActionsView: null,

	// Height of the bar in pixels. Drives the min-height on the chrome
	// row so it fills the panel cleanly even when the parent chain
	// (pict-section-modal shell uses min-height: 100% on its panel
	// content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 32,

	Templates:
	[
		{
			Hash: 'Theme-BottomBar-Template',
			Template: /*html*/`
<div class="pict-theme-bottombar">
	<div class="pict-theme-bottombar-status" id="Theme-BottomBar-Status"></div>
	<div class="pict-theme-bottombar-info" id="Theme-BottomBar-Info"></div>
	<div class="pict-theme-bottombar-actions" id="Theme-BottomBar-Actions"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BottomBar-Renderable',
			TemplateHash: 'Theme-BottomBar-Template',
			ContentDestinationAddress: '#Theme-BottomBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-bottombar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 32). A fixed px value avoids the
	   percent-height resolution trap the pict-section-modal shell sets
	   up — see the comment on Theme-TopBar's CSS for the full story. */
	min-height: 32px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-secondary, transparent);
	font-size: var(--theme-typography-size-xs, 12px);
	color: var(--theme-color-text-secondary, #4a5568);
	/* Single medium brand-primary stripe at the top of the bottombar.
	   The topbar carries the full two-stripe identifier; on the
	   bottombar (which is only 32px tall) a single 2px primary line is
	   enough to seat the brand colour at the bottom of the page
	   without competing for visual weight against the content row. */
	border-top: 2px solid var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
.pict-theme-bottombar-status {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 50%;
}
.pict-theme-bottombar-info {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	min-width: 0;
	overflow: hidden;
}
.pict-theme-bottombar-actions {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
}`,
	CSSPriority: 500
};

class PictViewThemeBottomBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-bottombar
		// — see the matching block in Theme-TopBar's onAfterRender for why.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-bottombar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		let tmpRenderSlot = (pIdentifier) =>
		{
			if (!pIdentifier) return;
			let tmpView = this.pict.views[pIdentifier];
			if (tmpView) { tmpView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-BottomBar: slot view "' + pIdentifier + '" not registered');
			}
		};
		tmpRenderSlot(this.options.StatusView);
		tmpRenderSlot(this.options.InfoView);
		tmpRenderSlot(this.options.ActionsView);

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Mirrors Theme-TopBar's setNavView / setUserView — call from a
	// router callback to swap the bottom bar's slot content as the
	// route changes (different status formats per page, etc.).

	setStatusView(pViewIdentifier)  { this._setSlotView('StatusView',  '#Theme-BottomBar-Status',  pViewIdentifier); }
	setInfoView(pViewIdentifier)    { this._setSlotView('InfoView',    '#Theme-BottomBar-Info',    pViewIdentifier); }
	setActionsView(pViewIdentifier) { this._setSlotView('ActionsView', '#Theme-BottomBar-Actions', pViewIdentifier); }

	_setSlotView(pOptionKey, pDestSelector, pViewIdentifier)
	{
		this.options[pOptionKey] = pViewIdentifier || null;
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-BottomBar: view "' + pViewIdentifier + '" not registered');
		}
	}
}

module.exports = PictViewThemeBottomBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":137}],127:[function(require,module,exports){
/**
 * Theme-Brand-Mark — single-row inline brand mark (icon + name).
 *
 * The drop-in counterpart to Theme-BrandStrip for apps that put the
 * brand wordmark *inside* their topbar (next to action buttons) rather
 * than as a multi-row chrome below the nav.
 *
 * Layout:
 *
 *   ┌─────────────────────────┐
 *   │ [icon]  App Name        │
 *   └─────────────────────────┘
 *
 * Colors come from the brand's primary/secondary; the icon (when SVG
 * with `stroke="currentColor"`) inherits `--brand-color-primary-mode`,
 * which auto-swaps between PrimaryLight (default mode) and PrimaryDark
 * (`.theme-dark`).
 *
 * Reads from libThemeBrand and re-renders on `onChange`. Renders an
 * empty span when no brand is registered.
 *
 * Drop-in destination: `<div id="Theme-Brand-Mark"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Brand-Mark',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Brand-Mark',
	DefaultRenderable: 'Theme-Brand-Mark-Renderable',

	// Optional: when false the icon is omitted (text-only wordmark).
	ShowIcon: true,
	// Optional: when false the name is omitted (icon-only mark).
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-Brand-Mark-Template',
			Template: /*html*/`{~TS:Theme-Brand-Mark-Body-Template:AppData.PictSectionTheme.BrandMark.BodySlot~}`
		},
		{
			Hash: 'Theme-Brand-Mark-Body-Template',
			Template: /*html*/`
<span class="pict-theme-brand-mark" title="{~D:Record.Tooltip~}">
	{~TS:Theme-Brand-Mark-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-Brand-Mark-IconImg-Template:Record.IconImgSlot~}
	{~TS:Theme-Brand-Mark-Name-Template:Record.NameSlot~}
</span>`
		},
		{
			// Inline SVG: trusted markup; let it ride. SVG icons that
			// reference `currentColor` inherit `--brand-color-primary-mode`.
			Hash: 'Theme-Brand-Mark-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			Hash: 'Theme-Brand-Mark-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		},
		{
			Hash: 'Theme-Brand-Mark-Name-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-name">{~D:Record.Name~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Brand-Mark-Renderable',
			TemplateHash: 'Theme-Brand-Mark-Template',
			ContentDestinationAddress: '#Theme-Brand-Mark',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brand-mark {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	/* line-height: 1 collapses the inherited ~1.2 line-box around the
	   name glyphs. Without this the inline-flex container is taller
	   than its visible content, the line-box adds asymmetric space
	   above the caps, and the whole mark looks pushed up vs.
	   neighbouring buttons that sit on standard 12px-text baselines. */
	line-height: 1;
	color: var(--brand-color-primary-mode, var(--theme-color-text-primary, #1a1a1a));
	user-select: none;
}
.pict-theme-brand-mark-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	color: currentColor;
}
.pict-theme-brand-mark-icon img,
.pict-theme-brand-mark-icon svg {
	width: 100%;
	height: 100%;
	display: block;
}
.pict-theme-brand-mark-name {
	/* Font size dropped from 15 → 14 so the brand name reads closer
	   to the typical 12px action-button text height; bigger glyphs
	   reaching higher into the row are why the mark looked optically
	   high. The 2px brand-secondary underline keeps the mark feeling
	   distinctly branded; padding-bottom: 1px was an asymmetric nudge
	   that shifted the visual center up — removed. */
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.4px;
	border-bottom: 2px solid var(--brand-color-secondary-mode, transparent);
	white-space: nowrap;
}
/* Compact form — at narrow viewports the brand mark collapses to
   icon-only. The icon alone still reads as the brand (the deterministic
   logo is designed to be recognisable without the wordmark) and freeing
   up the wordmark's width keeps the nav buttons reachable on tablet /
   small-laptop widths. The threshold matches the topbar's compact
   breakpoint in Theme-TopBar. */
@media (max-width: 720px) {
	.pict-theme-brand-mark-name {
		display: none;
	}
}`,
	CSSPriority: 500
};

class PictViewThemeBrandMark extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandMark = { BodySlot: [] };
			return;
		}

		// Single-element array slot drives the {~TS:~} render. Empty
		// slots for icon-img/icon-svg/name suppress those sub-templates.
		let tmpShowIcon = (this.options.ShowIcon !== false);
		let tmpShowName = (this.options.ShowName !== false);

		let tmpIconSVGSlot = (tmpShowIcon && tmpBrand.IconType === 'svg' && tmpBrand.Icon)
			? [{ IconHTML: tmpBrand.Icon }] : [];
		let tmpIconImgSlot = (tmpShowIcon && tmpBrand.IconType === 'image' && tmpBrand.Icon)
			? [{ IconURL: tmpBrand.Icon }] : [];
		let tmpNameSlot = (tmpShowName && tmpBrand.Name)
			? [{ Name: tmpBrand.Name }] : [];

		this.pict.AppData.PictSectionTheme.BrandMark =
		{
			BodySlot:
			[{
				Tooltip: tmpBrand.Tagline || tmpBrand.Name || '',
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot,
				NameSlot:    tmpNameSlot
			}]
		};
	}
}

module.exports = PictViewThemeBrandMark;
module.exports.default_configuration = _ViewConfiguration;

},{"../Theme-Brand.js":78,"pict-view":137}],128:[function(require,module,exports){
/**
 * Theme-BrandStrip — the subtle two-line brand signature that sits
 * under the application's navigation.
 *
 * Layout:
 *
 *   ┌─────────────────────────────────────────────────────────────┐
 *   │ [icon]  App Name                                            │
 *   │ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ │  ← primary stripe (3× tall)
 *   │ ─────────────────────────────────────────────────────────── │  ← secondary stripe (1× tall)
 *   └─────────────────────────────────────────────────────────────┘
 *
 * The icon + name row is colored using the brand's primary color (and
 * the secondary as an underline accent on the name). Clicking the row
 * does nothing by default — hosts that want it to navigate or open a
 * dropdown can pass an `OnClickName` hook in the view options.
 *
 * Reads the active brand from libThemeBrand. Subscribes to
 * libThemeBrand.onChange so swapping the brand at runtime updates the
 * strip immediately. Renders nothing (an empty span) when no brand is
 * registered.
 *
 * Drop-in destination: `<div id="Theme-BrandStrip"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BrandStrip',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BrandStrip',
	DefaultRenderable: 'Theme-BrandStrip-Renderable',

	// Stripe heights in pixels. Primary is conventionally 3× secondary,
	// per the design brief, but exposed here so hosts can tune.
	PrimaryStripeHeight: 3,
	SecondaryStripeHeight: 1,

	// When false, the icon + name row is omitted and only the two
	// stripes render. Useful for very tight chrome where the brand
	// name is already in the topbar.
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-BrandStrip-Template',
			Template: /*html*/`
{~TS:Theme-BrandStrip-Body-Template:AppData.PictSectionTheme.BrandStrip.BodySlot~}`
		},
		{
			Hash: 'Theme-BrandStrip-Body-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip" title="{~D:Record.Tooltip~}">
	{~TS:Theme-BrandStrip-NameRow-Template:Record.NameRowSlot~}
	<div class="pict-theme-brandstrip-stripes">
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-primary"
		     style="height: {~D:Record.PrimaryHeight~}px;"></div>
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-secondary"
		     style="height: {~D:Record.SecondaryHeight~}px;"></div>
	</div>
</div>`
		},
		{
			Hash: 'Theme-BrandStrip-NameRow-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip-row">
	{~TS:Theme-BrandStrip-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-BrandStrip-IconImg-Template:Record.IconImgSlot~}
	<span class="pict-theme-brandstrip-name">{~D:Record.Name~}</span>
</div>`
		},
		{
			// SVG icon: leading <svg> markup is trusted (host-supplied,
			// not user-supplied) so we let it through verbatim. Theme-Icons
			// SVGs use stroke="currentColor" so they pick up the brand
			// primary color from the row's `color: var(--brand-color-primary)`.
			Hash: 'Theme-BrandStrip-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			// <img> icon: src can be a data URL or a regular URL.
			Hash: 'Theme-BrandStrip-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BrandStrip-Renderable',
			TemplateHash: 'Theme-BrandStrip-Template',
			ContentDestinationAddress: '#Theme-BrandStrip',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brandstrip {
	display: flex;
	flex-direction: column;
	gap: 4px;
	user-select: none;
}
.pict-theme-brandstrip-row {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px 4px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--brand-color-primary, var(--theme-color-text-muted, #6b6b6b));
}
.pict-theme-brandstrip-name {
	border-bottom: 2px solid var(--brand-color-secondary, transparent);
	padding-bottom: 1px;
}
.pict-theme-brandstrip-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px; height: 16px;
	color: var(--brand-color-primary, currentColor);
}
.pict-theme-brandstrip-icon img,
.pict-theme-brandstrip-icon svg {
	width: 100%; height: 100%;
	display: block;
}
.pict-theme-brandstrip-stripes {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.pict-theme-brandstrip-stripe {
	width: 100%;
}
.pict-theme-brandstrip-stripe-primary {
	background: var(--brand-color-primary, transparent);
}
.pict-theme-brandstrip-stripe-secondary {
	background: var(--brand-color-secondary, transparent);
}`,
	CSSPriority: 500
};

class PictViewThemeBrandStrip extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		// No brand → empty BodySlot → renderable emits nothing.
		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandStrip = { BodySlot: [] };
			return;
		}

		let tmpShowName = (this.options.ShowName !== false);

		// Pick the right per-icon-type slot. Only one of these will be
		// non-empty so the template renders the right element.
		let tmpIconSVGSlot = [];
		let tmpIconImgSlot = [];
		if (tmpBrand.IconType === 'svg' && tmpBrand.Icon)
		{
			tmpIconSVGSlot = [{ IconHTML: tmpBrand.Icon }];
		}
		else if (tmpBrand.IconType === 'image' && tmpBrand.Icon)
		{
			tmpIconImgSlot = [{ IconURL: tmpBrand.Icon }];
		}

		let tmpNameRowSlot = tmpShowName
			? [{
				Name: tmpBrand.Name,
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot
			}]
			: [];

		let tmpTooltip = tmpBrand.Name + (tmpBrand.Tagline ? ' — ' + tmpBrand.Tagline : '');

		this.pict.AppData.PictSectionTheme.BrandStrip =
		{
			BodySlot:
			[{
				Tooltip: tmpTooltip,
				NameRowSlot: tmpNameRowSlot,
				PrimaryHeight: this.options.PrimaryStripeHeight || 3,
				SecondaryHeight: this.options.SecondaryStripeHeight || 1
			}]
		};
	}
}

PictViewThemeBrandStrip.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeBrandStrip;

},{"../Theme-Brand.js":78,"pict-view":137}],129:[function(require,module,exports){
/**
 * Theme-Button — an embeddable SVG button (sun/moon glyph) suitable for
 * application top bars. Clicking it opens a pict-section-modal popup
 * containing the Theme-Picker dropdown and the Theme-ModeToggle.
 *
 * Drop-in destination: `<div id="Theme-Button"></div>`. The button itself
 * is a tiny self-contained SVG that picks its color from the theme via
 * `currentColor` so it inherits the surrounding text color.
 *
 * Requires `pict-section-modal` to be registered (under the view hash
 * `Pict-Section-Modal` by default). If it isn't, clicking the button
 * falls back to a `console.warn` and a no-op.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Button',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Button',
	DefaultRenderable: 'Theme-Button-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Identifiers of the picker / toggle / scale views that the popup
	// will mount. Each one is optional — if a view isn't registered the
	// matching row is silently skipped (no broken DOM placeholders).
	PickerViewHash: 'Theme-Picker',
	ModeToggleViewHash: 'Theme-ModeToggle',
	ScaleSelectViewHash: 'Theme-ScaleSelect',

	// Visible button label / title (tooltip).
	Title: 'Theme',
	AriaLabel: 'Open theme menu',

	// Modal title.
	ModalTitle: 'Theme',

	// Modal width (CSS).
	ModalWidth: '320px',

	Templates:
	[
		{
			Hash: 'Theme-Button-Template',
			// SVG sourced from the shared Theme-Icons module so the
			// topbar glyph matches the picker + mode toggle exactly.
			Template: /*html*/`
<button type="button"
        class="pict-theme-button"
        aria-label="{~D:AppData.PictSectionTheme.Button.AriaLabel~}"
        title="{~D:AppData.PictSectionTheme.Button.Title~}"
        onclick="_Pict.views['Theme-Button'].openMenu();">
	${libThemeIcons.iconSun(16)}
</button>`
		},
		{
			Hash: 'Theme-Button-Modal-Template',
			Template: /*html*/`
<div class="pict-theme-button-menu">
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Theme</label>
		<div id="Theme-Picker"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Mode</label>
		<div id="Theme-ModeToggle"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Scale</label>
		<div id="Theme-ScaleSelect"></div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Button-Renderable',
			TemplateHash: 'Theme-Button-Template',
			ContentDestinationAddress: '#Theme-Button',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	/* Sized to match a typical 12px-font / 6px-12px-padding text button
	   (~28px tall) so this drops cleanly into a topbar row alongside
	   action buttons without standing taller and crashing the row's
	   visual rhythm. Squareish — width matches height for the icon. */
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-button:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-brand-primary, #2563eb);
	border-color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-button-icon { width: 16px; height: 16px; }
.pict-theme-button-menu { display: flex; flex-direction: column; gap: 14px; }
.pict-theme-button-menu-row { display: flex; flex-direction: column; gap: 6px; }
.pict-theme-button-menu-label {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

class PictViewThemeButton extends libPictView
{
	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the theme menu in a modal.
	 */
	openMenu()
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined')
			{
				console.warn('Theme-Button: pict-section-modal view not found at "'
					+ (this.options.ModalViewHash || 'Pict-Section-Modal')
					+ '" — cannot open theme menu.');
			}
			return null;
		}

		let tmpHTML = this.pict.parseTemplateByHash('Theme-Button-Modal-Template', {});

		let tmpSelf = this;
		return tmpModal.show(
		{
			title: this.options.ModalTitle || 'Theme',
			content: tmpHTML,
			width: this.options.ModalWidth || '320px',
			closeable: true,
			buttons: [],
			onOpen: function ()
			{
				// Mount the picker + toggle into the freshly-created
				// modal DOM. The views look up their own destinations
				// so a simple render() is enough.
				tmpSelf._mountSubViews();
			}
		});
	}

	// ================================================================
	// Internals
	// ================================================================

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	_mountSubViews()
	{
		let tmpPicker = this.pict.views[this.options.PickerViewHash || 'Theme-Picker'];
		if (tmpPicker)
		{
			tmpPicker.render();
		}
		let tmpToggle = this.pict.views[this.options.ModeToggleViewHash || 'Theme-ModeToggle'];
		if (tmpToggle)
		{
			tmpToggle.render();
		}
		let tmpScale = this.pict.views[this.options.ScaleSelectViewHash || 'Theme-ScaleSelect'];
		if (tmpScale)
		{
			tmpScale.render();
		}
	}

	_refreshAppData()
	{
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Button =
		{
			Title: this.options.Title || 'Theme',
			AriaLabel: this.options.AriaLabel || 'Open theme menu'
		};
	}
}

PictViewThemeButton.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeButton;

},{"../Theme-Icons.js":79,"pict-view":137}],130:[function(require,module,exports){
/**
 * Theme-ModeToggle — three-segment toggle for Light / Dark / System mode.
 *
 * Calls `provider.setMode(...)` on click. Greys itself out (and the
 * Dark / System buttons) when the active theme is single-mode (since
 * single-mode themes ignore mode requests internally).
 *
 * Like the Picker, subscribes to `provider.onApply` so the active button
 * highlight stays in sync with theme changes from elsewhere.
 *
 * Drop-in destination: `<div id="Theme-ModeToggle"></div>`.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ModeToggle',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ModeToggle',
	DefaultRenderable: 'Theme-ModeToggle-Renderable',

	ProviderHash: 'Theme',

	// Allow hosts to relabel buttons (i18n). Order is fixed.
	Labels:
	{
		Light:  'Light',
		Dark:   'Dark',
		System: 'System'
	},

	// Show the inline sun / moon / monitor SVG icons next to the labels.
	ShowIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-ModeToggle-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-wrap">
	<div class="pict-theme-modetoggle{~NE:AppData.PictSectionTheme.ModeToggle.Disabled^ pict-theme-modetoggle-disabled~}"
	     role="group" aria-label="Color mode"
	     title="{~D:AppData.PictSectionTheme.ModeToggle.WrapTitle~}">
		{~TS:Theme-ModeToggle-Button-Template:AppData.PictSectionTheme.ModeToggle.Buttons~}
	</div>
	{~TS:Theme-ModeToggle-LockedNote-Template:AppData.PictSectionTheme.ModeToggle.LockedNoteSlot~}
</div>`
		},
		{
			Hash: 'Theme-ModeToggle-Button-Template',
			Template: /*html*/`
<button type="button"
        class="pict-theme-modetoggle-btn{~NE:Record.Active^ pict-theme-modetoggle-btn-active~}{~NE:Record.LockedOut^ pict-theme-modetoggle-btn-lockedout~}"
        title="{~D:Record.Title~}"
        aria-pressed="{~D:Record.Active~}"
        aria-disabled="{~D:Record.LockedOut~}"
        onclick="_Pict.views['Theme-ModeToggle'].pickMode('{~D:Record.Mode~}');">
	{~TS:Theme-ModeToggle-Icon-Light:Record.IconLight~}{~TS:Theme-ModeToggle-Icon-Dark:Record.IconDark~}{~TS:Theme-ModeToggle-Icon-System:Record.IconSystem~}<span class="pict-theme-modetoggle-label">{~D:Record.Label~}</span>
</button>`
		},
		{
			Hash: 'Theme-ModeToggle-LockedNote-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-locked-note" role="note">
	<svg class="pict-theme-modetoggle-locked-icon" viewBox="0 0 24 24" fill="none"
	     stroke="currentColor" stroke-width="2" stroke-linecap="round"
	     stroke-linejoin="round" aria-hidden="true">
		<rect x="4" y="11" width="16" height="9" rx="2"/>
		<path d="M8 11V7a4 4 0 0 1 8 0v4"/>
	</svg>
	<span>{~D:Record.Message~}</span>
</div>`
		},
		// Icon templates pull SVG markup from the shared Theme-Icons
		// module so the picker, toggle, and topbar button stay visually
		// consistent — change the glyph in one place, every consumer
		// updates.
		{
			Hash: 'Theme-ModeToggle-Icon-Light',
			Template: libThemeIcons.iconSun()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-Dark',
			Template: libThemeIcons.iconMoon()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-System',
			Template: libThemeIcons.iconSystem()
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ModeToggle-Renderable',
			TemplateHash: 'Theme-ModeToggle-Template',
			ContentDestinationAddress: '#Theme-ModeToggle',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-modetoggle-wrap { display: inline-flex; flex-direction: column; gap: 6px; }
.pict-theme-modetoggle {
	display: inline-flex;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	border-radius: 6px;
	overflow: hidden;
	background: var(--theme-color-background-secondary, #fbfbfc);
	font-size: 12px;
}
.pict-theme-modetoggle-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	border: 0;
	background: transparent;
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	border-right: 1px solid var(--theme-color-border-default, #cfd5dd);
	transition: background-color 120ms ease, color 120ms ease;
}
.pict-theme-modetoggle-btn:last-child { border-right: 0; }
.pict-theme-modetoggle-btn:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-text-primary, #1f2933);
}
.pict-theme-modetoggle-btn-active {
	background: var(--theme-color-brand-primary, #2563eb);
	color: var(--theme-color-text-on-brand, #ffffff);
}
.pict-theme-modetoggle-btn-active:hover {
	background: var(--theme-color-brand-primary-hover, #1e54cc);
	color: var(--theme-color-text-on-brand, #ffffff);
}
/* When the active theme is single-mode the entire group becomes
   non-interactive. The locked-out buttons (the ones the theme cannot
   switch to) get a strikethrough so the cause is unmistakable; the
   active button stays styled normally so users can still see which
   mode the theme IS using. */
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn {
	pointer-events: none;
	cursor: not-allowed;
}
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn-lockedout {
	opacity: 0.45;
	text-decoration: line-through;
	text-decoration-thickness: 1.5px;
}
/* Icons come from Theme-Icons.js with explicit width/height baked into
   the <svg>. We only need to nudge their vertical alignment with the
   button label. */
.pict-theme-modetoggle .pict-theme-icon {
	display: inline-block; vertical-align: -2px;
}
.pict-theme-modetoggle-label { line-height: 1; }
.pict-theme-modetoggle-locked-note {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	line-height: 1.3;
	color: var(--theme-color-text-muted, #6b6b6b);
	padding: 0 2px;
}
.pict-theme-modetoggle-locked-icon {
	width: 12px; height: 12px;
	flex: 0 0 12px;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

// The icon SVGs themselves live as templates above (Theme-ModeToggle-Icon-*).
// Per CLAUDE.md "AppData stores data, not HTML" — we drive icon selection
// with one-or-zero element arrays (`Record.IconLight = [{}]` to render the
// Light icon, `[]` to skip it). Each template is keyed off `Record.Mode`.

class PictViewThemeModeToggle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — flip mode on the active theme. Single-mode themes
	 * silently ignore (the toggle is shown disabled in that case anyway).
	 */
	pickMode(pMode)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;
		let tmpOk = tmpProvider.setMode(pMode);

		if (tmpOk && typeof this.options.OnModeChange === 'function')
		{
			try { this.options.OnModeChange(pMode); }
			catch (pErr) { /* host hook failure */ }
		}

		// setMode fires onApply listeners which trigger our own re-render.
		// If single-mode rejected the change, force a re-render so the UI
		// state is still consistent.
		if (!tmpOk)
		{
			this.render();
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : null;
		let tmpActiveMode = (tmpActive && tmpActive.Mode) || 'light';

		// Detect single-mode (Strategy === 'single') so we can lock the
		// toggle and surface the reason the buttons aren't responding.
		let tmpDisabled = false;
		let tmpLockedToMode = null;
		let tmpThemeName = null;
		if (tmpActive && tmpActive.Hash && tmpProvider && typeof tmpProvider.getTheme === 'function')
		{
			let tmpBundle = tmpProvider.getTheme(tmpActive.Hash);
			let tmpStrategy = (tmpBundle && tmpBundle.Modes && tmpBundle.Modes.Strategy) || 'single';
			tmpDisabled = (tmpStrategy === 'single');
			if (tmpDisabled)
			{
				tmpLockedToMode = (tmpBundle.Modes && tmpBundle.Modes.Default) || tmpActiveMode || 'light';
				tmpThemeName = tmpBundle.Name || tmpBundle.Hash || 'this theme';
			}
		}

		let tmpLabels = this.options.Labels || _ViewConfiguration.Labels;
		let tmpShowIcons = (this.options.ShowIcons !== false);

		// Use one-or-zero element arrays to drive each icon template so
		// the icon SVG never gets stuffed into AppData as a raw string.
		let tmpModeRows =
		[
			{ Mode: 'light',  Label: tmpLabels.Light  || 'Light' },
			{ Mode: 'dark',   Label: tmpLabels.Dark   || 'Dark' },
			{ Mode: 'system', Label: tmpLabels.System || 'System' }
		];
		let tmpButtons = [];
		for (let i = 0; i < tmpModeRows.length; i++)
		{
			let tmpRow = tmpModeRows[i];
			let tmpIsActive = (tmpActiveMode === tmpRow.Mode);
			// "Locked out" = single-mode theme AND this button is not the
			// mode the theme is fixed to. The active button keeps normal
			// styling so users can still see which mode is in use.
			let tmpLockedOut = tmpDisabled && (tmpRow.Mode !== tmpLockedToMode);
			let tmpTitle;
			if (tmpLockedOut)
			{
				let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
				tmpTitle = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode — pick a different theme to switch.';
			}
			else
			{
				tmpTitle = tmpRow.Label + ' mode';
			}
			tmpButtons.push(
			{
				Mode: tmpRow.Mode,
				Label: tmpRow.Label,
				Title: tmpTitle,
				Active: tmpIsActive,
				LockedOut: tmpLockedOut,
				IconLight:  (tmpShowIcons && tmpRow.Mode === 'light')  ? [{}] : [],
				IconDark:   (tmpShowIcons && tmpRow.Mode === 'dark')   ? [{}] : [],
				IconSystem: (tmpShowIcons && tmpRow.Mode === 'system') ? [{}] : []
			});
		}

		// One-or-zero element array drives the locked-note template
		// (per CLAUDE.md "single-element-array trick"). Empty array →
		// note skipped entirely.
		let tmpLockedNoteSlot = [];
		let tmpWrapTitle = '';
		if (tmpDisabled)
		{
			let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
			let tmpMessage = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode';
			tmpLockedNoteSlot = [{ Message: tmpMessage }];
			tmpWrapTitle = tmpMessage + ' — pick a different theme to switch modes.';
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ModeToggle =
		{
			ActiveMode: tmpActiveMode,
			Disabled: tmpDisabled,
			LockedToMode: tmpLockedToMode,
			ThemeName: tmpThemeName,
			Buttons: tmpButtons,
			LockedNoteSlot: tmpLockedNoteSlot,
			WrapTitle: tmpWrapTitle
		};
	}
}

PictViewThemeModeToggle.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeModeToggle;

},{"../Theme-Icons.js":79,"pict-view":137}],131:[function(require,module,exports){
/**
 * Theme-Picker — a custom dropdown that lists every theme registered
 * with the Theme provider, grouped by category.
 *
 * Renders as a trigger button showing the active theme name + a chevron.
 * Click → opens a `pict-section-modal` dropdown menu where each row is
 * the theme name plus an inline SVG glyph indicating the modes the
 * theme supports (sun for light-only, moon for dark-only, sun+moon for
 * paired). This is why we ditched the native <select>: option elements
 * can't render SVG, only plain text, and the unicode crescent
 * substitutes that earlier looked like dental glyphs.
 *
 * Subscribes to `provider.onApply` so a theme switch from elsewhere
 * (the modal-tucked picker, a hotkey, persistence restore) keeps the
 * trigger button in sync.
 *
 * Drop-in destination: `<div id="Theme-Picker"></div>`.
 *
 * # Modal section dependency
 *
 * Requires pict-section-modal to be registered (the dropdown popover
 * is a modal-section feature, not a hand-rolled DOM widget). When
 * pict-section-theme.install() is used, the host always has the modal
 * section available because Theme-Button needs it too. If you add this
 * view manually without the modal section, the trigger button will
 * still render but clicking it logs a warning and no-ops.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

// AppData address used to surface picker state to templates.
const APPDATA_ADDRESS = 'PictSectionTheme.Picker';

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Picker',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Picker',
	DefaultRenderable: 'Theme-Picker-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Optional categories block — array describing the optgroup order.
	// If omitted we discover categories from the provider's themes in
	// first-seen order.
	Categories: null,

	// Show the per-row mode-capability glyph (sun / moon / sun+moon) as
	// the leading icon on each dropdown item. Default on. Pass false if
	// you want a plainer menu.
	ShowModeIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-Picker-Template',
			// Trigger button that mirrors a native <select>'s look but
			// can carry SVG content. Clicking opens the modal dropdown.
			Template: /*html*/`
<button type="button" class="pict-theme-picker"
        title="{~D:AppData.PictSectionTheme.Picker.TriggerTooltip~}"
        onclick="_Pict.views['Theme-Picker'].openMenu(this);">
	{~TS:Theme-Picker-Trigger-Glyph:AppData.PictSectionTheme.Picker.TriggerGlyphSlot~}
	<span class="pict-theme-picker-name">{~D:AppData.PictSectionTheme.Picker.ActiveLabel~}</span>
	<span class="pict-theme-picker-chevron">{~D:AppData.PictSectionTheme.Picker.ChevronHTML~}</span>
</button>`
		},
		{
			// Wrapped in a 1-or-0 element array so the trigger glyph is
			// optional (ShowModeIcons: false → empty slot, no leading
			// icon). Per CLAUDE.md "AppData stores data, not HTML".
			Hash: 'Theme-Picker-Trigger-Glyph',
			Template: /*html*/`<span class="pict-theme-picker-trigger-glyph">{~D:Record.IconHTML~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Picker-Renderable',
			TemplateHash: 'Theme-Picker-Template',
			ContentDestinationAddress: '#Theme-Picker',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-picker {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 200px;
	max-width: 100%;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
	text-align: left;
	transition: border-color 120ms ease, box-shadow 120ms ease;
}
.pict-theme-picker:hover { border-color: var(--theme-color-text-muted, #6b6b6b); }
.pict-theme-picker:focus, .pict-theme-picker:focus-visible {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.pict-theme-picker .pict-theme-picker-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-theme-picker .pict-theme-picker-chevron {
	color: var(--theme-color-text-muted, #6b6b6b);
	display: inline-flex;
	align-items: center;
}
.pict-theme-picker-trigger-glyph {
	display: inline-flex; align-items: center;
	color: var(--theme-color-text-muted, #6b6b6b);
}

/* Skin the modal-dropdown items with cleaner spacing for our glyphs. */
.pict-theme-picker-menu .pict-modal-dropdown-item-icon {
	width: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	color: var(--theme-color-text-muted, #6b6b6b);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active {
	background: var(--theme-color-background-selected, #e0eaff);
	color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active .pict-modal-dropdown-item-icon {
	color: var(--theme-color-brand-primary, #2563eb);
}`,
	CSSPriority: 500
};

class PictViewThemePicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the rich dropdown menu via pict-section-modal.
	 * @param {HTMLElement} pAnchor - the trigger button (click target)
	 */
	openMenu(pAnchor)
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-Picker: pict-section-modal not registered — cannot open menu.');
			}
			return null;
		}

		let tmpItems = this._buildMenuItems();
		let tmpSelf = this;
		return tmpModal.dropdown(pAnchor,
		{
			items: tmpItems,
			align: 'left',
			minWidth: '260px',
			maxHeight: '60vh',
			className: 'pict-theme-picker-menu',
			closeOnSelect: true,
			onSelect: function (pHash) { tmpSelf.pick(pHash); }
		});
	}

	/**
	 * Apply the picked theme. Public so external callers can drive the
	 * picker programmatically too (hotkeys, tests, etc.).
	 */
	pick(pHash)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;

		// Preserve the current user-facing mode if the new theme
		// supports modes. Single-mode themes will clamp internally.
		let tmpActive = tmpProvider.getActiveTheme();
		let tmpMode = tmpActive ? tmpActive.Mode : null;

		let tmpOk = tmpProvider.applyTheme(pHash, tmpMode);

		if (tmpOk && typeof this.options.OnPick === 'function')
		{
			try { this.options.OnPick(pHash); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	/**
	 * Build the modal-dropdown `items` array from the registered themes
	 * + the catalog's category metadata. One Header row per category,
	 * one item per theme with a leading SVG capability glyph.
	 */
	_buildMenuItems()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		let tmpCatalog = this._loadCatalog();
		let tmpCategoryByHash = {};
		let tmpCategoryOrder = [];
		if (Array.isArray(this.options.Categories))
		{
			tmpCategoryOrder = this.options.Categories.slice();
		}
		for (let i = 0; i < tmpCatalog.length; i++)
		{
			let tmpEntry = tmpCatalog[i];
			let tmpCat = tmpEntry.Category || 'Other';
			tmpCategoryByHash[tmpEntry.Hash] = tmpCat;
			if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
		}

		let tmpBuckets = {};
		for (let i = 0; i < tmpThemes.length; i++)
		{
			let tmpTheme = tmpThemes[i];
			let tmpCat = tmpCategoryByHash[tmpTheme.Hash] || 'Other';
			if (!tmpBuckets[tmpCat])
			{
				tmpBuckets[tmpCat] = [];
				if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
			}
			tmpBuckets[tmpCat].push(tmpTheme);
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpItems = [];
		for (let i = 0; i < tmpCategoryOrder.length; i++)
		{
			let tmpCat = tmpCategoryOrder[i];
			if (!tmpBuckets[tmpCat] || tmpBuckets[tmpCat].length === 0) continue;
			tmpItems.push({ Header: tmpCat });
			for (let j = 0; j < tmpBuckets[tmpCat].length; j++)
			{
				let tmpTheme = tmpBuckets[tmpCat][j];
				let tmpIcon = tmpShowIcons
					? libThemeIcons.iconForTheme(tmpTheme.Strategy, tmpTheme.DefaultMode, 14)
					: '';
				tmpItems.push(
				{
					Hash: tmpTheme.Hash,
					Label: tmpTheme.Name || tmpTheme.Hash,
					Icon: tmpIcon,
					Style: (tmpTheme.Hash === tmpActiveHash) ? 'active' : null,
					Tooltip: this._capabilityLabel(tmpTheme)
				});
			}
		}

		return tmpItems;
	}

	_capabilityLabel(pTheme)
	{
		let tmpStrategy = pTheme.Strategy || 'single';
		if (tmpStrategy === 'single')
		{
			let tmpMode = pTheme.DefaultMode || 'light';
			return (pTheme.Name || pTheme.Hash) + ' — '
				+ (tmpMode === 'dark' ? 'dark only' : 'light only');
		}
		return (pTheme.Name || pTheme.Hash) + ' — light + dark';
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		// Find the active theme's metadata for the trigger glyph.
		let tmpActiveTheme = null;
		for (let i = 0; i < tmpThemes.length; i++)
		{
			if (tmpThemes[i].Hash === tmpActiveHash) { tmpActiveTheme = tmpThemes[i]; break; }
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpTriggerGlyphSlot = [];
		if (tmpShowIcons && tmpActiveTheme)
		{
			tmpTriggerGlyphSlot = [{
				IconHTML: libThemeIcons.iconForTheme(tmpActiveTheme.Strategy, tmpActiveTheme.DefaultMode, 14)
			}];
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Picker =
		{
			ActiveHash: tmpActiveHash,
			ActiveLabel: tmpActiveTheme ? (tmpActiveTheme.Name || tmpActiveTheme.Hash) : 'Choose a theme',
			TriggerTooltip: tmpActiveTheme
				? this._capabilityLabel(tmpActiveTheme) + ' — click to change'
				: 'Choose a theme',
			TriggerGlyphSlot: tmpTriggerGlyphSlot,
			ChevronHTML: libThemeIcons.iconChevronDown(10)
		};
		this.pict.AppData.PictSectionTheme.AllThemes = tmpThemes;
	}

	_loadCatalog()
	{
		try { return require('../themes/_catalog.js'); }
		catch (pError) { return []; }
	}
}

PictViewThemePicker.default_configuration = _ViewConfiguration;
PictViewThemePicker.APPDATA_ADDRESS = APPDATA_ADDRESS;

module.exports = PictViewThemePicker;

},{"../Theme-Icons.js":79,"../themes/_catalog.js":85,"pict-view":137}],132:[function(require,module,exports){
/**
 * Theme-ScaleSelect — dropdown that picks a viewport scale (zoom).
 *
 * Independent of the active theme bundle: scale is a per-user
 * preference stored alongside ThemeHash + Mode in localStorage. Reads
 * presets from the Theme-Scale helper (or a host-supplied `Presets`
 * array). Subscribes to Theme-Scale.onChange so external scale changes
 * (the persisted boot apply, hotkeys, other code) keep the dropdown's
 * selected option in sync.
 *
 * Drop-in destination: `<div id="Theme-ScaleSelect"></div>`.
 */

const libPictView = require('pict-view');
const libThemeScale = require('../Theme-Scale.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ScaleSelect',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ScaleSelect',
	DefaultRenderable: 'Theme-ScaleSelect-Renderable',

	// Optional override of the preset list. Each entry: { Value: <number>, Label: <string> }.
	// When omitted we use libThemeScale.PRESETS.
	Presets: null,

	Templates:
	[
		{
			Hash: 'Theme-ScaleSelect-Template',
			Template: /*html*/`
<select class="pict-theme-scaleselect"
        title="{~D:AppData.PictSectionTheme.ScaleSelect.Tooltip~}"
        onchange="_Pict.views['Theme-ScaleSelect'].pickScale(parseFloat(this.value));">
	{~TS:Theme-ScaleSelect-Option-Template:AppData.PictSectionTheme.ScaleSelect.Options~}
</select>`
		},
		{
			Hash: 'Theme-ScaleSelect-Option-Template',
			Template: /*html*/`
<option value="{~D:Record.Value~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ScaleSelect-Renderable',
			TemplateHash: 'Theme-ScaleSelect-Template',
			ContentDestinationAddress: '#Theme-ScaleSelect',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-scaleselect {
	min-width: 180px;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
}
.pict-theme-scaleselect:focus {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}`,
	CSSPriority: 500
};

class PictViewThemeScaleSelect extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromScale = null;
	}

	onAfterInitialize()
	{
		this._subscribeToScale();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onchange handler — apply a new scale and let the listener re-render.
	 * @param {number} pScale
	 */
	pickScale(pScale)
	{
		let tmpApplied = libThemeScale.applyScale(pScale);
		if (typeof this.options.OnScaleChange === 'function')
		{
			try { this.options.OnScaleChange(tmpApplied); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpApplied;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToScale()
	{
		if (this._unsubscribeFromScale) return;
		let tmpSelf = this;
		this._unsubscribeFromScale = libThemeScale.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpPresets = Array.isArray(this.options.Presets) ? this.options.Presets : libThemeScale.PRESETS;
		let tmpActive = libThemeScale.getActive();

		// "Closest" match — the saved scale may be a custom value (e.g.
		// 1.10 from a hotkey nudge) that doesn't exactly equal any preset.
		// We highlight the nearest option so the dropdown still reflects
		// roughly where the user is.
		let tmpClosestIdx = 0;
		let tmpClosestDelta = Infinity;
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpDelta = Math.abs(tmpPresets[i].Value - tmpActive);
			if (tmpDelta < tmpClosestDelta) { tmpClosestDelta = tmpDelta; tmpClosestIdx = i; }
		}

		let tmpOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpEntry = tmpPresets[i];
			tmpOptions.push(
			{
				Value: tmpEntry.Value,
				Label: tmpEntry.Label,
				Selected: (i === tmpClosestIdx)
			});
		}

		let tmpTooltip = 'Viewport scale — currently '
			+ Math.round(tmpActive * 100) + '%';

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ScaleSelect =
		{
			ActiveScale: tmpActive,
			Tooltip: tmpTooltip,
			Options: tmpOptions
		};
	}
}

PictViewThemeScaleSelect.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeScaleSelect;

},{"../Theme-Scale.js":81,"pict-view":137}],133:[function(require,module,exports){
/**
 * Theme-TopBar — standard application chrome row.
 *
 * Provides the boilerplate every Pict / retold app remakes: a flex row
 * with three zones — brand mark on the left, navigation in the middle,
 * configuration / user widgets on the right (with the theme button
 * pinned at the far edge).
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ [Brand-Mark]   [── Nav slot (flex-grow) ──]   [User-slot] [⚙]  │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Auto-mounts:
 *   - Theme-Brand-Mark in the brand slot (skip via MountBrandMark: false)
 *   - Theme-Button at the far right of the user area (skip via
 *     MountThemeButton: false)
 *
 * Host fills two empty slots via standard Pict view destinations:
 *   - `#Theme-TopBar-Nav`  — primary navigation / action buttons
 *   - `#Theme-TopBar-User` — app-specific user-area widgets (account,
 *                            log toggle, custom indicators)
 *
 * Renders into `#Theme-TopBar` by default. The host's layout shell
 * provides that destination — typically the top panel of a
 * pict-section-modal Shell.
 *
 * The bottom border uses `--brand-color-primary-mode` so the topbar
 * carries a thin brand stripe that auto-swaps with light/dark mode.
 *
 * Each app's nav / user-area views can stay app-specific; this view
 * eliminates the chrome boilerplate around them.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-TopBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-TopBar',
	DefaultRenderable: 'Theme-TopBar-Renderable',

	// When false, the host is responsible for mounting Theme-Brand-Mark
	// itself (or skipping the brand entirely).
	MountBrandMark: true,
	// When false, Theme-Button is not auto-mounted into the user slot.
	// Useful when the host wants to position the button somewhere else
	// or when no theme picker is desired.
	MountThemeButton: true,
	// ViewIdentifier of a host-supplied view that fills the nav slot
	// (#Theme-TopBar-Nav). Typical convention: a small per-app view
	// rendering primary action buttons / nav links / breadcrumbs.
	NavView: null,
	// ViewIdentifier of a host-supplied view that fills the user-area
	// slot (#Theme-TopBar-User). Theme-Button still auto-mounts at the
	// far edge — this view fills the slot before it.
	UserView: null,

	// Height of the bar in pixels. Drives the min-height on the
	// chrome row so it fills the panel cleanly even when the parent
	// chain (pict-section-modal shell uses min-height: 100% on its
	// panel content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 56,

	// Horizontal alignment of items inside the nav slot. The slot
	// itself stretches (flex: 1) between brand mark and user area;
	// this option controls where the nav content sits within that
	// stretched space. Default 'right' so action buttons hug the
	// user-area / theme button cluster (the convention every
	// retold-* app converged on). Override to 'left' to put the nav
	// flush against the brand, or 'center' to centre it across the
	// row. Maps to justify-content: flex-end / flex-start / center.
	NavAlign: 'right',

	// Viewport width (px) below which the topbar collapses to compact
	// mode: nav + user-area widgets hide, a burger button shows in
	// their place. Clicking the burger opens a pict-section-modal
	// popup with a clone of the nav + user DOM, so every action stays
	// reachable.
	//
	// Default 900px — the conventional "narrow desktop / small laptop"
	// cut-off where a topbar with ~4 nav buttons + a brand mark + a
	// user-area cluster genuinely starts crowding. Most users will
	// resize a window to this range (drag a split-pane, dock a window
	// next to another app, etc.); 600px would only trigger at true
	// mobile widths most desktop users never hit.
	//
	// Conventional ladder for picking a value:
	//   ~1024px  large breakpoint — nav-heavy apps with 6+ buttons
	//    ~900px  default — "narrow desktop window" (recommended)
	//    ~768px  tablet portrait — minimal-nav apps
	//    ~600px  mobile-only — single-button toolbars
	//        0   disable compact mode entirely
	CompactBreakpoint: 900,

	Templates:
	[
		{
			Hash: 'Theme-TopBar-Template',
			// The burger button is hidden by default and the regular nav /
			// user-slot are visible — flipped by the media query in CSS
			// at the CompactBreakpoint (default 600px). On click the
			// burger opens a pict-section-modal popup containing a clone
			// of the existing #Theme-TopBar-Nav + #Theme-TopBar-User DOM
			// — host apps don't need to provide a separate burger view.
			Template: /*html*/`
<div class="pict-theme-topbar">
	<div class="pict-theme-topbar-mark"><div id="Theme-Brand-Mark"></div></div>
	<div class="pict-theme-topbar-nav" id="Theme-TopBar-Nav"></div>
	<div class="pict-theme-topbar-user">
		<div class="pict-theme-topbar-user-slot" id="Theme-TopBar-User"></div>
		<div class="pict-theme-topbar-user-button"><div id="Theme-Button"></div></div>
		<button type="button" class="pict-theme-topbar-burger"
			aria-label="More navigation"
			title="Menu"
			onclick="_Pict.views['Theme-TopBar'].openBurgerMenu();">
			<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2"
				stroke-linecap="round" stroke-linejoin="round"
				aria-hidden="true">
				<path d="M3 6h18M3 12h18M3 18h18"/>
			</svg>
		</button>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-TopBar-Renderable',
			TemplateHash: 'Theme-TopBar-Template',
			ContentDestinationAddress: '#Theme-TopBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-topbar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 56). Avoids the percent-height resolution
	   trap: pict-section-modal's panel destination uses min-height: 100%
	   on its inner div, which means a child's height: 100% / min-height:
	   100% resolves against the parent's *property* (auto), not its
	   resolved size — and collapses the row to its content. A fixed px
	   value gives align-items: center real space to centre into. */
	min-height: 56px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-panel, transparent);
	/* Brand stripes are drawn by .pict-theme-topbar::after as an absolute
	   element overlaying the bottom 5px of the row. Using ::after rather
	   than border-bottom + box-shadow lets us put a transparent gap
	   between the two stripes (border / box-shadow can't draw gaps).
	   Position relative so the ::after positions to this row. */
	position: relative;
}
/* Two-stripe brand identifier at the bottom of the topbar:
     4px brand-primary (thicker — the dominant identifier)
     2px transparent gap (clearly readable separation)
     3px brand-secondary (thinner than primary but still substantial)
   Earlier iterations used 1–2px stripes; both read clearly at light
   mode but dark-mode secondary colors are often desaturated (lifted)
   so the eye can miss a thin band against a dark background. The
   current sizes push the secondary above the perception threshold
   regardless of palette. Stripes overlay the bottom 9px of the row;
   content (which centres in the full row via align-items: center)
   keeps its visual position. */
.pict-theme-topbar::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 9px;
	pointer-events: none;
	background: linear-gradient(
		to bottom,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 0,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 4px,
		transparent 4px,
		transparent 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 9px
	);
}
.pict-theme-topbar-mark {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
}
.pict-theme-topbar-nav {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	/* Default to right-aligning nav items inside the stretched slot —
	   the convention retold-* apps converged on. Overridden per-instance
	   from the NavAlign option in onAfterRender. */
	justify-content: flex-end;
	gap: 8px;
	min-width: 0;
	/* Horizontally scrollable when the nav overflows (narrow viewports
	   with many buttons) — better than overflow:hidden which would
	   silently clip buttons offscreen. The vertical axis stays clipped
	   so a tall accidental child doesn't blow up the row height. A
	   proper overflow menu is a future enhancement; this gets us safe
	   degradation today. */
	overflow-x: auto;
	overflow-y: hidden;
	/* Hide the scrollbar by default; modern browsers pick up the
	   trackpad scroll without it. Apps wanting a visible scrollbar
	   can override at higher specificity. */
	scrollbar-width: none;
}
.pict-theme-topbar-nav::-webkit-scrollbar { display: none; }
/* Active-route indicator. The convention every host app should follow:
   put aria-current="page" on the button (or anchor) representing the
   current route. The W3C-standard attribute reads correctly to screen
   readers and gets a brand-tinted highlight here. Apps that already
   ship their own active styling can override these rules — they're
   keyed off attribute selectors so no class collision is possible. */
.pict-theme-topbar-nav [aria-current="page"],
.pict-theme-topbar-user [aria-current="page"] {
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	background: var(--theme-color-background-hover, rgba(37, 99, 235, 0.08));
}
.pict-theme-topbar-user {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-slot {
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-button {
	display: flex;
	align-items: center;
}
/* Burger button — hidden by default; the media query (or the inline
   per-instance JS that swaps it via CompactBreakpoint) shows it once
   the viewport drops below the host's compact threshold. Sized to
   match Theme-Button (28×28) so the row's rhythm is preserved. */
.pict-theme-topbar-burger {
	display: none;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-topbar-burger:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Burger menu popup — applied to the cloned nav + user DOM inside
   pict-section-modal. The cloned children inherit their original
   styling (action buttons, badges, etc.) so the popup looks visually
   consistent with what was on the topbar. */
.pict-theme-burger-menu {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.pict-theme-burger-menu-section {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
/* Cloned children render as a vertical stack inside the popup — flip
   the horizontal flex layouts to column so each button takes a full
   row instead of cramming side-by-side at narrow width. */
.pict-theme-burger-menu .rm-topbar-nav,
.pict-theme-burger-menu .rm-topbar-user,
.pict-theme-burger-menu [class*="-topbar-nav"],
.pict-theme-burger-menu [class*="-topbar-user"] {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 6px;
}
.pict-theme-burger-menu button { width: 100%; text-align: left; }
.pict-theme-burger-menu .rm-topbar-nav-divider,
.pict-theme-burger-menu [class*="divider"] { display: none; }
/* Compact mode — defaults to a 900px breakpoint. The onAfterRender
   handler injects a per-instance <style> rule when the host passes a
   different CompactBreakpoint, so this @media block is the fallback
   for hosts that accept the default. */
@media (max-width: 900px) {
	.pict-theme-topbar-nav            { display: none !important; }
	.pict-theme-topbar-user-slot      { display: none !important; }
	.pict-theme-topbar-burger         { display: inline-flex; }
	/* In wide mode the flex-1 nav slot pushes the user-area to the
	   right edge. With the nav hidden the user-area would collapse
	   left of the now-empty middle; the auto-margin re-creates the
	   "push right" effect so the theme button + burger stay flush
	   against the right edge of the topbar. */
	.pict-theme-topbar-user           { margin-left: auto; }
}`,
	CSSPriority: 500
};

class PictViewThemeTopBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-topbar.
		// Using inline style so each instance can carry its own size
		// (different apps will pick different heights) without us having
		// to inject per-instance <style> blocks.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-topbar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		// Per-instance CompactBreakpoint. CSS @media rules can't reference
		// JS option values, so when the host overrides the default 600px
		// we inject a single-rule <style> with the chosen breakpoint and
		// !important to win over the static media query. Set to 0 to
		// disable compact mode entirely (the burger stays hidden).
		this._applyCompactBreakpoint();

		// Translate NavAlign ('left' | 'right' | 'center') to the matching
		// justify-content. Right is the default (and already in the static
		// CSS), but the inline style wins so an explicit option always
		// takes precedence over the cached stylesheet.
		if (typeof document !== 'undefined' && this.options.NavAlign)
		{
			let tmpJustify = ({
				left:   'flex-start',
				right:  'flex-end',
				center: 'center'
			})[this.options.NavAlign];
			if (tmpJustify)
			{
				let tmpNav = document.querySelector('.pict-theme-topbar-nav');
				if (tmpNav) { tmpNav.style.justifyContent = tmpJustify; }
			}
		}

		// Auto-mount the standard pieces. Host can opt out via the view
		// options (MountBrandMark / MountThemeButton).
		if (this.options.MountBrandMark !== false)
		{
			let tmpBrandMark = this.pict.views['Theme-Brand-Mark'];
			if (tmpBrandMark) { tmpBrandMark.render(); }
		}
		if (this.options.NavView)
		{
			let tmpNavView = this.pict.views[this.options.NavView];
			if (tmpNavView) { tmpNavView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: NavView "' + this.options.NavView + '" not registered');
			}
		}
		if (this.options.UserView)
		{
			let tmpUserView = this.pict.views[this.options.UserView];
			if (tmpUserView) { tmpUserView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: UserView "' + this.options.UserView + '" not registered');
			}
		}
		if (this.options.MountThemeButton !== false)
		{
			let tmpThemeButton = this.pict.views['Theme-Button'];
			if (tmpThemeButton) { tmpThemeButton.render(); }
		}

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Apps with chrome that morphs between routes (e.g. breadcrumb-style
	// navigation that differs by section) call setNavView / setUserView
	// from their router callback. The new view is rendered into the
	// matching slot and the option is persisted so subsequent re-renders
	// of the topbar (theme switches, etc.) keep the new view mounted.

	/**
	 * Swap the NavView (slot at `#Theme-TopBar-Nav`) at runtime.
	 * @param {string|null} pViewIdentifier
	 *   View hash to mount, or null to clear the slot.
	 */
	setNavView(pViewIdentifier)
	{
		this.options.NavView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-Nav', this.options.NavView);
	}

	/**
	 * Swap the UserView (slot at `#Theme-TopBar-User`) at runtime.
	 * @param {string|null} pViewIdentifier
	 */
	setUserView(pViewIdentifier)
	{
		this.options.UserView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-User', this.options.UserView);
	}

	_mountSlot(pDestSelector, pViewIdentifier)
	{
		// Clear the slot first — handles both the clear-only case
		// (pViewIdentifier is null) and the swap case (gives the
		// new view a clean slate when its renderable doesn't use
		// `replace` mode).
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-TopBar: view "' + pViewIdentifier + '" not registered');
		}
	}

	// ─── Compact mode + burger menu ──────────────────────────────────────
	// At narrow widths the nav + user-area slots collapse into a single
	// burger button that opens a pict-section-modal popup with the
	// cloned nav + user DOM. The default breakpoint is 600px; hosts that
	// want a different value pass CompactBreakpoint in ViewOptions.

	_applyCompactBreakpoint()
	{
		if (typeof document === 'undefined') return;
		// Default value of 900 lives in the static CSS @media block; we
		// only need to inject when the host explicitly overrode it.
		let tmpBreakpoint = this.options.CompactBreakpoint;
		if (tmpBreakpoint === undefined || tmpBreakpoint === null) return;
		if (tmpBreakpoint === 900) return;  // matches default — no override needed

		let tmpStyleId = 'pict-theme-topbar-compact-' + this.UUID;
		let tmpStyleEl = document.getElementById(tmpStyleId);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = tmpStyleId;
			document.head.appendChild(tmpStyleEl);
		}

		// 0 (or any non-positive value) disables compact mode by emitting
		// a never-matching media rule. The static CSS still has the 600px
		// rule, so we override it with a more-specific selector + the
		// chosen breakpoint. Specificity-wise the inline rule wins
		// because it's emitted after the static CSS and has !important
		// matching the static rule's importance.
		if (typeof tmpBreakpoint !== 'number' || tmpBreakpoint <= 0)
		{
			// Disable: force compact selectors to never apply by giving
			// the burger display: none unconditionally at all widths.
			tmpStyleEl.textContent =
				'.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'.pict-theme-topbar-burger         { display: none !important; }\n' +
				'.pict-theme-topbar-user           { margin-left: 0 !important; }\n';
		}
		else
		{
			tmpStyleEl.textContent =
				'@media (max-width: ' + tmpBreakpoint + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: none !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: none !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: inline-flex !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: auto !important; }\n' +
				'}\n' +
				'@media (min-width: ' + (tmpBreakpoint + 1) + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: none !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: 0 !important; }\n' +
				'}\n';
		}
	}

	/**
	 * Open the burger / overflow menu. Clones the current contents of
	 * `#Theme-TopBar-Nav` and `#Theme-TopBar-User` into a
	 * pict-section-modal popup so every action stays reachable at narrow
	 * widths. The cloned buttons keep their inline `onclick` handlers
	 * (those reference globals like `_Pict.PictApplication.*`, which
	 * resolve at click-time regardless of where the DOM lives).
	 *
	 * Override on the instance (`view.openBurgerMenu = function() {...}`)
	 * to customise the popup contents — e.g. emit a per-app menu view
	 * instead of cloning the topbar DOM.
	 */
	openBurgerMenu()
	{
		if (typeof document === 'undefined') return null;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-TopBar: pict-section-modal not registered — burger menu unavailable.');
			}
			return null;
		}

		let tmpSections = [];
		let tmpNav = document.querySelector('#Theme-TopBar-Nav');
		let tmpUser = document.querySelector('#Theme-TopBar-User');
		if (tmpNav && tmpNav.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpNav.innerHTML + '</div>');
		}
		if (tmpUser && tmpUser.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpUser.innerHTML + '</div>');
		}
		if (tmpSections.length === 0)
		{
			tmpSections.push('<div class="pict-theme-burger-menu-empty">No menu items configured.</div>');
		}

		let tmpHTML = '<div class="pict-theme-burger-menu">' + tmpSections.join('') + '</div>';

		return tmpModal.show(
		{
			title:    'Menu',
			content:  tmpHTML,
			width:    '280px',
			closeable: true,
			buttons:  []
		});
	}
}

module.exports = PictViewThemeTopBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":137}],134:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],135:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":134,"fable-serviceproviderbase":6}],136:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],137:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":136,"fable-serviceproviderbase":6}],138:[function(require,module,exports){
const MICRODDL_TYPE_MAP =
{
	'@': { DataType: 'AutoIdentity', Label: 'Auto ID', HasSize: false },
	'%': { DataType: 'GUID', Label: 'GUID', HasSize: false },
	'$': { DataType: 'String', Label: 'String', HasSize: true },
	'*': { DataType: 'Text', Label: 'Text', HasSize: false },
	'#': { DataType: 'Numeric', Label: 'Numeric', HasSize: false },
	'.': { DataType: 'Decimal', Label: 'Decimal', HasSize: true },
	'&': { DataType: 'DateTime', Label: 'Date/Time', HasSize: false },
	'^': { DataType: 'Boolean', Label: 'Boolean', HasSize: false }
};

const DATATYPE_TO_SYMBOL = {};
for (let tmpSymbol in MICRODDL_TYPE_MAP)
{
	DATATYPE_TO_SYMBOL[MICRODDL_TYPE_MAP[tmpSymbol].DataType] = tmpSymbol;
}

function columnsToMicroDDL(pColumns, pTableName)
{
	let tmpTableName = (pTableName || 'Untitled').replace(/[^a-zA-Z0-9_]/g, '');
	let tmpLines = ['!' + tmpTableName];

	for (let i = 0; i < pColumns.length; i++)
	{
		let tmpCol = pColumns[i];
		let tmpSymbol = DATATYPE_TO_SYMBOL[tmpCol.DataType] || '$';
		let tmpLine = tmpSymbol + (tmpCol.Name || 'Column' + i);

		if (MICRODDL_TYPE_MAP[tmpSymbol].HasSize && tmpCol.Size)
		{
			tmpLine += ' ' + tmpCol.Size;
		}

		tmpLines.push(tmpLine);
	}

	return tmpLines.join('\n');
}

function microDDLToColumns(pDDL)
{
	let tmpLines = pDDL.split('\n');
	let tmpColumns = [];

	for (let i = 0; i < tmpLines.length; i++)
	{
		let tmpLine = tmpLines[i].trim();
		if (!tmpLine || tmpLine.startsWith('!') || tmpLine.startsWith('//') || tmpLine.startsWith('--') || tmpLine.startsWith('->'))
		{
			continue;
		}

		let tmpSymbol = tmpLine.charAt(0);
		if (MICRODDL_TYPE_MAP.hasOwnProperty(tmpSymbol))
		{
			let tmpRest = tmpLine.substring(1).trim();
			let tmpParts = tmpRest.split(/\s+/);
			tmpColumns.push(
			{
				Name: tmpParts[0] || '',
				DataType: MICRODDL_TYPE_MAP[tmpSymbol].DataType,
				Size: tmpParts[1] || ''
			});
		}
	}

	return tmpColumns;
}

module.exports = { MICRODDL_TYPE_MAP, DATATYPE_TO_SYMBOL, columnsToMicroDDL, microDDLToColumns };

},{}],139:[function(require,module,exports){
const libPictView = require('pict-view');

const libSchemaUtils = require('./MappingEditor-SchemaUtils.js');

const _ViewConfiguration =
{
	ViewIdentifier: "MeadowMappingEditor",

	DefaultRenderable: "MeadowMappingEditor-Content",
	DefaultDestinationAddress: "#MeadowMap-Editor-Container",

	AutoRender: false,

	CSS: /*css*/`
		/* Meadow Mapping Editor */
		.meadow-mapping-editor {
			display: none;
		}
		.meadow-mapping-editor.active {
			display: block;
		}
		.meadow-mapping-header {
			display: flex;
			align-items: center;
			gap: 1em;
			margin-bottom: 1em;
		}
		.meadow-mapping-header h3 {
			margin: 0;
			flex: 1;
		}
		.meadow-mapping-list-table {
			width: 100%;
			border-collapse: collapse;
			margin-bottom: 1em;
		}
		.meadow-mapping-list-table th {
			text-align: left;
			font-size: 0.72em;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--theme-color-text-muted, #a09070);
			padding: 0.5em 0.4em;
			border-bottom: 1px solid var(--theme-color-border-default, #d6c8ae);
		}
		.meadow-mapping-list-table td {
			padding: 0.35em 0.4em;
			border-bottom: 1px solid var(--theme-color-border-light, #e8ddc8);
			vertical-align: middle;
		}
		.meadow-flow-container {
			width: 100%;
			height: 500px;
			border: 1px solid var(--theme-color-border-default, #d6c8ae);
			border-radius: 6px;
			background: var(--theme-color-background-secondary, #fcf8f0);
			margin-bottom: 0.75em;
		}
		.meadow-mapping-json-editor {
			width: 100%;
			min-height: 300px;
			font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', monospace;
			font-size: 0.85em;
			padding: 0.75em;
			border: 1px solid var(--theme-color-border-default, #d6c8ae);
			border-radius: 6px;
			background: var(--theme-color-background-panel, #fcf8f0);
			color: var(--theme-color-text-primary, #3a3020);
			resize: vertical;
			tab-size: 4;
		}
		.meadow-mapping-store-checklist {
			display: flex;
			flex-wrap: wrap;
			gap: 0.5em;
			margin-top: 0.25em;
		}
		.meadow-mapping-store-checklist label {
			display: flex;
			align-items: center;
			gap: 0.35em;
			font-size: 0.82em;
			cursor: pointer;
			padding: 0.3em 0.5em;
			border: 1px solid var(--theme-color-border-light, #e8ddc8);
			border-radius: 4px;
			background: var(--theme-color-background-panel, #fcf8f0);
		}
		.meadow-mapping-store-checklist label:has(input:checked) {
			border-color: var(--theme-color-brand-primary, #18a5a0);
			background: var(--theme-color-background-selected, rgba(24,165,160,0.12));
		}
		.meadow-mapping-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			padding: 0.35em 0.9em;
			font-size: 0.82em;
			font-weight: 500;
			border-radius: 4px;
			border: 1px solid transparent;
			cursor: pointer;
			text-decoration: none;
			line-height: 1.4;
		}
		.meadow-mapping-btn-primary {
			background: var(--theme-color-brand-primary, #18a5a0);
			color: var(--theme-color-background-panel, #fff);
			border-color: var(--theme-color-brand-primary, #18a5a0);
		}
		.meadow-mapping-btn-primary:hover {
			opacity: 0.88;
		}
		.meadow-mapping-btn-secondary {
			background: var(--theme-color-background-panel, #fcf8f0);
			color: var(--theme-color-text-primary, #3a3020);
			border-color: var(--theme-color-border-default, #d6c8ae);
		}
		.meadow-mapping-btn-secondary:hover {
			background: var(--theme-color-border-light, #e8ddc8);
		}
		.meadow-mapping-btn-danger {
			background: var(--theme-color-status-error, #e74c3c);
			color: var(--theme-color-background-panel, #fff);
			border-color: var(--theme-color-status-error, #e74c3c);
		}
		.meadow-mapping-btn-danger:hover {
			opacity: 0.88;
		}
		.meadow-mapping-btn-small {
			padding: 0.2em 0.6em;
			font-size: 0.78em;
		}
		.meadow-schema-mode-tabs {
			display: flex;
			gap: 0.25em;
		}
		.meadow-schema-mode-tab {
			padding: 0.25em 0.75em;
			font-size: 0.8em;
			border: 1px solid var(--theme-color-border-default, #d6c8ae);
			border-radius: 4px;
			cursor: pointer;
			background: var(--theme-color-background-panel, #fcf8f0);
			color: var(--theme-color-text-primary, #3a3020);
		}
		.meadow-schema-mode-tab.active {
			background: var(--theme-color-brand-primary, #18a5a0);
			color: var(--theme-color-background-panel, #fff);
			border-color: var(--theme-color-brand-primary, #18a5a0);
		}
		.meadow-section-title {
			font-size: 0.72em;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--theme-color-text-muted, #a09070);
		}
	`,

	Templates:
	[
		{
			Hash: "MeadowMappingEditor-Template",
			Template: /*html*/`
<div>
	<div id="MeadowMap-Editor" class="meadow-mapping-editor">
		<div class="meadow-mapping-header">
			<button class="meadow-mapping-btn meadow-mapping-btn-secondary meadow-mapping-btn-small" onclick="{~P~}.views['MeadowMappingEditor'].closeMappingEditor()">&larr; Back</button>
			<h3 id="MeadowMap-Title">Mapping Editor</h3>
			<div class="meadow-schema-mode-tabs">
				<button class="meadow-schema-mode-tab active" id="MeadowMap-Mode-Flow" onclick="{~P~}.views['MeadowMappingEditor'].switchMapMode('flow')">Visual Mapper</button>
				<button class="meadow-schema-mode-tab" id="MeadowMap-Mode-JSON" onclick="{~P~}.views['MeadowMappingEditor'].switchMapMode('json')">JSON Config</button>
			</div>
		</div>

		<div id="MeadowMap-List-Wrap">
			<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:0.75em;">
				<div class="meadow-section-title" style="margin:0;">Existing Mappings</div>
				<button class="meadow-mapping-btn meadow-mapping-btn-primary meadow-mapping-btn-small" onclick="{~P~}.views['MeadowMappingEditor'].newMapping()">+ New Mapping</button>
			</div>
			<div id="MeadowMap-List"></div>
		</div>

		<div id="MeadowMap-Detail" style="display:none;">
			<div style="display:flex; gap:0.5em; align-items:center; margin-bottom:0.75em;">
				<label style="font-size:0.78em; font-weight:600;">Mapping Name</label>
				<input type="text" id="MeadowMap-Name" placeholder="Mapping name" style="flex:1; padding:0.3em 0.5em; font-size:0.85em; border:1px solid var(--theme-color-border-default); border-radius:4px; background:var(--theme-color-background-panel); color:var(--theme-color-text-primary);">
			</div>

			<div style="display:flex; gap:0.5em; align-items:center; margin-bottom:0.75em;">
				<label style="font-size:0.78em; font-weight:600;">Source</label>
				<select id="MeadowMap-Source" style="flex:1; padding:0.3em 0.5em; font-size:0.85em; border:1px solid var(--theme-color-border-default); border-radius:4px;"></select>
				<button class="meadow-mapping-btn meadow-mapping-btn-secondary meadow-mapping-btn-small" onclick="{~P~}.views['MeadowMappingEditor'].discoverSourceFields()">Discover Fields</button>
			</div>

			<div id="MeadowMap-Flow-Wrap">
				<div id="MeadowMap-Flow-Container" class="meadow-flow-container"></div>
			</div>

			<div id="MeadowMap-JSON-Wrap" style="display:none;">
				<textarea class="meadow-mapping-json-editor" id="MeadowMap-JSON" placeholder='{"Entity":"MyTable","GUIDTemplate":"{~D:Record.IDRecord~}","Mappings":{},"Solvers":[],"ManyfestAddresses":false}'></textarea>
			</div>

			<div style="margin-top:0.75em;">
				<div style="font-size:0.72em; font-weight:600; text-transform:uppercase; letter-spacing:0.5px; color:var(--theme-color-text-muted); margin-bottom:0.35em;">Target Stores</div>
				<div id="MeadowMap-Stores" class="meadow-mapping-store-checklist"></div>
			</div>

			<div style="margin-top:0.75em; display:flex; gap:0.5em; flex-wrap:wrap; align-items:center;">
				<button class="meadow-mapping-btn meadow-mapping-btn-primary" onclick="{~P~}.views['MeadowMappingEditor'].saveMapping()">Save Mapping</button>
			</div>
		</div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "MeadowMappingEditor-Content",
			TemplateHash: "MeadowMappingEditor-Template",
			DestinationAddress: "#MeadowMap-Editor-Container",
			RenderMethod: "replace"
		}
	]
};

class MeadowMappingEditorView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._EditingContextID = 0;
		this._EditingName = '';
		this._CurrentMappings = [];
		this._SelectedMappingID = 0;
		this._DiscoveredFields = {};
		this._FlowView = null;
		this._MapEditorMode = 'flow';
		this._MappingSources = [];
		this._MappingStores = [];
		this._CurrentTargetSchema = null;
	}

	// ── Overridable data methods ─────────────────────────────────────────────
	// Embedding apps override these to wire up their own persistence layer.

	/** Load all mappings for a context (e.g. dataset). Must return a Promise
	 *  that resolves to { Mappings: [...] }. */
	_doLoadMappings(pContextID)
	{
		return Promise.resolve({ Mappings: [] });
	}

	/** Load all available sources. Must return a Promise that resolves to an
	 *  array of source objects with at least { IDSource, Name }. */
	_doLoadSources()
	{
		return Promise.resolve([]);
	}

	/** Load all available target stores for a context. Must return a Promise
	 *  that resolves to { Stores: [...] }. */
	_doLoadStores(pContextID)
	{
		return Promise.resolve({ Stores: [] });
	}

	/** Load the target schema for a context. Must return a Promise that
	 *  resolves to { SchemaDefinition: "<micro-DDL string>" }. */
	_doLoadTargetSchema(pContextID)
	{
		return Promise.resolve({ SchemaDefinition: '' });
	}

	/** Load a single mapping by ID. Must return a Promise that resolves to
	 *  { Mapping: { Name, IDSource, IDProjectionStore, MappingConfiguration,
	 *    FlowDiagramState, Active, ... } }. */
	_doLoadMapping(pMappingID)
	{
		return Promise.resolve({ Mapping: null });
	}

	/** Delete a mapping by ID. Must return a Promise. */
	_doDeleteMapping(pMappingID)
	{
		return Promise.resolve({});
	}

	/** Discover fields from a source dataset. Must return a Promise that
	 *  resolves to { Headers: [...], SampleSize: N }. */
	_doDiscoverSourceFields(pContextID, pSourceID, pRecordLimit)
	{
		return Promise.resolve({ Headers: [], SampleSize: 0 });
	}

	/** Create a new mapping. Must return a Promise that resolves to
	 *  { Mapping: { IDProjectionMapping, ... } }. */
	_doCreateMapping(pContextID, pData)
	{
		return Promise.resolve({ Mapping: {} });
	}

	/** Update an existing mapping. Must return a Promise that resolves to
	 *  { Mapping: { ... } }. */
	_doUpdateMapping(pMappingID, pData)
	{
		return Promise.resolve({ Mapping: {} });
	}

	/** Called when the editor is closed. Override to notify the parent view. */
	_onClose()
	{
		// Default: no-op. Override in embedding app.
	}

	/** Show a toast notification. */
	_doToast(pMessage, pOptions)
	{
		let tmpModal = this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, pOptions);
		}
		else
		{
			this.log.info('[MeadowMappingEditor] ' + pMessage);
		}
	}

	/** Show a confirmation dialog. Returns a Promise<boolean>. */
	_doConfirm(pMessage, pOptions)
	{
		let tmpModal = this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			return tmpModal.confirm(pMessage, pOptions);
		}
		// Fallback to native confirm
		return Promise.resolve(typeof window !== 'undefined' ? window.confirm(pMessage) : false);
	}

	// ── Public API ───────────────────────────────────────────────────────────

	editMappings(pContextID, pName)
	{
		this._EditingContextID = pContextID;
		this._EditingName = pName || '';

		// Render the sub-view so its DOM exists
		this.render();

		let tmpEditor = document.getElementById('MeadowMap-Editor');
		let tmpTitle = document.getElementById('MeadowMap-Title');

		if (tmpEditor)
		{
			tmpEditor.classList.add('active');
			tmpEditor.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
		if (tmpTitle) tmpTitle.textContent = 'Mappings: ' + (pName || 'Untitled');

		// Show the mapping list, hide detail
		let tmpMappingListWrap = document.getElementById('MeadowMap-List-Wrap');
		let tmpMappingDetail = document.getElementById('MeadowMap-Detail');
		if (tmpMappingListWrap) tmpMappingListWrap.style.display = '';
		if (tmpMappingDetail) tmpMappingDetail.style.display = 'none';

		// Load mappings, sources, stores, and fresh schema in parallel
		Promise.all(
		[
			this._doLoadMappings(pContextID),
			this._doLoadSources(),
			this._doLoadStores(pContextID),
			this._doLoadTargetSchema(pContextID)
		]).then(
			(pResults) =>
			{
				this._CurrentMappings = (pResults[0] && pResults[0].Mappings) ? pResults[0].Mappings : [];
				this._MappingSources = Array.isArray(pResults[1]) ? pResults[1] : [];
				this._MappingStores = (pResults[2] && pResults[2].Stores) ? pResults[2].Stores : [];

				// Pre-populate _DiscoveredFields from source Columns (config-driven).
				// Sources that include a Columns array provide field names without
				// requiring a separate "Discover Fields" API call.
				for (let i = 0; i < this._MappingSources.length; i++)
				{
					let tmpSrc = this._MappingSources[i];
					if (Array.isArray(tmpSrc.Columns) && tmpSrc.Columns.length > 0)
					{
						this._DiscoveredFields[tmpSrc.IDSource] = tmpSrc.Columns;
					}
				}

				// Store the fresh schema locally for use by flow nodes
				let tmpSchema = pResults[3];
				if (tmpSchema && tmpSchema.SchemaDefinition)
				{
					this._CurrentTargetSchema = tmpSchema.SchemaDefinition;
				}

				this.refreshMappingList();
			});
	}

	closeMappingEditor()
	{
		// Clean up flow view
		if (this._FlowView)
		{
			this._FlowView = null;
		}

		this._SelectedMappingID = 0;

		this._onClose();
	}

	refreshMappingList()
	{
		let tmpContainer = document.getElementById('MeadowMap-List');
		if (!tmpContainer) return;

		if (this._CurrentMappings.length === 0)
		{
			tmpContainer.innerHTML = '<div style="text-align:center; padding:1.5em; color:var(--theme-color-text-muted, #a09070);">No mappings yet. Create one to map source fields to target columns.</div>';
			return;
		}

		let tmpViewID = this.options.ViewIdentifier;

		let tmpHtml = '<table class="meadow-mapping-list-table"><thead><tr>';
		tmpHtml += '<th>ID</th><th>Name</th><th>Source</th><th>Active</th><th>Actions</th>';
		tmpHtml += '</tr></thead><tbody>';

		for (let i = 0; i < this._CurrentMappings.length; i++)
		{
			let tmpMap = this._CurrentMappings[i];
			let tmpSourceName = '\u2014';
			for (let j = 0; j < this._MappingSources.length; j++)
			{
				if (this._MappingSources[j].IDSource === tmpMap.IDSource)
				{
					tmpSourceName = this._MappingSources[j].Name || 'Source ' + tmpMap.IDSource;
					break;
				}
			}

			tmpHtml += '<tr>';
			tmpHtml += '<td>' + tmpMap.IDProjectionMapping + '</td>';
			tmpHtml += '<td><strong>' + (tmpMap.Name || '\u2014') + '</strong></td>';
			tmpHtml += '<td>' + tmpSourceName + '</td>';
			tmpHtml += '<td>' + (tmpMap.Active ? '\u2713' : '\u2717') + '</td>';
			tmpHtml += '<td>';
			tmpHtml += '<button class="meadow-mapping-btn meadow-mapping-btn-primary meadow-mapping-btn-small" onclick="window._Pict.views[\'' + tmpViewID + '\'].openMappingDetail(' + tmpMap.IDProjectionMapping + ')">Edit</button> ';
			tmpHtml += '<button class="meadow-mapping-btn meadow-mapping-btn-danger meadow-mapping-btn-small" onclick="window._Pict.views[\'' + tmpViewID + '\'].deleteMapping(' + tmpMap.IDProjectionMapping + ')">Delete</button>';
			tmpHtml += '</td>';
			tmpHtml += '</tr>';
		}

		tmpHtml += '</tbody></table>';
		tmpContainer.innerHTML = tmpHtml;
	}

	newMapping()
	{
		this._SelectedMappingID = 0;

		let tmpMappingListWrap = document.getElementById('MeadowMap-List-Wrap');
		let tmpMappingDetail = document.getElementById('MeadowMap-Detail');
		if (tmpMappingListWrap) tmpMappingListWrap.style.display = 'none';
		if (tmpMappingDetail) tmpMappingDetail.style.display = '';

		// Reset fields
		let tmpNameInput = document.getElementById('MeadowMap-Name');
		if (tmpNameInput) tmpNameInput.value = '';

		// Populate source dropdown -- auto-select the first source if one exists.
		// _DiscoveredFields for that source is already populated from the
		// source Columns loaded in editMappings(), so _rebuildFlowNodes
		// will immediately show the source fields on the SRC node.
		let tmpAutoSourceID = (this._MappingSources.length > 0) ? this._MappingSources[0].IDSource : undefined;
		this._populateSourceDropdown(tmpAutoSourceID);
		this._populateStoreChecklist();

		// Clear JSON editor
		let tmpJSONTextarea = document.getElementById('MeadowMap-JSON');
		if (tmpJSONTextarea)
		{
			let tmpNewEntityName = (this._EditingName || 'Record').replace(/[^a-zA-Z0-9_]/g, '');
			let tmpNewGUIDCol = 'GUID' + tmpNewEntityName;
			let tmpNewIDCol = 'ID' + tmpNewEntityName;
			let tmpNewMappings = {};
			tmpNewMappings[tmpNewGUIDCol] = '{~D:Record.IDRecord~}';
			tmpNewMappings[tmpNewIDCol] = '{~D:Record.IDRecord~}';

			tmpJSONTextarea.value = JSON.stringify(
			{
				Entity: tmpNewEntityName,
				GUIDTemplate: '{~D:Record.IDRecord~}',
				GUIDName: tmpNewGUIDCol,
				Mappings: tmpNewMappings,
				Solvers: [],
				ManyfestAddresses: false
			}, null, '\t');
		}

		// Clear flow container
		let tmpFlowContainer = document.getElementById('MeadowMap-Flow-Container');
		if (tmpFlowContainer) tmpFlowContainer.innerHTML = '';
		this._FlowView = null;

		// Switch to flow mode and initialize the flow editor
		this.switchMapMode('flow');
		this.initFlowView();

		// Fetch fresh schema then build TGT node ports from schema columns
		this._doLoadTargetSchema(this._EditingContextID).then(
			(pSchema) =>
			{
				if (pSchema && pSchema.SchemaDefinition)
				{
					this._CurrentTargetSchema = pSchema.SchemaDefinition;
				}
				this._rebuildFlowNodes();
			});
	}

	openMappingDetail(pMappingID)
	{
		this._SelectedMappingID = pMappingID;

		this._doLoadMapping(pMappingID).then(
			(pResponse) =>
			{
				if (!pResponse || !pResponse.Mapping)
				{
					this._doToast('Mapping not found.', 'error');
					return;
				}

				let tmpMapping = pResponse.Mapping;

				let tmpMappingListWrap = document.getElementById('MeadowMap-List-Wrap');
				let tmpMappingDetail = document.getElementById('MeadowMap-Detail');
				if (tmpMappingListWrap) tmpMappingListWrap.style.display = 'none';
				if (tmpMappingDetail) tmpMappingDetail.style.display = '';

				// Set name
				let tmpNameInput = document.getElementById('MeadowMap-Name');
				if (tmpNameInput) tmpNameInput.value = tmpMapping.Name || '';

				// Populate dropdowns
				this._populateSourceDropdown(tmpMapping.IDSource);

				// Parse TargetStores from config, fall back to legacy IDProjectionStore
				let tmpTargetStores = null;
				try
				{
					let tmpParsedConfig = JSON.parse(tmpMapping.MappingConfiguration || '{}');
					if (Array.isArray(tmpParsedConfig.TargetStores) && tmpParsedConfig.TargetStores.length > 0)
					{
						tmpTargetStores = tmpParsedConfig.TargetStores;
					}
				}
				catch (e) { /* ignore */ }
				if (!tmpTargetStores && tmpMapping.IDProjectionStore)
				{
					tmpTargetStores = [tmpMapping.IDProjectionStore];
				}
				this._populateStoreChecklist(tmpTargetStores);

				// Parse mapping config
				let tmpConfig = {};
				try { tmpConfig = JSON.parse(tmpMapping.MappingConfiguration || '{}'); }
				catch (e) { /* ignore */ }

				// Restore discovered source fields from config (config-driven approach).
				// sourceColumns is written by saveMapping() so the SRC node shows
				// all fields immediately without an extra API call.
				if (Array.isArray(tmpConfig.sourceColumns) && tmpConfig.sourceColumns.length > 0)
				{
					this._DiscoveredFields[tmpMapping.IDSource] = tmpConfig.sourceColumns;
				}

				// Set JSON editor
				let tmpJSONTextarea = document.getElementById('MeadowMap-JSON');
				if (tmpJSONTextarea)
				{
					tmpJSONTextarea.value = JSON.stringify(tmpConfig, null, '\t');
				}

				// Clear flow container and re-initialize
				let tmpFlowContainer = document.getElementById('MeadowMap-Flow-Container');
				if (tmpFlowContainer) tmpFlowContainer.innerHTML = '';
				this._FlowView = null;

				// Switch to flow mode and initialize the flow editor
				this.switchMapMode('flow');
				this.initFlowView();

				// Fetch fresh schema then build TGT node ports from schema columns
				this._doLoadTargetSchema(this._EditingContextID).then(
					(pSchema) =>
					{
						if (pSchema && pSchema.SchemaDefinition)
						{
							this._CurrentTargetSchema = pSchema.SchemaDefinition;
						}
						// Restore saved flow diagram state if available,
						// then rebuild ports from current schema (schema is
						// the source of truth for ports, not saved state).
						if (this._FlowView)
						{
							let tmpFlowState = null;
							try { tmpFlowState = JSON.parse(tmpMapping.FlowDiagramState || 'null'); }
							catch (pParseError) { /* ignore invalid JSON */ }

							if (tmpFlowState && tmpFlowState.Nodes && tmpFlowState.Nodes.length > 0)
							{
								if (typeof this._FlowView.setFlowData === 'function')
								{
									this._FlowView.setFlowData(tmpFlowState);
								}
							}
						}
						// Always rebuild SRC/TGT ports from current schema
						// after restoring positions and connections
						this._rebuildFlowNodes();
					});
			});
	}

	async deleteMapping(pMappingID)
	{
		let tmpConfirmed = await this._doConfirm('Delete this mapping?', { title: 'Delete Mapping', confirmLabel: 'Delete', dangerous: true });
		if (!tmpConfirmed) return;

		this._doDeleteMapping(pMappingID).then(
			() =>
			{
				this._doLoadMappings(this._EditingContextID).then(
					(pResult) =>
					{
						this._CurrentMappings = (pResult && pResult.Mappings) ? pResult.Mappings : [];
						this.refreshMappingList();
					});
			});
	}

	switchMapMode(pMode)
	{
		this._MapEditorMode = pMode;

		let tmpFlowWrap = document.getElementById('MeadowMap-Flow-Wrap');
		let tmpJSONWrap = document.getElementById('MeadowMap-JSON-Wrap');
		let tmpFlowTab = document.getElementById('MeadowMap-Mode-Flow');
		let tmpJSONTab = document.getElementById('MeadowMap-Mode-JSON');

		if (pMode === 'flow')
		{
			if (tmpFlowWrap) tmpFlowWrap.style.display = '';
			if (tmpJSONWrap) tmpJSONWrap.style.display = 'none';
			if (tmpFlowTab) tmpFlowTab.classList.add('active');
			if (tmpJSONTab) tmpJSONTab.classList.remove('active');
		}
		else
		{
			if (tmpFlowWrap) tmpFlowWrap.style.display = 'none';
			if (tmpJSONWrap) tmpJSONWrap.style.display = '';
			if (tmpFlowTab) tmpFlowTab.classList.remove('active');
			if (tmpJSONTab) tmpJSONTab.classList.add('active');

			// If there's a flow view, serialize flow -> JSON
			if (this._FlowView && typeof this._FlowView.getFlowData === 'function')
			{
				let tmpConfig = this.flowToMappingConfig();
				let tmpJSONTextarea = document.getElementById('MeadowMap-JSON');
				if (tmpJSONTextarea)
				{
					tmpJSONTextarea.value = JSON.stringify(tmpConfig, null, '\t');
				}
			}
		}
	}

	_populateSourceDropdown(pSelectedIDSource)
	{
		let tmpSelect = document.getElementById('MeadowMap-Source');
		if (!tmpSelect) return;

		let tmpHtml = '<option value="0">Select a source...</option>';
		for (let i = 0; i < this._MappingSources.length; i++)
		{
			let tmpSrc = this._MappingSources[i];
			let tmpSelected = (tmpSrc.IDSource === pSelectedIDSource) ? ' selected' : '';
			tmpHtml += '<option value="' + tmpSrc.IDSource + '"' + tmpSelected + '>' + (tmpSrc.Name || 'Source ' + tmpSrc.IDSource) + '</option>';
		}
		tmpSelect.innerHTML = tmpHtml;
	}

	_populateStoreChecklist(pSelectedStoreIDs)
	{
		let tmpContainer = document.getElementById('MeadowMap-Stores');
		if (!tmpContainer) return;

		let tmpSelectedSet = {};
		if (Array.isArray(pSelectedStoreIDs))
		{
			for (let i = 0; i < pSelectedStoreIDs.length; i++)
			{
				tmpSelectedSet[pSelectedStoreIDs[i]] = true;
			}
		}
		else if (pSelectedStoreIDs)
		{
			// Backwards compat: single IDProjectionStore value
			tmpSelectedSet[pSelectedStoreIDs] = true;
		}

		if (this._MappingStores.length === 0)
		{
			tmpContainer.innerHTML = '<div style="font-size:0.82em; color:var(--theme-color-text-muted, #a09070);">No stores configured yet.</div>';
			return;
		}

		let tmpHtml = '';
		for (let i = 0; i < this._MappingStores.length; i++)
		{
			let tmpStore = this._MappingStores[i];
			let tmpChecked = tmpSelectedSet[tmpStore.IDProjectionStore] ? ' checked' : '';
			let tmpLabel = (tmpStore.TargetTableName || 'Store ' + tmpStore.IDProjectionStore) + ' (' + (tmpStore.Status || 'Unknown') + ')';
			tmpHtml += '<label>';
			tmpHtml += '<input type="checkbox" value="' + tmpStore.IDProjectionStore + '"' + tmpChecked + '>';
			tmpHtml += ' ' + tmpLabel;
			tmpHtml += '</label>';
		}
		tmpContainer.innerHTML = tmpHtml;
	}

	_getCheckedStoreIDs()
	{
		let tmpContainer = document.getElementById('MeadowMap-Stores');
		if (!tmpContainer) return [];

		let tmpChecked = tmpContainer.querySelectorAll('input[type="checkbox"]:checked');
		let tmpIDs = [];
		for (let i = 0; i < tmpChecked.length; i++)
		{
			tmpIDs.push(parseInt(tmpChecked[i].value, 10));
		}
		return tmpIDs;
	}

	discoverSourceFields()
	{
		let tmpSourceSelect = document.getElementById('MeadowMap-Source');
		let tmpIDSource = tmpSourceSelect ? parseInt(tmpSourceSelect.value, 10) : 0;

		if (!tmpIDSource)
		{
			this._doToast('Select a source first.', {type: 'warning'});
			return;
		}

		this._doDiscoverSourceFields(this._EditingContextID, tmpIDSource, 50).then(
			(pResponse) =>
			{
				if (pResponse && pResponse.Error)
				{
					this._doToast('Error: ' + pResponse.Error, {type: 'error'});
					return;
				}

				let tmpHeaders = (pResponse && pResponse.Headers) ? pResponse.Headers : [];
				this._DiscoveredFields[tmpIDSource] = tmpHeaders;

				this._doToast('Discovered ' + tmpHeaders.length + ' fields from ' + (pResponse.SampleSize || 0) + ' records: ' + tmpHeaders.join(', '), {type: 'success', duration: 6000});

				// Rebuild the flow if it exists
				this._rebuildFlowNodes();
			});
	}

	_rebuildFlowNodes()
	{
		// Get current source and schema columns
		let tmpSourceSelect = document.getElementById('MeadowMap-Source');
		let tmpIDSource = tmpSourceSelect ? parseInt(tmpSourceSelect.value, 10) : 0;
		let tmpFields = this._DiscoveredFields[tmpIDSource] || [];

		// Get schema columns from the target
		let tmpSchemaColumns = this._getSchemaColumns();

		// Initialize the flow view if needed
		this.initFlowView();

		if (!this._FlowView) return;

		let tmpSourceTitle = 'Source: ' + (tmpSourceSelect && tmpSourceSelect.selectedIndex >= 0 ? tmpSourceSelect.options[tmpSourceSelect.selectedIndex].text : 'Source');
		let tmpTargetTitle = 'Target: ' + (this._EditingName || 'Target');

		// Build deterministic source ports (Whole Record + discovered fields)
		let tmpSourcePorts =
		[
			{ Hash: 'src-whole-record', Direction: 'output', Side: 'right', Label: 'Whole Record' }
		];
		for (let i = 0; i < tmpFields.length; i++)
		{
			tmpSourcePorts.push(
			{
				Hash: 'src-field-' + tmpFields[i].replace(/[^a-zA-Z0-9_-]/g, '_'),
				Direction: 'output',
				Side: 'right',
				Label: tmpFields[i]
			});
		}

		// Build deterministic target ports -- entity-specific GUID and ID are always present
		let tmpEntityName = (this._EditingName || 'Record').replace(/[^a-zA-Z0-9_]/g, '');
		let tmpGUIDColumnName = 'GUID' + tmpEntityName;
		let tmpIDColumnName = 'ID' + tmpEntityName;

		let tmpTargetPorts =
		[
			{ Hash: 'tgt-col-' + tmpGUIDColumnName, Direction: 'input', Side: 'left', Label: tmpGUIDColumnName },
			{ Hash: 'tgt-col-' + tmpIDColumnName, Direction: 'input', Side: 'left', Label: tmpIDColumnName }
		];
		for (let i = 0; i < tmpSchemaColumns.length; i++)
		{
			// Skip entity GUID/ID if they appear in schema columns (already added above)
			if (tmpSchemaColumns[i] === tmpGUIDColumnName || tmpSchemaColumns[i] === tmpIDColumnName) continue;

			tmpTargetPorts.push(
			{
				Hash: 'tgt-col-' + tmpSchemaColumns[i].replace(/[^a-zA-Z0-9_-]/g, '_'),
				Direction: 'input',
				Side: 'left',
				Label: tmpSchemaColumns[i]
			});
		}

		// Find existing SRC and TGT nodes (preserve user-added TPL/SOL nodes)
		let tmpFlowData = this._FlowView.getFlowData();
		let tmpSrcNode = null;
		let tmpTgtNode = null;

		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			if (tmpFlowData.Nodes[i].Type === 'SRC') tmpSrcNode = tmpFlowData.Nodes[i];
			if (tmpFlowData.Nodes[i].Type === 'TGT') tmpTgtNode = tmpFlowData.Nodes[i];
		}

		if (tmpSrcNode)
		{
			// Merge source ports: start with newly built ports, then preserve
			// any existing ports from the saved state (e.g. previously discovered
			// fields) that aren't already in the new set.
			let tmpMergedSrcPorts = tmpSourcePorts.slice();
			let tmpSrcPortHashes = {};
			for (let p = 0; p < tmpMergedSrcPorts.length; p++)
			{
				tmpSrcPortHashes[tmpMergedSrcPorts[p].Hash] = true;
			}
			let tmpExistingPorts = tmpSrcNode.Ports || [];
			for (let p = 0; p < tmpExistingPorts.length; p++)
			{
				if (!tmpSrcPortHashes[tmpExistingPorts[p].Hash])
				{
					tmpMergedSrcPorts.push(tmpExistingPorts[p]);
				}
			}

			// Update existing source node in-place
			let tmpInternalNodes = this._FlowView._FlowData.Nodes;
			for (let i = 0; i < tmpInternalNodes.length; i++)
			{
				if (tmpInternalNodes[i].Hash === tmpSrcNode.Hash)
				{
					tmpInternalNodes[i].Ports = tmpMergedSrcPorts;
					tmpInternalNodes[i].Title = tmpSourceTitle;
					break;
				}
			}
		}
		else
		{
			// Push directly into _FlowData.Nodes to avoid addNode() rendering with empty ports
			this._FlowView._FlowData.Nodes.push(
			{
				Hash: 'node-src-' + this.fable.getUUID(),
				Type: 'SRC',
				X: 50,
				Y: 50,
				Width: 200,
				Height: 100,
				Title: tmpSourceTitle,
				Ports: tmpSourcePorts,
				Data: {}
			});
		}

		if (tmpTgtNode)
		{
			// Target ports: schema is the source of truth. Start with schema-
			// derived ports, then preserve any extra existing ports (e.g. user-
			// added custom columns) that aren't already in the new set.
			let tmpMergedTgtPorts = tmpTargetPorts.slice();
			let tmpTgtPortHashes = {};
			for (let p = 0; p < tmpMergedTgtPorts.length; p++)
			{
				tmpTgtPortHashes[tmpMergedTgtPorts[p].Hash] = true;
			}
			let tmpExistingTgtPorts = tmpTgtNode.Ports || [];
			for (let p = 0; p < tmpExistingTgtPorts.length; p++)
			{
				if (!tmpTgtPortHashes[tmpExistingTgtPorts[p].Hash])
				{
					tmpMergedTgtPorts.push(tmpExistingTgtPorts[p]);
				}
			}

			// Update existing target node in-place
			let tmpInternalNodes = this._FlowView._FlowData.Nodes;
			for (let i = 0; i < tmpInternalNodes.length; i++)
			{
				if (tmpInternalNodes[i].Hash === tmpTgtNode.Hash)
				{
					tmpInternalNodes[i].Ports = tmpMergedTgtPorts;
					tmpInternalNodes[i].Title = tmpTargetTitle;
					break;
				}
			}
		}
		else
		{
			// Push directly into _FlowData.Nodes to avoid addNode() rendering with empty ports
			this._FlowView._FlowData.Nodes.push(
			{
				Hash: 'node-tgt-' + this.fable.getUUID(),
				Type: 'TGT',
				X: 550,
				Y: 50,
				Width: 200,
				Height: 100,
				Title: tmpTargetTitle,
				Ports: tmpTargetPorts,
				Data: {}
			});
		}

		// Render the flow once with all ports correctly set
		if (typeof this._FlowView.renderFlow === 'function')
		{
			this._FlowView.renderFlow();
		}
		else if (typeof this._FlowView.render === 'function')
		{
			this._FlowView.render();
		}
	}

	_getSchemaColumns()
	{
		// Use the locally cached schema definition
		let tmpColumns = [];
		let tmpDDL = this._CurrentTargetSchema || '';
		if (tmpDDL)
		{
			let tmpParsedColumns = libSchemaUtils.microDDLToColumns(tmpDDL);
			for (let j = 0; j < tmpParsedColumns.length; j++)
			{
				tmpColumns.push(tmpParsedColumns[j].Name);
			}
		}
		return tmpColumns;
	}

	initFlowView()
	{
		if (this._FlowView) return;

		let tmpFlowContainer = document.getElementById('MeadowMap-Flow-Container');
		if (!tmpFlowContainer) return;

		try
		{
			let libPictSectionFlow = require('pict-section-flow');

			this._FlowView = this.pict.addView('MeadowMapping-Flow',
			{
				ViewIdentifier: 'MeadowMapping-Flow',
				DefaultDestinationAddress: '#MeadowMap-Flow-Container',
				EnableToolbar: true,
				EnablePanning: true,
				EnableZooming: true,
				EnableNodeDragging: true,
				EnableConnectionCreation: true
			}, libPictSectionFlow);

			// Register card types
			let libFlowCardSource = require('./flow-cards/FlowCard-MappingSource.js');
			let libFlowCardTarget = require('./flow-cards/FlowCard-MappingTarget.js');
			let libFlowCardTemplate = require('./flow-cards/FlowCard-TemplateExpression.js');
			let libFlowCardSolver = require('./flow-cards/FlowCard-SolverExpression.js');

			this.pict.addServiceType('FlowCardMappingSource', libFlowCardSource);
			this.pict.addServiceType('FlowCardMappingTarget', libFlowCardTarget);
			this.pict.addServiceType('FlowCardTemplateExpression', libFlowCardTemplate);
			this.pict.addServiceType('FlowCardSolverExpression', libFlowCardSolver);

			// Render the flow view first so _NodeTypeProvider is initialized
			if (typeof this._FlowView.render === 'function')
			{
				this._FlowView.render();
			}

			// Register card types with the flow view (must happen after render
			// so _NodeTypeProvider exists)
			let tmpSourceCard = this.pict.instantiateServiceProviderWithoutRegistration('FlowCardMappingSource', {});
			let tmpTargetCard = this.pict.instantiateServiceProviderWithoutRegistration('FlowCardMappingTarget', {});
			let tmpTemplateCard = this.pict.instantiateServiceProviderWithoutRegistration('FlowCardTemplateExpression', {});
			let tmpSolverCard = this.pict.instantiateServiceProviderWithoutRegistration('FlowCardSolverExpression', {});

			tmpSourceCard.registerWithFlowView(this._FlowView);
			tmpTargetCard.registerWithFlowView(this._FlowView);
			tmpTemplateCard.registerWithFlowView(this._FlowView);
			tmpSolverCard.registerWithFlowView(this._FlowView);
		}
		catch (pFlowError)
		{
			this.log.error('Failed to initialize flow view: ' + pFlowError.message);
			tmpFlowContainer.innerHTML = '<div style="padding:2em; text-align:center; color:var(--theme-color-text-muted, #a09070);">Flow editor could not be loaded. Use JSON Config mode instead.</div>';
		}
	}

	flowToMappingConfig()
	{
		let tmpEntityName = (this._EditingName || 'Record').replace(/[^a-zA-Z0-9_]/g, '');
		let tmpGUIDColumnName = 'GUID' + tmpEntityName;
		let tmpIDColumnName = 'ID' + tmpEntityName;

		let tmpConfig =
		{
			Entity: tmpEntityName,
			GUIDTemplate: '{~D:Record.IDRecord~}',
			GUIDName: tmpGUIDColumnName,
			Mappings: {},
			Solvers: [],
			ManyfestAddresses: false
		};

		if (!this._FlowView || typeof this._FlowView.getFlowData !== 'function')
		{
			return tmpConfig;
		}

		let tmpFlowData = this._FlowView.getFlowData();
		if (!tmpFlowData || !tmpFlowData.Connections) return tmpConfig;

		// Build node hash->node map and port hash->{Label, NodeHash, NodeType} map
		let tmpNodeMap = {};
		let tmpPortMap = {};

		if (tmpFlowData.Nodes)
		{
			for (let i = 0; i < tmpFlowData.Nodes.length; i++)
			{
				let tmpNode = tmpFlowData.Nodes[i];
				tmpNodeMap[tmpNode.Hash] = tmpNode;

				if (tmpNode.Ports)
				{
					for (let j = 0; j < tmpNode.Ports.length; j++)
					{
						tmpPortMap[tmpNode.Ports[j].Hash] =
						{
							Label: tmpNode.Ports[j].Label,
							NodeHash: tmpNode.Hash,
							NodeType: tmpNode.Type
						};
					}
				}
			}
		}

		// Track solver nodes that connect to multiple target columns
		let tmpSolverEntries = {};

		// Process each connection where the target is a TGT node
		for (let i = 0; i < tmpFlowData.Connections.length; i++)
		{
			let tmpConn = tmpFlowData.Connections[i];
			let tmpSourcePort = tmpPortMap[tmpConn.SourcePortHash];
			let tmpTargetPort = tmpPortMap[tmpConn.TargetPortHash];

			if (!tmpSourcePort || !tmpTargetPort) continue;

			// Only process connections that end at a TGT node
			if (tmpTargetPort.NodeType !== 'TGT') continue;

			let tmpTargetColumn = tmpTargetPort.Label;
			if (!tmpTargetColumn) continue;

			let tmpSourceNode = tmpNodeMap[tmpSourcePort.NodeHash];
			if (!tmpSourceNode) continue;

			if (tmpSourceNode.Type === 'SRC')
			{
				// Direct mapping: SRC field -> TGT column
				let tmpSourceField = tmpSourcePort.Label;

				// Skip "Whole Record" direct connections to TGT (need intermediate node)
				if (tmpSourceField === 'Whole Record') continue;

				let tmpTemplate = (tmpConn.Data && tmpConn.Data.Template)
					? tmpConn.Data.Template
					: '{~D:Record.' + tmpSourceField + '~}';

				// Connection to the entity GUID port sets the GUIDTemplate for upsert uniqueness
				if (tmpTargetColumn === tmpGUIDColumnName)
				{
					tmpConfig.GUIDTemplate = tmpTemplate;
				}

				tmpConfig.Mappings[tmpTargetColumn] = tmpTemplate;
			}
			else if (tmpSourceNode.Type === 'TPL')
			{
				// Template expression: TPL result -> TGT column
				let tmpExpression = (tmpSourceNode.Data && tmpSourceNode.Data.TemplateExpression)
					? tmpSourceNode.Data.TemplateExpression
					: '';

				if (tmpExpression)
				{
					// TPL connected to entity GUID sets the GUIDTemplate
					if (tmpTargetColumn === tmpGUIDColumnName)
					{
						tmpConfig.GUIDTemplate = tmpExpression;
					}

					tmpConfig.Mappings[tmpTargetColumn] = tmpExpression;
				}
			}
			else if (tmpSourceNode.Type === 'SOL')
			{
				// Solver expression: SOL result -> TGT column
				let tmpExpression = (tmpSourceNode.Data && tmpSourceNode.Data.SolverExpression)
					? tmpSourceNode.Data.SolverExpression
					: '';

				if (tmpExpression)
				{
					// Group outputs for the same solver node
					if (!tmpSolverEntries[tmpSourceNode.Hash])
					{
						tmpSolverEntries[tmpSourceNode.Hash] =
						{
							expression: tmpExpression,
							outputs: {}
						};
					}
					tmpSolverEntries[tmpSourceNode.Hash].outputs[tmpTargetColumn] = true;
				}
			}
		}

		// Ensure entity-specific GUID and ID are always present in Mappings
		if (!tmpConfig.Mappings.hasOwnProperty(tmpGUIDColumnName))
		{
			tmpConfig.Mappings[tmpGUIDColumnName] = tmpConfig.GUIDTemplate;
		}
		if (!tmpConfig.Mappings.hasOwnProperty(tmpIDColumnName))
		{
			tmpConfig.Mappings[tmpIDColumnName] = '{~D:Record.IDRecord~}';
		}

		// Add grouped solver entries
		let tmpSolverKeys = Object.keys(tmpSolverEntries);
		for (let i = 0; i < tmpSolverKeys.length; i++)
		{
			tmpConfig.Solvers.push(tmpSolverEntries[tmpSolverKeys[i]]);
		}

		return tmpConfig;
	}

	saveMapping()
	{
		let tmpNameInput = document.getElementById('MeadowMap-Name');
		let tmpSourceSelect = document.getElementById('MeadowMap-Source');

		let tmpName = tmpNameInput ? tmpNameInput.value.trim() : '';
		let tmpIDSource = tmpSourceSelect ? parseInt(tmpSourceSelect.value, 10) : 0;
		let tmpCheckedStoreIDs = this._getCheckedStoreIDs();
		let tmpIDProjectionStore = tmpCheckedStoreIDs.length > 0 ? tmpCheckedStoreIDs[0] : 0;

		if (!tmpName)
		{
			this._doToast('Enter a mapping name.', {type: 'warning'});
			return;
		}

		// Get mapping config
		let tmpMappingConfig;
		if (this._MapEditorMode === 'json')
		{
			let tmpJSONTextarea = document.getElementById('MeadowMap-JSON');
			let tmpJSON = tmpJSONTextarea ? tmpJSONTextarea.value : '{}';
			try
			{
				tmpMappingConfig = JSON.parse(tmpJSON);
			}
			catch (e)
			{
				this._doToast('Invalid JSON: ' + e.message, {type: 'error'});
				return;
			}
		}
		else
		{
			tmpMappingConfig = this.flowToMappingConfig();
		}

		// Store target stores in the mapping config
		tmpMappingConfig.TargetStores = tmpCheckedStoreIDs;

		// Persist discovered source columns so the SRC node loads correctly
		// on next open without requiring a separate API call.
		let tmpSavedColumns = this._DiscoveredFields[tmpIDSource];
		if (Array.isArray(tmpSavedColumns) && tmpSavedColumns.length > 0)
		{
			tmpMappingConfig.sourceColumns = tmpSavedColumns;
		}

		// Get flow diagram state
		let tmpFlowState = {};
		if (this._FlowView && typeof this._FlowView.getFlowData === 'function')
		{
			tmpFlowState = this._FlowView.getFlowData();
		}

		let tmpData =
		{
			Name: tmpName,
			IDSource: tmpIDSource,
			IDProjectionStore: tmpIDProjectionStore,
			MappingConfiguration: JSON.stringify(tmpMappingConfig),
			FlowDiagramState: JSON.stringify(tmpFlowState),
			Active: 1
		};

		let tmpPromise;
		if (this._SelectedMappingID)
		{
			tmpPromise = this._doUpdateMapping(this._SelectedMappingID, tmpData);
		}
		else
		{
			tmpPromise = this._doCreateMapping(this._EditingContextID, tmpData);
		}

		tmpPromise.then(
			(pResponse) =>
			{
				if (pResponse && pResponse.Error)
				{
					this._doToast('Error: ' + pResponse.Error, {type: 'error'});
					return;
				}

				// Update the selected mapping ID if it was a create
				if (pResponse && pResponse.Mapping && pResponse.Mapping.IDProjectionMapping)
				{
					this._SelectedMappingID = pResponse.Mapping.IDProjectionMapping;
				}

				this._doToast('Mapping saved.', {type: 'success'});

				// Refresh mapping list
				this._doLoadMappings(this._EditingContextID).then(
					(pResult) =>
					{
						this._CurrentMappings = (pResult && pResult.Mappings) ? pResult.Mappings : [];
					});
			});
	}

}

module.exports = MeadowMappingEditorView;

module.exports.default_configuration = _ViewConfiguration;

},{"./MappingEditor-SchemaUtils.js":138,"./flow-cards/FlowCard-MappingSource.js":140,"./flow-cards/FlowCard-MappingTarget.js":141,"./flow-cards/FlowCard-SolverExpression.js":142,"./flow-cards/FlowCard-TemplateExpression.js":143,"pict-section-flow":16,"pict-view":137}],140:[function(require,module,exports){
const libPictFlowCard = require('pict-section-flow').PictFlowCard;

/**
 * FlowCard-MappingSource
 *
 * Represents a source dataset in the mapping flow.
 * Output ports are dynamically generated from discovered fields.
 */
class FlowCardMappingSource extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			{
				Title: 'Mapping Source',
				Name: 'Mapping Source',
				Code: 'SRC',
				Category: 'Data Source',
				Description: 'Source dataset with discovered record fields',
				TitleBarColor: '#2980b9',
				Width: 200,
				Height: 100,
				Inputs: [],
				Outputs:
				[
					{ Name: 'Whole Record', Side: 'right' }
				],
				ShowTypeLabel: true,
				PortLabelsOnHover: false,
				PortLabelsOutside: true
			},
			pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'FlowCardMappingSource';
	}
}

module.exports = FlowCardMappingSource;

module.exports.default_configuration =
{
	Title: 'Mapping Source',
	Code: 'SRC',
	Category: 'Data Source',
	TitleBarColor: '#2980b9',
	Width: 200,
	Height: 100
};

},{"pict-section-flow":16}],141:[function(require,module,exports){
const libPictFlowCard = require('pict-section-flow').PictFlowCard;

/**
 * FlowCard-MappingTarget
 *
 * Represents the mapping target table in the mapping flow.
 * Input ports are dynamically generated from schema columns.
 */
class FlowCardMappingTarget extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			{
				Title: 'Mapping Target',
				Name: 'Mapping Target',
				Code: 'TGT',
				Category: 'Data Target',
				Description: 'Mapping target table with schema columns',
				TitleBarColor: '#27ae60',
				Width: 200,
				Height: 100,
				Inputs:
				[
				],
				Outputs: [],
				ShowTypeLabel: true,
				PortLabelsOnHover: false,
				PortLabelsOutside: true
			},
			pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'FlowCardMappingTarget';
	}
}

module.exports = FlowCardMappingTarget;

module.exports.default_configuration =
{
	Title: 'Mapping Target',
	Code: 'TGT',
	Category: 'Data Target',
	TitleBarColor: '#27ae60',
	Width: 200,
	Height: 100
};

},{"pict-section-flow":16}],142:[function(require,module,exports){
const libPictFlowCard = require('pict-section-flow').PictFlowCard;

/**
 * FlowCard-SolverExpression
 *
 * A transform card that applies a Fable ExpressionParser solver expression
 * to compute a derived value from the whole incoming record. Connect the
 * Source "Whole Record" output to this card's input, then connect this
 * card's output to a target column.
 *
 * Double-click the node to edit the solver expression in the properties panel.
 *
 * @class FlowCardSolverExpression
 * @extends PictFlowCard
 */
class FlowCardSolverExpression extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			{
				Title: 'Solver Expression',
				Name: 'Solver Expression',
				Code: 'SOL',
				Category: 'Transform',
				Description: 'Apply a Fable solver expression for conditional logic and computed values',
				TitleBarColor: '#d35400',
				Width: 220,
				Height: 90,
				Inputs:
				[
					{ Name: 'Whole Record', Side: 'left' }
				],
				Outputs:
				[
					{ Name: 'Result', Side: 'right' }
				],
				ShowTypeLabel: true,
				PortLabelsOnHover: false,
				PortLabelsOutside: true,
				LabelsInFront: true,
				Enabled: true,
				BodyContent:
				{
					ContentType: 'html',
					Template: '<div style="font-size:10px; padding:2px 4px; color:var(--theme-color-border-default, #ccc); overflow:hidden; white-space:nowrap; text-overflow:ellipsis; max-width:200px;">{~D:Record.Data.SolverExpression~}</div>'
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 420,
					DefaultHeight: 160,
					Title: 'Solver Expression',
					Configuration:
					{
						Template: '<div style="padding:8px;"><label style="display:block; margin-bottom:4px; font-weight:bold; font-size:12px;">Solver Expression</label><textarea id="FlowCard-SOL-{~D:Record.Hash~}" style="width:100%; height:80px; font-family:monospace; font-size:12px; resize:vertical; background:#1a1a2e; color:var(--theme-color-border-default, #e0e0e0); border:1px solid var(--theme-color-text-secondary, #444); border-radius:4px; padding:6px;" onchange="(function(el){var n=pict.views[\'MeadowMapping-Flow\'];if(n&&n._FlowData){for(var i=0;i<n._FlowData.Nodes.length;i++){if(n._FlowData.Nodes[i].Hash===\'{~D:Record.Hash~}\'){n._FlowData.Nodes[i].Data.SolverExpression=el.value;if(typeof n.renderFlow===\'function\')n.renderFlow();break;}}}})(this)">{~D:Record.Data.SolverExpression~}</textarea><div style="font-size:10px; color:var(--theme-color-text-muted, #888); margin-top:4px;">Example: IF(IncomingRecord.Type == \'Premium\', \'GOLD\', \'SILVER\')</div></div>'
					}
				}
			},
			pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'FlowCardSolverExpression';
	}
}

module.exports = FlowCardSolverExpression;

module.exports.default_configuration =
{
	Title: 'Solver Expression',
	Code: 'SOL',
	Category: 'Transform',
	TitleBarColor: '#d35400',
	Width: 220,
	Height: 90
};

},{"pict-section-flow":16}],143:[function(require,module,exports){
const libPictFlowCard = require('pict-section-flow').PictFlowCard;

/**
 * FlowCard-TemplateExpression
 *
 * A transform card that applies a Manyfest template expression to the
 * whole incoming record. Connect the Source "Whole Record" output to this
 * card's input, then connect this card's output to a target column.
 *
 * Double-click the node to edit the template expression in the properties panel.
 *
 * @class FlowCardTemplateExpression
 * @extends PictFlowCard
 */
class FlowCardTemplateExpression extends libPictFlowCard
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			{
				Title: 'Template Expression',
				Name: 'Template Expression',
				Code: 'TPL',
				Category: 'Transform',
				Description: 'Apply a Manyfest template expression to map source fields to a target column',
				TitleBarColor: '#8e44ad',
				Width: 220,
				Height: 90,
				Inputs:
				[
					{ Name: 'Whole Record', Side: 'left' }
				],
				Outputs:
				[
					{ Name: 'Result', Side: 'right' }
				],
				ShowTypeLabel: true,
				PortLabelsOnHover: false,
				PortLabelsOutside: true,
				LabelsInFront: true,
				Enabled: true,
				BodyContent:
				{
					ContentType: 'html',
					Template: '<div style="font-size:10px; padding:2px 4px; color:var(--theme-color-border-default, #ccc); overflow:hidden; white-space:nowrap; text-overflow:ellipsis; max-width:200px;">{~D:Record.Data.TemplateExpression~}</div>'
				},
				PropertiesPanel:
				{
					PanelType: 'Template',
					DefaultWidth: 420,
					DefaultHeight: 160,
					Title: 'Template Expression',
					Configuration:
					{
						Template: '<div style="padding:8px;"><label style="display:block; margin-bottom:4px; font-weight:bold; font-size:12px;">Template Expression</label><textarea id="FlowCard-TPL-{~D:Record.Hash~}" style="width:100%; height:80px; font-family:monospace; font-size:12px; resize:vertical; background:#1a1a2e; color:var(--theme-color-border-default, #e0e0e0); border:1px solid var(--theme-color-text-secondary, #444); border-radius:4px; padding:6px;" onchange="(function(el){var n=pict.views[\'MeadowMapping-Flow\'];if(n&&n._FlowData){for(var i=0;i<n._FlowData.Nodes.length;i++){if(n._FlowData.Nodes[i].Hash===\'{~D:Record.Hash~}\'){n._FlowData.Nodes[i].Data.TemplateExpression=el.value;if(typeof n.renderFlow===\'function\')n.renderFlow();break;}}}})(this)">{~D:Record.Data.TemplateExpression~}</textarea><div style="font-size:10px; color:var(--theme-color-text-muted, #888); margin-top:4px;">Use {~D:Record.FieldName~} syntax. Example: {~D:Record.Name~} in {~D:Record.City~}</div></div>'
					}
				}
			},
			pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'FlowCardTemplateExpression';
	}
}

module.exports = FlowCardTemplateExpression;

module.exports.default_configuration =
{
	Title: 'Template Expression',
	Code: 'TPL',
	Category: 'Transform',
	TitleBarColor: '#8e44ad',
	Width: 220,
	Height: 90
};

},{"pict-section-flow":16}]},{},[2])(2)
});

